module.exports={
"label_emailtocloudcc_department":`Afdeling`,
"label.wei.weiresearch":`Micro-stem`,
"message.error.appsecret.null":`Het wachtwoord van de geheime sleutel kan niet null zijn!`,
"label.file.orderbylastmodifydate":`Gesorteerd op laatst gewijzigde tijd`,
"label.minus":`-Minus`,
"label.horizontalbar":`Horizontale lijnen`,
"label.emailobject.emailsentfailed":`Mail is niet verzonden！`,
"assignedresource.check":`Dit service middel is toegewezen aan een service afspraak. Gelieve niet herhaaldelijk toe te voegen.`,
"label.finish":`Compleet`,
"label.document.history":`Download Geschiedenis`,
"label.customfields.number.numberLengthHelpText":`1.Voer de lengte van het getal en het aantal decimalen in. Bijvoorbeeld, een getal met een lengte van 8 en 2 decimalen kan waarden tot "12345678.90" accepteren.`,
"label.standard.buttonandlink.info":`Het overschrijven van standaardknoppen en -links verandert de betekenis van de CloudCC.com URL en alle aanroepen naar die URL zoals een CloudCC.com aangepaste pagina, een browsersnelkoppeling of een extern systeem. U kunt de CloudCC.com URL voor een standaard knop of link vervangen door een aangepaste pagina.`,
"front-epwechat-module-v1-contacts-desc":`Indien geactiveerd, zal het object van WeCom Contacts worden toegevoegd in het CloudCC systeem, klantinformatie van WeCom zal worden gesynchroniseerd met dit object.`,
"label.mr.caption.contact.result":`Duplicaten zoeken en samenvoegen: Resultaten voor het zoeken naar duplicaten van Contacten`,
"label.ems.selectaccount":`Account kiezen`,
"label.group.no.activity":`Er zijn geen overeenkomende actieve groepen.`,
"label.call.for":`Uitgenodigd door`,
"label.newreportguide":`Nieuwe rapportgids`,
"component.telerecord.label.name":`Namen`,
"vue.add.dashboard.component":`{TitelNaam} Component toevoegen`,
"label.chatter.sendEmailToGroupMember.check.V":`Stemmen bekijken`,
"UG.ST.002":`Bepaal`,
"label.setting.intergrationmanage":`Integratie Beheer`,
"label.field.apiname.validate":`Voer een getal tussen 0 en 6 in.`,
"label.emailmerge.list.deletefolder":`Map verwijderen`,
"vue_label_pool_received":`Ontvangen`,
"label_emailtocloudcc_step1_case1":`E-mail naar Case`,
"message.sumlength":`De som van de lengte en het aantal decimalen mag niet meer zijn dan 18 palces.`,
"vue_label_approve_reassignapproval":`{naam} heeft deze goedkeuring toegewezen aan {personen}`,
"label.specify.time":`Tijd: 13:00 Juni, 21th, 2016`,
"vue_label_report_sortdown":`Sorteren in aflopende volgorde`,
"chatter.login.now":`Uploaden...`,
"label.import.page2.notsuited":`Niet in kaart gebracht`,
"label.please.fill.out":`Gelieve in te vullen`,
"label.recordtype.edit.description":`Selecteer een waarde uit "Beschikbare Waarden", voeg die dan toe aan "Geselecteerde Waarden" en maak er een keuzelijstwaarde van voor dit recordtype. Merk op dat het verwijderen van een waarde uit de keuzelijst deze waarde niet verwijdert uit een bestaande record. Selecteer tenslotte de standaard picklist-waarde voor het recordtype.`,
"label.customer.tab.new":`Tabblad nieuwe klant`,
"label.sameas":`Zelfde als`,
"front-filter-module-v1-filter-a-week-ago":`Een week geleden`,
"label.processsetting.disable.process.failed":`Mislukt om het proces uit te schakelen!`,
"label.summaryreport.2018.step4":`Stap 4 Kies rapportcriteria`,
"label.secrecyinfo":`Vertrouwelijke informatie, niet verspreiden.`,
"label.custom.page.component.general.settings":`Component Algemene instellingen`,
"label.ccpeak.folder":`Niet gearchiveerde klassenmappen`,
"vue_label_homepage_select_button_operation":`Selecteer knop`,
"message.pleaseinputrightdistance":`Voer de juiste intervaldagen in`,
"label.mobile.phone.required.short":`is vereist`,
"vue_label_account_equityseructure":`Structuur van het aandeelhouderschap`,
"label.file.library.error1":`Dit bestand staat al in deze bibliotheek.`,
"fliter.nextmonth":`Volgende maand`,
"label.mr.descreption.oneGroupNote2":`set van bedrijfsinformatie, zijn er`,
"label.allfolderdashboard":`Alle Dashboardmappen`,
"lable.opppdt.selPdt.bykeywords":`Op trefwoord`,
"setup_layout_label_selectedfield":`Selecteer velden`,
"label.file.preview.convert.firstpage.failure":`Er is een fout opgetreden bij het voorvertonen, klik op preview details of download om te bekijken`,
"vue_label_systemSettings_companie":`Oprichting van het bedrijf`,
"label.loginhis.recently":`Recente inloggeschiedenis`,
"label.permission.visualpagepermission.edit":`Aangepaste Paginatoewijzing`,
"label.ccservice.validate.email":`Het formaat van de overeenkomstige waarde {2} van het veld {1} onder de object-API {0} is onjuist.Voer het juiste e-mailadres in!`,
"label.sms.companyname.gm":`SMS-2 instelling`,
"lable.opppdt.addpdt.table.discount":`Korting (% korting)`,
"Lead.Scoring.Setting.LevelSetting":`Leider Populariteit Instellingen`,
"message.duplication.label.duplicationremark":`is de bewerking van het opvragen van duplicaatgegevens wanneer nieuwe of gewijzigde records`,
"label.file.preview.error":`Er is een fout opgetreden bij het preveiw, gelieve te downloaden om te bekijken`,
"label.imgfield.type.input":`Afbeelding invoegen`,
"label.file.share.email.content1":`Bestandsnaam: #filename`,
"vue_label_notice_batchedit_fail":`De gegevensupdate met id {0} mislukt met faalreden {1}`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.four":`Four`,
"label.view.sortview.printview":`Afdrukken`,
"label.projectManagement.Addposttask":`Post-taak toevoegen`,
"vue_label_commonobjects_view_fail":`Het is niet gelukt om de standaardweergave in te stellen`,
"label.dayinweek":`Week's`,
"label.layout.notexist":`De lay-out bestaat niet.`,
"label.brief.total":`Neem op {totaal}`,
"label.dashboardSetup.tz.bb":`Ga naar Rapporten`,
"label_emailtocloudcc_select3":`Selecteer eigenaar record`,
"label.input.least.string":`Voer ten minste {0} tekens in`,
"label.app.step2":`Stap 2 Vul de gegevens in`,
"lable.account.LastWeek":`Vorige week`,
"label.notifications":`Kennisgevingen`,
"label.tabpage.viewname":`Naam bekijken`,
"label.knowledge.language.italian":`Italiaans`,
"label.sendmail.step2.introduce":`Kies een e-mail sjabloon`,
"label_enable_or_no":`Wilt u inschakelen ?`,
"pagecreator_button_save":`Save`,
"template.chart.cplb":`Product Categorie`,
"label.knowledge.publish":`Kan niet gepubliceerd worden omdat het niet gekwalificeerd is.`,
"label.name.required":`Het naamveld is verplicht`,
"component.chatter.label.myfans":`Mijn volgelingen`,
"label.rejectoperate":`Afwijzende acties`,
"label.report.action.addtodashboard3":`Kies Dashboard`,
"label.icon.101":`Tekstboek`,
"label.data.exp.su.ok":`Exporteren`,
"label.appupload.component.type.layout":`Pagina-indelingen`,
"template.chart.yscb":`Begrote kosten`,
"label.tabularreport.selectorder":`Bepaal de weergavesoort van elke rapportkolom`,
"email.title.one":`Wachtwoord opvragen`,
"label.case.copy.link":`Kopieer weblink`,
"label.mr.descreption.oneGroupReData4":`groep, blijft`,
"label.newprocess5.error.des":`U kunt alleen getallen invoeren.`,
"label.partnerCloud.loginButton":`Login knop`,
"label.interfaceconstraint.adminonly":`Alleen beheerders kunnen deze interface gebruiken.`,
"label.campaign.channel.input.date":`2. Stel de geldigheidsduur in voor uw marketing kanaal:`,
"label.clientwebsiteentranceprofile":`Klant Website Portaal Profiel`,
"UG.opportunity.011":`Transactie importeren`,
"label.page.copy.value.paste.template":`Kopieer en plak de waarde van het samenvoegveld in uw sjabloon hieronder.`,
"label.notselect":`Geen keuze`,
"label.weixin.input.password":`Voer uw wachtwoord in.`,
"label.email.select.template":`Selecteer sjabloon`,
"label_chatter_ok":`Bevestig`,
"permissionService.error":`Toewijzing toestemmingsset mislukt, controleer of de licentie van de toepassing verlopen is of dat de toewijzing de maximumlimiet heeft bereikt.`,
"label.webtocloudcc.sorry":`Sorry, pagina fout, probeer het opnieuw of neem contact op met uw beheerder.`,
"UG.opportunity.007":`Contact rol`,
"label.manageAll.forapproval":`Goed te keuren punten`,
"label.imgfield.type.ref":`Formulebeeld`,
"label.profile.setcustomtab":`Aangepaste tabbladinstellingen`,
"label.tabpage.datatyoez":`Gegevenstype`,
"label.partnerCloud.basicSetting.editPersonal":`Gebruikers van de partnercloud toestaan persoonlijke informatie te bewerken`,
"label.mr.caption.account":`Duplicaten zoeken en samenvoegen: Codities voor het opvragen van duplicaten van Rekeningen`,
"message.serviceterritoryMe.time.violation":`Overschrijding van de verzendtijd: de verzendtijd valt niet binnen het tijdsbestek van de regionale leden.`,
"pagecreator_page_message_publish_success":`Pagina succesvol gepubliceerd`,
"label.field.formula.timezonetip":`Wanneer een systeemfunctie zoals sysdate in een formule wordt gebruikt om de huidige tijd te verkrijgen, dient deze te worden vervangen door de overeenkomstige functie voor meerdere tijdzones, zoals current_date.`,
"label.marketseamemset.specialuser":`Speciaal lid`,
"label.staticresource.message":`Statische brongegevens`,
"label.workflow.rulecondition":`Regel Criteria`,
"component_salesperformance_label_nodata":`Voeg uw zakelijke opportuniteit toe en keer hier terug om de prestatiegrafiek te bekijken.`,
"label.customfields.textarea.tip":`Hiermee kunnen gebruikers meerdere regels tekst invoeren, tot maximaal 4000 tekens.`,
"font-evaluate-module-v1-template":`Aangepaste sjabloon`,
"label.step3.total5":`Stap 3 van 5`,
"label.customfields.formula.percent.tip":`Bereken een percentage en voeg automatisch het procentteken toe aan het getal.`,
"label.sortdesc":`Daal af`,
"lable.PowerProcess.edit":`Rechtsproces bewerken`,
"label.dongshifang.description":`Configureer de informatie van de Dongshifang om te voldoen aan de behoeften van de SMS-verzend- en ontvangstdiensten van uw organisatie.`,
"label.chatter.addressee":`Ontvanger`,
"vue_label_systemSettings_obj2":`Objects Management Console`,
"label.selectreporttype.tip":`Kies het gegevenstype dat u in dit rapport wilt opnemen`,
"label.version.enterprise":`Enterprise Editie`,
"label.area.add":`Territorium toevoegen`,
"label.h5.bookmarked":`Bladwijzers`,
"label.step5.total7":`Stap 5 van 7`,
"front-lightning-module-v1-title-quotation":`Voorbeeld Citaat`,
"label.search.onlymyrecords":`Beperk tot dingen die ik bezit`,
"vue_label_commonobjects_noduplication":`Duplicaat van {字段} in {记录}`,
"label.customerpage.edit":`Tabbladen op aangepaste pagina's bewerken`,
"message.please.choose.user":`Selecteer gebruiker`,
"label.approval.his.currentactor":`Huidige goedkeurder`,
"label.field.duplicate.error.msg3":`U kunt maximaal 3 unieke eigendomsvelden creëren.`,
"label.page_url":`URL van de pagina`,
"label.permission.goback":`Terug naar Toestemmingssets`,
"vue_label_commonobjects_view_kanban_notice2":`Om alle records te bekijken, gebruikt u de lijstweergave of de gesplitste schermweergave`,
"label.group.no.recent.searchs":`Er zijn geen overeenkomende recent bekeken groepen.`,
"label.event.fiducial.point":`punctueel`,
"label.integrations.mailchimp.addtolist":`Voeg de geselecteerde leads en contactpersonen van uw CloudCC account toe aan uw Mailchimp lijst`,
"label.workflow.configrule.introduce":`Voer de naam, beschrijving en criteria in om uw workflow regel te triggeren. In de volgende stap koppelt u workflow-acties aan deze workflow-regel.`,
"label.icon.161":`Koffer`,
"label.recordtype.enable":`Actief`,
"label_mailboxes_limit":`Aantal mailboxen overschrijdt de limiet.`,
"label.notification.time3":`{0} uren geleden`,
"label.setsharerule.step2":`Stap 2 Selecteer welke records moeten worden gedeeld`,
"vue_label_homepage_somecomponents":`Let op! Na het toevoegen van de component, overschrijdt de hoogte de limiet en veroorzaakt een onvolledige weergave. Gelieve sommige componenten te verwijderen`,
"label.icon.63":`Ondergrondse put`,
"label.use.standard.sharerules":`Gebruik standaard aandelenregels`,
"label.button.step2.select.required.field":`Stap 2 Selecteer de verplichte velden`,
"lable.Confirm.collect.potential.customers":`Bevestig het verzamelen van lead {naam}`,
"label.version.sum.custompage":`aangepaste pagina('s)`,
"label.file.ccchat.changefile":`Verander bestand`,
"label.mobile.phone.phone.call":`Bel`,
"label.appupload.managed.img":`Gecontroleerd`,
"vue_label_chatter_comment":`opmerking`,
"label.central.european.time":`Centraal Europese Tijd`,
"label.three.quarter":`Derde kwartaal`,
"label.service.newBuildDialog.filter.editor":`Filter-editor`,
"pagecreator_systemstyle_funcpath":`/ bouwer / merkgebonden stijlbibliotheek`,
"label_chatter_collect":`Bladwijzer`,
"label.custom.page.component.window.settings":`Component Venster Instellingen`,
"component_chatter_file_label_title":`Bestand uploaden`,
"label.marketsea.button.discard":`Weggooien`,
"label.Batch.input":`Batch Invoer`,
"vue_label_campaign_market_members":`Bestaande leden van de markt`,
"label.salescloud.salesdashboard":`Verkoop Dashboards`,
"message.summaryconditionrepeated":`Sorry, samenvatting voorwaarden duplicaten, gelieve opnieuw te selecteren`,
"label.tianyancha.h5.companycode":`Bedrijfscode`,
"label.quickbooks.description":`Houd uw QuickBooks Online-facturen, -betalingen en -ramingen bij.`,
"label.colombia.time":`Colombia Tijd`,
"label.usermanage.unknown.license":`Ongeldige licentie, en u kunt geen nieuwe gebruikers aanmaken, neem contact op met uw beheerder.`,
"label.operatedata.selectoperateandobject":`Selecteer de operatie (Importeren of Exporteren) en objecten`,
"message.setup.field.picklist.valuerepeated":`Lijstwaarden kunnen niet worden herhaald, gelieve opnieuw in te voeren.`,
"label.editerror.list":`De gegevenslijst is niet bewerkt.`,
"pagecreator_page_message_save_success":`Pagina succesvol opgeslagen`,
"label.icon.154":`Computer`,
"label.emailsync.setting":`Persoonlijke e-mail instellingen`,
"label.startuploadfile.step2":`Stap 3 Klik op "start upload" om bestanden te uploaden`,
"label.dashboard.notmeet.conditions":`Er is geen overeenkomende informatie gevonden en het dashboard is niet geconfigureerd.`,
"label.temp.del.conf":`Weet u zeker dat u wilt verwijderen?`,
"label.sms.authkey":`Authenticatie Wachtwoord`,
"lable.oppt.jieduan.choosejieduan":`Selecteer de gesloten fase`,
"label.tabpage.viewNamez":`Voer de naam van het uitzicht in`,
"label.totalQuotation":`Totaal van offerte`,
"label.tabpage.hoursagoz":`Uren`,
"label.receiveadminnews":`Ontvang de nieuwsuitzending van de beheerder`,
"label.field.is.lookup":`Is het veld gekoppeld aan het opzoekveld?`,
"label.any_changes":`Alle wijzigingen die hier worden gemaakt zullen ook uw voettekst bijwerken in`,
"lable.products.to.assets":`Bevestiging om product op activa over te dragen?`,
"label.dashboard.compare":`Vergelijking`,
"vue_label_chatter_notice1":`Na het verwijderen van de groep, zal alle informatie in de groep worden verwijderd, maar de bestanden van de groep zullen niet worden verwijderd`,
"label_tabpage_exitz":`Uitloggen`,
"label.potentialcustomerflow":`Leidt Processen`,
"label.longtext":`Tekstgebied (lang)`,
"october":`Oktober`,
"label.customer.email":`E-mail`,
"label.partnerCloud.productSet.addChildren":`Sublevel toevoegen`,
"label.defaultline.cannot.greater":`Het standaardaantal regels mag niet meer dan 30 bedragen.`,
"front-detail-module-v1-view-report":`Verslag bekijken`,
"label.knowledge.setting.hint.sixteen":`Bewaar kennis en ga door met het doorgeven`,
"label.page.use.merged.field":`Met Samenvoeg Veld`,
"label.salescloud.salescloud.continuerecover":`indien verdergaan, zal de schrapping uitgevoerd en ondekbaar zijn`,
"front-project-module-v1-from-template-create":`Maken van sjabloon`,
"label.exportall":`Exporteer alle records van alle objecten`,
"label.weixin.recalculate.shared.results":`Herberekenen van de resultaten van de deelregel`,
"label.components.isTemplate":`Sjabloongegevens`,
"label_emailsync_status":`E-mailstatus van de gebruiker`,
"label.file.library.delete":`Weet u zeker dat u {librayrname}？ wilt verwijderen`,
"label.integrations.username":`Gebruikersnaam`,
"front-lightningset-module-v1-detail-page-report-chart":`Rapportgrafieken op Detailpagina`,
"label_tabular":`Lijst Indeling`,
"label.approverecords":`Goedkeuring van`,
"vue_label_helpcenter_topic":`Lightning versie gebruik en hulp`,
"label.h5.date.none":`Nee`,
"lable.outlook.mcto.allrecord":`Alle Records`,
"label.readandwrite":`Lezen/Schrijven`,
"label.allfold":`Alles samenvouwen`,
"AD":`Adres`,
"message.custom.field.donotdelete.reporttype":`Naar het veld wordt verwezen door de gegevensbron van het rapport`,
"label.escalation.setup.newaction.title":`Escalatie Actie Edit`,
"label.dashboard.snapshot.settings":`Dashboard snapshots instellingen`,
"label.attendance.inner":`Kantoormedewerker`,
"chatter.ns":`Nieuw bericht`,
"label.validate.nowork":`Fout: ongeldig veld, gelieve de plaats van de foutmelding opnieuw te selecteren.`,
"label.custom.EmptyCanvas":`Duidelijk Canvas`,
"label.service.miniProgram.fillImageOrder":`Geef de carrousel volgorde op.`,
"label.icon.16":`Dienst`,
"label.selected":`Geselecteerd`,
"component_chatter_link_label_name":`Link naam`,
"label.reportsSubscriptionPage.schedulereport.starttime":`Gewenste begintijd`,
"label.file.uploadNewVersion":`Upload nieuwe versie`,
"chatter.group.theMembership":`Lidmaatschap`,
"label.knowledge.recommended.articles":`Voorgestelde artikelen`,
"label.appupload.install.parentobj":`Ouder voorwerp`,
"label.file.recent":`Recent`,
"vue_label_helpcenter_quote":`De offerte vertegenwoordigt de voorgestelde prijs van de producten en diensten van uw bedrijf. U kunt offertes maken van kansen en hun producten.<br>?In de rechterbovenhoek van de gedetailleerde informatie kunt u de knop gebruiken om de offerte te synchroniseren met de zakelijke kans, of om de offerte te synchroniseren met de zakelijke kans. Wanneer de offerte is gesynchroniseerd met de opportuniteit, worden alle wijzigingen in de offerteregel gesynchroniseerd met het opportuniteitsproduct, en vice versa. Elke zakelijke opportuniteit kan meerdere geassocieerde offertes hebben, waarvan elk kan worden gesynchroniseerd met de zakelijke opportuniteit.<br>?In de rechterbovenhoek van de gedetailleerde informatie kunt u een pdf genereren en een voorbeeld van de offerte bekijken, en u kunt direct afdrukken, downloaden of opslaan.`,
"message.error.field.default":`De standaardwaarde moet een positief geheel getal zijn.`,
"label.campaignmember.main.importmember.contacts.desc":`Importeer campagnecontacten uit bestanden.`,
"vue_label_calendar_show_only_this_calendar":`Toon alleen deze kalender`,
"vue_label_quot_syncfrom":`Sync van zakelijke kansen`,
"label.data.expnode.e_desc2":`2. Exporteren per sjabloon: gebruikers kunnen een sjabloon kiezen om gegevens te exporteren.`,
"label.login.verification.mfa.desc1":`U moet een MFA-applicatie op uw smart device installeren om verder te kunnen gaan.Gebruikelijke applicaties die MFA op smart devices ondersteunen zijn: Onions, Google Authenticator.`,
"label.jiandangfenpei.desc":`Wijs toegang van de huidige aangepaste pagina toe aan profiel. Beheerders hebben toegang tot alle aangepaste pagina's.`,
"label_tabpage_thisrecord":`Deze plaat`,
"lable.SalesCommitmentKanBan.totalPaymentAmount":`Rollup Ontvangsten Bedrag`,
"message.error.object.notvalidcurrency":`Ongeldige valuta`,
"label.edit.discount":`Korting bewerken`,
"label.setup.mobile.offlinecache.setenable":`Offline-functie aan mobiele zijde inschakelen`,
"UG.ST.005":`Ik heb het, laat me deze pagina niet meer zien en log de volgende keer direct in.`,
"label.assignedapprover":`Toegewezen Goedkeurder`,
"template.chart.htlx":`Contracttype Statistieken`,
"scope":`Binnen bereik`,
"label.workmate.search":`Collega's zoeken`,
"message.validation.isnotdigits":`Voer het ongeldige nummer in`,
"label.ccpeak.use.class.time.page":`Als de klasse wordt aangeroepen door een aangepaste pagina, roep dan de invoker() methode op in de klasse PageClsInvoker.`,
"setup_mainpage_label_welcome27":`Het CloudCC-cloudplatform biedt functies zoals importeren, exporteren, batchgewijs wissen en batchgewijze overdracht van alle objectgegevens in het systeem.`,
"front-epwechat-module-v1-epwechat-integrate":`WeCom Integratie`,
"label.file.publiclink":`Openbare link`,
"front-epwechat-module-v1-input-name":`Voer de naam van de onderneming in`,
"lable.Number.of.columns":`Kolommen`,
"message.error.dev.service.duplicateparameter":`Dienst parameters dupliceren.`,
"label.projectManagement.percent.complete":`Percentage van voltooiing`,
"label.chatter.nextSevenday":`Komende 7 dagen`,
"chatter.feed.myfollowers":`Mijn volgers`,
"label.bacchtransfer.pleaseselecttouser":`Overdracht naar`,
"label_partner_workspace_member_memo":`Alle gebruikers met een geselecteerd profiel en rechtenset hebben toegang tot deze partner cloud.`,
"label.marketsea.chosen.member":`Geselecteerde leden`,
"label.marketsea.assignment.setup":`Toewijzingsinstellingen`,
"label.myaccount":`Mijn Rekeningen`,
"label.schedulejob.setup.schedule.executedate":`Uitvoeren Tijd`,
"label.uploadaccessory":`Bijlage uploaden`,
"Homepage.News.004":`Geen recent nieuws.`,
"label.marketsea.name":`Naam van de leidende pool`,
"label.pending.task":`Open Taken`,
"label.report.details":`Details`,
"UG.homepage.008":`Inzicht in de huidige bedrijfsstatus (verkoopbriefings, leaderboards, verkooptrechters, enz.), zicht op zakelijke kansen die problematisch kunnen zijn, voorspelling van toekomstige prestaties, tijdige acceptatie en toewijzing van belangrijke kwesties, en weloverwogen beslissingen.`,
"label.h5.similar.opportunity.clear.all":`Alles wissen`,
"label.tabpage.noz":`Geen`,
"label.report.recent.all.reports":`Alle verslagen`,
"vue_label_lead_to_score":`Klik op Score om leads te scoren in de huidige weergave.`,
"vue_label_normal_receivable_sf":`Te ontvangen`,
"label.layout.edittabdistribute":`Tabblad Indeling Bewerken`,
"label.validate.function.funcFormat.PRIORVALUE":`PRIORVALUE(veld)`,
"label.salescloud.field.editoptionlist":`Keuzelijst bewerken`,
"APPIntegration.Dropbox.01":`Selecteer bestanden uit Dropbox`,
"label.campaign.channel.step2":`Stap 2: Stel de standaard lead veldwaarden van dit marketing kanaal in`,
"label_partner_new_function":`Functiebeschrijving`,
"vue_label_chat_no_search_results":`Geen zoekresultaten`,
"vue_label_commonobjects_detail_visitstate":`Bezoek staat`,
"label.sendemail.send.testemail":`Dit is een test e-mail, als u deze e-mail kunt ontvangen, kunt u deze mailbox gebruiken om e-mail te versturen.`,
"label.attendance.clear.position":`Duidelijke oriëntatiepunten`,
"chatter.write.n":`Reageer op dit bericht`,
"label_chatter_sendmail":`Stuur e-mail`,
"label.remindertime":`Herinneringstijd`,
"label.app.elegantgray":`Elegant Grijs`,
"label.tabpage.ownedz":`Helemaal`,
"label.select.approval":`Selecteer de goedkeurder`,
"UG.Lead.007":`Google sync`,
"chatter.emailSetUp":`Mijn CCChat Remind Setup`,
"label.default.censor":`Examinator in gebreke`,
"vue_label_notice_uploadavatar_success":`Avatar succesvol geupload`,
"label.sms.title":`SMS-interface-informatie`,
"front-console-choose-contact":`Kies Contact`,
"label.field.edit.des":`Een hogere score geeft meer stericoontjes, en de maximumscore is 100.`,
"label.pw.big.letter":`Hoofdletters`,
"label.select.time.dimension":`Kies tijd dimensie`,
"UG_Campaign_004":`Campagne importeren`,
"label.dashboard.summary":`Metrisch`,
"label.ems.yahoo":`Yahoo!`,
"label.leadscore.rule.name":`Leadscores Regel Naam`,
"vue_label_calendar_object_name":`Naam van het object`,
"label.icon.69":`Machine`,
"label.reporttotal":`Totalen`,
"lable.SalesCommitmentKanBan.theActualContract":`Werkelijk contractbedrag`,
"label.project.member.data":`Deze gebruiker is al lid van het huidige project!`,
"label.cloudccclass.list.viewremark":`Hulp voor deze pagina`,
"label.deleteObject.isNotAdministrator":`U bent geen beheerder en u kunt geen objecten verwijderen.`,
"lable.edit.queue.nameandemail":`Wachtrij naam en e-mail adres`,
"label.recordtype.tabname":`Record Soorten`,
"label.file.is.ok":`Is het ok`,
"label.knowledge.language.german":`Duits`,
"label.layout.realityapprover":`Feitelijke goedkeurder`,
"label.ems.with7day":`Binnen 7 dagen`,
"label.autoRegister.changepwd.setpwd.setpwd.button":`Opzetten`,
"label.weixin.edit.polls":`Wijzig stemming`,
"label.layout.mobile.default.tab":`Selecteer de standaard op tab in Mobiele applicatie`,
"vue_label_report_deletegroupcolumn":`Groep kolom verwijderen`,
"label.group.archived.success":`Archief met succes`,
"label.customfields.formula.returntype":`Formule Type terugkeer`,
"label.file.followers":`Volgers`,
"label.textmessage.new.templates.message1":`Sjabloonnaam kan niet leeg zijn！`,
"label.selected.field.length":`Niet meer dan 10 geselecteerde fileds`,
"ObjectDetailed_ViewKeyInformation_Layout":`Belangrijke informatie bewerken`,
"label.paging.totalofpage":`Een totaal van {0} pagina's`,
"label.ccchat.message.new.error41":`Om met meer mensen te praten, probeer groepen te gebruiken`,
"message.recordtype.detail.noselectlist":`Er kan geen keuzelijst worden weergegeven`,
"label.conditiontag.lookup.title":`Selecteer de waarden in de keuzelijst hieronder om toe te voegen.`,
"label_partner_setup":`Partner cloud-instellingen`,
"front-epwechat-module-v1-android-packname":`Android Pakket Naam:`,
"lable.custom.Current.CY":`Huidige CY`,
"label.newprocess2.desc":`Als de korting groter is dan 0.3%, evalueert naar waar.`,
"label.operatedata.selectobjectfields":`Selecteer de velden van het geëxporteerde object`,
"report_reportdatasource_label":`Verslag Gegevensbron`,
"label.chosesubject.others":`Andere activiteiten`,
"label.list.desc2":`U kunt een pc-pagina genereren voor toegang vanaf de pc of een mobiele pagina voor toegang vanaf mobiele apparaten.`,
"vue_group_several_groups":`{totalSize} groepen`,
"label.page.button.linkurl":`Knop of Link URL`,
"show.week":`Show weekend`,
"label.gotocalendar.new":`Ga naar de kalender en maak evenementen aan`,
"button.reset.advancedsearch":`Geavanceerd zoeken voorwaarden wissen`,
"label.h5.chatter.feedandcomnum":`Post en laat een bericht achter`,
"lable.opppdt.addpdt.table.unitprice":`Verkoopprijs`,
"label.dataimport.validate":`Selecteer de uit te voeren verificatie`,
"label.lead.score":`Leadscores`,
"vue_label_help_product":`Product- en prijsbrochure`,
"label.role.select":`Selecteer Rollen`,
"lable.opppdt.selPdt.searchproduct":`Zoek producten`,
"component_event_label_newevent":`Nieuwe evenementen`,
"front-invoice-online-payment-setup-configure-button":`Nu configureren`,
"label.stdashbord.xsld.business.img2":`Totale hoeveelheid opportuniteitsfase met waarschijnlijkheid 1%-99%`,
"label.event.moveup.2week":`2 weken vooruit`,
"label.partnerCloud.priceOfManual.allCustomer":`Alle Rekeningen`,
"lable.account.dep":`Klik op de knop Nieuw om een nieuw fiscaal jaar te definiëren.`,
"label.dataimport.insertdata.error.null.update":`De waarde van $schemefield_name$ in deze record is null en kan niet worden bijgewerkt. De record heeft import genegeerd.`,
"label_component_helper_businesschange_0activity":`30 dagen zonder enige activiteit`,
"lable.account.NextbbDays":`Komende 60 dagen`,
"label_scope_length":`Bereik-lengte`,
"label.customfields.operation":`een gegevensexport uitvoeren`,
"serviceappointment.save.workorder":`Kies een werkbon die bij de werkbonpost hoort.`,
"label.field.update.hide.editor":`Formule-editor verbergen`,
"button.partner.new":`Nieuwe partner cloud`,
"label.stdashbord.xsld.business.oppdetails":`Mogelijkheden Details`,
"message.pleasewaitingnextversion":`Deze functie zal in de volgende release beschikbaar zijn.`,
"label_tabpage_potentialcustomersz":`Leads`,
"label_emailtocloudcc_step2":`Stap 2`,
"label.weixin.username":`Naam`,
"label.quickbooks.viewlist.type":`TYPE`,
"front-kefu-moudle-v1-Select-seats":`Kies een agent`,
"label.customsetting.manage":`Beheer`,
"label.tabpage.field":`Veld`,
"label.custom.page.button.icon.URL":`Knop Pictogram URL`,
"font-evaluate-module-v1-evaluation-link":`Voeg evaluatie link toe:`,
"vue_label_salesfunnel_notice3":`Aantal zakelijke kansen met een waarschijnlijkheid van 1% - 99%`,
"front-email-payment-describe":`Dank u voor uw steun aan ons bedrijf. U kunt online betalen via de volgende link, en facturen bekijken, afdrukken en downloaden in PDFformaat.`,
"label.productsales.today.noevttskaddevt":`Er zijn geen openstaande gebeurtenissen en aflopende taken, u kunt op " " in de rechterbovenhoek klikken om een nieuwe gebeurtenis toe te voegen.`,
"component.setup.iframe.label.memo":`Klik op het instellingen icoon en voer het embedded url adres in.`,
"front-email-payment-select-country":`Voer het land in`,
"label.ems.starred":`Mails met sterretjes`,
"component_setup_label_object":`Objecten`,
"label.query.detail.viewpartneruser":`Bekijk partner gebruiker`,
"this.year":`Dit jaar`,
"serviceresource.isactive.notactive":`Deze dienst is niet ingeschakeld.`,
"label.marketing.message.recipientisnull":`De ontvanger kan niet leeg zijn`,
"label.unfold":`Uitbreiden`,
"label.service.assetBOM.view.tip":`U hebt geen toestemming om asset BOM te bekijken. Neem contact op met de beheerder.`,
"label.validate.function.funcExplain.ISCHANGED":`Controleer of de veldwaarde verschillend is van de vorige waarde. Zo niet, geef dan TRUE terug, anders FALSE.`,
"label.validate.function.funcExplain.NOW":`Geeft als resultaat een datum en tijd die het huidige moment vertegenwoordigen`,
"label.phoenix.islands.time":`Phoenix is. Time`,
"vue_label_checkduplicate_complete_filter_rules":`Gelieve de filtervoorwaarden in te vullen`,
"vue_label_report_rowcount":`Rij tellen`,
"chatter.p":`persoon`,
"label.umeng.activity.distributetask":`je een taak toegewezen.`,
"UG_quota_05":`Bisync met kansen`,
"june":`Juni`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.tuesday":`Dinsdag`,
"vue_label_commonobjects_view_chart_upto5":`Tot 5 groepen`,
"vue_label_opportunity_contactrole_searchallcontacts":`Alle contacten doorzoeken`,
"label.custom.field.task.notice":`Taak Kennisgeving`,
"label.weixin.insert.address":`Plaats invoegen`,
"label.attachementNew.desc":`Archiveer de bijlage bij een document, en de bijlage kan niet worden verwijderd.`,
"setup_mainpage_label_welcome18":`Met de machtigingsinstellingen op ondernemingsniveau van CloudCC kunt u de gebruiksrechten van individuele gebruikers controleren terwijl ze met gegevens en modules werken. De op rollen gebaseerde machtigingsinstellingen omvatten ook gebruikersposities, groepen, rollen, regels voor het delen van gegevens en beveiligingscontroles op veldniveau om het delen van gegevens tussen verschillende mensen en afdelingen van de onderneming mogelijk te maken.`,
"front-kefu-instance-noarea":`Er is geen instantie voor dit gebied aangemaakt, kies opnieuw`,
"label.please.ChooseMax":`Kies tot {een} productopties.`,
"label.businesschance":`Kansen`,
"label.verticalline-group":`Verticale kolommen-Kolom groepering`,
"label.ordering.platform":``,
"label.product.pricebooks.ples":`Selecteer Prijs Boek`,
"vue_label_norm_addcomponent":`Nieuw onderdeel`,
"label.ServiceCloud.Installation.address":`Installatie Adres`,
"vue_label_report_groupcolumn":`Groep kolom`,
"label.ccchat.person.invite.notallsucc":`{0} e-mailadressen werden opgeslagen maar niet verzonden. om een uitnodiging te verzenden, corrigeert u de volgende fout en klikt u op verzenden.`,
"label.customfields.optionlist.tip":`Stelt gebruikers in staat een waarde te selecteren uit een lijst die u definieert.`,
"UG.activity.07":`Maak een taak`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.last":`Laatste`,
"label.permission.accessname":`Toegangsnaam`,
"lable.custom.year.stadate":`Aangepast jaar Begindatum`,
"label.ems.inputmails":`E-mail server ontvangen (i)`,
"label.cpq.quote.transfer.order.already":`Deze offerte is overgezet naar order. Gelieve de oorspronkelijke bestelling te verwijderen en vervolgens een nieuwe bestelling te creëren.`,
"label.sendletter.status":`Status van campagnelid`,
"vue_label_commonobjects_view_save_as_view":`Opslaan als bekijken`,
"message.mobilechooseatmostfive":`Selecteer tot 5 velden`,
"label.errormessage.batchedit.nopermission":`Geen gegevensrecord waarvoor u bewerkingstoegang hebt.`,
"label.dataoperate.tip":`Selecteer de bewerking en de objecten.`,
"label.enableoperate":`Beschikbare acties`,
"label.ems.usernamepassword.error":`Mailbox account of wachtwoord fout.`,
"label.campaignmember.selectmember.deletemember":`Leden verwijderen uit`,
"label.Tab":`Tabs`,
"label.emailobject.template.message1":`Selecteer een veld, en klik op "Invoegen". Met de ">" klik om meer beschikbare velden te zien.`,
"label.approvalstep3.tip":`Specificeer de gebruiker die records moet goedkeuren die in deze stap binnenkomen. Kies optioneel of de gedelegeerde van de goedkeurder deze verzoeken ook mag goedkeuren.`,
"label.inusing":`Actief`,
"label.edit.select.tre":`Checkbox Lijst`,
"label.appointmentconfirmail.wizard.title1":`Hallo {0}`,
"label.partnerCloud.financeSetting.setAlipay":`Alipay instellen`,
"lable.edit.queue.avobj":`Beschikbare Objecten`,
"vue_label_checkduplicate_verify_all_characters":`Controleer alle tekens`,
"label.huntingzone":`Zoekbereik`,
"label.request.approved":`Het verzoek is goedgekeurd, niet herhalen.`,
"label.sharerule.msgerror":`Interne fout bij de server`,
"front-epwechat-module-v1-tick-unbound":`Gelieve bovenstaande vrijblijvende informatie aan te vinken en te aanvaarden`,
"label.console.step6":`Stap 6 Kies hoe lijsten worden weergegeven`,
"label.multilang.micropost.vote":`{0} ticket(s)`,
"message.error.appid.null":`De geheime sleutel kan niet null zijn!`,
"lable.product.delq":`Problemen verwijderen`,
"label.h5.approval.leixing":`Goedkeuringstype`,
"label.edit.field.select.style1":`Tegel elke optie`,
"label.passwordPolicy.setup.alpandnum":`Moet alfanumerieke en numerieke tekens combineren`,
"label.ems.close2":`Sluiten`,
"label.report.reporttypetitle":`Gegevensbron`,
"label.umeng.approval.approvalsuccess":`werd ter goedkeuring voorgelegd.`,
"label.page.showamount":`Totaal records per pagina`,
"label.copy.asset.successfully":`Kopieer asset BOM succesvol.`,
"vue_label_homepage_bigscreen_dark":`Dark`,
"vue_label_email_selected_members":`Geselecteerde leden`,
"label.file.preview":`Voorbeeld`,
"label.partner.new.step3.name":`Naam`,
"label.forecast.settings.periods.ago":`cyclus(s) geleden`,
"label.evaluation.praise":`Goed`,
"label.cloudccsite.edit":`Site bewerken`,
"label.knowledgebase.advanced.filtering":`Geavanceerd filter`,
"label.knowledgebase.framework":`Frame`,
"vue_label_pool_ownedpool":`Master Pool`,
"label.exchange.sync.setting.license":`Als deze functie is ingeschakeld, kunnen sommige gegevens van uw organisatie worden opgeslagen op Microsoft Exchange-server in de vorm van een interne implementatie of een cloud-basis en worden verwerkt via Microsoft Exchange-server.`,
"front-console-conversation-btn2":`Antwoord per email`,
"label.projectManagement.thelastone":`Dit is de laatste plaat.`,
"message.duplication.confirmscript.mergeoperation":`Deze records worden samengevoegd tot één record door middel van de geselecteerde waarden. Opmerking: de actie van samenvoegen kan niet worden herroepen. Weet u zeker dat u de records wilt samenvoegen?`,
"lable.outlook.detail.nosyn":`Uit sync`,
"label.iscopy":`Toestaan van kopiëren`,
"message.matrixReportSetupStage.row":`Selecteer 【Specify Row Headers】 subtotaalbasis, en u moet ten minste één subtotaalbasis selecteren in twee subtotaalbasissen.`,
"label.forecast.forehistory.possibility":`Waarschijnlijkheid`,
"label.timetrigger.validate":`De ingevoerde waarde moet een positief geheel getal zijn, en het systeem zal automatisch de workflowacties uitvoeren wanneer aan de afhankelijkheid van de workflow is voldaan, het systeem zal automatisch de workflowactie uitvoeren.`,
"member.name.choice.field":`De naam van het lid is een verplicht veld !`,
"label.undone_external page":`Dit is onomkeerbaar, dus gelieve te bevestigen. Dit formulier wordt niet gebruikt op een login pagina, maar kan elders gebruikt worden. U kunt bijvoorbeeld de embedcode gebruikt hebben om het in een externe pagina te plaatsen.`,
"UG_Lead_012":`Aanwijzingen importeren`,
"component_chatter_label_fans":`Volgers`,
"label.systeminfo":`Systeem Informatie`,
"label.mr.descreption.oneGroupNote1":`Selecteer ten minste twee gegevens en klik op [Geselecteerde informatie laden] om naar de pagina met samengevoegde gegevens te gaan.<br>Dit is de`,
"label.wtd.changefields.selfields":`Selecteer de velden die u in uw Web-to-CloudCC-formulier wilt opnemen:`,
"message.error.fileinfoid.null":`fileinfoid kan niet leeg zijn! Bestandsinformatie id`,
"label_tabpage_cownerz":`Verander eigenaar`,
"setup_layout_button_save":`Save`,
"Dashboard.View.Createdbyme":``,
"label.escalation.setup.detail.order":`Bestel`,
"button.partner.start":`Begin te gebruiken`,
"label.htyj.remark1":`Uw huidige editie ondersteunt het bekijken van contract objecten niet`,
"component.event.label.person":`Aangewezen persoon`,
"label.appointmentconfirmail.wizard.subtitle3":`Locatie`,
"label.emailtocloudcc.filed.username":`Email Adres`,
"label.vlidaterule.remark":`Definieer een validatieregel door een foutconditie en een bijbehorende foutmelding te specificeren. De gebruiker kan de fout corrigeren en het opnieuw proberen.`,
"message.duplication.label.insertoption":`Actie op creëren`,
"front-web-module-v1-detail-comment-toast":`Gelieve alle evaluaties in te vullen`,
"label.import.page2.notsuitedfiledwillbenotimport":`Opmerking: Het systeem zal geen velden importeren die niet in kaart zijn gebracht`,
"label.h5.similar.opportunity.enable":`Gelijkaardige kansen mogelijk maken`,
"label.allunfold":`Alles uitbreiden`,
"component_setup_iframe_label_inputurl":`Voer het url-adres in`,
"label.manage.all":`Alles beheren`,
"label.mobile.side.tab.cs":`Gemeenschappelijke functies`,
"label.datamanage.contact.information":`Contact Informatie`,
"lable.outlook.edit.sel":`Kies een waarde`,
"label.imgfield.type.url.tip2":`Bijvoorbeeld: http://www.cloudcc.com/images/logo.png&cimgSize=50,50`,
"setup.layout.label.areasetup":`Sectie Eigenschappen`,
"label.date":`Datum`,
"vue_label_commonobjects_detail_openfilter":`Filter uitbreiden`,
"label.loginip.pagecue":`Voer het bereik in van geldige IP-adressen vanwaar gebruikers met dit profiel kunnen inloggen.`,
"vue_label_email_not_valid":`Het ingevoerde e-mailadres is geen geldig e-mailadres`,
"label.page.step5.add.application":`Stap 5 Toevoegen aan aangepaste apps`,
"label.dashboard.donot.delete":`U kunt deze map niet verwijderen omdat er enkele dashboards in staan.`,
"label.visitAPPexchange":`CloudCC App Store (Nieuw venster)`,
"label.generate.location":`Genereren van lengte- en breedtegraadgegevens van de klant.`,
"lable.quote.syncing.syncingbutton":`Sync`,
"label.pw.error.text":`De twee wachtwoorden die u heeft getypt komen niet overeen.`,
"label_partner_setup_Enable":`Verifieer`,
"label.file.preview.unav":`Preview unavaliabled`,
"label.sms.tip":`Van het internet`,
"setup.mainpage.label.welcome21":`Het CloudCC-cloudplatform biedt een door de gebruiker gedefinieerde e-mailsjabloonfunctie, die handig is voor gebruikers om te gebruiken en de werkefficiëntie te verbeteren.`,
"label.trigger.for.example":`Bijvoorbeeld: update de gelegenheid in account update trigger, update de account update trigger in gelegenheid en trigger de account update trigger. Als er geen if no conditionele controle in de trigger zit, dan laat het systeem maximaal 3 van dergelijke circulaire aanroepen toe.`,
"setup.layout.button.layoutprop":`Eigendommen`,
"component.chatter.label.fans":`Volgers`,
"lable.PowerProcess.event.edit":`Mijlpaal bewerken`,
"label.detailintro":`Posten Beschrijving`,
"vue_label_report_nosearchresults":`Geen zoekresultaten`,
"error.name.repeat":`Naam kan niet worden herhaald.`,
"label.emailEncoding":`E-mail codering`,
"label.partnerCloud.financeSetting.enableAccount":`Activeer korting rekening`,
"label_emailtocloudcc_clear":`Duidelijk`,
"setup_mainpage_label_welcome12":`De gebruiker kan de rapportdefinitie voltooien door met de muis te klikken, zonder te programmeren, en de stappen van het systeem te volgen. Het systeem kan kiezen uit een lijstrapport, een samenvattingsrapport en een matrixrapport. Weergave-opties voor alle velden zijn ook beschikbaar. Verwijder onnodige veldinformatie. Tegelijkertijd biedt het een verscheidenheid aan grafische weergaven, waaronder stroken, vouwlijnen, ringen, trechters en taarten, zodat gebruikers in één oogopslag kunnen zien.`,
"lable.SalesCommitmentKanBan.contractStartDate":`Aanvangsdatum contract`,
"front-starter-v1-potential-customer-tips-success":`Activeer Leadpool met succes`,
"UG_Forcast_02":`Prognoses zijn ramingen van de verwachte verkoop voor een bepaalde periode, en prognosemodellen kunnen u helpen de vraag naar producten en de verkoopopbrengsten in een bepaalde periode te bepalen. Managers kunnen prognoses gebruiken om doelen te stellen en de voortgang van het team te meten. De algemene prognose van de organisatie kan een weerspiegeling zijn van de samenvatting van alle verkopen per verkoopvertegenwoordiger (ongeacht het stadium van voltooiing van de verkoop, van het stadium van de pijplijn tot het stadium van afgesloten verkoop).`,
"label.escalation.setup.detail.ruleentries":`Regel Ingangen`,
"lable.SalesCommitmentKanBan.allComplete":`Totaal Totaal Bedrag`,
"label.appupload.install.apicanuse":`De api-naam is beschikbaar`,
"label.organiza.field":`Organisatie Velden`,
"button.partner.workspace.manage":`Beheer`,
"lable.PowerProcess.setevent":`Mijlpaal Instelling`,
"label.emailobject.groupemail.msg2":`E-mail adres ontbreekt. Hierdoor kan de e-mail niet naar deze ontvanger worden verzonden.`,
"label.h5.orderbyname":`Gesorteerd op naam`,
"vue_label_salesadvance_opportunities":`Nummer van de gelegenheid`,
"label.appointment.disable.cancel":`Annulering uitschakelen`,
"label.trigger.folder.edit":`Trigger pagina : Map bewerken`,
"label.customfields.new.step2.opration.unique.info.v2":`Behandel "ABC" en "abc" als verschillende waarden (hoofdlettergevoelig)`,
"label.icon.40":`Positionering`,
"label.eventmenuandlink":`Knoppen en koppelingen voor evenementen`,
"label.service.gantt.candidate":`Kandidaat`,
"label.top.userphoto":`Foto gebruiker`,
"label.appointmentconfirmail.wizard.btn2":`Annuleer vergadering`,
"label.print":`Afdrukken`,
"saveandreturn":`Opslaan en terug`,
"lable.account.CurrentandNextCY":`Huidig en volgend CY`,
"label.group.no.recent1":`U hebt geen actieve groepen bekeken.`,
"lable.Asset.conversion":`Genereer activa volgens "Asset Transition" van het orderproduct bij het overdragen van activa.`,
"label.emailtocloudcc.button.sure":`Bevestig`,
"label.Path.List":`Pad Lijst`,
"label.please.rule.name":`Geef de naam van de regels op.`,
"label.knowledge.category.hint.six":`Beschikbare Categorie Groep`,
"setup_mainpage_label_welcome28":`Instructies: Klik op het menu aan de linkerkant van deze pagina → Beheer Instellingen → Gegevensbeheer → Gegevens Importeren en Exporteren, Batch Overdracht, Batch Verwijderen.`,
"vue_label_commonobjects_view_chart_editchart":`Grafiek bewerken`,
"label.permission.detail.app.object":`Object Instelling`,
"label.multilang.totalpage":`van`,
"label.marketsea.button.return":`Terug`,
"Click.to.load.more":`Klik om meer te laden`,
"label.validate.globalvariable":`Globale variabele`,
"label.marketsea.iseditseabymanager":`Sta beheerders toe om de lead pool te veranderen.`,
"label.price.yuan":`Prijs (Yuan)`,
"label.service.resource.uesr.tip":`Selecteer een gebruiker om service resources te maken en het type resources kan geen crew zijn.`,
"vue_label_help_viewusageguide":`Bekijk de gebruikershandleiding van de Lightning-versie`,
"label.autoRegister.changepwd.setpwd.too.long":`Te lang.`,
"label.campagin.roi.fwsl":`Aantal bezoeken`,
"label.campaign.mobile":`Mobiele app`,
"UG.Lead.012":`Aanwijzingen importeren`,
"link.recordtype.detail.backtoobject":`Terug naar aangepaste objecten`,
"front-kefu-moudle-callcentrt-hasclose":`Call Center is gesloten`,
"label.category.5":`IT High-tech`,
"label.import.page1.selectwayofdealdata":`Kies de gegevensverwerkingsmodus`,
"chatter.emailReceiveEmail":`CCChat-herinnering ontvangen`,
"vue_label_file_manage_lib_members":`Bestandsbibliotheek leden beheren`,
"label.appupload.upload.overview":`Recapitulatie`,
"label.service.miniProgram.inputNumber":`Gelieve een nummer in te vullen tussen 0-999.`,
"label.emailtemplate.finishdetailinfo":`Vul de Email sjabloon gegevens in.`,
"label.weixin.fmu.before.day":`{0} dagen voor`,
"label.integrations.login":`Inloggen`,
"label.dashboard.setUpHomePage":`Homepage is ingesteld om weer te geven`,
"label_partner_common_webSit":`Domein`,
"front-epwechat-module-v1-unbound-user":`Nietgebonden gebruikers`,
"label.partnerCloud.basicSetting.offline":`Offline betaling activeren`,
"label.start.loginip":`Start IP-adres`,
"label.projectManagement.delete.subtasks":`Alle gerelateerde informatie van deze subtaak zal ook worden verwijderd als u deze subtaak verwijdert, en de gegevens kunnen niet worden hersteld. Weet u zeker dat u de verwijdering wilt bevestigen?`,
"label.message.batchapp":`Massa Goedkeuring`,
"message.duplication.label.ruletitle":`Dubbele regels`,
"label.all_networks":`Alle netwerken`,
"label.select_columns":`Selecteer de kolommen die u wilt zien voor uw formulierinzendingen`,
"vue_label_notice_uploadavatar_exceed":`De grootte van de geüploade avatarafbeelding mag niet groter zijn dan 2MB`,
"message.error.get.failed":`Ik heb geen informatie gekregen!`,
"label.quickbooks.viewlist.duedate":`VERPLICHTINGSDATUM`,
"label.ccchat.topic.search":`Zoek Onderwerp`,
"label.forecast.shre.manager":`Manager Opdracht`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.thursday":`Donderdag`,
"lable.product.pricebooks.copy":`Kloon van bestaand prijsboek`,
"label.instrumentPanel.minLabelname":`Deze waarde moet positief zijn en lager dan de breekpunt 1 waarde.`,
"front-market-form-createdsecond":`Automatisch invullen van velden op de registratiepagina`,
"label.submission_detail":`Indiening Detail`,
"label.customfields.checkbox.tip":`Hiermee kunnen gebruikers een Waar (aangevinkt) of Onwaar (niet aangevinkt) waarde selecteren.`,
"label.escalation.setup.list.description":`U kunt automatisch acties bepalen wanneer de cases aan de criteria voldoen en na de opgegeven tijd. Wanneer u een zaak escaleert, kunt u ervoor kiezen om de gebruiker automatisch te verwittigen en de zaak aan een nieuwe gebruiker toe te wijzen.`,
"UG.Forcast.05":`Voorspellingsinstellingen: stap {0}/{1}`,
"label.data.import":`Gegevensinvoer`,
"label.upload.error.cause":`upload mislukt vanwege`,
"label.search.change.remark":`Geldt voor de objecten instellingen weergegeven in de zoekbalk aan de linkerkant van de homepage`,
"serviceappointment.edit.status.limitwithstatus":`De status van de serviceafspraak kan niet worden gewijzigd van {0} in {1}`,
"label.department.operation":`Operatie`,
"label.textmessage.vonage.message3":`Om API Sleutel en API Geheim op te zoeken, kunt u inloggen op uw Vonage API account en naar "Instellingen" gaan onder uw accountnaam. Om telefoonnummers op te zoeken die u in uw Vonage API account heeft, kunt u naar Nummers gaan onder Producten, en klikken op "Uw nummers" om alle telefoonnummers te zien die u heeft.`,
"label.privacystatement.dialog":`Privacyverklaring (Nieuw venster)`,
"label.datamanage.import.leadfield":`Selecteer in de volgende lijst de velden in het importbestand die leads moeten importeren. Klik dan op volgende:`,
"label.appupload.upload.install.failar":`Installeren mislukt.`,
"label.viewall":`Bekijk alle`,
"label.sendemail.chat.addComentsfavoritesubject":`CloudCC CCChat antwoord op Bladwijzer`,
"lable.custom.dp":`Op deze pagina kunt u aangepaste jaren definiëren.`,
"label.mobile.more.share":`Delen met collega's of groepen`,
"lable.name.cannot.be.empty":`Naam kan niet leeg zijn`,
"label.autoRegister.changepwd.setpwd.password":`Uw wachtwoord`,
"label.multipleactivity.aevents":`Gebeurtenis(en)`,
"label.many.dayline.lastday":`Laatste dag`,
"lable.Please.bind.the.QuickBooks.record.first":`Bind quickbook records eerst.`,
"vue_no_related_dashboards":`Geen relevante dashboards!`,
"label.newdashboardpage.name":`Naam`,
"vue_label_commonobjects_detail_network":`Relatie Net`,
"label.tianyancha.reginstitute":`Registratieautoriteit`,
"label.the.lower.bound.of.each.level.must.be.equal.to.the.upper.bound.of.the.upper.level.":`De ondergrens van elk niveau moet gelijk zijn aan de bovengrens van het hoogste niveau bij prijsbepaling per blok.`,
"label.chat.file.upload.info":`Bestanden uploaden`,
"label.appexchange.vlidaterule":`Validatieregels`,
"label.salescloud.salesdashboard.current.business":`Huidige mogelijkheden`,
"label.app.step4.homeisfrist":`De startpagina moet het eerste tabblad zijn en kan niet worden verwijderd.`,
"label.weixin.micro.research.optionname":`Micro-enquête Keuze Naam`,
"label.paging.totalofnbsp":`Een totaal van {0}`,
"label.opportunity.perm.title":`Toegang aanvragen`,
"front-kefu-moudle-v1-zhyzcw-reinput":`Fout bij verificatie huurder. Gelieve opnieuw in te voeren`,
"label.unsaved_changes":`Als u doorgaat met de bewerking, gaan nietopgeslagen wijzigingen verloren.`,
"label_partner_all_description":`Beschrijving`,
"lable.account.Next.CQ":`Volgende CQ`,
"chatter.feed.menutype.feed.me":`Voor mij.`,
"label.sourcetranstemp":`Bron - Produceert één bestand dat alle tekst bevat die kan worden vertaald`,
"label.apply.newuser.validate":`CloudCC registratie van nieuwe gebruiker, validatiecode:`,
"label.user.password.error":`Fout in gebruikersnaam of wachtwoord, of ongeldige gebruiker!`,
"label.there.is.no.quotation.line.item.in.this.quotation.line.group.at.present.":`Er zijn geen quote line items gevonden in deze quote line groep. Klik op "Product toevoegen" om toe te voegen.`,
"lable.PowerProcess.time.filed":`Gebaseerd op het datum en tijd veld op {detailInterestType}`,
"label.file.default.value.is.integer":`Alleen gehele getallen kunnen worden ingevoerd`,
"label.processsetting.please.select.field":`Selecteer de velden.`,
"label.app.step3.introduce":`De bestandsgrootte van een aangepast app-logo moet kleiner zijn dan 20 KB. De afmetingen van de afbeelding mogen maximaal 300 pixels breed en 55 pixels hoog zijn voor het beste resultaat. Grotere afbeeldingen worden verkleind en kunnen er vervormd uitzien.`,
"button_partner_save":`Save`,
"label.marketingmanagement":`Marketing`,
"label.isEnableVisualpage_new.leftlist":`Beschikbare aangepaste pagina's`,
"label.salescloud.teamrole.optionlist.choose.correct":`Hetzelfde item bestaat in de lijst, gelieve te wijzigen.`,
"System_ChangeUser_Info_001":`Eigenaar gewijzigd en klik om terug te keren naar de vorige pagina.`,
"front-console-no-contact":`Geen contact`,
"component.assistant.label.overduetask":`Kansen met achterstallige taken`,
"label.roleofpartner":`Partnerrol`,
"label.appointmentconfirmpage.wizard.subtitle4-1":`Jij en {0}`,
"front-template-V1-Please-select-a-picture":`Kies een afbeelding`,
"lable.SalesCommitmentKanBan.allsignedCommitmentRate":`Totaal ondertekende toezeggingen`,
"label.h5.similar.opportunity.step2.conment":`Selecteer tussen 3 en 10 velden of gerelateerde lijsten om mee te vergelijken bij het vinden van soortgelijke kansen.`,
"label.projectManagement.alert.frequency.will.not.work":`Als u Nee selecteert, zal de herinnering niet werken.`,
"vue_label_fllscreen":`Bekijken op volledig scherm`,
"label.customfields.selectcontainfieldlayout":`Selecteer de pagina-indelingen die dit veld moeten bevatten.`,
"label.appointment.wizard.subtitle1-4":`45 min.`,
"label.tianyancha.businessverify.unagree":`Niet mee eens`,
"label.unique":`Uniek`,
"setup_mainpage_label_welcome10":`Instructies: Klik op het menu aan de linkerkant van de pagina → Application Settings → Create → Object → Object Name → Custom Layout.`,
"vue_label_account_subsidiary":`Dochteronderneming`,
"label.dataimport.format.error":`Formatteringsfout, gebruik het formaat MM/DD/JJJJ of JJJJ-MM-DD.`,
"label.email.new":`Nieuwe e-mail`,
"label.log.descri":`Werking Beschrijving`,
"vue_label_dashboard_componentname":`Voer de naam van het onderdeel in`,
"label.weixin.quick.reply":`Snel antwoord`,
"label.productsales.payment.badversion":`Uw huidige editie ondersteunt het bekijken van contractobjecten niet, dus u kunt de betalingslijst niet bekijken.`,
"label.position":`Locatie`,
"label.Annex.Conditions":`Logische filters toevoegen voor extra voorwaarden (bijv.: 1 en 2 of 3)`,
"label_tabpage_endz":`Einde`,
"label.setup.mobile.bottombutton.prompt":`Opmerking: Als u deze instellingen opslaat, worden de oorspronkelijke instellingen van de mobiele app op het eerste niveau van de gebruiker gewijzigd.`,
"lable.Edit.template":`Bewerk Service Rapport Sjabloon`,
"vue_label_report_onlydisplay2000":`Alleen 2000 gegevens weergeven`,
"label.salescloud.salesdashboard.sign.account.top5":`Top 5 ondertekende rekeningen`,
"label.weixin.ontime":`Punctueel`,
"font-evaluate-module-v1-disappoint":`Sorry dat ik je teleurstel!`,
"chatter.sel.addre":`Tot 5 ontvangers kunnen worden geselecteerd!`,
"label.mobile.phone.month.summary":`Maandelijks overzicht`,
"label.partnerCloud.priceOfManual.selected":`Geselecteerde rekening`,
"label.south.georgia.time":`South Georgia Standard Time`,
"label.create.ccdocument":`Bijlage toevoegen`,
"label.chatter.to":`Naar`,
"label.ems.minute":`Notulen`,
"label.mobile.phone.submit.tome":`Aan mij voorgelegd`,
"label.approvalstep1":`Stap 1 Voer naam en beschrijving in`,
"label.h5.similar.opportunity.last.months9":`Recente 6-9 Maanden`,
"Opportunity_Detailed_Phase_Label_003":`Veranderingsfase`,
"lable.PowerProcess.time.input":`Geef een tijd op.`,
"label.stdashbord.xsld.business.yqzsr":`Verwacht totaalbedrag`,
"label.icon.64":`Zoeklicht`,
"label.data.choses.i_desc":`Importeer gegevens van een enkel object, afhankelijk van uw behoeften.`,
"label.integrations.mainlandchinaleads":`Vasteland China Leads`,
"vue_label_notice_savemenu_success":`Menu succesvol opgeslagen`,
"front-kefu-moudle-v1-xzhxzxkf-online":`Kies voor de online dienst van Easemob`,
"label_chatter_name":`Naam`,
"label.Viewon_Linkedin":`Bekijk op LinkedIn`,
"lable.PowerProcess.chioce.event":`Kies een mijlpaal.`,
"component.chatter.file.label.maxsize":`Maximale bestandsgrootte is 20m`,
"label.validate.function.funcExplain.SECOND":`Geef de tweede van de dag terug (Van datum/tijd-velden)`,
"label.data.downpage.i.title.num4":`4、Indien u een lookup relatieveld en een master-detail relatieveld heeft in het object dat u wilt importeren, moet de waarde voor dat veld ID zijn, anders is het ongeldig.`,
"label.icon.139":`Valuta`,
"label.app.step4.atleastone":`Het tabblad Home kan niet worden verwijderd.`,
"label.weixin.input.telephone":`Voer het mobiele nummer in`,
"label.setup.mobile.bottombutton.remark":`Een organisatie zou de initiële instellingen van de pagina op het eerste niveau kunnen configureren volgens het bedrijfsproces.`,
"label.file.searchs":`Bestanden zoeken...`,
"vue_label_email_there_is_no_draft_yet":`Er is nog geen ontwerp`,
"front-kefu-moudle-v1-bind-seats":`Bind Agent`,
"label.customfields.lookupmuti.tip":`Creëert een relatie die dit object met een ander object verbindt. Het relatieveld laat gebruikers toe op een lookup icoon te klikken om meerdere waarden te selecteren uit een popup lijst. Het andere object is de bron van de waarden in de lijst.`,
"label.integrations.password":`Wachtwoord`,
"label.data.newtemplate.t_conditions":`Sjabloon Voorwaarden`,
"message.error.repeatsubmit":`De indiening wordt herhaald of er worden meerdere vensters op dezelfde pagina geopend. In het laatste geval, gelieve in te dienen in het nieuw geopende venster.`,
"label.umeng.approval.approvalreassign":`Goedkeuringsaanvraag voor de #obj is opnieuw toegewezen. #objnaam`,
"lable.edit.queue.selobj":`Fout: Wachtrij moet ten minste één geselecteerd object hebben`,
"label.compact.layout.frame":`Pagina opmaak kader`,
"label.sms.companyname.dsf.infor":`Deze dienst ondersteunt alleen het vasteland van China`,
"template.report.individual.case.source":`Geval Bron`,
"pagecreator.button.pcpage":`Pc einde`,
"vue_label_commonobject_selectdatatime":`Kies datum en tijd`,
"label.icon.181":`Bestand`,
"label.loginip.setup.please":`Geef het IP-bereik op.`,
"vue_label_dashboard_?secondarygroup":`Gelieve een secundaire groep te kiezen`,
"lable.outlook.mcto.pleasedes":`Voer de e-maildomeinen in die u niet geassocieerd wilt zien, en scheid ze door ",".`,
"DetailedInfo_Activity_EmailMessage_01":`{0} stuur een e-mail naar {1}.`,
"label.sendmail.step4":`Stap 4 De e-mails die u hebt ingediend, worden verwerkt.`,
"label.monitorsys.delete.source":`Beschrijving`,
"label.monitorsys.log.datetime":`Download controle logboek binnen zoektijd bereik (Excel.xls)`,
"component_chatter_label_myfans":`Mijn volgelingen`,
"label.tianyancha.h5.registereddate":`Geregistreerde datum`,
"label.multilang.feedtrack.operatecreate":`{0} record is aangemaakt：`,
"label.console.step6.no":`Kies hoe lijsten worden weergegeven`,
"four":`Four`,
"message.confirmsetpwdforuser":`Wachtwoord opnieuw instellen voor nieuwe gebruikers?`,
"label.cape.verde.time":`Kaapverdische tijd`,
"label.queue.new":`Nieuwe wachtrij`,
"label.cloudccsite.start":`Startpagina van de actieve site`,
"label.data.exp.way":`Exportmethode`,
"label.lock.record.donot.delete":`U kunt de vergrendelde records niet verwijderen.`,
"label_emailtocloudcc_filed_type":`Aanbieder`,
"frame_personinfo_label_minipic":`Miniatuurafbeelding`,
"label.checkfield.choosetab":`Selecteer de velden om deplicaten te vinden`,
"component.setup.tabs.label.default":`Standaard pagina`,
"page.404.button.toknowmore":`Meer informatie`,
"vue_label_SMS_message_sent_cannot_be_empty":`De inhoud van het verzonden bericht kan niet leeg zijn`,
"label.lookupreplaceselectvalue":`Picklist zoeken en vervangen`,
"pagecreator_layout_button_new":`Nieuwe lay-out`,
"label.mobile.more.upload":`Nieuwe versie uploaden`,
"front-kefu-moudle-v1-Connection-failure":`Verbinding mislukt`,
"label.version.support.unlimited":`Onbeperkte ondersteuning`,
"message.error.notmarketseamember":`Geen lid van de lead pool`,
"label.taskandincident":`Taken en gebeurtenissen`,
"label.report.export.print.title":`Rapportweergaven afdrukken`,
"label.file.publicview.error2":`De publieke link is niet correct, gebruik aub een nieuwe publieke link`,
"label_chatter_cancel":`Annuleren`,
"front-web-module-v1-detail-comment-satisfied":`Tevredenheidsniveau`,
"label.knowledge.delete.topic":`Fout bij het verwijderen van het onderwerp gebruikt in dit kennisartikel.`,
"label.forecast.forehistory.all":`Alle`,
"label.displaybutton":`Weergegeven knoppen`,
"label.icon.148":`Robot`,
"label_tabpage_ok":`Bevestig`,
"label.checkfield.merge.mainrecord":`Master Record`,
"label.notification.arketsea.restored":`{5} hersteld {2}  {0}：{1}`,
"setup.mainpage.label.welcome31":`Instructies: Klik op het menu aan de linkerkant van deze pagina → Beheer Instellingen → Aanmaken → Toepassing`,
"front-kefu-moudle-v1-jtrrt-connect":`CloudCCgebruikers associëren met TRRT's extensies`,
"vue_label_calendar_please_select":`Selecteer het weergegeven veld`,
"setup.layout.label.pagename":`Naam pagina-indeling`,
"template.chart.schdywjhz":`Waarde van de campagnekans`,
"label.access_report":`Wie heeft toegang tot dit verslag?`,
"label.assignment.layout.section.optional":`Beschikbaar`,
"label_chatter_recently":`Onlangs`,
"lable.chat.advanced.setting":`Geavanceerde Setup`,
"label.knowledge.category.hint.eight":`Categorie Groep`,
"message.error.facebookuid.null":`Facebook gebruikers ID kan niet leeg zijn!`,
"label.step5.total6":`Stap 5 van 6`,
"label.is.cancel.delete":`De verwijdering annuleren?`,
"setup_mainpage_label_welcome11":`Aangepast rapport`,
"label.answers":`Antwoorden`,
"label.approvalstep1.tip":`Voer een naam, beschrijving en stapnummer in voor uw nieuwe goedkeuringsstap.`,
"template.chart.htjeph":`Contractbedrag Rangschikking`,
"label.campaigns.onsiteregistration":`Registratie ter plaatse`,
"front-epwechat-module-v1-input-agentid":`Voer a.u.b. agentId in`,
"label.emailobject.wizard.desc2":`Traceer geopende e-mails en open tijden`,
"label.multilang.chatterdetial.vote":`{0} ticket(s)`,
"label.customsetting.manage.value":`Aangepaste gegevens`,
"front-electronic-export-listCount":`{totalView} gegevens in totaal in de huidige weergave, selecteer de geïmporteerde gegevens`,
"label.dashboard.create.prompt":`Kan geen dashboards maken over tabellarische rapporten.`,
"label_tabpage_askz":`Wat zou je willen vragen aan`,
"label.ems.sentmail":`Outbox`,
"label.reportlist.untop":`Niet-vast`,
"label.owner.h5.plzchose":`Selecteer de eigenaar en sla op`,
"label.callcenter.addup.10.pieces":`Voeg 10 gegevens één keer toe maximaal`,
"label.ccdocument.save":`Bewaar document`,
"label.productcannotnull":`Product kan niet leeg zijn`,
"label_tabpage_enabletomobile":`Of de mobiele-kant ingeschakeld moet worden`,
"lable.account.CYAgo":`2 CY geleden`,
"lable.Select.the.returned.high.seas.pool":`Selecteer teruggekeerde pool`,
"tuesday":`Dinsdag`,
"label.partnerCloud.basicSetting.partnerPayment":`Activeer partnerfonds`,
"label.validate.function.funcExplain.WEEKDAY":`Geef een specifieke dag van de week. 1 staat voor zondag en 7 voor zaterdag`,
"label.query.detail.manageexuser":`Externe gebruikers beheren`,
"vue_label_systemSettings_environment":`Milieu`,
"component_setup_tabs_label_delete":`Delete`,
"label.weixin.delete.ccchat":`Weet je zeker dat je dit bericht wilt verwijderen?`,
"label.lanxin.title":`Lanxin-H5Micro App`,
"label.layout.editcondition.morethanten":`U kunt tot 10 velden als zoekcriteria opgeven.`,
"label.project.hit.fourteen":`Mijlpaal Bijwerking`,
"label.createby":`Gemaakt door`,
"label.moreoperation":`Meer werken`,
"label.lock.tip":`Vergrendel de records zodat ze niet kunnen worden bewerkt`,
"label.check.input.condition.three":`Veldtype formule en rollup samenvatting worden niet ondersteund om in te voegen`,
"label.quote.dingjia":`Prijsstelling`,
"label.currentuseremail":`Het huidige e-mailadres van de gebruiker`,
"UG_homepage_004":`Automatisering`,
"chatter.link":`Link`,
"label.new.zealand.standard.time":`Nieuw-Zeeland zomertijd`,
"APPIntegration.Dropbox.setting.02":`Uitgeschakeld`,
"label.version.searchandmerge":`Dupliceren en samenvoegen van cheques`,
"label.allmenus.showmsg.nomenu":`Ik heb het menu niet gevonden.`,
"front-template-V1-Enable-disable":`Activeren | Deactiveren`,
"label.marketing.setting4":`Succesvolle registratie keert terug naar de standaard URL`,
"UG.Forcast.07":`Sta voorspelling toe`,
"vue_label_systemSettings_correlation":`Verwante Lijst Weergavemodus`,
"label.cloudccsite.remark.length":`Hiermee kunnen gebruikers tot 255 tekens invoeren`,
"label.favorite":`Bladwijzer`,
"template.report.converted.leads":`Geconverteerde Leads`,
"label.campaignmember.main.description":`Gebruik deze pagina om campagnemembers te beheren. U kunt nieuwe campagnemembers toevoegen of de status van huidige campagnemembers bijwerken.`,
"label.salescloud.teamrole.account.organization":`Teamleden kunnen een hoger toegangsniveau tot deze account hebben dan de standaard toegangsinstellingen van uw organisatie.`,
"label.permission.modifyAppPermission.canselectapp":`Beschikbare apps`,
"front-epwechat-module-v1-self":`Zelfgemaakte App Setup`,
"message.duplication.label.matchexactletters":`Exact`,
"label.appointmentdetail.wizard.title18":`Vrijdag Plan`,
"label.area":`Gebieden`,
"label.sso.saml.sp.username":`Gebruikersnaam`,
"lable.outlook.new":`Nieuwe Exchange Sync Configuratie`,
"label.custom.field.close.conversion":`Gesloten - Bekeerd`,
"lable.outlook.detail.tmaping":`Kaart Taakvelden`,
"label.emailobject.emaildetail.nextactivity.event":`Een gebeurtenis toevoegen`,
"vue_label_commonobjects_detail_date":`Einddatum kan niet korter zijn dan begindatum`,
"vue_label_email_mark?as":`Markeer als`,
"label.guestgroup":`Account Teams`,
"label_emailtocloudcc_filed_server":`Server`,
"label.icon.186":`Advies`,
"label.department.user.edit":`Bewerken`,
"label.custom.page.component.button.settings":`Component Knop Instellingen`,
"label.partnerCloud.orderingPlatform.nextProduct":`Wilt u de huidige productconfiguratie opslaan en het volgende product configureren?`,
"vue_label_appstore_cloud_platform":`officieel cloud-platform`,
"label.page.previous":`Vorige`,
"label.direct.dashboard.week.report":`Nieuwe wekelijkse werkbrief`,
"label.ServiceCloud.prompt.warning":`Geen statistieken over de verdeling van de middelen per adres.`,
"label.emailtocloudcc.position":`Positie`,
"vue_label_email_please_enter_the_message_content":`Voer de inhoud van de e-mail in`,
"labal_About_to_jump":`Het is snel omleiden.`,
"label_profile_mobile_setup_stand":`Standaard Homepage`,
"label.visualpage.component.n3":`3.Parameters. Parameter wordt geschreven in de args propertites ,args="naam:'zhang', leeftijd:26" Let op enkele dubbele aanhalingstekens.`,
"vue_label_report_operationmode":`Werkingsmodus van rapport`,
"label.reportsSubscription.select.attached.file":`Selecteer het type van bijgevoegd bestand.`,
"label.afghanistan.time":`Afghanistan Tijd`,
"label.vlidaterule.formulatrue":`Als deze formule-uitdrukking waar is, wordt de tekst weergegeven die is gedefinieerd in het gebied Foutbericht`,
"label.ccchat.person.invite.erroremail":`Het formaat van het e-mailadres is onjuist.`,
"label.viewDashboard":`Ga naar Dashboard Lijst`,
"label.at":`op`,
"label.notification.arketsea.beforeretrieve":`Je {0}：{1} wordt gerecycleerd naar {2}， resterende tijd: {6} dagen`,
"label.field.update.show.editor":`Toon formule-editor`,
"label.weixin.polls.time":`Stem Datum`,
"vue_label_commonobjects_detail_activity_nostarttime":`Geen begintijd`,
"label.direct.dashboard.me.not.approval70":`In afwachting van goedkeuring door mij ingediende punten`,
"label.data.setok.t_desc3":`Bediening.`,
"label.view.edit.search.describe":`Zoeken na invoeren trefwoorden`,
"label.importsourcefiletip":`Voordat u uw vertaalde bestand importeert, moet u op het volgende letten: <span><ul><li>1.Maak een apart bestand voor elke taal die u wilt importeren, dat alleen de naam en de vertaling bevat.</li><li>2.Het taalkenmerk bovenaan elk bestand is vereist. (Chinese import wordt niet ondersteund). Het taalkenmerk ziet er als volgt uit:</li><li>3.Zorg ervoor dat uw importbestanden in UTF-8-codering zijn opgeslagen voordat u ze importeert.</li>4.Zorg ervoor dat u de regelfeed invoert aan het einde van het bestand dat u wilt importeren.</li></ul></span>`,
"UG.Case.01":`Zaak`,
"label.weixin.report.filters":`Filters`,
"vue_label_homepage_profilehomepageassignment":`Profiel Home Page Opdracht`,
"label_tabpage_editview":`Weergave bewerken`,
"label.tabpage.allpotentialcustomers":`Alle aanwijzingen`,
"label.sendemail.send.standbyemail":`(reserve uitbox)`,
"errormessage.email.atleastonereceiver.z":`U moet een ontvangstadres selecteren of bewerken.`,
"workflow.action.tasks.assignortype.ownertype":`Eigenaar Type`,
"label.list.userinterface.new.page.setup":`Nieuwe pagina`,
"chatter.seladress":`Kies ten minste één ontvanger.`,
"Pagelayout_Setup_004":`Er kunnen maximaal 4 velden worden ingesteld`,
"label.mobile.home.page.tenbig.opp":`Top 10 Kansen in de komende 30 dagen`,
"label.wtd.changefields.newpc":`PC-pagina genereren`,
"label.opportunity.perm.remark":`Dit zijn privé kansen, neem contact op met de eigenaar om toegang te krijgen.`,
"label.data.exp.tempdes":`Sjabloon Beschrijving`,
"label.appointment.wizard.subtitle2-1":`Van`,
"lable.currencyManage.button.manageexchangeRate":`Beheer gedateerde wisselkoersen`,
"label.file.viewinfo":`Bestandsdetails bekijken`,
"label.integrations.mailchimp.export.failed":`Gegevensexport mislukt, controleer uw netwerkverbinding en probeer het opnieuw`,
"pagecreator_page_button_edit":`Bewerken`,
"label.icon.86":`Aktentas`,
"label.exchange.sync.reset":`Reset Sync`,
"label.customfields.lookupfilter":`U kunt een filter maken om de records te beperken die beschikbaar zijn voor de gebruiker in het veld Opzoeken.`,
"label.component.hotdeal.nopermission":`Neem contact op met uw CloudCC-administratie om uw aan zakelijke kansen gerelateerde gegevens te bekijken.`,
"label.address.province":`Staat`,
"lable.PowerProcess.3digit.input":`Niet meer dan drie cijfers.`,
"label.asset":`Activa`,
"label.passwordPolicy.setup.nopwdremember":`Geen wachtwoord onthouden`,
"front-electronic-signature-setting-intro2":`Voordat u een contract initieert, moet u de sjabloon vooraf instellen op het DocuSignplatform. Wanneer u de ondertekening start, kunt u de vooraf ingestelde contractsjabloon selecteren.`,
"pagecreator.page.button.new":`Nieuwe pagina`,
"label.tabpage.step2":`Stap 2 specificeer de filtervoorwaarden`,
"label_switch_two_column_or_responsive_layout":`Schakel over naar twee-koloms of responsieve opmaak`,
"label.batchDelete":`Massa verwijderen`,
"chatter.edit.ct":`Wijzig uw contactgegevens.`,
"UG_ST_003":`U heeft geen toestemming om {0} aan te maken, neem contact op met de beheerder, klik op bevestigen om direct naar de {0} interface te gaan.`,
"label.timzone.tip.info2":`Wanneer je simpledateformat gebruikt om datums op te maken, moet je tijdzones instellen voor simpledateformat instanties, zoals SimpleDateFormat myDateFormat=new SimpleDateFormat("jjjjj-MM-dd");myDateFormat.setTimeZone(TimeUtil.getUserTimeZone(userInfo));of haal een instantie op met de gereedschapsmethode van TimeUtil, SimpleDateFormat myDateFormat=TimeUtil.getSimpleDateFormat("jjjjj-MM-dd",userInfo);`,
"label.ems.firstsynchistory":`Hoe lang geleden heb ik voor het eerst de mails gesynchroniseerd`,
"label.currency.invalid":`Inactieve valuta's`,
"label.mask.custom":`Aanpassen`,
"lable.opppdt.addpdt.title":`Kies product`,
"label.appointment.wizard.subtitle3-3":`Woensdag`,
"label.weixin.report.criteria":`Gegroepeerd per`,
"label.appupload.upload.install.uninstall":`Kan niet installeren`,
"label.compact.layout.frame.split":`Weergave op gescheiden scherm`,
"label.email.attach.complete.info":`Nadat de upload is voltooid, wordt het bestand weergegeven in de onderstaande lijst met bijlagen`,
"label.Receivables":`Vorderingen`,
"label.linkedin.title.setting":`Geïntegreerde informatie van LinkedIn`,
"label.companynotice":`Aankondiging bedrijf`,
"label.emailobject.discard":`Weggooien`,
"label.selected.searchfield":`Geselecteerde zoekresultaten veld`,
"front-electronic-signature-explainDocusign":`DocuSign Ehandtekening Beschrijving:`,
"chatter.link.name":`Link Naam`,
"label.low":`Laag`,
"label.verticalline":`Verticale kolommen`,
"label.approval.isallowed.reject.label":`Afwijzing toestaan bij het goedkeuren van afzonderlijke gegevens?`,
"label.emailtocloudcc.button.enable":`Actief`,
"label.dashboardSetup.showdw.d5":`Gehele Eenheid`,
"label.usermanage.not.authority":`U hebt niet voldoende rechten om dit te doen.`,
"label.customobjects.track.introduce0":`Op deze pagina kunt u kiezen welke velden moeten worden bijgehouden in de {0} "Veld bijhouden"-gerelateerde lijst. Telkens wanneer een gebruiker een van de hieronder geselecteerde velden wijzigt, worden de oude veldwaarde en de nieuwe veldwaarde, evenals de datum, het tijdstip, de kenmerken van de wijziging en de gebruiker die de wijziging aanbracht, toegevoegd aan de "Veld bijhouden"-gerelateerde lijst.`,
"canlendarmonth":`Kalendermaand`,
"vue_label_dashboard_minimum":`Geef het minimum`,
"label.salescloud.optionlist.inputname.linealone":`Voer hieronder een of meer keuzelijstwaarden in, met elke waarde gescheiden door een nieuwe regel.`,
"message.error.organuzation.information.null":`Organisatie-informatie bestaat niet.`,
"label.tabpage.maxfilez":`De maximale bestandsgrootte is`,
"message.validation.apiname":`Het moet beginnen met een letter. Het mag alleen letters, cijfers en underscore bevatten. Het mag alleen hoofdletters en kleine letters, cijfers en underscore bevatten. En de maximale lengte is 50 tekens, minimale lengte is 2 tekens.`,
"report.type.label.contractPayment":`Contracten en vorderingen`,
"label.limiting.choose.three.files":`U kunt 3 bestanden selecteren, nu geselecteerd.`,
"label.reportTypeFocus":`Rapport Gegevensbron Focus`,
"Report_Delete_Confirm_Title":`Gelieve te bevestigen`,
"front-gantt-module-reorder-milestones":`Mijlpalen herordenen`,
"front-starter-v1-customer-tips-success":`Activeer Account Pool met succes`,
"label.tabpage.isdeleteview":`Weet je zeker dat je dit uitzicht wilt verwijderen?`,
"label.favorite.title":`CloudCC-platform`,
"page.layout.sysinfo":`Systeem Informatie`,
"label.tabpage.pleaseSelectz":`Gelieve te kiezen`,
"label.smsnotice":`SMS-berichten`,
"label.forecast.customforecast.foretype.Pipeline":`Pijpleiding`,
"label.rejectbehaviour":`Verwerp Gedrag`,
"label.searchlayout.view.example.new":`Voorbeeld bekijken (nieuw venster)`,
"vue_label_homepage_notice2":`U kunt de lay-out van de homepage handmatig toewijzen, zodat werknemers hun dagelijkse taken gemakkelijker en effectiever kunnen uitvoeren`,
"label.import.index.chooseidorother":`3、U kunt kiezen om ID of naam te gebruiken om de record te matchen en het lookup veld in te vullen. Als u de bijbehorende record ID en andere informatie wilt verkrijgen, kunt u een rapport maken en de record naam en record ID als groepskolommen instellen, en vervolgens het rapport exporteren.`,
"label.westem.european.summer.time":`West-Europese tijd`,
"label.brackets":`Tussen haakjes`,
"asset.serialnumber.unique":`Het asset serienummer bestaat reeds, gelieve het niet herhaaldelijk toe te voegen.`,
"label.callcenter.access.keyID":`Toegangsgeheim SleutelID`,
"label.calendar.month.view":`Maandweergave`,
"label.realdelete":`Permanent verwijderen`,
"label.partnerCloud.orderingPlatform.amountPaid:":`Te betalen:`,
"label.reportTypName":`rapport gegevensbron Naam`,
"lable.newtabpage.opensearchresult":`Zoekresultaten uitbreiden`,
"front-kefu-moudle-v1-Session-duration":`Duur van de sessie:`,
"label.import.index.ignore":`Negeer`,
"label.customfields.url.tip":`Wanneer gebruikers op het veld klikken, zal de URL worden geopend in een nieuw venster of in het huidige venster, afhankelijk van de instellingen van de gebruiker, en de standaardinstelling is om de URL te openen in een nieuw venster.`,
"label.projectManagement.editMilestone":`Mijlpaal bewerken`,
"front-gantt-module-v1-project-gantt-list":`Projectlijst`,
"label.validate.remark":`Validatieregels helpen de kwaliteit van gegevens te verbeteren door te voorkomen dat gebruikers onjuiste gegevens opslaan. U kunt één of meer validatieregels definiëren die bestaan uit een foutconditie en een overeenkomstige foutmelding. Validatieregels worden uitgevoerd bij het opslaan van een record. Als aan een foutconditie wordt voldaan, wordt het opslaan afgebroken en wordt een foutbericht weergegeven.`,
"front-kefu-moudle-v1-sjgsbzq-reinput":`Het formaat van het telefoonnummer is onjuist. Gelieve opnieuw in te voeren`,
"label.channel.name":`Naam kanaal`,
"label.weixin.cloudcc.user.message":`CloudCC Gebruikers Informatie`,
"label.icon.59":`Workshop`,
"label.ccpeak.function":`Methode`,
"lable.opppdt.selPdt.leastten.fields":`Selecteer maximaal 5 velden`,
"label.deadline":`Deadline`,
"label.product.sel":`Prijs Boek Selectie`,
"vue_label_helpcenter_detail2":`Alle gebeurtenissen: Toon alle gebeurtenissen waartoe u toegang hebt, zelfs als u niet deelneemt.<br>   U kunt de activiteitenrecords die u wilt bekijken ook filteren op basis van het datumbereik en het activiteitentype.<br>    4. Dynamisch<br>   Alle personen die dit record kunnen bekijken kunnen een bericht en post achterlaten onder de "Dynamisch" kolom van het record, en u kunt ook alle informatie wijzigingen, laatste activiteiten, en andere mensen hun opmerkingen en posts over dit record bekijken. Deze kolom vergemakkelijkt online werkcommunicatie en samenwerking tussen u en uw collega's, en helpt zo teamwerk en efficiëntie te verbeteren.<br> Posten<br>   Stap 1: Klik op de posting balk en voer de posting inhoud in<br>   Stap 2: Klik op de Bestand/Link knop om een bestand/link toe te voegen als nodig<br>   nbsp;Stap 3: Klik op "Delen" om het posten af te ronden. <br> Bekijk bericht<br>    Nadat het bericht succesvol is gepubliceerd, kunt u hieronder de micro-post zien die u zojuist heeft gepubliceerd. De micro-post bestaat uit de volgende onderdelen: avatar, naam van de persoon, inhoud van de micro-post en interactie methoden (like/commentaar/bewerk/verwijder post). <br> Berichten sorteren en vinden<br>    Klik op de vervolgkeuzelijst rechts van "Sorteren" om de sortering van berichten te wijzigen. <br>     "Laatste activiteit" sorteren: sorteren op de laatste interactietijd van de micro-posts;<br>     "Laatste bericht "ordenen: Rangschikken op de publicatietijd van de micro-posts;<br>   Verschillende soorten micro-posts bekijken<br>   Micro-posts met platte tekst: Blader door de gehele inhoud direct in het micro-post publicatiegebied;<br>   ;  Micro-posts die bestanden bevatten: klik op de downloadknop van het bestand om het bestand lokaal te downloaden om te bekijken;<br>   Micro-posts die links bevatten: klik op de link in de micro-post om deze te openen;<br> Micro-posts becommentariëren en liken<br>   Commentaar geven<br>   Stap 1: Klik op "Commentaar" onder elke micro-post<br>    Stap 2: Geef het commentaar in het tekstvak dat opent<br>   Stap 3: Voeg het bestand/link naar behoefte toe aan het commentaar Stap 4: Klik op "Commentaar" onder het tekstvak om de bewerking te voltooien<br>   Commentaar verwijderen<br>    De uitgever van het commentaar kan de inhoud van het commentaar verwijderen. Klik op de knop rechts van de opmerking en selecteer "Verwijderen" in de vervolgkeuzelijst.`,
"pagecreator_layout_button_mergecell":`Cellen samenvoegen`,
"Lead_Scoring_Setting_Rule_Setup_Active":`Actief`,
"label.query.detail.loginbypartneruser":`Inloggen door partner gebruiker`,
"label.view.selectrenderfields":`Velden selecteren om weer te geven`,
"label.code.add":`QR code link informatie toevoegen`,
"label.appointmentconfirmpage.wizard.title1":`GEPLANDE VERGADERING`,
"label.timzone.tip.title":`Bij het werken met datums met new date() of calendar moet rekening worden gehouden met de meervoudige tijdzoneproblematiek. Daarnaast biedt de timeutil tool class een aantal tools die meervoudige tijdzones ondersteunen.`,
"label.tag.addtags.visibility":`Zichtbaarheid`,
"label.appointmentconfirmpage.wizard.title3":`Weet u zeker dat u de bestaande afspraak wilt annuleren en een nieuwe afspraak wilt maken?`,
"lable.outlook.detail.oldest":`Oudste`,
"label.account.custom.quarter.timeerror":`De begindatum van het aangepaste kwartaal of de einddatum van het aangepaste kwartaal ligt tussen de aangepaste kwartalen in de geschiedenis, controleer dit en stel opnieuw in`,
"label.sendsms.idea":`Gerespecteerd`,
"label.manageAll.pagenum2":`Dit is de laatste pagina.`,
"serviceterritory.isactive.notactive":`Dit servicegebied is niet ingeschakeld.`,
"label.userinfo.newpwd.notnull":`Voer uw nieuwe wachtwoord in.`,
"vue_label_dashboard_nolinkagedashboard":`Geen linkage dashboard`,
"message.cannotdeleteapproval":`U kunt dit goedkeuringsproces niet verwijderen.`,
"label.wtd.detail.m":`Mobiel`,
"label.app.step4.introduce":`Kies de tabbladen die u in deze aangepaste app wilt opnemen.`,
"label.ccchat.error.permission":`Geen toegang`,
"UG_opportunity_009":`Of`,
"label.Receivables.TheActualAmountOfMoney":`Werkelijke ontvangsten`,
"label.callcenter.no.search":`Geen relevante vraag naar de informatie`,
"label.user.introduce":`Gebruikers`,
"message.datalocked.addpdt":`Dit Opportunity-record is vergrendeld, u kunt geen Premium toevoegen.`,
"label.sendsms.step1":`Stap 1: Specificeer ontvangers`,
"label.brief.contracts":`Contracten`,
"label.setup.mini.swap":`Carrousel Instelling`,
"label.emailobject.wizard.desc1":`Sluit uw e-mail aan, verstuur hier e-mail en synchroniseer automatisch met het record`,
"label.login.verification.mfa.desc2":`Als u om een of andere reden niet kunt verifiëren, zoals verloren of abusievelijk verwijderde MFA-apps op uw telefoon, kan het zijn dat de beheerder de MFA heeft ontkoppeld.`,
"label.notification.receiveSms.message":`U heeft een SMS bericht ontvangen van {!vanadres}, klik om meer details te zien`,
"label.emailmerge.mergeFolder.publicfolder":`Niet-ingevulde publieke e-mail samenvoegsjablonen`,
"label.password.update.false":`Het is niet gelukt om het wachtwoord te veranderen, neem contact op met de beheerder!`,
"label_tabpage_systemz":`Systeem(en)`,
"label.dataimport.objectid.null":`De object-ID is leeg en kan niet worden geïmporteerd`,
"label.currency.type":`Valuta`,
"component_setup_button_appurl":`Systeem url`,
"label.appointmentconfirmail.wizard.title2":`Je hebt een geplande {0}`,
"lable.product.please.enter":`Voer in`,
"label.escalation.setup.title":`Escalatie regels`,
"label.create_failure":`Mislukt om formulier aan te maken`,
"label.weixin.brand.model":`Merk model`,
"label.layout.nameoftestobj2":`Naam testobject twee`,
"vue_label_filters_number":`Voor elk rapport worden 10 indieners ondersteund.`,
"label.file.following":`Naar aanleiding van`,
"vue_label_account_all_contracts":`Overdracht van alle contracten van klanteneigenaars`,
"label.service.please.select.cycle.type":`Selecteer type fiets`,
"label.weixin.weipoll.optionname":`Micro-stemkeuze Naam`,
"label.data.newtemplate.null":`Geen`,
"message.passwordPolicy.validate.complexReq1":`Fout: Uw paswoord moet een combinatie van letters en cijfers zijn`,
"label.forecast.shre.editmanager":`Manager Bewerken`,
"label.emailtemplate.tip":`Hieronder ziet u een lijst van al uw email sjablonen in de geselecteerde map. Klik op de knop nieuw om een nieuw tekst of HTML e-mail sjabloon aan te maken. U kunt deze e-mailtemplates gebruiken voor het verzenden van afzonderlijke e-mails.`,
"label.tag.manage.button":`Tags beheren`,
"label.changepw":`Wijzig Wachtwoord`,
"label.sso.saml.sp.idsource.nameid":`Identiteit staat in het NameIdentifier element van de Subject verklaring`,
"label.salescloud.teamrole.addmember":`Opportunitygroepsleden toevoegen CloudCC`,
"label.h5.similar.opportunity.last.months6":`Recente 3-6 maanden`,
"message.save.opportunity.role.save.failed":`Kan de rol van contactpersoon niet opslaan`,
"vue_label_report_formulainformation":`Formule-informatie`,
"label.area.assignuser.remark":`Gebruikers toewijzen aan territorium`,
"label.multilang.viewlist.total":`{0} Geselecteerd`,
"label.newprocessstep4":`Stap 4 Selecteer Email Notificatie Templates`,
"label.permission.objectpermission.open":`Open`,
"label.service.gantt.close.list":`Lijst sluiten`,
"label.standarduserfield":`Standaard gebruikersvelden`,
"vue_label_commonobjects_detail_the_administrator":`Het record is vergrendeld, neem contact op met de beheerder.`,
"label.exchange.sync.account":`Accountgegevens Exchange Service`,
"label.mr.title.button.back":`terug, en reset de zoekcriteria`,
"label.notsetup.operation":`Fout in de regel, er is geen operator ingesteld.`,
"label.notifications_center":`Kennisgevingen Centrum`,
"label.event.moveup.5hour":`5 uur vooruit`,
"report_label_pleaseinput":`Voer in waarnaar u wilt zoeken`,
"label.batchadd.newbatchpage.errorlist":`Gegevens toevoegen mislukt`,
"label.quickbooks.invoices":`Facturen`,
"chatter.feed.usingchatter":`Zet CCChat aan, uw gebruikers kunnen een paar mensen of records volgen en berichten plaatsen.`,
"label.all.marketing.activities":`Eigenaar van de marktcampagne`,
"label.lookup.finish":`Automatisch aanvullen van opzoekingen`,
"label.weixin.unbind":`Ontbinden`,
"front-console-closeTime":`Sluit de tijd.`,
"label.service.rest.time":`Resterende Tijd`,
"label.mr.descreption.condition1":`Voer het bereik en de regels voor het vinden van duplicaatrecords in. Klik op [Duplicaten zoeken] om gekwalificeerde duplicaatrecords te krijgen.`,
"label.group.new":`Nieuwe Groep`,
"vue_label_SMS_sending_please_wait":`Versturen, gelieve te wachten`,
"label.Standardobj.tab":`Standaard Object Tabbladen`,
"label_chatter_pastEvents":`Vroegere activiteiten`,
"label.chatter.priority":`Prioriteit`,
"select.nullvalue":`-Nee-`,
"setup_layout_group_pagecomponent":`Pagina Onderdelen`,
"label.dataimport.dataerror.check":`Fout in de gegevens, controleer de gegevens.`,
"label.permission.detail.app.pagesetting.tip":`Aangepaste pagina's toestemmingsinstellingen opheffen`,
"label.knowledge.language.polish":`Pools`,
"label.project.hit.two":`Subtaak Verval Herinnering`,
"label.customerapp":`Aangepaste app`,
"label.reportsSubscriptionPage.condition.value":`Waarde`,
"label.tabpage.no2z":`No2`,
"lable.system.administrator":`Sorry, u hebt geen toegang om te werken. Neem contact op met de beheerder.`,
"homepage.layout.buttion":`Pagina Lay-out Opdracht`,
"label.notification.event.overlapEvent":`De gedelegeerde gebruiker is al toegewezen aan een {subject} event van {begintijd}-{eindtijd}, wil je dit event toch aanmaken`,
"label.customfields":`Aangepaste velden`,
"label.data.downpage.e.title":`Stappen voor gegevensuitvoer`,
"label.notification.serviceappointment.remove":`Uw verzonden werkorder {0} is geannuleerd, gelieve uw werk redelijkerwijs te regelen.`,
"label.campagin.roi.zhuangtai":`Campagne Status`,
"label.applt.updown":`Download Miniprogramma QR Code`,
"label.customfields.new.step1.tip":`Specificeer het type informatie dat het aangepaste veld zal bevatten.`,
"label.staticresource.upload.limit":`Alleen bestanden in deze formaten kunnen worden geüpload: png, jpg, gif, js, css, zip.`,
"chatter.edit.user.p":`Gebruikersfoto wijzigen`,
"label.icon.32":`Computer`,
"vue_label_homepage_notice_cantset":`De homepage van het profiel is niet geconfigureerd voor dit profiel, de standaardhomepage van het profiel kan niet worden gewijzigd`,
"front-epwechat-module-v1-agree-unbound":`Akkoord te gaan met de bovenstaande vrijblijvende informatie en deze te aanvaarden`,
"label.version.chatter.cooperation":`CCChat`,
"label.customer.tab.step1.selectstyle":`Kies een tabblad stijl.`,
"label.select.an.asset":`Selecteer een goed.`,
"label.search.sizer.field":`Zoekfilter velden`,
"label.emailmerge.mergeFolder.lastone":`Kies tenminste een sjabloon.`,
"label_tabpage_step2":`Stap 2 specificeer de filtervoorwaarden`,
"label.version.lead.automatic.allocation":`Regels voor loodstoewijzing`,
"label.projectManagement.update.succeeded":`Update Succesvol`,
"label_tabpage_bar":`Bar`,
"label.appupload.component.type.tab":`Tab`,
"label.pigeonhole.sel.f":`Kies de te archiveren mappen`,
"homepage.components.status":`Component Status`,
"label.currency.edit.new":`Valuta bewerken: Nieuwe valuta`,
"label.input.new.password":`Voer het juiste nieuwe wachtwoord in`,
"chatter.group.membersName":`MMeMber Naam`,
"label.myinfo.modify":`Persoonlijke informatie bewerken`,
"label_tabpage_next":`Volgende stap`,
"vue_label_homepage_card_closedopportunities":`Gesloten kansen`,
"label.permission.edit":`Bewerk Eigenschappen`,
"message.error.searchfield.objid.null":`Het object-id vereist door het queryveld kan niet leeg zijn`,
"label.partnerCloud.productSet":`Product Setup`,
"label.emailtocloudcc.filed.emailto":`E-mail naar`,
"label.service.miniProgram.uploadingImage":`Upload alstublieft een carrousel foto.`,
"label.sso.saml.idp.description1":`Aangesloten apps`,
"label.event.moveup.10minutes":`10 minuten vooruit.`,
"label.quote.createby":`Voorbereider`,
"label.workflow.baseontimeoparate":`Tijdsafhankelijke workflowacties`,
"label.searchall.r":`Zoek opnieuw`,
"vue_label_homepage_differentprofiles":`Wijs verschillende homepages toe aan verschillende profielen`,
"label.campaign.channel.step1":`Stap1: Informatie`,
"label.event.moveup.2hour":`2 uur vooruit`,
"font-evaluate-module-v1-cancle-reply":`Automatisch antwoord annuleren`,
"message.datalocked.delete":`U kunt dit record niet verwijderen omdat het vergrendeld was. Als u het wilt verwijderen, neem dan contact op met de beheerder.`,
"label.sso.listOfKey":`Sleutel Lijst`,
"label_chatter_newtask":`Nieuwe taak`,
"label_emailsync_form_seversetting":`Setup`,
"label.partner.new.function":`Beschrijving`,
"vue_label_notice_homepage_pleaceentername":`Voer de naam van de homepage in`,
"message.please.choose.opportunity":`Selecteer een zakelijke mogelijkheid`,
"label_file_use_most_user":`Gebruikers met de meeste gebruikte opslagruimte`,
"label.htyj.remark2":`zodat u geen contractbedragen kunt zien`,
"label.formula.message":`wanneer de formule als onwaar geëvalueerd wordt, de prompt voor de submit failure`,
"UG_Case_04":`Geval opdracht`,
"label.displaycolumn":`Kolommen tonen`,
"vue_label_campaign_selected_member_status":`Update naar geselecteerde ledenstatus`,
"label.workflow.operate":`Werkstroom acties`,
"label_chatter_mail":`Mail`,
"label.setup.mini.setting":`Achtergrondinstelling van miniprogramma's`,
"vue_label_chat_invitetojoin":`Je hebt "{invite}" uitgenodigd om deel te nemen aan de groepschat`,
"setup.object.field.dependency.label.linkedfieldvalue":`Afhankelijk veld`,
"vue_label_email_update_template":`Sjabloon bijwerken`,
"label.email.template.private.mail":`Exclusieve Email Sjabloon Map`,
"lable.Confirm .potential.customers":`Bevestig om lood {naam} te recycleren`,
"vue_label_leadpool":`Lead Pool`,
"label.ems.hostorpost.error":`Server of poort configuratie fout, controleer het.`,
"label.search.saveok":`Succesvol gered`,
"label.custom.field.cannot.maping":`Kan dit veld niet meerdere keren toewijzen`,
"label.projectManagement.dispatched":`Verzonden`,
"time":`Tijd`,
"label.choose_socialnetwork":`Kies een sociaal netwerk om te beginnen`,
"label.vlidaterule.checkedtrue":`Als de formule een selectievakje is, hoeven er geen dubbele aanhalingstekens te zijn`,
"label.appointmentconfirmail.wizard.btn1":`Herschikken`,
"front-kefu-moudle-v1-maxchars-input":`Er kunnen maximaal {0} tekens worden ingevoerd`,
"setup.mainpage.label.welcome10":`Instructies: Klik op het menu aan de linkerkant van de pagina → Application Settings → Create → Object → Object Name → Custom Layout.`,
"label.ems.company.setup.title":`Instellen van de e-mailbox van het bedrijf`,
"label.channel":`Kanalen`,
"label.textmessage.groupsms":`Groep SMS`,
"label.asset.deleted.successfully":`Verwijder asset BOM succesvol.`,
"label.knowledgebase.new.workspace":`Nieuwe Werkruimte`,
"label.ServiceCloud.diliweizhi":`Locatie`,
"label.private_me":`Privé voor eigenaar (ik)`,
"label.service.miniProgram.imageLink":`Carrousel Link`,
"label.area.assigned":`Toegewezen gebruikers`,
"label.weixin..xsld.name":`Naam van de gelegenheid`,
"label.campaign.matchway.select.name":`Naam`,
"label.installedsoft":`Geïnstalleerde pakketten`,
"label.projectManagement.spare.time":`Beschikbare tijd`,
"label.user.select.custom.text.sendemail":`Selecteer aangepaste tekstindeling om e-mail direct te verzenden`,
"label_chatter_chatter":`CCChat`,
"label.approveorrefuse":`Goedkeuren/afwijzen`,
"startdate.enddate.time.illegal":`De begindatum moet kleiner zijn dan of gelijk aan de einddatum.`,
"label.project.hit.eight":`Dagelijkse taakherinnering`,
"message.duplication.label.uncheck":`Noo-verificatie`,
"label.allocation.role":`Gebruikers toewijzen`,
"label.sendemail.lead.scoreinfo":`Beste #gebruikersnaam:Het systeem heeft alle leads gescoord van de door u geselecteerde views "#viewlabel" op basis van de lead scoring regels. Het duurt #timestr.Log in en open de view om de resultaten te bekijken.\Let op: Als u de score niet kunt zien van de leads die u heeft gescoord, bewerk dan de view en voeg "lead score" toe aan het veld om het score resultaat te zien. Bedankt en vriendelijke groeten!`,
"lable.oppt.jieduan.closejieduan":`Sluit deze kans`,
"label.ems.verify":`Verifieer`,
"message.error.startdate":`De begindatum moet vroeger zijn dan de einddatum`,
"label.campaignmember.main.deletelead":`Verwijder Leden-bestaande Leads`,
"label.partnerCloud.financeSetting.account":`Nadat het partnerfonds is geactiveerd, worden de objecten van het partnerfonds en het fondsoverzicht toegevoegd. Partnergebruikers kunnen de rekening in CloudCC gebruiken om voor bestellingen te betalen.`,
"message.datalocked":`zijn record is vergrendeld. Als u het wilt bewerken, neem dan contact op met uw beheerder.`,
"lable.opppdt.selPbk.pricebook":`Prijs Boeken`,
"label.knowledgebase.restore.article":`Artikel herstellen?`,
"label.object.batchadd":`Batch toevoegen {objName}`,
"label.what_happen":`Pagina nadat het formulier is ingediend`,
"label.roleandunderling":`Rollen en Ondergeschikten`,
"label.knowledge.language.russian":`Russisch`,
"front-electronic-signature-explain-first":`Alvorens de Ehandtekening te binden, is het aanbevolen dat u zich registreert en certificeert op het Fadada platform.`,
"component.sendmail.label.subject":`Thema`,
"month":`Maand`,
"label_chatter_save":`Save`,
"label.view.sortview.sectiontitle":`De weergave wordt in de gekozen volgorde weergegeven`,
"label.mobile.home.page.major.project":`Belangrijkste projecten`,
"label.weixin.input.filename":`Voer de bestandsnaam in`,
"label.pagelayout.remark":`Op deze pagina kunt u verschillende pagina-indelingen maken om`,
"label.service.miniProgram.store":`Merk verhaal`,
"label.recordtype.edit.selected":`Geselecteerde waarde`,
"message.selectgroupcondition":`Selecteer de voorwaarden voor groepering`,
"label.y.axis.cannot.empty":`Y-as kan niet nul zijn`,
"label.textmessage.vonage.connected.count":`Tellen als gecontacteerd`,
"setup.layout.label.readonly":`Alleen-lezen`,
"front-kefu-moudle-service-agent":`Klantenservice`,
"message.login.mfaverification.page.invalid":`De pagina is ongeldig. Vernieuwen a.u.b.`,
"label.central.standard.time":`Central Standard Time`,
"label.processnoticepic":`Attentie beeld van goedkeuringsproces`,
"vue_label_helpcenter_calendar1.2":`Regels voor de weergave van kalenderitems: kalenderitems worden weergegeven in het kalenderraster, en het rastergebied waar de kalenderitem zich bevindt vertegenwoordigt het tijdsbereik van het record. Agenda-items die meer dan 24 uur bestrijken worden bovenaan de tijdschaal weergegeven in de dag-, week- en beschikbaarheidsweergave. Als er meerdere agenda-items in een raster in de maandweergave staan, kunt u op " Meer" klikken om ze te bekijken. De linker- of rechterkant van het agendapunt is een halve cirkel, wat betekent dat er geen dergelijk record is in de vorige of volgende dag van het raster. De linker- of rechterkant van de kalendervermelding is afgerond in een rechte hoek, wat betekent dat er nog een dergelijke vermelding is op de vorige of volgende dag van het rooster. <br> Snel de datum vinden in de kalender weergave: U kunt het datumbereik dat wordt weergegeven in de kalenderweergave aan de linkerkant lokaliseren door de tijd te selecteren op de kleine kalender aan de rechterkant van de kalenderpagina. U kunt ook op de pictogrammen "<" en ">" rechtsboven op de kalenderpagina klikken om snel van datum te wisselen. Als de tijd van de kalenderweergave niet de huidige tijd is, kunt u klikken op het "Vandaag" icoontje rechtsboven op de kalenderpagina om snel terug te schakelen naar vandaag. <br> Lijstweergave<br> Wissel van kalenderweergave naar lijstweergave: Klik op het "kalender" icoon rechtsboven in de kalenderweergave en selecteer "tabel" om over te schakelen naar de lijstweergave van gebeurtenissen. <br> Gebruik van de lijstweergave: Om specifieke gebeurtenissen of meerdere gebeurtenissen tegelijk te bekijken, opent u de tabelweergave. Er zijn vooraf ingestelde lijstweergaven in de lijstweergave. Klik op het "drop-down knop" icoon in de linkerbovenhoek van de lijstweergave om alle lijstweergaven weer te geven waartoe u toegang heeft. U kunt de lijstweergave van de gebeurtenis ook aanpassen aan uw behoeften. <br> 2. Mijn kalender en andere kalenders<br> Mijn kalender<br> Mijn kalender bevat mijn gebeurtenissen kalender en object kalender. <br> Mijn evenementenkalender: Toon alle gebeurtenisrecords waarbij de toegewezen persoon de jouwe is in de kalenderweergave. Mijn evenementenkalender kan niet worden verwijderd, bewerkt of van kleur veranderen. U kunt "Mijn evenementenkalender" delen met uw collega's.`,
"label.approval.end":`Einde`,
"vue_label_report_notice_cannotdelete":`Er zijn rapporten in deze map die niet kunnen worden verwijderd`,
"label.sso.saml.idp.loginurl":`idP Login URL`,
"label.emailtocloudcc.filed.port":`Haven`,
"label.directdashboard.righttitle":`Dashboards voor verkoopanalyse`,
"label.knowledge.case.suggest.article":`Voorgestelde artikelen in zaken`,
"label.version.maxcount":`en de grens overschrijden.`,
"label.weixin..xsld.yjqyrq":`Sluitingsdatum`,
"front-project-module-v1-unmarket-is-template":`Sjabloon verwijderen`,
"label.mobile.quickcreate.default.map":`Kaart`,
"chatter.click.p":`Klik om te bekijken`,
"label.chat.topic.all.topic":`Alle onderwerpen`,
"label.channel.head":`Channel Supervisor`,
"lable.edit.queue.emaildes":`Voer de naam van de wachtrij in en het e-mailadres dat moet worden gebruikt voor het verzenden van meldingen (bijvoorbeeld wanneer een zaak in de wachtrij is geplaatst). Het e-mailadres kan voor een persoon of een distributielijst zijn. Wanneer een object aan een wachtrij wordt toegewezen, zullen alleen de leden van de wachtrij hiervan op de hoogte worden gebracht.`,
"label.tag.filter":`Tag Filter`,
"label_chatter_filterTimeLine":`Tijdlijn filteren`,
"label.dashboard.show.value":`Toon waarden`,
"vue_label_normal_solution_sf":`Oplossing`,
"label.customfields.location.tip":`Stelt de gebruiker in staat de locatie te definiëren. bevat lengte- en dimensiecomponenten die kunnen worden gebruikt om afstanden te berekenen.`,
"label.weixin.copyright":`Copyright© 2008-2022 CloudCC.com,inc. Alle rechten voorbehouden door CloudCC.com`,
"label.icon.33":`Computer`,
"label.mr.title.opportunityName":`Naam van de gelegenheid`,
"template.report.sales.month":`Verkoop van deze maand`,
"chatter.group.lookingForPeople":`Begin met het typen van een naam`,
"label_tabpage_userz":`Gebruikers`,
"label.reportsSubscriptionPage.email.formatselection":`Selecteer het rapportformaat dat u via e-mail wilt ontvangen`,
"lable.product.plist":`Lijst Prijs`,
"label.multilang.activity.monthline":`Week 0.`,
"label.ccchat.whose.name.contains2":`Leden van een campagnegroep`,
"label.mobile.phone.day.report":`Dagelijkse werkaantekeningen`,
"label.processsetting.set.files":`Velden instellen`,
"label.systemlog.s":`Succes`,
"label.tabpage.uploadsz":`Upload`,
"serviceterritory.member.time.conflict":`Binnen deze tijdspanne zijn dienstmiddelen lid geworden van een ander dienstgebied.`,
"label_chatter_startDate":`Start gegevens`,
"label.search.at.least.two":`Zoektermen mogen niet minder dan 2 tekens bevatten.`,
"label.approval.ressign.project":`Items om toe te wijzen`,
"lable.custom.Previous.CY":`Vorige CY`,
"label_chatter_link":`Link`,
"label.weixin.group.name":`Naam`,
"label.partnerCloud.basicSetting.domainName":`De operatie is onomkeerbaar en de domeinnaam kan na initialisatie niet meer worden gewijzigd. Weet u zeker dat u de bewerking wilt bevestigen?`,
"lable.SalesCommitmentKanBan.targetContract":`Streefbedrag contract`,
"label.currency.new":`Nieuwe bedrijfsvaluta`,
"message.passwordPolicy.validate.complexReq3":`Fout: Uw wachtwoord moet bestaan uit een combinatie van cijfers, hoofdletters, kleine letters en speciale tekens.`,
"label.icon.127":`Artsen`,
"label.customfields.fieldname.tip":`De veldnaam is een interne referentie en wordt gebruikt voor integratiedoeleinden zoals de API.`,
"chatter.feed.menutype.feed":`Samenvatting`,
"label.home.standard.dashboard.role":`U beschikt niet over rolinformatie, dus u kunt het dashboard voor verkoopverbintenissen niet bekijken.`,
"label.customfields.fielddependency.button":`Klik op de knop om geselecteerde waarden in de afhankelijke keuzelijst op te nemen of uit te sluiten`,
"label.recentprojects":`Recente items`,
"label.appupload.logo.introduce":`Het verpakkingslogo moet kleiner zijn dan 20KB. Afbeeldingen mogen maximaal 60 pixels breed en 60 pixels hoog zijn voor het beste resultaat. Grotere afbeeldingen worden verkleind en kunnen vervormd overkomen.`,
"label.integrations.northamericanleads":`Noord-Amerikaanse Leads`,
"label.sms.balance":`Saldo (yuan)`,
"label.ccchat.message.num":`Nieuws`,
"label.embed_website":`Om dit formulier in te sluiten, kopieert en plakt u gewoon de onderstaande code in de HTMLcode van uw website.`,
"label.trigger.check.error":`Trigger syntax controle mislukt.`,
"label.bmap.baidu.maps":`Baidu Maps`,
"label.nextapproverauto":`Volgende geautomatiseerde goedkeurder Bepaald door`,
"label.customfields.date.tip":`Stelt gebruikers in staat een datum in te voeren of een datum te kiezen uit een popup kalender.`,
"button.partner.back":`Terug`,
"label.layout.editcondition.tip":`Selecteer de velden die u als zoekcriteria wilt gebruiken. U kunt maximaal 10 velden selecteren.`,
"label.stacked.area":`Gestapeld gebied`,
"font-evaluate-module-v1-case-closed":`Alleen als de zaak gesloten is`,
"label_emailsync_status_log":`Verbindingslogboek`,
"label.version.area.and.sales":`Territoriumbeheer en verkoopteam`,
"label.service.booking.sessions":`Tijd voor serviceafspraak`,
"label.untransfile":`Onvertaald`,
"label.textmessage.sentfail":`Mislukt te verzenden`,
"label.emailtemplate.detailinfo":`Sjabloon Details`,
"setup_mainpage_label_welcome13":`Instructies: Klik op het menu bovenaan → Rapporten → Nieuw`,
"label.ccchat.error.nullid":`ID kan niet leeg zijn`,
"label.partnerCloud.partnerAccount.rebate":`Korting Revenu`,
"label.appupload.component.type.scheme":`Veld`,
"front-kefu-moudle-phonein":`Inkomend gesprek`,
"label.emailmerge.list.description":`Mail merge sjablonen zijn MicroSoft Word documenten met samenvoegvelden die verwijzen naar CloudCC.com velden.`,
"vue_label_commonobjects_detail_select_first":`Selecteer eerst gerelateerde artikelen`,
"label_emailsync_form_action":`Actie`,
"label.customfieldrelation":`Aangepaste velden en relaties`,
"label.ems.other.msg":`Neem contact op met CloudCC admin(<a href='mailto:admin@cloudcc.com' style='text-decoration: underline;'>admin@cloudcc.com</a>), start de mailsynchronisatiedienst.`,
"label.appointment.wizard.subtitle4-3-4":`1 h`,
"label.service.miniProgram.isOpen":``,
"equal":`is gelijk aan`,
"label.partnerCloud.financeSetting.merchantInformation":`Toegangspad: Merchant Platform  Account Center  Merchant Informatie`,
"vue_label_calendar_displayed_field_name":`Naam van het weergegeven veld`,
"UG_opportunity_002":`Definieer uw verkoopcyclus, configureer fase`,
"label.tag.addtags.button1":`Save`,
"label.explain":`Instructies`,
"label.icon.166":`Paviljoen`,
"label.exchange.sync.setting.use":`Exchange synchroniseren inschakelen`,
"label.chatter.assignPerson":`Aangewezen persoon`,
"lable.PowerProcess.event.condition":`Voorwaarden voor mijlpalen`,
"label.addattachment.step1":`Stap 1 Selecteer het bestand`,
"label.account.fiscal.quarter.timeerror":`De begindatum of einddatum van het fiscaal kwartaal valt tussen twee fiscale kwartalen in de geschiedenis, gelieve dit te controleren en opnieuw in te stellen.`,
"label.URL":`URL naar verwijzing`,
"label.icon.134":`Gegevens`,
"label.forecast.customforecast.foredis.sq":`Duizenden`,
"label.custom.field.number.decimal":`Verkeerd aantal cijfers.`,
"label.version.history.track.error":`Uw versie ondersteunt alleen om <=5 velden te selecteren, kan niet meer velden selecteren.`,
"label.log.os":`Besturingssysteem`,
"label.partner.workspace.tab.option":`Beschikbare tabbladen`,
"label.partnerCloud.partnerAccount.accountWater":`Fondsverklaring`,
"setup_layout_label_norelatedlist":`Geen gerelateerde lijsten`,
"label.import.page1.nextstep":`Volgende`,
"label.emailobject.view.attached":`E-mails met bijlagen`,
"label.SalesCommitmentKanBan.allTask":`Totaal Taakbedrag`,
"label.eastem.daylight.time":`Eastern Daylight Time`,
"label.create_engaging":`Maak een aantrekkelijke post om verbinding te maken met de wereld.`,
"label.area.adduser":`Gebruiker toevoegen of verwijderen`,
"label.timezone.importtimezone.user":`Gebruik login gebruikers tijdzone`,
"label.passwordPolicy.setup.pwdremember1":`1 wachtwoord onthouden`,
"label.query.detail.openpartneruser":`Partner gebruiker inschakelen`,
"label.senduser":`Stuur van`,
"Pagelayout_Setup_001":`Selecteer de gerelateerde lijsten die getoond moeten worden op de hover lay-out.`,
"label.mobile.parameter.setup":`Instellingen mobiele app`,
"message.device.not.bound.mfa":`Niet geconsolideerd MFA-apparaten`,
"setup.layout.label.buttonarea":`Knop Gebied`,
"chatter.email.reply.like":`Commentaar op een item dat ik leuk vind`,
"label.chatter.day":`Dag`,
"label.sendemail.chat.addComentspraisesubject":`CloudCC CCChat beantwoord de post graag`,
"label.field.remark2":`pagina.`,
"label.ggReleaseRange.release":`Publiceer Bereik`,
"lebel.alreadyback":`Teruggeroepen`,
"label.appupload.install.appname":`App Naam`,
"label.selectnewadeckertag":`Selecteer het label voor het nieuwe hiërarchieveld`,
"label.cliententrancewebsiteadmin":`Klantportaalbeheerder`,
"label.checkbox.checked":`Geselecteerd`,
"UG.Case.03":`Automatisch opwaarderen van de behuizing`,
"vue_label_dashboard_group":`Gelieve een groep te kiezen`,
"label.import.index.preparedata":`Bereid de gegevens voor die u wilt importeren`,
"vue_label_member_notice1":`U kunt JPG, GIF of PNG bestanden uploaden, de maximale bestandsgrootte is 2M`,
"message.modify.success":`Wijziging succesvol.`,
"label.userquotas":`Quota`,
"label.appointmentpage.wizard.subtitle3-1":`Naam`,
"label.import.index.maxdata2":`2、Voordat u gaat importeren, zorg er dan voor dat u eerst alle gerelateerde records importeert. Als er bijvoorbeeld een lookup-relatie is tussen het object dat u nu importeert en de contactpersonen, importeer dan eerst die contactpersonen en importeer daarna uw gegevens. Als u de overeenkomstige Record ID en andere informatie wilt, kunt u een rapport maken en de recordnaam en record ID als groepskolom instellen, en vervolgens het rapport exporteren.`,
"label.pc.sectionpart":`PC Sectie`,
"template.chart.wcldqzkh":`Onbewerkte Leads`,
"label.save.the.block.pricing.information.of.the.current.price.manual":`Wilt u de blokprijsinformatie van het huidige koersboek opslaan?`,
"label.partnerCloud.financeSetting.payments":`Online betaling toestaan`,
"lable.account.ThisWeek":`Deze week`,
"label.validate.function.funcFormat.RIGHT":`RIGHT(tekst, num_chars)`,
"label.app.select.bgcolor":`Selecteer achtergrondkleur`,
"label.planned.work":`Geplande banen`,
"label.passwordPolicy.setup.nolimit":`Geen limiet`,
"label.vlidaterule.s":`Als u de munteenheid die door de gebruiker wordt gebruikt uitschakelt, wordt de munteenheid van de gebruiker ingesteld op de bedrijfsvaluta.`,
"label.paging.totalofrecords":`Een totaal van {0} records`,
"label.customobjects.behaviour":`Acties`,
"vue_label_ccchat_notice_deletecommentsuccess":`Commentaar succesvol verwijderd`,
"label.lock.record.dele":`Het record is vergrendeld, u kunt het niet verwijderen.`,
"label.data.expnode.e.desc3":`3、Template Create: gebruiker kan de sjabloon op basis van de velden en voorwaarden die zullen worden geëxporteerd naar uw behoeften, die handig is om de volgende keer te gebruiken.`,
"label.button.step3.create.page":`Stap 3 Paginageneratie`,
"label.sharer":`Deel van`,
"label.service.cycle.type":`Type fiets`,
"lable.SalesCommitmentKanBan.allreceivingCommitmentRate":`Totale ontvangsten Vastleggingspercentage`,
"label.formuladate":`Datumformaat: jjjj-MM-DD hh:mm:ss of MM/DD/JJJJh:mm:ss, zoals: 2007-12-25 12:25:30 of 12/25/2007 12:25:30.Je kunt ook today() of now() gebruiken;`,
"front-template-V1-addImg":`Foto toevoegen`,
"label.basecontrol":`Basis toegang`,
"label.forecast.settings.lable1":`Samenvoeging van prognosegegevens`,
"message.error.file.null":`Upload bestand kan niet leeg zijn`,
"label.multiply":`*Multiply`,
"message.duplication.label.targetobject":`Object`,
"label.addattachment":`Bijlage toevoegen`,
"vue_label_dashboard_notice_editcertification":`Weet je zeker dat je de component {naam} wilt bewerken?`,
"label.notification.tip2":`Geen nieuwe meldingen`,
"lable.quote.syncingfrom.firstsync":`Initiële Sync: Mogelijkheid tot Offerte`,
"label.createtasktip":`Creëer een taak om te koppelen aan één of meer workflow regels, goedkeuringsprocessen, of rechtenprocessen. Bij het wijzigen van een taak, zullen alle wijzigingen van toepassing zijn op alle regels, goedkeuringen, of rechten processen die eraan gekoppeld zijn.`,
"label.leave":`Verlaat`,
"front-invoice-online-payment-setup-china":`Solliciteer naar Chinese rekeningen`,
"label.appointment.wizard.subtitle4-1-2":`30 min.`,
"label.projectManagement.the.person.not.be.informed":`Wanneer u Nee selecteert, kan de verantwoordelijke persoon niet op de hoogte worden gebracht!`,
"label.campagin.roi.name":`Campagne Naam`,
"label.import.page1.newcreate":`Maak`,
"label.data.downpage.i.title.num2":`2、Voordat u begint met importeren, controleert u of de veldnaam in het bestand dat u wilt importeren overeenkomt met de veldnaam van het object in het CloudCC.`,
"label.callcenter.call.in":`Bel in`,
"label.weixin.activity.phone":`Activiteit: Oproep`,
"label.forecast.customforecast.type.role":`Door Rol`,
"label.moscow.standard.time":`Moskou Standaard Tijd`,
"label.profile.setcustomobjectrecordtype":`Aangepaste opnametype-instellingen`,
"lable.edit.queue.new":`Nieuwe wachtrij`,
"label.newAPPexchange":`Nieuwe toepassing...`,
"message.custom.field.donotdelete.fieldupdate":`Naar dit veld wordt verwezen door een veldupdate in een andere workflow of goedkeuringsproces.`,
"label.chatter.state":`Status`,
"label.subject_line":``,
"template.report.folder.active":`Analyse van campagnes en acties`,
"label.icon.114":`Huis`,
"label.assignment.setup.newentries.step3":`Stap 3 Selecteer de gebruiker aan wie u de leiding wilt toekennen`,
"label.salescloud.salesdashboard.sales.behavior.rankings":`Persoonlijk-gedragsoverzicht`,
"label.weixin.optiontwo":`Keuze 2`,
"label.sso.saml.idp.config.sp":`Dienstverleners`,
"System_TimeField_Description":`Hiermee kunnen gebruikers een lokale tijd invoeren. Bijvoorbeeld, "14:40 PM", "14:40" en "14:40:00" zijn allemaal geldige tijden voor dit veld.`,
"label.knowledgebase.draft":`Ontwerp`,
"label.chat.topic.no.more.suggestions":`Geen andere suggesties.`,
"label.quote.product":`Product`,
"label.cryptographictext":`Gecodeerde tekst`,
"label.custom.unlock":`Ontgrendelen`,
"label.assignment.setup.newentries.step2":`Stap 2 Selecteer de criteria voor deze regelinvoer`,
"label.tabularreport.selectline":`Selecteer de kolommen die u in het rapport wilt opnemen.`,
"label.exchange.sync.state.contact.m2":`Records gesynchroniseerd in de laatste 60 minuten:`,
"label.codeType":`Code Type`,
"saturday":`Zaterdag`,
"label.mask.type":`Masker Types`,
"label.schedulejob.setup.schedule.Monthly":`Maandelijks`,
"label.import.page2.totalfiled{{20}}，{{4}}notsuited":`文件中共{{20}}个字段，剩余{{20}}个未映射

{{20}} velden in het bestand , {{20}} unmapped`,
"label.projectManagement.delete.item":`Alle gerelateerde informatie van dit project zal worden verwijderd als u het project verwijdert, en de gegevens kunnen niet worden hersteld. Weet u zeker dat u de verwijdering wilt bevestigen?`,
"label.page.general.us.and.western.europe":`Algemeen VS & West-Europese talen`,
"label.reportsSubscription.status":`Ingeschreven`,
"label.discount.baifenbi":`Korting (%)`,
"font-evaluate-module-v1-web-page-evaluation-settings":`Web Evaluatie Setup`,
"message.error.searchwork":`Uw ingevoerde trefwoorden moeten uit 2 of meer tekens bestaan.`,
"label.weixin.option.setting":`Keuze-instellingen (tot 10 keuzes)`,
"label.lead.score.prompt1":`Scoor één leadrecord automatisch bij het maken of bewerken. Maar u moet handmatig meerdere lead records scoren, wanneer u batchgewijs importeert of aanmaakt via een interface.`,
"label.exception.must.try.throw":`Uitzondering moet worden uitgeworpen in een staement blok.`,
"label.activity.plan":`Plan`,
"label.partnerCloud.productSet.editor":`Optie bewerken`,
"label.mobile.quickcreate.default.signinnew":`Meld je aan.`,
"label.summaryreport.2018.step6.new":`Stap 6 Selecteer het grafiektype en het markeerpunt`,
"vue_label_homepage_owner":`Mijn homepage`,
"vue_label_dashboard_editfoldersuccessfully":`Map bewerken met succes`,
"label.quickbooks.view.overdueinvoices":`Achterstallige facturen`,
"label.emailtocloudcc.redmessage4":`Gelieve havengegevens in te voeren`,
"label.tabpage.equalz":`Gelijk aan`,
"lable.quote.syncing.firstsync":`Eerste Sync: Citaat naar Opportunity`,
"label.download.CloudCCAPP":`Download CloudCC App`,
"label.icon.6":`Valuta`,
"label.list.serial.number":`Serienummer`,
"label.profile.setstandardobjectrecordtype":`Standaard opnametype instellingen`,
"label.customize.memory.function.sorting.error":`De responstijd van de query is te lang en veroorzaakt een page timeout. Dit kan komen doordat het Geheugen van Kopteksten Sorteren is geactiveerd. Ga naar de persoonlijke instellingen en deactiveer deze functie.`,
"message.view.addtoallusers":`Zichtbaarheid van verwante gebruikers`,
"label.globaloperation.operationtype.record.phone":`Een oproep loggen`,
"lable.opppdt.selPdt.searchresult":`Zoekresultaten`,
"label.import":`Importeren`,
"label.service.gantt.work.based.resources":`Middelen op basis van werkuren`,
"label_partner_template_detailimage":`Foto`,
"label.cpq.product.feature.option.count":`Het minimum van de productopties kan niet groter zijn dan het maximum van de productopties`,
"label.chatter.newtask":`Nieuwe taak`,
"font-trade-module-v1-invoice-total-price":`Gepland Totaal Betalingen`,
"setup_mainpage_label_welcome29":`Standaard API-integratie met producten van derden`,
"label.data.exportall.all.btn":`Alle gegevens exporteren`,
"front-epwechat-module-v1-unbound-WeChat":`Ontbind WeCom`,
"label.salescloud.salesdashboard.performance.rankings":`Team-Sales Contract Bedrag Rangschikking`,
"label.import.page1.newcreateandupdate":`Bijwerken en nieuw beginnen`,
"component.chatter.post.button.file":`Bijlagen toevoegen`,
"label.partnerCloud.orderingPlatform.createOrder":`Nieuwe Orde`,
"label.lookup.multiple.data":`Meerdere gegevens gevonden, gelieve manueel te selecteren`,
"button.partner.save":`Save`,
"label.service.add.timeslot":`Tijdslot toevoegen`,
"label.campaign.matchway.select.email":`E-mail`,
"front-sales-button-fromQB":`Update van QuickBooks`,
"label.icon.108":`Pijl`,
"lable.outlook.edit.efmapping":`Veldtoewijzingen bewerken`,
"label_tabpage_refreshz":`Vernieuwen`,
"chatter.follow.cancel":`Stop met volgen`,
"label.totals.sum":`Totaal`,
"label.noRequest":`Geen vereiste`,
"vue_label_homepage_fixedcomponent":`Gelieve een vast onderdeel te kiezen`,
"label.knowledge.delete.case":`Fout bij het verwijderen van een zaakartikel.`,
"label.weixin..xsld.yjwc":`Verwachte inkomsten`,
"label.customcomponent.page.index.console.btn":`Ontwikkelaar Console`,
"label.sendsms.batch":`Mass SMS`,
"vue_label_chat_onlychosechat":`Alleen Team gebruikers kunnen worden geselecteerd voor chat`,
"label.tabpage.page":`Pagina`,
"label.cyen.note":`Valuta inschakelen. Merk op dat de actie van valuta ingeschakeld onomkeerbaar is.`,
"label.weixin.againsend":`Opnieuw verzenden`,
"label.processnumber":`Stap Nee.`,
"label.emailobject.to":`Naar:`,
"label.event.today":`Vandaag`,
"label.dashboard.dispalyPosition":`Onthechte positie`,
"message.error.recalculate.dupoperate":`Herberekenen, gelieve niet vaak te werken.`,
"vue_label_email_linkrecordsuccess":`Succesvol geassocieerd record`,
"label.updateoutboundnews":`Uitgaande berichten bijwerken`,
"label_emailtocloudcc_exists2":`Deze mailbox is ingesteld op E-mail naar Zaak. Instellingen niet herhalen.`,
"label.tag.addtags.button2":`Annuleren`,
"label.stdashbord.xsld.business.role":`Deze rol is ontleend aan de inschakel rollen in voorspellings hiërarchieën`,
"label.commonnew":`Normaal nieuw`,
"label.validate.remark2":`Gebruiksmonster:`,
"label.reportsSubscriptionPage.condition.checkbox":`Voeg voorwaarden toe aan dit rapport`,
"label.globalselect":`Global Options List Waardenset`,
"label.partnerCloud.partnerAccount.available":`Beschikbaar bedrag`,
"label_tabpage_nothingz":`Niets`,
"label.version.webtolead":`We to Lead`,
"label.projectManagement.heat.map":`Hitte kaart`,
"message.error.pleasecorrectdata":`Controleer alle volgende foutmeldingen om de gegevens te corrigeren.`,
"label.hight.tip":`Als het geavanceerd filter niet is ingeschakeld, is de relatie tussen de verschillende filtervoorwaarden: een record dat voldoet aan de gemeenschappelijke kenmerken van 1 en 2.`,
"label.workflow.estimatecondition3":`Gemaakt of elke keer dat het wordt bewerkt`,
"AssetRelationship.time.limit.error":`De aanvangsdatum is vroeger dan of gelijk aan de vervaldatum.`,
"label.multilang.workflow.dayinmonth":`De {1} elke {0} maand(en)`,
"label.reportsSubscriptionPage.schedulereport.daily":`Dagelijks`,
"label.emailtocloudcc.step1.name":`Kies Functie`,
"label.follow_up":`Followup email`,
"label.price.list.price.cannot.be.empty":`De lijstprijs kan niet leeg zijn.`,
"label.chatter.link":`Link`,
"label.ccpeak.condition.return.record":`Geeft records op voorwaarde en ondersteunt gewone "waar"-voorwaarden.`,
"pagecreator.layout.message.canntdelete":`De huidige lay-out is niet toegestaan om te verwijderen`,
"label.compact.layout.main":`Lay-out van de belangrijkste informatie`,
"label.testandupdate":`Controleren op updates`,
"button_partner_cancel":`Annuleren`,
"label.activity":`Activiteiten`,
"label.knowledge.setting.hint.fourteen":`Maak je klaar om te schrijven!`,
"vue_label_commonobjects_view_open_from_list":`Open uit de lijst om te beginnen`,
"front-electronic-export-intro":`2000 records kunnen in één keer naar Mailchimp worden geëxporteerd`,
"label.chosen.all":`Alle velden`,
"label.file.extension":`Bestandsextensie`,
"vue_label_systemSettings_server_miniprogram":`Service Miniprogramma`,
"label.weixin.no.pending.wdgz.qin.today":`Geen werkschema voor vandaag.`,
"label_tabpage_issuez":`Nummer`,
"label.staticresource.tip":`Gebruik statische bronnen om inhoud te uploaden waarnaar u in een aangepaste pagina wilt verwijzen, zoals .zip, afbeeldingen, stylesheets, JavaScript en andere bestanden.`,
"label.approvalstep":`Goedkeuring Stappen`,
"label.china.standard.time":`China Standaard Tijd`,
"label.appexchange.download.tiaoguo":`Negeer`,
"label.callcenter.link.Amazon.connect":`Amazon Connect`,
"vue.dashboard.notRequired.notConformToTheRules":`Kan niet indienen! De vereiste items zijn niet ingevuld of zijn niet in overeenstemming met de regels.`,
"label.appointment.wizard.title1":`Beschikbaarheid definiëren`,
"label.chat.remove.bookmark":`Bladwijzer verwijderen`,
"label.tabpage.advancedsearch":`Geavanceerd zoeken`,
"batch.ranf.f":`Massa overdracht records mislukt`,
"label.appointment.wizard.subtitle4-1-4":`1 h`,
"label.brief.account":`Rekeningen`,
"component.chatter.link.label.url":`Link url`,
"label_emailtocloudcc_redmessage8":`Parameter fout, neem contact op met de beheerder.`,
"label.object.create.two.number.field":`Per object kunnen maximaal 2 aangepaste Auto-Nummervelden worden aangemaakt.`,
"label.salecommit.not.roleinformation":`U hebt geen rollen en kunt de dashboards van de verkoopverbintenissen niet zien.`,
"label.defautline.cannot.less":`Het standaardaantal regels mag niet minder dan 1 zijn.`,
"label.selectedproducts":`Aantal geselecteerde producten`,
"label.productsales.today.notskadd":`Er zijn geen aflopende taken, u kunt op " " in de rechterbovenhoek klikken om een nieuwe taak toe te voegen.`,
"lable.account.year.stadate":`Begindatum boekjaar`,
"label.mobile.phone.month.plan2":`Taken van deze maand`,
"label.ccpeakfolder":`Klassenmappen`,
"setup_mainpage_label_welcome21":`Het CloudCC-cloudplatform biedt een door de gebruiker gedefinieerde e-mailsjabloonfunctie, die handig is voor gebruikers om te gebruiken en de werkefficiëntie te verbeteren.`,
"label.modify.layout":`Lay-out bewerken`,
"report.label.folder":`Mappen`,
"label.tianyancha.businessverify.rewritename":`Naam suppletierekening`,
"lable.currencyAdv.dao":`naar`,
"label.mobilelayout":`Mobiele lay-out`,
"label.the.current.model.is.enabled.and.cannot.be.edited.":`Het huidige model is geactiveerd en kan niet worden bewerkt.`,
"label_partner_all_disable":`Uitschakelen`,
"label.ownerapproverfield":`Goedkeurder Veld van Eigenaar`,
"label.emailobject.template.message4":`Sommige van de ingevoegde velden in het bericht zijn ongeldig, gelieve aan te passen en opnieuw te verzenden!`,
"label.productsales.today.notsk":`Er zijn geen aflopende taken.`,
"label.multilang.document.upload.success":`{0} bestanden zijn succesvol geuploadt en {1} bestanden zijn mislukt`,
"label.manageAll.sta3":`Afgewezen`,
"vue_label_calendar_week_view":`Kalender-week weergave`,
"setup_layout_label_nocustompage":`Geen aangepaste pagina's`,
"label.weixin.wdyj.jxdcl":`Persoonlijk-prestatie-prestatiepercentage`,
"label.donot.update":`Je hebt geen toestemming om te veranderen!`,
"setup.mainpage.label.welcome14":`Procesbeheer van workflowaanpassing, goedkeuring`,
"UG_Campaign_002":`Plannen, uitvoeren en controleren van de doeltreffendheid van de marktactiviteiten.`,
"label.layout2":`Lay-out twee`,
"label.app.looup":`Apps vinden`,
"label.projectManagement.selectitem":`Selecteer een project`,
"label.field.relating.rule":`Associatieregels van opzoekvelden`,
"vue_label_commonobjects_detail_selectname":`Kies eerst een naam`,
"front-email-payment-Invoice-select-pay":`Selecteer Betalen door:`,
"label.customfields.formula.numberexample":`Fahrenheit = 1.8 * Celsius__c 32`,
"component_event_label_enddate":`*Eindtijd`,
"label.partnerCloud.partnerAccount.lineOfCredit":`Kredietlimiet`,
"label.chatter.newpost":`Laatste bericht`,
"label.report_dashboard":`Dit rapport zal worden opgeslagen in uw rapporten. U kunt het ook toevoegen aan een dashboard.`,
"label.assigned":`Toegewezen aan`,
"Homepage_News_002":`De nieuwscomponent is momenteel niet beschikbaar.`,
"label.approval.select.relatedobj":`Om het relevante item te selecteren, moet het een type kiezen`,
"label.service.miniProgram.isTop":`Plakkerig bovenop`,
"message.error.object.datatoolang":`Datalengte is te lang, maximum {!lengte} tekens.`,
"label.importsourcetip":`Importeren is ontworpen om de bestanden van ons exportproces te accepteren. Als u nog niet geëxporteerd hebt, ga dan nu naar de exportpagina.`,
"label.select.deadlineplease.deadline":`Selecteer een termijn.`,
"vue_label_account_equityrelationship":`Vermogensverhouding`,
"label.account.Calendar.month":`Kalendermaand`,
"label.appointment.wizard.subtitle3-4":`Donderdag`,
"font-evaluate-module-v1-smaller-500":`Het bestand moet kleiner zijn dan 500KB`,
"label.reportsSubscriptionPage.email.tome":`Naar mij gestuurd`,
"label.ccchat.person.invite.existpers":`Al aan het volgen:`,
"label.appointment.wizard.subtitle1-3":`30 min.`,
"front-kefu-moudle-connected":`Aangesloten`,
"label.campaignmember.main.duplicatelist.tip":`Het systeem zal dubbele leads en campagneleden vinden op basis van de instellingen hier.`,
"label.visualpage.such.tags.double":`Deze tags zullen verschijnen in paar`,
"label.sendsms.batch.step2.introduce":`Kies een SMS sjabloon.`,
"Account_News_Setting_002":`Gebruik de onderstaande accountinstellingen om het standaard accountgedrag voor uw organisatie te specificeren.`,
"message.encryptchange.alert":`U staat op het punt om {{!fieldapi}} om te zetten van een Gecodeerd Tekstveld(Opslag Gecodeerd) naar een Gecodeerd Tekstveld(Weergave Gecodeerd), na succesvolle omzetting zal dit veld in duidelijke tekst in de database worden opgeslagen, die in duidelijke tekst of gecodeerde tekst kan worden weergegeven volgens de profielinstellingen. De velden zijn doorzoekbaar. Deze operatie is onomkeerbaar, wilt u doorgaan?`,
"label.mainpageset.description":`Configureer de homepagina op organisatieniveau op basis van de werkelijke behoeften van uw bedrijf.<br>Componenten in de standaardconfiguratie die niet relevant zijn voor uw bedrijf kunnen worden uitgeschakeld of uitgeschakeld.<br>Inschakelen: ingeschakelde componenten worden getoond op de homepagina van alle leden.<br>Uitzetten: uitgeschakelde componenten worden niet getoond op de homepage van alle leden, en ze worden ook niet getoond in de lijst van "Configureer Mijn Homepage" in app.<br>Uitzetten: uitgeschakelde componenten worden standaard niet getoond op de homepages van alle leden, en gebruikers kunnen ze aanzetten via "Configureer Mijn Homepage" in app.`,
"label_tabpage_linknamez":`Link naam`,
"label.companyname":`CloudCC.com Ltd. Co`,
"label.currency.current":`Huidige bedrijfsvaluta`,
"label.campaignmember.main.duplicatelist.html.title":`Instelling van het verwijderen van duplicaten door het scannen van code`,
"label.sendsms.batch.step3.plan":`Leveringsdatum Plan`,
"label.profile":`Profiel`,
"label.canceluploadfile.step":`Klik op de knop Annuleren om alle bestanden in het bovenste gebied te annuleren`,
"message.newreport":`Nieuw verslag`,
"label.service.newBuildDialog.date.selection":`Kies Datum`,
"label.lookup":`Lookup`,
"label.file.editinfo":`Bestandsdetails bewerken`,
"component_assistant_label_nodata":`Geen evenement vandaag, kom later terug.`,
"label.tianyancha.businessverify.msg4":`Deze functie maakt gebruik van diensten van derden en is momenteel gratis beschikbaar voor gebruikers, maar CloudCC garandeert niet dat derden de dienst altijd gratis aan gebruikers zullen leveren. Als derden kosten in rekening brengen, heeft CloudCC het recht om de gebruiker kosten in rekening te brengen of het gebruik van deze functie te stoppen.`,
"label.noequal":`!=Niet Gelijk`,
"vue_label_metric_column":`De tabel moet ten minste 1 evaluatiekolom hebben.`,
"label_reportType_chose_and_form":`Selecteer de rapportgegevensbron en een rapportopmaak`,
"vue_label_pool_reasondescription":`{0} reden omschrijving`,
"label.isusing":`Actief`,
"label.passwordPolicy.setup.pwdremember5":`5 wachtwoorden onthouden`,
"label.cancel":`Annuleren`,
"vue_label_helpcenter_detail1.1":`activiteiten, en dynamiek van elke record, en vouwt u de bijbehorende informatie rechtsboven in de module uit of in. U kunt ook de gegevens die bij de record horen bekijken en beheren via de gerelateerde lijst.<br> 1. Een enkel gegeven bekijken en beheren<br>U kunt gegevens bewerken, kopiëren, verwijderen, of delen met ander personeel via de knoppen in de rechterbovenhoek.<br>Bekijk de gedetailleerde informatie van de gebruiker, en u kunt direct enkele velden op de pagina bewerken om de eigenaar of het recordtype van de gegevens te veranderen.<br>Bekijk en beheer de gegevens die aan het record zijn gekoppeld via de verwante lijst. In de bestandsgerelateerde lijst, upload het opgenomen bestand, of klik op de bestandsnaam om het bijbehorende bestand te downloaden en te bekijken.<br> 2. Verwante lijsten<br>Kijk snel via de verwante lijst, en gebruik het zwevende venster om tot 10 verwante records te bekijken. Klik om de lijstweergave te openen, alle gerelateerde records te bekijken, en inline te bewerken.<br>Gebruik de kaartindeling om gerelateerde records hieronder te bekijken en te beheren.<br> 3. Activiteiten<br> Op de detailpagina van de records toont de Lightning versie niet de twee gerelateerde lijsten van "onverwerkte activiteiten" of "activiteit geschiedenis". In plaats daarvan wordt de activiteiten tijdlijn getoond.<br>Activiteiten tijdlijn toont inhoud<br> De activiteiten tijdlijn kan alle activiteiten tonen die van toekomst tot verleden in het huidige record. Te laat uitgevoerde taken en komende taken en gebeurtenissen worden getoond in de module "Te laat en Komend" van de activiteitentijdlijn. Verleden of momenteel voltooide taken, gebeurtenissen, opgenomen gesprekken, emails en sms-berichten worden weergegeven in de overeenkomstige maand.<br>`,
"registration.page.preview":`Voorbeeld Registratiepagina`,
"label.quickbooks.search":`Zoeken op`,
"label.setup.mobile.bottombutton.tab.show":`Tabbladweergave onderaan`,
"lable.want.to.delete.tem":`Weet u zeker dat u de service rapportsjabloon {currentTelmplateName} wilt verwijderen?`,
"label.multilang.fielddtrack.dealkey":`Verander {0} van {1} naar {2}`,
"vue_label_pool_return":`Terug`,
"vue_label_calendar_failed_to_share_calendar":`Kan de kalender niet delen`,
"label.less":`< Minder dan`,
"label.email.form.html":`Html`,
"label.tag.nodata":`Geen gegevens`,
"label.setarticlecon":`Ingangscriteria specificeren`,
"label.searchlayout.displayrow":`Weer te geven kolommen`,
"label.change.task":`Taak Weergave`,
"lable.quote.editqtpdt.title":`Quote Posten bewerken`,
"label.appointment.wizard.subtitle4-4":`Hoe ver in de toekomst kan iemand je boeken?`,
"label.custom.page.button.css":`Knop CSS`,
"label.input.documentmessage":`Details invoeren`,
"vue_label_commonobjects_detail_email_address":`Adres ontvanger`,
"label.chatter.filterTimeLine":`Tijdlijn filteren`,
"label.must.select.twoorthree.records":`U moet twee of drie records selecteren om samen te voegen`,
"label.mobile.setup":`Mobiele app instellen`,
"vue_label_commonobjects_detail_key_field":`Belangrijke velden`,
"label.chatter.relateitem":`Gerelateerd aan`,
"label.customobjects.tip":`Zodra u een aangepast object hebt gemaakt, kunt u een aangepast tabblad, aangepaste gerelateerde lijsten, rapporten en dashboards maken voor gebruikers om te interageren met de gegevens van het aangepaste object. U kunt ook toegang krijgen tot aangepaste objectgegevens via de API.`,
"label.sso.saml.idp.config":`Identity Provider`,
"label.knowledgebase.affect.article.version":`Zal de wijziging invloed hebben op de bestaande vertaling? Zo ja, dan kunt u de kostbare vertaling markeren als "Verlopen" en een lijst van pendign voor vertaling genereren voor de leveranciers van de vertaling.`,
"message.error.record":`Het overeenkomstige record werd niet gevonden!`,
"message.duplication.label.fieldname":`Veld`,
"setup.layout.button.cancel":`Annuleren`,
"label_radar_map_function":`Gebruik radardiagrammen met meerdere metrieken om de rol van contacten in de verkoopbeslissingsketen te meten.`,
"label.campagin.roi.fss":`Num Verzonden`,
"label.emailobject.template.giveup":`Annuleren`,
"label.apiname.exists":`API-naam bestaat al.`,
"message.failtoreaddata":`Lees gegevens mislukt`,
"label.file.versionedit":`Inhoud modificator`,
"template.report.lost.business.opportunity":`Verloren kansen`,
"label.ccchat.group.allowgd":`Groepen toestaan te archiveren`,
"label.fieldaccesslimit":`Toegankelijkheid van het veld`,
"label_target_model":`Doelmodel`,
"message.validation.isnoturl":`Ongeldige URL`,
"servicecrew.member.time.conflict":`Binnen deze tijdspanne zijn dienstmiddelen lid geworden van andere dienstteams.`,
"label.knowledgebase.delete.details":`Het zal alle opdrachtinformatie wissen.`,
"vue_label_normal_bottom":`Bodem`,
"label.custombutton.editerror":`Bewerken mislukt`,
"label.dashboardSetup.showdw.d6":`Automatisch`,
"message.error.field.decimalPlaces":`Decimale invoer formaat fout.`,
"label.tabpage.busoppnamez":`Naam zakelijke mogelijkheid`,
"label.insertfield.intro":`Selecteer een veld, en klik op "Invoegen". Met de ">" klik om meer beschikbare velden te zien.`,
"setup.layout.label.nocustompage":`Geen aangepaste pagina's`,
"front-gantt-module-project-has-only":`Dit project heeft slechts {n} mijlpalen`,
"label.weixin.fmu.am":`{0} AM`,
"label.emailsync.status.connectaccounts":`Aangesloten e-mailaccount`,
"label.customcomponent.check.name.same":`Deze naam bestaat al.`,
"label.validate.function.funcFormat.HOUR":`UUR(datum)`,
"label.approvepagelayout4":`Kopieer vorige pagina lay-out`,
"label.knowledge.category.hint.nine":`Activeer Categorie Groep`,
"label.report.sorting.column":`Kolom Sorteren`,
"label.hours":`Klok`,
"label.email.clearAllemail":`Wilt u alle gesynchroniseerde E-mails in de mailbox leegmaken?`,
"font-evaluate-module-v1-satisfaction":`Tevreden Evaluatie`,
"label.service.hide.more.info":`Verberg meer info`,
"label.area.list.intro":`U kunt territoriuminformatie op deze pagina bewerken.`,
"label.sendemail.chat.addPostat":`Beste #naam:hallo! #gebruikersnaam noemde u in een micropost.`,
"label.data.newtemplate.e_seltype.desc":`Er zijn twee soorten afgeleide gegevens</li><li class="titledesc1">1.een is het CSV-formaat (de standaard)</li><li class="titledesc1">2.de andere is het compressieformaat. De compressieformaatmodus is onderverdeeld in twee soorten</li><li class="titledesc1">2.1.één soort is het automatisch genereren van een wachtwoord voor gecomprimeerde bestanden, het automatisch gegenereerde wachtwoord wordt naar de gebruiker verzonden na een succesvolle gegevensexport in de mailbox</li><li class="titledesc1">2.2.een andere soort is het handmatig invoeren van het wachtwoord voor gecomprimeerde bestanden, het wachtwoord voor handmatige invoer wordt niet naar de mailbox van de gebruiker verzonden, zodat gebruikers het wachtwoord niet hoeven te onthouden.Als u geen wachtwoord invoert, is de standaardwaarde geen wachtwoord.`,
"message.passwordPolicy.validate.minlengths":`Fout: Uw wachtwoord moet ten minste`,
"message.save":`Weet je zeker dat je wilt sparen?`,
"label.marketsea.notfollowdays1":`Na het verkrijgen van`,
"label.app.step1":`Stap 1 Kies type`,
"message.error.pageid.null":`Facebook social media ID kan niet leeg zijn!`,
"label.weixin.input.lookupfield":`Voer trefwoorden in om de bijbehorende microstem te vinden`,
"label.whChatAccount":`WeChat-account`,
"label.tabpage.groupingitem":`Groeperingsitem`,
"label.callboard.introduce":`Alle aankondigingen van uw bedrijf staan hieronder.`,
"label.financial.services.seminar":`Seminar financiële planning`,
"label.data.file.i_title.num1":`1. Het geïmporteerde bestand moet een bestand in CSV-formaat zijn. Het bestand moet een titel bevatten en kan niet zonder titel worden geïmporteerd.`,
"label.visualpage.filename.exist":`De bestandsnaam bestaat al.`,
"front-kefu-moudle-v1-new-chats":`Nieuwe Agent`,
"label.console.step5.tab":`tabblad open`,
"vue_label_opportunity_contactrole_edit":`Contactrollen bewerken`,
"label.projectManagement.delete.return":`Het zal terugkeren naar de vorige pagina na het wissen van de laatste gegevens.`,
"registration.page.designs":`Verschijningsinstelling voor registratiepagina`,
"label.console.step6.heigth":`Hoogte`,
"label.objectRelationshipAtLeast":`ten minste één record hebben dat verband houdt met`,
"label.knowledge.delete.viewstat":`Erroe bij het verwijderen van browsegegevens van kennisartikel`,
"label.direct.dashboard.month.report":`Nieuwe maandelijkse werknota`,
"label_tabpage_lookatmorez":`Zie Meer`,
"label.setup.rights.management":`Beheer van rechten`,
"label.campaign.channel.clear.img":`Duidelijk beeld`,
"label.calendar":`Kalender`,
"label.biaoqingfaxian.username":`Rekening`,
"label.weixin.wdyj.jxht":`Persoonlijk-Verkoop-Prestatie-Contracten`,
"label.emailtocloudcc.exists1":`Deze mailbox is ingesteld op Email to Lead. Instellingen niet herhalen.`,
"label.emailtocloudcc.filed.password":`Wachtwoord`,
"label.what_create":`Welk soort vorm wil je creëren?`,
"vue_label_report_onlydisplaypart":`Er kunnen maximaal 50 gegevens worden weergegeven, en na afloop worden alle gegevens weergegeven.`,
"label.up":`Up`,
"label.addattachment.edit":`Bijlage bewerken`,
"label.ccchat.message.search.desc5":`Zoekwoorden kunnen niet uit minder dan 2 tekens bestaan`,
"label.chose.nonotice":`Selecteer het record dat u niet meer herinnert`,
"UG_activity_06":`Wil je accounts opvolgen`,
"label.set_contactsmarketing":`Instellen als Campagne Contact`,
"pagecreator.layout.button.horizontal":`Zijdelingse demontage`,
"label.brief.opportunity2":`Kansen die naar verwachting zullen worden afgesloten`,
"label.ems.nomsg":`Niet ingesteld`,
"label.fieldupdate.tip":`Met veldupdates kunt u de waarde van een veld automatisch wijzigen in een waarde die u opgeeft. Veldupdates zijn acties die gekoppeld zijn aan workflowregels en goedkeuringsprocessen.`,
"label.sso.saml.sp.federationid":`Federatie ID`,
"label.import.page2.suited":`Mapped`,
"message.error.appexchange.integrity":`Zorg voor de integriteit van de onderdelen in het uploadpakket.`,
"label.fielddatatype":`Veld Gegevenstype`,
"message.approval.cannotsubmit.detail2":`Het record moet aan de volgende criteria voldoen of de formule evalueert naar waar, anders kan het goedkeuringsverzoek niet worden ingediend, gelieve opnieuw in te dienen na wijziging.`,
"vue_label_commonobjects_detail_cloud_as_a_user":``,
"label.summaryreport.selectlinetogroup":`Selecteer de kolom waarop de rapportgroepering is gebaseerd`,
"label.tabpage.norecordtypez":`Onbruikbaar recordtype`,
"label.icon.141":`Valuta`,
"label.addattachment.step3.intruduce":`Als u aan het uploaden bent, zal dit de lopende upload annuleren.`,
"label.trigger.recursive.call.three":`Triggers kunnen inter-atief worden aangeroepen, het aantal loops is beperkt tot 3 keer, indien meer dan 3 keer zal het systeem een foutmelding geven.`,
"maintenanceplan.workorder.type.asset.workorder":`Kies "Een werkbon voor elk bedrijfsmiddel" als het type werkbon.`,
"label.emailtocloudcc.select1":`Kies alstublieft`,
"label.system.log":`Configuratie Audit Log`,
"vue_homepage_dashboard_not_support_fullscreen":`Sorry, uw browser ondersteunt geen volledig scherm.`,
"label.projectManagement.nodata.resource":`Nog niet betrokken bij projecten. Voeg 'Mijn' projectinformatie toe aan de leden om de tijdsindeling van teamleden te bekijken.`,
"label.exchange.sync.state.contact":`Contacten`,
"label.field.type":`Veld Type`,
"label.selected.object":`Geselecteerd Object`,
"label.customfields.new.step2":`Stap 2 Vul de gegevens in`,
"label.monitorsys.delete.style":`Soorten bewerkingen`,
"label.projectcondition":`Toegangscriteria`,
"potential.customers.field.default":`Standaardinstelling van afleidingen`,
"message.password.nosame":`De wachtwoorden komen niet overeen.`,
"label.validate.function.funcExplain.MONTH":`Geeft als resultaat de maand, die een getal is tussen 1 (januari) en 12 (december)`,
"label.project.user.project.count":`Aantal projecten waaraan gebruikers hebben deelgenomen`,
"chatter.to":`naar`,
"vue_label_commonobjects_detail_activity_owntask":`eigen taak`,
"label.generate.mobile.page":`Mobiele pagina is voltooid.`,
"label.escalation.setup.newentries.step1":`Stap 1 Stel de volgorde in waarin deze regel zal worden verwerkt`,
"label.email_footer":`Email voettekst`,
"label_partner_workspace_member_profile":`Beschikbare profielen`,
"label.loginhis.between":`Startdatum afstand einddatum niet langer dan 2 maanden`,
"label.user.verficationcode.error":`Verkeerde verificatie code.`,
"label.email_notifications":`Stuur een emailbericht over de indiening`,
"APPIntegration_Dropbox_01":`Selecteer bestanden uit Dropbox`,
"label.projectManagement.Selectweek":`Kies week`,
"wednesday":`Woensdag`,
"message.atleastonereceiver":`Kies ten minste één ontvanger`,
"label.applt.link.text":`Wij hebben uw bedrijf gekoppeld aan het portaal miniprogramma. Kopieer het portal adres van het mini programma gewijd aan uw bedrijf, plaats het mini programma adres in de jump link naar de officiële account van uw bedrijf menu, dan kunnen klanten klikken op het menu om het mini programma te gebruiken. (Officieel account aangepast menu < Spring naar miniprogramma< Miniprogrammapad)`,
"label.wait.for.a.moment":`Een ogenblik geduld alstublieft met het instellen van de taal...`,
"vue_label_chatter_only_group_members_look":`Alleen leden van de groep hebben toegang om te kijken, u kunt proberen om lid te worden van de groep`,
"label.knowledgebase.last.release":`Laatst verschenen`,
"component.setup.label.pagesize":`Artikelen per pagina`,
"label.paging.totalofpages":`Een totaal van {0} pagina's`,
"label.globaloperation.successmessage":`Succesbericht`,
"label.logout":`Uitloggen`,
"label.partner.common.enable":`Schakel partner cloud in`,
"label.permission.objectpermission.goback":`Terug naar lijst: Toestemmingsreeksen`,
"label.approvalstep5.required":`Vereist`,
"component_chatter_label_to":`Naar`,
"message.please.choose.role":`Gelieve een rol te kiezen`,
"maintenanceasset.servicecontract.contractlineitem.illegal":`U moet de contractregel selecteren onder het servicecontract dat bij het onderhoudsplan hoort.`,
"label.projectManagement.Resource.usage.view":`Hulpbronnen gebruiksweergave`,
"label.smsmainbody":`Bericht Tekst`,
"label.ccchat.error.nullname":`Naam is verplicht`,
"label.appupload.upload.version":`Versie Nummer`,
"label.data.setok.t_desc2":`Terug naar Data sjabloon pagina`,
"vue_label_pool_allocationstatus":`Toewijzingsstatus`,
"label.tianyancha.orgapprovedinstitute":`Org erkend instituut`,
"label.quickbooks.searchlist.startdate":`Begindatum`,
"label.setapp":`App-instellingen`,
"chatter.about":`Over mij`,
"label.layoutname":`Naam pagina-indeling`,
"label.icon.160":`Aarde`,
"label.tabpage.Rolesz":`Rollen en ondergeschikten`,
"label.console.step5.introduce":`Kies hoe u wilt weergeven`,
"label.customfields.totalsummary.gettogetherfield":`Veld om samen te voegen`,
"message.appexchange.addtopackage.profile":`In een pakket kan slechts één profielcomponent worden toegevoegd!`,
"vue_label_file_user_header_pic":`Avatar`,
"font-trade-module-v1-invoice-detail-price":`Gedetailleerde Betalingen`,
"homepage.components.three":`Stap 3 Voer de inhoud van het aangepaste componenten scherm in`,
"nine":`Nine`,
"label.marketsea.button.restore":`Herstel`,
"label.forecast.editshrepage.desc2":`Individueel delen kan alleen worden gebruikt om een ruimere toegang tot gegevens te verlenen, niet om de toegang te beperken.`,
"label.cloudccsite.list":`Sites`,
"label.icon.35":`Wolk`,
"vue_label_pricebook_price":`Voeg standaard prijs toe`,
"label.version.sum.addressfield":`Adresveld(en)`,
"label.projectManagement.Gotomilestone":`Draai naar Mijlpaal`,
"label.dataimport.name.length":`Fout: de lengte van de naam is te lang.`,
"label_alculation_method":`Berekeningsmethode`,
"label.uploadfile":`Bestand uploaden`,
"label.ems.otheraccount":`Andere rekening`,
"vue_label_commonobjects_detail_group_opportunitystrategy":`Weet je zeker dat je bij dit team wilt`,
"message.error.chatter.img.nodata":`Fout: het beeldbestand bestaat niet en kan niet worden vastgelegd.`,
"component.chatter.file.button.files":`Selecteer een document`,
"label.salescloud.teamrole.optionlist.choose.null":`De naam van de rol is verplicht`,
"label.yourexportsuc":`Uw exportverzoek is verwerkt, gelieve uw e-mail te bekijken.`,
"pagecreator_systemstyle_label_modifycolor":`Kleur bewerken`,
"label_partner_setup_title":`Instellingen`,
"label.chat.topic.topic":`Onderwerp`,
"file.error.nottype":`Fout: ongeldig type. bestandstypen die kunnen worden geüpload zijn txt, doc, excel, ppt, pdf, jpg, jpeg!`,
"label.all_time":`Alle Tijden`,
"homepage_componet_approval_label":`Goed te keuren punten`,
"label.partnerCloud.financeSetting.merchantNumber":`WeChat Pay Handelaar Nr.`,
"label.user.resetpw":`Reset Wachtwoord`,
"label.exchange.sync1":`Nadat u een serviceaccount met impersonatiemachtigingen voor de gebruikers in Microsoft©Exchange hebt ingesteld, voert u de serviceaccountreferenties in om CloudCC te laten communiceren met de Exchange-server.`,
"label.import.index.editfield":`Veldtoewijzing bewerken`,
"and":`En`,
"label.partnerCloud.cloudInfrastructure":`Partner Cloud Basisinstellingen`,
"label.escalation.setup.newentries.createdate":`Wanneer de zaak is gemaakt`,
"Pagelayout.Setup.002":`U heeft 3 gerelateerde lijsten geselecteerd, en het toevoegen van meer gerelateerde lijsten zal de pagina layout beïnvloeden.`,
"label.customfields.file.tip":`Laat de gebruiker een bestand uploaden tussen 1 en N.`,
"label.tianyancha.businessverify.accname":`Opvragen van klantnamen in real time`,
"label.Additional.Conditions":`Filter service afspraak volgens aanvullende voorwaarden.`,
"label.emailtocloudcc.filed.type":`Aanbieder`,
"vue_label_homepage_fixedcomponents":`Standaardcomponent`,
"label.visualpage.delerror":`Verwijderen mislukt, probeer het later nog eens.`,
"label.tabpage.filetypez":`Bestandstype`,
"label.emailobject.search.input":`Zoeken op`,
"label.createprocessstep2":`Stap 2: Ingangscriteria specificeren`,
"label.weixin.inhead":`Verwerking`,
"component.recdetail.label.title":`Gedetailleerde informatie`,
"label.weixin.telephone":`Telefoonnummer`,
"label.web.link":`Weblink`,
"label.partnerCloud.paySuccess":`Met succes betaald`,
"label.case.adress.link":`Web van Klantendienst Portaal`,
"label.emailobject.view.connectopp":`Emails in verband met open kansen`,
"front-kefu-moudle-think-again":`Laat me nog eens denken`,
"label.Button":`Knop`,
"chatter.pt.most":`De maximale bestandsgrootte is 20 MB.`,
"label.service.newBuildDialog.numberdays.horizontal":`Dagen voor peildatum`,
"label.ems.relatedobj":`Verwant object`,
"label.notification.insert.approval":`[提交人] legt [对象] voor aan uw goedkeuring`,
"label.setting.codeSet":`Code Set`,
"vue_label_report_rowlevelformula":`Formule op rij-niveau`,
"label.validate.function.funcFormat.TIMENOW":`TIMENOW()`,
"label.copyright":`Copyright © 2008-2022 CloudCC Inc. Alle rechten voorbehouden.`,
"component.setup.button.save":`Save`,
"label.emailsync.button.sure":`Bevestig`,
"label.multilang.dupicatecheck.getdatalist":`De {0}-de groep van gedupliceerde gegevens, heeft een totaal van {1} records:`,
"label.ccchat.person.invite.tochat":`Nodig mensen uit voor CCChat`,
"label_partner_all_maxNum":`Maximum gegevens van partner cloud:`,
"label.checkfield":`Veldinstellingen voor het vinden van duplicaten`,
"label.sales.dashboard.income":`Inkomsten Doel`,
"label.setup":`Setup`,
"label.dashboardSetup.center":`Midden`,
"lable.quote.syncing.finished":`Synchronisatie voltooid`,
"vue_label_helpcenter_dashboard1":`Om u te helpen statistische gegevens intuïtiever weer te geven, biedt CloudCC Sales Cloud Lightning dashboard u krachtige grafiekproductiemogelijkheden.<br> CloudCC Sales Cloud Lightning versie dashboard heeft de volgende kenmerken<br>In staat om verschillende gegevensbronnen te gebruiken: u kunt de originele gegevens in een weergave onder het object selecteren als de gegevensbron, of u kunt de gegevens nadat het rapport is verwerkt selecteren als de gegevensbron<br>Maar liefst 13 soorten grafieksjablonen die u kunt kiezen: ondersteuning van verkooptrechter, wijzer meter, taartdiagram, secundair gegroepeerd histogram, enz. <br> Vrijelijk slepen en neerzetten om de grootte en positie van de grafiek te veranderen: het dashboard kan onderscheid maken tussen belangrijke gegevens en ondersteunende gegevens door de positie en grootte van verschillende grafieken te plaatsen, die volledig aan u zijn<br>Dashboard algemene filtering: Het dashboard ondersteunt het filteren van de ingebouwde grafiekgegevens met filtervelden die zijn ingesteld op tijdbereik en gebruiker<br>Data caching: Dashboard grafiekgegevens kunnen worden gecached wanneer het voor het eerst wordt gemaakt, waardoor de secundaire laadtijd wordt verminderd. <br>Indringen in onderdelen: U kunt naar de overeenkomstige rapportdetails of de recordlijst in de overeenkomstige weergave van het object springen door op de component te klikken<br>Componentkoppeling: In hetzelfde dashboard kan een component andere componenten van dezelfde gegevensbron instellen om met zichzelf te interageren. Door op het gegevensgebied in de component te klikken, kunnen andere componenten worden ingesteld om de gegevens opnieuw te tellen volgens de filtervoorwaarden van dit gegevensgebied<br> 1. Maak een nieuw dashboard<br> Als vertegenwoordiger of manager van de verkoopafdeling kunt u uw verkoopgegevens weergeven door dashboards te maken. De Lightning versie van CloudCC Sales Cloud biedt rijke mogelijkheden om dashboards te maken<br>Note: De gegevens van de Lightning versie van het dashboard en de oude versie van het dashboard zijn niet interoperabel. <br> Klik op het tabblad "Dashboard", klik op "Nieuw Dashboard", vul de naam van het dashboard in en selecteer de map waarin u dit dashboard wilt opslaan. U kunt een nieuw dashboard invoeren.`,
"label.layout.availabletab.trackrecord":`Track Records`,
"label.campaignmember.main.deletecontact":`Verwijder leden-bestaande contacten`,
"lable.outlook.mcto.emaltoc":`Wanneer e-mails worden verzonden naar CloudCC.com`,
"label.setup.mobile.offlinecache.savesuccess":`Offline cache-instellingen zijn succesvol opgeslagen.`,
"label.timezone.default":`Standaard tijdzone`,
"label.noRules.have.been.enabled":`Geen ingeschakelde regels.`,
"label.ccchat.person.invite.existsend":`Sommige van de e-mailadressen die u hebt ingevoerd, komen overeen met bestaande gebruikers.`,
"label.work":`Werk`,
"actualstarttime.actualendtime.time.illegal":`De werkelijke begintijd van de dienstafspraak moet kleiner zijn dan of gelijk aan de werkelijke eindtijd.`,
"lable.product.stsp":`Setup Standaard Prijs`,
"vue_label_normal_account_sf":`Rekening`,
"label.finishpic":`Gegenereerde grafieken`,
"label.h5.similar.opportunity.step3":`Stap 3 Selecteer velden om weer te geven voor gelijkaardige opportuniteiten`,
"label.relateobjDefault":`Standaardopname`,
"label.customcomponent.check.tag.endwith":`Component moet eindigen met het label`,
"label.related.organization":`Verwante kans`,
"label.recordtype.edit.selectvalue.orderby":`Optie Lijst Waarde Sorteren`,
"vue_label_homepage_enter_name":`Voer een naam in`,
"label.permission.group":`Machtigingsgroepen`,
"label.emailobject.send":`Stuur`,
"label.ralateuser":`Verwante gebruikers`,
"label.validate.function.funcFormat.ADDMONTHS":`ADDMONTHS(datum,num)`,
"label.tablayoutedit.remark2":`Selecteer de velden op het tabblad startpagina.`,
"setup_mainpage_label_welcome3":`Het maken van formulieren in het CloudCC cloud-platform is gebaseerd op aangepaste databases (objecten). Gebruikersgedefinieerde objecten zijn databasetabellen waarin gegevens worden opgeslagen die specifiek zijn voor uw organisatie. Tabel-naar-tabel relaties kunnen eenvoudig worden gelegd zonder enige programma-ontwikkeling.`,
"label.user.notallowed.login.scope":`U mag niet inloggen binnen het tijdsbestek of uw IP-adres is beperkt.`,
"label.tel.ten.case":`U kunt tot 10 telefoonnummers invoeren om meldingen te ontvangen, elk nummer wordt gescheiden door ",".`,
"front-kefu-moudle-v1-user-info":`Informatie voor de gebruiker`,
"label.aboutme":`Over mij`,
"label.setfieldediting.tip":`Wanneer u goedkeuringsstappen definieert, kunt u goedkeuringsverzoeken aan verschillende gebruikers toewijzen. Een van uw opties is om een gebruikersveld te gebruiken om deze verzoeken automatisch te routeren. Als u deze optie voor een van uw goedkeuringsstappen wilt gebruiken, selecteert u een veld uit de onderstaande keuzelijst. Wanneer een record zich in het goedkeuringsproces bevindt, zal het altijd vergrendeld zijn - alleen een beheerder zal het kunnen bewerken. U kunt er echter voor kiezen om ook de momenteel toegewezen goedkeurder de mogelijkheid te geven de record te bewerken.`,
"label.existing_dashboard":`Toevoegen aan bestaand dashboard`,
"label.sendemail.spotsign":`Beste #naam: het campagnelid #klant dat u heeft uitgenodigd voor de #activiteit is aangekomen en heeft zich aangemeld, gelieve te noteren dat.`,
"UG_solution_01":`Bied de oplossing`,
"label.tianyancha.estiblishtime":`Tijd instellen`,
"label.pc.lightningpage":`Lichtgewicht toepassing (beta)`,
"label.saveAndSync":`Opslaan en synchroniseren`,
"label.state.end":`Voltooid`,
"label.sendemail.queue.assigninfo":`Queues:[#queueName] heeft #objectName: #recordName`,
"label.approvalprocessname":`Goedkeuringsproces Naam`,
"label.view.conditions.message":`Gefilterd door {!voorwaarden}`,
"label.partnerCloud.financeSetting.alipayCorporate":`Alipay Business Account`,
"label.forecast.detailforecast.de":`s`,
"label.savepayset.failure.nopay":`Configureer ten minste één online betaalrekening`,
"label.step1.total6":`Stap 1 van 6`,
"label.appointment.wizard.subtitle4-1-3":`45 min.`,
"label.emailobject.markasread":`Markeer als gelezen`,
"message.error.orgid.null":`orgid kan niet null zijn!`,
"label.emailtemplate.mergefield":`Waarde samengevoegd veld`,
"label.weixin.recent.list":`Onlangs bekeken lijsten`,
"label.emailsync.form.email":`E-mail`,
"label.funnel":`Trechter`,
"label.logintime.clear":`Duidelijke tijd`,
"label.chatter.followed":`Gevolgd door`,
"label.ccpeak.function.field.spack":`Velden in een functie moeten aan beide zijden een sapces hebben.`,
"label.setup.mobile.offlinecache.remark":`Na het inschakelen van deze functie, kunnen leden van de organisatie records maken, bewerken en verwijderen terwijl ze offline zijn met mobiele apparaten`,
"label.product.function":`Pakketcategorieën`,
"label.icon.14":`Hamer`,
"message.report.nodata":`Er zijn geen gegevens teruggestuurd.`,
"label.please.ChooseMin":`Kies ten minste {een} productopties`,
"label.tabpage.releaseTourz":`Gids publiceren`,
"vue_label_chat_opportunity":`Opportunity-team`,
"vue_label_chatter_refucecertification":`Weet je zeker dat je "{naam}" weigert om mee te doen aan de team chat?`,
"label.version.unlimited":`Onbeperkt`,
"label.processsetting.enable.prompt":`Na het inschakelen zal het pad naar de instellingen in de detailpagina staan die overeenkomt met de bliksem versie. U kunt ook eerst de instellingen opslaan en later inschakelen.`,
"label.page.display.property":`Weergave-eigenschappen`,
"label.service.appointmentList.thisOption":`Ongecontroleerd`,
"label.register.date":`Registratie Datum`,
"label.brief.contract.amount":`Contractbedrag`,
"setup.object.field.dependency.label.actionfieldnotnull":`Selecteer eerst een controlerend veld.`,
"UG_homepage_009":`Toegang CRM`,
"label.icon.98":`Map`,
"label.weixin.datacount":`Totaal`,
"label.mobile.hasbind":`Dit mobiele nummer is gebruikt. De laatste binding zal worden vrijgegeven als u doorgaat met binden.`,
"label.emailtemplate.choosemorecontacts":`Selecteer meer ontvangers`,
"setup_layout_button_deleteitem":`Verwijder de geselecteerde items`,
"vue_label_account_collection_plan":`Onverwerkt inzamelingsplan`,
"label_chatter_maturiyDate":`Verloopdatum`,
"label.emailtocloudcc.license":`Licentie`,
"vue_label_checkduplicate_complete_check_rules":`Vul alstublieft de regels voor dubbele controle in`,
"chatter.up.type":`U kunt een jpg-, gif- of png-bestand uploaden.`,
"label.attendance.nocheckout":`Niet uitchecken`,
"label.setup.mobile.offlinecache.remark2":`De geselecteerde tabbladen zullen worden ingeschakeld op de mobiele apparaten van alle gebruikers in uw organisatie als de standaard offline cache-tabbladen. Elke gebruiker kan de offline cache-tabbladen van de organisatorische instellingen uitschakelen, of andere tabbladen inschakelen als offline cache-tabbladen, afhankelijk van hun behoeften.`,
"template.report.count.marketing.activities":`Totaal Campagne`,
"label.multilingual.tip4":`Als meertaligheid is uitgeschakeld, wordt de standaardbedrijfstaal ingesteld op Chinees of Engels op basis van het bedrijfsadres, en wordt de taal van alle gebruikers ingesteld op de standaardbedrijfstaal.`,
"label.settings_area":`Instellingen`,
"label_assessment_content":`Inhoud van de beoordeling`,
"label.top":`Top`,
"UG.Account.06":`Maak een account aan`,
"label.emailtocloudcc.step1.case2":`Zodra dit is geconfigureerd, worden e-mails die in deze postbus zijn ontvangen automatisch geregistreerd als zaakrecords in CloudCC. Afhankelijk van de contactpersoon en account in de outbox, worden de zaken gekoppeld aan de corresponderende contactpersoon en account, zodat de acceptatie en het volgen van zaken wordt vergemakkelijkt.`,
"label.forecast.forehistory.best.remark":`Best Case Notes`,
"label.project.problem.date":`De uitgiftedatum moet vallen binnen het datumbereik van de mijlpaal of het project waartoe hij behoort.`,
"label.forecast.customforecast.foredis.wzs":`Volledige nummers`,
"message.setup.field.name.value.notexists":`De waarde van de teamrollijst die u hebt ingevoerd, bestaat niet. Voer deze opnieuw in.`,
"label.salescloud.teamrole.opportunity.organization":`Teamleden hebben mogelijk meer toegang tot deze opportuniteit dan de standaard toegangsinstellingen van uw organisatie.`,
"label.sms.message.input":`Geef het bericht`,
"label.document.type.not.allow":`Dit documenttype kan niet worden geüpload.`,
"label.customfields.totalsummary.tip":`Een alleen-lezen veld dat de som, minimum- of maximumwaarde van een veld in een verwante lijst of het recordtotaal van alle records in een verwante lijst weergeeft.`,
"label.tabpage.filesizez":`Bestandsgrootte`,
"label.import.page2.filedname":`Bestandsnaam`,
"label.same.analyze":`Mijn gelijkaardige opportuniteitsanalyse`,
"label.service.gantt.refreshData":`Update gegevens na het verversen van de pagina.`,
"label.sendsms.batch.step2.sendbycontext":`Stuur door aangepaste SMS-inhoud`,
"UG_Account_05":`Contactstructuurdiagram`,
"label_emailtocloudcc_step1total3":`Stap 1 van 3`,
"label.weixin.no.history":`Geen antecedenten`,
"label.datamanage.queryfield.error":`Fout in queryveld.`,
"label.emailmerge.mergeFolder.emailmerge":`Mail Merge sjablonen`,
"label.workflow.estimatecondition":`Evaluatie Criteria`,
"label.autonumberfield.wrong":`Voer een nummer in van 0-{0}`,
"label.data.setok.t.desc1":`Als u deze sjabloon afgeleide gegevens wilt gebruiken, klik dan op`,
"label.data.downpage.i.title":`Stappen voor het importeren van gegevens:`,
"label.data.downpage.i_list.desc2":`Nadat de gegevens zijn geïmporteerd, ontvangt u een e-mail om u eraan te herinneren dat de import is gelukt.`,
"label.opportunity.jieduan":`Huidig stadium`,
"vue_label_commonobjects_view_sumby":`Geaggregeerde methode`,
"label.knowledge.setting.hint.three":`Wij kunnen u voorbereiden op de operatie. Dit is wat u nodig heeft om het op te zetten:`,
"page.activity.history":`Activiteit Geschiedenis`,
"label.cancelQuoteLineGroup":`Annuleren offerte lijngroep`,
"label.addattachment.batch.step3":`Stap 3 klik op de knop om te eindigen.`,
"label.chat.topic.follow":`Ik wil  volgen.`,
"label.import.page1.uploadcsvfiled":`Slepen of klikken om CSV-bestand te uploaden`,
"label.batchtransfer.datetype.tip":`Voor datumvelden, voer de waarde in in het volgende formaat:`,
"vue_label_systemSettings_application_util":`Console voor toepassingsbeheer`,
"label.partner.workspace.member.selectedpermission":`Geselecteerde toestemmingen set`,
"label.service.appointmentList.plansToEnd":`Einde plan`,
"label.industrialandcommercialverification.contactinformation":`Bel voor aankoop of vragen 400-642-2008`,
"chatter.del.p":`Verwijder dit bericht.`,
"label.forecast.customforecast.replacefirst":`Overruled door mij`,
"Lead.Scoring.Setting.Rule.Setup.RuleName":`Score regel naam`,
"label.weixin.appr.applicant":`Ingediend door`,
"component_event_label_calendar":`Bekijk kalender`,
"step":`Stap`,
"label.attendance.setting.position.alert":`Office Worker moet de plaats van het oriëntatiepunt bepalen.`,
"label.end":`Voltooid`,
"label.mobile.change.owner.success":`veranderd naar de nieuwe eigenaar`,
"label.chinese":`Chinees`,
"label.textmessage.vonage.account":`Rekeninginformatie`,
"front-console-no-related-contact":`Associeer eerst met contact`,
"label.dashboardSetup.seltype":`Optioneel onderdelentype`,
"chatter.follow.user":`Volg deze gebruiker`,
"label.textmessage.sentsuccess":`Succesvol verzonden`,
"label.australian.gentral.standard.time":`Australische Centrale Daglichttijd （Zuid Australië）`,
"label.validate.function.funcFormat.AND":`AND(logisch1,logisch2,...)`,
"lable.SalesCommitmentKanBan.contract":`Ondertekend`,
"label.processsetting.basic.settings":`Basisinstelling`,
"label.escalation.setup.newentries.ifcondtions":`Voer deze regel uit als de`,
"label.lookup.nofound.data":`De waarde bestaat niet of komt niet overeen met het filter.`,
"vue_label_commonobjects_view_chart_chartname":`Grafiek Naam`,
"label.dashboard.show.percent":`Toon %`,
"label.sso.saml.sp.userid":`Gebruikers-ID`,
"label_tabpage_minutesagoz":`minuten`,
"vue_label_chatter_comment_content":`Geef commentaar inhoud`,
"label.campaign.channel.step6.mobilepc":`Genereer mobiele en PC pagina`,
"vue_label_homepage_editprofilepage":`Bewerk naam`,
"label.tabpage.crecordtypez":`Type record wijzigen`,
"label.social.posts.type.null":`Het posttype kan niet leeg zijn`,
"label.projectManagement.groupbyuser":`Groeperen op gebruikers`,
"vue_label_email_new_template":`Opslaan als een nieuw sjabloon`,
"label.ems.close":`Annuleren`,
"label.ccdocument.noauthority.folder":`Je hebt geen toestemming om deze map te bedienen.`,
"message.filterconditionerror":`<strong>Fout: </strong> Uw filter heeft de filtervoorwaarden verkeerd vermeld:`,
"label.User.Interface":`Gebruikersinterface`,
"label_tabpage_greaterz":`Groter dan`,
"vue_label_CCChat_unfollow":`Unfollow`,
"label.selectandcontinue":`Kiezen en doorgaan`,
"vue_label_commonobjects_detail_influence":`Invloed`,
"label.total.have.priority":`vooraf is`,
"label.manageAll.sta4":`Terugroepen`,
"label.setup.mobile.offlinecache.setup":`Offline cache-instellingen aan mobiele zijde`,
"vue_label_chatter_cancel_adding":`Annuleren`,
"vue_label_lead_select_existing":`Kies bestaand`,
"front-epwechat-module-v1-contacts-sync":`Synchroniseer WeCom Contacten`,
"label.appupload.component.type.recordtype":`Record Soorten`,
"label.layout.hint":`Deze pagina is niet beschikbaar voor preview. Gelieve op te slaan en te bekijken op de voorgrond pagina.`,
"label.change":`Verander`,
"setup_layout_label_detailpage":`Detail Pagina`,
"label.imgfield.use.tip":`img(docid,width,height), deze functie wordt gebruikt om afbeeldingen uit te voeren, "docid" is de document ID, "width" stelt de breedte van de afbeelding in (Integer type kan null zijn), "height" stelt de hoogte van de afbeelding in (Integer type kan null zijn).`,
"pagecreator.systemstyle.button.edit":`Bewerk stijl`,
"label.delete_externalpage":`Het ' ' dat u wilt verwijderen kan niet worden teruggetrokken, gelieve opnieuw te bevestigen. Het formulier wordt niet gebruikt op een login pagina, maar kan elders gebruikt worden. U kunt bijvoorbeeld de embedcode hebben gebruikt om het in een externe pagina in te voegen.`,
"font-evaluate-module-v1-open-case":`Heropen de zaak:`,
"label_not_adjust":`Geen aanpassing`,
"vue_label_title_ordernow":`Bestel nu`,
"label.notification.serviceappointment.allocation":`Er is een nieuwe werkorder {0} naar u verzonden, controleer deze a.u.b.`,
"label.objectRelationshipDescription2":`. U kunt bepalen welke gerelateerde records van andere objecten worden geretourneerd in rapportresultaten door een relatie tot een ander object te kiezen.`,
"vue_label_calendar_notice_createfail":`Kan geen kalender maken`,
"label.ems.step1":`Stap 1`,
"label.ems.password":`Wachtwoord`,
"label.icon.143":`Spaarvarken`,
"label.select.year":`Kies Jaar`,
"label.termsforusage.dialog":`Gebruiksvoorwaarden (Nieuw venster)`,
"label.tag.addtags.create":`Maak`,
"label.emailobject.groupemail.msg4":`wordt niet verzonden vanwege een ongeldig e-mailadres.`,
"label.version.sum.autonumberfield":`auto nummer veld(en)`,
"label.projectManagement.unallocated.time":`Niet-toegewezen tijd`,
"PageLayout.Search.MultiSearch.002":`Aangepast zoekvak inschakelen (Enkel veld zoeken)`,
"label.icon.150":`VR`,
"label.SMS.edit":`SMS Melding Bewerken`,
"Opportunity.Detailed.Phase.Label.003":`Veranderingsfase`,
"vue_label_helpcenter_all":`1. Algemeen zoeken<br> Algemeen zoeken is een hulpmiddel om snel te vinden wat u nodig hebt. <br>?Voer trefwoorden in het zoekveld in de navigatiebalk boven aan de pagina. Tijdens het invoerproces zal het systeem in real time relevante inhoud aanbevelen op basis van de door u ingevoerde inhoud; <br>?Klik op "Zoeken" of druk direct op de Enter toets op het toetsenbord om de pagina met zoekresultaten te openen; <br>?In de resultatenpagina kunt u filteren op het object aan de linkerkant om de lijst met zoekresultaten onder dat object te bekijken. In de resultatenlijst worden maximaal 10 records voor u aanbevolen. U kunt op "Meer weergeven" klikken om de lijst van dit object te openen en meer zoekresultaten te zien; <br>Note: Het systeem zoekt standaard op "offerte", "klant", "lead", "zakelijke mogelijkheid", "marketing activiteit", "contract", "product", "service aanvraag", "taak" en "gebeurtenis". <br> 2. Snel aanmaken<br> Klik op " " in de navigatiebalk, en u kunt het object dat u wilt aanmaken selecteren in het uitklapvenster. <br> 3. Mijn Centrum<br> Klik op de avatar aan de rechterkant van de navigatiebalk om het venster Mijn Centrum te openen. De volgende functies zijn beschikbaar: <br>?Snel naar de persoonlijke instellingen pagina, batch import en prullenbak ingang; <br>?Als u in de proefperiode zit, klik dan op "Bestel Nu" om snel naar de Cloud CC bestelpagina te gaan; <br>?Klik op een versie om snel te wisselen; <br>?Log uit. <br> 4. Menu<br> Sommige menu-objecten worden u aanbevolen in de menubalk. U kunt op een menu klikken om snel naar de pagina te gaan. U kunt ook alle menu's bekijken en instellen dat de meest gebruikte menu's in de menubalk worden getoond. <br>Alle menu's: Klik op "Meer", en klik op "Alle menu's" onder in het uitklapmenu; <br>?Mijn menu aanpassen: Klik op de knop aan de rechterkant van het menu om het venster met aangepaste menu's te openen en stel in alle menu's de gemeenschappelijke menu's in die u in de menubalk wilt weergeven. <br> 5. Applicatie Start Centrum<br> Klik op het pictogram aan de rechterkant van de menubalk om snel over te schakelen naar de systeembeheerder om andere applicatiediensten voor u in te stellen. <br>Noot: Een applicatie is een verzameling van een reeks functionele modules (zoals lead management, business opportunities, contract management, etc.) die kunnen worden gebruikt om aan specifieke bedrijfsbehoeften te voldoen.`,
"label.summaryreport.2018.step5.new":`Stap 5 Kies rapportcriteria`,
"label.weixin.id":`Nummer`,
"chatter.pu.mess":`post(en)`,
"label.weixin.lookup.record":`Records vinden`,
"label.ServiceCloud.statistics.by.address":`Statistieken per adres`,
"label.jixiaoswitchoff":`Instorten`,
"label.savealipay.failure":`Kan informatie over Alipay-handelaar niet opslaan`,
"template.chart.khdqfb":`Rekeningen Regionale Distributie`,
"front-email-payment-immediate-payment":`Betaal nu`,
"label.dashboard.unit5":`Eenheid: 100 miljoen`,
"label.tabpage.greaterz":`Groter dan`,
"vue_label_calendar_stop_sharing_calendar":`Stop met het delen van de kalender`,
"label.projectManagement.allhours":`Alle (uren)`,
"label.currency":`Valuta`,
"label_vue_create_edit_obj_create_event_dialog_title":`Herhaalde schema's Herinnering`,
"front-template-V1-templateSetting":`Sjabloon instellen`,
"label.dashboard.away.condition":`Ingestorte toestand`,
"label.replacelayout":`Pagina-indeling vervangen`,
"label.permission.detail.system.setting.tip":`Voer de bewerking uit die op de apps is toegepast. Bijvoorbeeld: wijzig machtigingen voor alle gegevens`,
"label.customfield.delete.prompt":`Aangepast veld Label`,
"label.add":`Toevoegen`,
"label.deputationalsoapprove":`De gedelegeerde goedkeurder kan dit verzoek ook goedkeuren`,
"label.leave_nosave":`Na vertrek worden de huidige gegevens niet opgeslagen.`,
"label.tianyancha.title":`TianYanCha`,
"vue_label_pool_restore":`Herstel`,
"chatter.feed.menutype.feed.markcom":`Bladwijzer`,
"label.query.data.error":`Mislukt bij het opvragen van verwante lijsten`,
"label.pc.ui.2018.unpin":`Unpin`,
"label.partner.template.memo":`Titel`,
"label.weixin.cannot.gain.userinformation":`Kan gebruikersinformatie niet verkrijgen.`,
"label.stdashbord.xsld.department":`Afdeling`,
"label.service.ganttBaiduMap.scheduled.starttime":`Geplande starttijd`,
"label.documentforms":`Documenten`,
"label.operator.insert":`Operator invoegen`,
"label.processsetting.select.five.fields":`Er kunnen maximaal 5 velden worden geselecteerd.`,
"label.weixin.password":`Wachtwoord`,
"vue_label_chatter_share_followers":`Deel met volgers`,
"label.brief.baifang":`Bezoeken`,
"label.emailobject.track.unopen":`Ongeopend`,
"label.sendmail.immediately":`Nu verzenden`,
"label.partnerCloud.payTheAmount":`Bedrag van de betaling`,
"label.integrations.mailchimp.connect":`Verbind CloudCC met uw account`,
"label.datamove.record.sucessfully":`record(s) succesvol overgedragen.`,
"lable.outlook.edit.allocation":`Gebruikers en profielen toewijzen`,
"label.chosesubject.talk":`Plan een gesprek`,
"label.escalation.setup.entrydetail.escalation.time":`Escaleer bij`,
"label.projectManagement.must.be.less.than.24.hours":`Minder dan 24 uur`,
"setup_mainpage_label_welcome15":`CloudCC Cloud Platform workflowregels automatiseren het ondersteuningsproces voor uw verkoop, marketing en meer. Afhankelijk van een voorgedefinieerde set regels kunnen records automatisch aan gebruikers worden toegewezen of van de ene gebruiker naar de andere worden geconverteerd. Het belangrijkste voordeel van workflowbeheer is het verbeteren van de werkefficiëntie door het elimineren van veel onnodige handelingen bij het bijwerken van records, en het verbeteren van de bedrijfsverwerkingsniveaus en het optimaliseren van controleprocessen door het standaardiseren van werkmethoden en het verlagen van operationele kosten. Het ondersteunt onbeperkte oneindige goedkeuring voor elk object, en kan herinneringse-mail, SMS-herinnering, taak, veldupdate en andere functies triggeren.`,
"label.mobile.phone.week.plan2":`Deze week`,
"label.add.newAsset":`Nieuwe aanwinst`,
"vue_label_salesadvance_losts":`Verlies aantal`,
"vue_label_report_editcolumn":`Kolom Bewerken`,
"vue_label_homepage_assignedtasks":`Toegewezen taken`,
"label.posting_from":`Gepubliceerd door`,
"year":`Jaar`,
"label.autoRegister.changepwd.setpwd.tip.letter":`Tenminste één letter`,
"label.version.nonsupport.feature.staticresource":`Deze functie wordt tijdelijk niet ondersteund. Wacht op de upgrade voordat u hem gebruikt.`,
"label.toleadmyclientandlinkman":`Mijn rekeningen en contacten importeren`,
"label.appupload.install.processcrash":`De conflicten oplossen`,
"label.profile.setstandardtab":`Standaard tabblad Instellingen`,
"template.chart.khhyfx":`Analyse accountsector`,
"label.reportTypcrtC":`Bijbehorend object (c) gelieve te klikken om verwant object te selecteren`,
"vue_label_report_mayormaynothave":`Het bovenliggende object kan al dan niet records hebben die betrekking hebben op dit object`,
"label.service.gantt.plan.recommendation":`Aanbevolen schema`,
"label.version.sum.lookupfield":`lookup relatievelden`,
"label.builder":`Pagina bouwer`,
"label.sharerule.remark":`Specificeer het delen van dit record. U kunt de records en gerelateerde gegevens delen met de gebruiker, rol, rol en ondergeschikten, gebruikers in een gebied, gebruikers in het gebied en subgebied.  Individueel delen kan alleen worden gebruikt om bredere toegang tot gegevens te verlenen, niet om de toegang te beperken.`,
"vue_label_email_benn_added":`De postbus is toegevoegd`,
"label.version.allow.sum":`Indien nodig, gelieve CloudCC versie te upgraden.`,
"label.icon.130":`Valuta`,
"label.custom.new":`Nieuw`,
"label.see_allfields":`Bekijk alle velden`,
"front-marketing-module-v1-share-poster":`Deel Poster`,
"label.service.one":`Uw filter verwijst naar ongedefinieerde filtervoorwaarden:`,
"lable.outlook.edit.alprec":`Altijd de voorkeur aan CloudCC.com`,
"Account_News_Setting_001":`Account Instellingen`,
"label.mr.caption.opportunity.result":`Duplicaten zoeken en samenvoegen: Resultaten voor het zoeken naar duplicaten van Opportunities`,
"label.forbidden":`Uitschakelen`,
"label.query.detail.openpartner":`Inschakelen als partner gebruiker`,
"label.session_date":`Zitting Datum`,
"label.forecast.customforecast.submit.deyuce":`Voorspelling`,
"label.emailtocloudcc.filed.server":`Server`,
"label.emailtocloudcc.tip2":`Na het verwijderen, zult u niet in staat zijn om E-mail naar CloudCC te gebruiken, bent u zeker dat u wilt verwijderen?`,
"pagecreator_layout_message_delete_fail":`Verwijdering van lay-out mislukt`,
"front-lightning-module-v1-dashborad-export-PDF":`PDF exporteren`,
"lable.quote.syncing.syncingto":`Offerte-regelitems zijn gesynchroniseerd met opportuniteitsproducten`,
"message.error.view.lastview.update":`De laatste openbare lijstweergave kan niet worden verwijderd</br>U kunt de zichtbaarheid van de laatste openbare lijstweergave niet wijzigen van "Zichtbaar voor alle gebruikers" in "Alleen zichtbaar voor mij"<br><br>`,
"label.weixin.select.one":`Kies ten minste één`,
"label.projectManagement.Pleaseenterprojectname":`Voer de naam van het project in...`,
"label.data.downpage.e_list.desc1":`Deze pagina toont succesvol geëxporteerde bestanden. Download de geëxporteerde bestanden op tijd volgens de download link in uw e-mail.`,
"label_tabpage_notexceed25":`De geselecteerde plaat mag niet meer dan 25`,
"label.campaign.channel.step5.remark":`U bent klaar met het opzetten van de registratiepagina.`,
"label.setup.mobile.bottombutton.profile.prompt":`Tips: aangepaste bodem menu van het profiel zal overschrijven het bedrijf bodem menu verenigd instellingen`,
"label.stdashbord.xsld.business.knx":`Waarschijnlijkheid`,
"label.setemailtip":`Creëer een e-mail alert om te koppelen aan één of meer workflow regels of goedkeuringsprocessen. Bij het wijzigen van een e-mail alert, zullen alle wijzigingen van toepassing zijn op alle regels of goedkeuringen die eraan gekoppeld zijn.`,
"report.button.go":`Ga naar`,
"lable.the.united.arab.emirates":`De gegevens zijn ontvangen.`,
"label.writer. name.file":`Gelieve de bestandsnaam van de offerte in te vullen`,
"label.validate.function.funcExplain.ADDMONTHS":`Tel het aantal maanden bij de datum op, gebruik makend van de laatste datum van de maand als datum de laatste dag van de maand is of als het aantal maanden minder dagen telt.`,
"vue_label_chatter_enter_shared_content":`Gelieve gedeelde inhoud in te voeren`,
"message.lookup.condition":`Zoekcriteria moeten meer dan één teken bevatten`,
"vue_label_commonobjects_detail_customers":`Klanten die externe gebruikers permanent uitschakelen zullen alle externe gebruikers verbannen die geassocieerd zijn met de klant en ze verwijderen van alle gemeenschappen, groepen, teams, toestemmingen sets, en het delen van regels die aan hen zijn gekoppeld. Tegelijkertijd zullen de rollen en groepen die aan de account zijn gekoppeld permanent worden verwijderd en niet in de prullenbak verschijnen. Weet u het zeker?`,
"label.emailobject.view.all":`Alle e-mails`,
"vue_label_file_size_limit_new":`Uploaden mislukt. De bijlage overschrijdt {size}M.`,
"front-gantt-module-please-reorder-milestones":`Voer een geldig nummer in om mijlpalen te herbestellen`,
"label.escalation.setup.entrydetail.escalation.assingTemplate":`E-mail`,
"label.namespaceprefix":`Namespace Voorvoegsel`,
"label.ems.delete.success":`Succesvol wissen`,
"label.partnerCloud.financeSetting.setWechatPay":`WeChat Pay instellen`,
"front-epwechat-module-v1-input-token":`Voer Token in`,
"setup_object_field_dependency_button_setdependency":`Veld Afhankelijkheid Instellingen`,
"chatter.group.request01":`Verzoek(en)`,
"message.error.field.number.length":`De lengte van het door u ingevoerde formaat fout.`,
"label.tabpage.lessz":`Minder dan`,
"vue_label_notice_uploadavatar_format":`De geüploade avatarafbeelding mag alleen in JPG/PNG/GIF-formaat zijn`,
"label.project.hit.thirteen":`Dagelijkse Mijlpaal Herinnering`,
"frame_personinfo_label_usethisimage":`We zullen variaties van deze miniatuurafbeelding in de applicatie gebruiken.`,
"label.startuploadfile.step":`Anders niet succesvol uploaden van bestanden zal worden weergegeven in het bovenste gebied, moeten worden verwijderd, kies dan een nieuw bestand.`,
"component_assistant_label_overduetask":`Kansen met achterstallige taken`,
"label.partnerCloud.financeSetting.information":`Hoe kan ik abonnementsinformatie van Alipay instellen?`,
"label.appupload.install.package.component":`Pakketonderdelen`,
"label.emailobject.emaildetail.nextactivity.task":`Taak toevoegen`,
"vue_label_chatter_edit_post":`Post bewerken`,
"label.appupload.upload.logo":`Icoon`,
"label.role.selecteduser":`Geselecteerde gebruikers`,
"label.letter.assign":`Specificeer de inhoud van de uitnodiging`,
"label.forecast.shrepage.title":`Details voor het delen van prognoses`,
"lable.Generate.service.appointment":`Service afspraken gegenereerd per werkorder regel`,
"label.productsales.nodata":`Geen gegevens`,
"vue_label_email_Please_select_at_least_one_email":`Selecteer ten minste één e-mail`,
"label.data.downpage.i_title.num4":`4. Indien u een lookup relatieveld en een master-detail relatieveld hebt in het object dat u wilt importeren, moet de waarde voor dat veld ID zijn, anders is het ongeldig.`,
"label.new.exchagecurrency":`Nieuwe wisselkoersen`,
"label.layout.listtip":`De onderstaande tabel toont de pagina-indeling voor verschillende profielen.`,
"label.icon.2":`Portemonnee`,
"label.chat.topic.delete.prompt3":`Weet je zeker dat je dit onderwerp wilt verwijderen?`,
"UG_Lead_008":`Visitekaartje scan code`,
"label.multilang.databatchadd.fail":`{0} gegevens worden niet toegevoegd：`,
"front-kefu-moudle-v1-chzx-confirm":`Weet je zeker dat je de agent wilt verwijderen?`,
"label.import.page1.matchlabel":`Manier om {{$store.state.labelName}} te evenaren`,
"label.dashboardSetup.showdw.d3":`Miljoen`,
"label.version.ifnecessary":`Upgrade indien nodig uw CloudCC-versie.`,
"label.confirm.delete.default.tab":`Weet u zeker dat u de standaard logging tabs wilt verwijderen?`,
"label.emailtemplate.mergefields.tip":`Wanneer gebruikers de inhoud van e-mails bewerken, kunnen zij samengevoegde velden toevoegen om tekst in de e-mailinhoud te vervangen. Wanneer e-mails worden verzonden, vervangt het systeem ze door tekst. Bijvoorbeeld, {!Contact.naam} in uw e-mail zal de naam van de contactpersoon worden.`,
"vue_label_chatter_decline_members_join":`Weigeren leden tot de groep toe te treden`,
"label.role.no":`Geen rollen`,
"label.service.gantt.resources":`middelen`,
"label.knowledge.language.simplified":`Vereenvoudigd Chinees`,
"label.eidt.queue.length.cannot.than":`De naam mag niet langer zijn dan 50 karakters.`,
"label.mobile.quickcreate.default.tasks":`Taken`,
"label.discount.yuan":`Korting (Yuan)`,
"message.error.delete.pending":`Het record is in afwachting van goedkeuring, u kunt het niet verwijderen.<br>Klik <a href='javascript:history.back();'>hier</a> om terug te keren.`,
"chatter.show.mostnews":`Toon Meer`,
"label.optionlist":`Keuzelijst`,
"template.chart.cpdj":`Prijzen van producten`,
"label.user.usernamepassword.error":`Controleer uw gebruikersnaam en wachtwoord.`,
"label.file.sharetype.check":`Viewer`,
"label.completed.generated.page":`PC pagina is voltooid`,
"label.martrixcross":`Matrix Kruis`,
"label_tabpage_entercusnamez":`Voer de naam van de klant in`,
"lable.account.NextwDays":`De komende 30 dagen`,
"label.list.userinterface.dashboard.hint":`Nieuwe dashboardgrafieken snel weergegeven op mobiele telefoons, tablets, enz.`,
"message.fieldtrack.operatecreate":`Gemaakt`,
"label.service.gantt.available.plan":`Tijdschalen die kunnen worden gepland:`,
"label.activity.setting":`Activiteit instellingen`,
"label.tag.manage.record":`Aantal records`,
"label.customcomponent.page.edit.title":`Aangepaste componenten bewerken`,
"label.import.index.creationrecord":`Een record aanmaken`,
"label.tabpage.printz":`Afdrukken`,
"label.appointment.wizard.subtitle4-1-5":`1.5 h`,
"label.partnerCloud.orderingPlatform.discountUnit":`Kortingseenheid:`,
"label.weixin.micro.message.profile.associated":`WeChat officiële account gekoppeld aan het bedrijfsprofiel`,
"label.cpq.opportunity.pricebook.change":`Deze opportuniteit is gekoppeld aan een primaire offerte en het koersboek kan niet worden gewijzigd`,
"vue_label_opportunity_business_opportunity":`Resultaten van gesloten en door de klant bekroonde zakelijke opportuniteiten bevatten records met een of meer van dezelfde velden als de huidige zakelijke opportuniteit.`,
"message.standardreport":`Standaardrapporten`,
"vue_label_account_outstanding_business":`Alle onverwerkte zakelijke kansen van anderen overdragen`,
"vue_label_commonobjects_detail_field":`Selecteer filter veld`,
"pagecreator_page_button_delete":`Delete`,
"label.leadconvers.permisson":`Geen {!operator} permissie voor het {!objectnaam}, neem contact op met de admministrator!`,
"vue_label_systemSettings_customcode":`Aangepaste code`,
"button.partner.cancel":`Annuleren`,
"label.whChatBindingState":`WeChat Binding Status`,
"label.appointmentconfirmail.wizard.subtitle6":`Telefoon`,
"label.recycle.dis.tip2":`Klik op Uw prullenbak legen of op Alles legen om de prullenbak van gebruikers of organisatie te legen. Dit zal enige tijd duren, wanneer het legen voltooid is, wordt u per e-mail op de hoogte gebracht.`,
"batch.transfer.succ":`gegevens van succesvolle massaoverdracht`,
"label.chat.add.bookmark":`Bladwijzer`,
"label.mr.object.contact":`Contacten`,
"component_setup_label_parentobject":`Superieur object`,
"label.reportsSubscriptionPage.schedulereport.weekly.tuesday":`Dinsdag`,
"vue_label_report_list":`Selecteer het veld dat moet worden weergegeven in de titel van de lijst`,
"label.checkbox.false":`Geen`,
"label.chatter.followers":`Wordt gevolgd`,
"label.mr.loadReDate":`Laad de geselecteerde`,
"label.versiontype.Essential":`Essentieel`,
"front-project-module-v1-input-actual_working_hours":`Voer de manuren in`,
"label.visualpage.staticresource.p2":`2. Merk op dat de ondersteunde statische bronbestandstypes png, jpg, gif, js and css`,
"label.query.clone.detail.choose":`Kies de te klonen lijnen`,
"component.assistant.label.30daysnoact":`30 dagen zonder campagne`,
"label.tianyancha.businessverify.relation":`Heeft in kaart gebracht`,
"vue_label_email_havent_received_the_email_yet":`Geen post ontvangen nu`,
"label.isEnableVisualpage_new.title":`Toegang tot aangepaste pagina's inschakelen`,
"lable.SalesCommitmentKanBan.allContractAmount":`Totaal contractbedrag`,
"label.searchall":`Alles zoeken`,
"label.h5.similar.opportunity.select.all":`Alles kiezen`,
"label.area.tree.intro":`U kunt de hiërarchie van de gebieden hier bekijken.`,
"label.select.up.three.fields":`Opgelet: Er kunnen maximaal drie velden worden geselecteerd.`,
"label.leadscore.doing":`Het scoren is begonnen, gelieve het scoren niet te herhalen`,
"message.choosereportobj":`Selecteer rapport objecten`,
"button_partner_start":`Begin te gebruiken`,
"label.quote.print":`Offerte afdrukken`,
"label.workflowoperateselect":`Stap 3 Workflow-acties specificeren`,
"label.greate":`> Groter dan`,
"lable.setting.qrcodeOrbarcode.rule":`Regels Instellingen van QR Code/Bar Code Generatie`,
"label.partnerCloud.orderingPlatform.discounts":`Korting Schema`,
"label.ems.save2draft":`Opslaan als klad`,
"vue_label_homepage_editname":`Naam startpagina bewerken`,
"label.ccdocument.save.error":`Opslaan mislukt en de foutcode is`,
"label.samoa.standard.time":`Samoa Standaard Tijd`,
"label.tianyancha.businessverify.msg7":`3. omvang van de dienst`,
"vue_label_commonobjects_view_up_to_data":`De operatie ondersteunt tot 200 gegevens`,
"label.manage":`Beheer`,
"label.tooltip":`rapportgegevensbron is gebruikt, kunt u de objectrelatie niet bewerken!`,
"vue_label_calendar_edit_calendar":`Kalender bewerken`,
"label.attendance.keywords":`Voer de trefwoorden in`,
"label.otherinfo":`Andere informatie`,
"System_TAB_SeeViewAmount":`Bekijk Totalen`,
"label.recordtype.remark":`Beschrijving`,
"label.object.cannot.delete":`Het object kan niet worden verwijderd omdat het is gekoppeld aan de volgende relaties met andere objecten`,
"label.setup.mobile.bottombutton.saveprompt":`Selecteer 4 pagina's op het eerste niveau`,
"label.department.lastpage":`Het is de laatste pagina`,
"label.emailtemplate.mergefield.use":`Kopieer en plak samenvoegveldwaarden in de e-mail`,
"vue_label_salesfunnel_notice8":`Percentage succesvolle conversies van deze fase naar de volgende fase`,
"lable.opppdt.addpdt.table.product":`Producten`,
"vue_label_helpcenter_report2.2":`Stap 2: Selecteer hoe u de kolommen wilt samenvatten: Totaal, Gemiddelde, Max, Min. <br>? Sorteer de gegevens in het rapport in oplopende of aflopende volgorde<br> Klik op het ↑ of ↓ symbool naast een veld in de koptekst van het voorbeeldrapport. De gegevens in het rapport worden gesorteerd in oplopende of aflopende volgorde op basis van dit veld. <br>? <br>Detailrijen tonen of verbergen<br> Na het groeperen, kunt u detailrijen tonen of verbergen door de schakelaar "Detailrij" rechtsboven in het rapport in het voorbeeldvenster te zetten. De "Detail Rij" staat standaard uit. <br>? Automatische update preview aan- of uitzetten<br> Met de schakelaar "Automatische update preview" rechtsboven in het voorbeeldrapport kunt u de automatische update preview aan- of uitzetten. Als deze optie is ingeschakeld, wordt de impact van elke stap die u neemt op de gegevens automatisch weergegeven in het voorbeeldrapport. ? Om de rapport records te filteren, klikt u op de filters<br>De filters zijn onderverdeeld in standaard filters en veld filters. <br>De standaard filters omvatten het Rol filter, het Toon mij filter, en het Datum filter. <br> A. Het "Rol" filter verdeelt gegevens naar huidige rol en direct ondergeschikte rollen, en u kunt schakelen tussen rollen door te klikken op de rolnaam. <br> B. Het "Toon aan Mij"-filter verdeelt de data op "Toon aan Mij" en "Toon aan Allen", waarbij "Toon aan Mij" data toont waarvan de eigenaar de huidige gebruiker is, en "Toon aan Allen" alle data toont waarvan de huidige gebruiker kijkrechten heeft. <br> C. Het "Datumbereik" filter verdeelt gegevens op datum over een tijdsbereik, zoals "Aanmaakdatum", "Einddatum". <br> Het veldfilter bevat zowel een veldfilter als een geavanceerd filter. <br>`,
"label.validate.function.funcFormat.YEAR":`JAAR(datum)`,
"label.service.gantt.timeScale":`Kies tijdschaal in Gantt`,
"label.data.dataexptemplate.desc1":`1. Data export bestanden hebben twee formaten: CSV-formaat en gecomprimeerd formaat. Standaard CSV-formaat.`,
"template.chart.btjbkhqk":`Verschillende niveaus van klanten`,
"label.role.assign.select":`Verwijder een gebruiker uit de <b>Geselecteerde gebruikers</b> lijst en wijs de gebruiker toe aan de hierboven geselecteerde rol.`,
"label.event.lookupmulti.assigner":`Toegewezen aan`,
"label.appexchange.fieldupdata":`Workflow Veld Updates`,
"label.lookup.page.notexists":`De pagina komt niet uit.`,
"label.appupload.install.error.choice3":`Conflicterende componenten samenvoegen tot één component`,
"vue_label_commonobjects_detail_team":`Teamleiding`,
"label.approvereqiest":`Verzoek om goedkeuring`,
"message.error.id.replace":`De kalenderinformatie die overeenkomt met {0} werd niet gevonden`,
"font-evaluate-module-v1-general":`Het type evaluatie is Neutraal`,
"vue_label_report_whatweek":`Welke dag?`,
"vue_label_chatter_img_upload":`U kunt JPG, GIF of PNG bestanden uploaden, de maximale bestandsgrootte is 2M`,
"label.checkbox":`Checkbox`,
"label.visualpage.component.n5":`5.Voorbeeld. Roep:`,
"chatter.updat":`Update`,
"label.ems.emailaccount":`E-mail account`,
"label.autoRegister.changepwd.setpwd.tip1":`Wachtwoord instellen voor CloudCC account`,
"label.import.step1.matchway":`Manier om overeen te komen { labelNameshow }`,
"label.manageAll.sel.one4":`Items die ik afwees`,
"label.tabpage.lookatmorez":`Zie Meer`,
"label_tabpage_addadvancedoptions":`Geavanceerde opties toevoegen`,
"message.validation.accept":`Ongeldig formaat`,
"label.handlingnooperate":`De gegevens worden verwerkt, doe alstublieft niets anders, anders zal de verwerking mislukken.`,
"label.mobile.buttom.homepage":`Homepage`,
"lable.account.LastaDays":`Laatste 7 dagen`,
"label.user.notexists":`De gebruiker bestaat niet.`,
"front-electronic-signature-isclose":`Inactief`,
"label.optional.groups":`Optionele Offerte Lijn Groepen`,
"pagecreator.layout.label.layoutname":`Naam van de lay-out`,
"label.error404":`De pagina die u probeert te bekijken is er niet, probeer het later nog eens.`,
"label.eventtrigger":`Gebeurtenis triggers`,
"label.projectManagement.next.page":`Volgende pagina`,
"vue_label_SMS_chosen":`Gekozen`,
"label.part.cannot.empty":`Het veld kan niet null zijn`,
"label.call.center.jilu":`Gesprekshistorie`,
"front-kefu-moudle-v1-tenant-reinput":`Voer huurder ID in`,
"label.projectManagement.you.want.to.delete.this.data":`Weet u zeker dat u dit record wilt verwijderen?`,
"label.projectManagement.nocharge":`Gratis`,
"System_TAB_SeeViewPageAmount":`Pagina's bekijken`,
"label.password.query.error":`Fout in gebruikersvraag.`,
"message.chooseatleastone":`Kies tenminste een waarde.`,
"label.sortasc":`Ascend`,
"label.stdashbord.xsld.business.jinezhb":`Bedrag Verhouding`,
"label.attendance.add":`Aanwezigheden toevoegen`,
"vue_label_account_invoices":`Overdracht van alle facturen van de eigenaar van de klant`,
"label_delete _model":`Het verwijderen van een model zal ook de bijbehorende doelgegevens verwijderen en is onomkeerbaar. Wilt u de verwijdering bevestigen?`,
"label.folder.sort。discreption":`De mappen worden uitgevoerd in de geselecteerde volgorde.`,
"label.partnerCloud.financeSetting.merchantPlatform":`Toegangspad: Merchant Platform  Account Centrum  API Veiligheid  API GeheimＫey`,
"label.equal":`=Gelijk`,
"lable.PowerProcess.Workorder":`Werkopdracht`,
"front-docusign-setting-error-tips":`Kies het aangepaste veld`,
"template.report.lead.status":`Leads Status`,
"label.create.remark":`Noot toevoegen`,
"font-evaluate-module-v1-one-points":`Negatief cijfer: 1 punt`,
"label.validate.function.funcExplain.DATETIMEVALUE":`Geeft als resultaat een jaar, maand, dag en GMT tijdwaarde (Datum/Tijd-veld)`,
"label.report.select.group.mode":`Selecteer groeperingsmodus`,
"label.h5.editmydetails":`Mijn gegevens wijzigen`,
"front-epwechat-module-v1-authorize":`Geautoriseerd terugbel domein`,
"label.tabpage.kanban":`Viewboard setup`,
"label.emailobject.emaildetail.button.addtocontact":`Toevoegen aan contacten`,
"lable.opppdt.selPbk.description":`Selecteer een prijsboek voor deze opportuniteit. U kunt slechts een product uit één prijsboek toevoegen, en als u het geselecteerde prijsboek wijzigt, worden alle bestaande producten uit de opportuniteit verwijderd.`,
"component.event.button.save":`Save`,
"vue_label_homepage_homepage_assigned_success":`Homepage met succes toegewezen`,
"message.duplication.label.blankmatch":`Overeenkomende lege velden`,
"label.icon.24":`Eerste Hulp Kit`,
"label.mobile.same":`Het nieuwe telefoonnummer is hetzelfde als het oude telefoonnummer`,
"label.file.library.managemembers.addmember":`Leden toevoegen`,
"chatter.sp":`Toon Berichten`,
"label.user.notlogin.range":`Buiten aanmeldtijdbereik.`,
"label.step3.total7":`Stap 3 van 7`,
"label.user.fullname":`Volledige naam`,
"label.button.menubar":`Menubalk`,
"#label.importfilestep3":`Stap 3 Selecteer en upload uw bestand(en)#`,
"label.appointment.wizard.subtitle6":`Beschrijving`,
"message.lostnextapprover":`Als u het goedkeuringsverzoek wilt indienen, vul dan het veld "Relevante gebruiker" in om de volgende goedkeurder te definiëren. Dat wil zeggen dat het "Relevante Gebruiker" veld niet leeg mag zijn. Als u nog andere vragen heeft, kunt u contact opnemen met admin.`,
"label.sso.saml.sp.logoutUrl":`Identity Provider Single Logout URL`,
"label.weixin.isgoon":`Uw lidmaatschap informatie bestaat al. Als u doorgaat, zal WeChat ID die dit mobiele telefoonnummer eerder heeft gebonden geen gebruik kunnen maken van AidMax WeChat Official account. Weet u zeker dat u wilt doorgaan?`,
"vue_label_notice_homepage1":`Voer de juiste streefwaarde in, binnen 12 cijfers`,
"label.umeng.activity.event.will":`zal`,
"label.insertURL":`URL invoegen`,
"label.partnerCloud.orderingPlatform.administrator":`Geen prijsboek beschikbaar. Neem contact op met de beheerder.`,
"vue_label_systemSettings_emailtemplate":`Email Tamplate`,
"template.dashboard.market.analysis":`Campagne Analyse`,
"message.deleteapproval.tip":`U kunt alleen het goedkeuringsproces verwijderen waaraan geen gegevens of records gekoppeld zijn.`,
"pagecreator_page_message_delete":`Verwijdert u de huidige geselecteerde pagina?`,
"component.telerecord.label.message":`Commentaar`,
"front-email-payment-Invoice-preview-opening":`Neem contact op met de systeembeheerder om de online betalingsfunctie te activeren en de overeenkomstige betalingsmethodeparameters te configureren.`,
"noless":`Groter dan of gelijk aan`,
"label_emailtocloudcc_button_back":`Annuleren`,
"lable.Please.select.a.template":`Kies een bestaand sjabloon.`,
"front-lightning-module-v1-details-page-chart-relevant":` Wanneer de geassocieerde objecten van het geselecteerde rapport het huidige object bevatten, kunt u de gegevens van het rapport verder filteren aan de hand van het huidige record; Stel in of gebruikers de gegevens handmatig kunnen verversen.`,
"label.object.page.head":`Koptekst pagina`,
"label.notification.time1":`in een paar seconden`,
"label.weixin.optionnine":`Keuze 9`,
"label.approval.content.tolang":`De inhoud die u heeft ingevoerd is te lang, gelieve opnieuw in te voeren.`,
"label.leadconvers":`Leiding Conversie`,
"label.compact.layout.frame.tabseq":`Toon tabblad paginavolgorde:`,
"label.permission":`Toestemmingsreeksen`,
"vue_label_notice_new_success":`Succesvol aangemaakt`,
"label.money":`Valuta`,
"label.ccchat.person.invite.unsuppem":`Het door u ingevoerde e-mailadres ondersteunt {0} niet.`,
"message.profile.del":`Dit profiel is een beheerders profiel en kan niet verwijderd worden!`,
"vue_label_report_savelocation":`Bewaar plaats`,
"label.knowledgebase.select.lighting.target":`Kies Lightning doelwit`,
"label.visualpage.labelname":`Pagina Label Naam`,
"label.notification.ccchat2":`【点赞用户名】 heb je bericht geliked.`,
"label.htyj.wanchenglv":`Percentage`,
"label.weixin.report.generatedchart":`Gegenereerde grafiek`,
"label.customer.tab.please.label":`Gelieve het tabblad`,
"label.template.lookup":`Sjabloon bekijken`,
"label.attendance.setting.wucha":`Afwijking binnen 200 meter`,
"vue_label_opportunity_product_addproduct":`Product toevoegen`,
"label.data.setok.t.desc3":`Bediening.`,
"label.emailobject.template.public":`Publiek`,
"label.setsubmit":`Instellingen`,
"chatter.feed.menutype.feed.companycom":`Alle bedrijven`,
"label.Generate.Document":`Genereer document`,
"label.knowledge.setting.hint.six":`Artikelen ordenen op gegevensclassificatie.`,
"label.dashboard.show.total":`Toon totaal`,
"attachment.select.warning.001":`De bijlage is gearchiveerd en de knop Archiveren is niet beschikbaar, gelieve opnieuw een bijlage te selecteren.`,
"message.schedulejob.error.delete":`Er is een fout opgetreden bij het verwijderen van de Taakbasis.`,
"setup.layout.group.pagecomponent":`Pagina Onderdelen`,
"label_partner_new_step3_meno":`Weet u niet wat u moet invoeren? Geen zorgen, u kunt het later altijd nog veranderen.`,
"label.partnerCloud.orderingPlatform.mutex":`Mutex`,
"label.subtotalrely":`Subtotaal Bases`,
"label.file.library.selectFile2Lib":`Bestanden toevoegen`,
"label.lock.record":`Er zijn( records vergrendeld`,
"label.multilang.addcustomreporttypestage2.description":`Deze gegevensbron zal een rapport over {0} genereren. Door een object te kiezen dat er aan gerelateerd is,
kunt u bepalen welke gerelateerde records in andere objecten zullen worden teruggegeven aan de resultaten van de gegevensbron.`,
"message.duplication.errorinscript.greaterthan10":`U kunt maximaal 10 records selecteren om samen te voegen.`,
"label.encd":`Weergave Gecodeerd`,
"UG.Account.03":`Proactief controleren en samenvoegen van dubbele rekeningen`,
"label.salescloud.teamrole.main2":`Major`,
"label.email.to":`Ontvanger`,
"label.members.sign.notify":`Stel de supervisor op de hoogte`,
"template.report.individual.case.priority":`Zaak Prioriteit`,
"vue_label_report_selectfolder":`Selecteer map`,
"label_partner_all":`Alle partnercloud`,
"lable.custom.year":`Aangepaste Jaren`,
"label.ispigeonhole":`Archief`,
"label.campaignmember.selectmember.steptotal":`Stap 2 van 2`,
"label.userphoto.save":`Save`,
"label.knowledgebase.published.version.online":`De gepubliceerde versies staan nog online totdat u dit ontwerp publiceert.`,
"template.report.customer.level.statistics":`Statistieken op rekeningniveau`,
"label.mobile.phone.day.plan":`Morgen`,
"label.icon.95":`Lesgeven`,
"label.recordphone":`Een oproep loggen`,
"lable.currencyManage.unEnabledadvcurrency.discripation":`Het uitschakelen van geavanceerd valutabeheer zal het gebruik van alle gedateerde wisselkoersen voor uw organisatie stopzetten. Conversies van valutavelden op opportunities, opportunity producten, en rapporten gekoppeld aan deze objecten zullen niet langer worden gekoppeld aan een datumbereik - alle valuta conversies zullen de statische wisselkoers gebruiken.`,
"label.service.gantt.is.candidate":`Kandidaat van`,
"label.ruleofchecktask":`Regels voor taakvalidatie`,
"label.whole.page.show":`Volledige pagina`,
"label.validate.function.funcFormat.ISNULL":`ISNULL(uitdrukking)`,
"label.ccdocument.template.set":`Sjabloon ingestelde functie`,
"label.icon.103":`Schema`,
"lable.no.products.to.assets":`Geen enkel product kan worden overgedragen op activa.`,
"label.fristname":`Voornaam`,
"label.appointmentconfirmail.wizard.subtitle5":`Organisator`,
"label.partner.workspace.myspace":`Mijn werkruimte`,
"label.tabpage.optionsz":`Opties`,
"component_chatter_link_button_save":`Publiceren`,
"label.validate.function.funcFormat.NOW":`NU()`,
"label.discountPlanEditor":`Kortingsplan editor`,
"label.weixin.fmu.pm":`{0} PM`,
"front-gantt-module-milestone-sorting":`Mijlpaal sorteren`,
"label.partnerCloud.maximumNumber":`Het maximum aantal partner sites:`,
"label.mobile.place.record.interval.setup":`Interval voor delen van locatie`,
"label.visiblelinenumber":`Zichtbare lijnen`,
"front-kefu-moudle-nopower-calluser":`Geen toestemming, neem contact op met de beheerder`,
"label.field":`Velden`,
"label.projectManagement.groupbydate":`Groepen op datum`,
"label_vue_create_edit_obj_create_event_dialog_desc_deal_field":`gepland`,
"label.operation.monitoring.history":`Job Monitor Geschiedenis`,
"label.data.dataexpalltype.all_desc1":`U kunt kiezen tussen het automatisch genereren en het handmatig invoeren van het wachtwoord van het geëxporteerde compressiebestand. Het automatisch gegenereerde wachtwoord zal naar de mailbox van de gebruikers worden gestuurd wanneer de gegevens succesvol zijn geëxporteerd. Het handmatig ingevoerde wachtwoord wordt niet naar de mailbox gestuurd, dus gebruikers moeten het ingevoerde wachtwoord onthouden. Indien niet ingevoerd, standaard geen wachtwoord.`,
"front-web-module-v1-detail-comment-proposal":`Ik kijk uit naar uw waardevolle suggesties`,
"label_partner_workspace_member_selectedpermission":`Geselecteerde toestemmingen set`,
"vue_label_helpcenter_view1":`In de weergave van de verlichtingsversie, kunt u intuïtief en flexibel de gegevens bekijken en beheren waartoe u toegang hebt. Via de view, kunt u basisfuncties realiseren zoals data classificatie bekijken, data op meerdere manieren weergeven, data toevoegen, wijzigen en verwijderen, en u kunt ook gemakkelijk rapporten en grafieken bekijken voor verdere data analyse.<br> 1. Beheer weergave<br> In het drop-down menu in de linker bovenhoek van de weergave, selecteert u de weergave die u wilt bekijken, en kiest u de standaard weergave via vaste instellingen. <br> Gebruik het lijstweergave menu om weergaven te maken, bewerken, verwijderen, of sorteren. Gebruik tegelijkertijd de filterfunctie rechtsboven om snel nieuwe weergaven te bewerken en te maken. <br> 2. Gegevens bekijken via meerdere weergaven<br> U kunt de gegevens op verschillende manieren bekijken. In de rechterbovenhoek kunt u wisselen tussen de lijst, Kanban en gesplitst scherm om de gegevens te bekijken. <br>In de lijstweergave kunt u met sommige typen velden direct één of meerdere gegevens wijzigen. Dubbelklik op de cel die moet worden bewerkt, of klik op de bewerk-knop, u kunt de gegevens direct bewerken in het pop-up venster. Om meerdere gegevens te bewerken, selecteert u eerst de verschillende gegevens, en vervolgens "Pas toe op geselecteerde gegevens" in het pop-up venster. <br> In de lijstweergave kunt u direct de weer te geven kolom in de linker bovenhoek bewerken, klik op de kop van de tabel om te sorteren, of selecteer de kolom die u wilt vergrendelen via het zwevende uitklapvenster. <br> Na het instellen van de Kanban weergave, kunt u de gegevens in groepen bekijken, en de samenvattende waarde van elke groep bekijken. In de Kanban bekijken instellingen, kunt u de groeperingsbasis, samenvattingsbasis en samenvattingsmethode van de Kanban bekijken bewerken, en u kunt ook maximaal vier velden selecteren om weer te geven. U kunt de groepering van gegevens snel veranderen door te slepen en neer te zetten. <br>`,
"component.task.label.priority":`Prioriteit`,
"label.datamanage.field.error":`Query object veldfout.`,
"label.console.step3":`Stap 3. Selecteer de beeldbron voor de console`,
"label.ems.emailsyncsetup":`E-mail synchronisatie instelling`,
"label_tabpage_placeenterz":`Voer in`,
"label.getontocolumn":`Ga naar Kolom`,
"label.file.down.e":`Het huidige bestandstype mag niet worden gedownload`,
"vue_label_notificationcenter_unreadonly":`Alleen ongelezen`,
"label.login.access.change":`Verander`,
"label.globaloperation.operationtype.send_e-mail":`Stuur e-mail`,
"label.dashboard.refresh.hint":`Klik op Verversen om de nieuwste gegevens in het dashboard te laden. Het zal enige tijd duren om de gegevensbron te draaien, weet u zeker dat u wilt verversen?`,
"front-kefu-moudle-open-free":`Inschakelen (proef)`,
"label.lanxin.setting.appsecret":`AppSecret`,
"label.payment.manage.order":`Uw abonnement beheren`,
"label.chatter.maturiyDate":`Verloopdatum`,
"message.mobilechooseatmostthree":`In het tabblad voor mobiele app kunnen maximaal drie velden worden geselecteerd.`,
"label.customfields.formula.tip":`Een alleen-lezen veld dat zijn waarde ontleent aan een formule-uitdrukking die u definieert. Het formuleveld wordt bijgewerkt wanneer een van de bronvelden verandert.`,
"lable.PowerProcess.start.time":`Selecteer de starttijd.`,
"label.mr.title.button.group2":`set(s) van dubbele records, een totaal van`,
"label.atlantic.standard.time":`Atlantische Standaard Tijd`,
"label.account.LengthofTime":`Duur`,
"label.ccchat.message.search.desc2":`berichten`,
"label.pigeonhole.desc":`Archiveren van bijlage is alleen geldig voor niet-gearchiveerde bijlagen.<br/>Als een bijlage eenmaal is gearchiveerd, wordt deze niet meer verwijderd.`,
"label.partnerCloud.orderingPlatform.sure":`Schakelaar {alias} zal de kar legen. Ben je zeker om de operatie te bevestigen?`,
"label.default.value.is.positive.integer":`De standaardwaarde moet een positief geheel getal zijn`,
"label.partnerCloud.selectOne":`Kies ten minste één menu`,
"label.dashboard.more.condition":`Meer voorwaarden`,
"component.event.label.enddate":`*Eindtijd`,
"label.forecast.settings.type":`Voorspelling Type`,
"com.cloudcc.login.error.message.licensenotstart":`De licentie start niet`,
"lable.list.queue":`Wachtrijen`,
"label.mobile.app.isdisablum":`Uitschakelen van het selecteren van foto's uit het mobiele album bij het inchecken`,
"label.service.gantt.filter":`Bij het filteren op vaardigheden, zullen alleen middelen met de geselecteerde vaardigheid worden weergegeven op de Gantt chart`,
"label.potentialcustomeronline":`Web-to-Lead`,
"label.campaignmember.main.deletecontactdesc":`Massa verwijder alle contacten van deze campagne`,
"label.list.desc1":`Met Web to CloudCC kunt u contact- en profielgegevens van gebruikers vastleggen en automatisch nieuwe leads genereren in CloudCC.com`,
"label.generatepage.title.desc3":`De naam moet uniek zijn, en moet beginnen met een letter. Hij mag alleen hoofdletters, kleine letters, cijfers en underscore bevatten. Hij mag niet langer zijn dan 30 tekens.`,
"label.emailtocloudcc.step2total3":`Stap 2 van 3`,
"label.movablemenu":`Activiteit Knoppen`,
"label.partnerCloud.partnerAccount.topUp":`Herladen`,
"label.data.standobject":`Standaard objecten`,
"label.frequency":`Frequentie`,
"label.schedulejob.setup.schedule.end":`Einde`,
"label.chat.topic.following":`Naar aanleiding van`,
"label.martrixreport.2018.step2":`Stap 2. Vat de informatie samen door:`,
"label.event.moveup.11hour":`11 uur vooruit`,
"label.forecast.customforecast.directorcommit":`Commitment van directe ondergeschikten`,
"vue_label_homepage_card_view":`Kaart`,
"vue_labenl_applauncher_notice_closecertification":`Gegevens zullen verloren gaan na het uitschakelen. Weet je zeker dat je dit moet doen?`,
"component_setup_button_weburl":`Externe url`,
"label_emailtocloudcc_button_addemailaddress":`Uw zakelijke e-mailaccount toevoegen`,
"vue_label_campaign_added_campaign_members":`Met succes campagne leden toegevoegd`,
"label_tabpage_rtemptyz":`Type record kan niet leeg zijn`,
"label.martrixreport.2018.step5":`Stap 5 Selecteer het grafiektype en het markeerpunt`,
"label.moverecord":`Overdrachtsverslag`,
"pagecreator_layout_label_layoutdesc":`Lay-out beschrijving`,
"label.knowledge.setting.data.nine":`Ja, ik wil deze categorie groep en de categorieën onder deze groep verwijderen.`,
"label.icon.90":`Mensen`,
"label.weixin.micro.research.name":`Micro-enquête Naam`,
"label.ccchat.micropost.allowedit":`Sta gebruikers toe om berichten en commentaren te bewerken`,
"vue_label_homepage_fixed_components":`Standaard onderdeel`,
"label.version.document":`Documenten Bibliotheek`,
"label_assessment":`Beoordeling (Kansen - Bedrag)`,
"label.appupload.component.type.lookuplayout":`Zoek Lay-out`,
"label_chatter_loadmore":`Meer laden`,
"component_setup_tabs_label_memo":`Tabbladnaam instellen`,
"label.icon.167":`Kompas`,
"vue_label_chatter_enter_content_sharing":`Voer de delende inhoud en delende groep in`,
"vue_label_notice_modify_success":`Succesvol gewijzigd`,
"label.sharerules":`Regels delen`,
"label.field.api.exists":`Dit veld API-naam bestaat al.`,
"label.icon.83":`Verf`,
"label.file":`Bestand`,
"vue_label_report_foldernameisrequired":`Mapnaam is vereist`,
"label.emailobject.wizard.btn2":`Verbonden, ga naar e-mail verzenden`,
"label.data.downpage.i_title.num3":`Voordat u importeert, moet u alle gerelateerde records importeren. Bijvoorbeeld: als er een lookup-relatie is tussen de objecten die u momenteel importeert en de contactpersonen, moet u eerst de contactpersonen importeren en dan uw gegevens importeren.`,
"label.email.original.content":`Referentieinhoud`,
"vue_label_campaign_add_to_campaign":`Toevoegen aan campagne`,
"label.dashboard.new":`Nieuw Dashboard`,
"label.console.detail":`Console Detail`,
"label.view.desc":`Het datumveld kan gelijk zijn aan "gisteren", "vandaag", "morgen", "vorige maand", "deze maand", "volgende maand", "vorige week", "deze week", "volgende week" of "JJJJ-MM-DD、MM/DD/JJJJ".`,
"label.emailobject.template.insert.continue":`Ga door`,
"label.notification.appointment.overlapEvent":`De geselecteerde tijd wordt ingepland, gelieve een andere tijd te kiezen.`,
"label.console.step6.top":`Vast bovenaan en de lijsten zijn altijd zichtbaar.`,
"label.data.file.the_trigger":`Trigger uitvoeren`,
"message.report.error.operation":`Actie mislukt, gelieve het rapport te resetten`,
"vue_label_helpcenter_detail3":`<br>   Liken en ontliken<br>   U kunt een reactie op een micro-post liken of alleen een micro-post liken. Na het liken kunt u het aantal likes voor de post bekijken, en u kunt de post ook unliken. <br>? Berichten bewerken en verwijderen<br>    De uitgever van een bericht kan het bericht opnieuw bewerken of verwijderen. <br>    Stap 1: Klik op de knop rechts van het bericht en selecteer Bewerken of Verwijderen in de vervolgkeuzelijst<br>   Stap 2: Open de Bewerken/OK om te verwijderen pop-up<br>    Stap 3: Klik op Opslaan/OK om de bewerking te voltooien<br>5. Goedkeuringsgeschiedenis<br>? Ter goedkeuring indienen<br>   De knop "Ter goedkeuring indienen" verschijnt als een nieuw record is aangemaakt, een goedkeuringsverzoek is teruggebeld, of een goedkeuring uiteindelijk is geweigerd. <br>    Stap 1: Klik op "Ter goedkeuring indienen". Het systeem bepaalt of het record en de indiener voldoen aan de project- en initiële voorwaarden van het goedkeuringsproces, en als aan al deze voorwaarden is voldaan, is de indiening succesvol. <br>    Als de volgende goedkeuringsstap in de configuratie van het goedkeuringsproces handmatige selectie van de goedkeurder vereist, dan wordt stap 2 uitgevoerd na "Ter goedkeuring indienen".<br>   Stap 2: Selecteer de volgende goedkeurder en voltooi de indieningsprocedure. <br>? Goedkeuringsgeschiedenis<br>    A. Voor het indienen:<br>   Klik op "Goedkeuringsproces bekijken", het systeem zal bepalen of het record en de indienende operator voldoen aan de items die zijn ingesteld in het goedkeuringsproces en als aan al deze voorwaarden is voldaan, wordt het goedkeuringsproces getoond. <br>    B. Na indiening:<br>   In de goedkeuringsgeschiedenis kunt u niet alleen de stappen in de goedkeuringsgeschiedenis en de huidige goedkeuringsstatus van het record bekijken, maar ook een voorvertoning van het volgende goedkeuringsproces. <br>? Goedkeuringsverzoeken terugtrekken<br>   Als dit goedkeuringsproces is ingesteld om goedkeuringsverzoeken terug te trekken, kunnen deze op elk moment worden ingetrokken nadat u ze hebt ingediend. <br>   Stap 1: Klik op "Goedkeuringsverzoek terugtrekken" op de detailpagina van het record <br>   Stap 2: Open de pagina "Goedkeuringsverzoek terugtrekken" en klik op "Goedkeuringsverzoek terugtrekken" om de bewerking te voltooien`,
"Opportunity_Detailed_Phase_Label_004":`dag(en)`,
"PageLayout_Search_MultiSearch_001":`Selecteer maximaal 3 velden.`,
"vue_label_systemSettings_set_business":`Stel de layout en de velden van objecten in op uw bedrijf.`,
"label.compact.layout.frame.select":`Selecteer een pagina opmaak frame`,
"label.tabpage.rolez":`Rol`,
"label.weixin.appr.currentauditor":`Toegewezen aan`,
"label.knowledgebase.verification.status":`Verificatie Status`,
"UG_Case_05":`Maak een zaak`,
"label.service.marking.completed":`Markeer als voltooid`,
"label.notification.ccchat1":`Ik heb het over jou gehad.`,
"label.knowledgebase.no.action.available":`Geen actie beschikbaar`,
"label.tabpage.newlybuildz":`Nieuw`,
"label.appupload.install.error.choice2":`Hernoem de lokale componenten die conflicteren met het pakket`,
"label_tabpage_as":`Zoals`,
"Opportunity.Detailed.Phase.Label.Popup.001":`Begindatum van de huidige fase`,
"vue_label_homepage_singlepage":`Voeg tot 10 componenten toe aan één pagina`,
"font-evaluate-module-v1-fair-and-bad":`Wanneer het type evaluatie Neutraal en Negatief is`,
"label.partnerCloud.orderingPlatform.orderInformation":`Orderbevestiging`,
"label.custom.lead.conversion.notice":`Leads converteren Herinnering`,
"label.re.upload":`Opnieuw uploaden`,
"label.knowledgebase.top.window":`Bovenste raam`,
"label.h5.allmarkedasread":`Alles gemarkeerd als gelezen`,
"vue_label_SMS_open_record_from_start_activation":`Open het record uit de lijst om te activeren.`,
"label.customer.tab.step2":`Stap 2 Toevoegen aan profielen`,
"label.campaign.channel.input.owner.select2":`Solicitatie Persoon van dit Marketing Kanaal`,
"component.task.button.save":`Save`,
"front-kefu-moudle-v1-phone-type":`Type telefoon`,
"label.wedge-shapearrows":`Wigvormige staartpijl`,
"vue_label_homepage_todaysevent":`De gebeurtenissen van vandaag`,
"label.data.exp.way.sel":`Selecteer de exportmodus`,
"label.setting.intergrationlist.status1":`Deze integratie is momenteel niet geïnstalleerd.`,
"button_partner_workspace_disable":`Activering annuleren`,
"label.customfields.reference":`Er kan naar verwezen worden door andere velden zoals formules, keuzelijsten, opzoekvelden, enzovoort.`,
"label.publicgroups.new":`Nieuwe Pubilc Groep`,
"label.data.setok.e_desc3":`， uw geëxporteerde gegevens downloaden.`,
"vue_label_commonobjects_view_chart_countmode":`Tel Modus`,
"label.service.appointmentList.earliest.allowedStart":`Vroegste begindatum`,
"label.data.choses.e.desc":`Afhankelijk van uw behoeften kunt u alle gegevens exporteren of gegevens van een object.`,
"label.multilang.common.fieldlist.fieldremark":`Toepassen op de velden op de pagina {0}`,
"label.umeng.activity.event":`evenement`,
"label.project.hit.ten":`Issue Update Herinnering`,
"label.c_d_least":`Elke "C"-plaat moet minstens één verwante "D"-plaat hebben.`,
"label.emailobject.wizard.btn1":`Verbind uw e-mail`,
"lable.product.pricebooks.info":`Prijs Boek Details`,
"component_telerecord_label_message":`Commentaar`,
"lable.total.of.estimates":`0 ramingen in totaal`,
"label.stdashbord.xsld.business.oppcounts":`Hoeveelheid mogelijkheden`,
"vue_label_commonobject_duplicatewith":`Dupliceer {1} in {0}`,
"label.setpicandreport":`Grafiek Instellingen`,
"label.category.2":`Algemeen`,
"label.emailtocloudcc.reauthorization":`Hergoedkeuring`,
"label.chatter.vote":`Poll`,
"label_emailtocloudcc_edit":`Bewerken`,
"label.pleaseinput":`Ingang`,
"vue_label_homepage_user_particular_application":`De startpagina wanneer de gebruiker een bepaalde toepassing gebruikt, opdrachten zullen de standaard startpagina overschrijven`,
"label.allianceID":`Alliantie ID`,
"label.h5.homepage.cannot.applied.mobile.terminal":`Profiel homepage is niet geconfigureerd voor dit profiel. Het is niet beschikbaar voor Mobile App`,
"label.appointmentpage.wizard.notif2":`Naam is verplicht!`,
"label_emailsync_status_email":`Uitgevoerde actie Email`,
"label.icon.179":`Mensen`,
"UG_Contract_03":`Contract maken`,
"label.cy.new":`Nieuwe valuta`,
"label.version.setup.controllist":`Controlelijst van Setup`,
"label.vlidaterule":`Validatieregels`,
"label.customer.tab.name":`Tabblad Naam`,
"label.recentview.seloption1":`Onlangs bekeken`,
"vue_label_report_notice_nameisrequired":`De naam van het rapport is verplicht`,
"label.createapproveprocessstep":`<li>1.Lees de Help-onderwerpen</li><li>2.Maak e-mailsjablonen</li><li>3.Maak SMS-sjablonen</li><li>4.Maak een goedkeuringsproces met de Jump Start- of de Standaardwizard</li><li>5.Voeg een "Goedkeuringsgeschiedenis" gerelateerde lijst toe aan alle paginalay-outs</li><li>6.Activeer het proces om het naar uw gebruikers uit te rollen</li>`,
"label.gotocalendar":`Ga naar Kalender`,
"label.import.page1.pleaseselectobj":`Selecteer eerst uw object`,
"label_tabpage_messagez":`Geef commentaar`,
"vue_label_homepage_profilepage":`Profiel startpagina`,
"label.tabpage.choose":`Selecteer`,
"label.campaignmember.setup.lead.field":`Aanknopingspunten`,
"label.setalipay.null":`De vereiste informatie voor het configureren van Alipay is leeg.`,
"label.custom.Current.and.NextCQ":`Huidige en volgende CQ`,
"label.knowledgebase.needto.publish.articles":`Een opnieuw gearchiveerd artikel zal een kladversie aanmaken. Wilt u het artikel publiceren?`,
"pagecreator.layout.message.save.success":`Layout succesvol opgeslagen`,
"homepage.componet.approval.label":`Goed te keuren punten`,
"label.last_submission":`Laatst ingediende tijd`,
"lable.outlook.detail.prefo":`Uitwisseling wint altijd`,
"label.projectManagement.new.subtask":`Nieuwe subtaak`,
"label.service.appointmentList.checkThe":`Gecontroleerd`,
"message.error.searchlayoutselectdefields":`Kan niet worden verwijderd en moet het eerste veld in de zoekopmaak zijn.`,
"label.ems.normal":`Normaal`,
"vue_label_notice_pleaseselectobject":`Selecteer een object`,
"component.sendmail.button.send":`Stuur`,
"label.relevant.records":`Verwante Records`,
"label.weixin.login.CloudCC":`Inloggen`,
"label.tag.addtags.private":`Privé`,
"label.appointment.disable.remark":`Sorry, deze functie is momenteel uitgeschakeld. Als u de vergadering wilt verplaatsen of annuleren, neem dan contact op met de verantwoordelijke persoon op {邮箱地址}`,
"label.campaignmember.main.addMember1":`Leden toevoegen`,
"message.error.objectnofound":`Object undefined`,
"label.employeenum":`Werknemer Nummer`,
"label.search.applyfilter":`Filter toepassen`,
"label.version.history.track.nonsupport":`Alleen de oneindige versie ondersteunt de geschiedenisfunctie voor het bijhouden van velden.`,
"label.ccpeak.direction.for.use.time":`Instructie Voor Geplande Klassen [Versie 2.0]`,
"label.ems.settings":`Instellingen`,
"label_tabpage_arecordtypez":`Beschikbaar recordtype`,
"vue_label_pool_assign1":`{1}{2}`,
"label.customcomponent.direction.for.use":`Instructie voor aangepaste componenten [ versie 2.0]`,
"label.appupload.appname":`Naam pakket`,
"label.cpq.order.status.no.active":`Alleen orders met een actieve status kunnen contracten genereren`,
"label.dashboard.maxlength":`U kunt maximaal 255 tekens invoeren`,
"label.customize.memory.function.sorting.title2":`Geheugen van kopteksten sorteren`,
"label.report.chose.obj":`selecteer object relatie en rapport gegevensbron`,
"label.partner.step3":`Stap 3 Basisinformatie`,
"message.report.type.error.fail":`Ongeldige rapport gegevensbron.`,
"pagecreator.page.message.publish.fail":`Pagina publiceren mislukt`,
"label.minimun":`Minimum`,
"label.state":`Status`,
"label.customcomponent.referencetype":`Referentie Type`,
"label.nameandemailtemplate":`Voer een naam in voor uw proces in het vak hieronder en selecteer vervolgens een e-mailsjabloon om de goedkeurder op de hoogte te brengen (optioneel).`,
"label.customobjects.track.introduce":`Op deze pagina kunt u de velden selecteren die u wilt volgen op de`,
"label.campaign.matchway.label":`Bijpassende methode`,
"label.redistribution":`Opnieuw toewijzen`,
"label.groupmanage":`Organisatie Beheer`,
"label.icon.157":`Camera`,
"label.quickbooks.viewlist.total":`TOTAAL`,
"label.file.copy.file.fail":`Kopiëren mislukt, gelieve manueel te kopiëren`,
"label.outline.selectfield":`Geselecteerde velden in samenvatting:`,
"label.datetime.maxsize":`Een zoekopdracht kan niet langer dan drie maanden duren.`,
"label.dashboard.CustomDashboardMyHomePage":`Mijn startpagina-dashboards aanpassen`,
"label.data.customobject":`Aangepaste objecten`,
"vue_label_SMS_noselected":`Geen record geselecteerd`,
"label_tabpage_value":`Waarde`,
"label.quote.qianming":`Handtekening`,
"label.view.source":`Broncode bekijken`,
"label_popup_infoz":`Prompt`,
"label.emailtocloudcc.redmessage8":`Parameter fout, neem contact op met de beheerder.`,
"label.tianyancha.Search.business":`Zoek bedrijfsregistratie informatie`,
"vue_label_systemSettings_server":`Dienst`,
"vue_label_homepage_dashboard_components":`Dashboard-component`,
"label.search.listview":`Lijst bekijken`,
"label.service.gantt.distribution.success":`Met succes toegewezen`,
"label.icon.4":`Portemonnee`,
"label.partnerCloud.orderingPlatform.calculate":`Bereken Prijs`,
"label.forecast.edittotal.ycyx":`Voorspelling Prioriteit`,
"vue_label_commonobjects_detail_to_precise_search":`Nauwkeurig zoeken`,
"label.order.number":`Bestel`,
"setup.mainpage.label.welcome7":`Instructies: Klik op het menu aan de linkerkant van de pagina → Applicatie-instellingen → Aanmaken → Object → Objectnaam → Aangepast veld.`,
"label.weixin.user.binding":`Binding gebruiker`,
"label.custom.canvas.size":`Canvas Maat`,
"label.projectManagement.recent.projects":`Recent Project`,
"vue_label_helpcenter_lead":`Traceer en beheer uw leads via Cloud CC. Gebruik de geconfigureerde regels om leads te scoren en toe te wijzen, en ze op het juiste moment te converteren naar klanten, contactpersonen en bijbehorende zakelijke kansen.<br>Score<br> In de rechterbovenhoek van de weergave kunt u de knop Partij scoren gebruiken om leads te scoren in de weergave.<br>Distributie<br> Wanneer u een lead aanmaakt of bewerkt, selecteert u Toewijzen onderaan de pagina om de lead toe te wijzen aan de bijbehorende medewerker voor verwerking volgens de bestaande regels.<br>Conversie<br> Op het juiste moment kunt u leads converteren naar klanten en contactpersonen door te klikken op de conversie knop in de rechterbovenhoek van de detailpagina. Tegelijkertijd kunt u corresponderende zakelijke kansen en taken creëren om de voortdurende follow-up van transactiekansen te vergemakkelijken.`,
"label.enabledprocess":`Actieve goedkeuringsprocedures`,
"label.emailobject.noemail":`Nog geen post, ga er een sturen!`,
"label.validate.remark3":`Bepaal of een veld vereist is op basis van de waarde van een ander veld`,
"vue_label_salesadvance_retention":`Retentie`,
"label.product.managep":`Manage Prijs Boeken`,
"font-evaluate-module-v1-not-report":`Niet heropenen`,
"label.emailmerge.mergepage.step1":`1. Kies de records die u wilt samenvoegen:`,
"front-epwechat-module-v1-epwechat-describe":`CloudCC biedt de integratie met WeCom, waarbij de krachtige functies van WeCom worden gecombineerd met de lichte H5versie van het CloudCCsysteem,<br /> zodat u gemakkelijk klantrelaties kunt beheren, privédomeinverkeer kunt beheren en de bedrijfsinkomsten kunt verbeteren.`,
"label.partner.template.detailimage":`Foto`,
"label.recycle.clearall":`Leeg de prullenbak van uw organisatie`,
"chatter.error.nottype":`Fout: Ongeldig bestandstype. Gebruik JPG, GIF of PNG bestanden.`,
"pagecreator.button.cancel":`Annuleren`,
"front-market-form-quired-ziduan":`Verplichte velden op de registratiepagina`,
"vue_label_report_columnname":`Kolom naam`,
"message.notdelete.type":`U kunt dit recordtype niet verwijderen, omdat de volgende profielen dit recordtype als standaardwaarde gebruiken.`,
"label.ccpeak.folder.all.time":`Alle geplande klassenmappen`,
"label.quickbooks.searchlist.total3":`Er zijn {0} niet-gekoppelde schattingen voor een totale waarde van {1}`,
"label.forecast.detailforecast.quantity":`Verwachte hoeveelheid`,
"label.knowledge.language.british":`Brits`,
"label.vlidaterule.example.messagelocation":`Deze foutmelding kan verschijnen bovenaan de pagina of onder een specifiek veld op de pagina`,
"front-kefu-moudle-chf-success":`Succesvol gesplitst`,
"vue_label_jihui_yi":`Mogelijkheid 1`,
"label.import.step1.null":`Geen opties beschikbaar`,
"label.console.step5.tab.subtab":`Als een subtab van`,
"batch.edit.permission":`Geen rechten om te bewerken`,
"label.weixin.fmu.before.min":`0 minuten voor op schema`,
"chatter.up.file":`Het uploaden van bestanden neemt enige tijd in beslag, afhankelijk van de grootte van het geüploade bestand, gelieve even te wachten.`,
"setup.layout.group.field":`Velden`,
"label.chat.unlike":`Liked`,
"vue_label_dashboard_updatefrequency":`Bijwerkingsfrequentie`,
"label.trigger.folder.new":`Trigger pagina's: Nieuwe map`,
"label.process.des.app":`Klik op de juiste link om de details van het huidige record te bekijken.`,
"vue_label_pool_assignselect":`Kies om leden toe te wijzen`,
"label.lookup.user":`Collega's zoeken`,
"label.mobilescreentablayoutedit.remark2":`Selecteer de filtervelden die worden weergegeven op de startpagina van het tabblad in de mobiele app.`,
"label.data.exp.objtemp":`U maakt het sjabloon om gegevens van dit object te exporteren als volgt cretira`,
"label.weixin.moreselect.error":`Je kunt maar 10 records selecteren`,
"label.icon.25":`Verband`,
"lable.sample.text":`Voorbeeldtekst`,
"label.most.setup.obj":`Er kunnen maximaal 10 objecten worden ingesteld.`,
"label.weixin.coming":`Coming`,
"label.editdescription":`Opmerking Bewerken`,
"label.multipleactivity.multiple":`Meerdere Gebruikers`,
"label.sso.saml.idp.entityid":`Entiteit-ID`,
"label.SMS.pho.filed":`Telefoon`,
"message.serviceabsence.violation":`Overtreding van de opdrachtperiode: het is in strijd met de afwezigheidslijst.`,
"label.forecast.settings.type.clist":`Productfamilies gebruiken`,
"label.state.noend":`Onvolledig`,
"label.sourcetemp":`Bron`,
"vue_label_chatter_name_link":`Gelieve de naam en link in te vullen`,
"label.emailobject.attach":`Bevestig`,
"label.everyother":`Every Other`,
"label.title":`CloudCC.com`,
"vue_label_chat_haventactivate":`Je hebt nog geen chat account geactiveerd. Wil je het nu activeren?`,
"pagecreator_layout_button_delete":`Lay-out verwijderen`,
"label.transfer.temporarily":`Bel`,
"label.service.dispatchingUnits.search.services":`Zoek Service Afspraak`,
"customer.message.fail.chat":`Mislukt om bericht records te krijgen, neem contact op met de beheerder voor hulp`,
"label.apiname.toolong":`API naam is te lang.`,
"label.empty.filter":`Filters wissen`,
"label_tabpage_personalCenterz":`Persoonlijk centrum`,
"label.minutes":`Minuutje`,
"label.multipleactivity.atasks":`Taak(en)`,
"label_tabpage_deleteview":`De weergave verwijderen`,
"pagecreator_layout_message_save_success":`Layout succesvol opgeslagen`,
"label.reportlineorder":`Volgorde rapportkolommen`,
"label.total.forecast.have.priority":`~lke voorspelling is voorrang, maar de personen die andere voorspellingen aanvaarden zijn voorrang`,
"label.custom.quarter.subtitle":`Aangepaste kwart`,
"label.icon.79":`Afdrukken`,
"label.hiddenoperate":`Acties verbergen`,
"label.project.hit.six":`Kennisgeving van toewijzing van taken`,
"label.visualpageaction.errordesc":`U hebt niet de toestemming om de door u gevraagde bewerking uit te voeren. Neem contact op met de eigenaar van het record of met uw beheerder.`,
"label.chat.unmute":`Annuleer "niet storen"`,
"label.zhaiyao":`Abstract`,
"vue_label_commonobjects_detail_bcc":`Bcc`,
"label.customcomponent.page.index.table.version":`API-versie`,
"UG.quota.06":`Een offerte maken`,
"label.icon.152":`Robot`,
"label.partnerCloud.partnerAccount.account":`Gebruikersnaam`,
"label.file.sharewith":`Sharer`,
"label.data.dataexptemplate.desc2":`2. Het compressieformaat is verdeeld in twee typen: het ene type genereert automatisch het wachtwoord voor het gecomprimeerde bestand, het andere type voert het wachtwoord voor het gecomprimeerde bestand handmatig in.`,
"vue_label_dashboard_newfoldersuccessfully":`Succesvol nieuwe map aanmaken`,
"label.campaignmember.main.importmember":`Massa import campagne leden`,
"label.htyj.completed":`Voltooid`,
"label.reportTypeLabel":`Rapporttype Label`,
"label.customer.tab.label":`Tab Label`,
"label.dashboard.component":`Componenten`,
"label.safetystatement.dialog":`Veiligheidsverklaring (Nieuw venster)`,
"label.forecast.settings.data":`Verwachte datum`,
"label.knowledgebase.modifiedby":`Gewijzigd door`,
"label.batchadd.remark":`Meerdere records toevoegen`,
"button.partner.delete":`Delete`,
"Pagelayout_Setup_005":`Naam moet op de eerste plaats komen.`,
"label.forecast.edit.wcpxl":`Geen productfamilies`,
"lable.PowerProcess.seq.input":`Voer een bestelling in.`,
"pagecreator.layout.message.delete.fail":`Verwijdering van lay-out mislukt`,
"label.emailobject.edit":`EDIT`,
"label.weixin.million":`Tienduizend yuan`,
"setup.mainpage.button.manageobject":`Objecten Beheer`,
"label.weixin.participants.perfect.information":`Deelnemers zijn verplicht om informatie te verbeteren`,
"vue_label_campaign_campaign_members":`Campagne leden toevoegen`,
"label.ccchat.person.invite.emplaceholder":`Voer e-mailadressen in, en scheid ze door puntkomma's`,
"label.mobile.phone.new":`Nieuw`,
"font-evaluate-module-v1-small-program-evaluation-settings":`Miniprogramma Evaluatie Opzet`,
"UG.opportunity.005":`Meervoudig verkoopproces`,
"vue_label_report_polymerization":`Geaggregeerd`,
"label.multilang.lookfiltercondition.fieldtypenotmate":`De regelvoorwaarde {0} is onjuist, het veldtype komt niet overeen!`,
"label.knowledgebase.delete.draft":`Delete Draft?`,
"label.mr.descreption.condition3":`Regel-exacte overeenkomst: controleer dit item en vind dubbele records door dezelfde karakters van het veld. Indien aangevinkt, zal het vinden van duplicaten door de eerste paar karakters invaidate.`,
"Lead.Auto.Scoring.Setting":`Lead Scoring Instelling`,
"label.marketing.channel.default":`Marketingkanaal (standaard ingeschakeld)`,
"front-project-module-v1-select-projecttemplate":`Selecteer Project Sjabloon`,
"front-email-payment-select-area":`Voer het district in`,
"lable.PowerProcess.message":`Informatie over het rechtsproces`,
"label.weixin.free.get.captcha":`Krijg Verificatie Code Gratis`,
"label.projectManagement.please.select.task.or.question":`Selecteer taak/probleem`,
"label.pacific.daylight.time":`Pacific Daglicht Tijd`,
"label.sendsms.batch.step1.introduce":`Selecteer een van de volgende weergaven (die de ontvangers van deze SMS bevat)`,
"label.same.analyze.account.name":`Naam van de rekening`,
"Homepage.Contract.FieldMissed.DoesntSupport":`Er zijn geen "qdrq" en "htje" velden op het contractobject, dus de gegevens kunnen niet worden getoond.`,
"label.partnerCloud.orderingPlatform.noProduct":`Geen configuratie van productoptie onder dit product vereist.`,
"label.totalsummary":`Samenvatting oprollen`,
"label.partner.workspace.tab":`Tab`,
"label.entitlement.process.name.unique":`Deze naam bestaat al. Gelieve opnieuw in te voeren.`,
"report.label.norole":`U heeft geen toestemming om dit te doen, neem contact op met uw beheerder.`,
"label.password.old.error":`Oud wachtwoord onjuist, opnieuw invoeren a.u.b.`,
"lable.account.quarter.stadate":`Begindag fiscaal kwartaal`,
"label.salescloud.contactrole.choose.correct":`Dubbele contacten geselecteerd, corrigeren aub.`,
"label.schedulejob.setup.schedule.day":`Dag`,
"label.communalusergroup":`Openbare groepen`,
"label.Display.Fields":`Velden die op de dienstaanbiedingslijst worden weergegeven`,
"label.marketsea":`Zwembad`,
"label_partner_setup_address":`Partner cloud-adres`,
"label.industrialandcommercialverification.label.url":`URL`,
"lable.data.exp.newtemp":`Gegevens exporteren en sjablonen maken`,
"label.pc.ui.2018":`Verticaal`,
"label.version.free":`Gratis Editie`,
"label.dataimport.contact.length":`Fout: de lengte van de naam van de contactpersoon is te lang`,
"label.cy.vlidate":`De actie van valuta ingeschakeld is irreversideare. Weet u zeker dat u Valutabeheer wilt inschakelen?`,
"label.recycle.all":`Alle prullenbakken`,
"label.message.changeaccount.isnot":`Contact heeft partnergebruiker ingeschakeld, kan account niet wijzigen`,
"label.searchlayout.exactsearch":` Tip: Vink het selectievakje achter het zoekveld aan om een exacte zoekopdracht voor dat veld uit te voeren`,
"label.file.size.limit":`Opmerking: De maximale bestandsgrootte is 10M.`,
"label.mobileapp.modelsetting1":`Instellingen mobiele standaardmodule`,
"template.report.overall.sales.opportunities":`Totale verkoopperiode (per type opportuniteit)`,
"label.password.update.success":`Wachtwoord succesvol gewijzigd.`,
"label.import.page3.gobackhome":`Terug naar huis.`,
"label.phone":`Telefoon`,
"label.detail.vlidaterule":`Validatieregels bekijken`,
"label.weixin.input.usernames":`Vul uw gebruikersnaam in`,
"label.icon.85":`Transformator`,
"vue_label_systemSettings_partner":`Partner`,
"label.processsetting.new.process":`Nieuw proces`,
"Lead_Scoring_Setting_Rule_Setup_01":`Lead Scoring Regel Lijst`,
"setup.layout.component.area":`Gebied`,
"label.createnewpwdinformuser":`Genereer een nieuw wachtwoord en stel de gebruiker onmiddellijk op de hoogte`,
"label.pwinfo":`Wachtwoord Details`,
"label.imgfield.type.url":`Referentiebeeld`,
"label.attendance.sxccheckincy":`Campagne leden Check-In`,
"lable.PowerProcess.condition.input":`Selecteer conditie.`,
"label.partnerCloud.partnerAccount.topUpFailure":`Bijgevuld fialed`,
"label.document.size.too.long":`Documentgrootte overschreden`,
"label.link":`Toegang Link`,
"label.partnerproduct.sort.repeat":`De naam van de productfamilie wordt genomen.`,
"label.data.setok.e_desc2":`Gegevenslijst exporteren`,
"front-project-module-v1-plase-input-project-name":`Voer de naam van het project in`,
"label.export":`Exporteren`,
"label.icon.45":`Ketel`,
"label.autoRegister.changepwd.title":`Uw inlog wachtwoord instellen`,
"label_clear_adjust":`Duidelijke aanpassing`,
"front-kefu-moudle-return-visit":`Review`,
"label.ems.compose":`Samenstellen`,
"Pagelayout_Setup_002":`U heeft 3 gerelateerde lijsten geselecteerd, en het toevoegen van meer gerelateerde lijsten zal de pagina layout beïnvloeden.`,
"label.service.gantt.skill.screening":`Gebruik Vaardighedenfilter`,
"label.partnerCloud.basicSetting.enable":`De Partner Cloud zal worden gedeactiveerd. Aanmeldings en bewerkingsacties in uw organisatie zullen automatisch door het systeem worden uitgezet.`,
"label.workbanch.setup.description":`U kunt de volgende weergaven instellen om in Mijn werkbank te tonen.`,
"label.category.1":`Alle`,
"label.foldername":`Mapnaam`,
"label.forecast.settings.shuliang":`Hoeveelheid`,
"label.emailmerge.newtemplate.word":`Gelieve Microsoft Word documenten te uploaden.`,
"message.error.type":`type kan niet leeg zijn, u moet een publiek publiek type of personeel privaat doorgeven!`,
"label.manualallocation":`Handmatig toewijzen`,
"label.addattachment.step2":`Stap 3 Klik op Bestand uploaden om het bestand te uploaden`,
"label.company":`Bedrijf`,
"label_emailsync_status_export":`Exporteren als Excel_csv formaat bestand`,
"label.eventreminder":`Evenement Herinnering`,
"label.emailtemplate.lookup":`Bekijk e-mail sjablonen`,
"label.customsetting.touse.getCustomSetting":`Zoek het "hiërarchie" type van aangepaste instellingen, geef de corresponderende apiName en rechten terug (ID is profiel ID of Gebruikers ID ), Map map = cs.getCustomSetting(String apiName, String id);`,
"label.projectManagement.Resourceuse":`Gebruik van hulpbronnen`,
"label.appointment.wizard.subtitle4":`Buffer en tijdinstellingen`,
"label.donot.close.your.browser":`Klik tijdens dit proces niet op een andere link en sluit uw webbrowser niet af.`,
"label.multilang.customforcast.target":`Doelwit van {0}：`,
"setup_layout_label_newarea":`Nieuw gebied`,
"component.timeline.button.more":`Meer stappen`,
"label.appointmentdetail.wizard.title3":`Duur`,
"label.help.new.features.pc":`Pc-side nieuwe functies bedieningshandleiding`,
"label.mr.record":`Record`,
"label.trigger.wgd":`Niet gearchiveerde triggers`,
"label.icon.72":`Gereedschapskist`,
"setup.layout.label.detailpage":`Detail Pagina`,
"frame.personinfo.label.usethisimage":`We zullen variaties van deze miniatuurafbeelding in de applicatie gebruiken.`,
"label.multilingual.confirm.open":`Weet je zeker dat je het inschakelt? Meertaligheid kan gebruikt worden na inschakelen.`,
"label.recordcreater":`Gemaakt door`,
"label.afterfinish":`Wanneer u klaar bent, klikt u op Opslaan`,
"label.companyinformation":`Informatie over het bedrijf`,
"step1":`Stap 1`,
"label.sales.page.dashboard.add":`Toevoegen aan Homepage Dashboards`,
"label.processsetting.process.enabled.failed":`Het is niet gelukt om het proces te verwijderen!`,
"label.document.history.date":`Datum`,
"label.linkedin.title":`LinkedIn-H5MiniApp`,
"label.foldervisitlimit1":`Alle gebruikers hebben toegang tot deze map`,
"april":`April`,
"label_emailsync_form_disconnect":`Annuleer Conncet`,
"label.appointment.wizard.subtitle4-2-6":`2 Dagen`,
"vue_label_notice_follow_success":`Gevolgd door`,
"label.startuploadfile.success":`Als u op "Start Upload" klikt en de voortgangsbalk 100% bereikt, is het bestand met succes geupload en verdwijnt het in het bovenste gebied.`,
"message.accesstoken.acquisition.failed":`Kan geen toegangstoken krijgen!`,
"label.quickbooks.fieldlabel.fistname":`Voornaam`,
"label.appointment.wizard.subtitle1-5":`1 h`,
"2018UI.Homepage.DataNoAccess.Info":`U heeft geen toestemming om dit dossier te bekijken, klik a.u.b. om terug te keren naar de vorige stap.`,
"label.batchaddattachments":`Massa toevoegen Bijlage`,
"label.ems.next":`Volgende`,
"label.quote.zhekou":`Korting`,
"lable.product.notdel":`Omdat het nog steeds in de handleiding met andere prijsboek record.The gerelateerde records zijn als volgt.`,
"label.ems.action":`Actie`,
"message.error.chart.type":`Grafiektypes kunnen niet leeg zijn.`,
"label.conditiontag.lookup.value":`Waarde`,
"label.chatter.allactivity":`Alle activiteiten`,
"label.summaryreport":`Samenvattende rapporten`,
"label.textmessage.vonage.action":`Actie`,
"label.ccpeak.must.result":`Moet als gevolgd door aliassen gebruiken om het resultaat op te halen`,
"label.data.newtemplate.savetemp.desc":`Vul de naam en beschrijving van het sjabloon zorgvuldig in om het gebruik ervan te vergemakkelijken.`,
"label.projectManagement.search.for.users":`Zoeken naar gebruiker`,
"component.milestones.label.title":`Mijlpaal`,
"vue_label_applauncher_description_accountpool":`Gebruik de Account Pool om de opvolgingsstatus binnen de organisatie gemakkelijk te beheren en het personeel te motiveren om de transactie te voltooien.`,
"label.import.index.startimport":`Starten met importeren`,
"page.field.masterinput2":`Master-Detail Ingang`,
"label.mobile.change.owner.permission":`De nieuwe eigenaar moet "Lees"-permissies hebben voor dit type record.`,
"label_partner_common_enable":`Schakel partner cloud in`,
"label.log.browser":`Browser`,
"label.app.step4":`Stap 4 Kies de Tabbladen`,
"lable.quote.syncing.opportunity":`Kansen`,
"label.forecast.customforecast.foredis.jqz":`Exacte waarde`,
"label.forecast.forecastroleuserpage.title":`Forecasts Manager Opdracht`,
"label.starting.quarter":`Startkwartaal`,
"label-combination-record":`Record {index}`,
"label.here":`hier`,
"label.weixin.underfind.error":`Onbekende fout`,
"label.cloudccclass.list.tip.time":`Sta ontwikkelaars toe om geplande klassen te ontwikkelen op het CloudCC.com platform, die gebruikt kunnen worden voor geplande programma's.`,
"label.data.setok.t_desc1":`Als u deze sjabloon afgeleide gegevens wilt gebruiken, klik dan op`,
"label.service.gantt.break.rules":`Regels overtreden`,
"label.weixin.no.pending.ywjh.qin":`Geen kansen voor de komende 30 dagen`,
"label.view.atleastone":`De lijst kan niet leeg zijn.`,
"label.attendance.sxccheckin":`Campagne aanwezigheid`,
"label.custom.split":`Split`,
"front-kefu-moudle-v1-yesorno-delete-templete":`Weet u zeker dat u dit sjabloon wilt verwijderen?`,
"label_chatter_theme":`Onderwerpen`,
"label.partner.new.step1":`Stap 1 Kies een sjabloon dat u bevalt`,
"vue_label_commonobjects_view_settings":`Kanban Weergave Instellingen`,
"UG_Contract_02":`Het contract is een schriftelijke overeenkomst tussen de partijen. Veel bedrijven gebruiken contracten om de voorwaarden voor het zakendoen met andere bedrijven vast te leggen. Gebruik CloudCC om uw bestaande contracten met uw klanten en zakelijke kansen vast te leggen en te documenteren. Volg het contract door het goedkeuringsproces. Gebruik workflow reminders om u te herinneren aan de contract rollover.`,
"label.setup.mobilesetup.isenableh5newandedit":`Activeer nieuw en bewerken van H5 in uw mobiele app.`,
"label.attendance.edit":`Aanwezigheid Edit`,
"label.service.miniProgram.fillImageLink":`Gelieve de link van de carrousel in te vullen.`,
"label.b.c.without":`B-records kunnen al dan niet verwante "C"-records hebben.`,
"label.sso.key":`Autorisatie Code`,
"label.star_click":`Klik om te wissen`,
"vue_label_SMS_name_or_phone_number_lookup":`zoeken op recordnaam`,
"label.case.copre.text":`U kunt ook een webportaal QRcode downloaden die speciaal voor uw bedrijf is bedoeld en deze op uw website of apparaat plaatsen, zodat klanten de QRcode kunnen scannen om de webversie van het klantenportaal te gebruiken.`,
"label.salescloud.forbidden.confirm":`Weet u zeker dat u de gelegenheidsteams wilt uitschakelen?`,
"vue_label_chat_conformactivation":`Bevestig de activering`,
"label.emailtocloudcc.redmessage9":`Databasefout, neem contact op met de beheerder.`,
"label.sahreto":`Deel met`,
"label.recordtype.sort":`Record Types worden weergegeven in de volgorde waarin ze zijn opgeslagen.`,
"label.allreport":`Alle verslagen`,
"front-gantt-module-drag-and-drop-subtask":`Sleep (zet het in een taak) om het als een subtaak te maken!`,
"label.permission.objlist.nopermission":`Geen toegang`,
"label_file_num":`Hoeveelheid`,
"chatter.mostword":`Uw commentaar is meer dan 500 woorden, alstublieft verwijderen en opnieuw invoeren.`,
"label.h5.chatter.comment":`Commentaar op het lichaam`,
"vue_label_calendar_notice_havecreated":`U heeft een kalender gemaakt`,
"label.tabpage.loadz":`Pagina wordt geladen, even geduld...`,
"chatter.w.p":`Telefoon werk`,
"label.chat.topic.name.desc":`U kunt alleen de hoofdletters en de spaties van onderwerpnamen wijzigen.`,
"label_partner_template_name":`Naam sjabloon`,
"label.mobile.phone.required.examines.people":`De Revised By is vereist.`,
"message.error.view.notexists":`Weergave bestaat niet.</br> Of de weergave kan zijn gewijzigd door iemand anders, klik <a href='javascript:history.back();'>hier </a>om terug te keren.`,
"label.custom_time":`Aangepaste tijd`,
"label_partner_workspace_member_all":`Alle`,
"lable.custom.year.name":`Naam aangepast jaar`,
"label.account.previous.M":`Vorige maand`,
"vue_label_commonobjects_detail_locking":`Slot`,
"label.brief.lead":`Leads`,
"label.linkedin.setting.appsecret":`Wachtwoord van Geheime Sleutel`,
"label.query.detail.closepartner":`Uitschakelen partners`,
"label.isEnableVisualpage_new.rightlist":`Actieve aangepaste pagina's`,
"front-epwechat-module-v1-unbound-item3":` gegevens van geautoriseerde informatie`,
"label.exchange.sync.setting.info":`Na het instellen van een service account met impersonatie rechten voor de gebruikers in Microsoft©Exchange, voert u de service account gegevens in om CloudCC te laten communiceren met de Exchange server. Als de service account credentials zijn opgeslagen, maar de gebruiker nog steeds niet in staat is om de records te synchroniseren, controleer dan of u de Exchange Sync heeft ingesteld.`,
"label.emailobject.groupemail.fail.title":`CloudCC groep e-mail verzenden mislukt e-mail adres`,
"label.the.upper.bound.of.each.level.of.edit.discount.must.be.greater.than.the.lower.bound.":`De bovengrens voor het bewerken van elk niveau van korting moet groter zijn dan de ondergrens.`,
"label.visualpage.list.vpname":`Aangepaste paginanaam`,
"label.mask.length.error.message":`Het gecodeerde tekstveld kan niet meer dan 255 tekens bevatten`,
"label.h5.approval.actorname":`Ingediend door`,
"label.knowledgebase.view.translation":`Vertaling bekijken`,
"label.ems.edit":`Bewerken`,
"vue_label_commonobjects_view_reset_width":`Reset Kolom Breedte`,
"label.version.feature.controllist":`Functie Grenslijst`,
"label.setuppagelayout":`Pagina-indelingen`,
"vue_label_commonobjects_view_new_view":`Nieuw uitzicht`,
"label_tabpage_queuez":`Wachtrij`,
"label.direct.dashboard.wait.me.approval":`Goed te keuren punten`,
"message.report.error.noRelatedField":`Geen gerelateerde velden bij het rapport. Ze kunnen verwijderd zijn, neem contact op met uw beheerder.`,
"label.ccchat.person.invite.notme":`U kunt geen uitnodigingen naar uw eigen e-mailadres sturen.`,
"label.weixin.jieduan.finish":`Markeer de huidige fase als voltooid`,
"vue_label_commonobjects_detail_?enter_subject":`Voer onderwerp in`,
"label_starting_month":`Beginnende maand`,
"label.address_linetwo":`Adresregel 2`,
"message.error.select.contiguous.item":`Selectie van relevante items met`,
"vue_label_pricebook_enterbookname":`Voer de naam van de prijslijst in`,
"label.cycleworkflowoperate":`Periodieke workflowacties`,
"label.ems.withoneday":`Vandaag`,
"component.todaytask.label.notask":`Er is geen vervaldatum vandaag, neem een koffie.`,
"label.tianyancha.id":`Bedrijf id`,
"label.user.illegal.login":`Onwettige aanmelding`,
"label.withgathercondition":`Volgens samengevatte criteria`,
"label.foldervisitlimit":`Toegangsmachtigingen`,
"label.ccchat.search.conversation":`Zoek in dit gesprek`,
"lable.annual.project.report":`Verslag van de projectrekening in dit jaar`,
"template.chart.qzkhzhfx":`Leads Conversie Analyse`,
"label.my":`Mijn`,
"label.sendsms.batch.chosetemplate":`Mass SMS: Selecteer een sjabloon of bewerk de inhoud`,
"label.callcenter.enterprise.number":`Onderneming nr.`,
"label_last_modified_by_time":`Laatste modifier & tijd`,
"message.fieldtrack.operaterecord":`<b>operatefield</b> gewijzigd van<b>operateold</b>in<b>operatenew</b>`,
"label.mobile.more.openin":`Open in...`,
"label.multilingual.tip2":`U kunt de meertaligheid in of uitschakelen.`,
"label.datamanage.lead.novalue":`Opmerking: Als het veld leadnaam leeg is, zullen de contactpersonen niet geïmporteerd worden.`,
"label.custom.revoke":`Ongedaan maken`,
"label_chatter_leaveword":`Commentaar`,
"vue_label_ccchat_group_deletedgroup":`De groep is verwijderd`,
"label.tabpage.operationz":`Veld, operatie kan niet leeg zijn`,
"label.user.organization.permit.overdue":`De licentie van uw organisatie is verlopen, neem contact op met de beheerder!`,
"label.log.datetimeoruser.value":`Voer de zoektijd en de gebruikersnaam in.`,
"lable.product.stsp.noavailable":`Geen standaardprijs beschikbaar`,
"label.appservice.cannot.delete.app":`U kunt deze aangepaste app niet verwijderen, omdat sommige profielen deze aangepaste app als de standaard app gebruiken.`,
"component.event.label.newevent":`Nieuw evenement`,
"label.view.sortview.exportview":`Uitvoer Weergave`,
"label.uploadfilemaxsize":`De maximaal toegestane waarde voor het uploaden van bestanden is`,
"label.event.weekview":`Weekoverzicht`,
"label.conversion_rate":`Omrekeningskoers`,
"label.partnerCloud.partnerAccount.useWechat":`Gebruik WeChat scan om te betalen.`,
"UG_Forcast_05":`Voorspellingsinstellingen: stap {0}/{1}`,
"label.service.gantt.jobresour":`Toon alleen werkreserves`,
"vue_label_campaign_fromopprotunities":`Van {dsrjine} zakelijke kansen`,
"label.app.skyblue":`Hemelsblauw`,
"label.chinacloudcc":`Cloud Computing China`,
"label.connectOtherFinalNumber":`Objectlimiet bereikt<br/>U kunt maximaal vier objecten aan een aangepaste rapportgegevensbron koppelen.`,
"label.redistributionrequest":`Goedkeuringsverzoeken opnieuw toewijzen`,
"label.knowledge.category.button.one":`Subcategorie toevoegen`,
"label.campagin.pcandmo":`PC en mobiel`,
"label.project.milestone.date":`De mijlpaaldatum moet vallen binnen het datumbereik van het project waartoe hij behoort.`,
"assetbom.transfer.notpermission":`U heeft niet de bevoegdheid om asset BOM te migreren. Neem contact op met de beheerder.`,
"label.marketing.setting1":`Marketingkanalen`,
"label.select.file":`Selecteer het bestand`,
"message.error.object.contactadministrators":`Het systeem is abnormaal, neem contact op met de systeembeheerder voor hulp.`,
"label.custom.quarter.title":`Aangepaste kwart`,
"label.knowledge.case.settings":`Gevallen Instelling`,
"front-service-cloud-transfer-title":`Overdracht Activa BOM Eigenaar`,
"label.group.search.searchthisfeed":`Zoeken in deze feed`,
"label.report.action.addtodashboard5":`Toevoegen aan nieuw dashboard`,
"label.mobile.side.tab.remark2":`Bij het instellen van de schuifregelaar kunt u de meest gebruikte items vooraan zetten. belgeschiedenis, menu-item kan alleen worden gebruikt voor android versie van CloudCC aan de mobiele kant.`,
"contain":`Neem  op.`,
"label.select.template":`Selecteer Sjabloon`,
"label.addattachment.step3.weixin":`Stap 3 Klik op de knop "Voltooien" en ga terug naar de vorige pagina.`,
"lable.Order.successfully":`Overdracht order naar activa met succes.`,
"label.user.title":`Titel`,
"label.weixin.check.agreement":`Raadpleeg de desbetreffende overeenkomst`,
"label.SMS.pfi":`Telefoonnummer veld`,
"label.weixin.micro.research":`Micro-onderzoek`,
"label.projectManagement.assigned.work":`Toegewezen werk`,
"label.document.login.error":`Inloggen mislukt, probeer het opnieuw.`,
"label.mobile.phone.examines.people":`Herzien door`,
"label.safetyset":`Beveiligingsinstellingen`,
"label_function_tip":`Deze functie wordt momenteel niet ondersteund voor gebruikers op het Chinese vasteland. Wij waarderen uw begrip!`,
"label.app.sort":`Apps sorteren`,
"component.sendmail.label.cc":`Cc`,
"label.titlename":`Titel`,
"label.event.moveup.3day":`3 dagen vooruit`,
"label.condition":`Voorwaarden`,
"label.description.message":`Maximaal 500 tekens.`,
"label.ems.detailedsettings":`Gedetailleerde instellingen`,
"label.repeat.condition.field.prompt":`Vul een getal in bij "Volgens de lengte van de tekens" Filed！`,
"label.validate.function.funcExplain.OR":`Controleert of alle parameters waar zijn en geeft WAAR of ONWAAR terug. Geeft alleen FALSE terug als alle parameters onwaar zijn.`,
"label.salecommit.allow.prediction.query":`U kunt de dashboards van de verkoopcommitments niet bekijken omdat u de optie Prognoses toestaan uit Instellingen-Mijn persoonlijke gegevens-Persoonlijke instellingen niet hebt aangevinkt.`,
"front-kefu-moudle-soft-phone":`Softphone`,
"label.view":`Bekijk`,
"front-gantt-module-quick-create-task":`Snel een taak maken`,
"label.all_forms":`Alle vormen`,
"front-lightning-module-v1-dashborad-statistical-dimension":`Statistische dimensie`,
"label.forecast.settings.data.chanpin":`Product Datum`,
"label.appointment.wizard.subtitle4-2-7":`3 Dagen`,
"front-web-module-v1-detail-comment-please":`Geef de feedback`,
"label_chatter_nextSevenday":`Komende 7 dagen`,
"homepage.components.desctiption":`Op deze pagina kunt u componenten maken en bewerken die op een of meer lay-outs van startpagina's kunnen worden getoond.`,
"label.customcomponent.page.index.table.namespace":`Namespace Voorvoegsel`,
"label_emailtocloudcc_exists":`De e-mail bestaat al.`,
"label_tabpage_save":`Save`,
"label.mergeRechecking":`Dupliceren en samenvoegen van cheques`,
"vue_label_helpcenter_view2":`In de gesplitste scherm weergave, kunt u snel schakelen om de gedetailleerde informatie van elk gegeven te bekijken. <br> 3. Snel verkoopgegevens analyseren<br> In de rechterbovenhoek van de weergave, kunt u de grafiek in de weergave openen om een eenvoudige visuele analyse van de gegevens in de weergave uit te voeren. Tegelijkertijd kunt u het dashboard en de rapportagelijst met betrekking tot de gegevens in de weergave bekijken voor verdere analyse. <br> Klik op de grafiekknop in de rechter bovenhoek, en u kunt eenvoudige grafieken die zijn gemaakt met gegevens uit het overzicht bekijken, maken en bewerken, of dashboards bekijken die zijn gerelateerd aan het huidige overzicht. <br> Stap 1: Klik op de grafiek knop in de rechter bovenhoek om de grafiek uit te vouwen op de pagina. U kunt de bestaande grafieken bekijken en beheren volgens de rechten, en de lijst van dashboards bekijken die zijn gerelateerd aan de view data. <br> Stap 2: Klik op de Instellingen knop, u kunt grafieken maken, bewerken en verwijderen, afhankelijk van de permissies. U kunt vier stijlen van grafieken maken, verticale kolomgrafiek, horizontale kolomgrafiek, taartdiagram en trechterdiagram. <br> Klik op de Rapport knop om de rapporten te bekijken die betrekking hebben op de huidige weergave. <br> 4. Gegevens beheren in de view<br>?In de view kunt u, afhankelijk van uw bevoegdheden, gegevens toevoegen, bewerken, verwijderen en de eigenaar van de gegevens wijzigen via de knoppen rechtsboven in de view, of naast elk stukje gegevens. <br>Gebruik tags om uw gegevensbeheer te ondersteunen. Gebruik de knop aan de rechterkant om de lijst met tags uit te breiden, en u kunt de gegevens in de weergave filteren op basis van tags. Nadat u op Tags beheren hebt geklikt, kunt u ook uw tag bibliotheek onderhouden en beheren. Nadat u de gegevens hebt geselecteerd, gebruikt u de knop Tag toevoegen in de rechterbovenhoek om in batches tags aan de gegevens toe te voegen.`,
"label.app.ismobile":`Weergegeven op mobiele app`,
"chatter.group.changeTheGroupPicture":`Verander de groepsfoto`,
"label.mr.descreption.reDataList2":`verslagen van herhaalde`,
"vue_label_chatter_agree_join":`Akkoord om toe te treden`,
"label.planned.nextrun":`Run In Volgende Gepland`,
"Homepage.News.003":`Kan geen nieuws tonen zonder accountgegevens, maak een nieuwe account aan en het gerelateerde nieuws zal getoond worden.`,
"label.summaryreport.selectpictype":`Selecteer het grafiektype en andere grafische opties`,
"label.app":`Toepassingen`,
"label.trigger.name":`Trigger Naam`,
"vue_label_email_private_template":`Privé sjabloon`,
"label.appointmentpage.wizard.subtitle1":`Kies datum en tijd Inviter's tijdzone is {0}`,
"label.partnerCloud.orderingPlatform.payment":`Betaling`,
"label.stdashbord.xsld.title":`Verkoop trechter`,
"vue_label_pool_poolname":`Naam van de rekeningpool`,
"label.ServiceCloud.fuwuyuyue.distributionMap":`Distributiekaart van dienstafspraken`,
"front-lightning-module-v1-dashborad-target-value":`Streefwaarde`,
"label.reportsSubscriptionPage.email.keywords":`Zoeken na het invoeren van een trefwoord`,
"label.appointmentconfirmail.wizard.subtitle1":`Naam evenement`,
"label.limited_scanning":`Het toegangsbewijs is alleen voor het scannen om ter plaatse te registreren`,
"label.weixin.nomore":`Niet meer.`,
"february":`Februari`,
"label.view.filterbyowner":`Filter op eigenaar:`,
"label.contentType":`Document Uitbreiding`,
"label.customobjdel.master.hsiang":`Het Master-Detail relatieveld wordt in dit object aangemaakt, zodat u het niet kunt verwijderen.`,
"lable.Removal.succeeded":`Met succes verwijderd.`,
"label.weixin.end.incorrect":`Ongeldige einddatum`,
"label.email.cc.recipients":`Cc ontvangers`,
"label.taskevent.list":`Activiteiten Lijst`,
"label.formula":`Formule`,
"label.h5.new.errorheader":`Bekijk de fouten op deze pagina.`,
"label.emailobject.template.private":`Privé`,
"label.visualpage.component.n4":`4.Variabele. U kunt variabelen rechtstreeks gebruiken, en let op dat u geen enkele aanhalingsteken gebruikt.`,
"label.newemailnotice.step1":`Stap 1 Selecteer object`,
"label.chatter.file":`Bestand`,
"vue_label_checkduplicate_rules":`Regels voor duplicaatcontrole instellen`,
"label.appointment.wizard.subtitle1-6":`1.5 h`,
"label.customReportType":`Aangepaste rapportgegevensbron`,
"vue_label_email_with_accessories":`Emails met bijlagen`,
"label_efine_assessment_cycle":`Periode voor prestatiebeoordeling vaststellen`,
"label_emailtocloudcc_button_sure":`Bevestig`,
"label.forecast.userenablepage.isusing":`Ingeschakelde gebruikers`,
"lable.goal.description":`Doelomschrijving`,
"message.error.serviceresource.relatedrecordid":`Elke gebruiker kan slechts worden toegevoegd als één service resource van het type {0}`,
"label.weixin.addbus.information":`Voertuig informatie toevoegen`,
"label.emailtocloudcc.button.view":`Bekijk`,
"label.detail.workflow":`Bekijk workflows`,
"label.standardfilter":`Standaard Filters`,
"label.mobile.phone.results":`Prestaties`,
"chatter.feed.unavailabled":`Uitschakelen`,
"label.view.sortview":`Weergave sorteren`,
"label.availabilityobject.wizard.title":`Beschikbaarheid`,
"Main_Menu_Mobiledownload":`GA OP`,
"chatter.sticker":`Op rupsbanden`,
"label.workflow.intruduce":`Configureer de workflow van een organisatie door workflowregels te creëren. Elke workflow regel bestaat uit:`,
"label.customfields.richtext.tip":`Hiermee kunnen gebruikers opgemaakte tekst invoeren en afbeeldingen en links toevoegen. Tot 32.768 tekens op afzonderlijke regels.`,
"label.new.cy.select":`Kies een nieuwe valuta uit de beschikbare lijst.`,
"template.chart.schdzqzkhzhqk":`Leads Conversie in Campagnes`,
"label.forecast.customforecast.cpxl":`Product Familie`,
"front-electronic-signature-open-service":`De Ehandtekening inschakelen`,
"label.datamanage.import.field":`Import velden`,
"chatter.email.sendMessageToMe":`Stuurt me een bericht`,
"message.cannotusebefore":`Let op: u kunt dit goedkeuringsproces pas gebruiken nadat het is geactiveerd.`,
"label.textmessage.vonage.api.secret":`API-geheim`,
"label_chatter_newEvent":`Nieuw evenement`,
"label.ji.year":`{een} jaar`,
"label.sendmail.step2":`Stap 2 Kies een e-mail sjabloon`,
"label.console.step5.record":`records open`,
"label.customfields.totalsummary.gettogetherfield.isnull":`Selecteer een veld om te aggregeren`,
"vue_label_commonobjects_detail_current_recorder":`De nieuwe eigenaar zal ook eigenaar worden van de registers die met dit project verband houden, en deze registers zijn eigendom van de huidige archivaris`,
"label.SMS":`SMS-berichten`,
"label.reconfigure.bundle":`Herconfigureer het pakket`,
"front-kefu-select-region":`Selecteer het gebied waar de instantie zich bevindt`,
"chatter.feed.deletefeeds":`Weet je zeker dat je dit bericht en de reacties wilt verwijderen?`,
"label.customsetting.manage.introduce.h":`Als de aangepaste instelling een hiërarchie is, kunt u gegevens toevoegen voor het gebruikers-, profiel- of organisatieniveau. U kunt bijvoorbeeld verschillende waarden laten weergeven afhankelijk van of een specifieke gebruiker de app uitvoert, een specifiek profiel of gewoon een algemene gebruiker.`,
"label.product.name":`Productnaam`,
"vue_label_commonobjects_view_saveas":`Opslaan als`,
"label.group.my.archived":`Mijn gearchiveerde groepen`,
"vue_label_pool_coflictmethods":`Conflict met huidige verkoopmodus`,
"label.appupload.upload":`Upload`,
"lable.SalesCommitmentKanBan.signedTaskRate":`Ondertekende taak voltooiingspercentage`,
"label.dashboardStandard":`Standaard dashboards`,
"label.niboer.time":`Nepal Tijd`,
"label.emailtocloudcc.filed.email":`E-mail`,
"market.name.social.post":`Sociale Berichten`,
"evaluation.detail.notfound":`Commentaar is niet gevonden`,
"label.layoutoftestobj":`Test object indelingen`,
"label.example":`Voorbeelden`,
"label.campaign.channel.step6.remark6":`bezoek dan hier`,
"chatter.emailLike":`Houdt van`,
"label.knowledge.category.button.two":`Categorie bewerken`,
"label.alluser":`Alle Gebruikers`,
"addadvancedconditions":`Geavanceerde voorwaarden toevoegen`,
"message.selectgsummarycondition":`selecteer de samenvattende criteria`,
"message.duplication.label.sectionremar2":`Nota: Alle gerelateerde records, met inbegrip van notities, bijlagen en activiteiten zullen worden geassocieerd met de nieuwe samengevoegde record.`,
"vue_label_helpcenter_product&pricebook":`Producten zijn uw basiscatalogus voor alle artikelen en diensten die u verkoopt en hun standaardprijzen. Met de prijslijst kunt u een aangepaste verzameling maken van product- en bijbehorende lijstprijzen voor specifieke gebruikers.`,
"message.duplication.label.isprofile":`Met toestemming.`,
"component_setup_label_milestonesfield":`Mijlpaal veld`,
"setup_layout_label_required":`Vereist`,
"component_chatter_label_title":`Laatste bericht`,
"label.assignment.setup.detail.order":`Sorteer volgorde`,
"vue_label_pool_unassigned":`Niet-toegewezen`,
"UG_Lead_007":`Google sync`,
"label.knowledge.record":`Er bestaan geen relevante gegevens!`,
"label_tabpage_filetypez":`Bestandstype`,
"label.ccpeak.if.error.message":`Indien er een fout terugkomt: gebruik`,
"label.intialsubmitter":`Initiële indieners`,
"label.wei.icon":`Icoon`,
"label.mask.show.last.4":`Masker laatste vier tekens`,
"lable.PowerProcess.time.trigger":`Tijd Trigger (min)`,
"july":`Juli`,
"label.usestandardwizard":`Standaard installatiewizard gebruiken`,
"label.two.quarter":`Tweede kwartaal`,
"label.size":`Maat`,
"label.integrations.mailchimp.massage4":`Mailchimp is momenteel niet geïnstalleerd. Installeer Mailchimp in "Integraties"`,
"label_emailtocloudcc_step2total3":`Stap 2 van 3`,
"vue_label_chat_customer_group_strategy":`Klantenteam`,
"label.searchvalue":`Waarden vinden`,
"label.sendemail.birthday.title":`Verjaardag Herinnering`,
"label.projectManagement.planned.days":`Planning dagen (dag)`,
"label.service.gantt.workhours":`Gebaseerd op arbeidsuren`,
"label.notification.approval5":`Gedelegeerde goedkeuring: 【提交人】 vraagt de 【对象】 goedkeuring aan`,
"label.service.miniProgram.bindAddressDesc":`CloudCC Officieel Klanten Service Mini Programma Portaal:`,
"chatter.error.wt":`Fout: Ongeldig bestandstype.`,
"vue_label_calendar_my_calendar":`Mijn kalender`,
"label.customername":`Naam van de rekening`,
"label.salescloud.salesdashboard.huikuan.rankings":`Team-betaling klassement`,
"message.query.opportunity.contactrole.error":`Het opvragen van de standaard rol van contactpersoon is mislukt, neem contact op met de beheerder!`,
"noequal":`niet gelijk aan`,
"label.document.searchcustominfo":`Voer trefwoorden in om overeenkomende documenten te vinden.`,
"label.account.PreviousFQ":`Vorige FQ`,
"label.file.f":`Bestanden`,
"label.dashboard":`Dashboards`,
"label.report.folder":`Mappen`,
"batch.edit.permission.list":`Geen toestemming om de gegevenslijst te bewerken`,
"label.file.orderbyowner":`Gesorteerd op eigenaar`,
"label.exchange.sync.account.password":`Service account wachtwoord:`,
"pagecreator.button.publish":`Publiceren`,
"label.modify":`Bewerken`,
"label.exchange.sync4":`Staten`,
"label.remark.information":`Beschrijving Informatie`,
"label.service.without.major.event":`Geen belangrijke gebeurtenis weer te geven`,
"label.knowledgebase.release.status":`Status publiceren`,
"label.tabpage.ok":`Bevestig`,
"label_screening_assessment_content":`Filter beoordelingsinhoud`,
"label_partner":`Partner wolk`,
"label.user.detail":`Gebruikers bekijken`,
"front-kefu-moudle-or-this":`of, zoals dit?`,
"label.unselect.object":`Optioneel Object`,
"label.quote.contactfax":`Fax`,
"label.weixin.appmanage.alert":`Druk op {0} om een app te verwijderen uit Mijn Apps, Druk op {1} om een app toe te voegen aan Mijn Apps.`,
"vue_label_dashboard_thisfolder":`Voeg publiek dashboard toe aan deze map`,
"label.delete":`Delete`,
"label.appexchange.installedpage.message1":`U kunt applicaties direct in de CloudCC App Store bekijken en downloaden en ze in uw CloudCC.com omgeving installeren.`,
"label.mobile.phone.required.summary":`Samenvatting is vereist`,
"label.batchadd.newbatchpage.addtr":`Er kunnen maximaal 30 records worden toegevoegd.`,
"label.partnerCloud.partnerAccount.lockLine":`Vergrendeld bedrag`,
"label.emailsync.status.connectstatus":`Verbindingsstatus`,
"label.campaignmember.main.importmember.lead":`Leden-Leads importeren`,
"message.username.isnull":`U moet een waarde invoeren voor de gebruikersnaam.`,
"label.forecast.tree.enableuser":`Gebruikers inschakelen`,
"label.multilang.view.viewmessage":`Deze weergave is toegepast op het mobiele toestel. Er kunnen maximaal 10 velden worden gekozen, er zijn er nu {0}:`,
"friday":`Vrijdag`,
"label.sendemail.activity.neweventtitle":`Nieuw evenement melding`,
"label.page.addtabto.user":`Voeg het tabblad toe aan bestaande persoonlijke aanpassingen`,
"front-kefu-moudle-v1-connect-phone":`Telefoonnummer medewerker`,
"label.wei.pollis":`Stem voor`,
"lable.opppdt.editPdt.title":`Bewerk Opportunity Producten`,
"label.permission.objectpermission.recordfenpei":`Record Type Toewijzing`,
"pagecreator.layout.message.delete.success":`Lay-out succesvol verwijderd`,
"label.dataimport.isdupecatcher":`Filters uitvoeren`,
"label.deletelayout.tip":`Om een paginaopmaak te verwijderen, moet u een andere kiezen om deze door te vervangen.`,
"label.projectManagement.No.matching.data":`Geen overeenkomende gegevens.`,
"pagecreator_page_message_delete_success":`Pagina succesvol verwijderd`,
"label_tabpage_equalz":`Gelijk aan`,
"label.ems.emailsetup":`Instelling e-mail`,
"label.decimaldigits":`Decimale plaatsen`,
"component.chatter.button.delete":`Delete`,
"label.isallowreport":`Rapporten toestaan`,
"label.view.appliedMobile.message":`Vink dit aan, Stap 3. Selecteer de velden die moeten worden weergegeven, en u kunt maximaal 6 velden selecteren`,
"label.must.positive.integer":`Het getal moet een geheel getal zijn.`,
"label.preview.print.template":`Voorbeeld van afdruksjabloon`,
"label.schedulejob.setup.schedule.start":`Start`,
"UG.Case.04":`Geval opdracht`,
"vue_label_pool_move1":`{1}{2}`,
"label.list.userinterface.enableHoverDetails":`Schakel details in`,
"vue_label_email_alltemplates":`Alle sjablonen`,
"label_report_chose_obj":`selecteer object relatie en rapport gegevensbron`,
"label.partnerCloud.productSet.del":`Item verwijderen`,
"label.quote.shrdz":`Adres van de ontvanger`,
"page.approval.history":`Goedkeuringsgeschiedenis`,
"lable.outlook.detail.prefc":`Altijd de voorkeur aan CloudCC.com`,
"label.translation.unable.display.view":`Kan weergave niet weergeven`,
"label.encrypt.change":`Gecodeerd type omzetten`,
"button.partner.workspace.login.logo.upload":`Afbeelding uploaden`,
"label.batchadd.mustinput2":`is vereist, kan dit record niet worden opgeslagen als de vereiste informatie leeg is.`,
"label.dataimport.update.error.check":`Er is een fout opgetreden bij het bijwerken van de gegevens. Gelieve deze gegevens zorgvuldig te onderzoeken.`,
"label.staticresource.name.already.exists":`De unieke naam van de statische bron bestaat al!`,
"label.appupload.upload.install.success":`Met succes geïnstalleerd`,
"label.conditiontag.lookup.true":`TRUE`,
"label.quickbooks.viewlist.customer":`KLANT`,
"label.field.edit.change2":`De hoogste score is ten minste 1`,
"label.fianalrejectoperate":`Definitieve afwijzingsacties`,
"label.ccpeak.wgd":`Niet-ingediende Klassen`,
"label.reportsSubscriptionPage.condition.emailreport":`Samenvatting   verslag`,
"label.detailinf":`Details`,
"label.eastem.standard.time":`Eastern Standard Time`,
"chatter.group.manager":`Manager`,
"label.manage_columns":`Koptekst beheren`,
"label.daylight.time":`Daglichttijd`,
"label.weixin.mycar.information":`Mijn voertuigen`,
"label.ccpeak.help":`Hulp voor Klassen`,
"lable.outlook.detail.match":`Bijbehorende criteria`,
"label.version.nonsupport.approval":`Goedkeuringsprocessen worden tijdelijk niet ondersteund.`,
"label.custom-tailor":`Aanpassen`,
"label.showoperate":`Toon acties`,
"label.view_edit":`Bekijken en bewerken`,
"label.lead.score.prompt2":`Selecteer het scorings bereik en klik op de knop [Lead Scoring], waarna het systeem de geselecteerde leads zal scoren volgens de actieve Lead Scoring Regel.`,
"label.datamanage.savetemplate.error":`Sjabloon opslaan mislukt.`,
"label.source":`Bron`,
"label.multilang.customfieldsetup.reference":`Naar dit veld wordt verwezen door {0}`,
"chatter.poll.option7":`Keuze 7`,
"label.login.access.day":`dag(en)`,
"label.icon.66":`Uitrusting`,
"label.tabpage.kanbansetup":`Viewboard setup`,
"label_emailtocloudcc_step1_lead2":`Eenmaal geconfigureerd, zullen mails die in deze mailbox worden ontvangen automatisch worden gelogd als lead records in CloudCC. Zorg ervoor dat er geen deals worden gemist.`,
"label.partnerCloud.partnerAccount.numericValue":`Het herlaadbedrag is een numerieke waarde.`,
"label.permission.detail.app.object.tip":`Objecten, Velden en Tabbladen Toegangsinstellingen`,
"label.emailobject.template.subject":`Onderwerp`,
"template.report.month.customer":`Rekeningen van deze maand`,
"label.weixin.formerly":`In het verleden`,
"label.contract":`Contracten`,
"label.help":`Help`,
"vue_label_homepage_setdefault":`Instellen als standaard startpagina`,
"label.icon.52":`Stroomopwekking`,
"label.customfields.file.count":`Het aantal bestanden`,
"UG_Account_07":`Account importeren`,
"label.addattachment.ntko":`Online bewerken`,
"label.service.ganttBaiduMap.assign.service":`Aan deze persoon een dienstopdracht geven`,
"vue_label_file_my_file":`Mijn dossier`,
"label.custom.page.hide":`Verberg`,
"label.addexistoperate":`Bestaande bewerking toevoegen`,
"label.already.startdate":`Begintijd`,
"label.partnerCloud.financeSetting.alipay":`U moet openen Alipay zakelijke rekening. Alleen zakelijke rekening wordt ondersteund om als ontvangstrekening te dienen. Transactie kosten zullen worden gebracht door Alipay aan de begunstigde.`,
"label.dashboard.summary.editPageFooter":`Footer bewerken`,
"label.category.8":`Consumentengoederen`,
"label.forecast.customforecast.foretype.best":`Beste geval`,
"message.validation.isnull":`Voer een waarde in`,
"label.savewxpay.failure":`Kan informatie van WeChat-betalingshandelaar niet opslaan`,
"label.file.stop.sharing.desc1":`Stop met delen met`,
"label.opportunity.setting.showstage。read.info":`De kansfasen kunnen niet handmatig worden gewijzigd na het aanvinken van`,
"UG_Campaign_003":`Creëer een campagne`,
"label.edit.field.select.showoptions":`Toon alle opties`,
"message.inputplatformpwd":`Voer Admin-Wachtwoord in`,
"vue_label_systemSettings_mobel_set":`Mobiele app instellen`,
"label.projectManagement.thefirstone":`Dit is de eerste plaat`,
"label.data.newtemplate":`Sjabloon voor gegevensexport maken`,
"label.monitorsys.delete.log":`Sleutel operatie audit log`,
"label.template":`Sjablonen`,
"Lead.Auto.Scoring.Setting.001":`Automatisch scoren bij bewerken of opslaan (behalve de leads die batchgewijs zijn geïmporteerd of aangemaakt door de interface)`,
"label.operatesuccess":`Operatie geslaagd.`,
"label.send":`Stuur`,
"chatter.yp":`Verberg Feed`,
"label.overall_responses":`Totale respons`,
"vue_label_systemSettings_server_report":`Service Rapport`,
"label.icon.113":`Huis`,
"label.partnerCloud.basicSetting.domainSet":`Domeinnaam instellen`,
"label.login.access.text":`Ter ondersteuning kunt u de beheerder toegang verlenen om in te loggen en uw gegevens te bezoeken.`,
"vue_label_report_addrowlevelformula":`Formule op rijniveau toevoegen`,
"message.duplication.label.mergeTitle":`Mijn samenvoegen`,
"label.event.add":`Evenement toevoegen`,
"vue_label_homepage_bigscreen_light":`Licht`,
"setup.chatter.enabled":`Niet beschikbaar, neem contact op met de beheerder om CCChat in te schakelen.`,
"label.inputreceiver":`U kunt maximaal vijf (5) e-mailadressen opgeven om op de hoogte te worden gebracht. Elk e-mailadres wordt gescheiden door ";".`,
"label.custom.page.custom.page":`Aangepaste pagina's`,
"label.data.exp.csv":`CSV-formaat`,
"label.searchlayout.view.example":`Voorbeeld bekijken`,
"label_tabpage_fullscreenz":`Volledig scherm`,
"label.tabpage.last":`Laatste stap`,
"lable.outlook.mcto.accepemail":`Mijn beschikbare e-mailadressen`,
"front-electronic-signature-isopen":`Actief`,
"vue_label_commonobjects_detail_earlier":`Bekijk eerder`,
"label.name.cannot.greater.str":`Naam kan maximaal 255 tekens bevatten.`,
"label.weixin.activity.email":`Activiteit: E-mail`,
"label.tabpage.unequalz":`Ongelijk aan`,
"label_calendar_year":`Kalenderjaar`,
"label.appupload.upload.installor":`Geïnstalleerd door`,
"label.jixiaoswitchon":`Uitbreiden`,
"label.user.congratulations.send.finish":`Gefeliciteerd, voltooide massa e-mail.`,
"label.customsetting.touse.getListCustomSetting2":`Vraag de gegevens van het type aangepaste instellingen op, geef enkele gegevens terug die overeenkomen met de API-naam. Map map = cs.getListCustomSetting(String apiName, String Name);`,
"label.recordtype.masterrecordtype.selectedTip":`Het hoofdrecord type kan niet worden toegewezen aan het profiel waaraan reeds een recordtype is toegewezen.`,
"label.tippage.li3":`Zodat alle dashboard onderdelen die gebaseerd zijn op het rapport van de storing zijn verwijderd`,
"label.weixin.no.name":`Geen onderwerp`,
"label.tabpage.viewz":`Huidige weergave afdrukken`,
"label.create_contacts":`Lijst van contactpersonen maken`,
"vue_label_homepage_operationitem":`Selecteer een knop`,
"label.pc.ui.2018.switch.version":`Overschakelen naar versie`,
"label.salescloud.teamrole.main":`Belangrijk contact`,
"label.reportsSubscription.format.report":`Opgemaakt rapport (Excel-formaat .xlsx)`,
"label.forecast.customforecast.total":`Bedrag`,
"label.quickbooks.fieldlabel.lastname":`Achternaam`,
"label.appointment.wizard.title2":`Details vergadering`,
"label.project.template.one":`Het creëren van een project vanuit een project sjabloon duurt 2~3 minuten. Dank u voor uw geduldig wachten.`,
"label.timetrigger.workflow":`Wanneer de workflow actief is.`,
"label.projectManagement.creator":`Schepper`,
"label.customfields.formula.selectreturnfieldtype":`Selecteer het formule-retourtype`,
"label.list.userinterface.dashboard.enable":`Nieuwe Dashboard-onderdelen inschakelen`,
"label.email.delete.html.format":`Alle html formaten zullen worden verwijderd. weet je het zeker?`,
"label.appupload.install.modifyapi":`Wijzig de conflicterende api-naam:`,
"label.chat.add.topics":`Een onderwerp toevoegen`,
"label.savepartner.fail":`Opslaan van instellingen voor Partner Cloud mislukt`,
"label.pc.query.new":`Bekijk uw laatste`,
"message.duplication.label.editfiltertitle":`Duplicaat zoeken Filter bewerken`,
"label.task":`Taken`,
"label.emailobject.emaildetail.title.toaddress":`Naar:`,
"label.setup.mobile.bottombutton.select":`Selecteer de 4 pagina's op het eerste niveau die je wilt tonen op de mobiele app`,
"label.loginip.pagecue.invalido":`Ongeldig internetadres`,
"label_tabpage_listshow":`De lijst toont`,
"component.newrecords.label.10records":`10 records`,
"label_chatter_file":`Bestand`,
"pagecreator.systemstyle.label.detailcolor":`Detail tekst kleur`,
"label.forecast.userenablepage.title":`Voorspellingen Gebruikers`,
"front-project-module-v1-actual_working_hours":`Gerapporteerde manuren`,
"vue_label_systemSettings_Security":`Beveiliging Inperking`,
"label.processsetting.two.select.key.fields":`Stap 2: Selecteer sleutelvelden voor elke stap in het proces en geef begeleiding`,
"label.page.display1":`Records per pagina`,
"label.appointmentpage.wizard.subtitle1.2":`De tijdzone van de uitzender is {0}`,
"label.ggReleaseRange.searchTeam":`Zoek openbare groep`,
"chatter.group.searchGroup":`Typ een groepsnaam...`,
"label_card_type":`Kaartindeling`,
"label.appupload.managed.tip":`Gecontroleerd worden betekent dat je alleen bepaalde attributen kunt bewerken.`,
"label.changemyshow":`Mijn scherm veranderen`,
"label.custom.CustomQuarter":`Aangepaste kwart`,
"label.tobedelete":`Te verwijderen`,
"label.newPage.unuse":`Uw pagina is verloren.`,
"label.product.pricebooks":`Prijs Boeken`,
"label.mobile.layout":`Pagina-indelingen voor mobiele apparaten`,
"label.multilang.file.items":`{0} projecten:`,
"label.app.step4.tabused":`Geselecteerde tabbladen`,
"label_ccchat_create_account":`Maak een account aan`,
"message.startusingprocess":`Na het activeren van dit goedkeuringsproces, kunt u geen goedkeuringsstappen meer toevoegen of verwijderen. Ook kunnen sommige kenmerken van goedkeuringsstappen niet worden bewerkt. Weet u zeker dat u wilt doorgaan?`,
"vue_label_email_please_add_a_theme":`Voeg een thema toe voordat u het opslaat als een sjabloon`,
"label.please.create.a.target.record.first.":`Maak eerst een indicatorrecord aan`,
"label.processsetting.set.objandfile":`Stap 1: Selecteer objecten en velden waarop u het proces wilt instellen`,
"label.newreport.group.data":`groep (s）)`,
"label.notcreatenew":`Creëer geen nieuwe kans bij conversie.`,
"lable.custom.CurrentandPreviousCY":`Huidige en vorige CY`,
"front-epwechat-module-v1-input-androidschema":`Voer Android schema in`,
"label.projectManagement.unfinished.quantity":`Onvoltooid Aantal`,
"label.visualpage.idandname":`Pagina ID en Pagina Naam is:`,
"label.approvingprojects":`Goed te keuren punten`,
"label.partnerCloud.financeSetting.weChat":`WeChatservice moet worden geopend en de overeenkomst voor het verzamelen van diensten met Tencent is vereist. Transactie kosten zullen door Tencent in rekening worden gebracht aan de begunstigde.`,
"label.quickbooks.viewlist.view":`Bekijk`,
"label.knowledge.category.hint.ten":`Inactieve Categorie Groep`,
"report_type_label_productPricebooks":`Producten en Prijsboeken`,
"label.fenbeitong.description":`Controleer en activeer het FenBeiTong reisaanvraagformulier om werknemers te helpen bij het aanvragen van zakenreizen en de terugbetaling van reis
kosten`,
"label.ccchat.upload.change":`Wat is er veranderd? (facultatief)`,
"label.emailsync.status.log":`Verbindingslogboek`,
"label.addnew":`Nieuw toevoegen`,
"UG_contact_05":`Een contactpersoon maken`,
"label.appupload.componet.queryerror":`Er is een fout opgetreden bij het zoeken naar het omponent. Neem contact op met uw beheerder.`,
"label.salescloud.setting":`Team Verkoop Setup`,
"label.recurrencetimetriggeroperate":`Periodieke tijdriggerende acties`,
"label.event.moveup.4day":`4 dagen vooruit`,
"No.Hisitory.Activity":`Geen historische activiteit`,
"label.validate.function.funcFormat.MINUTE":`MINUUT(datum)`,
"label.recentview.seloption3":`Onlangs gewijzigd`,
"label.login.access.nopermission":`--Geen toegang.`,
"label.taskmenuandlink":`Taakknoppen en links`,
"label.forecast.customforecast.foredis.sbw":`Miljoenen`,
"lable.PowerProcess.created.event":`mijlpaal creëren`,
"label.stdashbord.xsld.funnelchat":`Verkoop trechter diagram`,
"label.step1.total7":`Stap 1 van 7`,
"label.sendsms.batch.chosepersion":`Mass SMS: Selecteer de ontvangers`,
"Lead.Scoring.Setting.Rule.Setup.Value":`Score`,
"label.ccdocument.isdel.folder":`Weet u zeker dat u deze map wilt verwijderen?`,
"label.discard_change":`Ja, gooi veranderingen weg`,
"label.knowledgebase.assign":`Toewijzen`,
"PersonalInfo_LoginHistory_001":`Broswer valideert de registratielink in uw mailbox`,
"label.globalselect.deletedvlaue":`Globale waardeset verwijderd`,
"label.ems.lookup2":`Zoeken op`,
"label.dataimport.system.unable.determine":`kan het systeem niet bepalen of het verlies`,
"label.weixin.invitation.consultant":`Uitgenodigd adviseur`,
"label.salescloud.salesdashboard.phone.rankings":`Kiezen`,
"label.knowledgebase.plan.release":`Plan om te publiceren`,
"label.integrations.first.half":`Het huidige uitzicht in totaal`,
"label.icon.123":`Eerste Hulp Kit`,
"label.leadscore.isactivity":`Actief`,
"front-epwechat-module-v1-corpid":`WeCom ID (Corpld)`,
"label.createnewcustomer":`Nieuw account`,
"front-lightning-module-v1-details-page-chart-tittle":`U kunt grafiek en diagrammodules invoegen in de detailpagina, en u kunt tot 10 rapportgrafieken invoegen. U kunt bijvoorbeeld een rapportgrafiekmodule toevoegen voor een record met het recordtype Agent in het object Rekeningen, grafieken toevoegen van het verkoopbedrag van de agentorder en het kwartaalverkooprapport van de agent aan de module, en filteren op de accountnaam om gerelateerde gegevens direct op de detailpagina van de agentrekening te bekijken.`,
"label.customobjects.fieldsrelation":`Aangepaste velden en relaties`,
"label.dashboardSetup.left":`Links`,
"label.mobile.app.sectionpart":`Mobiele App Sectie`,
"setup.mainpage.label.welcome25":`Instructies: Klik op het menu aan de linkerkant van deze pagina → Instellingen beheren → Beveiligingscontrole → Instellingen delen.`,
"label.custombutton.edit.error":`Fout: De naam is al in gebruik of is al eerder gebruikt, kies a.u.b. een andere naam.`,
"label.icon.48":`Uitlaatventilator`,
"label.tabularreport.step2":`Stap 2 Selecteer de kolom van het rapport`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.two":`Twee`,
"UG_quota_01":`Beheer rekeningoffertes`,
"label.customcomponent.btn.usewhere":`Waar wordt dit gebruikt?`,
"label.quickbooks.searchresault.email":`E-mail`,
"label.emailobject.appointment.urltext2":`reserveer hier een tijd`,
"label.tianyancha.field.relation.error":`Stel eerst de mapping relatie in tussen het tianyancha veld en het klant veld`,
"APPIntegration_Social_facebookerror":`U moet een geldige URL voor facebook.com invoeren`,
"label.notification.arketsea.transfer":`{5} verplaatst {0}：{1} van {2} naar {3}`,
"lable.SalesCommitmentKanBan.allreceivingTaskRate":`Totale ontvangsten Taak Voltooiingspercentage`,
"UG.Account.04":`Passieve query account filtering`,
"this.week":`Deze week`,
"label.email.track.attachment.num.control1":`Aantal geüploade bestanden overschrijdt 10,en kan niet worden geüpload`,
"label.exchange.sync.state.event":`Evenementen`,
"vue_label_systemSettings_websitesetting":`Web Instellingen`,
"vue_label_file_replace_reason":`Reden voor vervanging`,
"label.version.feature":`Kenmerken`,
"E":`E-mail`,
"label.escalation.setup.entrydetail.escalation.notifyTemplate":`Sjabloon`,
"label.chosesubject.meet":`Heb een vergadering`,
"UG.ST.003":`U heeft geen toestemming om {0} aan te maken, neem contact op met de beheerder, klik op bevestigen om direct naar de {0} interface te gaan.`,
"label.authorization.failure":`Autorisatie mislukt. Gelieve opnieuw te autoriseren!`,
"label.newprocessstep3":`Stap 3 Specificeer de eigenschappen voor het goedkeuringsveld en de bewerkbaarheid van records`,
"lable.outlook.mcto.mostrecord":`Record met de meeste activiteiten`,
"vue_label_normal_select":`Selecteer`,
"label.partner.workspace.login.buttontext":`Knop tekst`,
"template.chart.ydschdtj":`Maandelijkse campagnestatistieken`,
"label.ServiceCloud.zichanmingcheng":`Naam activa`,
"label.productsales.oppor.nooverdue":`Goed werk, geen achterstallige kansen.`,
"label.appointment.wizard.subtitle3-5":`Vrijdag`,
"label.payment.the.current.version":`Huidige abonnementseditie`,
"label.reportlist.top":`Vast aan de bovenkant`,
"label.emailobject.emaildetail.prompt":`Prompt`,
"label.weixin.endst":`Eindtijd kan niet voor de begintijd liggen.`,
"report_label_knowcreatehighlevelreport":`Hoe maak ik een geavanceerd rapport?`,
"label.quickbooks.view.openestimates":`Open Schattingen`,
"label.url.cannot.empty":`URL kan niet null zijn!`,
"label.emailnoticetemplate":`Email Notificatie Sjablonen`,
"calendar.tips.task":`Geen taak vandaag`,
"label_partner_all_operate":`Operatie`,
"message.duplication.label.cancelbutton":`Annuleren`,
"vue_label_SMS_addcontact":`Contact toevoegen`,
"label.martrixreport.setsumfield2":`Selecteer het veld dat gebruikt wordt als overzichtskolom in uw matrix rapport`,
"approval_request_email_body":`Voor de volgende items is goedkeuring nodig. Klik op de link hieronder om ze goed te keuren.`,
"label.emailobject.emaildetail.field.record":`Record`,
"label.tab.page":`Pagina`,
"label_tabpage_prepagez":`Weergave op elke pagina`,
"label.iran.daylight.time":`Iran Standaard Tijd`,
"label.event.nextweek":`Volgende week`,
"fliter.lastmonth":`Vorige maand`,
"label.group.no.recent.search":`Er zijn geen overeenkomende recent bekeken groepen.`,
"label.h5.act.confirm":`Bevestig`,
"label_tabpage_mypotentialcustomers":`Mijn aanwijzingen`,
"label.tabpage.queuez":`Wachtrij`,
"label.batch.edit.description":`Selecteer de velden die u wilt bewerken, selecteer ten minste één veld en maximaal 5.`,
"label.batchadd.newbatchpage.deltr":`Blijf tenminste aan de lijn.`,
"label.industrialandcommercialverification.instructions2":`De versie die u gebruikt is gratis, en het maximum aantal queries is 10.000 keer per dag. Als u het aantal query's wilt uitbreiden, wordt het aanbevolen om de service aan te schaffen. Nadat u de service hebt gekocht, krijgt u het token van de verkoper, stel het in op deze pagina. De verkoper zal blijven om u te voorzien van de bijbehorende betaalde service.`,
"label.rejectrequestbehaviour":`Voer alle afkeuringen <strong>en</strong> alle definitieve afkeuringen voor deze stap uit. (Eindafwijzing)`,
"label.batchCopy":`Batch kloon`,
"label.service.two":`Sommige filters zijn wel gedefinieerd, maar worden niet genoemd in Geavanceerde filters.`,
"label.data.import.setup.detail.remark":`Als u de volgende opties aanvinkt, wordt dit uitgevoerd in de importgegevens.`,
"vue_label_file_delete_lib":`Bestandsbibliotheek verwijderen`,
"label.integerdigit":`Het aantal cijfers links van het decimaalteken`,
"label.profile.standardobjcontrol":`Standaard Object Rechten`,
"label.reportrecords":`Records`,
"label.noplan":`U heeft geen evenementen gepland voor de komende 7 dagen.`,
"label.visualpage.ytype":`Dashboards`,
"label.branch":`;`,
"label.knowledgebase.new.article":`Nieuw artikel`,
"label.Addressbook":`Contacten`,
"label.delete.reward.groups":`Groep citaatregels verwijderen`,
"label.appexchange.uninstallpage.message1":`Verwijder permanent alle componenten in dit pakket （die hieronder staan）`,
"chatter.group.everyone":`Alle Gebruikers`,
"label.cooperation":`Samenwerking`,
"label.uploadfail":`Uploaden mislukt`,
"to":`naar`,
"button_partner_delete":`Delete`,
"attachment_select_warning_001":`De bijlage is gearchiveerd en de knop Archiveren is niet beschikbaar, gelieve opnieuw een bijlage te selecteren.`,
"label.step4.total4":`Stap 4 van 4`,
"label.login.access.avalid":`Verloopt vandaag`,
"label.defaultview2":`Gepinde lijst`,
"vue_label_commonobjects_detail_style":`Stijl kopen`,
"label.selectfield":`Selecteer Velden`,
"label.report.select.column.collect":`Selecteer de kolom die u wilt samenvatten`,
"lable.currencyAdv.newdaterate.existeddate":`De datum wordt al gebruikt voor HKD. Geef een andere begindatum op.`,
"pagecreator_systemstyle_button_new":`Nieuwe stijl`,
"label.ccchat.person.invite":`Uitnodiging collega`,
"label.sendemail.recycle.clear":`Duidelijk recyclen`,
"label.usermanage.view.notexist":`Het uitzicht bestaat niet`,
"setup_chatter_enabled":`Niet beschikbaar, neem contact op met de beheerder om CCChat in te schakelen.`,
"UG.Contract.01":`Contract beheren`,
"label.martrixreport.2018.step4":`Stap 4 Kies rapportcriteria`,
"message.errorinscript":`Problemen met het uitvoeringsscript.`,
"label.knowledgebase.modification.date":`Gewijzigde datum`,
"label.projectManagement.the.maximum.number.of.fees.is.10":`Tot 10 cijfers kunnen worden ingevoerd voor de kosten`,
"label.list.isActiveNewApproval":`Nieuwe goedkeuringspagina inschakelen`,
"label.mobile.main.page.icon.setup":`Instellingen pictogrammen mobiele app`,
"label.select.customer":`Account kiezen`,
"label.sharerule":`Instellingen delen`,
"label.fiscal.FY":`Fiscaal Jaar`,
"label.appupload.component.type.customfield":`Aangepast veld`,
"label.emailobject.emailsend.sendindividually":`Individueel verzenden`,
"label.new_formname":`Nieuwe formuliernaam`,
"label.appointment.wizard.notif1":`De eindtijd mag niet vroeger zijn dan de begintijd`,
"front-console-conversation-evaluate-desc":`Evaluatierespons van {evaluateInfoName}`,
"homepage.components.lasttime":`Laatst Gewijzigde Datum`,
"vue_label_commonobjects_view_chart_deletechart":`Grafiek verwijderen`,
"label.multilang.document.upload.fail":`{0} bestanden zijn succesvol geuploadt en {1} bestanden zijn mislukt`,
"UG_contact_03":`Contacten volgen op één plaats, verkoopsignalen`,
"label.marketsea.istoseafromother":`Sta overdracht toe van andere loodpools`,
"label.datamanage":`Gegevensbeheer`,
"label.globaloperation.operationtype.create.data":`Record aanmaken`,
"label.customer.tab.step2.see":`Tab Zichtbaarheid`,
"label.wtd.changefields.desc":`Nadat gebruikers het formulier hebben verzonden, worden ze naar de opgegeven retour-URL op uw website geleid, zoals een "dank u"-pagina.`,
"label.ems.eamilinfo":`Email informatie`,
"label.recordtypeselect.new":`Nieuw recordtype`,
"vue_label_report_output":`Formule uitgangstype`,
"label.emailnotice":`Waarschuwing per e-mail`,
"label.icon.196":`Toiletpapier`,
"label.emailsync.status.disabel":`Inactief`,
"label.tabpage.isdeleterecord":`Als u de geselecteerde record verwijdert`,
"message.selectoneoftypes":`Gelieve een van de volgende types te kiezen`,
"label.import.index.createid":`Maak ID`,
"vue_label_systemSettings_social2":`Instelling account sociale media`,
"label.ccpeak.sel.time":`Geplande lessen in deze map`,
"label.data.downpage.i_list.desc1":`Tijdens de import, gegevens die niet succesvol zijn geïmporteerd omdat de gegevens onjuist zijn geformatteerd, of omdat de trigger of validatieregel faalt, genereert het CSV-bestand dat op de huidige pagina moet worden weergegeven. De gegevens die met succes zijn geïmporteerd, worden niet op de huidige pagina weergegeven.`,
"label_adjust_forecast":`Prognose aanpassen`,
"vue_label_normal_lead_sf":`Lead`,
"vue_label_report_notice1":`Het rapport bevat niet-opgeslagen wijzigingen. Als u het rapport sluit, gaan deze wijzigingen verloren. Klik op de onderstaande knop "Opslaan en sluiten" om de wijzigingen op te slaan.`,
"label.notfiledpublicreport":`Niet-ingediende openbare verslagen`,
"one":`One`,
"UG.Lead.008":`Visitekaartje scan code`,
"label.archived":`Gearchiveerd`,
"label.standardabstractfield":`Standaard samenvattende velden`,
"vue_label_notice_add_fail":`Toevoegen mislukt`,
"label.sendemail.registIMUser.addresserror":`het e-mailadres van de ontvanger is onjuist`,
"label.ccdocument.toolbar.switch":`Werkbalk schakelaar`,
"first":`De Eerste`,
"label.icon.147":`Muis`,
"vue_label_jihui_er":`Opportunity 2`,
"label.ccchat.micropost.isedit":`Wijziging van berichten en opmerkingen`,
"label.department.next":`Volgende pagina`,
"front-kefu-moudle-confirm-disable-phone-user":`Ben je er zeker van dat je de dialout voor de gebruiker {0} uitschakelt?`,
"label.reportsSubscription.time.meets.subscription.frequency":`De begin- en einddatum komen niet overeen met de abonnementsfrequentie!`,
"lable.account.NextpDays":`De komende 120 dagen`,
"UG_opportunity_007":`Contact rol`,
"label.encrypt":`Gecodeerd`,
"label.knowledge.category.hint.three":`Bestaande categorie verwijderen of vervangen, waardoor alle catetogieën die bij het artikel horen worden verwijderd.`,
"label.customcomponent.usewhere.info":`Hieronder staan alle verwijzingen naar deze component. Klik op het referentielabel om de definitie te bekijken.`,
"vue_label_import_addandupdate":`Toevoegen en bijwerken`,
"label.email.all.members":`Per email aan alle groepsleden sturen`,
"component_task_button_save":`Save`,
"label.file.deleted.unavailable.desc":`Bestand is nu verwijderd, onbereikbaar of niet beschikbaar.`,
"label.emailsync.status.viewlog":`Logboek bekijken`,
"label.marketsea.othersetup":`Andere Instellingen`,
"label.data.exp.newtemppage":`Sjabloon pagina maken`,
"vue_label_lead_score_successsful":`Succesvol gescoord`,
"label.sendemail.activity.newtask":`Beste #belongtoidccname, hallo:je collega #createbyidccname heeft je een nieuwe taak toegewezen in #createdate, die er als volgt uitziet:onderwerp:#onderwerp:vervaldatum:#gerelateerd item: #gerelateerdst: inhoud: #remark Voor meer details, bezoek deze link: #pad #orgNameCRM-systeem`,
"component.event.label.soon":`Onmiddellijk`,
"label.forecast.shrepage.getlist":`Terug naar Voorspellingshiërarchie`,
"UG.solution.02":`De oplossing is een interne oplossing van de instelling voor het probleem dat de rekeningen tegenkomen.`,
"label.weixin.data.approval":`Het dossier is onder goedkeuring`,
"label.build.pagelist":`Pagina bouwer pagina lijst`,
"label.customsetting.type.hiberarchy":`Hiërarchie`,
"label.forecast.ccfh":`Overtref`,
"label.Current.Window":`Weergave in bestaand venster`,
"label.appointmentdetail.wizard.title20":`Zondag Plan`,
"label.emailaddress":`Postadres`,
"label.qetting_notifications":`Ontvangt u onze emails niet? Zorg ervoor dat u CloudCC emailadressen aan uw toestemmingenlijst hebt toegevoegd en uw exportmeldingen hebt ingeschakeld.`,
"Homepage.News.001":`Nieuws`,
"label.runreport":`Loop Rapport`,
"label.customer.tab.step3":`Stap 3 Toevoegen aan aangepaste apps`,
"label.dashboard.snapshot.refresh":`Vernieuwen`,
"label.approvepagelayout3":`Lay-out pagina goedkeuren`,
"vue_label_SMS_send_messages":`Stuur Berichten`,
"label.executestate.old":`Uitgevoerd`,
"label.approvalstep3":`Stap 3 Selecteer Toegewezen Goedkeurder`,
"label.step3.total6":`Stap 3 van 6`,
"front-kefu-moudle-v1-delete-templete":`Verwijder sjabloon`,
"label.data.downpage.e.title.num3":`3, Gebruikers kunnen export sjablonen maken op basis van hun behoeften en selecteer het item "Exporteren op sjabloon", die kan maken export operatie handiger.`,
"label.attendance.outer":`Mobiele Werker`,
"setup_layout_button_selectall":`Alles kiezen`,
"chatter.photo.img":`De maximale bestandsgrootte is 2 MB.`,
"front-dynamiclayout-module-v1-required":`Het veld van {verplicht} is ingesteld als vereist.`,
"label.mytask":`Mijn Taken`,
"label.edit.customerinfo":`Bedrijfsprofiel bewerken`,
"label.processsetting.process.explain":`Door het proces in te stellen en te gebruiken, kunnen gebruikers zich concentreren op de belangrijkste punten en krijgen ze op het juiste moment trefwoorden en tips te zien om hen te helpen het proces te voltooien.`,
"label.emailobject.subject":`Onderwerp`,
"label.mobileapp.scansetting.message":`Selecteer of u de gescande kaarten in het beeldformaat wilt opslaan in de gerelateerde lijst van "Notities en Bijlagen", afhankelijk van uw huidige gebruiksscenario. <br>Inschakelen: de gescande kaart wordt automatisch in de bijlage opgeslagen terwijl de record wordt opgeslagen. <br>Uitschakelen: alleen de record wordt opgeslagen.`,
"front-epwechat-module-v1-android-autograph":`Android app ondertekenen`,
"label_component_helper_potentialcustom":`Leads die vandaag aan u zijn toegewezen`,
"label.projectManagement.nodata.week.work":`Laten we taken toevoegen om het werk van deze week beter te organiseren.`,
"label_tabpage_rolez":`Rol`,
"label.importsourcestep4":`Stap 3 Importeer uw bestanden`,
"label.icon.50":`Kompas`,
"lable.service.prompt":`Kan geen nieuw veld aanmaken, het aantal velden heeft de limiet bereikt.`,
"label.campaign.channel.input.page":`Geef een webpagina op, meestal wordt de homepage van de campagne ingesteld als dankpagina.`,
"UG.homepage.001":`Win meer deals in minder tijd`,
"label.step4.total6":`Stap 4 van 6`,
"label.partner.required":`Fout: domein kan niet leeg zijn`,
"label.tag.manage.title":`Manage- {0}`,
"label.data.downpage.i_title.num1":`1. Het systeem ondersteunt alleen het gewone CSV-formaat.`,
"label.custom.quarter.end":`Einddatum aangepast kwartaal`,
"label.layout.distribute":`Pagina Lay-out Opdracht`,
"label.version.allsms":`Mas SMS`,
"label.tolead":`Importeren`,
"label.texttemplate.usemergefields":`Gebruik op te nemen velden in SMS sjabloon.`,
"label.emailobject.sure":`Zeker`,
"lable_setup_mobilesetup_isenbaleh5newandedit":`Als je h5 inschakelt in je mobile-side en`,
"label.tabpage.messagez":`Geef commentaar`,
"label.mobile.phone.write.day.report":`Nieuwe dagelijkse werkaantekeningen`,
"label.data.setok.e.desc2":`Gegevenslijst exporteren`,
"label.emailsync.message":`Prompt`,
"label.sales.page.mubiao":`Doel bereiken`,
"label.ccdocument.list":`Bekijk uw laatste document`,
"label.tabpage.userGuidez":`Gebruikershandleiding`,
"label.report.fields":`Beschikbare velden voor rapporten`,
"vue_label_checkduplicate_at_same_time":`Bevredig alles tegelijk`,
"label.sms.phone":`Dienst telefoon`,
"UG_ST_004":`U hebt geen toestemming voor gegevensbeheer - "gegevensimport, neem contact op met de beheerder, klik op bevestigen en ga direct naar de {0} interface.`,
"label.mobile.nobindmobile":`Dit mobiele nummer bestaat nu niet. Gelieve het mobiele nummer aan de gebruikersinformatie te koppelen`,
"label.partnerCloud.basicSetting.intro":`CloudCC ondersteunt het opzetten van meerdere sites voor partners van verschillende types en het afzonderlijk configureren van loginpagina's, menu's en rechten. Detailhandelaren kunnen bijvoorbeeld verschillende sites voor lokale agenten en advertentiepartners aanmaken.`,
"label.trigger.targetobject":`Doelobjecten`,
"label.ems.emailsyncperiod":`Synchronisatieperiode voor e-mail`,
"lable.Transformation.mode":`Transformatie modus`,
"label.emailobject.new.template":`Nieuwe sjabloon toevoegen`,
"label.System.Setting":`Systeem Instellingen`,
"label.emailtocloudcc.button.addemailaddress":`Enterprise Mailbox toevoegen`,
"lable.a.total.of.invoices":`0 factuur in totaal`,
"label.multilang.customforcast.forecasthistory":`Prognosegeschiedenis van {0}：`,
"label.role":`Rollen`,
"advancedconditions":`Geavanceerde filter voorwaarden`,
"label.tabpage.beginz":`Begin`,
"label.campagin.roi.khzhsl":`Hoeveelheid van rekeningomzetting`,
"chatter.poll.option5":`Keuze 5`,
"label.weixin.horse.club.registered":`Registratie van Aid-Max-gebruikers`,
"frame_personinfo_label_resizeimage":`Als u aanpassingen wilt maken aan uw miniatuurafbeelding, sleept u de stippellijnen in uw profielfoto hierboven en past u de grootte aan.`,
"label.file.share.select.warning":`Het is opgezet om te delen!`,
"label.event.this.week":`Deze week`,
"label.data.import.object.label":`Object Labels`,
"label.visualpage.folder":`Niet gearchiveerde paginamappen`,
"vue_label_report_saveandclose":`Opslaan en sluiten`,
"label.newdashboardpage.saveto":`Opslaan naar`,
"label.partnerCloud.financeSetting.developerIDTwo":`Ontwikkelaar ID`,
"lable.PowerProcess.created.ago.please":`Alvorens een proces te creëren, gelieve`,
"label.chatter.myfollowers":`Mijn volgelingen`,
"label.campaignmember.main.duplicatelist.title":`Campagne leden: Scan code om dubbele instellingen te vinden`,
"label.group.no.recent2":`Zoek groepen om lid van te worden`,
"label.icon.110":`Boek`,
"label.merge.my.account":`Mijn rekeningen samenvoegen`,
"setup.layout.button.quicksave":`Snel Opslaan`,
"pagecreator.page.message.canntdelete":`De huidige pagina mag niet verwijderd worden`,
"label.report.printable.view":`Afdrukbaar Bekijken`,
"ccchat_fieldtrack_fieldchange":`Verander van {0} naar {1}`,
"label.email.bcc":`Bcc`,
"label.sso.saml.sp.idpcert":`Identity Provider Certificaat`,
"label.step2.total2":`Stap 2 van 2`,
"lable.product.pricebooks.isn":`Actieve Prijs Boeken`,
"labal.emailtemplate.namemassage":`De unieke naam van het mailsjabloon bestaat al, gelieve opnieuw aan te passen`,
"only.one.field":`Er kan slechts één veld worden geselecteerd.`,
"label.weixin.appr.audittime":`Goedkeuring Datum`,
"pagecreator.page.button.delete":`Delete`,
"front-kefu-moudle-v1-Session-start-time":`De sessie begint om:`,
"label_chatter_state":`Status`,
"vue_label_systemSettings_lightningcustom":`Aangepaste UI in Lightning`,
"label.searchs":`Zoeken op`,
"label.mobile.phone.not.read":`Ongewijzigd`,
"label_chatter_allweather":`All-weather`,
"label.enter.number":`Voer een geheel getal tussen 0-6 in.`,
"front-epwechat-module-v1-addressbook-desc":`Wanneer ingeschakeld, zullen contacten en afdelingen in WeCom gesynchroniseerd worden met CloudCC gebruikers en rollen`,
"label.emailfield":`E-mail velden`,
"pagecreator_button_next":`Volgende stap`,
"label.more.select.merge.records":`U kunt slechts tot 3 gegevens selecteren om samen te voegen`,
"lable.edit.queue.selobjct":`Geselecteerde Objecten`,
"label.reportsSubscription.editsubscribe":`Abonnement bewerken`,
"label.selectfieldtoautotransmit":`Selecteer het veld dat wordt gebruikt voor geautomatiseerde goedkeuringsroutering`,
"label.ccpeak.need.topass":`Moet overgaan in`,
"label.checkfield.merge":`Samenvoegen`,
"front-lighting-module-v1-detail-file-downlaodInfo":`Het record is vergrendeld en niet beschikbaar voor het downloaden van bestanden. Neem contact op met de beheerder voor ontgrendeling.`,
"vue.please.enter.a.chart.name":`Voer de naam van de kaart in.`,
"label.data.dataexptemplate.desc3":`3. De exportmodus is alleen geldig voor de geëxporteerde gegevens en is niet geldig voor de exportsjabloon. Het bestandsformaat voor het uitvoersjabloon is CSV.`,
"label.setup.mobile.homepageshortcuts.setting":`Homepage swift functie-instellingen`,
"label.ems.connect.success":`E-mail test geslaagd`,
"label.applet.text":``,
"label.knowledgebase.parent.window":`Ouder Venster`,
"label_file_size":`Gebruikte ruimte`,
"label.allocation.department":`Gebruikers toewijzen`,
"label.browser":`Browser`,
"label.reportsSubscriptionPage.schedulereport.weekly.wednesday":`Woensdag`,
"label.integrations.description1":`Exporteer de gegevens in de huidige weergave`,
"label.project360":`Project 360`,
"label.choose_formtype":`Formuliertype kiezen`,
"label_emailsync_status_connectstatus":`Verbindingsstatus`,
"label.bmap.beijing.city":`Beijing`,
"label.mask.encryption.scheme":`Gecodeerd formaat`,
"label.imgfield.type":`Type afbeelding`,
"label.person.target.responsible":`Kies doel supervisor.`,
"label.appexchange.installedpage.installdate":`Installatiedatum`,
"label.partnerCloud.orderingPlatform.partnerUsers":`Deze functie is alleen beschikbaar voor partnergebruikers.`,
"label.profile.customfieldsafety":`Aangepaste beveiliging op veldniveau`,
"label.no.target.models.available.":`Geen indicatormodellen beschikbaar. Maak een indicatormodel aan of neem contact op met de beheerder.`,
"label.process.execute.tip":`Uw aanvraag is verwerkt, massaal goedkeuren of massaal afwijzen zal enige tijd in beslag nemen, en het systeem zal u per e-mail informeren wanneer de verwerking voltooid is.`,
"label.app.step2.introduce":`Voer de volgende velden in om de aangepaste app te definiëren`,
"label.loginip.cue":`Er wordt geen IP-bereik opgegeven en gebruikers van om het even welk IP-adres kunnen inloggen.`,
"label.step1.select.tablayout":`Stap 1 Kies Tabbladindeling`,
"mainpage.setup.chosecomponent.leastone":`U moet ten minste één onderdeel kiezen op de homepage.`,
"label.custom.quarter.name":`Naam aangepaste wijk`,
"chatter.ptup.link":`Plaats een link`,
"label.compact.layout.frame.error2":`Gedetailleerde informatie en verwante lijst moeten op het linker scherm staan`,
"vue_label_salesfunnel_notice7":`Totaal aantal zakelijke kansen met een waarschijnlijkheid van 100%/Totaal aantal zakelijke kansen met een waarschijnlijkheid van 0% of 100%`,
"label.multilang.datamanage.dataimport.lostmsg":`De lengte van de titel is &nbsp;{0}&nbsp; maar de lengte van de gegevens is &nbsp;{1}&nbsp; het systeem kan niet bepalen welke &nbsp;{2}&nbsp; velden overbodig zijn.`,
"label.owner.notnull":`De eigenaar kan niet leeg zijn`,
"label.logintime.pagecue.invalidt":`De begintijd kan niet groter zijn dan de eindtijd.`,
"vue_label_file_checked_num_limit":`Het aantal geselecteerde bestanden overschrijdt de limiet`,
"front-email-payment-repayments":`Betaal opnieuw`,
"template.report.today.prospects":`Leads van vandaag`,
"label.weixin.appr.status":`Status`,
"label.knowledge.language.japanese":`Japans`,
"label.event.reminder.lead.time":`Herinnering`,
"lable.custom.dep":`Klik op de knop Nieuw om een nieuw aangepast jaar te definiëren.`,
"Dashboard_View_Createdbyme":`Dashboards door mij gemaakt`,
"label.file.upload.fail":`Upload bestand mislukt`,
"label.manager":`Manager`,
"label.stdashbord.xsld.business.jine":`Bedrag`,
"label.tag.manage.tag":`Tag`,
"chatter.nlk":`In tegenstelling tot`,
"label.file.search.people":`Zoek mensen`,
"message.error.domain.format":`Domeinnamen kunnen alleen bestaan uit Engels en arrays`,
"label.firstisdefault":`Gebruik de eerste waarde als standaardwaarde`,
"label.discount":`Korting`,
"label.mobile.phone.have.read":`Herzien`,
"label.field_selected":`Dit veld is geselecteerd`,
"label.payment.renew.now":`Vernieuw nu`,
"label.multilang.lookfiltercondition.notsetup":`De regelvoorwaarde {0} is onjuist, er is geen operator ingesteld!`,
"label.projectManagement.Selectionday":`Kies dag`,
"label.user.organization.permit.licensenotstart":`De licentie van uw organisatie is niet geactiveerd, probeer het opnieuw nadat de licentie is geactiveerd`,
"label.download.save.attachment":`Downloaden en opslaan in bijlage`,
"lable.outlook.mcto.must":`Moet in e-mail formaat zijn.`,
"vue_label_notice_unfollow_success":`Unfollow succesvol`,
"label.taskinfo":`Stap 2 Configureer Taak`,
"label.other.SMS":`Andere telefoonnummers`,
"label_partner_workspace_login_logo":`Kop logo`,
"label.weixin.data.lock":`Het record is vergrendeld.`,
"label.Yaxis":`Y-as`,
"lable.edit.queue.selobjdes":`Selecteer de objecten die u aan deze wachtrij wilt toewijzen. Individuele records voor die objecten kunnen dan eigendom zijn van deze wachtrij.`,
"label.campagin.roi.dcfezb":`Aanwezigheidspercentage`,
"label.marketseamemset.maximum":`Maximaal bedrag`,
"label.owner":`Eigenaar`,
"label.reportsubscribe.error.noview":`Gelieve in te vullen als welke gebruiker u dit rapport wilt uitvoeren in "Uitvoeren als"`,
"label.icon.133":`Map`,
"vue_label_file_share_files":`gedeelde documenten`,
"label.searchlayoutfilterfields.remark":`Selecteer de filterveldkolommen die u wilt gebruiken bij het zoeken in de zijbalk van de homepage en op de startpagina van het tabblad.`,
"vue_label_help_contract":`Contract en inzamelingsplan`,
"component.chatter.button.message":`Commentaar`,
"label.marketsea.recyclereminddays2":`Dag herinnering (moet minder zijn dan het aantal dagen zonder follow-up na het verkrijgen)`,
"label.webtocloudcc.input.information":`De informatie is vereist.`,
"vue_label_chatter_exit_group":`Verlaat de groep`,
"vue_label_lead_notcreatetask":`Maak geen taak`,
"front-lightning-module-v1-dashborad-date-dimension":`Datum Afmeting`,
"setup.layout.label.fieldlist":`Beschikbare velden`,
"label.leadscore.charname":`Veldnaam`,
"label.forecast.customforecast.mybest":`Mijn beste zaak`,
"setup_mainpage_label_welcome24":`Het CloudCC-cloudplatform biedt beveiligingstoegangsinstellingen voor alle objectgegevens in het systeem. Het delen van gegevens en de toegangsrechten kunnen worden gecontroleerd door verschillende regels en voorwaarden in te stellen.`,
"label.queue":`Wachtrijen`,
"label.icon.159":`Chip`,
"label.path":`Pad naar referentie`,
"label.app.message.failtoget":`Kan de aanvraaglijst niet krijgen`,
"label.returntoprocess":`Terug naar lijst: Goedkeuringsprocedures`,
"vue_label_commonobjects_detail_more_data":`Geen gegevens meer.`,
"label.number":`Nummer`,
"label.product.find":`Zoek Prijs Boeken`,
"label.legend":`Legende`,
"label.partner.workspace.member.profile":`Beschikbare profielen`,
"label.service.gantt.sum.appointments":`Afgehandelde dienstafspraken/Alle dienstafspraken`,
"label.partnerCloud.financeSetting.paymentAllowed":`Online herlading toestaan`,
"label.integrations.upgrate":`Upgraden`,
"label.timzone.tip.info3":`Wanneer je de kalender klasse gebruikt om datums te verwerken, moet je de tijdzone voor de kalender instantie instellen, en je kunt een van de volgende twee methoden kiezen om de kalender objecten te krijgen: Calendar cal=Calendar.getInstance(TimeUtil.getUserTimeZone(userInfo))和Calendar cal=TimeUtil.getCalendar(userInfo)`,
"label.ems.addaccount2":`E-mail account toevoegen`,
"label.partneruser":`Partner Gebruiker`,
"label.validate.globalvariable.user.roleId":`Rol ID`,
"pagecreator.layout.button.mergecell":`Cellen samenvoegen`,
"label.evacuantvalue":`Waarden uitsluiten`,
"label.setup.mini.msg":`Merk verhaal/boodschap instellen`,
"label.icon.178":`Mensen`,
"vue_label_pricebook_notice_cantbedeleted":`Prijslijstvermeldingen kunnen niet worden verwijderd omdat er al records op de prijslijst zijn toegepast. In plaats daarvan kunt u prijslijstvermeldingen als inactief markeren.`,
"vue_label_appstore_application_recommendation":`Aanbeveling voor populaire toepassingen`,
"label.version.createlimit":`Uw huidige CloudCC editie is {0}, en u kunt {1} {2}. Nu, het aantal van {2} is het maximum van uw abonnementsplan overschreden, gelieve uw CloudCC editie bij te werken.`,
"message.duplication.label.sectionremar1":`Selecteer de waarden die u in de samengevoegde record wilt behouden. Gemarkeerde rijen geven velden aan die tegenstrijdige gegevens bevatten. De geselecteerde master record behoudt de waarden van alleen-lezen en verborgen velden.`,
"label.icon.1":`Wolk`,
"label.salescloud.salesdashboard.sales.performance":`Resultaten algemeen-verkoopcontract`,
"System_AddressFieldType_Post":`Postcode`,
"setup_object_field_dependency_label_mustone":`U moet ten minste 1 waarde van het afhankelijke veld selecteren.`,
"label.appointmentdetail.wizard.title6":`Locatie`,
"label.layout.testobj2":`Testobject 2`,
"label.searchlayout.dupcacher.field":`Klik op de link Duplicaten zoeken en samenvoegen om de dubbele velden te bekijken.`,
"label.attendance.persons.title":`Geschikte gebruikers`,
"template.report.product.sales":`Producten Verkoop`,
"label.editCustomReportType":`Aangepast rapport Gegevensbron bewerken`,
"label.multilang.ui.setup.profile.alltime":`Alle tijden zijn {0}`,
"label.service.dispatchingUnits.noservice.booking":`Geen service afspraak`,
"label.validate.remark4":`Zorg ervoor dat het getal binnen een bepaald bereik ligt, zoals de korting minder dan 30%`,
"front-kefu-moudle-v1-Waiting-time":`Wachttijd:`,
"label.weipagelayout.remark":`Gebruikt in de mobiele app of WeChat-pagina`,
"vue_label_wang_er":`Michael`,
"label.pw.text":`Voer het wachtwoord voor {user} in, en zorg ervoor dat het minstens`,
"message.error.user.data.null":`Gebruikersinformatie kan niet leeg zijn!`,
"chatter.like.p":`Zoals deze post`,
"label.page.double.column.style.cloudcc":`De 2-kolomsstijl biedt handige CloudCC.com-functies, zoals Zoeken en Recente items, op dezelfde pagina als uw ingesloten inhoud.`,
"label.h5.iscloseaccount":`Weet u zeker dat u wilt uitloggen?`,
"label.dataimport.insertdata.id.error":`Formatteringsfout, gebruik een combinatie van letters en cijfers.`,
"label_tabpage_sum":`Totaal`,
"front-epwechat-module-v1-addressbook-sync":`Synchroniseer Contactenboek`,
"label.setup.mobile.offlinecache.mostsave":`Platform kan de standaard ingeschakelde mobiele kant offline tabblad tot 10`,
"label.weixin.quickcreate":`Snel maken`,
"label.forecast.edittotal.de.mubiao":`Quota`,
"label.icon.144":`Garantie`,
"label.icon.155":`Afbeelding`,
"label.In.the.search":`Zoeken op`,
"message.validation.isnotdateISO":`Ongeldige datum (ISO)`,
"label.service.appointmentList.send.successfully":`Verzending succesvol`,
"label.dynamicpage.error.exist":`Dynamische paginaopmaakgegevens bestaan niet`,
"vue_label_SMS_otherpeople":`en {0} anderen`,
"label.cloudccsite.url":`URL van de site`,
"label.tabpage.contactsz":`Contacten`,
"vue_label_commonobject_notice_clickthename":`Als u het geüploade bestand wilt downloaden, klikt u op de bestandsnaam`,
"vue_label_file_new_lib":`Nieuwe bestandsbibliotheek`,
"label.chatter.card":`Kaart`,
"chatter.feed.menutype.user.allusercom":`Alle collega's`,
"label.exchange.sync2":`Instellingen`,
"template.report.year.income":`Inkomsten van dit jaar`,
"label.partner.template.detail":`Beschrijving van de functies`,
"label.setup.service.template":`Service Rapport Sjabloon`,
"label.dataimport.insertdata.id.length":`Formatteringsfout, controleer dit record en pas het aan. Let op dat de lengte minder dan 20 tekens is.`,
"label.partnerCloud.financeSetting.collaborator":`CoöperatieID`,
"label.processskipwizard":`Jump Start Wizard Goedkeuringsproces`,
"label.weixin.inputbusnumber":`Voer het kenteken in`,
"label.dashboardSetup.d1":`Breekpunt 1`,
"template.report.conversions.number.industry":`Aantal Leads Conversies (Per Sector)`,
"vue_label_chat_group_chat":`groepsgesprek`,
"label.file.publicview.error":`Het bestand is verwijderd of bestaat niet of kan niet worden bekeken`,
"label.customfields.location.locationHelpText":`Gelieve een locatienaam in te geven, zoals "hoofdkantoor". Wees beschrijvend en specifiek, en hou er rekening mee dat een record meerdere locaties kan hebben, zoals "verkoopkantoor westkust" en "verkoopkantoor oostkust".`,
"message.duplication.label.blankmatchtip":`Stel het veld leeg in om te matchen, de standaardwaarde is False`,
"message.appexchange.addtopackage":`Kies één of meer onderdelen om aan dit pakket toe te voegen!`,
"label.ems.return2query":`Terug naar de zoekpagina van toegevoegde e-mailaccounts`,
"label_model_name":`Naam van het model`,
"label.apiname.retainapi":`Naam is de systeem gereserveerde naam, gebruik aub een ander veld API naam.`,
"lable.Cancel.the.search":`Annuleren Zoeken`,
"label.custom.viewport":`Gezichtspunt`,
"label.weixin.polls.type":`Type`,
"label.opportunity.setting.showstage.label":`Auto promotie`,
"label_component_helper_businesschange_expiredtask":`Kansen met achterstallige taken`,
"label.operator":`Operator`,
"label.ccpeak.use.class.time.listmap":`Toegang door het doorgeven van de List<Map> collectie`,
"component_timeline_label_past":`Vroegere activiteiten`,
"label.mobile.phone.submit":`Ingediend door mij`,
"message.recordtype.new.subtip":`Voer een naam en beschrijving in voor het nieuwe recordtype. Het nieuwe recordtype zal alle keuzelijstwaarden van het hieronder geselecteerde bestaande recordtype bevatten. Nadat u het nieuwe recordtype hebt opgeslagen, kunt u de waarden van de keuzelijst aanpassen.`,
"UG_product_05":`Invoerproduct`,
"label.validate.globalvariable.user.id":`Gebruikers-ID`,
"label.umeng.activity.distribute":`die u toewijst aan`,
"label.weixin.avote":`Stem`,
"label.weixin.already.sign":`Al aangemeld.`,
"label.emailmerge.mergepage.generator":`Genereer`,
"label.batchtransfer.transferto":`Overdracht naar`,
"label.tianyancha.industry":`Industrie`,
"label.addattachment.name":`Bestandsnaam`,
"label.customfields.formula.date.tip":`Om een datum te berekenen, bijvoorbeeld dagen bij andere data optellen of dagen van andere data aftrekken.`,
"label.partnerCloud.orderingPlatform.noPayment":`Niet te betalen`,
"label.emailobject.failedtosend":`Mislukt te verzenden`,
"label.knowledge.setting.data.three":`Er kunnen maximaal {count} gegevens van categoriegroepen worden geselecteerd.`,
"label.weixin.input.maxlength.langtext":`Vul hier in, maximaal 32000 tekens`,
"vue_label_calendar_delete_calendar":`Kalender verwijderen`,
"vue_label_commonobjects_detail_filter":`Filter samenvouwen`,
"setup.layout.group.custompage":`Pagina aanpassen`,
"component_sendmail_label_subject":`Thema`,
"label_tabpage_maxfilez":`De maximale bestandsgrootte is`,
"label.logintime.pagecue":`Selecteer de datum en tijd waarop gebruikers met dit profiel kunnen inloggen. Merk op dat de exacte tijd van de opgegeven tijdzone wordt gebruikt voor alle tijden. Zelfs als de gebruiker zich in verschillende tijdzones bevindt, worden deze exacte tijden gebruikt voor de inlogtijd.`,
"label.salescloud.salesdashboard.datetime":`Sluitingsdatum`,
"label.format":`Formaat`,
"label.newfoundland.daylight.time":`Newfoundland zomertijd`,
"front-kefu-moudle-v1-messagetemplate.finishdetailinfo":`Kopieer en plak de waarde van het samenvoegveld in de SMSinhoud`,
"message.chooseatleastoneforshare":`Selecteer ten minste één gebruiker om te delen`,
"label.multilang.datamanage.importobjfield":`Kolom {0}`,
"label.denglu":`Inloggen`,
"label.popup.infoz":`Prompt`,
"label.schedulejob.setup.schedule.onday":`Op elke maand`,
"label.appointmentdetail.wizard.title16":`Woensdag Plan`,
"label.userphoto.dragtoadjust":`Slepen om thumbnail aan te passen`,
"label.product.series":`Product Familie`,
"message.view.kanban.not.set.group.summary.field":`Het view dashboard stelt het groepsoverzichtsveld niet in`,
"page.un.activities":`Niet begonnen Activiteiten`,
"label.exchange.sync3":`Configuraties`,
"label.login.activityExpired":`De actieve periode van de gebruiker is verlopen, neem contact op met de systeembeheerder.`,
"component_chatter_file_button_files":`Selecteer een document`,
"message.onlydelete.type":`U kunt alleen de inactieve recordtypes verwijderen. U kunt dus eerst de recordtypes uitschakelen als u ze wilt verwijderen.`,
"message.recordtype.selectlayouttouse":`Te gebruiken pagina-indeling`,
"label.knowledgebase.unable.restore.draft":`U kunt verwijderde concepten niet herstellen.`,
"label.shangqing.name":`Zakelijke informatie`,
"label.weixin.target.payment":`Doel betaling`,
"label.chatter.sendEmailToGroupMember.check":`Bekijk Berichten`,
"front-kefu-moudle-v1-input-single-login-area":`Voer de domeinnaam voor eenmalige aanmelding in`,
"vue_label_zhang_yi":`Alice`,
"label.icon.190":`Haardroger`,
"label.quickbooks.fieldlabel.company":`Bedrijf`,
"vue_label_email_are_you_sure_to_delete":`Weet je zeker dat je de mail wilt verwijderen?`,
"Pagelayout.Setup.005":`Naam moet op de eerste plaats komen.`,
"label.object.name.two":`Objectnaam 2`,
"label.tabpage.completez":`Markeer de geselecteerde status om te voltooien`,
"label.setup.mobile.bottombutton.saveerror":`Opslaan van instellingen op het eerste niveau mislukt`,
"label.report.action.addtodashboard8":`Kies Dashboard map`,
"label.data.downpage.i_list.desc3":`Gebruikers kunnen de reden van de mislukte import zien in de laatste kolom van het bestand na het downloaden.`,
"label.layout":`Lay-out`,
"label.marketsea.button.assign":`Toewijzen`,
"UG.solution.03":`Creëer een oplossing`,
"label.ccchat.person.invited":`Collega's uitnodigen`,
"label.ccchat.person.invite.address":`Ontvanger`,
"label.displaytype1":`Link naar detailpagina`,
"label.tianyancha.h5.ziranrengudong":`Natuurlijk persoon aandeelhouder`,
"lable.SalesCommitmentKanBan.targetReceipts":`Doel Ontvangsten`,
"message.error.getitems.type":`getItems:type kan niet leeg zijn`,
"label.addattachment.list":`De volgende bestanden zijn geüpload`,
"label.datamanage.export.false":`Er is een fout opgetreden tijdens het exporteren.`,
"pagecreator.systemstyle.label.buttonfontcolor":`Knop tekst`,
"label.emailtocloudcc.redmessage1":`Ongeldig e-mailadres`,
"label.weixin.polls.closed":`De stemming is gesloten, deadline is`,
"label.icon.165":`Hoed`,
"vue_label_report_detailsonly":`Alleen details`,
"component.salesperformance.label.100finish":`Beëindigd`,
"november":`November`,
"label.data.file.generatejwd":`Genereren van de lengte- en breedtegraaddienst volgens het adres`,
"label.salescloud.opportunity.access":`Kansen Toegang`,
"label.isremider.remider":`Herinnering`,
"vue_label_total":`Totaal`,
"label.email.prompt.using.lightning.link":`Stel de email link in systeemmeldingen zo in dat deze overeenkomt met Lightning links.`,
"label.knowledgebase.cancel.attached.articles":`Bijgevoegd artikel annuleren`,
"label.version.custom.xslc":`Aanpasbaar verkoopproces`,
"component_setup_button_save":`Save`,
"label.ems.cc":`Cc`,
"label.edit.user":`Gebruikers bewerken`,
"label.emailtocloudcc.select2":`Gelieve type te kiezen`,
"label.industrialandcommercialverification.fieldnumber":`Aantal in kaart gebrachte velden:4`,
"label.ccchat.havenot.joined.group":`U zit niet in een actieve groep`,
"pagecreator_page_label_pagename":`Naam van de pagina`,
"setup.layout.button.save":`Save`,
"label.campaignmember.main.updatestatus":`Mass Update Status Campagne Leden`,
"label.tab.web.edit":`Web Tabblad Bewerken`,
"label.ring_chart":`Deegnotentabel`,
"label.usermanage.resetpwd.error":`Wachtwoord-reset mislukt en de gebruiker bestaat niet.`,
"label.Xaxisscope":`X-as Reikwijdte`,
"label.app.new":`Nieuwe aangepaste app`,
"message.modifythereport":`Het dashboard maakt gebruik van dit rapport. Wijzigingen kunnen het dashboard dat naar dit rapport verwijst, ongeldig maken.`,
"label.component.helper.businesschange.0activity":`30 dagen zonder enige activiteit`,
"label.weixin.fmu.noon":`{0} PM`,
"label.enter.rule.name":`Voer de naam van de regels in`,
"lable.Confirm.recovery.potential.customers":`Bevestig om leiding {naam} te herstellen.`,
"lable.PowerProcess.type.created":`Welk soort proces van rechten wilt u creëren?`,
"front-lightning-module-v1-dashbord-rectangle-size":`Orthogon grootte`,
"label.projectManagement.new.service.appointment":`Nieuwe service afspraak`,
"label.multilang.totalpage2":`Een totaal van`,
"pagecreator.systemstyle.label.styledesc":`Stijlbeschrijving`,
"chatter.up":`Uploaden`,
"2018UI_Homepage_DataDeleted_Info":`De gegevens die u wilt bekijken zijn verwijderd, klik a.u.b. om terug te keren naar de vorige stap.`,
"label.knowledge.draft.recordid":`Ontwerp ID kan niet null zijn!`,
"vue_label_pool_recyclecertification":`{0}{1}{2}{3}？`,
"label.setting.intergrationlist.viewall":`Alle integratie bekijken`,
"vue_label_file_num_limit_tip":`Het aantal bestanden overschrijdt het vooraf ingestelde aantal. Als u bestanden moet vervangen, verwijder dan eerst de geüploade bestanden`,
"vue_label_commonobjects_view_refreshat":`Vernieuwd op {tijdInterval} geleden`,
"laebe.data.exp.save.success":`Als u deze sjabloon moet gebruiken om gegevens te exporteren, ga dan terug naar de "Exporteren per sjabloon" om te werken.`,
"label.mr.caption.contact":`Duplicaten zoeken en samenvoegen: Codities voor het zoeken naar duplicaten van Contacten`,
"label.webtocloudcc.submit.error":`Indiening mislukt`,
"label.multilang.datadelete.delmessage":`Vergrendelde records ({0}) mogen niet worden verwijderd:`,
"label.quickbooks.searchlist.total2":`Er zijn {0} niet-gekoppelde betalingen voor een totale waarde van {1}`,
"label.createnew":`Maak nieuwe...`,
"component.milestones.label.choicestate":`Bevestig deze status`,
"lable.outlook.edit.exist":`Deze veldnaam bestaat al. Voer een unieke veldnaam in.`,
"vue_label_dashboard_eachother":`Alleen weergaven van hetzelfde rapport of hetzelfde object kunnen worden gekoppeld`,
"label.new.role":`Nieuwe rol`,
"message.error.operationType":`De bewerking is niet gedefinieerd wanneer een dienst wordt opgeroepen.`,
"label.fenbeitong.name":`FenBeiTong`,
"label.choose.person":`Selecteer de te verzenden ontvangers`,
"label.attendance.thanks":`Bedankt voor uw medewerking.`,
"label.invoice.message.statusupdatefailed":`Bijwerken factuurstatus mislukt, probeer later nog eens.`,
"template.chart.yzhqzkhlyfx":`Bronanalyse van geconverteerde leads`,
"chatter.feed.menutype.user.alluser":`Alle collega's`,
"UG_Forcast_04":`Start proef`,
"label.appupload.upload.tips.profile":`Opmerking: de "profiel"-component is aan dit pakket toegevoegd en kan niet opnieuw worden toegevoegd (per pakket mag maximaal één profielcomponent worden toegevoegd).`,
"lable.PowerProcess.leave.the.process":`{describeName} Exit Process`,
"template.report.sales.cycle.opportunities":`Duur van verkoopcyclus (per type opportuniteit)`,
"vue_label_calendar_please_fill_in_the_calendar":`Gelieve de naam van de kalender in te vullen`,
"label.salescloud.unit.wanyuan":`eenheid ( Chinese Yuan)`,
"label.fileAPI":`Document Unieke Naam`,
"label.weixin.link":`Gerelateerd aan`,
"label.service.seconds":`secs`,
"label.encd.visible":`Gecodeerd veld zichtbaar`,
"label.tianyancha.regstatus":`Bedrijfsstatus`,
"label.event.moveup.18hour":`18 uur vooruit`,
"label.upper.bound":`Bovengrens`,
"label.please.insertURL":`Voer de URL in die moet worden ingevoegd.`,
"label.approval.notallowed.reject":`Weigering niet toegestaan`,
"label.permission.fieldpermission":`Instellingen veldmachtigingen`,
"label.customcomponent.page.index.title":`Aangepaste componenten`,
"label.quickbooks.viewlist.number":`NEE.`,
"lable.list.queue.sendemail":`Stuur e-mail naar leden`,
"label.productsales.today.noevtadd":`Er zijn geen open evenementen, u kunt op " " in de rechterbovenhoek klikken om een nieuw evenement toe te voegen.`,
"label.report.line.daixuan":`Kolom in afwachting van verslag`,
"label.reportsSubscription.select.start.endtime":`Selecteer begin- en eindtijd!`,
"template.chart.schdyscb":`Begrote kosten van de campagnes`,
"label.sendemail.chat.addPostatsubject":`Ik werd genoemd in de CloudCC CCChat micropost`,
"label.RelatedList":`Verwante Lijsten`,
"label.knowledgebase.delete.translation.associated.with.draft":`Bestaande ontwerpvertalingen worden gekoppeld aan de laatst gepubliceerde versie van het artikel in de hoofdtaal. Als er geen gepubliceerde versie bestaat, zullen alle vertalingen worden verwijderd.`,
"vue_label_chatter_submitted_review":`Je hebt een aanvraag ingediend om lid te worden, wacht a.u.b. op de beheerder om te beoordelen`,
"label.layout.list2":`Lijst 2`,
"label.manage.area":`Territoria beheren`,
"label.manageapproveprocess":`Beheren van goedkeuringsprocessen voor`,
"workflow.action.tasks.assignortype.created":`Gemaakt door`,
"label.custombutton.nonsupport.operation":`De huidige versie ondersteunt niet de werking van standaardknoppen en -links.`,
"label.ip":`IP-adres`,
"label.chat.topic.desc.error.info":`De themabeschrijving mag niet langer zijn dan 1000 tekens. Probeer een kortere themabeschrijving te gebruiken.`,
"label_tabpage_cue":`Informatie herinnering`,
"label.integrations.mailchimp1":`Door CloudCC met Mailchimp te integreren, kunnen uw gebruikers geselecteerde leads en contactpersonen uit uw CloudCC-account importeren in Mailchimp.`,
"label.email.track.required":`Vereiste informatie`,
"label.set.case":`Stel eerst de eigenaar van de zaak in.`,
"label.weixin.newspaper.coverage.number":`Risicoblad Nummer`,
"vue_label_approve_submitreason":`Reden voor indiening`,
"message.oppdt.noenabledpricebook":`Geen actieve prijsboeken`,
"label.partner.workspace.setup":`Instellingen`,
"label.version.nonsupport.feature":`Deze functie wordt tijdelijk niet ondersteund. Indien nodig, gelieve CloudCC versie te upgraden.`,
"com.cloudcc.login.error.message.licenseexpired":`De licentie is verlopen`,
"label.emailsync.form.signin":`Inloggen`,
"label.campaign.channel.input.to.chooselanguage":`Gelieve een taal te kiezen`,
"label.tabpage.gotit":`Ik heb het.`,
"front-console-no-contact-tip":`Geen gegevens. Neem contact op met de betrokken persoon en kijk.`,
"label.approval.apiname":`De unieke naam die API en Managed packages gebruiken moet beginnen met een letter, en alleen alfanumerieke tekens en underscores gebruiken. Namen mogen niet eindigen met een underscore of twee opeenvolgende underscores bevatten.`,
"label_emailtocloudcc_filed_ssl":`Beveiligde verbinding`,
"component_sendmail_label_fromuser":`Afzender`,
"front-kefu-moudle-v1-new-online-chats":`Nieuwe online agent`,
"label.searchlayout.merge.duplicated.results":`Mogelijk maken om duplicaten te vinden en samen te voegen`,
"label.weixin.input.maxlength.remark":`Vul hier in, maximaal 500 tekens`,
"component.telerecord.label.related":`Aanverwante artikelen`,
"label.note":`Opmerkingen`,
"message.duplication.label.nletters":`personages`,
"label.productsales.payment.phb":`Betalingslijst`,
"label.forecast.editshrepage.desc":`Voorspelling:Specificeer het delen van dit record. U kunt dit record en verwante gegevens delen met een gebruiker, de gebruikers in een bepaalde rol, of de gebruikers in een bepaalde rol plus alle gebruikers in rollen onder die rol.`,
"vue.dashboard.setPenetrationSuccessful":`Succes met het opzetten van de penetratie!`,
"label.tabpage.noOperationz":`Deze inhoud is een vast item en kan niet bediend worden!`,
"label.email.jump":`Doorverwijzen naar een website van een derde partij...`,
"label.appointmentpage.wizard.btn1":`Bevestig reservering`,
"label.umeng.approval.pass":`#goedkeurder heeft uw goedkeuringsverzoek goedgekeurd #obj.`,
"label.project.hit.twelve":`Mijlpaal Verval Herinnering`,
"two":`Twee`,
"label.approvedinfo":`Goedkeuring Informatie`,
"label.import.step1.choosecsv":`Selecteer een csv-bestand`,
"vue.please.select.the.expansion.method":`Kies een uitbreidende manier.`,
"UG.homepage.005":`Verkoopinformatie`,
"Account.News.Setting.003":`Algemene Instellingen`,
"label.quickbooks.button.actions":`Acties`,
"lable.list.queue.email":`Wachtrij e-mail`,
"label.name.lastname":`Achternaam`,
"message.confirm":`Ben je zeker?`,
"Opportunity.Detailed.Phase.Label.Popup.002":`Sluitingsdatum van de huidige fase`,
"label.knowledge.setting.title":`Kennis Instellingen`,
"label.helptocreateprocess":`Om een nieuw goedkeuringsproces te maken, klikt u op "Nieuw goedkeuringsproces maken" en selecteert u vervolgens "Jump Start Wizard gebruiken" om uw goedkeuringsproces in een paar korte stappen in te stellen. Of selecteer "Standaard Wizard gebruiken" om alle goedkeuringsopties in te stellen.`,
"label.batcheditor.remark":`Meerdere records kunnen worden bewerkt.`,
"label.page":`Pagina`,
"label.newfolder":`Nieuwe map maken`,
"label.version.interceptor.api":`Interface-API`,
"label.sms.toaddress":`een SMS ontvangen`,
"front-kefu-moudle-noopen-callcenter":`De organisatie heeft de call center functie niet geactiveerd, neem contact op met de beheerder`,
"label.data.exp.zip":`Compressie formaat`,
"lable.account.LastcDays":`Laatste 60 dagen`,
"label.import.index.starttime":`Statijd`,
"label.dashboardall":`Alle dashboards`,
"label.create_socialpost":`Nieuw bericht`,
"label.searchlayoutedit.remark":`Selecteer de velden en knoppen die worden weergegeven wanneer u op de homepage op de zijbalk zoeken klikt of op het tabblad zoeken klikt.`,
"message.servicecrew.violation":`Schending van de toewijzing van middelen: dienstmiddelen zijn teamleden in deze periode.`,
"label.email.attrach.file":`Bijlage`,
"report.label.folderandreport":`Rapporten en mappen`,
"label.list.userinterface.sales.setup":`Verkoop Homepage Setup`,
"label.martrixreport.2018.step1":`Stap 1 Maak een groepering`,
"label.campaignmember.selectmember.memberstatus":`Status van campagnelid`,
"label.textmessage.vonage.api.key":`API Sleutel`,
"label.tabpage.next":`Volgende stap`,
"UG_Lead_006":`Website bezoeker`,
"label.salescloud.salesdashboard.visit.rankings":`Bezoek Rankings`,
"label.myevent":`Mijn Gebeurtenissen`,
"label.activity.history":`Geschiedenis`,
"label_tabpage_kanban":`Viewboard setup`,
"label.weixin.allapp":`Alle toepassingen`,
"label.query.clone.detail.choose.choosed":`Geselecteerde posten`,
"message.error.view.errvalid":`Fout: Het veld unieke naam van de weergave kan alleen underscores en alfanumerieke tekens bevatten. Hij moet uniek zijn, met een letter beginnen, geen spaties bevatten, niet met een underscore eindigen, en geen twee underscores na elkaar bevatten.`,
"label.customfields.searchrelation.dependobject.tip":`Selecteer een ander object dat bij dit object hoort`,
"label.appointment.wizard.subtitle4-4-3":`3 weken`,
"label.setup.mobile.offlinecache.saveerror":`Mobiele offline cache instelling wordt niet opgeslagen.`,
"label.planned.started":`Begonnen met`,
"label.page.step4.of.step5":`Stap 4 van 5`,
"label.tabpage.value":`Waarde`,
"label.reportlist.allfolder":`Alle mappen`,
"label.callcenter.sure.disable.center":`Weet u zeker dat u het huidige call center wilt deactiveren?`,
"vue_label_commonobjects_detail_activity_tocalendar":`Ga naar Kalender`,
"label.setup.mobile.bottombutton.recovery.default":`Herstel standaard`,
"label.appointmentdetail.wizard.title15":`Dinsdag Plan`,
"label.icon.15":`Reparatieopdracht`,
"component_sendmail_label_touser":`Naar`,
"template.report.all.owner":`Eigenaar van Leads`,
"front-Partner-email-tips":`Vul email in voor de gebruikersnaam`,
"vue_label_systemSettings_mobelhomepagesetting":`Mobiele App Homepage Setup`,
"label.service.newBuildDialog.aswellas":`en`,
"label.name":`Naam`,
"label.tag.search.taglist":`Tag Lijst`,
"label.partnerCloud.priceOfManual.theOnly":`Het is aan te bevelen om voor elke partner gebruiker een prijsboek op te zetten. Of ze moeten tijdens het bestellen uit meerdere prijsboeken kiezen. Het standaardprijsboek wordt toegepast als er geen specifiek prijsboek is ingesteld.`,
"label.knowledge.field.update":`{1} is veranderd van {2} in {3}`,
"label.emailobject.save":`Save`,
"label.top.changeVersion":`Horizontaal`,
"label.recordtype.edit.unselected":`Bestaande Waarden`,
"label.knowledgebase.additional.articles":`Artikel bijvoegen`,
"label.lead.score.confirm":`Selecteer het scorebereik en klik op de knop [Lead Scoring], waarna het systeem de geselecteerde leads zal scoren volgens de actieve Lead Scoring Regel.<br><br>Dit kan enkele minuten duren.<br><br>U ontvangt een bevestigingsmail zodra dit is voltooid.<br><br>`,
"label.projectManagement.pleaseselectadate":`Gelieve datum te kiezen`,
"label.appointment.wizard.subtitle5":`Naam vergadering`,
"label_setup_failed":`Setup mislukt`,
"label.chatter.collect":`Bladwijzer`,
"label.appointment.cancelappointment":`Annuleren`,
"front-console-response":`Responstijd`,
"message.delete":`Weet u zeker dat u wilt verwijderen?`,
"label.dataimport.type.selected":`Selecteer het type import`,
"label.new.target":`Nieuwe indicator`,
"vue_label_report_autoupdatepreview":`Autoupdate voorbeeld`,
"label.knowledgebase.guidance":`Begeleiding`,
"label.chatter.mail":`Mail`,
"label.login.verification.scan.code.acquisition":`Scan de code om te krijgen:`,
"label.customsetting.changefieldtype":`Veldtype wijzigen`,
"label.data.dataexpalltype.all_desc2":`2. Het duurt enige tijd om alle gegevens te exporteren. Wanneer de export voltooid is, ontvangt u een herinneringsmail dat de gegevensexport geslaagd is.`,
"label.opportunity.contactisnull":`Geen klantinformatie, kan niet worden weergegeven.`,
"pagecreator_layout_button_upload":`Upload lay-out`,
"label.dashboard.noRecord":`Geen gegevens`,
"label.SMS.template":`SMS Sjabloon Naam`,
"label.c.d.without":`C-records kunnen al dan niet verwante "D"-records hebben.`,
"UG.Case.05":`Maak een zaak`,
"front-epwechat-module-v1-edit-selfapp":`Bewerk Seflcreatie app`,
"label.role.createrole.tip":`U kunt voortbouwen op de bestaande rolhiërarchie die op deze pagina wordt getoond. Om een nieuwe rol toe te voegen, klikt u op <b>Rol toevoegen</b>.`,
"label.grouping":`Groep door`,
"vue_label_email_upload_new_file":`Upload nieuw bestand`,
"label.notification.event3":`Uw evenement 【事件名】 begint op 【开始时间】`,
"labe_benchmark_objects":`Referentie object`,
"component.chatter.button.collect":`Bladwijzer`,
"front-QBtoCC-sinchronies":`Synchroniseren...`,
"message.submitpage.sms":`Gefeliciteerd. SMS succesvol verzonden.`,
"label.imgfield.width":`Breedte`,
"label.send_email":`Emailberichten over indiening sturen naar`,
"label.queue.list":`Wachtrij Lijst`,
"label.tabpage.fieldoptions":`Record type veld, optie lijst veld, en optie lijst (meerkeuze) veld. het is aanbevolen om maximaal 10 trefwoorden in te voeren, gescheiden door komma's om "of relatie" te bereiken, zoals: "New York, Toronto, Tokyo".`,
"component.chatter.post.button.save":`Publiceren`,
"chatter.group.groupDescriptionInformation":`Groep Beschrijving`,
"label_setup_mobilesetup_isenableh5newandedit":`Activeer nieuw en bewerken van H5 in uw mobiele app.`,
"lable.Confirm.recallpotential.customers":`Bevestig om {num} afleidingen te recyclen.`,
"label.knowledge.setting.hint.seven":`Kies een naam uit de volgende en geef schrijf toegang om uw inspanningen bij te dragen.`,
"label.emailtocloudcc.redmessage2":`Voer het wachtwoord van uw e-mailaccount in`,
"message.validation.equalTo":`Voer dezelfde waarden in.`,
"vue_label_help_golbal":`Algemene navigatie`,
"vue_label_chatter_delete_group_title":`Groep verwijderen`,
"label.user.login.success":`Succes met inloggen`,
"label.chatham.standard.time":`Chatham Standaard Tijd`,
"label.vlidaterule.example.percent":`Kortingspercentage kan niet hoger zijn dan 30%`,
"label.group.field":`Specificeer groeperingsveld`,
"label.trigger.operation.sharetab":`Trigger Actions Shared Form:`,
"label.mobile.phone.write.month.report":`Maandelijkse werkaantekeningen`,
"label.statusofconvers":`Omgezette status`,
"label.version.emailtemplate.track":`Email sjabloon`,
"label.customobjects.onlytrackforupdate":`Alleen wijzigingen bijhouden`,
"label_tabpage_enterviewname":`Stap 1: voer de naam van het uitzicht in`,
"label.processsetting.three.enable":`Stap 3: Activeren`,
"label.service.show.more.info":`Toon meer info`,
"front-epwechat-module-v1-input-iosschema":`Voer het iOSschema in`,
"label.dataimport.datatype.error":`Fout in het gegevenstype, controleer zorgvuldig of de gegevens en de titel één voor één overeenkomen.`,
"label.staticresource":`Statische bron`,
"label.weixin.customize":`Aanpassen`,
"label.product.edit.sel":`Bewerk Geselecteerd`,
"label.appointmentpage.wizard.notif5":`Ongeldig telefoonformaat`,
"label.marketsea.basicsetup":`Basis Instellingen`,
"label.workflow.supplyintruduce":`1.Criteria die de workflow regel laten lopen.<br/> 2.Onmiddellijke acties die worden uitgevoerd wanneer een record aan de criteria voldoet. CloudCC kan bijvoorbeeld automatisch een e-mail sturen die het accountteam informeert wanneer een nieuwe kans is aangemaakt.<br/>3.Tijdafhankelijke acties die in een wachtrij worden geplaatst wanneer een record aan de criteria voldoet, en worden uitgevoerd volgens de tijdstriggers.`,
"label_report_line_tuozhuai":`Sleep of dubbelklik om de rapportkolom te selecteren en de volgorde aan te passen`,
"label.add.new.rule":`Nieuwe Generatieregels toevoegen`,
"label.marketing.setting2":`Instelling`,
"vue_label_chatter_delete_some_group":`Weet je zeker dat je de groep "{groupInfoList}" wilt verwijderen?`,
"label.appupload.uploading.wait":`Even geduld a.u.b.`,
"label.linecondition.error":`Rij conditie fout, veldtype mismatch!`,
"chatter.group.request":`Verzoek`,
"label.recordtype.tabname.remark":`Gebruik deze pagina om recordtypes voor uw organisatie aan te maken en te onderhouden. U kunt verschillende paginalay-outs en keuzelijstwaarden weergeven op basis van recordtypes. Om recordtypes te gebruiken, voegt u het veld Recordtype toe aan uw paginalay-outs.`,
"setup_mainpage_label_welcome4":`Instructies: Klik op het menu aan de linkerkant van de pagina → Application Settings → Create → Object.`,
"vue_label_salesadvance":`Voorschot verkoopfase`,
"vue_label_campaign_of_existing_campaign_members":`Stel de status van bestaande campagnemembers in`,
"label.report.object.detail.no.permission":`Het rapporttype is gewijzigd of verplaatst. Neem contact op met de beheerder voor hulp.`,
"label.weixin.untreated":`Open`,
"label.service.miniProgram.bindSetOwnerDesc":``,
"label.autoassigntoapprover":`Automatisch toewijzen aan goedkeurder(s).`,
"label.marketseamemset.containself":`Bevat zelfgebouwde records`,
"vue_label_report_drill":`Boor`,
"label.order.products.to.assets":`Orderproduct omzetten in activa`,
"label.recordtype.list":`Bestaand recordtype`,
"lable.outlook.detail.conflict":`Conflict Gedrag`,
"pagecreator.page.label.layoutpreview":`Lay-out voorbeeld`,
"front-kefu-moudle-v1-zxltyhxzc-buyuser":`Chatten met agenten wordt door Easemob ondersteund. U dient eerst een Easemobaccount aan te schaffen.`,
"label.convers":`Converteren`,
"serviceappointment.worktype.isnot.father.worktype":`Het werktype dat bij het bovenliggende record hoort moet voor deze dienstafspraak worden geselecteerd.`,
"lable.tianyancha.h5.relatedcom":`Relavante bedrijven`,
"label.reportsSubscriptionPage.schedulereport":`Schema Rapport`,
"label.workbanch.setup.showinworkbanch":`Weergave op mijn werkbank`,
"label_emailsync_connectaccount":`Verbind e-mail account`,
"label.usermanage.license.not.qualified":`Het systeem heeft gedetecteerd dat dit een nietconforme licentie is, neem contact op met de leverancier om opnieuw een licentie te verkrijgen!`,
"component_setup_label_displayfield":`Weergave veld`,
"setup_layout_label_buttonarea":`Knop Gebied`,
"label.weixin.input.content":`Voer de inhoud in`,
"label.operatedata.importsuc":`Succesvolle import, u kunt het importresultaat controleren door op het tabblad van het object te klikken.`,
"label_tabpage_yes1z":`Ja1`,
"front-electronic-signature-describe":`Toegang tot Ehandtekening, teken een contract waar en wanneer u maar wilt. Ondertekenen met één klik, veilig en efficiënt!`,
"label.event.this.month":`Deze maand`,
"label.document.replaces":`Vervangen`,
"label.email.cc":`Cc`,
"chatter.feed.sticker":`Voer traceren`,
"vue_label_commonobjects_view_chart_notice_pleaseaddchart":`Kaart toevoegen a.u.b.`,
"label.cpq.main.quote.transfer.order":`Alleen de primaire notering kan orders genereren.`,
"label.partnerCloud.partnerAccount.topUpSuccess":`Succesvol herladen`,
"label.appexchange.uninstallpage.uninstall":`Verwijder`,
"label.campagin.roi.channel":`Kanalen`,
"label.multilang.versioncontrol.checkversion":`Uw huidige CloudCC versie is {0} waardoor u {1} {2} die de limiet hebben bereikt! Upgrade indien nodig de CloudCC-versie!`,
"label.emailobject.my.template":`Alleen mijn sjablonen`,
"label.edittimetrigger":`Tijd trekker bewerken`,
"label.setup.mobile.homepageshortcuts.saveerror":`De mobiele homepage swift functie-instellingen worden niet opgeslagen.`,
"label.address.street":`Straat`,
"label.workflow.estimatecondition2":`gecreëerd`,
"label.wei.expiresdate":`Verloopdatum`,
"label.quickbooks.viewlist.date":`DATUM`,
"label.page.select.field.type":`Selecteer type veld`,
"label.tabpage.mypotentialcustomers":`Mijn aanwijzingen`,
"label.file.library.editlib":`Wijzig bibliotheek details`,
"label.weixin.message.operateexception":`Prompt`,
"label.visualpage.staticresource.p1":`1.Methode aanroepen.Referentie geselecteerde statische middelen door te verwijzen naar statische middelen knoppen`,
"label.icon.175":`Vliegtickets`,
"chatter.edit.r":`Schrijf een commentaar...`,
"label.examinationandapproval.flow":`Goedkeuringsprocedures`,
"label.mr.descreption.reDataList5":`reeksen gegevens.`,
"label.edit.field.select.showstyle":`Weergave Stijl`,
"label.reportsSubscriptionPage.condition.and":`EN`,
"label.please.associations":`Kies een bijbehorend object.`,
"label.service.dispatchingUnits.displays.service.appointments":`Toon service afspraken die niet gekoppeld zijn aan een regio`,
"label.addcurrent":`Bestaande toevoegen`,
"label.search.change":`Doorzoekbare objecten aanpassen`,
"message.schedulejob.error.modify":`Op basis van een geconfigureerd schema, zal de gegeven job nooit worden getriggerd. Controleer de gegevens en verzend opnieuw.`,
"label.chatter.sendEmailToGroupMember.subject.L":`{0} gepubliceerde links voor alle in {1}`,
"label.weixin.micro.oldid":`Originele ID van WeChat Official Account`,
"label.employees.only.invitation.code":`Het systeem zal een unieke uitnodigingscode genereren voor de werknemer, die kan worden gebruikt om uitnodigingen te maken en kan worden geteld als individuele prestatie. Let op: de eigenaar van de lead is de huidige eigenaar van de marketingcampagne of de uitnodiger van het marketingkanaal. U kunt de leads opnieuw toewijzen via de regels voor leadtoewijzing. Voor toewijzingsregels`,
"lable.PowerProcess.event.msg":`U kunt tijdsafhankelijke workflowacties toevoegen die optreden bij elke stap (mijlpaal) in het rechtenproces. U kunt bijvoorbeeld acties instellen om een e-mail te sturen naar de eigenaar van de zaak één uur voordat een mijlpaal verstrijkt, of om automatisch specifieke zaakvelden bij te werken wanneer de eerste reactie op een mijlpaal is voltooid.`,
"label.file.share.email.content2":`Premission: #sharerole`,
"label.querydetailservice.datalayout.notexist":`De overeenkomstige lay-out van het record bestaat niet.`,
"label.group.items":`Groepsartikel`,
"label.istouse":`Beschikbaar`,
"front-electronic-signature-explain":`Fadada Ehandtekening Beschrijving:`,
"label.partner.template.thumbnail":`Thumbnail`,
"registration.page.selected.fields":`Verplichte velden op de registratiepagina`,
"label.reportTypeCategoryLabel":`Gegevensbron`,
"vue_label_email_You_have_not_activated_the_mailbox":`U heeft de mailbox niet geactiveerd`,
"lable.SalesCommitmentKanBan.taskCompletionRate":`Taak Voltooiing Rate`,
"label.forecast.detailforecast.program":`Prognose-items`,
"label.page.display":`Weergave`,
"label.passwordPolicy.setup.minute":`minuten`,
"label.emailtocloudcc.step1total3":`Stap 1 van 3`,
"label.file.title":`Titel`,
"label.callcenter.private.key":`Geheime toegangssleutel`,
"com.cloudcc.login.error.message.loginerror":`Uw id of uw wachtwoord is onjuist`,
"UG_Lead_004":`Webformulier`,
"label_tabpage_recordsz":`Record`,
"label.shangqing.discovery":`Ontdekking van bedrijfsinformatie`,
"vue_label_notice_change_success":`Met succes veranderd`,
"label.ems.other":`Andere`,
"loading":`Laden...`,
"label.committedtoapprove":`De ingediende goedkeuringsaanvragen`,
"label.category.4":`Financieel`,
"template.report.folder.customer.situation":`Analyse van de boekhoudkundige situatie`,
"label.quickbooks.searchresault.phone":`Telefoon`,
"label.ccpeak.ccobj.save":`Om CCObject op te slaan in de database, is de aanroepmethode`,
"label.knowledge.delete.linked":`Fout bij het verwijderen van geassocieerd artikel`,
"label.forecast.settings.future2":`Toekomstige 2 cycli`,
"message.error.displaytype.detail":`Weergavetype kan niet leeg zijn, Dag: dag, Maand: maand, Week: week, Beschikbaarheid: beschikbaarheid!`,
"front-template-V1-search-template-name":`Voer objectnaam in en zoek`,
"label.sendsms.batch.step3.introduce":`Activiteiten van elke SMS opslaan`,
"UG.Forcast.08":`Vorige stap`,
"label.inputnameandintro":`Voer naam en beschrijving in`,
"label.redistributioned":`Opnieuw toegewezen`,
"label.service.dispatchingUnits.left.right.total":`{left}-{right} records , {totalCount} records in totaal.`,
"label.projectManagement.Pleaseentertheactualworkinghours":`Gelieve de werkelijke werkuren in te vullen`,
"label.exporttemplate":`Exporteer de sjabloon`,
"label.data.downpage":`Pagina voor het downloaden van gegevens`,
"message.please.choose.contact":`Selecteer een contactpersoon`,
"message.error.dataformat.error":`Fout in gegevensformaat`,
"label.customsetting.changefieldtype.losevalue":`Als u overschakelt op het geselecteerde gegevenstype, gaan alle bestaande gegevens in het veld verloren.`,
"label.sendemail.chat.chattype":`Het type van de hoofdpost:`,
"label.ccdocument.upload.error":`Fout bij uploaden document.`,
"label.quickbooks.view.all":`Alle`,
"label.data.downpage.e_title":`Stappen voor gegevensuitvoer`,
"lable.data.lock":`De gegevens zijn vergrendeld, als u ze wilt bewerken moet u ze eerst ontgrendelen.`,
"label.locked":`Gesloten`,
"label.customfields.beforedeletedata":`Om een gegevensbestand te bewaren voor toekomstig gebruik, moet u een gegevensexport uitvoeren voordat u aangepaste velden verwijdert door te klikken op Instelling | Gegevensbeheer | Gegevensexport.`,
"label.productsales.oppor.noapproach":`Geen mogelijkheden met een verwachte contractdatum van minder dan 30 dagen`,
"label.input.notmore.than.number":`Voer een getal in kleiner dan of gelijk aan {0}`,
"label.list.userinterface.isenable":`Inline bewerken inschakelen`,
"label.listofshare":`Lijst met aandeleninformatie`,
"label.emailsync.status.role":`Rol`,
"label.staticresource.useful.realtion":`Waar wordt deze statische bron gebruikt`,
"label.sharerule.tip":`Deze pagina toont de instellingen voor delen van uw organisatie. Deze instellingen bepalen het niveau van toegang dat uw gebruikers hebben tot gegevens van anderen.`,
"label.qrcodelogin.message.expired":`QR Code is verlopen`,
"label.marketing.setting3":`Instelling van marketingkanalen`,
"vue_label_statistical_field":`Statistisch gebied`,
"message.view.addtomyhomepage":`Toevoegen aan mijn homepage Werkbank`,
"label.customfields.percent.tip":`Stelt gebruikers in staat een percentage in te voeren, bijvoorbeeld "10" en voegt automatisch het procentteken toe aan het getal.`,
"component_newrecords_label_10records":`10 records`,
"Lead_Scoring_Warning_001":`Scoor één leadrecord automatisch bij het maken of bewerken. Maar u moet handmatig meerdere lead records scoren, wanneer u batchgewijs importeert of aanmaakt via een interface.`,
"label.project.planing":`Verzonden manuren VS Gerapporteerde manuren in dit jaar`,
"label.data.exp.pwdverif":`Wachtwoorden zijn alleen toegestaan voor letters en cijfers.`,
"coderules.notEnable":`Neem contact op met de beheerder om de regels voor het genereren van QR code en streepjescode te activeren.`,
"label.weixin.wdyj.jxhk":`Persoonlijk-Verkoop-Prestaties-Betalingen`,
"label.data.expnode.e_desc3":`3. Sjabloon maken: de gebruiker kan de sjabloon maken op basis van de velden en voorwaarden die zullen worden geëxporteerd om aan uw behoeften te voldoen, wat handig is om de volgende keer te gebruiken.`,
"chatter.group.join":`Word lid van`,
"vue_label_systemSettings_monitoring":`Monitor`,
"front-kefu-moudle-v1-yesorno-delete-folder":`Weet u zeker dat u deze map wilt verwijderen?`,
"label.exchange.sync.state.info":`Controleer de systeemstatus om ervoor te zorgen dat records worden gesynchroniseerd tussen Exchange en CloudCC.`,
"lable.outlook.mcto.emaildes":`Voer alle e-mailadressen in van leads en contactpersonen die u hebt gebruikt om e-mail te verzenden, en gescheiden door komma's. Alleen e-mail verzonden vanaf het onderstaande e-mailadres kan worden toegevoegd aan de Activiteitengeschiedenis als de gerelateerde records.`,
"label.ems.save":`Save`,
"vue_label_dashboard_maximumvalue":`Voer de maximumwaarde in`,
"label.passwordPolicy.setup.norestriction":`Geen beperking`,
"label.multilang.customforcast.total":`Accumulatie van {0}：`,
"label_partner_all_memo":`Lijst toont alle partner clouds in uw organisatie. Klik op url om in te loggen.`,
"Account.News.Setting.002":`Gebruik de onderstaande accountinstellingen om het standaard accountgedrag voor uw organisatie te specificeren.`,
"label.essential":`vereist`,
"label.nonotice":`Geen aanmaningen meer.`,
"vue_label_calendar_calendar_deleted_successfully":`Kalender succesvol verwijderd`,
"message.huanxinagent.disable":`Inactief Agent`,
"label.goto":`Ga naar`,
"label.chat.topic.add.favorite":`Toevoegen aan Favorieten`,
"label.trigger.targetobj":`Doelobject`,
"label.form_fields":`Formulier velden`,
"this.month":`Deze maand`,
"vue_label_homepage_select_view":`Selecteer Weergave`,
"label.weixin.input.subject":`Gelieve het onderwerp in te vullen`,
"label.ems.emailType":`Type brievenbus`,
"vue_label_file_safe_type_file":`Gelieve te bevestigen dat het bestand geen gevoelige informatie bevat. Overweeg bestanden te delen met specifieke gebruikers of dossiers`,
"label.version.case.automatic.upgrade":`Escalatie en toewijzing van zaken`,
"label.input.invalid.credit.card.number":`Voer een geldig kredietkaartnummer in`,
"component_timeline_label_future":`Volgende stap`,
"label.emailtemplate.cannotsupporthtml":`HTML-type wordt momenteel niet ondersteund`,
"label.appupload.install.error.info2":`{1} {0}' conflicteert met bestaande componenten.`,
"label.custom.field.maping":`naar dit veld.`,
"encd":`Gecodeerde tekst (gecodeerd weergeven)`,
"label.service.newBuildDialog.filter.logic":`Filter Logica`,
"label.customerinfo":`Profiel van het bedrijf`,
"vue_label_applauncher_notice_activepoolsuccess":`Met succes de loodpool geactiveerd`,
"label.partner.workspace.member.choicepermission":`Kies toestemmingenset`,
"front-gantt-module-this-task-of-other-tasks":`Deze taak bestaat als een subtaak en kan geen subtaak van een andere taak zijn!`,
"label_chatter_publish":`Publiceren`,
"label.forecast.settings.mrfw":`Beginnend op`,
"label.Named.Filter":`Geef het filter een naam`,
"label.department.email":`E-Mail Adres`,
"label.updatingfield":`Veld bijwerken`,
"label_partner_template_detail":`Functiebeschrijving`,
"front-epwechat-module-v1-unbound-item":` bindend voor alle ondernemingen`,
"vue_label_file_lib_name":`Naam bestandsbibliotheek`,
"label.notification.arketsea.distribution":`{5} toegewezen {2}{0}：{1} aan jou`,
"vue_label_norm_removecomponent":`component verwijderen`,
"component.event.label.begindate":`*Start tijd`,
"chatter.note":`ontvangen commentaar(en)`,
"label.forecast.settings.type.all":`Opheffingsvoorspelling`,
"label.compact.layout.frame.full":`Weergave op volledig scherm`,
"label.approvalstep3intro":`Specificeer met behulp van de onderstaande opties de gebruiker aan wie het goedkeuringsverzoek moet worden toegewezen.`,
"label.notification.approval6":`【被委派人名称】approved het goedkeuringsverzoek van 【提交人】 van 【对象】【对象名称】for u.`,
"setup.object.field.dependency.label.actionfieldvalue":`Controlling Field`,
"label.multilang.page2":`Pagina`,
"vue_label_email_submitted":`Ingediend`,
"label.Standard.button":`Standaard Knoppen`,
"vue_label_report_emailchoose":`E-mail optie`,
"page.field.masterinput.list":`Master-Detail Invoergegevens Lijst`,
"label.martrixdown":`Matrix Omlaag`,
"vue_label_helpcenter_opportunity":`<br>In de rechterbovenhoek van het scherm, klikt u op het verkooptrechter-icoon om naar de verkooptrechter te springen.<br>Via de intuïtieve voortgangsbalk kunt u de voortgang van elke zakelijke kans volgen, en op de knop klikken om de voltooiing van de huidige fase te markeren, of de huidige fase aan te passen. Als u obstakels tegenkomt in de voortgang van zakelijke kansen, kunt u de voortgangsbalk ook uitbreiden om de informatie en enkele warme tips te bekijken waaraan in de huidige fase meer aandacht moet worden besteed.<br>Via de gerelateerde lijst van de zakelijke kansen groep, kunnen de gegevens over de zakelijke kansen worden gedeeld met andere mensen die geen toegang hebben om ze te bekijken, om zo het samenwerken te vergemakkelijken.<br>In de contactrol-gerelateerde lijst onder de zakelijke opportuniteit, voegt u snel de rol in de opportuniteit toe aan het contact in de overeenkomstige klant, en vervolgens bekijkt u de superieure en ondergeschikte relatie van het gerelateerde contact via het relatienetwerk, en gebruikt u de radardiagram om het huidige contact te evalueren De waarde van kansen, opvolgen, sleutelpersonen lokaliseren, en contacten controleren. Rol, bezoekstatus, relatiegraad, aankoopstijl en bezoektijden<br> Via de gerelateerde lijst van business opportunity producten, kunt u producten toevoegen in dezelfde prijslijst voor de business opportunity, en de prijs en hoeveelheid van de producten bewerken.`,
"label.sso.ssoKeyMan":`Single Sign-On Sleutelbeheer`,
"label.forecast.edit.desc":`Stel het quotum van een gebruiker in voor de volgende periode`,
"label.weixin.newspaper.coverage.time":`Risico Datum`,
"label.pleaseselectpro":`Gelieve producten te kiezen`,
"label.bottonandlink":`Knoppen en links`,
"label.donot.know.error":`Er is een onbekende fout opgetreden, neem contact op met de beheerder.`,
"label.account_noordab":`Uw account heeft 0 aangepaste rapporten en 2 dashboards.`,
"label.partnerCloud.orderingPlatform.toPay":`Betalen per partnerfonds`,
"label.many.dayline.nextday":`Volgende dag`,
"lable.showmorerecords":`Toon meer`,
"front-lightning-module-v1-details-page-chart-record-type":`Selecteer type record`,
"label.ccpeak.query.record":`zoeken naar de gegevens`,
"pagecreator.systemstyle.message.save.fail":`Stijl opslaan mislukt`,
"label.weixin.share.file":`Bestand delen`,
"errormessage.email.relatedorreceivermusthaveone.z":`U moet ten minste één ontvanger of een verwant onderwerp kiezen.`,
"chatter.save.f":`Opslaan mislukt`,
"button.partner.create":`Nieuw`,
"label.marketseamemset.lead.title2":`Stel alstublieft een bovengrens aan het aantal leads dat alle leden aangaat. De limiet heeft niets te maken met de pool op volle zee`,
"label.service.major.event.new":`Nieuwe Mijlpaal`,
"label.version.custom.site":`Aangepaste site`,
"label.permission.visualpagepermission":`Toegewezen aangepaste pagina's`,
"lable.product.zongjia":`Totale prijs`,
"label.viewchart":`Bekijk Grafieken`,
"label.alaska.daylight.time":`Alaska zomertijd`,
"front-kefu-moudle-v1-rgdyhcwzx-reply":`Laat meer gebruikers agenten worden en bezoekers dienen, verbeter de klantendienst.`,
"component_assistant_label_todaylead":`De leads die vandaag aan jou zijn toegewezen`,
"label.sendemail.chat.addComentsfavorite":`Beste #naam:\n ; hallo! #gebruikersnaam heeft gereageerd op uw bericht.`,
"label.smstemplate.tip":`Alle SMS sjablonen in de geselecteerde map worden hieronder weergegeven. Klik op de knop "Nieuw" om een nieuw tekst of HTML SMS sjabloon aan te maken. U kunt deze SMS-sjablonen gebruiken bij het verzenden van berichten. Klik op de rol link om meer gedetailleerde informatie te bekijken"`,
"label.documentname":`Naam van het document`,
"label.icon.162":`Landschap`,
"label.salescloud.wanyuan":`Yuan`,
"label.view.desc1":`Record type veld, picklist veld en picklist (multi-select) veld, is het aanbevolen om maximaal 10 trefwoorden in te voeren, gescheiden door komma's. Zoals "New York, Toronto, Tokyo".`,
"label.searchlayout.lookup.newfield":`Opzoekingsdialoogvensters die verschijnen wanneer u op de nieuwe knop op Opzoekingsvelden klikt.`,
"label.emailobject.bcc":`Bcc:`,
"label.manageAll.pagenum1":`Dit is de eerste pagina.`,
"vue_label_appstore_crm_used_companies":`CRM gebruikt door beursgenoteerde ondernemingen`,
"label.document.replace":`Vervangen`,
"label.assignment.setup.newrule.title":`Nieuwe zaak toewijzing regel`,
"component.chatter.label.mygroup":`Mijn groep`,
"lable.currencyAdv.exchangedate":`Datum Bereik`,
"label.quickbooks.button.viewinqb":`Bekijk in QuickBooks`,
"UG.homepage.004":`Automatisering`,
"label.currencyName":`Valuta Naam`,
"Homepage_News_001":`Nieuws`,
"front-lightning-module-v1-details-page-chart-refresh-button":`Toon knop Vernieuwen`,
"label.list.projectSetting.isenable":`Project timer inschakelen (Inclusief: Mijlpaal, taak, subtaak, probleem)`,
"setup.layout.message.relatedlistbutton":`Kies standaard knoppen om op de`,
"vue_label_homepage_homepageassignment":`Toepassing Home Page Opdracht`,
"label.pending":`In afwachting van`,
"component.timeline.label.today":`Vandaag`,
"front-kefu-moudle-free-hasexpire":`Uw gratis proefperiode is verlopen`,
"homepage.layout.customlayout":`Aangepaste pagina-indeling`,
"label.service.miniProgram.content":`Vul de inhoud in.`,
"label.defaultline.must.int":`Het standaard aantal regels kan alleen positieve gehele getallen zijn.`,
"label.mirror_issues":`Als het formulier niet overeenkomt met wat u op uw scherm ziet, lees dan ons artikel over het oplossen van veel voorkomende problemen met het scherm.`,
"label.edit.select.two":`Lijst met één selectievakje`,
"label.emailmerge.mergeFolder.tip":`Het samenvoegen van sjablonen neemt enige tijd in beslag, klik tijdens het samenvoegen niet op andere links, sluit uw webbrowser of vernieuw de pagina.`,
"label.ServiceCloud.zichan.distributionMap":`Kaart van activaspreiding`,
"label.selectfile":`Bestanden kiezen`,
"vue_label_account_equitymanage":`Beheren van aandelenrelatie`,
"label.email.clearAll":`Alles wissen`,
"label.selecting.parent.assets":`Kies Ouder Actief`,
"component.setup.tabs.label.delete":`Delete`,
"label.visualpage.top.must.is":`De eerste regel van de oage header moet zijn:`,
"label.SalesCommitmentDashboard":`Verkoop Commit Dashboards`,
"chatter.group.changeTheRole":`Verander de rol`,
"label.dataimport.insertdata.error":`Er is een fout opgetreden bij het invoegen van nieuwe gegevens. Controleer deze gegevens zorgvuldig.`,
"label.partner":`Partner wolk`,
"label.process.async.execute.tip":`Uw aanvraag is in behandeling. De goedkeuring neemt enige tijd in beslag en het resultaat zal op de detailpagina worden getoond. Even geduld a.u.b.`,
"label.service.newBuildDialog.additional.conditions":`Bijkomende voorwaarden`,
"label.name_copy":`U staat op het punt dit bestaande formulier te klonen. Geef een naam op voor de kopie.`,
"label.integrations.install":`Installeer`,
"label.edit.ccpeakfolder.time":`Geplande Klassen: Map Bewerken`,
"label.knowledgebase.filing.time":`Gearchiveerde tijd`,
"vue_label_chatter_success_exit_group":`Met succes de groep verlaten`,
"font.market.module.v1.save.name":`Gelieve de naam van de vergadering in te vullen`,
"label.a.b.without":`A-records kunnen al dan niet verwante "B"-records hebben.`,
"label.chat.topic.desc":`Beschrijving`,
"label.field.editoptionlist.introduce":`Voer de naam van de picklist waarde in.`,
"label.versiontype.Enterprise":`Onderneming`,
"message.selectrulecondition":`Specificeer alstublieft de regel criteria`,
"label.custombutton.unknown.operation":`Ongeldige acties`,
"label.pricecannotnull":`Prijs is vereist`,
"component_salesperformance_label_target":`Doel`,
"pagecreator.page.message.delete.success":`Pagina succesvol verwijderd`,
"label.help.new.features":`Nieuwe functies van CloudCC`,
"label.weixin.vehicle.owner.information":`Gegevens eigenaar voertuig`,
"label.exchange.sync.state.user.info":`Controleer de synchronisatiestatus van een gebruiker om ervoor te zorgen dat records worden gesynchroniseerd tussen Exchange en CloudCC. Als de gebruiker een probleem heeft met de synchronisatie tussen Exchange en CloudCC, kunt u het synchronisatieproces opnieuw instellen. Hiermee reset u alleen gegevens die CloudCC for Exchange gebruikt en verwijdert u geen gegevens van uw Microsoft Exchange-server of CloudCC.`,
"label.batcheditor":`Massa bewerken`,
"report.label.knowcreatehighlevelreport":`Hoe maak ik een geavanceerd rapport?`,
"label.dataimport.title.length":`De lengte van de titel is`,
"label_model_description":`Beschrijving van het model`,
"label.tabpage.ctbtsftcz":`Klik op de achterkant om de inhoud te zoeken`,
"label.channel.activity.member.owner":`Eigenaar van Campagne Lid`,
"label.ems.serverinfo":`Server informatie`,
"tjinvilid":`Onwettige voorwaarden`,
"label.nameofreport":`Naam rapport`,
"label.ifapproverreject":`Wat gebeurt er als de goedkeurder dit verzoek afwijst?`,
"label.wtd.changefields.title.desc2":`Als u een record op de mobiele app "Web to CloudCC" nodig hebt om een lead te koppelen, moet u een veld van het huidige object maken om de lead op te zoeken, en de veld-API-naam is " lead_wtd".`,
"label_emailsync_form_connecttime":`Verwante tijd`,
"label.visualpage":`Aangepaste pagina`,
"label.customlink":`Aangepaste koppelingen`,
"label.lead.score.doing.remark":`Uw verzoek is verwerkt en het zal een bepaalde tijd duren voor lead scoring. en het systeem zal u per e-mail informeren wanneer het voltooid is.`,
"label.h5.act.details":`Details van de activiteit`,
"label.profile.setrecordtype":`Instellingen opnametype`,
"label.processsetting.process.enabled.successfully":`Inschakel proces succesvol!`,
"label.campaign.url.overtime":`De link is verlopen.`,
"label.structureChart.notFiled":`Niet gevuld`,
"label.h5.chatter.something":`Je zegt iets`,
"label.pm":`PM`,
"template.chart.rwlx":`Type taak`,
"label.icon.42":`Wolk`,
"label.project.hit.one":`Mededeling subtaakverdeling`,
"label.martrixreport.2018.step3":`Stap 3 Kies kolomkoppen`,
"label.wtd.changefields.newmo":`Mobiele pagina genereren`,
"label.downloadTheTemplate":`Sjabloon downloaden`,
"label_chatter_assignPerson":`Aangewezen persoon`,
"label_emailtocloudcc_license":`Licentie`,
"label.willdeletedlayout":`Paginalay-outs die u wilt verwijderen`,
"label.projectManagement.delete.question":`Alle gerelateerde informatie van deze kwestie zal ook worden verwijderd als u deze kwestie verwijdert, en de gegevens kunnen niet worden hersteld. Weet u zeker dat u de verwijdering wilt bevestigen?`,
"lable_setup_mobilesetup_isEnableValidationRulesForScan":`Validatieregels inschakelen bij gebruik van Scan`,
"label.salescloud.opportunity.addandedit.contactrole.note":`Opmerking: dubbelklikken op de lege contacten, kan een leeg record toevoegen`,
"label.step6.total6":`Stap 6 van 6`,
"label.knowledge.setting.hint.one":`Met Knowledge kunnen klanten en servicepersoneel de Knowledge-artikelen ten volle benutten.`,
"label.usefieldautoassign":`Wijs automatisch een goedkeurder toe met behulp van een standaard of aangepast hiërarchieveld:`,
"label.partnerCloud.orderingPlatform.orderAmount":`Bedrag van de bestelling:`,
"chatter.fieldtrack.operateupdate":`veranderde een`,
"chatter.del.com":`Verwijder deze opmerking`,
"report.reportdatasource.label":`Verslag Gegevensbron`,
"label.text":`Tekst`,
"label.marketsea.select.member":`Facultatieve leden`,
"label.typeofreceivers":`Type ontvanger`,
"label.knowledgebase.affect.existing.translations":`Ja, mijn wijzigingen zullen de bestaande vertaling beïnvloeden. Markeer als "vervallen`,
"label.marketing.invitationmail":`Welkom bij onze activiteit. Uw uitnodigingslink is:`,
"label.version.quotation.management":`Beheer van offertes`,
"label.dataimport.insertdata.error.unique":`$fieldName$ schendt de uniciteitsbeperkingen bij het invoegen van nieuwe gegevens.`,
"label.emailmerge.list.newtemplate":`Nieuw sjabloon`,
"label.salescloud.salescloud.allteam":`Alle Opportunity Team gebaseerd op alle Teams`,
"vue_label_commonobjects_detail_record_changes":`Veld record wijzigingen`,
"label.file.delete.info":`Bestanden verwijderen`,
"vue_label_calendar_name":`Kalender Naam`,
"label.version.support":`Steun`,
"label.event":`Evenementen`,
"label.searchlayout.lookup.searchdialog":`Opzoekingsdialoogvensters die verschijnen wanneer u op het opzoekingsicoon klikt in Opzoekingsvelden.`,
"label.data.downpage.e_list.desc2":`Na voltooiing ontvangt u een e-mail om u eraan te herinneren dat de gegevens met succes zijn geëxporteerd.`,
"label.partnerCloud.productSet.delIsTrue":`Wilt u dit product verwijderen?`,
"label.tianyancha.businessverify.msg2":`Deze overeenkomst is een overeenkomst tussen u (hierna te noemen de gebruiker) en CloudCC met betrekking tot het gebruik van de business data verificatie functie. deze overeenkomst beschrijft de rechten en plichten van het gebruik van de business data verificatie functie en aanverwante diensten tussen CloudCC en gebruiker. deze overeenkomst kan op elk moment door CloudCC worden bijgewerkt. de bijgewerkte voorwaarden van de overeenkomst zullen na publicatie de oorspronkelijke voorwaarden van de overeenkomst zonder voorafgaande kennisgeving vervangen.`,
"label.customobjects.cancleselectallfield":`Alle geselecteerde velden annuleren`,
"image.up.maxsize":`Het geuploade bestand is te groot, niet groter dan 2M aub.`,
"label.icon.8":`Bestand`,
"label.donot.delete":`U heeft geen toestemming om`,
"label.version.profile.and.layoutpage":`Profielen en pagina-indelingen`,
"chatter.coll.s":`Deze bladwijzer verwijderen`,
"label.icon.163":`Aarde`,
"label_chatter_myfollowers":`Mijn volgelingen`,
"label.multilang.customforecast.refuse":`Weiger elke voorspellende voorrang van {0}, maar aanvaard voorspellende voorrang van andere ondergeschikten`,
"label.tabpage.findz":`Zoeken op`,
"label.smstemplate.detailinfo":`Details van SMS Sjabloon`,
"label.knowledge.setting.hint.nineteen":`Laten we beginnen.`,
"label.mr.tip":`Vul de regels in regel {0} in.`,
"label.icon.132":`Garantie`,
"label.customobjects.track.introduce2":`Geschiedenis gerelateerde lijst. Telkens wanneer een gebruiker een van de hieronder geselecteerde velden wijzigt, worden de oude en nieuwe veldwaarden toegevoegd aan de Historiek-gerelateerde lijst, evenals de datum, het tijdstip, de aard van de wijziging, en de gebruiker die de wijziging aanbracht.`,
"label_emailtocloudcc_redmessage5":`Onbekende staus, neem contact op met de beheerder.`,
"label.must.select.field":`Regelvoorwaarde fout, u moet een veld selecteren.`,
"label.tag.manage.modifiedby":`Laatst gewijzigd door`,
"label.translation.start1":`Selecteer een taal (als u een vertaler bent).`,
"label.ccchat.topic.searchs":`Zoek Onderwerp`,
"label.mask.custom.example":`{AAAA}{****}{AAAA} staat voor de gecodeerde weergave van het vijfde tot en met het achtste teken.`,
"setup_object_field_dependency_label_addtolist":`Voeg de geselecteerde waarden toe`,
"label.view.total.record":`Totaal geselecteerd 0 record.`,
"label.service.without.right":`Geen aanspraak`,
"template.chart.wxqzkhyy":`Redenen voor ongeldige leads`,
"vue_label_dashboard_pleaseenterabreakpoint1value":`Voer een breekpunt 1 waarde in`,
"message.pleaseinputmouthdistance":`Voer het geldige maandinterval in.`,
"label.forgetPsd.tip":`Wachtwoord vergeten, neem contact op met de beheerder.`,
"label.projectManagement.planned":`Gepland`,
"lable.Product.conversion.asset.operation":`Overdracht product naar activa`,
"label.search_forms":`Formulieren zoeken`,
"label.sendemail.chat.addPostmainPagesubject":`CloudCC CCChat startpagina bericht`,
"label_tabpage_viewNamez":`Voer de naam van het uitzicht in`,
"label_chatter_addresser":`Afzender`,
"Opportunity_Detailed_Phase_Change_Text_001":`Change Opportunity Stadium`,
"label.what":`Pagina`,
"vue_label_systemSettings_set_android":`Menu's en functies instellen voor Android en IOS om het geschikt te maken voor zakelijke gebruikers.`,
"label.sell":`Verkoop`,
"template.report.folder.case":`Gevallen Analyse`,
"label.customfields.profilefieldsafety":`Veld-niveau beveiliging van profiel`,
"label.industrialandcommercialverification.label.token":`Penning`,
"label.finished":`Voltooid`,
"label.sendmail.step3.introduce1":`Je hebt momenteel`,
"vue_label_calendar_other_calendars":`Andere Kalender`,
"label.donot.know.validate.field":`Ongeldige validatievelden`,
"label.exportdetail":`Uitvoer Details`,
"label.step.filter":`Filtervoorwaarden specificeren`,
"label.campaignmember.main.hasMember":`Bestaande leden`,
"label.updown.suess":`Succesvol downloaden`,
"label.ems.browse":`Bladeren`,
"front-email-payment-Invoice-login-account-describe":`Klik op "Doorgaan" om de betaling van de factuur te voltooien door de QRcode van Alipay te scannen of in te loggen op Alipay.`,
"label.copyCustomReportType":`Kloon aangepaste rapport gegevensbron`,
"label.visualpage.write.class":`Bewerk Class code in de pagina met dezelfde syntaxis als Java.`,
"label.setsharerule.tip":`<br>Gebruik de regels voor delen om automatische uitzonderingen te maken op uw organisatiebrede instellingen voor delen voor gedefinieerde groepen gebruikers.<br>Note: "Rollen en ondergeschikten" omvat alle gebruikers in een rol, en de rollen onder die rol.`,
"label.report.action.addtodashboard9":`Dashboard Lijst Pagina`,
"label.cloudccsite.remark":`Site Beschrijving`,
"label_tabpage_noz":`Geen`,
"chatter.up.limit":`Het geüploade bestand is te groot, gelieve niet groter te zijn dan`,
"label.leadmarketsea.grouplist.title":`Lead Pool Groep Instellingen`,
"label.pc.user.help":`Gebruikershandleiding`,
"label.partnerCloud.orderingPlatform.relyOn":`Afhankelijkheid`,
"label.appointmentpage.wizard.subtitle2":`Kies Tijd`,
"label.deleteoneormore":`Verwijder één of meer`,
"january":`Januari`,
"label.delete.profile":`Profiel verwijderen`,
"label.appointment.wizard.subtitle1-7":`2 h`,
"label.icon.188":`Cosmetisch`,
"vue_label_file_already_in_lib":`Bestaat al in deze bestandsbibliotheek`,
"label.icon.151":`VR`,
"label.withvalue":`Naar waarde`,
"label.tianyancha.businseeverify.opererror":`Het openen van bedrijfsgegevens is mislukt. Probeer het opnieuw of neem contact op met uw systeembeheerder!`,
"label.tabpage.individual":`Individuele keuze`,
"label.layout.editdistribute":`Opdracht bewerken`,
"label.smstemplate.lookup":`Bekijk SMS sjabloon`,
"pagecreator.systemstyle.button.delete":`Stijl verwijderen`,
"label.customer.tab.step2.same.option1":`Standaard aan`,
"label.knowledgebase.no.results.knowledge":`Geen resultaat in Kennis`,
"label.data.exp.newtemporexp":`Selecteer de methode waarmee de gegevens worden geëxporteerd of maak een nieuw sjabloon`,
"vue_label_chatter_refuse_join":`Weigeren toe te treden`,
"Homepage.News.002":`De nieuwscomponent is momenteel niet beschikbaar.`,
"label.log.requesttype":`Aanvraag methode`,
"vue_label_dashboard_generatefromreport":`Genereer uit rapport`,
"label.knowledge.create.version":`Versie maken`,
"label.emailtocloudcc.description2":`Verbind uw e-mail`,
"label.partnerCloud.partnerAccount.recharge":`Het herlaadbedrag moet tussen 0.1 en {upperlimiet} liggen.`,
"label.customobjects":`Aangepaste objecten`,
"label.schedulableprg.endtime":`Einddatum moet later zijn dan de huidige datum van het systeem`,
"message.error.viewreport.confirmdelete":`Er zijn grafieken die de huidige view/het huidige rapport als gegevensbron gebruiken. Wilt u de grafiek ook verwijderen?`,
"label.marketing.social.seting":`Instelling sociale media`,
"chatter.follow.stop":`Stop met het volgen van deze gebruiker`,
"label.notification.arketsea.return":`{5} teruggestuurd {0}：{1} naar {2}`,
"label.conditionsofnextapprover":`Er is een of meer volgende gespecificeerde goedkeurder in uw geselecteerde goedkeuringsverzoek. Gebruik het volgende opzoekvak om de volgende goedkeurder op te geven.`,
"label.partner.all.state":`Status`,
"mobel_web_closed":`Gesloten`,
"label.icon.65":`Uitrusting`,
"label.stdashbord.xsld.business.jinehj":`Totaal Bedrag`,
"label.selectobject":`Selecteer object`,
"label.account.CurrentFQ":`Huidige FQ`,
"label.workflow.estimaterule":`Evalueer de regel wanneer een record is:`,
"label.list.userinterface.shownewrecordssetup":`Onlangs opgenomen instellingen`,
"label.tianyancha.businessverify.msg3":`1. laden`,
"label.weixin..xsld.jieduan":`Stadium`,
"label.first.quarter":`Eerste kwartaal`,
"Opportunity.Detailed.Phase.Label.002":`{0} dag(en) in huidige stadium`,
"label_tabpage_page":`Pagina`,
"label_emailsync_status_time":`Tijd`,
"label.pleaseselectaapprover":`Selecteer een goedkeurder`,
"label.emailtocloudcc.redmessage5":`Onbekende staus, neem contact op met de beheerder.`,
"label.four.quarter":`Vierde kwartaal`,
"label_chatter_relateList":`Relevante lijst`,
"label.customfields.new.step2.opration.exid.info":`Stel dit veld in op een unieke record-identifier voor een extern systeem`,
"label.projectManagement.nodata.overdue.tasks":`Geweldig. Geen achterstallige taak`,
"label.sendemail.activity.task.statuscompleted":`Beste #createbyidccname Hallo! \De taak die je hebt toegewezen aan #belongtoidccname op #createdate is als volgt: \Onderwerp: #onderwerp #vervaldatum: #vervaldatum #gerelateerde items: #relatedstr: #Bezoek de link voor meer details: \Let op: #belongtoidccname is gemarkeerd als voltooid. #orgNaamCRMsysteem`,
"label.sso.saml.idp.config.issuer":`Emittent`,
"label.cannot.delete":`items) zijn niet toegestaan om te verwijderen`,
"label.pigeonhole.sel_f":`Kies de te archiveren mappen`,
"label.customfields.text.tip":`Hiermee kunnen gebruikers elke combinatie van letters en cijfers invoeren.`,
"message.error.user.service.common":`Operatie mislukt, neem contact op met de beheerder voor hulp.`,
"label.datamanage.account.information":`Rekeninginformatie`,
"vue_label_homepage_deleteprofilepage":`Profiel homepage verwijderen`,
"label.sendmail.step3.introduce3":`ontvanger(s) die zijn geselecteerd om deze SMS te ontvangen.`,
"label.pc.ui.2018.recentitem":`Recente items`,
"label.report.loading":`Wachten op laden`,
"vue_label_globalsearch_adjustment":`Aanpassingsmethode`,
"label_report_line_yixuan":`Geselecteerde rapportkolom`,
"label.h5.similar.opportunity.only.view":`Alleen tonen`,
"label.marketactivitymember":`Campagne leden`,
"label.recycle.execute.tip":`Uw verzoek is verwerkt en het zal enige tijd duren om de prullenbak te legen. U wordt per e-mail verwittigd wanneer het voltooid is.`,
"label.permission.detail.system.setting":`Instellingen systeemmachtigingen`,
"label.RecordType":`Record Soorten`,
"label.custom.error.between":`De startdatum of einddatum van het aangepaste jaar ligt tussen de aangepaste jaren in de geschiedenis, controleer dit en stel opnieuw in`,
"vue_label_dashboard_selectview":`Selecteer Weergave`,
"label.tianyancha.businessverify.cancel":`Uitschakelen verificatie bedrijfsgegevens`,
"label.partnerCloud.financeSetting.MD5":`MD5 Geheime Sleutel`,
"label.multilang.messagedetail.new.error":`We kunnen geen Chat gebruiker vinden met een naam met {0}:`,
"label.callcenter.pleaseenter.private.key":`Voer de geheime toegangssleutel in`,
"label.umeng.activity.youdistribute":`U toegewezen aan`,
"label.weixin.nickname":`Bijnaam`,
"label.customerinfo.mailusername":`Email Gebruikersnaam`,
"label.partnerCloud.orderingPlatform.discountPlan":`Kortingsschema Naam:`,
"lable.account.year":`Fiscaal Jaar`,
"T":`Tijd`,
"System.Email.Template.Title":`Welkom bij CloudCC CRM platform`,
"label.login.type":`Types aanmelding`,
"label.notification.evaluation":`{0} links commentaar van {2} voor geval {1}`,
"label.turntolist":`Ga naar Lijsten`,
"label.sort":`Sorteren`,
"vue_label_commonobject_notice_clickcross":`Als u het geüploade bestand moet vervangen, klik dan op de [X] knop en upload opnieuw`,
"label.Select.maximumecords.operate":`Er kunnen maximaal 200 records worden geselecteerd om te verwerken.`,
"label.submission_rate":`Indieningspercentage`,
"label.datadelete.record.sucessfully":`record(s) successfully!`,
"label.version.standard.dashboard":`Standaard dashboards`,
"label.task.postunsolve":`Achterstallige Taken`,
"label.Receivables.name":`Vordering Naam`,
"label_tabpage_noOperationz":`Deze inhoud is een vast item en kan niet bediend worden!`,
"label.attendance.onrecord":`Kies een record ten minste`,
"label.partner.error2":`Fout: De domeinnaam kan alleen cijfers of letters bevatten.`,
"label.account.map":`Account Kaart`,
"label.dashboardSetup.reference.legend":`Diagram Referentie`,
"label.Yaxisscope":`Y-as Reikwijdte`,
"label.hierarchy.tree.tip":`Selecteer een record in het opzoekveld van elk tabblad om een hiërarchie te maken. En de hiërarchie is als volgt:`,
"label.permission.objlist.columnsize":`Totaal veldnummer`,
"label.setup.mobile.bottombutton.savesuccess":`Instellingen op het eerste niveau opgeslagen`,
"label.mobile.side.tab.selected":`Reeds geselecteerd`,
"label.partner.donotdel.cause":`Omdat het verwant is met de volgende partner cloud`,
"label.ccchat.message.new.error4":`Herinnering:`,
"vue_label_systemSettings_setorganization":`Stel toepassingen in voor uw organisatie, pas verschillende menu's aan voor verschillende functionele divisies.`,
"label.umeng.approval.approvalmes4obj1":`Herzie de goedkeuring op tijd`,
"UG_opportunity_010":`Een transactie aanmaken`,
"label.tag.addtags.public":`Publiek`,
"System.TAB.SeeViewPageAmount":`Pagina's bekijken`,
"label.filterconditions":`Filter`,
"front-personalEmailBox-module-v12-clear-not-associated":`Annuleer verbinding zal alle ongeassocieerde emails wissen, ben je zeker om verbinding te annuleren?`,
"label.assign":`Toewijzen`,
"label.layout.clone.tip":`U kunt een bestaande lay-out selecteren om te klonen`,
"label.choose.relatedlist":`Selecteer de gerelateerde lijst die u wilt overbrengen`,
"label_chatter_recordcall":`Opgenomen gesprek`,
"label.product.proofOne":`In {0}, kies tot {1} product opties.`,
"label.layout.availablefield.relatedlist":`Beschikbare velden / Verwante lijsten`,
"label.campaignmember.main.updateleadstatus":`Update status-bestaande leads`,
"label.custom.buttonandlink":`Aangepaste knoppen`,
"label.view.manage":`Beheer bekijken`,
"label.search.exp":`Selecteer de objecten waarvoor u de volgende functies wilt inschakelen en klik op Opslaan:`,
"vue_label_appstore_apply_to":`Solliciteer naar`,
"label.dashboard.message.refreshfail":`Vernieuwing Dashboard mislukt`,
"UG_Case_02":`Cases stellen u in staat te reageren op accountproblemen en deze op te lossen. Cases zijn een krachtig record in Cloud CC dat niet alleen problemen met de account bijhoudt, maar ook een volledig overzicht van de account weergeeft.`,
"label.project.hit.three":`Dagelijkse Subtaak Herinnering`,
"label.tianyancha.businessverify.tip":`De functie voor de verificatie van bedrijfsgegevens is ingeschakeld om gebruikers te helpen de juiste bedrijfsregistratie-informatie in te voeren wanneer zij de klantgegevens van de onderneming invoeren.`,
"label_emailsync_status_disconnect":`Annuleer Conncet`,
"label.rule.disabled.successfully":`Schakel de regels succesvol uit`,
"label.custombutton.queryerror":`Query mislukt, gelieve opnieuw te beginnen.`,
"label.customfields.deletecannotresume":`De overeenkomstige gegevens zullen permanent worden gewist en kunnen niet worden hersteld.`,
"label.account.current.M":`Deze maand`,
"label.under.approve.data":`de records worden gecontroleerd(`,
"vue_label_title_remainingdays":`Resterende dagen`,
"label.partnerCloud.orderingPlatform.refundable":`Beschikbare korting`,
"label.lookup.iscover":`Sta synchronisatie toe bij bewerken`,
"label.recordtype.detail.selectlist":`Picklists beschikbaar voor bewerking`,
"label.sso.isActiveYes":`Ja`,
"label.service.appointmentList.canceltheSuccess":`Met succes geannuleerd`,
"label.escalation.setup.newentries.createfirst":`Wanneer de zaak wordt aangemaakt, en wordt uitgeschakeld nadat de zaak voor het eerst is gewijzigd`,
"label.new.ccpeakfolder":`Klasse : Nieuwe map`,
"lable.currencyAdv.exchagecurrency.after":`en na`,
"label.majoranddetailrelation":`Master-Detail relaties`,
"label.appointment.wizard.subtitle4-2-1":`1 h`,
"label.projectManagement.working.hours":`Werktijden`,
"label.forecast.customforecast.button.forehistory":`Voorspelling Geschiedenis`,
"label.mymasterplate":`Mijn sjablonen`,
"component.setup.tabs.label.memo":`Tabbladnaam instellen`,
"label.customfields.longtextarea.tip":`Hiermee kunnen gebruikers tot 32.000 tekens op afzonderlijke regels invoeren. U kunt tot 10 Tekst(Lang)-velden per object aanmaken.`,
"label.service.miniProgram.fillJumpLink":`Gelieve de spring link in te vullen.`,
"label.british.summer.time":`Greenwich Mean Time`,
"label.nogreate":`<=Minder dan of gelijk aan`,
"label.assignment.setup.detail.sameuser":`Dezelfde gebruiker`,
"mesage.error.profile.delate.user":`Profiel kan niet worden verwijderd omdat de gebruiker is toegewezen aan het huidige profiel.`,
"label.tabpage.cownerz":`Verander eigenaar`,
"label.multilang.dupicatecheck.processedcount":`Dubbele gegevens, {0} groepen zijn behandeld, {1} groepen gegevens zijn niet behandeld：`,
"vue_label_report_notice_leavecertification":`Weet u zeker dat u deze pagina wilt verlaten? De gegevens die u hebt ingevoerd worden mogelijk niet opgeslagen.`,
"label.master.required":`Verplichte velden ontbreken kind records`,
"label.chatter.follow":`Ik wil  volgen.`,
"label.dataimport.insertdata.error.repeat":`Het record dupliceert de gegevens in de oorspronkelijke database en het record is genegeerd import.`,
"label.sms.cgid":`Galerij nummer`,
"label.knowledge.article.rator":``,
"label.datamanage.object.field":`Object Velden`,
"label.forecast.editshrepage.quanxian":`Delen Peimission Toegangsniveau`,
"label.weixin.interactive.log":`Interactie Logboek`,
"label.batchedit.remark":`Meerdere records bewerken`,
"label.user.permissions.message":`Geen rechten om gebruikersinformatie in te stellen.`,
"label.mobile.phone.month":`maand`,
"chatter.sel.u":`Selecteer de gebruikers die u @ wilt noemen, of typ de gebruikersnaam die u @ wilt`,
"label.service.gantt.assigned.work":`Toegewezen werk`,
"UG_ST_001":`Prompt`,
"label.edit.select.one":`Uitklapbare lijst`,
"label.forecast.shrepage.desc0":`Op deze pagina staan de gebruikers, rollen en zones die gedeelde toegang hebben tot {0}.`,
"label.multilingual.confirm.close":`Weet u zeker dat u wilt uitschakelen? Meertaligheid kan niet gebruikt worden na het uitschakelen en de taal van de gebruiker zal veranderd worden in de standaard taal.`,
"label.setting.intergrationlist.integration":`Integratie`,
"label.leadscore.rule.list":`Leads Scoren Regels lijst`,
"component_telerecord_button_save":`Save`,
"label.weixin.save.log":`Logboek opslaan`,
"label.validate.function.funcExplain.DAY":`Als u een dag van de maand opgeeft, moet u een getal tussen 1 en 31 invoeren.`,
"label.appointmentdetail.wizard.title1":`Naam`,
"label.multilang.feedtrack.dealkey":`Verander {0} van {1} naar {2}`,
"label.optional.features":`Optionele functies`,
"vue_label_email_no_email":`Geen e-mail`,
"label.sendemail.chat.messagecontent":`De inhoud van het bericht:`,
"label.tabpage.lessequalz":`Minder dan of gelijk aan`,
"setup.layout.label.setupfield":`Veld eigenschappen`,
"label.approved.receiveApprovalEmail.option1":`Als ik een goedkeurder of gedelegeerd goedkeurder ben`,
"label.chatter.relateList":`Relevante lijst`,
"component.sendmail.label.fromuser":`Afzender`,
"label.projectManagement.problem.status":`Issue status`,
"label.weixin.fmu.before.hour":`{0} uur(en) vooruit`,
"chatter.feed.menutype.feed.mark":`Bladwijzer`,
"label.addQuoteLineGroup":`Groep toevoegen`,
"label.report.action.addtodashboard6":`Toevoegen`,
"label.url":`URL`,
"lable.account.CurrentandPreviousCQ":`Huidige en vorige CQ`,
"label.tabpage.emptyz":`Leeg`,
"less":`Minder dan`,
"label.h5.selectmostphotos":`Er kunnen maximaal negen foto's worden geselecteerd`,
"UG.activity.04":`Outlook/Gmail postvak, e-mail opnemen`,
"template.chart.qbhtje":`Alle Contractbedrag`,
"label.tabpage.endz":`Einde`,
"label.partner.workspace.member":`Lid`,
"label.filter.error.filedvaluetoolong":`Fout: Veldwaarde overschrijdt maximum limiet.`,
"label.months":`Maand`,
"button.partner.workspace.disable":`Activering annuleren`,
"label.visualpage.checkpinyin.grammar":`Controleer de spelling en de grammatica.`,
"label.dashboardSetup.geshihua":`Opmaak`,
"label.belongto":`Behoren tot`,
"label.upload.cannot.empty":`U moet een bestand selecteren om te uploaden.`,
"label.number.MaxCheck":`Het maximum van {0} is {1}. Wijzig de hoeveelheid en sla de wijzigingen op.`,
"pagecreator.page.message.save.fail":`Pagina opslaan mislukt`,
"label.edit.SMS":`SMS Melding Bewerken`,
"UG_Lead_002":`Er zijn vele manieren om "leads" voor uw product of dienst te identificeren.`,
"label.quickcreate.active.quickcreate":`Snel aanmaken inschakelen`,
"label.recordtypeselect.tip":`Om deze stap in de toekomst over te slaan, kunt u standaard recordtypes instellen.`,
"label.form_content":`Formulier`,
"workflow.action.tasks.assignortype.related":`Verwante gebruiker`,
"vue_label_allsearch_set_more_items":`U kunt meer zoek-items instellen in de vervolgkeuzelijst aan de linkerkant van het zoekvak om verder te zoeken`,
"label.tianyancha.businessverify.title":`Zakelijke verificatie`,
"label.errormessage.batchedit.norecord":`Geen gegevens.`,
"label.permission.appname":`App Naam`,
"label.report.action.addtodashboard7":`Annuleren`,
"label.generated.transfer.product":`Genereer activa volgens de manier van activaconversie.`,
"vue_label_commonobjects_detail_you":`Jij`,
"label.user.captcha":`Verifieer uw identiteit`,
"label.notification.event4":`Het evenement 【事件名】 dat u hebt toegewezen aan 【被分配人】 begint op 【开始时间】`,
"label.version.setup":`Setup`,
"setup.object.layout.message.selectedlayoutandrecordtype":`Selecteer de lay-out en het recordtype`,
"label.role.add":`Rol toevoegen`,
"label.versiontype.Unlimited":`Onbeperkt`,
"label.partnerCloud.financeSetting.developerID":`Voer ontwikkelaar ID in.`,
"front-invoice-online-payment-setup-global":`Solliciteer bij Global Accounts`,
"vue_label_commonobjects_view_basis":`Classificatiebasis`,
"label.decimaldigits.tip":`Het aantal cijfers rechts van het decimaalteken`,
"vue_label_commonobjects_detail_selected":`Markeer als huidige fase`,
"label.data.export.page":`Ga naar de export pagina`,
"message.error.serviceresource.servicecrewid":`Elke dienstbemanning kan slechts als één dienstmiddelrecord van het bemanningstype worden toegevoegd.`,
"label.loginttime.alltime":`Alle tijd is`,
"label.requiredinfo":`Vereiste informatie`,
"label.forecast.edit.di":`FY`,
"vue_label_calendar_failed_to_remove_calendar":`Kan kalender niet verwijderen`,
"pagecreator_systemstyle_button_delete":`Stijl verwijderen`,
"label.import.page3.continueimport":`Doorgaan met importeren`,
"label.page.width":`Volledige pagina breedte`,
"label.campaignmember.selectmember.addmember":`Leden toevoegen van`,
"label.finalreject":`Definitieve afwijzing`,
"label.isend":`Is voltooid`,
"front-console-conversation":`Dialoog`,
"label.mr.theLastGroupOfThisPage":`Dit is de laatste reeks gegevens op deze pagina. Klik op [Terug naar lijst met dubbele gegevens] om meer dubbele gegevens te bekijken.`,
"label.data.dataexpalltype.all_desc":`Exporteer gegevens van alle objecten waartoe de huidige gebruiker toegang heeft om te lezen.`,
"label_emailtocloudcc_redmessage7":`Configuratiefout, neem contact op met de beheerder.`,
"label.forecast.shrepage.classdes.all":`Volledige toegang - Gebruikers kunnen prognosegegevens bekijken en overschrijven en de toegang uitbreiden tot andere gebruikers door ze te delen.`,
"market.contacts":`Marktcontact`,
"label.weixin.polls.voter":`Lijst van doorgestemden`,
"template.report.industry.distribution.customers":`Sectorale verdeling van de rekeningen`,
"front-electronic-signature-setup":`Contract Infor Autofill en Backfill Setup`,
"vue_label_chatter_removecertification":`Weet u zeker dat u het lid "{naam}" wilt verwijderen?`,
"label.appointment.wizard.subtitle1-2":`15 min.`,
"label.sso.saml.idp.config.custattr":`Aangepast attribuut`,
"label_tabpage_totalTeamz":`Een totaal van groepen`,
"lable.outlook.detail.assigned":`Toegewezen gebruikers en profielen`,
"label.department.user.delete":`Delete`,
"label.customcomponent.check.label.same":`Dit label bestaat al.`,
"label.partner.error1":`Fout: domeinlengte is te lang`,
"label.escalation.setup.entrydetail.escalation.notify":`Waarschuw`,
"component_todaytask_label_choicestate":`Kies status`,
"label.customfields.fielddependency.new.step1":`<b>Stap1a</b> Selecteer een controlerend veld en een afhankelijk veld. Klik op Doorgaan als u klaar bent.`,
"chatter.group.anyoneCanSeeTheUpdateAndJoin":`Iedereen kan deze groep zien en er lid van worden`,
"label.custom.pixel":`pixel`,
"label.quicksave":`Snel Opslaan`,
"label.approved.persion":`Gedelegeerd goedkeurder`,
"lable.info.queue.member":`Wachtrij leden`,
"label.addattachment.step2.weixin":`Stap 2 Klik op Uploaden om bestanden te uploaden`,
"label.forecast.customforecast.title":`Voorspellingen`,
"mainpage_setup_chosecomponent_leastone":`U moet ten minste één onderdeel kiezen op de homepage.`,
"label.appointmentconfirmpage.wizard.title2":`Een uitnodiging voor de kalender is naar uw e-mail gestuurd.`,
"label.useallselectedapprover":`Vereist dat alle geselecteerde goedkeurders <strong>unaniem </strong>goedkeuren`,
"label.ccpeak.current.line.return":`Keert terug van de huidige regel en wordt niet meer naar beneden uitgevoerd.`,
"label_new_target_model":`Nieuw doelmodel`,
"label.saving":`Sparen...`,
"label.mobile.phone.write":`Schrijf`,
"label.applt.updown.text":`U kunt ook de QRcode van een aan uw bedrijf gewijd miniprogrammaportaal downloaden en de QRcode in een webpagina of openbaar artikel plaatsen, en klanten kunnen de QRcode scannen om het miniprogramma te gebruiken.`,
"label.partner.common.manageSetup":`Beheerinstellingen partnercloud`,
"label.quickbooks.new":`Nieuwe klant`,
"message.error.color":`kleur kan niet leeg zijn!`,
"label.project.template.two":`Er kan slechts één set configuraties onder elk recordtype per object zijn!`,
"label.approval.input.des1":`Goedkeuren of afwijzen niveau per niveau, en het maximum niveau van de hiërarchie is:`,
"label.x.axis.cannot.empty":`X-as kan niet nul zijn`,
"label.solomon.isiands.time":`Solomon is. Time`,
"label.login.access.duedate":`Toegangsduur`,
"label.service.dispatch.booking.order":`Service Afspraak toewijzen`,
"label_shareme_forecast":`Gedeelde voorspelling met mij`,
"label.custom.page.cuspage.height":`Hoogte (Pixels)`,
"label.quote.line.group.":`Weet u zeker dat u de aanhalingsteken groep van {groupName} wilt verwijderen? Aanhalingstekens in deze groep zullen ook verwijderd worden na de operatie.`,
"label.data.downpage.i_title.num6":`Het wordt aanbevolen dat u een testbestand met 5 records importeert voordat u de gegevens importeert, om er zeker van te zijn dat de gegevens die u wilt importeren juist zijn.`,
"label.\u2019s":`s`,
"label.version.contact.management":`Contractbeheer`,
"label.document.history.user":`Gebruikers`,
"vue_labenl_commonobjects_opportunity_product_edit_notice1":`Voer het juiste bedrag in, tot twee cijfers na de komma.`,
"label.weixin.target.contract.jine":`Streefbedrag contract`,
"lable.common":`￥0 in totaal`,
"front-kefu-moudle-sendemail-success":`De email is verzonden en de verkoopmedewerkers zullen zo spoedig mogelijk contact met u opnemen`,
"label.service.no.operation.time":`Het huidige record heeft geen geassocieerde werkingstijd!`,
"label.info":`Informatie`,
"label.ccchat.zw":`NOON`,
"label.assignment.setup.newentries.title":`Regel invoer bewerken`,
"label.weixin.report.timeline":`Datum veld`,
"UG.quota.04":`Offerte afdrukken`,
"label.social.user.exception":`Abnormale gebruikersinformatie van sociale.`,
"label.import.index.failed":`Mislukt`,
"label.common.settings":`Algemene Instellingen`,
"label.nullvalue":`Null Waarde`,
"PageLayout_Search_MultiSearch_002":`Aangepast zoekvak inschakelen (Enkel veld zoeken)`,
"message.myselfreport":`Mijn persoonlijke aangepaste rapporten`,
"label.productsales.today.noevttskaddtsk":`Er zijn geen openstaande gebeurtenissen en aflopende taken, u kunt op " " in de rechterbovenhoek klikken om een nieuwe taak toe te voegen.`,
"lable.oppdt.noconditionrecrods":`Geen records om weer te geven`,
"label.campaignmember.selectmember.deletelead":`Campagne: leden uit leads verwijderen`,
"label.marketingactivity":`Campagnes`,
"vue_label_pool_self-built":`Zelfbouw`,
"message.textareamaxlength":`Lengte niet meer dan 4000 tekens`,
"label.valadate.must.value":`Moet een waarde invoeren`,
"label.tabpage.groupsVisiblez":`Sommige gebruikersgroepen zijn zichtbaar`,
"component.button.cancel":`Annuleren`,
"label.emailobject.list.inbox":`Inbox`,
"label.app.step1.error.labelexist":`ERROR1a Dit label bestaat al of is al eerder gebruikt.`,
"front-calendar-V1-Unable-to-display":`De record kan niet in de kalender worden weergegeven als het eindveld van een of meer records vroeger is dan het beginveld.`,
"label.forecast.settings.prompt1":`U moet ten minste één prognosemeting selecteren: Inkomsten of Hoeveelheid.`,
"front-kefu-moudle-callout-missphone":`Oproepen van gemiste oproepen`,
"label.tabpage.editz":`Bewerken`,
"vue_label_chatter_label_new_team":`Nieuwe groep`,
"label.version.formulafield":`Formuleveld`,
"label.partner.step1":`Stap 1 kies sjabloon`,
"label.weixin.perfect.url":`URL-gegevens invoeren`,
"label.appointmentconfirmail.wizard.subtitle4":`Beschrijving`,
"label.step7.total7":`Stap 7 van 7`,
"setup.object.layout.label.selectedprofile":`Geselecteerde Profielen`,
"label.payments.paytip5":`Voer het juiste aantal gebruikers in!`,
"label.visualpage.open.type":`is open aangepaste pagina stijl`,
"lable.Sort.field.tips":`Pas de opnamevolgorde in de verwante lijst aan door velden te selecteren die gesorteerd moeten worden. U kunt sorteren op basis van numerieke of datumvelden van objecten.`,
"label.nosharerules":`Er zijn geen regels voor het delen gespecificeerd.`,
"label.service.miniProgram.bindSetOwner":`Gevallen instellen Eigenaar`,
"report_label_highlevelreport":`Met geavanceerde rapporten kunt u relaties leggen tussen maximaal 4 objecten.`,
"S":`Tekst`,
"label.lastmodifyby":`Laatst gewijzigd door`,
"label.customerinfo.mailaddress":`Email Adres`,
"vue_label_pool_converted":`Omgebouwd`,
"UG.ST.004":`U hebt geen toestemming voor gegevensbeheer - "gegevensimport, neem contact op met de beheerder, klik op bevestigen en ga direct naar de {0} interface.`,
"label.view.application.mobile.terminal.filed":`Deze weergave is toegepast in de mobiele app. Er zijn maximaal 10 velden beschikbaar; zijn geselecteerd.`,
"chatter.feed.limitentity500":`U kunt 500 collega's en records volgen.`,
"label.starttime":`Start`,
"chatter.emailToMe":`Herinner me eraan wanneer iemand:`,
"label.custom.Current.and.PreviousCQ":`Huidige en vorige CQ`,
"label.my.logout":`Ik`,
"label.quickbooks.searchlist.enddate":`Einddatum`,
"label.ccservice.validate.length":`De lengte van de overeenkomstige waarde {2} van het veld {1} onder de object-API {0} is overschreden. Stel deze a.u.b. opnieuw in!`,
"label.integrations.installed":`Geïnstalleerd`,
"label.integrations.mailchimplist":`Mailchimp Lijst`,
"label.checkfield.matchothers":`Andere Records`,
"label.umeng.activity.event.distributewillbegin":`De gebeurtenis #event die je hebt toegewezen aan #name begint in #tijd.`,
"pool.notice.gotolightning":`Ga naar Lightning Menu als u deze functie wilt gebruiken.`,
"label.batchtransfer.pleaseselecttransferreddata":`Selecteer de gegevens die u wilt overbrengen`,
"label.mr.title.mailingAddress":`Postadres`,
"vue_label_approve_no_response":`Geen reactie`,
"component.event.label.title":`Komende evenementen`,
"label.mobile.setup.confirm":`U wijzigt de locatie van het standaard tabbladpictogram in de mobiele app. Nadat de wijziging is geslaagd, worden alle eerdere configuraties van het mobiele tabbladpictogram gewist, u moet het tabbladpictogram dat in de mobiele app wordt gebruikt opnieuw instellen. Als u niet selecteert, zal het systeem willekeurig selecteren in uw instellingscatalogus.`,
"label.tianyancha.approvaltime":`Goedkeuringsdatum`,
"label.download_merge_file":`Samengevoegd bestand downloaden`,
"label_display_quota":`Toon Quotum`,
"label.publishreadonly":`Publiek Alleen lezen`,
"label.campagin.roi.query.roi":`Campagne ROI`,
"label.dashboardSetup.lookup":`Dashboards zoeken`,
"vue_label_notificationcenter_nomessages":`Geen ongelezen berichten`,
"label.create.object":`Maak object`,
"label.social.campaign.null":`Campagininformatie kan niet leeg zijn`,
"label.console.step6.left":`Vast aan de linkerkant en de lijsten zijn altijd zichtbaar.`,
"label.line":`Kolom`,
"label.bottonandlink.introduce":`Hier is een lijst met knoppen en links. Als u knoppen of links wilt toevoegen, kunt u de lay-out bewerken.<br/>Knoppen en links kunnen worden toegevoegd aan de detailpagina, gerelateerde lijst en lijstweergave.<br/>`,
"label.layout.list1":`Lijst 1`,
"label.mr.title.customerName":`Naam van de rekening`,
"label.user.text":`Tekst`,
"label.nolastestrecord":`Geen recentste record`,
"label.emailobject.appointment.urltext1":`Zie mijn schema en`,
"label.chat.topic.my.favorites":`Bladwijzer`,
"label.select.dashboar.cd0":`Het groeperingsveld kan niet leeg zijn`,
"label.data.downpage.e_title.num2":`2. Indien u kiest om gegevens van een enkel object te exporteren, moet u kiezen hoe de gegevens worden geëxporteerd: aangepast exporteren, exporteren volgens sjabloon en exporteersjabloon.`,
"message.error.user.service.login.unconn":`Netwerk bezet, probeer het opnieuw of neem contact op met de beheerder.`,
"label.escalation.setup.newentries.title":`Regel invoer bewerken`,
"label.import.step1.above2000":`Wanneer de trigger wordt uitgevoerd, kunnen maximaal 2000 records tegelijk worden geïmporteerd. Splits ze op in meerdere bestanden en importeer ze in batches.`,
"label.ccchat.person.allowinvite":`Sta collega's toe uit te nodigen`,
"label.input.number.between":`Voer een nummer in tussen {0} en {1}`,
"label.forecast.shrepage.wpfmanager":`Gedelegeerd prognosebeheerder`,
"label_server_is_time_out":`De server is time-out. Probeer het later opnieuw.`,
"label.indochina.standard.time":`India Standaard Tijd`,
"label.cpq.quote.sync.opportunity.failure":`Alleen primaire offertes kunnen worden gesynchroniseerd met kansen. Vink het vakje van primaire offerte aan en begin dan met synchroniseren.`,
"label.emailobject.send100emails":`Sorry, u kunt maar 100 e-mails per dag versturen, gelieve opnieuw te selecteren!`,
"label.dashboard.snapshot.end":`Vanaf`,
"label.jiandangfenpei.rightlist":`Toegewezen Profielen`,
"label.input.string.length.between":`Voer een string in met een lengte tussen {0} en {1}`,
"label.multilang.lookfiltercondition.select":`De {0} regel voorwaarde is onjuist. U moet een veld selecteren!`,
"label.datamanage.lead.namenull":`Opmerking: Als de lead name fiels ongeldig is, wordt het record niet geïmporteerd.`,
"label.forecast.detailforecast.button.saveandfresh":`Save`,
"label.venezuela.time":`Venezuela Time`,
"label.same.analyze.miaoshu1":`Als u meer regels nodig hebt, gebruik dan "`,
"label.twomb":`Alleen jpg/pngbestanden mogen worden geüpload met een maximale grootte van 2MB.`,
"label.event.moveup.7hour":`7 uur vooruit`,
"label.weixin.forgot.password":`Wachtwoord vergeten?`,
"label.import.page1.diledsizelimited":`2. De maximaal toegestane bestandsgrootte is 100M`,
"label.file.foldername":`Mapnaam`,
"label.multilingual.open":`Multilangiuage beheer is ingeschakeld.`,
"label.dashboard.snapshot.refresh.failed":`Vernieuwing Dashboard snapshot mislukt`,
"label.marketsea.memberfieldselectone":`Velden bekijken en leden kunnen velden bekijken Selecteer ten minste één veld`,
"label.trigger.createdate":`Gemaakt op`,
"label.ccpeak.operation.sharetab":`Opereren op delen van vorm:`,
"label.partner.message.admin.access":`Alleen beheerders kunnen inloggen`,
"label.emailsync.status.email":`Uitgevoerde actie Email`,
"chatter.error":`Fout: Selecteer een bestand om te uploaden!`,
"label.role.viewinlist":`Toon in lijstweergave`,
"label.tag.addtags.title":`Tag`,
"setup.mainpage.label.welcome6":`Gebruikers kunnen verschillende veldtypes aanmaken in alle objecten van het CloudCC systeem zonder enige programmeerkennis of code-ontwikkeling. De veldtypes zijn onder andere: zoekrelatie, enkel-selectieveld, dubbel-item selectie, formule, automatische nummering. URL, telefoon, fax, e-mail, checkbox, datum, tijd, getal, tekst, tekstgebied, optielijst (enkelvoudige/meervoudige selectie), valuta, enz.`,
"label.delete.rule.successfully":`De regels succesvol verwijderen`,
"label.field.duplicate.error.msg6":`Gedupliceerde veldwaarde. De waarde komt voor in record:`,
"label.stdashbord.xsld.business.jhzsl":`Totale kansen (hoeveelheid)`,
"label.compact.layout":`Lay-out van de belangrijkste informatie`,
"label.checkfield.merge.introduce":`Selecteer de waarde die u in het samengevoegde record wilt behouden.`,
"earlieststarttime.duedate.time.illegal":`De werkelijke begintijd van de dienstafspraak moet kleiner zijn dan of gelijk aan de werkelijke eindtijd.`,
"label.dataimport.validate.prompt":`Validatie regel Prompt`,
"message.setuptip":`U kunt de door u aangemaakte pakketten verwijderen.`,
"template.report.customer.collection.statistics":`Statistieken van rekeningbetalingen`,
"vue_label_homepage_dashboardcomponents":`Dashboardonderdelen bewerken`,
"setup.mainpage.label.welcome30":`Het CloudCC-platform is een echt cloud computing-platform. De open attributen van het platform, de standaard integratiemethoden en de flexibele aanpasbaarheid zijn toepasbaar in alle bedrijfstakken, integreren software van derden, realiseren real-time unificatie van bedrijfsmanagementgegevens en maximaliseren de uitgebreide en diepgaande managementbehoeften van onze klanten. Het CloudCC-platform kan worden geïntegreerd met elke bedrijfsapplicatie of elk bedrijfssysteem, inclusief software van derden zoals SAP, Kingdee, en UF. De standaard Web Service-methode onder de flexibele SOA-architectuur kent geen destructieve, technische afhankelijkheden of vendor lock-in.`,
"label.SMS.new.det":`Creëer een SMS notificatie om één of meer workflow regels, goedkeuringsprocessen aan te koppelen. Als de SMS notificatie wordt gewijzigd, worden alle wijzigingen toegepast op alle regels en goedkeuringen die eraan zijn gekoppeld.`,
"lable.product.page.previous":`Terug naar Vorige`,
"label.recordtype.labelname":`Type plaat Etiket`,
"message.error.system.service.failure":`Dienstuitvoering mislukt, neem contact op met de beheerder.`,
"label.visualpagefolder":`Pagina Mappen`,
"label.username":`Gebruikersnaam`,
"label.data.downpage.i.title.num5":`5、Lieve de juistheid van de gegevens te controleren.`,
"label.permission.manage":`Beheer Opdrachten`,
"label_emailsync_status_user":`Gebruikers`,
"label.weixin.voting.least.two":`Er zijn ten minste twee stemmogelijkheden.`,
"label.tabpage.thisrecord":`Deze plaat`,
"label.icon.119":`Blackboard`,
"label.partner.common.webSit":`Domein`,
"label.email.form.html2":`[schakel over naar tekst-only]`,
"label.appupload.upload.noversion":`Geen geüploade versies`,
"label.appointmentpage.wizard.subtitle1_2":`De tijdzone van de uitzender is {0}`,
"MR":`Opzoekingsrelatie (Multi-Select)`,
"label.partnerCloud.orderingPlatform.availableBalance":`Beschikbaar Saldo`,
"label.schedulejob.setup.schedule.st3":`De 3e`,
"label.reportsSubscriptionPage.email.general":`Algemeen`,
"label.setsharerule.step4":`Stap 4 Selecteer het toegangsniveau voor de gebruikers`,
"front-epwechat-module-v1-info-desc":`Haal informatie uit de backend van WeCom en vul hier in`,
"message.duplication.label.isactive":`Actief`,
"pagecreator_systemstyle_label_linkcolor":`Link kleur`,
"label.import.page1.alertfiledsize":`De geladen bestanden mogen niet groter zijn dan 100MB!`,
"tomorrow":`Morgen`,
"label.publicdashboard":`Niet-ingevulde publieke dashboards`,
"label.knowledgebase.same.taborworkspace":`Zelfde Tabblad of Werkruimte`,
"homepage.layout":`Lay-outs startpagina`,
"label.emailobject.trackemailopening":`Opening van e-mail volgen`,
"label.unlock.tip":`Ontgrendel de records voor bewerking`,
"lable.account.NextzDays":`Komende 90 dagen`,
"vue_label_report_throw":`Weggooien`,
"label.icon.102":`Schema`,
"label.payments.paytip2":`U hebt een upgrade naar onze betaalde editie uitgevoerd, klik op Bevestigen om het venster te sluiten en uw CRM-systeem te vernieuwen.`,
"label.customfields.email.tip":`Hiermee kunnen gebruikers een e-mailadres invoeren, dat wordt gevalideerd om de juiste opmaak te garanderen. Als dit veld is gespecificeerd voor een contactpersoon of lead, kunnen gebruikers het adres kiezen wanneer ze klikken op Een e-mail verzenden. Merk op dat aangepaste e-mailadressen niet kunnen worden gebruikt voor massa-e-mails.`,
"label.test_visitors":`Test hoe uw formulier eruit moet zien als het door bezoekers wordt bekeken.`,
"label.workflow.immediatelyoperate":`Onmiddellijke workflowacties`,
"label.approvalstep4.tip":`De goedkeuringspagina is waar de goedkeurder daadwerkelijk de aanvraag goedkeurt of verwerpt. gebruik de volgende opties om de velden te selecteren die op deze pagina moeten worden weergegeven.`,
"label.ccchat.person.invite.failsend":`De volgende uitnodiging is niet verzonden. Neem contact op met de beheerder.`,
"label.import.index.obj":`Object`,
"label.multilang.leadscore.countnum":`{0} keer:`,
"label.report.error.typefind":`Geen rapporttype gevonden door informatie te groeperen`,
"label.validate.function.funcFormat.SUBSTITUTE":`SUBSTITUTE(tekst, oude_tekst, nieuwe_tekst)`,
"label_tabpage_unpacketz":`Geen gegevens over groepering beschikbaar!`,
"lable.Create.new.template":`Nieuw Service Rapport Sjabloon`,
"label.knowledgebase.display.error":`Laat {een}fouten zien`,
"label.emailobject.template.message2":`Het veld dat in de huidige e-mail is ingevoegd komt niet overeen met de bijbehorende record, wat kan leiden tot null-waarden.`,
"label.productsales.today.taskcomplete":`Ingesteld op voltooid`,
"label.emailobject.selectone":`Selecteer ten minste één record als de ontvanger van de e-mail`,
"button_partner_workspace_saveas_memo":`Sla de huidige partnerwolk op als een "sjabloon".`,
"vue_label_help_detail":`Record Details`,
"label.tabpage.minutesagoz":`Notulen`,
"label_tabpage_characterz":`Beginnend karakter`,
"message.error.accesstoken.null":`Token kan niet leeg zijn!`,
"label.textMessageObject.send100":`Sorry, u kunt maar 100 sms'jes per dag versturen, gelieve opnieuw te selecteren!`,
"vue_label_commonobjects_detail_record_call":`Een oproep loggen`,
"label.campaignmember.main.addlead":`Leden-bestaande Leads toevoegen`,
"setup_mainpage_label_welcome30":`Het CloudCC-platform is een echt cloud computing-platform. De open attributen van het platform, de standaard integratiemethoden en de flexibele aanpasbaarheid zijn toepasbaar in alle bedrijfstakken, integreren software van derden, realiseren real-time unificatie van bedrijfsmanagementgegevens en maximaliseren de uitgebreide en diepgaande managementbehoeften van onze klanten. Het CloudCC-platform kan worden geïntegreerd met elke bedrijfsapplicatie of elk bedrijfssysteem, inclusief software van derden zoals SAP, Kingdee, en UF. De standaard Web Service-methode onder de flexibele SOA-architectuur kent geen destructieve, technische afhankelijkheden of vendor lock-in.`,
"label.file.library.deleteprompt":`{0} Verwijderen uit de activa-bibliotheek ?`,
"label.wtd.changefields.title":`Web naar CloudCC installatie`,
"label.sendmail.step1":`Stap 1 Specificeer de ontvangers die moeten worden opgenomen`,
"label.cpq.newquote.createorder.checkbox.selected":`Het selectievakje Order aanmaken kan niet worden geselecteerd bij het maken van een nieuwe offerte.`,
"label.emailtocloudcc.name":`Naam`,
"message.error.object.nullbinding":`binding is leeg`,
"B":`Checkbox`,
"label.pc.endtime":`Uw licentie verloopt over minder dan 30 dagen. Verleng tijdig om verder gebruik te garanderen.`,
"label.visualpage.section.start":`Gebruik de tag aan het begin`,
"label.partnerCloud.basicSetting.available":`De domeinnaam is beschikbaar.`,
"label.data.exportall.all_desc":`Exporteert alle gegevens voor alle objecten die de huidige gebruiker mag bekijken.`,
"label.editor.layout":`Bewerk Zoek Lay-out`,
"label.send.chatter":`Versturen Chatter`,
"label.h5.chatter.reply":`Het snelle antwoord`,
"component_chatter_post_button_file":`Bijlagen toevoegen`,
"label.emailobject.emaildetail.button.reply":`Antwoord`,
"label.eidt.queue.title.desc":`De naam moet uniek zijn, en de naam moet beginnen met een letter. Hij mag alleen hoofdletters, kleine letters, cijfers en underscore bevatten. Hij mag niet langer zijn dan 40 tekens.`,
"label.campaign.channel.input.url":`5.Stel de informatie in die de gebruikers te zien krijgen nadat zij zich hebben aangemeld, dit kan een dankpagina, een folder of een ticket zijn`,
"label.compact.layout.assign.tip":`Deze tabel toont de belangrijkste informatie-indelingstoewijzingen voor verschillende recordtypes.`,
"vue_label_fall":`Daal af`,
"label.trigger.save.failed":`Opslaan mislukt, de gegevens kunnen niet null zijn`,
"label.appupload.upload.tips.report":`OPMERKING: De rapporten en oude rapporten in "My Custom Reports" en "Unfiled Public Reports" kunnen niet aan pakketten worden toegevoegd en zullen niet in deze map worden weergegeven."`,
"label.tianyancha.businessverify.rewriteall":`Backfill alle gegevens`,
"label.campaign.channel.step6.remark4":`Merk op dat de eigenaar van de lead de eigenaar van de huidige campagne kan zijn, of de aanvrager van het huidige marketingkanaal.`,
"front-kefu-moudle-called-num":`Gekozen nummer`,
"label.approvalstep4":`Stap 4 Selecteer de velden die moeten worden weergegeven op de lay-out van de goedkeuringspagina`,
"label.login.verification.please.scan":`Scan de code met de MFA-applicatie op uw smartphone`,
"label.invoice.message.statusupdated":`Factuurstatus bijgewerkt`,
"label.pc.ui.2018.subject":`Thema`,
"label.area.notexist.userinfo":`De gebruikersgroep bestaat niet.`,
"label.newuser":`Nieuwe gebruiker`,
"label.chat.micropost.share":`Deel de post`,
"label.locatedupcurrentvalue":`De waarde boven de huidige`,
"vue_label_systemSettings_course":`Bliksemafleider Setup`,
"chatter.group.public":`Publiek`,
"label.reportsSubscription.entrance":`Inschrijven`,
"front-kefu-moudle-v1-online-at":`Online Agent`,
"label.rejectbehaviourselect":`Voer <strong>alleen</strong> de afwijzing van deze stap uit en stuur het goedkeuringsverzoek terug naar de meest recente goedkeurder. (Terug naar vorige stap)`,
"vue_label_commonobjects_view_currentviewset":`Om de instelling van de huidige standaardweergave te annuleren, kunt u een andere weergave als de standaardweergave instellen.`,
"lable.currencyAdv.and":`en`,
"label.appexchange.installedpage.publish":`Gepubliceerd door`,
"label.tab.profile.ismobile":`Aanvragen voor mobiele app`,
"label.data.setok.t.desc2":`Terug naar Data sjabloon pagina`,
"label.email_required":`De email is verplicht.`,
"label.tabpage.fullscreenz":`Volledig scherm`,
"chatter.sticker.set":`Voer traceren`,
"label.mobile.phone.year":`jaar`,
"label.projectManagement.next.page.before":`Vorige pagina`,
"pagecreator_button_pcpage":`Pc einde`,
"label.dashboard.xsld.percent":`Percentage`,
"label.ccpeak.service.checkerror":`Syntax check mislukt.`,
"label.icon.26":`Map`,
"label_partner_common_webSit_memo":`Standaard domeinnaam:`,
"label.unselectfile":`Geen bestanden geselecteerd`,
"label.take.notice":`Bericht`,
"message.error.filename.null":`fileName kan niet leeg zijn!`,
"vue_label_SMS_nophone":`Geen telefoonnummer`,
"label.area.assignuser":`Gebruikers toewijzen`,
"label.icon.176":`Prompt`,
"label.icon.21":`Valuta`,
"message.error.system.service.deletedeny":`Dada is geassocieerd en kan niet worden verwijderd.`,
"label.compact.layout.main.tip":`Selecteer de lay-out van de sleutelgegevens die u wilt gebruiken wanneer dit record als lijstitem in CloudCC verschijnt.`,
"label.emailtocloudcc.delete":`Delete`,
"label.dashboardSetup.showdw.d2":`10 Miljoen`,
"front-kefu-moudle-hqyyjlsb-admin":`Het lukt niet om de stem op te nemen, neem contact op met de beheerder voor hulp`,
"label.partnerCloud.basicSetting.userCounts":`Totale rol van de partner`,
"front-kefu-moudle-calling-num":`Bellen naar nummer`,
"label.alldocument":`Alle documenten`,
"coderules.nullvalue1":`Het genereren is mislukt. Voer de waarde in voor 【{0}】 die gebruikt wordt in de generatie regels.`,
"lable.automatically.shared":`Automatisch gedeeld`,
"label.batchadd.newbatchpage.save.emptyselect":`Controleer of er verplichte opties zijn die niet zijn geselecteerd.`,
"vue_label_homepage_card_30dayswithout":`Geen contact met kansen gedurende 30 dagen`,
"label.multilang.dupicatecheck.onegroupnote":`Gelieve minstens twee gegevens te kiezen, klik op de knoop [Laad geselecteerde informatie] om de pagina van gegevenscombinatie binnen te gaan. Momenteel in de {0}-de groep van ondernemingsgegevens, zijn er een totaal van {1}records. :`,
"UG.activity.03":`Reserveer een rooster`,
"label.pc.oldpage":`Oude pagina`,
"label.exchange.sync.state.task.m2":`Records gesynchroniseerd in de laatste 60 minuten:`,
"label.setmovable":`Activiteit Instellingen`,
"label.sendemail.send.loginfail":`Mislukt om in te loggen in mailbox, gelieve uw email informatie te resetten.`,
"label.copy.quote.lines":`Kloon citaatregel`,
"label.copying.reward.to.groups":`Kopiëren naar Quote lijngroepen`,
"label.ems.connect.error":`Storing in de verbinding, controleer het.`,
"lable.account.Tomorrow":`Morgen`,
"label.manageAll.sta2":`Goedgekeurd`,
"label.create_form":`Nieuw formulier`,
"label.ems.saveDetail.error.msg":`Opslaan mislukt. Controleer mailbox account en wachtwoord`,
"label.service.gantt.distribution.recommendation":`Voorgestelde toewijzing`,
"label.email.track.attachment.size.control2":`De grootte van het geüploade bestand overschrijdt 10m, en kan niet worden geüpload`,
"lable.product.pricebooks.add":`Toevoegen aan prijslijst`,
"label.login.time":`Inlogtijd`,
"label.tabpage.yes1z":`Ja1`,
"label.SalesCommitmentKanBan":`Verkoop Commit Dashboards`,
"label_partner_workspace_myspace":`Mijn werkruimte`,
"chatter.like":`zoals(s) ontvangen`,
"lable.PowerProcess.number.input":`Voer een geheel getal in.`,
"chatter.coll":`Bladwijzer`,
"label.campaign.channel.img.remark":`Opmerking: Beeldgrootte mag niet groter zijn dan 2M`,
"label.field.duplicate.error.msg7":`Gedupliceerde gegevens`,
"vue_label_pool_discard":`Weggooien`,
"label.service.gantt.total.planned.duration":`Som van de geplande duur voor dienstafspraken`,
"label.weixin.click.loadmore":`Klik om meer te laden`,
"label.help.new.features.yd":`Mobile-sade nieuwe interface bedieningshandleiding`,
"label":`Etiket`,
"label.quickbooks.viewlist.total1":`Er zijn {0} facturen voor een totale waarde van {1}`,
"front-kefu-moudle-v1-input-publicKey":`Voer de gedeelde sleutel in`,
"label.approval.allowed.reject":`Weigering toegestaan`,
"label.visualpage.folder.notdel":`U kunt deze map niet verwijderen, omdat sommige bestanden erin staan.`,
"label.projectManagement.charging":`Opladen`,
"label.ccservice.validate":`Het formaat van de overeenkomstige waarde {2} van het veld {1} onder de object-API {0} is onjuist. Voer a.u.b. het juiste getal in!`,
"message.unbind.mfadevice.no.permission":`U heeft geen permissie om MFA apparaten te deblokkeren. Neem contact op met uw beheerder.`,
"label.partner.new.step3.meno":`Weet u niet wat u moet invoeren? Geen zorgen, u kunt het later altijd nog veranderen.`,
"label.import.page3.importsucceedtip":`Start de import met succes. Na de import zal een e-mail worden verzonden naar uw gekoppelde mailbox`,
"label.customsetting.visible.protect":`Beschermd`,
"label.publishreadandwrite":`Publiek lezen/schrijven`,
"vue_label_file_add_most_once":`Voeg maximaal eenmaal toe`,
"label.salescloud.teamrole.optionlist.group":`Wijs rollen toe aan opportunity teamleden en account teamleden.`,
"label.appointment.wizard.subtitle7":`Locatie`,
"label.task.dateminus":`Minus`,
"label.data.exp.zippwd":`Handmatig wachtwoord gecomprimeerd bestand invoeren`,
"UG_Forcast_09":`Volgende stap`,
"message.duplication.label.allselectlink":`[Select All]`,
"label.file.ccchat.selectfromcloudcc":`Selecteer een bestand uit CloudCC`,
"label.ems.addaccount3":`Account toevoegen`,
"front-epwechat-module-v1-schedule-sync":`Synchronisatie Schema's`,
"label.h5.manage":`Beheer toepassingen`,
"setup.layout.label.nobutton":`Geen beschikbare knoppen`,
"label_component_hotdeal":`Laatste aanbiedingen`,
"template.dashboard.contract.analysis":`Analyse van contracten en vorderingen`,
"vue_label_dashboard_editcomponent":`Component bewerken`,
"label.quotationInformation":`Offerte Informatie`,
"label.data.file.validation_rules":`Uitvoeren van validatie regels`,
"label.ccpeak.construction.shareobj":`Om een sharing form object van een object te maken, moet je de API naam en sharing mark doorgeven.`,
"label.wei.pollinformation":`Micro Stemming Details`,
"label.quickbooks.viewlist.total3":`Er zijn {0} betalingen voor een totale waarde van {1}`,
"label.paging.totalofpagesnoid":`Een totaal van {0} pagina's`,
"label.unlock":`Ontgrendelen`,
"front-invoice-online-payment-information":`Factuur informatie`,
"label.permission.systempermission":`Toegewezen systeemmachtigingen`,
"message.error.object":`Bij het aanroepen van een dienst wordt vastgesteld dat het object niet gedefinieerd is.`,
"font-trade-module-v1-invoice-intro":`Voer het factuurnummer of de factuurnaam in`,
"label.userinfo.pwdexpired":`Het huidige wachtwoord is verlopen. Om veiligheidsredenen moet u uw wachtwoord nu veranderen.`,
"label.userphoto.photo":`Foto`,
"label.tabularreport.filterrecord":`Selecteer de criteria om te bepalen welke records moeten worden weergegeven`,
"label.partnerCloud.orderingPlatform.rechargeIt":`Uw rekeningsaldo is niet voldoende, gelieve op te waarderen.`,
"label.icon.120":`Computer`,
"label.projectManagement.select.new.type":`Selecteer het type creatie`,
"vue_label_commonobjects_detail_customer_details":`Klantgegevens laden`,
"label.ems.status":`Status`,
"label.validate.function.description":`Elke functie die voldoet aan de java syntaxis kan worden gebruikt in de validatieregel, en de expressie moet een Booleaanse waarde teruggeven.<br>U kunt ook een specifieke functie gebruiken die door CloudCC wordt geleverd.
Bijvoorbeeld, isNew(),isChanged(FieldAPIName__c),priorValue(FieldAPIName__c),priorValue() retourneert een object, het moet worden geconverteerd naar het corresponderende veldtype.`,
"label.escalation.setup.newaction.step2":`Stap 2 Selecteer de gebruiker voor het automatisch opnieuw toewijzen van zaken`,
"label.forecast.customforecast.searchforecast":`Zoek de voorspelling`,
"label.the.upper.bound.of.each.level.of.block.pricing.must.be.greater.than.the.lower.bound.":`De bovengrens van elk niveau moet groter zijn dan de ondergrens bij prijsbepaling per blok.`,
"vue_label_commonobjects_view_notice_deletefailreason":`Het is niet gelukt om gegevens te verwijderen met record id {0}, mislukte reden: {1};`,
"page.field.masterinput.remark":`Ingeschakeld Master-Detail Invoer wordt gebruikt om verwante lijst records op tabblad te maken.`,
"lable.SalesCommitmentKanBan.contractName":`Naam contract`,
"front-gantt-module-add-milestone":`Mijlpaal toevoegen`,
"label.callcenter.save.error":`Alsjeblieft niet opnieuw opslaan`,
"label.workflow.selectobj":`Stap 1 Selecteer object`,
"label.validate.function.category.all":`-- Alle functiecategorieën...`,
"label.multilang.uploadifupage.select":`Je hebt totaal {0} bestanden gekozen:`,
"label.weixin.dragsort":`Sleep de pictogrammen in Mijn toepassingen om ze te sorteren.`,
"N":`Nummer`,
"label.knowledge.article.translation.completed":`Artikel vertaling voltooid`,
"label.weixin.myapp":`Mijn Apps`,
"label.icon.138":`Valuta`,
"vue_label_chat_create_discussion_now":`Creëer nu discussie`,
"label.knowledge.recover.article":`Artikel herstellen`,
"label.ccpeak.use.class.time.map":`Toegang door in de kaartcollectie te gaan`,
"front-email-payment-error-tips":`Interface fout`,
"label.service.gantt.ziyuan":`Alleen voor`,
"label.upload.error":`Mislukt`,
"label.staticresource.upload.error":`Fout bij het uploaden van statische bronnen!`,
"com.cloudcc.login.error.message.loginfail":`Operatie mislukt, neem contact op met de beheerder`,
"pagecreator_button_back":`Laatste stap`,
"label_tabpage_skip":`Ga naar`,
"label.pw.old":`Voer het oude wachtwoord in`,
"pagecreator.layout.label.modifylayout":`Lay-out editor`,
"vue_label_chatter_share_group":`Deel met de groep`,
"label.app.edit":`App bewerken`,
"label.user.Email.repeat":`Email duplicaat. Deze gebruiker wordt niet ondersteund voor binding met agent`,
"label.field.quilt":`Dit veld is`,
"label.projectManagement.Groupuser":`Groeperen op gebruikers`,
"label.deleteall":`Alles verwijderen`,
"label.appexchange.download.tiaoguo.mes":`Negeer de installatie van de volgende conflicterende componenten:`,
"label.sendemail.recycle.operatehello":`#Gebruikersnaam hallo.`,
"label.emailmerge.mergeFolder.max20templates":`U kunt tot 20 sjablonen kiezen!`,
"label.campaignmember.main.deleteleaddesc":`Massa verwijder alle leads van deze campagne`,
"Opportunity_Detailed_Phase_Label_Popup_003":`Dagen in huidige fase`,
"vue_label_file_no_title":`Geen titel`,
"label.data.dataexpalltype.all.desc":`Exporteer gegevens van alle objecten waartoe de huidige gebruiker toegang heeft om te lezen.`,
"label.dashboard.unit2":`Eenheid: miljoen`,
"label.list.userinterface.isrelatedlist":`Gerelateerde lijst hover links inschakelen`,
"label.role.tree":`Rolhiërarchie van uw organisatie`,
"label.campagin.roi.zcsl":`Inschrijving`,
"message.error.forecast.setupchange":`De gegevens die u probeerde te openen, konden niet worden gevonden. Ze kunnen door andere gebruikers zijn verwijderd of gewijzigd.`,
"label.sendemail.changeowner.dataname":`De naam van het document is: #dataname bestand`,
"label.salescloud.opportunity.contactrole.optionlist":`Opportunity Contact Rollen Picklist Waarden`,
"setup_mainpage_label_welcome1":`Heb overeenkomstige toestemming nodig`,
"UG_activity_02":`Taken toewijzen`,
"label.tabpage.erraddressz":`Onjuist formaat van e-mail adres, gelieve e-mail adres correct in te vullen`,
"label.weixin.nicheng":`WeChat Bijnaam`,
"label.forecast.settings.mrsz":`Voorspelling Meting`,
"label.campaign.channel.download.size3":`Klein formaat: 300*300 pixels`,
"label.icon.73":`Gereedschapswerktuigen`,
"label.ServiceCloud.suoxuchanpin":`Benodigde producten`,
"label.escalation.setup.newrule.description":`Voer de regelnaam in en activeer deze. Door deze regel te activeren, wordt de huidige escalatieregel gedeactiveerd. Om de automatische escalatie uit te schakelen, deactiveert u alle escalatieregels.`,
"label.data.import.setup.whichfield.cloudccid":`CloudCC ID`,
"label.validate.function.funcExplain.PRIORVALUE":`Geeft objecttype weer, het overeenkomstige veldtype moet worden geconverteerd.`,
"Lead.Scoring.Warning.001":`Scoor één leadrecord automatisch bij het maken of bewerken. Maar u moet handmatig meerdere lead records scoren, wanneer u batchgewijs importeert of aanmaakt via een interface.`,
"label.tianyancha.businessverify.msg9":`De bevoegdheid tot interpretatie van deze overeenkomst berust bij de shenzhou yundong science and technology co., ltd.`,
"label.compact.layout.tip":`De sleutelinformatie lay-out wordt gebruikt om het sleutelveld van de recorddetails op de detailpagina weer te geven.`,
"label.visualpage.btype":`Verslagen`,
"label.textmessage.vonage.settings":`Instellingen`,
"label.field.not.exites":`niet bestaan`,
"label.payment.switch.version":`Overschakelen naar de nieuwe editie`,
"label.ems.hour":`Uur`,
"label.weixin.cannot.edit":`Het bestandstype kan niet worden bewerkt`,
"chatter.pt.limit":`De maximale bestandsgrootte is`,
"label.quote.detailinfo.add":`Item toevoegen`,
"component.setup.label.displayfield":`Weergave veld`,
"vue_label_report_reportfolder":`Verslag map`,
"label.gbkencoding":`Chinees (GBK)`,
"front-kefu-moudle-v1-Transfer-to":`Transfer naar {TransferName}`,
"label.file.stop.sharing.desc2":`Delen`,
"label.textmessage.messageCannoutuse":`Niet mogelijk, neem contact op met de beheerder om tekstberichten in te schakelen.`,
"component_newrecords_label_type":`Type opslag`,
"label.validate.function.funcFormat.ISNEW":`ISNEW()`,
"lable.product.pricebooks.new":`Nieuw Prijsboek`,
"vue_label_newfile":`Nieuw bestand`,
"label.reportTypcrtB":`Verwant object (b) klik om verwant object te selecteren`,
"label.knowledgebase.type":`Categorie`,
"label.report.select.format":`Selecteer rapport formaat`,
"component.todaytask.label.title":`Vandaag`,
"message.undelete":`Weet u zeker dat u het wissen wilt annuleren?`,
"label.ccdocument.trace.retention":`Sporenbehoud Functie`,
"label.publicgroup.tip":`Een openbare groep is een groep gebruikers. Hij kan individuele gebruikers bevatten, andere groepen, de gebruikers in een bepaalde rol of gebied, of de gebruikers in een rol of gebied plus alle gebruikers onder die rol of dat gebied in de hiërarchie.`,
"label.forecast.settings.lable2":`De standaard voorspellingsweergave configureren`,
"label.projectManagement.positive.integer":`Voer een positief geheel getal in tussen 0-24.`,
"label.projectManagement.one.work.list":`Vul ten minste één werklijst in!`,
"label.or":`||Of`,
"label.projectManagement.no.person.in.charge":`Geen toezichthouder`,
"vue_label_commonobjects_detail_an_email":`een email`,
"front-electronic-signature-field-mapping":`Veldtoewijzing toevoegen`,
"label.marketsea.name.error":`De naam van de lead pool kan niet leeg zijn`,
"component.setup.button.appurl":`Systeem URL`,
"label.mr.title.button.group1":`De`,
"chatter.contact":`Neem contact op met`,
"vue_label_pool_hasfixed":`vaste samenwerkingskanalen`,
"lable.list.queue.des":`Met wachtrijen kunnen groepen gebruikers een gedeelde werklast doeltreffender beheren. Een wachtrij is een plaats waar records kunnen worden gerouteerd in afwachting van verwerking door een groepslid. De records blijven in de wachtrij tot een gebruiker ze aanvaardt voor verwerking of ze naar een andere wachtrij worden overgebracht. U kunt de reeks objecten specificeren die door elke wachtrij worden ondersteund, evenals de reeks gebruikers die records uit de wachtrij mogen opvragen.`,
"label.reportsSubscriptionPage.condition":`Voorwaarden`,
"label.transwork":`Vertaal Werkbank`,
"label.batch.batchopration.resel":`Selecteer opnieuw de gegevens die u wilt overbrengen, en klik op "OK" om naar de lijstpagina te gaan.`,
"label.cloudccsite.new":`Nieuwe site`,
"label.button.select.page.required.field":`Selecteer de verplichte velden die u op uw pagina wilt opnemen:`,
"label.pagelayout":`Pagina-indelingen`,
"label.weixin.trace.record":`Track Records`,
"label.emailtocloudcc.clear":`Duidelijk`,
"label.checkfield.find":`Duplicaten zoeken`,
"message.view.count.title0":`Huidige pagina samenvatting`,
"label.reportsSubscriptionPage.schedulereport.frequency":`Frequentie`,
"setup.mainpage.label.welcome5":`Aangepast veld`,
"label.implementation.details":`Details uitvoeren`,
"label.attendance.history":`Aanwezigheidsgeschiedenis`,
"label.is.pigeonhole":`Archief`,
"lable.account.CurrentandPreviousFYt":`Huidig en vorig 2 FY`,
"label.forecast.customforecast.tab.opportunity":`Kansen`,
"label.version.business.track":`Opportunities Tracking`,
"label.profilelayoutedit.selectrecordtype.tip":`Selecteer het recordtype voor dit profiel van gebruikers. U moet het recordtype veld toevoegen aan de pagina lay-out die bij dit profiel hoort, zodat het op de detailpagina's en de bewerkingspagina's kan worden weergegeven.`,
"label.campagin.roi.zclzb":`Inschrijvingstarief`,
"label.validate.function.funcFormat.WEEKDAY":`WEEKDAG(datum)`,
"label.view.sort.message":`Gesorteerd op {!sort}`,
"page.field.masterinput.sort":`Master-Detail Inputs worden weergegeven in de volgorde waarin ze zijn opgeslagen.`,
"label.selected.field":`Geselecteerde zoekvelden`,
"label.product.proofTwo":`In {0}, kies ten minste {1} productopties.`,
"vue_label_report_filtercondition":`Filter toestand`,
"label.forecast.shrepage.desc1":`Op deze pagina staan de gebruikers, rollen en territoria die toegang hebben tot`,
"label.file.copy.link":`Kopieer link`,
"vue_label_chat_movedto":`{naam} verplaatst {label} naar {newField}`,
"label.layout.new.built":`Nieuwe Sectie`,
"label_tabpage_crecordtypez":`Type record wijzigen`,
"label.report.searchcustominfo":`Voer de trefwoorden in om bijpassende aangepaste rapporten te vinden`,
"chatter.feed.menutype.user":`Collega's`,
"label.recordtypeselect":`Record Type kiezen`,
"label.partner.new.step3":`Stap 3 Voer naam en url in`,
"label.newCustomReportType":`Nieuwe gegevensbron voor aangepast rapport`,
"label.service.gantt.day.timescale":`Tijdschaal op dag zicht:`,
"label.displaytype3":`Lijst knop`,
"label.weixin.discharge.rate":`Uitlaatvolume`,
"label.weixin.menu.message":`Menu`,
"label.mask.show.all.characters":`Masker geeft alle tekens weer`,
"label.quickbooks.fieldlabel.billingaddress":`Factuuradres`,
"Dashboard.View.All":`Alle dashboards`,
"setup_mainpage_label_welcome22":`Instructies: Klik op het menu aan de linkerkant van deze pagina → Instellingen beheren → Nieuwsbrief sjabloon → E-mail sjabloon.`,
"chatter.group.groupInformation":`Groep Informatie`,
"front-epwechat-module-v1-input-secret":`Voer Geheim in`,
"lable.Set.value.prompt":`Of filter records die in de verwante lijst worden weergegeven. Kies de checkbox, of de picklist velden en de waarden die u wilt filteren. Als u de waarden handmatig invoert, scheidt u ze met komma's.`,
"label.appupload.upload.from":`Door`,
"label.weixin.postunsolve":`Achterstallige`,
"label.cooperation.all":`Alle samenwerking`,
"lable.PowerProcess.close.time":`Gebaseerd op de sluitingstijd van {detailInterestType}`,
"lable.opppdt.selPdt.leastone.fields":`Kies tenminste een veld.`,
"label.emailtocloudcc.help":`Voer het juiste e-mailwachtwoord of de juiste autorisatiecode in. Als uw e-mail server de IMAP/SMTP service moet inschakelen om in te loggen met een account van derden, moet u eerst inloggen in de instellingen van uw e-mail account om de service in te schakelen, en de juiste autorisatiecode kopiëren naar dit wachtwoord invoerveld.`,
"label.attendance.offwork.time":`Einde van de dag`,
"front-gantt-module-v1-project-gantt":`Project Gantt Grafiek`,
"label.chuangming.description":`Configureer de informatie van de Chuangming om te voldoen aan de behoeften van de SMS-verzend- en ontvangstdiensten van uw organisatie.`,
"label.custom.lead.notice.account.name":`Er is een lead die, werd geconverteerd, specificeer dat u de eigenaar bent van account, contact en opportuniteit. Accountnaam:`,
"label.emailobject.failedtosend1":`Verzenden mislukt: E-mail authenticatie is ongeldig, gelieve opnieuw te verbinden！`,
"vue_label_ccchat_notice_updaterecordsuccess":`Dit record is bijgewerkt`,
"label.dayinmonth":`Maanden'`,
"label.sendemail.chat.follow":`Beste #naam:hallo! #gebruikersnaam volgt u.`,
"label.emailsync.form.emialpassword":`Wachtwoord`,
"component_task_label_subject":`Thema`,
"label.projectManagement.please.enter.a.positive.integer":`Voer een positief geheel getal in.`,
"lable.account.NexteDays":`Volgende 7 dagen`,
"label.appupload.upload.managed":`Er kan maximaal één gecontroleerd pakket worden aangemaakt!`,
"label.data.dataexpalltype.all.desc1":`1、U kunt kiezen tussen automatisch genereren en handmatig invoeren van het wachtwoord van het geëxporteerde gecomprimeerde bestand. Het automatisch gegenereerde wachtwoord zal naar de mailbox van de gebruikers gestuurd worden wanneer de data succesvol geëxporteerd is. Het handmatig ingevoerde wachtwoord zal niet naar de mailbox worden gestuurd, dus gebruikers moeten het wachtwoord dat ze hebben ingevoerd onthouden. Indien niet ingevoerd, standaard geen wachtwoord.`,
"label.step1.total3":`Stap 1 van 3`,
"label.escalation.setup.detail.section":`Regel Detail`,
"front-gantt-module-drag-task-sorting":`Taken naar volgorde slepen`,
"label.isEnableVisualpage.new.title":`Toegang tot aangepaste pagina's inschakelen`,
"label_tabpage_yesz":`Ja`,
"label.emailobject.emaildetail.button.replyall":`Antwoord allen`,
"label.knowledge.setting.data.one":`Dit kan niet meer subcategorie toevoegen.`,
"label.manageAll.sel.one3":`Goedgekeurde punten`,
"UG_contact_01":`Hoe haalt u het beste uit uw contacten?`,
"font-trade-module-v1-invoice-name":`Factuur Naam`,
"label.central.daylight.time":`Central Daylight Time`,
"label.chatter.pastThirtyday":`De afgelopen 30 dagen`,
"vue_label_commonobjects_detail_activity_ownevent":`Beschikbaar evenement`,
"label.user.modify":`Gebruiker bewerken`,
"label.uploadTemplate":`Sjabloon uploaden`,
"setup_mainpage_label_welcome14":`Procesbeheer van workflowaanpassing, goedkeuring`,
"label.workmate":`Collega's`,
"label.displaycolumns":`Kolommen weergeven`,
"label.emailnoticeintro":`E-mail waarschuwingen zijn de e-mails die workflow regels sturen wanneer ze getriggerd worden.`,
"label.knowledge.category.button.five":`Categorie verwijderen`,
"template.report.business.opportunities.type":`Kansen per type`,
"vue_labenl_applauncher_moreapp":`Meer Apps`,
"label.captcha.expired":`De verificatiecode is verlopen, gelieve opnieuw te verifiëren.`,
"template.chart.bnqzkhslmb":`Beoogd aantal leads voor het jaar`,
"chatter.up.user.pic":`Upload gebruikersfoto`,
"label.timezone.importtimezone.gmt":`Gebruik gmt tijdzone`,
"label.step.type":`Selecteer het type lid dat u wilt zoeken`,
"Dashboard.View.RecentlyView":`Onlangs bekeken`,
"label.reportinthisfolder":`Rapporten in deze map`,
"label.product.vies":`Productoverzicht`,
"pagecreator_systemstyle_message_delete_fail":`Stijl wissen mislukt`,
"label.multipleactivity.singleUser":`Enkele gebruiker`,
"vue_label_email_enter_subject":`Onderwerp invoeren`,
"label_tabpage_alltabs":`Alle tabbladen`,
"label.publicgroup.groupname":`Naam van de groep`,
"template.report.sales.performance":`Prestaties van verkopers`,
"label.newWindow":`Nieuw Venster`,
"label.forecast.editopp.forecastedit":`Voorspelling bewerken`,
"label.data.import.setup.whichfield":`Welk veld wilt u gebruiken voor matching?`,
"label.noadd_dashboard":`Niet toevoegen aan dashboard`,
"label.subtotal":`Subtotaal`,
"front-email-payment-weichat":`Gebruik alsjeblieft WeChat "Scan"`,
"label.attendance.position.alert":`Kies eerst het masker`,
"chatter.follow.me":`Volg mij.`,
"label.mobile.more.details":`Bestandsdetails bewerken`,
"Dashboard_SelectBoardToDisplay":`Selecteer de dashboards die u wilt tonen op het dashborad tabblad`,
"front-gantt-module-v1-search-project":`Zoek uw project...`,
"label.paging.totalofpagereport":`Een totaal van {0} pagina's({1})`,
"label.from.phone":`Van`,
"lable.Signatory":`Signtory:`,
"label.campagin.roi.query.roi2":`Marketingkanalen ROI`,
"label.tabpage.selectcontentz":`Selecteer inhoud`,
"label.multilang.lookfiltercondition.valuetypenotmate":`De regelvoorwaarde {0} is onjuist, het waardetype komt niet overeen!`,
"label.interfaceconstraint.disabled":`De interface is uitgeschakeld, neem contact op met uw systeembeheerder.`,
"third":`De Derde`,
"label.quickbooks.viewlist.status":`STATUS`,
"label.emailtocloudcc.select3":`Selecteer eigenaar record`,
"label.projectManagement.week.work":`Mijn werk voor deze week`,
"vue_label_pool_nodemand":`Geen vraag`,
"label.version.two.developapi":`Secundaire ontwikkeling API`,
"label.icon.82":`Printer`,
"label.batchadd.newbatchpage.suclist":`stuk(ken) gegevens succesvol toegevoegd`,
"label.checkfield.chooseatlast":`Kies er ten minste twee uit`,
"label.quotation.deleteTip":`Selecteer de te verwijderen regels`,
"label.generatepage.title.desc2":`Klik op Opslaan om de webpagina en de Web URL-link te genereren die kan worden geopend.`,
"label.licence.total":`Totaal licenties`,
"Y":`Opzoeking Relatie`,
"label.wuzibiekesitan.time":`Oezbekistan Tijd`,
"label.component.hotdeal.nodata":`Geen gegevens over zakelijke kansen.`,
"label.data.exp.save":`Sla de sjabloon op`,
"label.appupload.upload.tips.dashboard":`OPMERKING: De dashboards in Mijn aangepaste dashboards" en "Niet gearchiveerde openbare dashboards" kunnen niet aan pakketten worden toegevoegd en worden niet in deze lijst getoond. De bijbehorende oude rapporten kunnen niet worden geüpload."`,
"lable.PowerProcess.new.PowerProcess":`Nieuw rechtsproces`,
"label.loginhis.search.download":`Aangezien er veel inloggeschiedenis is, kan bij het zoeken naar downloads alleen de geschiedenis binnen 2 maanden worden gedownload.`,
"label.tabpage.deleteview":`De weergave verwijderen`,
"label.chatter.recently":`Onlangs`,
"label.industrialandcommercialverification.title":`Industriële en commerciële verificatie`,
"message.nextapproverlost":`De volgende gespecificeerde goedkeurder is null.`,
"front-kefu-moudle-v1-mfsysy-time":`Resterende dagen voor gratis trail`,
"label.role.assign.tip":`Kies een gebruiker in de lijst Beschikbare gebruikers en voeg deze toe aan de lijst Geselecteerde gebruikers om gebruikers aan de rol toe te wijzen`,
"label.addattachment.step2.intruduce":`Herhaal stap 1 en stap 2 om meerdere bestanden toe te voegen.`,
"vue_label_pool_returnreasondiscription":`Beschrijving van de reden van terugzending`,
"label.weixin.report.range":`Bereik`,
"label.wei.weiresearchtab":`Micro-stemkeuze`,
"vue_label_report_setdrill":`Set Boor`,
"page_404_button_back":`Terug naar vorige stap`,
"label.customfields.autonumber.tip":`Een door het systeem gegenereerd volgnummer dat gebruik maakt van een door u gedefinieerde weergave-indeling. Het nummer wordt automatisch verhoogd voor elke nieuwe record.`,
"label.ccpeak.return.allrecords":`Geef alle records terug`,
"label.ccchat.notmember.active.group2":`Je staat niet in de naam met`,
"label.uniquename":`Unieke naam`,
"label.emailtocloudcc.filed.ssl":`Beveiligde verbinding`,
"chatter.emailFollowMe":`Volgt mij`,
"label.allrightsreserved.allrightsreserved.customerServiceHotline":`Copyright. Alle rechten voorbehouden. Klanten Service Hotline`,
"label.projectManagement.actualworkinghours":`Werkelijke werkuren`,
"label.quickbooks.fieldlabel.taxresale":`Belasting Wederverkoop`,
"label.icon.12":`Dienst`,
"label.data.exp.dataexptemp":`Sjablonen voor gegevensexport`,
"component_setup_tabs_label_add":`Toegevoegd:`,
"label.appointmentdetail.wizard.title10":`Begindatum`,
"label.multilingual.close":`Het meertalig beheer is niet ingeschakeld.`,
"message.error.username.notexist":`Ongeldige gebruikersnaam, gelieve opnieuw in te geven.`,
"label.batchadd.newbatchpage.des2":`Indien het veldtype Auto Number is, wordt het nummer automatisch verhoogd voor elke nieuwe record zonder manuele invoer.`,
"vue_label_SMS_search":`Zoeken naar leads of contacten`,
"label.appupload.successWithUrl":`Uw pakket is nu beschikbaar voor installatie via de installatie URL hieronder.`,
"UG_Forcast_06":`Selecteer de gebruikers die een voorspelling mogen doen`,
"vue_label_dashboard_secondarygroup":`Selecteer secundaire groep`,
"label.weixin..xsld.total":`Totaal bedrag in verkoop trechter`,
"label.setup.mobile.bottombutton.recovery.default.fail":`Kan standaard niet herstellen`,
"label.addrecurrencetimetrigger":`Periodieke tijd-trigger toevoegen`,
"label.emailsync.connectaccount":`Verbind e-mail account`,
"label_fiscal_years":`Fiscaal jaar`,
"label.icon.164":`Coach`,
"label.batchadd.mustinput":`Veld met`,
"message.newtabpage.nokeywords":`Uw zoekterm moet 1 of meer tekens bevatten. Of u kunt geavanceerde zoekcriteria toevoegen.`,
"label.login.verification.mfa.desc3":`Als uw account door meerdere mensen is gedeeld, zullen andere niet-gebonden MFA mensen niet kunnen inloggen nadat u MFA succesvol hebt gebonden. De oplossing is om iemand anders de MFA-toepassing te laten installeren en de QR-code voor deze pagina te laten scannen, of de QR-code-afbeelding op te slaan om later door anderen te laten scannen. In termen van de beste beveiligingspraktijken raden wij u echter aan om meerdere gedeelde accounts te annuleren.`,
"label.partnerCloud.basicSetting.initialize":`U kunt de domeinnaam na initialisatie niet meer wijzigen.`,
"label.address.county":`County`,
"label.validate.function.funcFormat.TODAY":`VANDAAG()`,
"label.sso.addAKey":`Sleutels toevoegen`,
"label.myusergroup":`Mijn gebruikersgroepen`,
"label.import.index.time-consuming":`Tijd`,
"label_tabpage_systems":`Er zijn * systemen`,
"batch.sendemail.s":`, Mail succesvol verzonden.`,
"label.appointment.wizard.subtitle4-1-1":`15 min.`,
"label.projectManagement.delete.milestone":`Alle gerelateerde informatie van deze mijlpaal zal ook worden verwijderd als u deze mijlpaal verwijdert, en de gegevens kunnen niet worden hersteld. Weet u zeker dat u de verwijdering wilt bevestigen?`,
"label.umeng.chatter.praise":`vond je post leuk.`,
"font-evaluate-module-v1-evdetails":`Evaluatie Detail:`,
"label.group.filter.resources.and":`Kies een methode voor het filteren van bronnen, EN relatie.`,
"label_emailtocloudcc_description":`Sluit uw zakelijke e-mailaccount aan, zoals sales@company.com, info@company.com, support@company.com. Log automatisch ontvangen e-mails als leads en cases in CloudCC om tijdige opvolging van klantenbrieven te verzekeren.`,
"label.chat.topic.delete.prompt2":`Onderwerpen met dezelfde naam in andere gemeenschappen zullen niet worden verwijderd.`,
"message.error.group.authorization":`U hebt geen toegang om deze groep in te stellen`,
"label.attendance.wz":`Locatie`,
"vue_label_activity_notice_logacal_success":`Je hebt een oproep gelogd`,
"label.emailtocloudcc.step1.case1":`E-mail naar Case`,
"label.h5.chatter.praisenum":`Lof ontvangen`,
"label_time_statistics_basis":`Tijdstatistieken basis`,
"label.onlyadmincanedit":`Beheerders kunnen <strong>AlLEEN</strong> records bewerken tijdens het goedkeuringsproces.`,
"label.fieldtoolongmassage":`Veld`,
"label.sales.team.shared":`Commerciële mogelijkheden groepsdeling`,
"label_emailsync_status_department":`Afdeling`,
"label.mobile.quickcreate.default.sellingfunnel":`Verkoop trechter`,
"label.tabpage.closez":`Sluiten`,
"homepage.components.two":`Stap 2 kies de plaats waar de aangepaste componenten worden weergegeven`,
"label.everyday":`Alledaags`,
"lable.Product.to.asset.BOM":`Product naar Asset BOM`,
"label.appointment.wizard.subtitle4-3":`De genodigde kan een start kiezen in elke`,
"label.customobjects.standardfieldslist":`Lijst standaardvelden`,
"label.customfields.suretodelete":`Ja, ik wil het aangepaste veld verwijderen.`,
"component.chatter.label.to":`Naar`,
"label.emailsync.form.seversetting":`Setup`,
"label.service.gantt.enabled.resources":`Geactiveerde bron`,
"label.tianyancha.h5.weibo":`Microblog`,
"template.chart.dddje":`Bedrag aan verloren orders`,
"label.pc.trigger.apiname":`De API-naam bestaat al, probeer het opnieuw.`,
"label.icon.34":`Opstellen`,
"label.schedulejob.setup.schedule.prgname":`Naam van de toepassing`,
"label.weixin.free.registration":`Meld u gratis aan`,
"label.placeholder":`Snel vinden`,
"label.emailobject.manage.template":`Sjablonen beheren`,
"label.knowledge.article.existsdata":`Er bestaan nog andere niet-gekwalificeerde gegevens.`,
"label.campaign.channel.lookup.ticket":`Controleer het ticket`,
"label.searchlayout.relation.searchfield":`Zoek Filter Velden voor gerelateerde lijsten.`,
"label.recordid.cannot.empty":`Record ID kan niet null zijn`,
"label_partner_workspace_member_choice":`Profiel kiezen`,
"vue_label_campaign_amount":`Inkomensbedrag`,
"label.niue.time":`Niue Time`,
"front-homepageobject-module-v1-workload-ranking":`Rangschikking van de werklast`,
"message.error.datainvalid":`Fout: ongeldige gegevens.`,
"vue_label_helpcenter_salesfunnel":`Gebruik de nieuwe versie van de verkooptrechter om de opvolging van zakelijke kansen te analyseren en gegevens te verstrekken voor uw verkoopproces.<br> In de linkerbovenhoek worden records gefilterd op basis van voorwaarden, zoals rol of eigenaar, en alle zichtbare zakelijke kansen onder de overeenkomstige voorwaarden worden bekeken en geanalyseerd. Klik op de fase van het verkooptrechter diagram om alle records onder die fase te bekijken.`,
"vue_label_transferownernotice":`De eigenaar van het record dat aan dit item is gekoppeld, wordt ook gewijzigd`,
"label.monitorsys.operator":`Geacteerd door`,
"label.please.codeNorm":`Kies de code standaard.`,
"label.campaign.channel.step6.remark2":`Werknemerswerving mogelijk maken`,
"market.potential.customers":`Marktleider`,
"label.customfields.phone.tip":`Hiermee kunnen gebruikers een willekeurig telefoonnummer invoeren. Formatteert het automatisch als een telefoonnummer.`,
"label.currency.edit":`Valuta bewerken: Wijzig bedrijfsvaluta`,
"label.emailobject.emaildetail.button.markasunread":`Markeer als ongelezen`,
"label_partner_template_memo":`Titel`,
"label.chat.message.search.all":`Zoeken in alle informatie`,
"label_tabpage_hoursagoz":`uren`,
"label.customcomponent.developer.help":`Aangepaste componenten Ontwikkelaar Hulp`,
"setup_mainpage_label_welcome":`Welkom bij CloudCC PaaS platform, de belangrijkste functies van het platform zijn als volgt:`,
"label.h5.similar.opportunity.list":`De resultaten omvatten gesloten kansen die een of meer velden gemeen hebben met uw kans. Door een bladwijzer te maken van een opportuniteit, voegt u ze toe aan de lijst met gelijkaardige opportuniteiten op de detailpagina van uw opportuniteit.`,
"vue_label_record_count":`Record aantal`,
"label.icon.29":`Demo`,
"pagecreator.page.label.pagelayout":`Pagina-indeling`,
"label.ggReleaseRange.searchRole":`Een rol zoeken`,
"label.campagin.member.field.setup":`Veldinstellingen voor campagneleden`,
"augest":`Augustus`,
"label.salescloud.massloss.content":`Het uitschakelen van gelegenheidsteams zal bestaande teams onherroepelijk verwijderen uit alle Opportunities en standaard gelegenheidsteams van gebruikers verwijderen.`,
"label.customfields.new.step2.opration.unique.info":`Dubbele waarden zijn niet toegestaan.`,
"vue_label_email_optional_members":`Facultatieve leden`,
"label.emailobject.attachment.download":`Download`,
"label.recordamount":`Record Aantal`,
"front-kefu-moudle-call-recorder":`Gespreksopname`,
"label.more.info":`Details`,
"vue_label_commonobjects_view_secondsbefore":`{seconden} seconden`,
"label.emailsync.status.action":`Actie`,
"label.customfields.totalsummary.collectedfields":`Samengevat Object`,
"label.knowledge.setting.hint.two":`Opgelet: U kunt de Kennis niet uitschakelen als deze eenmaal is ingeschakeld.`,
"label.login.access.yujidao":`Exp.`,
"label.assignment.setup.detail.description":`Voeg regelitems toe die de criteria specificeren die worden gebruikt om automatisch leads aan gebruikers toe te wijzen.`,
"message.error.marketsea.null":`Lead Pool bestaat niet`,
"lable.account.Current.CY":`Huidige CY`,
"vue_label_salesadvance_lost":`Verlies`,
"label.file.ownedbyme":`Eigendom van mij`,
"label.component.helper.nodata":`Niets heeft uw aandacht nu nodig. Kom later terug.`,
"label.weixin.appr.pending.auditor":`Ingediend door`,
"UG_opportunity_004":`Type multiservice`,
"label.leadscore.setup":`Leads Scoren Instellingen`,
"label.addtimetrigger":`Tijd trigger toevoegen`,
"label.mr.title.match":`Indien exacte overeenkomst`,
"label.projectManagement.Newmilestone":`Nieuwe Mijlpaal`,
"label.preview":`Voorbeeld`,
"label.tabpage.issuez":`Nummer`,
"label.img.max.size":`De geüploade afbeelding is te groot. De maximale grootte van een geüploade afbeelding is 500K, gelieve opnieuw te uploaden.`,
"label.mainpageset":`Homepage-onderdelen configureren`,
"label.user.login.false.lock":`Inlogpogingen overschreden. De account is vergrendeld`,
"UG_solution_02":`De oplossing is een interne oplossing van de instelling voor het probleem dat de rekeningen tegenkomen.`,
"vue_label_approve_put_away":`Instorten`,
"label.profile.existing":`Bestaand profiel`,
"label.ems.logininfo":`Inloggegevens`,
"label.weixin.location.service":`Objecten die locatiediensten ondersteunen`,
"label.multilang.datamoveaction.totaldata":`Er is een totaal van {1} records die voldoen aan de voorwaarde, maximaal 100 records kunnen in één keer worden overgedragen！：`,
"label.ccdocument.cannot.update.set":`Dit document behoort niet Word of Excel of PPT type van het bestand, niet geupload naar de rode map sjabloon.`,
"vue_label_fliter_addfliter":`Fliter toevoegen`,
"label.custom.page.or.trigger":`(Aangepaste pagina's of triggers)`,
"label.tag.filter1":`Filter records uit die alle geselecteerde tags bevatten`,
"UG.homepage.006":`360-graden zicht op de activiteit van uw account via enquêtes, live chats, e-mails, werkopdrachten, berichten op sociale media en zelfs verkoopactiviteiten (zoals leads, serviceondersteuning en activiteiten).`,
"SCORE":`Score`,
"label.file.library.managemembers2":`Bibliotheekleden beheren`,
"label.email.template.public.SMS":`Openbare SMSsjabloonmap`,
"label.leadscore.donot":`Niet in staat om leads te scoren`,
"label.gaode.map":`Amap`,
"pagecreator_button_preview":`Voorbeeld`,
"UG_contact_04":`Of`,
"label.ccchat.person.invite.eminfo":`{0} heeft je uitgenodigd om {1} te joinen op CCChat.Met ccchat kun je chatten met je collega's, teams maken voor je projecten, en bestanden delen.`,
"setup_object_field_dependency_label_actionfieldvalue":`Controlling Field`,
"lable.Product.options":`Product Opties`,
"front-electronic-signature-add-autofill-field":`Automatisch aanvullen veld toevoegen`,
"label.customfields.totalsummary.selectcollectedfields":`Selecteer Object om samen te vatten`,
"label.projectManagement.the.maximum.contract.amount.is.10.digits":`Er kunnen maximaal 10 cijfers worden ingevoerd voor het contractbedrag.`,
"label.forecast.shrepage.pagetitle":`Gebruikers, rollen en gebieden delen`,
"label.login.access.mark":`Om u te helpen bij ondersteuningsproblemen, kunt u uw beheerder of ondersteuningspersoneel de mogelijkheid geven om als u in te loggen en toegang te krijgen tot uw gegevens.`,
"lable.outlook.edit.zdyout":`Aangepaste Exchange-veldtoewijzing`,
"label.approveoperate":`Goedkeuringsacties`,
"label.tabpage.linknamez":`Link naam`,
"label.report.error.deletehavedashboard":`Dit rapport heeft een nieuw dashboard en kan niet worden verwijderd`,
"label.summaryreport.2018.step1":`Stap 1 Maak een groepering`,
"label.campaignmember.main.leadtomember.title":`Configuratie veldtoewijzing`,
"label.select.dashboar.type":`Selecteer het Dashboard type`,
"message.setup.field.picklist.valueexists":`Deze picklist waarde bestaat al.`,
"label.loading":`Laden...`,
"label.payments.paytip1":`Uw huidige geabonneerde editie is geen gratis editie, klik op Bevestigen om te vernieuwen of log opnieuw in.`,
"label.view.appliedMobile":`Aanmelden voor de mobiele app`,
"label.multilang.forcast.financialyear":`{0} fiscaal jaar：`,
"front-web-module-v1-detail-comment-opinion":`Feedback`,
"UG_Forcast_10":`Compleet`,
"label.optionlistset":`Keuzelijst Opties`,
"label.visualpage_list.vpname":`Aangepaste paginanaam`,
"vue_label_calendar_failed_to_delete_calendar":`Kalender verwijderen mislukt`,
"label.json.string.null":`Leeg`,
"message.serviceappo.time.violation2":`De beschikbare tijd overtreding van de dienst afspraak: De afgesproken eindtijd van de afspraak is eerder dan de vervaldatum van de dienstafspraak`,
"label.productsales.today.noevttsk":`Er zijn geen openstaande gebeurtenissen en aflopende taken.`,
"label_tabpage_emptyz":`Leeg`,
"front-kefu-moudle-no-create":`Niet gemaakt`,
"label.wedge.shaped.tail.arrow.cannot.empty":`Wig staart pijl kan niet null zijn`,
"label.continue.shopping":`Ga verder met winkelen`,
"label.turntomain":`Ga naar Master inhoud`,
"component.assistant.label.nodata":`Geen evenement vandaag, kom later terug.`,
"label.payments.paytip4":`Voer het aantal gebruikers in！`,
"label.appupload.upload.versionName":`Versie Naam`,
"label.chatter.endData":`Einddatum`,
"front-kefu-moudle-buytr-tip":`We hopen dat u een geweldige ervaring zult hebben met het call center van CloudCC, en dat u een officieel call center account kunt aanschaffen en wij u een betere service zullen bieden.`,
"label.repw":`Herhaal Wachtwoord`,
"label.tabularreport.intro":`Een tabelvormig rapport is een van de eenvoudigste en snelste manieren om gegevens op te sommen.`,
"label.selectoperatetype":`Selecteer type actie`,
"setup.layout.label.required":`Vereist`,
"label.default.designee":`Standaard verzonden Peron`,
"label.ccdocument.cannotdel.folder":`U kunt deze map niet verwijderen omdat sommige bestanden in deze map.`,
"label.escalation.setup.newentries.inputentries":`Voer de regel in`,
"label.emailobject.addnewtemplate":`Nieuwe sjabloon toevoegen`,
"label_chatter_content":`Inhoud`,
"label.htyj.mubiao":`Doel`,
"label.reportsSubscriptionPage.schedulereport.weekly.friday":`Vrijdag`,
"label_tabpage_fieldoptions":`Record type veld, optie lijst veld, en optie lijst (meerkeuze) veld. het is aanbevolen om maximaal 10 trefwoorden in te voeren, gescheiden door komma's om "of relatie" te bereiken, zoals: "New York, Toronto, Tokyo".`,
"label.mobiletablayoutedit.remark2":`Selecteer de velden die worden weergegeven op de startpagina van het tabblad in de mobiele app.`,
"label.sendemail.chat.addComentsat":`Beste #naam:#gebruikersnaam noemde u in commentaar.`,
"Z":`Formule`,
"label.multilang.batchdeleteaction.movesuccess":`Er zijn in totaal {0} records succesvol verwijderd！：`,
"label.textmessage.vonage.message2":`Door Vonage API-accounts aan te maken, geven gebruikers CloudCC toegang tot hun Nexmo API-account voor het verzenden en ontvangen van sms'jes.`,
"label.file.use.document":`Gebruik opslagruimte`,
"UG.Lead.011":`Maak een aanwijzing`,
"label.view.name":`Bekijk naam`,
"label.data.downtemplate":`Sjabloon downloaden`,
"vue_label_appstore_get_now":`Haal het nu.`,
"label.controlfield":`Controlling Field`,
"label.dataimport.type.insert":`Invoegen`,
"label.customfields.multiselect.tip":`Stelt gebruikers in staat meerdere waarden te selecteren uit een lijst die u definieert.`,
"label.weixin.approval.qxzjl":`Selecteer het record`,
"component.salesperformance.label.70finish":`Afgewerkt - onverwerkt (>70%)`,
"Lead_Auto_Scoring_Setting":`Lead Scoring Instelling`,
"pagecreator_layout_message_canntdelete":`De huidige lay-out is niet toegestaan om te verwijderen`,
"vue_label_report_exprotpage":`Pagina exporteren: Pagina {pagina}`,
"label.campaign.channel.step4":`Stap 4: Selecteer de verplichte velden die moeten worden weergegeven op de registratiepagina van het marketingkanaal`,
"label.app.launcher":`Applicatie Launcher`,
"vue_label_campaign_selectedmember":`{member} campagne leden geselecteerd`,
"label.mobile.quickcreate.default.approvals":`Goedkeuringen`,
"label.view.step4":`Stap 4 Beperk de zichtbaarheid`,
"label.exchange.sync.state.user":`Gebruiker Synchronisatie Status`,
"label.forecast.customforecast.tab.forecast":`Voorspellingen`,
"label.theUserLoginForTheFirstTime":`Eerste gebruiker login.`,
"label.workflowoperate.tip":`Specificeer de workflow acties die zullen worden getriggerd wanneer aan de regel criteria wordt voldaan.`,
"font-evaluate-module-v1-ten-points":`Positief cijfer: 10 punten`,
"label.knowledge.delete":`Fout bij het verwijderen van kennis`,
"front-console-see-contacts":`Geïdentificeerde {num} contacten`,
"label.h5.similar.opportunity.add.to.favorites":`Toevoegen aan Favorieten`,
"front-epwechat-module-v1-install-app":`Installeer in WeCom`,
"setup_layout_message_relatedlistbutton":`Selecteer standaardknoppen om op de gerelateerde lijst weer te geven.`,
"label.salescloud.massloss.title":`Kan leiden tot groot gegevensverlies.`,
"front-console-conversation-btn1":`Ring terug`,
"label.custom.canvasScale":`Canvas Schaal`,
"label.lead.score.doing":`In het proces van lead scoring`,
"message.approval.step.validation.invalid.number":`Ongeldig nummer`,
"chatter.lk":`Zoals`,
"label.dashboardSetup.showmaxval":`Max. Weergegeven`,
"label.keywords":`Trefwoorden`,
"vue_label_helpcenter_SMS":`Zet SMS functie aan<br> Als de landcode van het CRM systeem dat u heeft aangeschaft USA is, dan is de SMS functie beschikbaar in het systeem van uw organisatie. De organisatiebeheerder kan het telefoonnummer dat door uw organisatie is aangeschaft in het vonage systeem invoeren in de vonage gateway in de achtergrond integratie applicatie, en vervolgens de SMS functie gebruiken in het menu van de sales cloud applicatie.<br>SMS box<br> De SMS box is verdeeld in twee delen. Aan de linkerkant is het record van leads of contacten met SMS. Nadat u op een record hebt geklikt, worden de verzendende en ontvangende details aan de rechterkant weergegeven. U kunt de records van uzelf en uw ondergeschikten bekijken.<br>Groepsbericht versturen<br> U kunt groeps SMS berichten versturen in het SMS menu, de lijst met leads of contacten, en de knop om SMS berichten te versturen op de leden van de campagne. U kunt alleen SMS-berichten sturen naar potentiële klanten of contactpersonen in CRM. Na het bewerken van het tekstbericht, selecteert u "Verzenden", en een groepsrecord zal worden gegenereerd, ongeacht het aantal ontvangers, of u kunt "Afzonderlijk verzenden" selecteren om de tekstberichten afzonderlijk te verzenden Afzonderlijke SMS-berichten ondersteunen het tonen van de samengevoegde velden ingevoegd in het SMS-sjabloon.`,
"label.emailobject.createnewavailability":`Nieuwe beschikbaarheid creëren`,
"front-kefu-moudle-buytr-send-email":`U bent nog niet geassocieerd met de mailbox van het systeem. Stuur een email naar support@cloudcc.com en schrijf uw intentie, bedrijfsnaam en contactinformatie, verkoopmedewerkers zullen zo spoedig mogelijk contact met u opnemen.`,
"front-kefu-moudle-v1-Put-away-the-chat":`Chatgegevens samenvouwen`,
"label.marketseamemset.lead.maxuser":`Maximum aantal leden`,
"label.forecast.forecastroleuserpage.shre.manager":`Alleen beheerders kunnen deze voorspelling delen`,
"label.file.noselect":`Er zijn geen bestanden geselecteerd`,
"label.notification.task3":`【被分配人】 de status wijzigen van de taak die u hebt toegewezen aan 【新状态】`,
"label.dependfield":`Afhankelijk veld`,
"lable.SalesCommitmentKanBan.receipts":`Ontvangsten`,
"label_partner_workspace_member_search":`Zoeken op`,
"label.share.originally.posted":`Eerste poster`,
"label.autonumber":`Auto Nummer`,
"label.view.sortview.name":`Bekijk naam`,
"label.h5.add.activity":`Activiteit toevoegen`,
"label.textmessage.vonage.phone.number":`Telefoonnummer`,
"label.partnerCloud.financeSetting.enterApiKey":`Voer API geheime sleutel in`,
"label.industrialandcommercialverification.enablestatus":`Inschakelstatus`,
"label.reportTypeFocusD1":`Specificeer welk type records (rijen) de focus zullen zijn van rapporten die door deze rapportgegevensbron worden gegenereerd.`,
"vue_label_report_four-levelseriesobjecttree":`Boomstructuur van serieobjecten op vier niveaus`,
"label.mobile.default.catalogue":`Standaardcatalogus`,
"label.partnerCloud.partnerAccount.again":`Herladen`,
"label.summaryreport.step2.new":`Stap 2 Selecteer de groeperingsmethode voor samengevatte gegevens`,
"label.tabpage.cancel":`Annuleren`,
"label.multilang.datamovelist.datamove":`Overdracht van meerdere {0} van een gebruiker naar een andere gebruiker:`,
"label.conferloginandvisitlimit":`Verleende Login Toegang`,
"vue_label_help_viewhelpcenter":`Bekijk het CloudCC Helpcentrum`,
"label.leadscore.norule":`Geen lead score regels, maak een lead score regel of activeer een bestaande regel`,
"label.tabpage.exitz":`Exit`,
"label.DeploymentStatus":`Uitrolstatus`,
"label.layout.saving":`Lay-out opslaan...`,
"label.emailobject.emaildetail.field.object":`Object`,
"label.customfields.searchrelation.fieldtag.tip":`Voer de labels in die u wilt gebruiken in de weergaveweergave, de paginalay-outweergave, de rapportweergave en de lijstweergave.`,
"message.huanxin.bindtenant.notfound":`Ongebonden agent`,
"label.referpersonalias":`Ingediend door`,
"label.icon.31":`Computer`,
"label.appupload.upload.install.thispackage":`Dit pakket`,
"label.appointment.wizard.subtitle1-1":`Custom`,
"pagecreator_page_message_save_fail":`Pagina opslaan mislukt`,
"label.lastset":`Eindelijk Volgens`,
"label.version.support.limited":`Ondersteuning Beperkt`,
"vue_label_homepage_kanban":`Kanban`,
"label.layout.editsearchdistribute":`Bewerk Zoek Lay-out`,
"template.dashboard.customer.analysis":`Rekeningen Analyse`,
"label.continue_editing":`Doorgaan met bewerken`,
"label.version.sum.customtab":`aangepaste tab(s)`,
"label.validate.function.funcExplain.TIMEVALUE":`Geeft als resultaat de waarde van de plaatselijke tijd zonder de datum`,
"label.import.page1.selectobjfromdata":`Selecteer objecten om gegevens te importeren`,
"label.partnerCloud.basicSetting.success":`Succesvol initialiseren`,
"label.customfields.fielddependency.cannotcreat":`Het veld dat u selecteert hangt direct of indirect van zichzelf af, dus u kunt geen afhankelijkheid creëren.`,
"label.umeng.activity.youhaveatask":`Je hebt een nieuwe taak.`,
"label.file.folder.create":`Nieuwe map`,
"vue_label_campaign_member_status":`Status van lid`,
"lable.opppdt.addpdt.table.date":`Datum`,
"label_partner_workspace_login_buttontext":`Knop tekst`,
"label_other_mistakes":`Andere fouten`,
"label.must.be.configured":`Moet worden geconfigureerd`,
"label.customize.memory.function.sorting.enable":`Activeer het geheugen van het sorteren van kopteksten`,
"setup.layout.label.areaname":`Sectie Naam`,
"label_chatter_pastThirtyday":`De afgelopen 30 dagen`,
"setup_mainpage_label_welcome25":`Instructies: Klik op het menu aan de linkerkant van deze pagina → Instellingen beheren → Beveiligingscontrole → Instellingen delen.`,
"label.ccchat.person.invite.succsend":`Een uitnodiging om deel te nemen aan de CCChat wordt gestuurd naar`,
"label.select.time.range":`Gelieve een tijdspanne te kiezen`,
"label.partnerCloud.orderingPlatform.djustQuantity":`Voeg producten toe aan de winkelwagen, waar u de hoeveelheid kunt aanpassen en de prijs kunt bekijken.`,
"label.manageAll.sta1":`In afwachting van`,
"label.cy.select":`Kies een nieuwe valuta uit de beschikbare lijst.`,
"chatter.lam":`Commentaar`,
"label.partner.setup.title":`Instellingen`,
"component.setup.label.displaybutton":`Weergaveknop`,
"component.salesperformance.label.target":`Doel`,
"label.campagin.channel":`Voer de kanaalwaarde in`,
"label.validate.function.funcFormat.ISCHANGED":`ISWANGED(veld)`,
"UG.homepage.009":`Toegang CRM`,
"label.file.item":`Project`,
"label.file.library.addmembprompt":`De volgende personen zijn reeds lid.`,
"label.bmap.releasePosition":`Locatie`,
"setup_object_layout_label_selectedprofile":`Geselecteerde Profielen`,
"label_emailsync_message":`Prompt`,
"label.view_submissions":`Bekijk inzendingen`,
"lable.tianyancha.repeated":`Herhaalde selectie`,
"label.import.index.introduce":`Importeer uw gegevens in het systeem in drie eenvoudige stappen`,
"label.time.operation.new":`Nieuwe geplande taak`,
"label.projectManagement.Pleaseentersettlementtype":`Gelieve het type regeling in te voeren`,
"label.icon.169":`Tourwagen`,
"vue_label_commonobjects_detail_related_listview":`Lijst`,
"label.view.step1":`Stap 1 Geef View Naam`,
"label.summaryreport.intro":`Overzichtsrapporten tonen zowel subtotalen van gegevens als andere samenvattende informatie.`,
"vue_label_file_input_correct_name":`Gelieve de juiste naam in te vullen`,
"System_Email_Template_Title":`Welkom bij CloudCC CRM platform`,
"label.tianyancha.province":`Provinciale afkorting`,
"label.deleteall.sure":`Weet je zeker dat je alles wilt verwijderen?`,
"label.passwordPolicy.setup.uppercasealpandnum":`Moet cijfers, hoofdletters en kleine letters combineren`,
"front-lightning-module-v1-details-page-chart-select":`Object kiezen en weergeven`,
"setup_mainpage_label_welcome8":`Interface aanpassen via slepen en neerzetten`,
"lable.outlook.edit.lastupc":`Laatst bijgewerkt Contact`,
"label.weixin.registered":`Aanmelden`,
"vue_label_file_history_version":`Herzieningen`,
"vue_label_campaign_earned":`Te innen bedrag`,
"label.staticresource.useful.realtion.tip":`Hieronder vindt u een lijst van alle CloudCC.com pagina's die naar deze statische bron verwijzen.`,
"vue_label_file_libraray":`Bibliotheken`,
"label.department.phone":`Mobiel nummer`,
"label.emailtemplate.edit":`Email sjabloon bewerken`,
"label.processsetting.key.information.tips":`Belangrijke informatie en tips`,
"label.summaryreport.step7":`Stap 7 Selecteer het grafiektype en het markeerpunt`,
"label.chat.topic.remove.favorite":`Verwijderen uit bladwijzers`,
"label.campagin.roi.ksrq":`Begindatum`,
"label.data.downpage.e_title.e_btn":`Ga naar de export pagina en start het exporteren`,
"label.approvaldatamove.dname":`Huidige goedkeurder`,
"lable.Partial.attributes":`Gedeeltelijk kenmerk`,
"template.report.enabled.products":`Geactiveerde producten`,
"lable.outlook.detail.cto":`CloudCC.com naar Exchange`,
"label.sendemail.activity.newtasktitle":`Nieuwe taak melding`,
"label.validate.function.funcFormat.DAY":`DAG(datum)`,
"label.log.datetime.value":`Voer de query tijd in`,
"label.import.index.updaterecord":`Record bijwerken`,
"label.registration.page.invitation":`Uitnodiging registratiepagina`,
"pagecreator_systemstyle_label_detailcolor":`Detail tekst kleur`,
"label.tabname.cannot.empty":`Tabbladnaam kan niet null zijn`,
"label.data.newtemplate.savetemp":`U kunt deze opslaan als sjabloon en de velden en criteria voor deze gegevensexport gebruiken als gegevensexportsjabloon. Voer de naam en de beschrijving van het sjabloon zorgvuldig in om het gebruik ervan te vergemakkelijken.`,
"label.ems.body":`Lichaam`,
"enc":`Gecodeerde tekst (opslag gecodeerd)`,
"label.profile.mobile.setup.commonSaler":`Algemene verkoop`,
"label.continueselectproduct":`Producten blijven kiezen`,
"label.event.new":`Nieuw evenement`,
"label.renametabandtaglib":`Tabblad en label hernoemen`,
"label.qrcodelogin.message.exception":`Server uitzondering, neem contact op met uw beheerder.`,
"label.service.gantt.locationToGantt":`Gantt Grafiek`,
"label.mr.theLastGroup":`Dit is de laatste groep. Klik op "Terug naar de lijst met dubbele records" om de dubbele records te bekijken.`,
"label.report.export.format.content":`Exporteer huidige rapportkop, groepen en details. Het maximum aantal details dat kan worden geëxporteerd is`,
"label.version.accountandcontact":`Rekeningen en Contacten`,
"label.partnerCloud.financeSetting.enterMd5Key":`Voer de MDS geheime sleutel in.`,
"label.login.access.quater":`Week`,
"vue_label_commonobjects_view_searchthisview":`Zoek in deze lijst`,
"label.import.step1.allobj":`Alle objecten`,
"front-efficient-project-management":`Project Cloud biedt volledig levenscyclusbeheer van project kickoff, planning, uitvoering, controle tot afsluiting, optimaliseert het projectbeheerproces volgens uw zakelijke behoeften en helpt u projecten efficiënt te beheren.`,
"label.includedvalue":`Waarden opnemen`,
"label.service.newBuildDialog.past.days":`afgelopen dagen`,
"vue_label_report_sortup":`Sorteren in oplopende volgorde`,
"label.appointment.wizard.subtitle3-2":`Dinsdag`,
"label.dashboard.trend":`Tendens`,
"label.schedulejob.setup.schedule.st2":`De 2e`,
"label.view.sortview.number":`Aantal records`,
"lable.Please.enable.order":`De bestelling is niet geactiveerd, gelieve te activeren.`,
"label.datamanage.immediately.import":`Importeren`,
"label.delete.condition":`Duidelijk`,
"label.dashboard.chooseDispalyOnTheHomePage":`Selecteer de homepage die moet worden weergegeven`,
"asset.accountid.contactid.required":`Elk goed moet aan een rekening of contactpersoon worden gekoppeld.`,
"label.mask.character":`Masker Karakter`,
"lable.account.Previous.FY":`Vorige FY`,
"chatter.attachment":`Bestanden toevoegen`,
"label.view_only":`Alleen bekijken`,
"label.tianyancha.name":`Bedrijfsnaam`,
"label.service.gantt.avg.traveltime":`Gemiddelde reistijd van dienstafspraken`,
"vue_label_pool_move":`Verplaats`,
"label.import.index.beforeexport":`2、Voordat u gaat importeren, zorg er dan voor dat u alle gerelateerde records importeert. Bijvoorbeeld, als u contact records importeert en u wilt het account veld invullen, wat een lookup veld is, dan moet u eerst het account record aanmaken dat u wilt invullen, dan het contact record importeren en het account veld invullen met naam of ID van de corresponderende klant.`,
"label.view.delete":`Delete`,
"template.detail.info.link":`Details Link`,
"label.sendemail.send.setfail":`Het instellen van de e-mail informatie is mislukt, vul aub de juiste e-mail informatie in.`,
"label_emailtocloudcc_redmessage11":`verificatie van SMTP gefiatteerd. Controleer of het e-mailadres en het wachtwoord juist zijn.`,
"label.campaigns.memberalert":`Selecteer ten minste een lid`,
"label.schedulejob.setup.schedule.frequency":`Frequentie`,
"component.newrecords.label.all":`Bekijk alle`,
"label.mr.caption.opportunity":`Duplicaten zoeken en samenvoegen: Coderingen voor het opvragen van duplicaten van Opportunities`,
"chatter.group.onlyMembers":`Alleen leden kunnen deze groep zien. En alleen de eigenaar van de groep heeft toestemming om teamleden toe te voegen.`,
"label.recordtype.edit.selectvalue.show":`Picklistwaarden worden weergegeven in de volgorde waarin ze zijn opgeslagen.`,
"message.textmaxlength":`Lengte mag niet meer zijn dan 255 tekens`,
"label.reportsSubscriptionPage.visibility":`Lopend als`,
"label.umeng.chatter.addcoments":`Uw wolkenpost heeft 1 nieuw antwoord`,
"chatter.up.f":`Upload mislukt, onbekende fout.`,
"label.icon.146":`Toetsenbord`,
"lable.custom.CY.Ago":`2 CY geleden`,
"label.tabpage.step3":`Stap 3 selecteer de weer te geven velden`,
"label.checkfield.introduce":`Stel de velden van het object in die kunnen worden gebruikt om te controleren op doublures, en zoek de doublures in de recordlijst op de velden die u hebt ingesteld.`,
"label.tag.addtags":`Tags toevoegen`,
"label.service.newBuildDialog.characterlimit":`De naam overschrijdt de limiet van 25 tekens.`,
"font-evaluate-module-v1-evquestions":`Evaluatievraag`,
"label.knowledge.only.update.draft":`Alleen ontwerp bijwerken`,
"label.partnerCloud.basicSetting.defaultCounts":`Standaard rolnummer voor het toevoegen van een partnerrekening`,
"label.chat.topic.delete":`Delete`,
"label.workflow.contentcondition":`aan de criteria is voldaan`,
"vue_label_commonobjects_view_sortby":`Sorteren op {veld}`,
"label.passwordPolicy.setup.pwdremember24":`Onthoud (0) wachtwoord`,
"front-kefu-moudle-free-account":`Proefrekening`,
"label.marketsea.isautorecycle":`Automatische recycling inschakelen`,
"label.addattachment.view":`Bestanden bekijken`,
"vue_label_helpcenter_contact":`In de gedetailleerde informatie, klik op de boomdiagram knop naast het contact, kunt u het contact hiërarchie diagram bekijken, de leider-lid relaties van gerelateerde contacten begrijpen, en sommige veldinformatie van elk contact bekijken.`,
"label.taskevent":`Activiteiten`,
"label.industrialandcommercialverification.message":`De gratis vragen van vandaag zijn op.`,
"label.object.already.delete":`Het object verwijderd`,
"label.project.hit.four":`Subtaak Bijwerking Mededeling`,
"label.taskpagelayout":`Lay-outs taakpagina's`,
"label.version.sum.locationfield":`Geolokatie velden`,
"front-sales-button-toQB":`Synchroniseren met QuickBooks`,
"label.app.oceanblue":`Oceaan Blauw`,
"label.operating":`Bediening...`,
"label.customfields.formula.dateexample":`Herinnerdatum = SluitDatum - 7`,
"label.happen_delete":`Wat gebeurt er als ik een formulier verwijder?`,
"label.service.appointmentList.plansToStart":`Start Plan`,
"label.persmets.operate.licence":`Toestemming`,
"label.mobile.quickcreate.default.activities":`Kalender`,
"label.australian.eastem.standard.time":`Australische oostelijke zomertijd （New South Wales）`,
"label.emailobject.remove":`VERWIJDER`,
"label.weixin.vote":`Stem`,
"label.reportsSubscriptionPage.condition.aggregate":`Geaggregeerd`,
"front-kefu-moudle-has-unbind":`Je bent ongebonden geweest`,
"chatter.group.newGroup":`Nieuwe Groep`,
"label.tabpage.systems":`Er zijn * systemen`,
"label.textmessage.vonage.connect":`Verbinden met Vonage`,
"label.campaign.channel.input.ticket":`Toegangskaart sturen`,
"label.ccpeak.query.sharetab":`Formulieren zoeken`,
"label.reporttype":`Verslag Gegevensbron`,
"message.duplication.label.isprofiletip":`Indien aangevinkt, worden de gegevens die de huidige gebruiker kan zien geverifieerd bij het zoeken naar duplicaten. Anders worden alle gegevens gecontroleerd.`,
"label.tianyancha.businessverify.xieyi":`CloudCC gebruikers licentie overeenkomst`,
"font-evaluate-module-v1-select-person":`Selecteer klantenservice personeel`,
"vue_label_chatter_all_groups":`Alle groepen`,
"label.recordtype.profile.setdefault":`Standaard maken`,
"label.mr.descreption.nocondition":`Geen dubbele gegevens die aan de voorwaarden voldoen.`,
"label.tabpage.askz":`Wat zou je willen vragen aan`,
"label.marketsea.selectMember":`Selecteer lid`,
"template.report.stage.possibility.analysis":`Fase Mogelijkheidsanalyse`,
"label.data.selectderivedobject":`Selecteer het uit te voeren object`,
"label.customfields.formula.explain":`Beschrijving: ondersteunt momenteel het aantal, percentage, en andere velden van de vier principes, alsmede de overdracht waarden van de lookup veld. Bijvoorbeeld: aantal berekenen: eenheid*eenheidsprijs&nbsp;&nbsp;&nbsp;&nbsp;lookup veld dragen waarde:contact__r.adres`,
"vue_label_notice_change_fail":`Verandering mislukt`,
"label.customobjects.trackoldandnewvalues":`Oude en nieuwe waarden bijhouden`,
"label.h5.leftprompt":`Je hebt wat bewerkte inhoud die niet verzonden is, ben je zeker dat je weggaat?`,
"label.select.field":`Beschikbare velden`,
"label.customobjects.layoutedit":`Pagina Lay-out Opdracht`,
"label.false":`FALSE`,
"UG_Forcast_07":`Sta voorspelling toe`,
"vue_label_chatter_team_member":`groepslid`,
"label.tabpage.retypez":`Wanneer het recordtype gewijzigd wordt, zullen de bestaande waarden van de optielijst niet automatisch gewijzigd worden. wij raden aan om de bestaande waarde van de optielijst van het record op dezelfde plaats bij te werken.`,
"front-epwechat-module-v1-single-desc":`Single Sign On andere uiteinden van CloudCC via WeCom; Swift switch tussen alle uiteinden.`,
"label.closeandconverted":`Gesloten-geconverteerd`,
"label.service.confirmed":`Bevestigd`,
"label.partner.workspace.member.cloudcc":`CloudCC profiel`,
"label.star.click":`Klik om te wissen`,
"label.icon.135":`Valuta`,
"button_partner_workspace_login_logo_upload":`Afbeelding uploaden`,
"message.error.sql.constraint.recordnotsingle":`Externe ID succesvol ingesteld. Reden: dit veld in de oorspronkelijke gegevens bevat dubbele gegevens.`,
"label.ccchat.person.invite.errorpwd":`Gebruik ten minste 8 tekens en een combinatie van cijfers en tekens`,
"label_tabpage_isdeleterecord":`Als u de geselecteerde record verwijdert`,
"label.weixin.prompt.message":`Prompt bericht`,
"vue_label_chatter_view_original_post":`Bekijk origineel bericht`,
"label.multilingual.tip3":`Door meertaligheid in te schakelen kan elke gebruiker in de organisatie de talen configureren die u hebt ingeschakeld.`,
"label.dataimport.error.datetime":`Fout: Data en tijd formaat is onjuist`,
"label_tabpage_addcondition":`Voeg de voorwaarde toe`,
"label.query.detail.manageexcludeuser":`Beheer externe gebruiker`,
"label.tianyancha.creditcode":`Eengemaakte code voor sociaal krediet`,
"label.cy.enter":`Voer de omrekeningskoers van uw bedrijfsvaluta naar deze nieuwe valuta in.`,
"label.textmessage.vonage.message1":`Door de integratie met Vonage kunnen gebruikers tekstberichten verzenden en ontvangen op CloudCC Platform via Vonage. Gebruikers moeten echter Vonage-accounts registreren en telefoonnummers kopen voordat ze sms-berichten kunnen versturen.`,
"front-marketing-module-v1-share-invitation":`Uitnodiging aan het personeel`,
"label.file.items":`artikel(en)`,
"label.otherwise":`Anders`,
"label.permission.detail.system":`Systeem`,
"message.success.task.emailsend":`Opslaan en verzenden van e-mailbericht gelukt`,
"label.the.reward.group":`Quote Line Groep`,
"setup.layout.label.relatedlistsetup":`Verwante lijst Instellingen`,
"label.empty":`Duidelijk`,
"label.weixin.cloudcc.user.binding":`CloudCC gebruikersbinding`,
"label.file.what.change":`Wat is er veranderd?(optioneel)`,
"label.search":`Zoeken op`,
"label.mobile":`Mobiel`,
"template.report.month.potential.customer":`Leads van deze maand`,
"lable.setup.mobilesetup.isEnableValidationRulesForScan":`Validatieregels inschakelen bij gebruik van Scan`,
"lable.outlook.list.des":`Exchange Sync-configuratie definieert de instellingen voor CloudCC for Exchange die op een specifieke gebruikersgroep van toepassing moeten zijn.`,
"label.appupload.install.error.info":`{0} "{1}" is gebruikt door {2}, hernoem de bestaande {0}.`,
"label.tabpage.addoptionsz":`Opties toevoegen`,
"label.arabian.standard.time":`Arabië Standaard Tijd`,
"label.thefirst":`De Eerste Kolom`,
"label_partner_workspace_login_footertext":`Tekst voettekst`,
"lable.Disabled.successfully":`Deactiveer succesvol.`,
"label.confirm.del":`De hangende goedkeuring records, weet u zeker dat u ze wilt verwijderen?`,
"vue_label_normal_reregister":`Opnieuw inloggen`,
"label_file_img":`Afbeelding`,
"label.salescloud.salesdashboard.sales.behavior":`Verkoopactiviteiten`,
"label.startdate":`Begindatum`,
"label.field.duplicate.error.msg5":`Controleer alle fouten hieronder, probeer opnieuw na aanpassing.`,
"setup.main2018.label.managesetup":`Administratieve instellingen`,
"label.forecast.editshrepage.title":`Nieuw Delen`,
"UG.solution.01":`Bied de oplossing`,
"label.knowledgebase.data.recovery.successfully":`Herstel {a} gegevens met succes`,
"label.pc.ui.2018.myccchat":`Mijn CCChat`,
"label.attachement":`Opmerkingen`,
"message.mobilechooseatmostten":`Selecteer tot 10 velden`,
"label.campagin.roi.bhzeywjh":`Totaal Kansen`,
"label.autoresponserule":`Auto-antwoord regels`,
"label.attendance.yuyue":`U heeft geen afspraak, meld u nu aan.`,
"label.insert":`Invoegen`,
"label.service.ganttBaiduMap.shutDown":`Wil je sluiten?`,
"label.icon.194":`TV`,
"message.serviceterritory.violation":`Zoneovertreding: de zone van de middelen komt niet overeen met de dienstzone van de afspraak.`,
"label.appointment.disable.function":`Uitschakelen Functie`,
"lable.currencyManage.manageexchangeRate.dis":`Om gedateerde wisselkoersen voor uw organisatie te beheren, klikt u op Gedateerde wisselkoersen beheren. Gedateerde wisselkoersen worden gebruikt in opportunities, opportunityproducten en de rapporten die aan deze twee objecten zijn gekoppeld.`,
"vue_label_file_upload_tip_newmsg":`Minder dan {size} MB bestand wordt aanbevolen om te uploaden, anders kunnen er trage laadproblemen ontstaan.`,
"label.event.next.week":`Volgende week`,
"label.datamanage.import.contactfield":`Selecteer in de volgende tabel de velden in het geïmporteerde bestand die in elk contact moeten worden geïmporteerd. Klik dan op Volgende:`,
"label.projectManagement.time.allocated":`Toegewezen tijd`,
"label_tabpage_isdeleteview":`Weet je zeker dat je dit uitzicht wilt verwijderen?`,
"label.pc.ui.2018.search":`ZOEK...`,
"label.role.createrolelevel":`Creëren van de Rol Hiërarchie`,
"label.tabpage.editview":`Weergave bewerken`,
"label_partner_common_manageSetup":`Beheerinstellingen partnercloud`,
"label.service.gantt.noservice.resource":`In het geselecteerde servicegebied werden geen beschikbare dienstmiddelen gevonden.`,
"message.numbertoolarge":`Het aantal is te groot`,
"label.sendsms.success":`De tekst is succesvol verzonden`,
"UG.opportunity.009":`Of`,
"label.ccpeak.construction.dataobj":`om een dataobject te bouwen, moet de API-naam van het object worden doorgegeven in`,
"front-lighting-module-v1-detail-file-uploadInfo":`Het record is vergrendeld en niet beschikbaar voor het uploaden van bestanden. Neem contact op met de beheerder om het te deblokkeren.`,
"label.import.page2.newnotmatchfiled":`Een totaal van {{ csvfiledlength }} velden in het bestand. {{this.csvfiledlength - this.selectlength}} niet in kaart gebracht.`,
"label.ems.inputmailss":`E-mail server ontvangen`,
"label.knowledgebase.data.published.successfully":`{a}Gegevens succesvol publiceren`,
"label_emailtocloudcc_position":`Positie`,
"label.data.exp.customexp":`Aangepaste export`,
"component_chatter_post_button_user":`Mensen toevoegen`,
"label.new.visualpagefolder":`Aangepaste pagina : Nieuwe map`,
"label.forecast.shrepage.classdes":`Beschrijving van toegangsniveaus`,
"label.task.overdue.unfinished":`Achterstallige onverwerkte taken`,
"label.ccchat.micropost.isedit.setting.info":`De auteur van het bericht of commentaar, de eigenaar van het record, de CCChat moderator, en de moderator van deze gemeenschap hebben allen toestemming om deze tekst te wijzigen.`,
"label.recordname":`Recordnaam`,
"label.posted_your":`en geplaatst in uw`,
"label.globaloperation.operationtype.custom.page":`Aangepaste pagina`,
"label_tabpage_busoppnamez":`Naam zakelijke mogelijkheid`,
"front-epwechat-module-v1-schedule-desc":`Synchroniseer WeCom schema's en CloudCC evenementen`,
"label.escalation.setup.newentries.lastmodifydate":`Gebaseerd op laatste wijzigingstijd`,
"setup_layout_label_nofield":`Geen beschikbare velden`,
"label.sendemail.registIMUser.logininfo":`Het partner cloud portaal waar u kunt inloggen ziet er als volgt uit:<br>`,
"label.weixin..xsld.kehu":`Rekeningen`,
"label.display_thank":`Toon dank u pagina`,
"label.group.no.my.group":`Er zijn geen overeenkomsten met mijn groep.`,
"label.partnerCloud.newBuildSite.enterDomain":`Voer de domeinnaam in`,
"label.step1.total2":`Stap 1 van 2`,
"label.ccpeak.delete.record":`Wis de records:`,
"label.customer.tab.step1.introduce":`Kies het aangepaste object voor dit nieuwe aangepaste tabblad. Vul andere details in.`,
"label_tabpage_newInterfacez":`De nieuwe interface`,
"setup.mainpage.label.manageuser":`Gebruikers beheren`,
"label.partnerCloud.partnerAccount.completed":`Betaling voltooid?`,
"label.projectManagement.kanban":`Taak Kanban`,
"label.operate":`Actie`,
"label.service.dispatchingUnits.selected.time.range":`Toon service-afspraken binnen het geselecteerde tijdsbestek.`,
"component_setup_label_pagesize":`Cijfers op elke pagina`,
"font-evaluate-module-v1-email-evaluation-settings":`Instelling email evaluatie`,
"label.service.dispatchingUnits.skills":`Vaardigheid`,
"label.editrecurrencetimetrigger":`Periodieke tijdrigger bewerken`,
"vue_label_file_edit_lib":`Bestandsbibliotheek bewerken`,
"label.campaignmember.selectmember.deleteconc":`Campagne: leden uit contacten verwijderen`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.monday":`Maandag`,
"front-detail-module-v1-by":`door`,
"label.mobile.home.page.date.signed":`Sluitingsdatum`,
"label.apply.send.success":`Succes met verzenden.`,
"label.app.choseimg":`Logo kiezen`,
"label.customsetting.visible":`Zichtbaarheid`,
"label.sendemail.activity.task.distributetaskcompleted":`De taak die je hebt toegewezen aan #belongtoidccname is voltooid.`,
"label.dashboard.snapshot.refreshing":`Verfrissend`,
"label.document.name.already.exists":`Deze unieke documentnaam bestaat al.`,
"label.ccchat.person.invite.needlastname":`Vul uw achternaam in`,
"pagecreator_page_button_copy":`Kopiëren`,
"label.appointmentpage.wizard.subtitle1-2":`Vorige week`,
"label.validate.function.funcFormat.MILLISECOND":`MILLISECOND(datum)`,
"label.profile.allowtocreateview":`Creëer uitzichten`,
"message.error.recordid":`Record id kan niet leeg zijn`,
"lable.SalesCommitmentKanBan.returnToTheSuperiorRole":`Terug naar superieure rol`,
"label.translation.start3":`Indien nodig, selecteer een object. Bijvoorbeeld, een workflow taak heeft een object (Account, Contact, enz.) om te filteren op vertaalbare termen.`,
"label.ccpeak.send.email":`Stuur een e-mail om op te merken:`,
"vue_label_commonobjects_detail_activity_noexpirationdate":`Geen vervaldatum`,
"label.permission.objectpermission.objpermission":`Object Toestemmingsinstellingen`,
"label.version.custom.report":`Standaardrapporten (aangepaste pagina)`,
"label.title.qrcodeOrbarcode":`Genereer streepjescode/QR-code`,
"label.emailtocloudcc.step2.name":`Configuratie van e-mail eigendom`,
"label.reportsSubscription.edited.successfully":`Bewerk verslag abonnement succesvol!`,
"label_tabpage_kanbansetup":`Viewboard setup`,
"label.tianyancha.regcapital":`Geregistreerd kapitaal`,
"front-epwechat-module-v1-web-single":`Web Single Sign On:`,
"label.visualpage.display.top":`koptekst weergeven, false - koptekst niet weergeven`,
"label.customfields.fielddependency.selectcell":`Kies ten minste één cel uit de onderstaande lijst`,
"label.paging.addmember.totalofpages":`Een totaal van {0} item(s)`,
"label.email.saveing":`Gegevens worden opgeslagen...`,
"label.userinfo.doublepwd.notnull":`U moet uw wachtwoord herhalen.`,
"label.appointment.wizard.subtitle4-4-2":`2 weken`,
"label.chatter.BCC":`Bcc (blind courtesy copy)`,
"label.emailtocloudcc.description":`Sluit uw zakelijke e-mailaccount aan, zoals sales@company.com, info@company.com, support@company.com. Log automatisch ontvangen e-mails als leads en cases in CloudCC om tijdige opvolging van klantenbrieven te verzekeren.`,
"label.sendemail.send.atlastone":`U moet ten minste één ontvanger kiezen.`,
"label.mobile.phone.subordinate":`Betrek de ondergeschikten`,
"label.data.choses.e_desc":`Afhankelijk van uw behoeften kunt u alle gegevens exporteren of gegevens van een object.`,
"chatter.new":`Nieuws`,
"vue_label_help_back":`Terug`,
"label.skipwizardintro":`De Jump Start Wizard creëert voor u een goedkeuringsproces in één stap, in slechts enkele minuten.`,
"label.weixin.fmu.before.week":`{0} week(en) vooruit`,
"label.sendemail.chat.praiseFeedsubject":`CloudCC CCChat vond je bericht leuk`,
"lable.currencyAdv.andafterdate":`en na`,
"label.sometoprocess":`Als alleen bepaalde soorten records aan dit goedkeuringsproces moeten deelnemen, voert u die criteria hieronder in. Bijvoorbeeld, alleen onkostennota's van werknemers op het hoofdkantoor mogen dit goedkeuringsproces gebruiken.`,
"label.campaignmember.main.updateleaddesc":`Update alle leads status in een keer`,
"label_partner_common_roleSetup":`Partner cloud rol- en gebruikersinstellingen`,
"label.console.step5.no":`Kies hoe records worden weergegeven`,
"label.salescloud.teamrole.optionlist.account":`Voeg lid van account team toe aan`,
"Report.Delete.Confirm.Title":`Gelieve te bevestigen`,
"label.onclick":`Klik op`,
"label.weixin.input.identifying.code":`Voer de verificatiecode in`,
"label.knowledge.translate":`Alleen kennisartikelen van de hoofdeditie in de status Ontwerp of Gepubliceerd kunnen worden vertaald.`,
"label.log.ip":`IP`,
"front-electronic-export-goResult":`Check in Mailchimp`,
"label.escalation.setup.newaction.otheremail.otheremail":`Extra e-mails`,
"label.icon.104":`Schema`,
"label.partnerCloud.exceedTwo":`De geüploade profielfoto mag niet groter zijn dan 2MB!`,
"label_tabpage_thevalurofz":`De waarde van`,
"front-lightning-module-v1-details-page-chart-maximum":`Er kunnen maximaal 50 tekens worden ingevoerd.`,
"label.data.downpage.i.title.num6":`Het wordt aanbevolen dat u een testbestand met 5 records importeert voordat u de gegevens importeert, om er zeker van te zijn dat de gegevens die u wilt importeren juist zijn.`,
"label.ccpeak.update.record":`Records wijzigen`,
"label.dataimportandexport":`Importeren en exporteren van gegevens`,
"label.tabpage.notexceed25":`De geselecteerde plaat mag niet meer dan 25`,
"label.starting":`In uitvoering`,
"label.knowledge.language.spanish":`Spaans`,
"label_emailtocloudcc_set":`Mailbox-informatie instellen`,
"message.oneormoreneedsreport":`dashboard gebruik dit rapport. Verwijder de referentie instrumentenpaneel assemblage voor het rapport, en probeer het dan opnieuw.`,
"label.attendance.xccheckin":`Inchecken`,
"label.emailmerge.editfolder.title":`Mail Merge Sjabloon Mappen`,
"template.report.year.customer":`Leads van dit jaar`,
"label.partner.common.webSit.memo":`Standaard domeinnaam van partner cloud van uw organisatie:`,
"label.partnerCloud.financeSetting.onlinePayment":`Online betaling`,
"Pagelayout.Setup.001":`Selecteer de gerelateerde lijsten die getoond moeten worden op de hover lay-out.`,
"front-kefu-moudle-time-length":`Duur`,
"label.deleteObject":`Object is verwijderd.`,
"label.setup.mobile.homepageshortcuts.select":`Selecteer 4 snelkeuze opties om te tonen op het bovenste gedeelte van de __ homepage`,
"setup.mainpage.label.welcome26":`Gegevensbeheer - Batchverwerking`,
"label.ServiceCloud.yuyuebainhao":`Service Afspraak Nr.`,
"label.emailobject.emaildetail.button.addtolead":`Toevoegen aan Leads`,
"label.event.single.view":`Single User View`,
"lable.product.pricebooks.ustand":`Kies standaard prijs`,
"label.emailtocloudcc.department":`Afdeling`,
"component_assistant_label_30daysnoact":`30 dagen zonder campagne`,
"label.weixin.no.pending.qzkh.qin":`Sorry, geen aanwijzingen om te laten zien.`,
"label.vlidaterule.formula":`Foutvoorwaarde Formule`,
"label.tianyancha.h5.contact":`Contact informatie`,
"label.button":`Knoppen`,
"message.checkemail":`<strong>Fout:</strong> er is een fout in uw ingevoerde e-mail, gelieve te controleren.`,
"lable.account.previous.CY":`Vorige CY`,
"label.icon.13":`Dienst`,
"chatter.coll.c":`Bladwijzer verwijderen`,
"label.knowledge.category.hint.four":`Toewijzing gegevenscategorie`,
"label.tianyancha.phonenumber":`Telefoon`,
"label.tablayoutedit.remark":`Selecteer de velden en aangepaste pagina's die op het tabblad startpagina worden weergegeven.`,
"label.shareusers":`Delen naar gebruikers`,
"label.endtime":`Einde`,
"label.length":`Lengte`,
"label.umeng.activity.event.begin":`beginnen na`,
"label.tabpage.alltabs":`Alle tabbladen`,
"label.exact.query":`Verbeterde Lookups`,
"label.weixin.skip":`Ga naar`,
"label.ems.cancel":`Annuleren`,
"label.trigger":`Triggers`,
"label.exchange.sync.setting":`Exchange Sync Setup`,
"label.product.pricebooks.name":`Prijs Boek Naam`,
"label.relation.list.total":`Geselecteerd`,
"label.step2.total7":`Stap 2 van 7`,
"label.martrixreport.2018.step6.new":`Stap 6 Selecteer het grafiektype en het markeerpunt`,
"label.standard.buttonandlink.override":`Override Breedte`,
"front-console-conversation-btn4":`Afzonderlijk als nieuwe zaak`,
"vue_label_dashboard_range":`bereik`,
"label.app.sort.show":`De toepassing wordt weergegeven in de opgeslagen volgorde.`,
"label.salescloud.teamrole.choose.correct":`Duplicate gebruikers geselecteerd, gelieve te corrigeren`,
"label.schedule_post":`Publiceer bericht`,
"front-kefu-moudle-server-request-num":`Service Request Lijst Nr.`,
"label.h5.logout":`Log uit.`,
"label.weixin.horse.club.member.message":`Aid-Max leden informatie`,
"label.field.addoptionlist.introduce":`Voer hieronder een of meer keuzelijstwaarden in, met elke waarde gescheiden door een nieuwe regel.`,
"setup_layout_label_setupfield":`Veld eigenschappen`,
"label.chatter.nextStep":`Volgende stap`,
"label.quickbooks.searchlist.total1":`Er zijn {0} niet-gekoppelde facturen voor een totale waarde van {1}`,
"label.tianyancha.h5.regcapital":`Geregistreerd kapitaal`,
"label.icon.184":`Advies`,
"label.dashboard.message.refreshtoomush":`De dashboard momentopname wordt te vaak ververst, ververs deze later`,
"label.umeng.approval.reject":`#goedkeurder heeft uw goedkeuringsverzoek afgewezen #obj.`,
"label.h5.chatter.newmessage":`Voer een nieuw bericht in`,
"message.error.relationid":`relatieid kan niet leeg zijn!`,
"label.setup.mobile.offlinecache.selectdefault":`Selecteer de tabbladen als standaard offline cache tabbladen`,
"label.setup.mobile.homepageshortcuts.saveprompt":`Selecteer 4 vlugge functies.`,
"label.projectManagement.Selectmonth":`Kies maand`,
"label.version.ultimate":`Ultieme Editie`,
"label.validate.remark5":`De verplichte datumvelden staan in de juiste volgorde, bijvoorbeeld: de begintijd moet korter zijn dan de eindtijd`,
"label.version.nowis":`Uw huidige CloudCC-versie is`,
"front-kefu-moudle-CRM-set":`CRMinstellingen`,
"label.mr.title.customerAddress":`Rekening Adres`,
"label_emailtocloudcc_step1_name":`Kies Functie`,
"label.time.operation.edit":`Geplande taken wijzigen`,
"label_tabpage_operationz":`Veld, operatie kan niet leeg zijn`,
"label.translation.start4":`Dubbelklik in de vertaalkolom om nieuwe waarden in te voeren.`,
"vue_label_systemSettings_request":`Verzoek om overdracht van een batch`,
"label.maintenance.notice":`Kennisgeving van onderhoud`,
"label.customfields.txet.textlength.tip":`Vul hieronder de maximale lengte voor een tekstveld in En de maximale lengte is 255 tekens.`,
"label.ccdocument.select.template.open":`Selecteer het sjabloon om te openen.`,
"vue_label_display_date_field":`Toon Datum Velden`,
"label_partner_workspace_tab":`Tab`,
"lable.account.LasthDays":`Laatste 120 dagen`,
"chatter.using.sticker":`Feed traceren inschakelen`,
"message.save.dataerror":`Fout: fout bij het opslaan door lange datalengte of andere problemen. Wijzig de gegevens om opnieuw op te slaan.`,
"vue_label_commonobjects_view_chart_newchart":`Nieuwe kaart`,
"label.chat.micropost.a.group":`Groep`,
"lable.currencyManage.advcurrencyunEnabled":`Geavanceerd valutabeheer is niet ingeschakeld`,
"label.appexchange.workflow":`Werkstroom Regels`,
"vue_label_calendar_show_details_and_add_events":`Details tonen en gebeurtenissen toevoegen`,
"label.salescloud.optionlist.inputname":`Voer de naam van de keuzelijst in`,
"label.dashboard.folder":`Mappen`,
"label.knowledgebase.permanently.remove.articles":`Het verwijderen van een gearchiveerd artikel zorgt ervoor dat andere relevante versies ook permanent worden verwijderd.`,
"label.emailtocloudcc.titel":`E-mail naar CloudCC`,
"label.visualpage.sel":`Aangepaste pagina's in deze map`,
"label.planned.all.work":`Alle geplande banen`,
"label.weixin.agree.agreement":`Instemmen met de betreffende overeenkomst`,
"label.forecast.customforecast.qsn":`Beginjaar`,
"label.appupload.managed":`Gecontroleerd`,
"template.report.folder.sale.index":`Analyse van verkoopindicatoren`,
"UG_opportunity_011":`Transactie importeren`,
"label.validate.function.funcFormat.SECOND":`TWEEDE(datum)`,
"UG_homepage_005":`Verkoopinformatie`,
"label.clicktoreturn":`Klik hier om terug te gaan`,
"label.collectionofview":`s View Sets`,
"com.cloudcc.login.error.message.nonuser":`Uw id bestaat niet`,
"vue_label_systemSettings_emailsetting":`Email instellen`,
"vue_label_email_mark_as":`Markeer Als`,
"label.tabpage.customernamez":`Naam klant`,
"label.appupload.install.apicannotsame":`De nieuwe api-naam kan niet dezelfde zijn als de oorspronkelijke waarde`,
"label.task.all.undealt":`Alle achterstallige onverwerkte taken`,
"front-lightning-module-v1-dashborad-statistical-indicators":`Statistische index`,
"UG.quota.02":`Veranderingskans-fase`,
"label.approve":`Goedkeuring van`,
"vue_label_calendar_remove_calendar":`Kalender verwijderen`,
"label.mr.title.contactName":`Naam contactpersoon`,
"label.projectManagement.resource":`Beheer van de middelen`,
"label.rejectbehaviour1":`Sta de goedkeurder toe om handmatig terug te kiezen naar stap nummer.  (terug naar vorige stap N)`,
"label.publicgroup.relationship":`Lidmaatschap van de groep`,
"Lead.Scoring.DetailedPage.Popup.Title":`Leidend Inzicht`,
"label.owner.edit":`Eigenaar bewerken`,
"label.campaign.channel.ticket.mark":`OPMERKING: Sla de QRcode op in het fotoalbum met behulp van de schermafbeelding van de mobiele telefoon of sla deze op in de mobiele telefoon en voer de campagne in met de QRcode.`,
"label.opportunity.setting.showstage.info":`Of kansstadium op de CloudCC app moet worden getoond.`,
"label.emailobject.wizard.desc3":`Bespaar tijd door e-mailsjablonen te gebruiken`,
"label.cpq.quote.no.product.add":`Geen producten toegevoegd in de offerte. Gelieve producten toe te voegen alvorens orders te genereren.`,
"label.customer.tab":`Aangepaste tabbladen`,
"Opportunity_Detailed_Phase_Label_Popup_002":`Sluitingsdatum van de huidige fase`,
"component_telerecord_label_name":`Namen`,
"label_component_helper_nodata":`Niets heeft uw aandacht nu nodig. Kom later terug.`,
"label.dashboardSetup.d2":`Breekpunt 2`,
"setup.mainpage.label.welcome4":`Instructies: Klik op het menu aan de linkerkant van de pagina → Application Settings → Create → Object.`,
"label.step4.total5":`Stap 4 van 5`,
"label.payment.the.remaining.days":`Uw licentie verloopt over {0} dagen`,
"label.encoding":`Codering`,
"label.setting.intergrationlist.status2":`Deze integratie is momenteel geïnstalleerd.`,
"label.new":`Nieuw`,
"label.search.searchsetup":`Zoek Instellingen`,
"label_tabpage_printz":`Afdrukken`,
"report.type.label.customService":`Klantenondersteuning`,
"label.notification.addEmailObject.message":`U heeft een e-mail ontvangen van {!fromaddress}, klik om meer details te zien`,
"label.icon.68":`Machine`,
"UG.Lead.003":`Sociaal`,
"label_mobile_default_field_service_home":`Service Cloud Homepage`,
"label.select.one.group":`Kies ten minste één quote line groep.`,
"front-kefu-moudle-trkey-nopower":`Tianrun's sleutelpaar heeft geen toegewezen rechten`,
"label.chatter.cancel":`Annuleren`,
"label.weixin.report.optiondisplay":`Toon`,
"front-kefu-moudle-v1-System-version":`Systeemversie:`,
"lable.product.pricebooks.editall":`Alles bewerken`,
"label.group.no.recent3":`of`,
"label.knowledge.article.delete":`Fout bij het verwijderen van het kennisartikel.`,
"label.relateobj":`Gerelateerd aan`,
"workflow.action.tasks.assignortype.type":`Type`,
"label.layout.selectedfields":`Geselecteerde Velden`,
"label.role.assign.operate":`Andere gebruikers aan deze rol toewijzen:<ul><li>Klik op de vervolgkeuzelijst om alle beschikbare gebruikers weer te geven.</li><li>Selecteer een gebruiker in de linker lijst "Beschikbare gebruikers" en voeg deze toe aan de lijst "Geselecteerde gebruikers".</li></ul>`,
"label.field.insert":`Veld invoegen`,
"label.icon.11":`Mensen`,
"label.group.no.recent4":`een groep beginnen.`,
"front-epwechat-module-v1-input-corpid":`Voer alstublieft Corpld in`,
"setup_object_field_dependency_label_actionfieldnotnull":`Selecteer eerst een controlerend veld.`,
"setup.mainpage.label.welcome19":`Instructies:  Klik op het menu aan de linkerkant van deze pagina → Beheer Instellingen → Beheer Gebruikers → Gebruikers, Rollen, Profielen`,
"label.escalation.setup.list.rulename":`Regel Naam`,
"label.ems.addaccount":`Nu account toevoegen`,
"label.reportsSubscription.details.only":`Alleen details (Excel-formaat .xlsx)`,
"vue_label_commonobjects_view_groupby":`Groep per`,
"label.email.form.text":`Alleen tekst`,
"label.weixin.loginname":`Inlognaam`,
"label.forecast.settings.sr":`Inkomsten`,
"label.chatter.sendEmailToGroupMember.subject.F":`{0} gepubliceerde berichten voor alle in {1}`,
"label.ccchat.enter.subject":`Voer het onderwerp van de stemming in`,
"label.customer.tab.introduce":`Aangepaste Object-tabbladen zien eruit en gedragen zich als de standaardtabbladen die met CloudCC worden geleverd.`,
"message.login.mfaverification.wrong":`Beveiligingscode fout.`,
"component.newrecords.label.name":`Naam`,
"label.salescloud.opportunity.addandedit.contactrole":`Rollen voor contactpersonen toevoegen en bewerken`,
"label_emailtocloudcc_button_next":`Volgende`,
"label.console.step5":`Stap 5 Kies hoe de records worden weergegeven`,
"setup.main2018.label.norole":`U hebt niet de administratieve rechten`,
"template.chart.ywjhqd":`Zakelijke Mogelijkheid Stadium`,
"label.instrumentPanel.breakpointOneLabelname":`Deze waarde moet groter zijn dan de minimumwaarde.`,
"label.qrcode":`QR-code`,
"label_tabpage_no2z":`No2`,
"label.log.search.date.range":`De cyclus van een zoekopdracht kan niet langer zijn dan {c} maanden.`,
"label.console.step7":`Stap 7 Profiel toewijzen`,
"label.australian.central.standard.time":`Australische centrale standaardtijd （Northern Territory）`,
"label_tabpage_deleteviewfailed":`Weergave verwijderen mislukt`,
"vue_label_commonobjects_view_searchview":`Zoeken in deze weergave`,
"message.error.object.notexists":`Object bestaat niet.`,
"label.tablecell":`Cellen`,
"vue_label_notice_edit_success":`Succesvol bewerken`,
"label.customer.language":`Standaard taal`,
"label.csrf":`Activeer csrf Beveiliging`,
"label.forecast.customforecast.submit.zhi":`naar`,
"label.sso.saml.idp.config.desc2":`Klik op Enable Identity Provider (Identiteitsprovider inschakelen) om uw CloudCC.com-organisatie als identiteitsprovider in te schakelen.`,
"label.export_data":`Gegevens exporteren`,
"component.todaytask.label.all":`Bekijk alle`,
"label.h5.chatter.record":`Track record`,
"front-vew-email-verification":`Bekijk email en verifieer account. U kunt pas inloggen nadat u de email heeft bevestigd.`,
"laber.marketsea.del.error":`De lead pool is bezet en kan niet worden verwijderd`,
"vue_label_notice_homepage_entername":`Voer de gewijzigde naam in`,
"UG.Forcast.01":`Voorspelling`,
"front-email-payment-tips":`Het factuurbedrag is leeg. Gelieve de online betaling te starten na het invullen van het factuurbedrag.`,
"setup.mainpage.label.welcome2":`Aangepaste databank (object)`,
"APPIntegration.Social.facebookerror":`U moet een geldige URL voor facebook.com invoeren`,
"label.profile.mobile.setup.stand":`Standaard startpagina`,
"label.custom.CY":`Aangepast jaar`,
"label.knowledgebase.publishing.conditions":`Pulish {a} data mislukt, ze zijn van de publicatie criteria af!`,
"label.tianyancha.description":`Stel TianYanCha in staat om de industriële en commerciële gegevens te verifiëren. Deze dienst ondersteunt de bedrijfsgegevens geregistreerd op het vasteland van China.`,
"label.appexchange.uninstallpage.title":`Verwijder het pakket will:`,
"label.currencyRate":`Omrekeningskoers`,
"setup_layout_label_areashow":`Sectiekop weergeven Aan`,
"label.setup.case.setting":`Mini Programma aan Geval`,
"vue_label_commonobjects_view_fixed_at_most":`Er kunnen hooguit drie kolommen worden vastgesteld`,
"template.report.month.income":`Inkomsten van deze maand`,
"label.sms.companyname":`Bedrijfsnaam`,
"label.sendemail.registIMUser.waitmessage":`Helaas, u heeft geen partner cloud portal waarmee u kunt inloggen. wacht even, onze beheerder zal u later op de hoogte brengen. u kunt naar het opgegeven adres gaan om op de inlogpagina te komen. gebruik de gebruikersnaam en wachtwoord hierboven om in te loggen.`,
"label.custom.field.task.object":`Een aan u toegewezen taak. Taak iemend:`,
"message.pleaseselectdayinweek":`Gelieve een dag van de week te kiezen.`,
"label.chat.topic.favorites":`Bladwijzer`,
"UG.Campaign.004":`Campagne importeren`,
"label.approval.preview":`Procesvoorbeelden`,
"label.knowledgebase.assign.articles.to.people.or.queues":`Kies doeltaal en wijs artikel toe aan betrokken persoon of wachtrij. Vertaalexport wordt meestal toegewezen aan een wachtrij, en intern vertaalde artikelen gaan naar een persoon.`,
"pagecreator_systemstyle_message_save_success":`Stijl succesvol opgeslagen`,
"label.outline":`Schets`,
"label.read.only.field":`Alleenlezen Velden`,
"front-gantt-module-v1-early-warning":`Vroegtijdige waarschuwing`,
"label.file.ccchat.selectfrompc":`Selecteer een bestand op uw computer`,
"vue_label_systemSettings_social":`Sociale media`,
"label_report_year_last_year":`Jaar op Jaar`,
"lable.PowerProcess.Meet.the.conditions":`Aan de volgende criteria moet worden voldaan:`,
"label.changemydisplay.list.title":`Weergave`,
"UG_Forcast_03":`Begin met het plannen en uitvoeren van bedrijfsstrategieën. <br>Ik wens u een voorspoedige toekomst!`,
"label.sendemail.chat.sendmessage":`Beste #naam:hallo! #gebruikersnaam heeft u een bericht gestuurd.`,
"label.huanxinconfig.secretid.lost":`secretid kan niet leeg zijn`,
"label.icon.49":`Stroomopwekking`,
"chatter.feed.button.publish":`Deel`,
"label.power":`^Power`,
"label.partnerCloud.financeSetting.informationThree":`3. Nadat u de beheerpagina voor geheime sleutels hebt geopend, klikt u op mapi Gateway Product Key, en verkrijgt u partner ID en MDS geheime sleutel.`,
"label.emailtocloudcc.step1.lead2":`Eenmaal geconfigureerd, zullen mails die in deze mailbox worden ontvangen automatisch worden gelogd als lead records in CloudCC. Zorg ervoor dat er geen deals worden gemist.`,
"label.knowledgebase.delete.draft.succeeded":`Succesvol ontwerp verwijderen`,
"label.dashboardSetup.title":`Component-editor`,
"label.trigger.operation.email.template.map":`Terug naar sjablooninformatie, Onderwerp e-mail: m.get("subject"); Inhoud e-mail: m.get("context"); Of type e-mail tekst is: m.get("istext")`,
"label.dependencesearchfilter":`Gerelateerde Lookup Filters`,
"label.selected.search.length":`Niet meer dan 10 geselecteerde zoekvelden`,
"label.profile.commonusercontrol":`Algemene gebruikersmachtigingen`,
"lable.Microsoft.YaHei":`Microsoft YaHei`,
"label.appupload.component.type.app":`App`,
"label.customsetting.manage.position":`Locatie`,
"vue_label_systemSettings_bindweb":`Bind Web`,
"label.loginservice.license.notexist":`De licentie bestaat niet.`,
"label.icon.43":`Bells`,
"UG_homepage_003":`360 graden zicht`,
"label.file_format":`Bestandsformaat`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.sunday":`Zondag`,
"vue_label_chatter_post_has_delete":`Bericht is verwijderd`,
"report_label_searchresult":`Zoekresultaten`,
"label.tabpage.justsz":`Just`,
"Lead_Scoring_Setting_LevelSetting":`Leider Populariteit Instellingen`,
"setup.object.field.dependency.label.selectedfieldvalue":`Beschikbare veldwaarden`,
"label.search.morelistview":`Meer lijstweergave`,
"vue_label_homepage_won":`Gesloten`,
"label.notification.last30days":`Laatste 30 dagen`,
"vue_label_helpcenter_pool":`Gebruik de leadpool en de accountpool om uw verkoopgegevens te beheren.<br>Accountpool opzetten<br> Maak de accountpool op de achtergrond aan, stel de beheerders en leden van de accountpool in, en configureer de regels voor automatisch recyclen bij te late betaling, wat handig is om de opvolging van kansen binnen uw team te beheren en teamleden aan te moedigen actief opvolging te geven.<br>Manueel gegevens beheren<br> De beheerder van de account pool kan bewerkingen uitvoeren zoals distributie, recycling, weggooien en overdracht van records in de account pool, en de records in de account pool op een uniforme manier beheren;<br> Leden van de account pool kunnen niet-toegewezen records ontvangen of de records bekijken waarvoor zij verantwoordelijk zijn.`,
"label.emailsync.status.export":`Exporteren als Excel_csv formaat bestand`,
"label.service.miniProgram.slideshowTitle":`Carrousel`,
"label.service.miniProgram.slideshowName":`Carrousel Naam`,
"label.fieldupdate.selectobj":`Definieer het object dat gekoppeld is aan de veldupdate, klik dan op Volgende. Veldupdates kunnen alleen worden gekoppeld aan workflowregels en goedkeuringsprocessen van hetzelfde type.`,
"label.ccpeak.take.notice.sharetab":`Opgelet: voor de velden in de uitdrukking van het gedeelde formulier is de toevoeging "__c" niet nodig.`,
"label.log.startdate.after.endate":`De begintijd mag niet later zijn dan de eindtijd.`,
"label.rememberme":`Herinner Mij`,
"label.partner.all.maxNum":`Grootste gegevens van partern wolken:`,
"component.setup.iframe.label.inputurl":`Voer het url-adres in`,
"label.h5.systemmessage":`Systeem bericht`,
"label.delete.date":`Verwijder Datum`,
"front-email-payment-select-month-tips":`Gelieve MM te kiezen`,
"front-kefu-moudle-bind-userinfo":`Bind Gebruikersinformatie`,
"label.appointment.wizard.notif2":`您需要在创建日程预约前先设定好一个预约的时长`,
"label.custom.field.maping.number":`Het aantal voorloopcijfers kan niet groter zijn dan het aantal in kaart gebrachte veldcijfers.`,
"label.event.dayview":`Dag uitzicht`,
"label.replace":`Vervangen`,
"label.knowledgebase.search.knowledge.articles":`Zoek kennis artikel`,
"component_event_label_soon":`Onmiddellijk`,
"label.imgfield.upload":`Afbeelding uploaden`,
"message.printable.view":`Afdrukbaar Bekijken`,
"vue_label_notice_uploadavatar_notice1":`De grootte van de geüploade avatarafbeelding mag niet groter zijn dan 2MB`,
"label.visualpage.developer.help":`Hulp voor aangepaste pagina-ontwikkelaars`,
"label.validate.function.funcFormat.IF":`IF(logical_test, waarde_if_true, waarde_if_false)`,
"label.sso.saml.sp.description1":`Single Sign-On instellingen`,
"vue_label_calendar_step_1":`Stap 1: Geef de kalender een naam`,
"component.telerecord.button.save":`Save`,
"setup_mainpage_button_manageobject":`Objecten Beheer`,
"label.marketingactivityinfluence":`Invloed van de campagne`,
"label.quote.bjjsxx":`Informatie over aanvaarding van offertes`,
"label.appupload.upload.install.retry":`Installeer  opnieuw.`,
"label.layout.assignrules":`Regels voor de toewijzing`,
"UG.Lead.006":`Website bezoeker`,
"label.workmate.searchs":`Collega's zoeken`,
"label.visualpage_list.no":`Geen rechten voor toegang tot de aangepaste pagina's`,
"label.service.miniProgram.slideshowintroduce":`De naam van de carrousel wordt alleen gebruikt om meerdere advertenties te identificeren en wordt niet weergegeven in de advertentie.`,
"label.multilang.messagedetail.search.desc":`We kunnen geen bericht vinden met {0}:`,
"label.mobile.phone.read.note":`Vul hier de notities in`,
"label.passwordPolicy.setup.isUsingGotp":`Inschakelen secundaire verificatie`,
"message.datetypeerror":`<strong>Fout</strong> Ongeldige datum.`,
"label.searchlayout.listview.button":`Knoppen die in lijstweergaven worden weergegeven.`,
"label.sectionpart":`Sectie`,
"label.partnerCloud.basicSetting.userSetting":`Rollen en gebruikers instellen`,
"System_Data_Import_Warning_MaxCount":`Uw organisatie kan slechts {0} gegevens per keer importeren, dat is nu buiten de limiet, gelieve aan te passen en opnieuw te importeren.`,
"label.datamove.qualified.record":`gekwalificeerde record(s), kan elke keer 100 records overdragen op zijn hoogst`,
"component_task_label_priority":`Prioriteit`,
"vue_label_report_me":`Ik`,
"label.college.duplicate.option":`Opties kunnen niet worden herhaald!`,
"label.pw.letter":`Brieven`,
"label.file.sharedwithme":`Gedeelde met mij`,
"label.translation":`Vertalen`,
"lable.currencyAdv.exchagecurrency.before":`en voordat`,
"label.file.share":`Deel`,
"label.page.next":`Volgende`,
"label.autoRegister.changepwd.setpwd.notmatch":`Twee wachtwoorden zijn inconsistent`,
"label.tabpage.include":``,
"front-email-payment-thanks":`Bedankt`,
"vue_label_help_helponthispage":`Hulp op deze pagina`,
"label.approvepagelayout":`Lay-out goedkeuringspagina`,
"vue_lightning_help_zero_distance_communication":`De online ondersteuning zal u helpen tijd te besparen door contact op te nemen met de service-experts van CloudCC zonder enige afstand.`,
"vue_label_normal_case_sf":`Zaak`,
"label.report.line.tuozhuai":`Sleep of dubbelklik om de rapportkolom te selecteren en de volgorde aan te passen`,
"template.dashboard.management":`Operationeel beheer`,
"label.customcomponent.params.info.n1":`De waarde "args" van de "args" in de "component" tag is in "json" formaat, bijvoorbeeld: args="naam:'zhang',leeftijd:26", In cc code blok, gebruik: String myName = naam; int myAge = leeftijd;`,
"lable.SalesCommitmentKanBan.signedCommitmentRate":`Aantal ondertekende toezeggingen`,
"label.add.status":`Status toevoegen`,
"label.loss.customers":`Gesloten / Rekening verloren`,
"vue_label_chatter_involving_me":`Betrokken`,
"label.update.input":`Corrigeer de invoer alstublieft`,
"label.import.step1.commonobj":`Algemene voorwerpen`,
"label.appupload.upload.tips.document":`Opmerking: documenten in "mijn persoonlijke mappen" en "sjablonen rode mappen" kunnen niet aan het pakket worden toegevoegd, noch kunnen ze in deze lijst worden weergegeven.`,
"label.appupload.install.complete":`Compleet`,
"label.console.edit":`Console bewerken`,
"setup.object.field.dependency.label.removefromlist":`Verwijder geselecteerde waarden`,
"label.textmessage.groupsms.no.phone":`Geen telefoon`,
"label.account.Current.and.NextFQ":`Huidig en volgend FQ`,
"label.sso.saml.sp.idtype.userid":`Assertie bevat de gebruikers-ID van het object Gebruiker`,
"label.data.import.setup.operate.update":`Bestaande records bijwerken, geen nieuwe records invoegen`,
"front-kefu-moudle-v1-jcaws-call-serve":`Call Center geïntegreerd met AWS (Amazon Web Service) om uitgebreidere SaaSdiensten aan te bieden`,
"label.version.bacheditordel":`Massaal bewerken/verwijderen/overdragen`,
"lable.even.higher":`Hoger`,
"label.datetime.error":`Datum formaat is onjuist`,
"vue_label_commonobjects_detail_customer_hierarchy":`Klantenhiërarchie`,
"label.startuploadfile":`Start Uploaden`,
"label.appointment.wizard.subtitle3-1":`Maandag`,
"label.weixin.relevance":`Geassocieerde Kans`,
"label.datamanage.field.mapping.information":`Instelling veldtoewijzing`,
"label.brief.lastweek":`Vorige week`,
"label.nextstep":`Volgende stap`,
"label.listtoshow":`Een lijst van zowel actieve als inactieve goedkeuringsprocessen voor {0} wordt hieronder weergegeven.`,
"label.partner.ishave":`Fout: domein bestaat al`,
"label.service.miniProgram.name":`Vul de naam in.`,
"label.view.filterbyaddition":`Filter op extra velden (optioneel):`,
"label.projectManagement.nodata.task":`Geen gegevens voor taken. Laten we taakinformatie toevoegen!`,
"label.chooseemailtemplate":`Selecteer e-mail sjabloon`,
"label.page.step4.add.profile":`Stap 4 Toevoegen aan profielen`,
"label.ems.mailtype":`Soort post`,
"label.weixin.no.pending.projects.vg":`Goed werk, geen hangende goedkeuring items`,
"label.tabpage.saveviewfailed":`Beeld opslaan mislukt`,
"label.chat.file.upload.cancel":`Annuleren`,
"com.cloudcc.login.error.message.notenabled":`Uw id niet ingeschakeld`,
"label.data.import.setup.operate.insertandupdate":`Bijwerken van bestaande records en invoegen van nieuwe records`,
"label_target_type":`Type doel`,
"label.notification.event2":`【被分配人】 het door u toegewezen evenement bekeken`,
"chatter.feed.menutype.feed.news":`Wat ik volg`,
"label.import.page1.suitedwayofcustomer":`Klant passende stijl`,
"label.import.page2.CloudCCfiled":`CloudCC-veld`,
"label.custom.quarter.start":`Aanvangsdatum aangepast kwartaal`,
"label.page.including.tab":`Inclusief tabbladen`,
"label.mobile.phone.day.plan2":`Vandaag`,
"template.report.lead.conversion.statistics":`Conversiestatistieken van Leads`,
"label.show.type":`Vertoningstype`,
"label.weixin.no.pending.wdgz.qin.week":`Geen werk gepland voor deze week.`,
"2018UI.Homepage.DataDeleted.Info":`De gegevens die u wilt bekijken zijn verwijderd, klik a.u.b. om terug te keren naar de vorige stap.`,
"label.vlidaterule.message":`Foutmelding`,
"label.approval.remark":`Goedkeuring Advies`,
"label.field.duplicate1":`Uniek`,
"label.batchtransfer":`Massa overdracht`,
"label.quickbooks.view.allinvoices":`Alle facturen`,
"vue_label_commonobjects_detail_lead_selectedstatus":`Markeer als huidige status`,
"label_home_page_source":`Kies uw gegevensbron.`,
"front-kefu-moudle-v1-opencall-please":`Schakel het call center in en stel dan`,
"setup_layout_label_asc":`Oplopend`,
"label.use_tikect":`Toegangsbewijs gebruiken?`,
"label.tag.setup":`Tag Instellingen`,
"label.existinglayout":`Bestaande pagina-indeling`,
"label.productsales.today.noevt":`Er zijn geen open evenementen.`,
"message.error.view.date.validerr":`Voer het geldige datumformaat (JJJJ-MM-DD、MM/DD/JJJJ) of speciale datumtekens in`,
"label.mr.descreption.oneGroupReData3":`heeft te maken met de`,
"label.tianyancha.businessverify.msg1":`Met de functie voor de verificatie van commerciële gegevens ingeschakeld, moeten gebruikers de voorwaarden van deze "gebruikerslicentieovereenkomst" (hierna de "overeenkomst" genoemd) zorgvuldig lezen en volledig begrijpen, inclusief de vrijstelling van aansprakelijkheid van beijing shenzhou yundong customer co., ltd. (hierna te noemen "CloudCC") en de beperkingen van het recht van de gebruiker. lees het aandachtig en kies of u deze overeenkomst al dan niet aanvaardt.`,
"label.custom.CQ":`Aangepaste kwart`,
"label.version.custom.dashboard":`Standaard dashboards (aangepaste pagina)`,
"vue_label_commonobjects_detail_dragtoupload":`Sleep uw bestand hierheen, of <em>klik en upload</em>`,
"label.tabpage.addadvancedoptions":`Geavanceerde opties toevoegen`,
"front-kefu-moudle-v1-Launch-page":`Landingspagina:`,
"label.emailobject.tabname":`E-mail`,
"label.weixin.addmore":`Meer toevoegen`,
"message.error.view.operator.validerr":`Ongeldige operator`,
"label.another_page":`Doorverwijzen naar een andere pagina`,
"label.reportTypeFocusD2":`Voorbeeld: Als u rapporteert over "Contacten met Kansen met Partners", selecteer dan "Contacten" als het primaire object.`,
"label.icon.47":`Barometer`,
"label.task.today":`Vandaag`,
"label.service.gantt.weekend.highlight":`Markeer het Weekend`,
"label.customcomponent.referencetagname":`Tabblad Naam`,
"label.senderemail":`E-mailadres van de afzender`,
"label.defaultvalue":`Standaardwaarde`,
"label_tabpage_Sdfez":`dagen`,
"pagecreator.page.label.pagename":`Naam van de pagina`,
"vue_label_report_pagenumber":`Paginanummer in reeks`,
"label.emailsync.connectaccount.description":`Voeg hier uw persoonlijke mailbox toe, en CloudCC zal automatisch leads en contactpersonen in het systeem matchen op basis van hun e-mailadressen, en de inhoud van de e-mail synchroniseren met de records om tracering en communicatie te vergemakkelijken.`,
"label.schedulableprg.chooseweek":`Selecteer de datum van elke week`,
"lable.edit.queue.membercanuse":`Beschikbare leden`,
"lable.Quick.find":`Snelle blik`,
"label.daynuminmonth":`Dag(en) van maand(en)`,
"message.error.state":`staat kan niet leeg zijn!`,
"label.introduction.the.form":`Beschrijving`,
"label.batchtransfer.pleaseselectcomefromuser":`Overdracht van`,
"front-dashboard-module-implemented":`Gerealiseerd`,
"label.custombutton.newerror":`Nieuw gemaakt mislukt`,
"label.version.allow.size":`Overschrijd de limiet. Indien nodig, upgrade CloudCC versie.`,
"label.weixin.account.loginpage":`Inloggen pagina beveiliging account`,
"message.pleaseselectfieldtype":`Selecteer veldtype`,
"component.setup.label.parentobject":`Superieur object`,
"System.TAB.SeeViewAmount":`Bekijk Totalen`,
"label.event.lastmonth":`Vorige maand`,
"label.taskrecordtype":`Typen taakrecords`,
"label.layout.selectedpages":`Geselecteerde pagina's`,
"label.appointmentdetail.wizard.title19":`Zaterdag Plan`,
"label_chatter_endData":`Einddatum`,
"label.appupload":`Pakketten`,
"label.knowledgebase.article.link":`Gelinkt artikel`,
"label.licence.enddate":`Vervaldatum`,
"chatter.fieldtrack.record":`record`,
"label.reportsSubscriptionPage.schedulereport.weekly":`Wekelijks`,
"label.forecast.editshrepage.title2":`Delen Bewerken`,
"label.attendance.onwork.time":`Begin van de dag`,
"label.appointment.wizard.subtitle1-8":`3 h`,
"pagecreator.layout.button.upload":`Upload lay-out`,
"label.input.notless.than.number":`Voer een getal in groter dan of gelijk aan {0}`,
"setup.mainpage.label.welcome13":`Instructies: Klik op het menu bovenaan → Rapporten → Nieuw`,
"label.forecast.settings.data.opp":`Sluitingsdatum van de gelegenheid`,
"vue_label_display_checkbox_field":`Checkbox-velden tonen`,
"label.summaryreport.2018.step5":`Stap 5 Selecteer het grafiektype en het markeerpunt`,
"front-lightning-module-v1-dashborad-one-statistic":`Kies ten minste één statistische waarde en statistisch type`,
"label.home.standard.dashboard.forcase":`U mag geen voorspellingen doen en u kunt het dashboard voor verkoopverbintenissen niet bekijken.`,
"page.field.track":`Veld opsporingsgeschiedenis`,
"label.dataimport.format.datetime.error":`Formatteerfout, gebruik jjjj/MM/dd HH:mm:ss of jjjj-MM-dd HH:mm:ss.`,
"lable.opppdt.selPbk.title":`Kies Prijs Boek`,
"pagecreator_systemstyle_label_stylename":`Stijl naam`,
"label.projectManagement.nodata.project":`Geen verwante gegevens. Waarom geen aan mij gerelateerde projecten?`,
"label.start_below":`Begin met het delen van uw formulier met contacten. Uw formulier is veilig gepubliceerd en klaar voor gebruik op het onderstaande webadres.`,
"label.campaignmember.main.delete":`Massa verwijder campagne leden`,
"label.modifyall":`Alles wijzigen`,
"label.homepage":`Startpagina`,
"vue_label_pool_adoptedbyme":`Ik verzamelde`,
"label.email.clearItem":`Alleen E-mails zonder gekoppelde items worden gewist.`,
"label.callcenter.login.Amazon.connect":`Aanmelden bij Amazon Connect`,
"label.import.page1.selectimportfiled":`Selecteer het te importeren bestand`,
"message.error.id":`id kan niet leeg zijn!`,
"label.ggReleaseRange.searchUsers":`Zoek partner gebruiker`,
"label.changemypwd":`Verander mijn wachtwoord`,
"label.ccpeak.reference.parameters":`De parameters waarnaar rechtstreeks kan worden verwezen zijn:`,
"chatter.share.success.tip":`Succes! je hebt deze post gedeeld om`,
"label.message.checkfailed":`Syntax controle mislukt, de klasse naam bestaat.`,
"label.shangqing.introduction":`Integreer en analyseer de recente hot events van leads of klanten om verkopers te helpen klanten beter te begrijpen`,
"label.allemailnotice":`Alle e-mail waarschuwingen`,
"vue_label_report_copy":`Kopieer rapport`,
"label.exchange.sync.state.setting":`Configuratie-instellingen`,
"label.merge.result.error1":`Het volgende record is vergrendeld, en geen "merge" operatie is toegestaan`,
"label.process.des":`Klik op de link links om de details van het huidige record te bekijken.`,
"label.textmessage.vonage.create.lead.setting":`Nieuwe leads aanmaken bij ontvangst van sms'jes van nummers die niet in het systeem staan`,
"label.views":`Bekeken`,
"label.notification.tip1":`Geen kennisgevingen`,
"label.forecast.detailforecast.returnforecast":`Terug naar Voorspellingen`,
"label.knowledgebase.target.framework.name":`Naam doelkader`,
"label.brief.close.opportunities":`Gesloten-Win`,
"label.appointment.wizard.subtitle4-2":`De kortste tijd om je op te merken`,
"vue_label_systemSettings_set_record":`Stel de dispaly mode van gerelateerde lijst in, probeer te schakelen tussen Card Mode en List Mode.`,
"pagecreator_page_message_publish_fail":`Pagina publiceren mislukt`,
"vue_label_homepage_name":`Naam startpagina`,
"label.weixin.no.pending.wdgz.qin.month":`Je hebt deze week niets gepland.`,
"label.campagin.register.page":`Campagne Lid Registratie Pagina`,
"label.campaign.channel.edit":`Campagnes: Marketing Kanaal Bewerken`,
"label.folder":`Map`,
"label.umeng.chatter.follow":`volgde je.`,
"label.sso.theKeyToEdit":`Sleutel bewerken`,
"label.deletelayout":`Pagina-indelingen verwijderen`,
"label.same.analyze.miaoshu":`De relatie tussen bovenstaande voorwaarden is "Naam van de gelegenheid" of "Naam van de rekening" of "Mobiel contact" en "E-mail contact";`,
"label.ccpeak.sel":`Klassen in deze map`,
"label.tabpage.addtoworkbench":`Toevoegen aan startpagina werkbank`,
"label.forecast.shrepage.classdes.r":`Alleen lezen - Gebruiker kan voorspellingsgegevens lezen.`,
"homepage.custompagename":`Aangepaste homepage-naam`,
"label.sendemail.batchapprovalinfo":`Hallo #naam:de batch goedkeuring operatie die u uitvoerde was succesvol, met een totaal van #successnum succesvol goedgekeurd en #errornum mislukt.`,
"front-email-payment-Invoice-alipay-describe":`Veilige en betrouwbare betaling`,
"setup.object.field.dependency.label.configured":`Paginalay-outs toegewezen aan het profiel`,
"label.potentialcustomers":`Leads`,
"label.timetrigger.button":`De knop Tijd trigger toevoegen is niet beschikbaar in de volgende gevallen:`,
"label.category.10":`Advocaat`,
"label.selectall":`Alles kiezen`,
"message.field.id.not.null":`Het veld ID mag niet leeg zijn.`,
"CloudCCCRM.ST.Info.TypeIn.001":`Gelieve in te voeren`,
"label.author":`Auteur`,
"label.import.step1.csvonly":`1. Alleen csv formaat bestand wordt ondersteund, en tot {recordnumlimit} records kunnen worden geïmporteerd voor een keer. Tot 2.000 records kunnen worden geïmporteerd als u een trigger moet uitvoeren. Records die de limiet overschrijden zullen automatisch genegeerd worden door het systeem. Als u meer gegevens wilt importeren, splits ze dan eerst in meerdere bestanden en importeer ze op verschillende tijdstippen. .`,
"label.assignment.setup.newrule.name":`Regel Naam`,
"label.campaignmember.selectmember.chosestatusdesc":`Selecteer de campagne waar u leden aan wilt toevoegen, en bewerk de Campagne Lid Status. Maak een nieuwe campagne, u moet dit proces afsluiten.`,
"label_tabpage_operation":`Operatie`,
"label_tabpage_datatyoez":`Gegevenstype`,
"UG_product_04":`Creëer product`,
"label_emailtocloudcc_step1_case2":`Zodra dit is geconfigureerd, worden e-mails die in deze postbus zijn ontvangen automatisch geregistreerd als zaakrecords in CloudCC. Afhankelijk van de contactpersoon en account in de outbox, worden de zaken gekoppeld aan de corresponderende contactpersoon en account, zodat de acceptatie en het volgen van zaken wordt vergemakkelijkt.`,
"workflow.action.tasks.assignortype.role":`Rol`,
"vue_label_notice_refreshi_success":`Vernieuwen met succes`,
"label.notification.arketsea.abandon":`{5} weggegooid {2} {0}：{1}`,
"label.icon.36":`Computer`,
"chatter.group.cancelToJoin":`Annuleren om lid te worden`,
"label.publicgroups.edit":`Openbare groep bewerken`,
"message.duplication.label.letternum":`Passende tekenbits`,
"label.brief.lost.opportunities":`Lost`,
"setup.layout.label.nofield":`Geen beschikbare velden`,
"label.dataimport.isSharingRule":`Gedeelde regels afdwingen`,
"vue_label_opportunity_contactrole_synctocontacts":`Synchroniseer informatie naar contacten`,
"attachment_button_massdownload":`Massa Downloaden`,
"label.weixin.agreement.remark":`Deze WeChat-dienst is het hulpinstrument van de Aid-Max-adviesdienst aan klanten, het is niet de ultieme basis voor verzekeringsmaatschappijen om claims af te wikkelen, en de claims van klanten moeten worden afgewikkeld volgens de acturele vereisten van de verzekeringsmaatschappijen.`,
"label.partnerCloud.basicSetting.introTwo":``,
"pagecreator_layout_funcpath":`/ bouwer / lay-out bibliotheek`,
"label.ccdocument.online.edit":`Document online bewerken`,
"label.partner.setup.Enable":`Verifieer`,
"label.log.state":`Actie Status`,
"label.lower.bound":`Ondergrens`,
"label.timezone.isenable":`Schakel meerdere tijdzones in, laat de gebruiker de tijdzone instellen en geef datum en tijd weer volgens de tijdzone van de gebruiker.`,
"label.martrixreport.setrowtitle":`Kolomkopteksten specificeren`,
"label.bottom":`Bodem`,
"label.multilang.ccchat.groupnotcontainsname":`U bent geen lid van een campagnegroep met {0} in zijn naam`,
"label.step1.of.step5":`Stap 1 van 5`,
"message.report.error.FieldListIsAmbiguous":`Er is een formule ingediend werd verwezen in het rapport, dat een uitzondering veroorzaakt, verwijdert u de ingediend:&nbsp;`,
"label.monitorsys.operator.ip":`IP`,
"ccchat.fieldtrack.fieldchange":`Verander van {0} naar {1}`,
"label.report.export.print.content":`Exporteer huidige rapportkoppen, groepen en eerste 2000 records`,
"message.thanksusing":`Bedankt voor het gebruiken van CloudCC.com`,
"label.reportexport.allobject":`Alle objecten exporteren`,
"label.projectManagement.working.hours.per.day":`Dagelijkse werkuren`,
"label.partnerCloud.financeSetting.enterCollaborator":`Voer de ID van de medewerker in`,
"label.defineReportRecords":`Rapport Recordset definiëren`,
"greate":`groter dan`,
"label.sure_discard":`Ben je zeker dat je de veranderingen opgeeft?`,
"label.escalation.setup.newaction.notifyowner":`Informeer zaak eigenaar`,
"label.icon.28":`Dokter Hoed`,
"lable.PowerProcess.see.page":`Mijlpalen bekijken`,
"message.error.object.relogin":`Inloggen mislukt, probeer opnieuw in te loggen`,
"label.chatter.activity":`Activiteiten`,
"label.query.clone.detail.choose.canChoose":`Beschikbare lijnen`,
"chatter.using.object":`Schakel feed-tracking in voor objecten zodat gebruikers records van dat objecttype kunnen volgen. Selecteer velden om bij te houden, zodat gebruikers feedupdates kunnen zien wanneer die velden worden gewijzigd in records die ze volgen.`,
"UG.opportunity.001":`Hoe volgt u uw verkoop?`,
"label.ServiceCloud.fuwuziyuan.distributionMap":`Kaart van de verdeling van dienstmiddelen`,
"vue_label_email_current_email":`Het invoegen van dit sjabloon zal de huidige e-mail overschrijven`,
"label.h5.approval.page.layout":`U kunt de layout van de goedkeuringspagina instellen: <br>Instellen>Maken>Workflow&Approval>Approval Processen<br>selecteer goedkeuringsproces, klik op de goedkeuringsnaam<br>klik op Bewerken>Stel de Goedkeuringspagina Layout in`,
"component.hots.label.title":`Laatste aanbiedingen`,
"mail.foldername.notOnly":`Dit bestand bestaat al`,
"label.customer.tab.step1":`Stap 1 Vul de gegevens in`,
"label.delete.persion":`Verwijderd door`,
"chatter.changed0":`Verander {0} van {1} in {2}`,
"homepage.components.type":`Type component`,
"label.norfolk.isiands.time":`Norfolk Time`,
"label.product.pricebooks.view":`Prijs Boek Uitzicht`,
"label.forecast.customforecast.director":`Directe Ondergeschikten`,
"label.emailtocloudcc.step3total3":`Stap 3 van 3`,
"label.cloudccsite.end":`Inactieve Site Home Page`,
"label.login.verification.mfa.device":`Het virtuele MFA-apparaat verifiëren`,
"chatter.follow":`Ik wil  volgen.`,
"label.month's":`Maand`,
"label.sendmail.step1.introduce":`Selecteer hieronder een weergave die de ontvangers bevat die in deze e-mail moeten worden opgenomen.`,
"label.shangqing.title":`Instelling bedrijfsinformatie`,
"label.rejectrecords":`Afgewezen Records`,
"label.selectupdatevalue":`Waarde Veranderen van`,
"vue_label_pricebook_disabled":`Prijslijst is uitgeschakeld`,
"component.chatter.label.title":`Laatste bericht`,
"label.partner.all.workspace":`Werkruimte`,
"label.querydetailservice.delete.message":`Gegevens gewist of bestaan niet.`,
"label.objectRelationshipWithout":`met of zonder verwante gegevens`,
"nocontain":`bevat geen`,
"label.partnerCloud.financeSetting.accountSettings":`Partnerfonds instellen`,
"label.file.sharetype.owner":`Eigenaar`,
"label.open.multilingual":`Multitaal inschakelen`,
"label.searchresult.field":`Velden met zoekresultaten`,
"label.tabpage.selectdate":`Kies een datum`,
"label.h5.logouting":`Log uit.`,
"label.quickbooks.fieldlabel.payment":`Betaling`,
"label.chatter.leaveword":`Commentaar`,
"label.customfields.majoranddetailrelation.tip":`Maak een speciale ouder-kind relatie tussen dit object (kind of details) en een ander object (ouder of master), waarbij: <br>● de relatievelden voor alle detailrecords moeten worden ingevuld. <br>● Als de waarde van het relatieveld eenmaal is opgeslagen, kan deze niet meer worden gewijzigd. </li><br>● het eigendom en het delen van het detailrecord wordt bepaald door het masterrecord. </li><br>● wanneer de gebruiker de masterrecord verwijdert, worden alle details verwijderd. </li><br>● u kunt cumulatieve samenvattingsvelden maken op de masterrecord om detailrecords samen te vatten. </li><br>● In het relatieveld kan de gebruiker op het pictogram Zoeken klikken om een waarde uit de pop-uplijst te selecteren. Het primaire object is de bron van de waarde in de lijst. "`,
"label.batchapproveorrefuse":`Massa goedkeuren/afwijzen`,
"label.copy.success":`Succesvol kopiëren`,
"vue_label_show_record_count":`Toon Record Telling`,
"label.ems.delete.false":`Mislukt te verwijderen`,
"label.new.Product.Goals":`Doelstelling nieuw product`,
"label_chatter_BCC":`Bcc (blind courtesy copy)`,
"label.knowledgebase.data.archived.successfully":`{\a6} data archief succesvol`,
"label.chuangming.title":`Chuang Ming SMS`,
"label.notification.arketsea.recovery":`Uw {0}:{1} is gerecycleerd tot {2} door {5}`,
"label.partnerCloud.orderingPlatform.paymentAmount":`Bedrag van de betaling:`,
"label.martrixreport.2018.step5.new":`Stap 5 Kies rapportcriteria`,
"label.testing":`Controleren...`,
"chatter.poll.option4":`Keuze 4`,
"lable.outlook.detail.otc":`Uitwisseling naar CloudCC.com`,
"label.startuploadfile.batch.step2":`Stap 2 Klik op de "start upload" knop, bestanden uploaden`,
"lable.outlook.edit.outdes":`Voer de aangepaste velden in die u al in Exchange hebt aangemaakt. Alvorens dit aangepaste Exchange-veld aan een CloudCC.com-veld toe te wijzen, zal CloudCC.com het bestaan van het Exchange-veld bij de eerste synchronisatie controleren.`,
"hour":`Uur`,
"label.appointmentpage.wizard.notif4":`Ongeldig e-mail formaat`,
"label.import.index.state":`Status`,
"label.integrations.mailchimp.massage6":`De geselecteerde gegevens op de huidige pagina zullen kunnen worden geëxporteerd naar uw Mailchimp lijst`,
"label.file.share.email.subject":`#sharedBy heeft een bestand met je gedeeld op #orgname`,
"label.assignment.setup.newentries.noassignment":`Eigenaar niet opnieuw toewijzen`,
"label.dashboard.unit1":`Eenheid: 10,000`,
"label.forecast.customforecast.foretype.commit":`Vastgelegd`,
"label.type":`Type`,
"label.partner.workspace.login.logo":`Koptekst logo`,
"pagecreator_systemstyle_button_edit":`Bewerk stijl`,
"label.displaytype2":`Detail Pagina Knop`,
"email.one":`Beste gebruiker: \Welkom bij CloudCC. U heeft verzocht om uw wachtwoord te resetten op {!operatetime}, log alstublieft in met de verificatiecode hieronder binnen 15 minuten: \Willekeurige verificatiecode: {Klik op onderstaande link om uw wachtwoord te resetten: \Belangrijk: Als u dit niet heeft aangevraagd, of u denkt dat dit bericht u niet zou mogen bereiken, neem dan onmiddellijk contact op met uw beheerder!`,
"label.partnerCloud.orderingPlatform.unavailable":`Geen producten beschikbaar`,
"vue_label_email_save_the_signature_successfully":`Succesvol opslaan van de handtekening`,
"label.reportsSubscriptionPage.email.detailed":`Gedetailleerd`,
"chatter.group.query":`Vraag`,
"label.translation.unsupported.format":`Unsupported format, multi-languages import support only Property format`,
"message.operateexception":`Prompt (neem contact op met uw beheerder).`,
"label.sendemail.chat.praiseFeedcomment":`Beste #naam:hallo! #userName vond uw reactie leuk (#href).`,
"label.recycle.clearmy":`Leeg je prullenbak`,
"label_tabpage_choose":`Selecteer`,
"#label.importstep2tip":`Als u meer dan één bestand wilt uploaden, kunt u alle bestanden samenpersen en ze importeren.`,
"label.batchedit":`Mas bewerken`,
"label.integrations.mailchimp.export":`Exporteren naar Mailchimp`,
"label.cloudccsite.name":`Plaatsnaam`,
"serviceterritory.serviceappointment.iscontain.contain":`U kunt het servicegebied niet verwijderen omdat het gekoppeld is aan een serviceafspraak. U kunt dit servicegebied uitschakelen.`,
"label.sum":`Som`,
"setup.mainpage.label.welcome29":`Standaard API-integratie met producten van derden`,
"label.tabpage.nothingz":`Niets`,
"label.weixin.actual.contract.jine":`Werkelijk contractbedrag`,
"label.tabpage.emailaddressz":`Van? Adres`,
"label.dashboard.unit4":`Eenheid: 10 miljoen`,
"label.dashboard.data.labels":`Gegevenslabels`,
"label.import.page2.oneonone":`Eén CloudCC-veld kan slechts corresponderen met velden in één bestand.`,
"homepage.components.name":`Componenten Naam`,
"template.report.task.theme":`Taak Onderwerp`,
"component.setup.label.setupsaveok":`Componentinstellingen succesvol opgeslagen`,
"front-epwechat-module-v1-add-selfapp":`Seflcreatie app toevoegen`,
"label.to.save.the.current.page.information.button.":`Als u de informatie van de huidige pagina wilt opslaan, klik dan op de "Snel Opslaan" knop.`,
"vue_label_file_not_support_preview":`Het bestand ondersteunt geen preview, gelieve te downloaden en te bekijken`,
"label.object.reached.limit":`Het aantal objecten dat u kunt maken bereikt de bovengrens.`,
"label.partnerCloud.basicSetting.online":`Online betaling activeren`,
"label.app.step1.error.nameexist":`Deze groepsnaam bestaat al of is al eerder gebruikt. Gelieve een andere naam te kiezen.`,
"label.workflowandapprove":`Workflow en goedkeuringen`,
"label.recordtypeselect.change.tip":`Wanneer u het recordtype van een record wijzigt, worden de bestaande picklistwaarden niet automatisch gewijzigd. Het is aanbevolen dat u de bestaande picklistwaarden van de record op dezelfde plaats bijwerkt.`,
"label.summaryreport.step6":`Stap 6 Kies rapportcriteria`,
"Pagelayout.Setup.004":`Er kunnen maximaal 4 velden worden ingesteld`,
"label.file.attached":`Bijgevoegd`,
"front-invoice-online-payment-setup-configure":`Klik op "Nu configureren", Configureer {naam} Betalingsinterface.`,
"label.approvaldatamove.submitdate":`Datum ingediend`,
"label.emailobject.time.from":`Van:`,
"label.dataimport.insertdata.error.fieldrepeat.insert":`Het veld $schemefield_name$ in de record bestaat al in de database en wordt niet meer ingevoegd. De record is genegeerd import.`,
"assetbom.copy.notpermission":`U hebt niet de bevoegdheid om asset BOM te klonen. Neem contact op met de beheerder.`,
"lable.outlook.mcto.autoallocation":`Wijs ze automatisch toe aan gerelateerde CloudCC.com records.`,
"label.dataimport.but.datalength":`maar de lengte van de gegevens is`,
"label.setuserstocommit":`Specificeer met behulp van de onderstaande opties welke gebruikers het initiële verzoek ter goedkeuring mogen indienen.`,
"component_telerecord_label_related":`Aanverwante artikelen`,
"front-lighting-module-v1-detail-file-lockInfo":`Het record is vergrendeld en niet beschikbaar voor het toevoegen van bestanden. Neem contact op met de beheerder om het te deblokkeren.`,
"pagecreator_layout_button_edit":`Lay-out bewerken`,
"label.app.step3.tabcanuse":`Beschikbare tabbladen`,
"label.ems.delete.sure":`Ben je zeker dat je deze e-mail account informatie wilt verwijderen?`,
"label.email.show":`Toon`,
"label.checkbox.unchecked":`Niet geselecteerd`,
"message.error.operation":`Storing in de werking, neem contact op met de beheerder.`,
"label.template.set.folder.only.upload.type.file":`De rood gemarkeerde mappen in het sjabloon kunnen alleen worden gebruikt voor het uploaden van bestanden van het type Word, Excel en PPT.`,
"label.knowledgebase.select.publish.status":`Kies een publicatiestatus`,
"label.recordtype.tabname.edit":`Voer de nieuwe naam in voor het geselecteerde recordtype, en klik dan op "Opslaan"`,
"label.tabpage.exportview":`Weergave exporteren`,
"label.dataimport.insert.sharetab":`Kan geen formulier voor delen invoegen`,
"vue_label_dashboard_penetrateto":`Doordringen tot`,
"label.weixin.group.member":`Personeel`,
"vue_label_systemSettings_customadd":`Aangepaste uitbreiding`,
"UG_Account_03":`Proactief controleren en samenvoegen van dubbele rekeningen`,
"label.singapore.standard.time":`Singapore Standaard Tijd`,
"label.weixin.captcha":`Verificatie Code`,
"Account_News_Setting_004":`Enable Nieuws`,
"label_emailtocloudcc_select1":`Kies alstublieft`,
"label_ring_ratio":`Maand op maand`,
"label.industrialandcommercialverification.button.save":`Save`,
"label.approvalstep5.tip":`De goedkeuringspagina is waar de goedkeurder daadwerkelijk het verzoek goedkeurt of afwijst. gebruik de volgende opties om de bewerkingseigenschappen van de velden te selecteren die op deze pagina moeten worden weergegeven.`,
"label.import.page1.maxrecord{{30000}}":`1. U kunt {{30000}} records eenmaal importeren`,
"setup_object_layout_label_profileoptions":`Beschikbare profielen`,
"label.emailtemplate.type":`Type sjabloon`,
"label.searchlayout.tab.field":`Velden op de startpagina van het tabblad.`,
"chatter.news":`Berichten`,
"label.pw.small.letter":`Kleine letters`,
"label.notification.group3":`Uw aanvraag om lid te worden van de openbare groep werd afgewezen`,
"label.ccchat.day.before.yesterday":`Eergisteren`,
"component.chatter.post.label.title":`Publiceren`,
"label.tianyancha.type":`Type wettelijke vertegenwoordiger`,
"label.detail.searchlayout":`Bekijk Zoek Lay-out`,
"vue_label_pool_deleteconfirm":`Weet u zeker dat u de (1) geselecteerde record(s) wilt verwijderen?`,
"label.import.index.maxmb{{100}}，maxitem{{30000}}":`1. 2. Ondersteunt alleen csv formaat bestanden, de maximale ondersteuning is {{100}}mb, en een maximum van {{30000}} records kunnen eenmaal worden geïmporteerd; gelieve op te splitsen in meerdere bestanden en ze in fasen te importeren als de limiet wordt overschreden,`,
"label.h5.similar.opportunity.lookup":`Vind gelijkaardige mogelijkheden`,
"template.report.customer.list.opportunity":`Accountlijst met meer mogelijkheden`,
"component_setup_iframe_label_memo":`Klik op het instellingen icoon en voer het embedded url adres in.`,
"label.version.allemail":`Massa e-mail`,
"lable.product.editp":`Prijs Bewerken`,
"label.weixin.plate.number":`Plaatnummer`,
"font-evaluate-module-v1-disabled-successfully":`Evaluatieoptie "Neutraal" met succes uitgeschakeld`,
"label.multilingual.tip1":`Gebruik deze pagina om de taal van uw organisatie te definiëren.`,
"label.japan.standard.time":`Japan Standaard Tijd`,
"lable.product.notdel.use":`Verwijder pogingen, Omdat het nog steeds geassocieerd is met de volgende records.In dit geval, is het aanbevolen dat u uitschakelt.`,
"label.appointment.wizard.subtitle4-2-4":`4 h`,
"label.queue.edit":`Bewerken`,
"label.partnerCloud.financeSetting.informationTwo":`2. Klik in het Merchant Center op Accountbeheer  Merchantbeheer  Product PIDIKEY  Beheer geheime sleutel`,
"label.partnerCloud.partnerOrdering.permission":`Partner bestellen Toestemming`,
"vue_label_commonobjects_detail_company_hierarchy":`Bedrijfshiërarchie`,
"label.forecast.settings.sl":`Hoeveelheid`,
"label.partner.workspace.tab.memo":`Selecteer tabbladen voor deze partnerwolk. Zowel standaardtabbladen als aangepaste tabbladen kunnen worden geselecteerd.`,
"label.mr.mainRecord":`Master Record`,
"setup_mainpage_label_welcome20":`Mail, SMS sjabloon`,
"front-email-payment-select-date-tips":`Kies YY`,
"label.dependencelisttag":`Verwante Lijst Etiket`,
"label.umeng.activity.eventof":`gebeurtenis van`,
"label.sales.dashboard.collection":`Ontvangsten Doelstelling`,
"report_label_folder":`Mappen`,
"label.assignment.setup.newentries.step1":`Stap 1 Stel de volgorde in waarin deze regel zal worden verwerkt`,
"label.quote.shrname":`Naam ontvanger`,
"label.newreport.group.sum":`Het aantal groeperingen`,
"label.number.MinCheck":`Het minimum van {a} is {0}. Wijzig de hoeveelheid en sla de wijzigingen op.`,
"label.chatter.save":`Save`,
"vue_label_email_all_email_templates":`Alle e-mail sjablonen`,
"message.summaryconditionnototal":`Voorwaarde van Samengevat kan geen gebruik maken van Roll-Up velden!`,
"label.callboard":`Aankondigingen`,
"label.step2.total5":`Stap 2 van 5`,
"vue_label_homepage_custom_homepage_page":`Aangepaste startpagina`,
"label.data.newtemplate.e_seltype":`Selecteer de methode voor het exporteren van gegevens`,
"label.data.dataexpalltype.all.desc2":`2、Het duurt enige tijd om alle gegevens te exporteren. Wanneer de export voltooid is, ontvangt u een herinneringsmail dat de export geslaagd is.`,
"lable.account.CalenderYear":`Kalenderjaar`,
"message.error.data":`De doorgegeven gegevens kunnen niet leeg zijn, controleer de doorgegeven parameters`,
"label.from_user":`Van gebruiker`,
"label.parentdepartment":`Superieure afdeling`,
"template.dashboard.product.analysis":`Producten Analyse`,
"label.tabpage.unpacketz":`Geen gegevens over groepering beschikbaar!`,
"label.icon.107":`Communicatie`,
"label.monitorsys.operator.username":`Gebruikers`,
"label.serchreport":`Zoek Rapporten`,
"label.payment.upgrade":`Upgrade`,
"setup_layout_button_ok":`Bevestig`,
"label.please.select.channel":`Selecteer kanaal supervisor.`,
"template.chart.txdrw":`Taak Herinnering`,
"chatter.group.accept":`Accepteren`,
"pagecreator_systemstyle_message_canntdelete":`De huidige stijl is niet toegestaan om te verwijderen`,
"label_tabpage_ctbtsftcz":`Klik op de achterkant om de inhoud te zoeken`,
"label.datamanage.select.accountfield":`(Selecteer de velden die overeenkomen met de geïmporteerde rekening)`,
"label.schedulejob.setup.list.title":`Geplande taken`,
"label.visualpage_list.title":`Actieve toegang tot aangepaste pagina's`,
"label.mr.selectTwoData":`Selecteer ten minste twee records die moeten worden samengevoegd.`,
"label.customer.tab.step2.different":`Pas een verschillende tabbladzichtbaarheid toe voor elk profiel`,
"label.mobile.side.tab.can":`Beschikbaar`,
"label.log.url":`URI`,
"label.weixin.cloudccnumber.isgoon":`CloudCC account is gebonden, als u doorgaat, zal WeChat die eerder gebonden was aan dit CloudCC account niet in staat zijn om het micro CloudCC systeem te gebruiken. Wilt u doorgaan?`,
"label.applet.to.case":`Miniprogramma Klantenserviceportaal`,
"lable.outlook.detail.cmaping":`Kaart Contact Velden`,
"label.theUserActiveTime":`Actieve periode gebruiker`,
"label.event.moveup.9hour":`9 uur vooruit`,
"vue_label_pool_other":`andere`,
"label.fieldname":`Veldnaam`,
"vue_label_notice_add_success":`Succesvol toegevoegd`,
"label.conditiontag.lookup.insertbutton":`Geselecteerd invoegen`,
"label.identifying":`Identificatie`,
"label.tabpage.uploadingz":`Uploaden`,
"label.view.introduce":`Bewerken Bekijken`,
"vue_label_dashboard_sortingmethod":`Selecteer sorteermethode`,
"label.quote.number.introduce":`Voer het aantal en de kortingen in en klik op Opslaan.`,
"front-kefu-moudle-which-missphone-case":`Creëer gevallen waarvoor oproepen werden gemist`,
"label.sendemail.chat.response":`Antwoord van CCChat:`,
"label.productsales.refreshTime":`Laatste Update`,
"lable.SalesCommitmentKanBan.phase":`Stadium`,
"label.version.sum.object":`voorwerp(en)`,
"label.defineReportStep2":`Stap 2`,
"message.duplication.label.returnDuplications":`Terug naar de filterlijst voor ontdubbeling`,
"label.lookover":`Bekijk`,
"label.quickbooks.button.copy2":`CloudCC-details naar QuickBooks kopiëren`,
"label.checkbox.true":`Ja`,
"label.profilename":`Profiel Naam`,
"label.finalapproveoperate":`Definitieve goedkeuringsmaatregelen`,
"label.SMS.detailed":`SMS-waarschuwingen worden verzonden door workflowregels wanneer ze zijn getriggerd.`,
"label.lasttimemodifier":`Laatst gewijzigd door`,
"label.sso.summary":`Samenvatting`,
"label.customfields.encd.tip":`Hiermee kunnen gebruikers elke combinatie van letters en cijfers invoeren en opslaan in onversleutelde tekst die kan worden gecodeerd en doorzocht.`,
"vue_label_report_formulacolumn":`Formule kolom op rij-niveau`,
"vue_label_systemSettings_transfer":`Batch overdracht Records`,
"lable.product.ecm":`regel, vul het juiste bedrag in.`,
"label.partner.setup":`Partner cloud-instellingen`,
"label.same.analyze.miaoshu2":`functie`,
"label.mobile.phone.day.summary":`Dagelijkse samenvatting`,
"label.ccchat.person.error.illdomain":`Fout: onjuist ingevuld domeinformaat`,
"label.knowledgebase.edit.as.draft":`Bewerken als klad`,
"message.duplication.label.newfilterule":`Nieuwe Duplicaat en Overeenstemmende Regel`,
"vue_label_salesfunnel_notice1":`Samenvatting van de kansen`,
"label.partnerCloud.partnerAccount.order":`Bestelnr. :`,
"label.account.Current.and.PreviousFQ":`Huidige en vorige FQ`,
"label.customfields.formula.dateandtimeexample":`Volgende = NU() 1`,
"label.area.unassign":`Niet-toegewezen gebruikers`,
"label.at.my":`Inhoud die ik noemde (@)`,
"vue_label_calendar_notice_stopsharingfail":`Niet gestopt met delen`,
"label.data.file.validation.rules":`Uitvoeren van validatie regels`,
"label.escalation.setup.entrydetail.escalation.hour":`Uren`,
"vue_label_ccchat_notice_pleaseentercontent":`Voer de inhoud en opties in`,
"label.forecast.edit.error1":`Fout: Inactieve Valuta`,
"label_emailtocloudcc_exists1":`Deze mailbox is ingesteld op Email to Lead. Instellingen niet herhalen.`,
"label.trigger.send.email":`E-mailmeldingen via triggers`,
"label.setmysafetysignagain":`Reset mijn veiligheidsteken`,
"label.callcenter.pleaseenter.access.keyID":`Voer de geheime sleutel ID in`,
"chatter.poll.option10":`Keuze 10`,
"vue_label_systemSettings_mobelbottonsetting2":`Unified Bottom Menu Setup`,
"label.quickbooks.searchs":`Zoeken op`,
"label.section":`Segment`,
"label.customfields.fielddependency.new.tip":`Maak een afhankelijke relatie die ervoor zorgt dat de waarden in een picklist of multi-select picklist dynamisch worden gefilterd op basis van de waarde die de gebruiker in een ander veld selecteert.<ul ><li>Het veld dat de filtering aanstuurt, wordt het "controlling field" genoemd. Standaard- en aangepaste selectievakjes en keuzelijsten met ten minste één en minder dan 300 waarden kunnen controlerende velden zijn. </li><li>Het veld waarin de waarden worden gefilterd, wordt het "afhankelijke veld" genoemd. Aangepaste keuzelijsten en keuzelijsten met meerdere selecties kunnen afhankelijke velden zijn.</li></ul>`,
"label.customobjects.track.introduce3":`Opgelet: slechts een deel van de velden wordt getraceerd en "Bewerkt" zal getoond worden bij het traceren van velden.`,
"front-kefu-moudle-all-hidden-phone":`Verberg telefoonnummer wereldwijd`,
"vue_label_calendar_share_calendar_with_others":`Kalender delen met anderen`,
"label.case.copre":`Download Webportaal QRcode`,
"label.conditiontag.lookup.pagetitle":`Selecteer keuzelijst waarden`,
"UG.opportunity.004":`Type multiservice`,
"label.event.moveup.1day":`1 dag vooruit`,
"label.industrialandcommercialverification.enablestatus1":`Verificatie van industriële en commerciële gegevens mogelijk maken`,
"label.ccpeak.newrecord.getorpost":`Nieuw record: er zijn twee manieren om een CCObject te construeren met behulp van CCObject.`,
"frame.personinfo.label.resizeimage":`Als u aanpassingen wilt maken aan uw miniatuurafbeelding, sleept u de stippellijnen in uw profielfoto hierboven en past u de grootte aan.`,
"label.optional.searchresultfield":`Beschikbare zoekresultaatvelden`,
"UG.Contract.02":`Het contract is een schriftelijke overeenkomst tussen de partijen. Veel bedrijven gebruiken contracten om de voorwaarden voor het zakendoen met andere bedrijven vast te leggen. Gebruik CloudCC om uw bestaande contracten met uw klanten en zakelijke kansen vast te leggen en te documenteren. Volg het contract door het goedkeuringsproces. Gebruik workflow reminders om u te herinneren aan de contract rollover.`,
"label.group.activity":`Actieve groepen`,
"label.tabpage.characterz":`Beginnend karakter`,
"label.globalsearch.tip":`Voer de zoekinhoud in`,
"label.campaign.channel.download.size2":`Medium formaat: 500*500 pixels`,
"label.step3.total4":`Stap 3 van 4`,
"label.partnerCloud.payForFailure":`Betaling mislukt`,
"label.ggReleaseRange.editSuccess":`Succesvol bewerken`,
"label.summaryinforelyon":`Samengevatte gegevens per`,
"label.productsales.htyj":`Uitvoering van het contract`,
"label.newpagelayout":`Nieuwe pagina-indeling`,
"front-gantt-module-input-task-name":`Voer de naam van de taak in！`,
"label.c_d_without":`"C-registraties kunnen al dan niet verwante D-registraties hebben.`,
"label.licence":`Licenties`,
"setup.layout.button.selectall":`Alles kiezen`,
"label.app.step1.error.appnameexist":`Deze app naam bestaat al.`,
"label.cpq.quote.item.no.record":`Alleen bestelproducten met records kunnen worden overgebracht naar contracten.`,
"label.knowledgebase.noaffect.existing.translations":`Nee, mijn wijzigingen zullen de bestaande vertaling niet beïnvloeden.`,
"label.schedulejob.setup.schedule.editjob":`Geplande taak bewerken`,
"lable.PowerProcess.Tips":`Het aanspraakproces is een aanpasbare tijdlijn met alle stappen (mijlpalen) die de klantendienst en ander personeel kunnen ondersteunen om alle stappen te doorlopen om een ondersteunde zaak of werkorderrecord op te lossen. Nadat de opzet is voltooid, kan het worden toegepast op de aanspraak.`,
"label.campaignmember.selectmember.step2":`Stap 2 Selecteer de leden die u wilt toevoegen`,
"vue_label_calendar_stopsharing":`Ben je zeker om te stoppen met het delen van kalender`,
"vue_label_notice_savemenu_fail":`Menu opslaan mislukt`,
"message.error.getitems.id":`getItems: id kan niet leeg zijn`,
"label.return.currencylist":`Terug naar lijst: Valuta Beheer`,
"label.wtd.detail.p":`PC`,
"label.knowledgebase.publish.now":`Nu publiceren`,
"label.appupload.install.explain":`Installeer Instructies`,
"label.visualpage.folder.all":`Alle paginamappen`,
"message.passwordPolicy.validate.complexReq2":`Fout: Uw wachtwoord moet bestaan uit een combinatie van hoofdletters, kleine letters en cijfers.`,
"label.umeng.chatter.at":`vermeld je.`,
"label.mobile.phone.month.report":`Maandelijkse werkaantekeningen`,
"label.describableEditeSelectedFields":`Selecteer de velden die standaard in de rapportkolommen worden weergegeven wanneer u een nieuw aangepast rapport aanmaakt.`,
"component.event.label.subject":`Thema`,
"label.knowledgebase.edit.draft":`Klad bewerken?`,
"label.customer.tab.step1.selectoneobject":`Selecteer een bestaand aangepast object`,
"label_partner_step2":`Stap 2 bevestig sjabloon`,
"label_starting_annual":`Startjaar`,
"X":`Tekstgebied`,
"label.customer.tab.style":`Tabblad Stijl`,
"vue_label_commonobjects_detail_book":`Een standaard prijzenboek`,
"chatter.email.referredToMe":`Noemt mij in een bericht`,
"label.enable.both.barcode.qrcode":`Activeer streepjescode en QR code`,
"front-market-form-quired-choose":`Verplichte Velden`,
"noinclude":`uitgezonderd`,
"label.sms.template.select":`Selecteer het SMS sjabloon`,
"label.weixin.optionten":`Keuze 10`,
"message.duplication.label.matchlastletters":`Laatste N Tekens`,
"label.webtocloudcc.submit.success":`Succesvolle indiening`,
"label.sales.dashboard.number":`Nummer`,
"label.custom.field":`Map dit aangepaste veld`,
"label.dataimport.of.field":`gebied(en)`,
"label.view.new":`Nieuwe weergave maken`,
"UG_activity_03":`Reserveer een rooster`,
"label.customfields.image.tip":`Hiermee kunnen gebruikers foto's uploaden.`,
"label.startexport":`Start uitvoer`,
"vue_label_commonobjects_view_chart_verticalbar":`Verticaal staafdiagram`,
"label.ccchat.person.invite.allexist":`Iedereen die je uitnodigt, gebruikt al CCChat`,
"label.fielddependence":`Veldafhankelijkheden`,
"label.scan.tip":`Gebruik de browser IE7, IE8, Chrome of Firefox, en het is aanbevolen een resolutie van meer dan 1024.07768 te gebruiken.`,
"label.wei.weiactor":`Gestemd door`,
"label.service.miniProgram.quantity":`Er kunnen maximaal 20 carrouselrecords worden aangemaakt~`,
"vue_label_homepage_new_homepage_page":`Nieuwe startpagina`,
"label.apply.telphone.validate.error":`Verkeerd validatienummer.`,
"component.assistant.button.newevent":`Nieuw evenement`,
"System_TimeField_Format_Warning":`Ongeldige tijd`,
"chatter.feed.publishfeed":`Post`,
"label.setting.intergrationlist":`Integratie lijst`,
"label.object.prefix":`Object Voorvoegsel`,
"label.tippage.confirmed":`Ja, ik wil de aangepaste rapport gegevensbron en alle afhankelijke rapporten verwijderen.`,
"label_emailsync_form_signin":`Inloggen`,
"label.delete.cancel":`Undelete`,
"label.dashboard.myHomePage.des":`Selecteer het dashboard om te diaplayen in elke app.`,
"lable.account.FY.Ago":`2 FY Ago`,
"label.umeng.approval.reassign":`#goedkeurder heeft uw goedkeuringsverzoek opnieuw toegewezen #obj.`,
"label.data.exp.zippwd2":`Automatisch gecomprimeerd bestandswachtwoord genereren`,
"label.tabpage.contentz":`Gelieve inhoud in te voeren`,
"label.callcenter.batch.add.number":`Nummers toevoegen in Batch`,
"label.tabpage.deleteviewsuccess":`Bekijk verwijderen succes`,
"setup_layout_group_field":`Velden`,
"label.appupload.component.addobj.scheme.label.suoshu":`Object`,
"front-project-module-v1-market-is-template":`Markeren als sjabloon`,
"label.service.gantt.one.esource.types":`en een van de volgende brontypes`,
"label.emailtocloudcc.search":`Zoeken op`,
"label.mobile.home.page.myyj":`Mijn optreden`,
"vue_label_normal_invoice_sf":`Factuur`,
"label.permission.detail.app.fenpei.tip":`Geef aan welke toepassingen zichtbaar zijn in het toepassingsmenu.`,
"label.login.access.month":`Maand`,
"label_tabpage_retypez":`Wanneer het recordtype gewijzigd wordt, zullen de bestaande waarden van de optielijst niet automatisch gewijzigd worden. wij raden aan om de bestaande waarde van de optielijst van het record op dezelfde plaats bij te werken.`,
"label.ems.private.company.message":`Private cloud-versies bieden geen ondersteuning voor het online bewerken van de e-mailbox van het bedrijf.`,
"label.dataimport.length.check":`Lengte meer dan 18 bits, gelieve de plaat zorgvuldig te bekijken en aan te passen.`,
"label.batchtransfer.type1":`Overdracht van de openstaande kansen die niet toebehoren aan de huidige rekening eigenaar`,
"vue_label_calendar_are_you_sure_to_remove":`Ben je zeker dat je deze kalender wilt verwijderen`,
"label.icon.117":`Schooltas`,
"vue_label_systemSettings_downloadapp":`Download mobiele app`,
"label.approval.project":`Goed te keuren punten`,
"template.organization":`Organisatorisch niveau`,
"label.weixin.return.research":`Terug naar Detailpagina Micro-enquête`,
"label.ccchat.person.invite.addsay":`Voeg een optioneel bericht toe...`,
"UG.Case.02":`Cases stellen u in staat te reageren op accountproblemen en deze op te lossen. Cases zijn een krachtig record in Cloud CC dat niet alleen problemen met de account bijhoudt, maar ook een volledig overzicht van de account weergeeft.`,
"label_emailtocloudcc_step1":`Stap 1`,
"workflow.action.tasks.assignortype.owner":`Eigenaar`,
"label.data.import.page":`Ga naar de invoerpagina`,
"label.cache":`Cache`,
"label.custom.page.cuspage.width":`Breedte (Pixels)`,
"label.customcomponent.referencetag":`Referentie-etiket`,
"label.tabpage.search":`Zoeken op`,
"label.knowledge.searcharticle.casefields":`Velden van zaken voor het zoeken van voorgestelde artikelen`,
"setup_layout_message_relatedlistfield":`Selecteer velden die u in de verwante lijst wilt weergeven. U kunt ook de volgorde van de geselecteerde velden wijzigen.`,
"label.relationobject.type":`Verwant objecttype`,
"UG_Account_02":`Sommige bedrijven verlenen diensten aan andere bedrijven, andere werken rechtstreeks samen met eindgebruikers, en weer andere staan ten dienste van NGO's.`,
"UG_homepage_006":`360-graden zicht op de activiteit van uw account via enquêtes, live chats, e-mails, werkopdrachten, berichten op sociale media en zelfs verkoopactiviteiten (zoals leads, serviceondersteuning en activiteiten).`,
"chatter.poll.option1":`Keuze 1`,
"label.ccdocument.fieldforld":`Naam van de map waartoe de documenten behoren`,
"label.wei.result":`Resultaat`,
"label.recentview.new":`Nieuwste`,
"label.martrixreport.setsumfield":`Selecteer het veld dat u wilt gebruiken als de overzichtsrij in uw matrixrapport`,
"label.reportsSubscriptionPage.schedulereport.weekly.monday":`Maandag`,
"label.marketsea.button.recycle":`Recycleer`,
"label.standard.buttonandlink.info2":`Selecteer de aangepaste CloudCC.com-pagina om te gebruiken in plaats van de CloudCC.com URL voor deze standaardknop of -link.`,
"label.reportsSubscription.select.two.months":`Kies een datumbereik binnen twee maanden voor deze frequentie!`,
"label.standard.buttonandlink.page":`CloudCC Klassiek`,
"vue_label_commonobjects_view_chart_horizontalbar":`Horizontaal staafdiagram`,
"label.Remove":`Verwijder`,
"label.mobile.phone.receivable":`Betalingen`,
"label.appupload.uploaddetail.goback":`Terug naar pakket`,
"label.select.role":`Kies een rol`,
"label.file.sharetype":`Type aandeel`,
"label.app.chosetab":`Selecteer Tabbladen`,
"label.case.other.phone":`Ander telefoonnummer`,
"chatter.edit.cancel":`Uw wijzigingen zijn geannuleerd.`,
"label.html":`HTML`,
"message.auth2cn.acquisition.failed":`Mislukt om auth2cn te krijgen!`,
"message.error.system.service.permissiondeny":`Sorry, u mag deze dienst niet ontvangen, neem contact op met uw beheerder.`,
"label.chatter.mygroups":`Mijn groepen`,
"label.umeng.approval.approvalpass":`Goedkeuringsaanvraag voor de #obj is goedgekeurd. #objnaam`,
"label.chatter.owner":`Eigenaar`,
"vue_label_commonobjects_view_kanban_view":`Kanban Bekijken`,
"message.please.choose.group.role":`Selecteer de rol van de groep`,
"label.icon.136":`Valuta`,
"label_tabpage_selectdate":`Kies een datum`,
"chatter.emailInformation":`Algemene informatie`,
"front-lightning-module-v1-dashborad-bubble-size":`Bellengrootte`,
"label.stdashbord.xsld.business.wan":`myriade`,
"label.datamanage.field.notexist":`Het veld dat overeenkomt met het object bestaat niet.`,
"UG.Forcast.04":`Start proef`,
"UG.contact.02":`Contacten benaderen via meerdere kanalen, telefoon, e-mail, sociale media`,
"vue_label_pool_selecttransferinto":`Selecteer de lead pool om naar over te dragen`,
"label.quote.xingming":`Naam`,
"label.customerinfo.userlicencenum":`Gebruikerslicenties`,
"label.group.no.my.archived":`Geen overeenkomende gearchiveerde groepen gevonden.`,
"label.weixin.add.activity.tel":`Activiteit Oproep toevoegen`,
"label.partner.setup.address":`Partner cloud-adres`,
"label.data.file.i_title.num3":`3. Het systeem leest het gegevensbestand vooraf naar de server en start dan de back-end massa-importeur, waarvan de resultaten per e-mail aan de gebruikers zullen worden meegedeeld, zodat u niet op deze pagina hoeft te wachten.`,
"label_sum_up":`SUM`,
"label.searchall.title":`Globaal zoeken`,
"label.bind.chooseone":`Kies Eigenaar`,
"label.campaign.channel.input.owner.select1":`Huidige campagne eigenaar`,
"front-kefu-moudle-v1-Expand-chat":`Uitbreiden Chat Details`,
"label.component.hotdeal":`Laatste aanbiedingen`,
"component_event_label_title":`Komende evenementen`,
"No.planed.activity":`Geen geplande activiteit`,
"label.searchlayout.result.field":`Zoekresultaten Kolommen voor zoeken en taggen.`,
"label.leadscore.value":`Waarde`,
"vue.dashboard.linkage.is.set.successfully":`Koppeling succesvol opgezet!`,
"PersonalInfo.LoginHistory.001":`Broswer valideert de registratielink in uw mailbox`,
"front-gantt-module-v1-problem-number":`Probleem Nummers`,
"label.page.step5.of.step5":`Stap 5 van 5`,
"label.sendemail.chat.sendmessagesubject":`CloudCC CCChat bericht waarschuwing`,
"label.Linkedin_accounts":`LinkedInaccount`,
"label.qrcode.useful.life":`QR Code Vervaldatum`,
"deleterow":`Rij verwijderen`,
"label.forecast.settings.future1":`Toekomst 1 cyclus`,
"message.error.group.operation":`Fout in de archivering van de groep`,
"label_tabpage_loadz":`Pagina wordt geladen, even geduld...`,
"label.brackets.left":`(Open Parenthese`,
"label.source.code":`Broncode bekijken`,
"setup_layout_label_areasetup":`Sectie Eigenschappen`,
"component.assistant.label.todaylead":`De leads die vandaag aan jou zijn toegewezen`,
"label.qrcode_signin":`QRcode is beperkt tot toepassingen waarbij codes ter plaatse moeten worden gescand en aangemeld`,
"label.calendarshare":`Kalender delen`,
"IMG":`Afbeelding`,
"label.use.rule.when.both":`Pas deze regel toe wanneer u streepjescode en QR-code tegelijk inschakelt.`,
"label.ccpeak.addshare.record":`Nieuwe records gedeeld formulier:Recentelijk toegevoegde records`,
"label.enable.email.tracking":`E-mail tracering inschakelen`,
"label.top.plsinput":`Doorzoek deze lijst...`,
"vue_label_helpcenter_case":`Cases zijn vragen, feedback of problemen van klanten. Ondersteunende medewerkers kunnen cases bekijken om te begrijpen hoe ze betere service kunnen verlenen. Verkoopvertegenwoordigers kunnen cases gebruiken om de impact op het verkoopproces te begrijpen. Door te reageren op individuele cases kunt u uw klanten tevreden stellen en uw merkimago verbeteren.`,
"label.useonly":`Privé`,
"label.displaytype":`Vertoningstype`,
"label.most.user.group":`Gebruikers kunnen lid worden van maximaal 100 gebruikersgroepen, en u bent al lid van de 100e gebruikersgroep.`,
"label.umeng.activity.yourevent":`Uw evenement`,
"label.forecast.shrepage.classdes.w":`Lezen/Schrijven - Gebruiker kan voorspellingsgegevens bekijken en overschrijven.`,
"label.defaultaccess":`Standaard toegang`,
"label.partner.new.step2":`Stap 2 bevestig sjabloon`,
"component_setup_iframe_label_title":`Pagina aanpassen`,
"label.sso.saml.sp.idenitytype":`SAML Identiteitstype`,
"label.dashboard.this.folder":`Dashboards in deze map`,
"label.data.newtemplate.e.seltype.desc":`Er zijn twee soorten afgeleide gegevens</li><li class`,
"label.forecast.customforecast.submit.tip1":`Dien uw voorspelling in:`,
"label.version.workflow.and.approval":`Automatisering van workflow- en goedkeuringsprocessen`,
"label.tianyancha.tip":`De ingevoerde tekst is onjuist, gelieve opnieuw in te voeren!`,
"label.report_details":`Details van het verslag`,
"template.report.folder.contract.product":`Contract en productanalyse`,
"label.all":`Alle`,
"label.version.area.long.rich":`{0} rijke tekst of lange tekst gebied velden`,
"label.enc":`Gecodeerde opslag`,
"vue_label_pricebook_enterproductname":`voer de productnaam in`,
"label.edit.quote.line":`Quote-regel bewerken`,
"label.edit":`Bewerken`,
"M":`Master-Detail Verhouding`,
"front-kefu-phonenumber-exists":`Zitplaats nr.{a} bestaat al`,
"label.standardplatformuser":`Standaard Platform Gebruikers`,
"label.custom.page.configuration":`Aangepaste console-component bewerken`,
"url.error.contact.null":`Het adres van de Microservice is leeg.`,
"label.sethelp":`Help Instellingen`,
"setup.mainpage.label.welcome23":`Beveiligingsinstellingen`,
"label.sales.page.dashboard.fenxi":`Dashboards voor verkoopanalyse`,
"label.limit":`Toegang`,
"maintenanceasset.asset.contractlineitem.illegal":`U moet het goed op de contractregel selecteren voordat u de contractregel aan het onderhoudsgoed kunt koppelen.`,
"UG.contact.04":`Of`,
"Opportunity.Detailed.Phase.Label.004":`Dag(en)`,
"label.emailobject.receive":`Naar`,
"label.brief.new":`Recent Nieuw`,
"label.marketsea.button.adopt":`om te verzamelen`,
"label.select.up.to.three.fields":`Er kunnen maximaal drie velden worden geselecteerd.`,
"vue_label_allsearch_noresults":`We hebben gezocht met uw aangepaste zoekinstellingen, geen overeenkomend resultaat gevonden met {userInput}`,
"Report_CantDelete_Info":`{0} rapport is de gegevensbron voor het {1} dashboard en kan niet worden verwijderd!`,
"label.chile.summer.time":`Chili zomertijd`,
"label.partnerCloud.menu.selectedMenu":`Geselecteerd menu (aangevinkte menu's worden gesynchroniseerd met de app)`,
"vue_label_report_onlysummary":`Alleen samenvatting`,
"front-template-V1-Applicable-object":`Kies het toepasselijke object.`,
"label.invoice.message.sendfailed":`Factuur is niet verzonden, probeer het later nog eens`,
"front-kefu-moudle-v1-use-free":`GRATIS UITPROBEREN`,
"label.rule.updated.successfully":`Update de regels met succes`,
"label.owner.lastone":`Behoud ten minste één voorwaarde`,
"label.appointment.wizard.subtitle1":`Duur vergadering`,
"template.report.opportunities.closed.month":`Gesloten kansen van deze maand`,
"label.tabpage.choosecontent":`Selecteer de waarde-inhoud`,
"template.chart.jbnddxl":`Orderomzet in het afgelopen halfjaar`,
"label.fieldsecurity.detail":`Details veldbeveiliging`,
"label.knowledgebase.data.deleted.successfully":`{a} gegevens succesvol verwijderd`,
"label.sso.saml.idp.config.nameidfmt":`Naam ID Formaat`,
"label.emailobject.prompt":`Prompt`,
"label.marketsea.isgetbyself":`Sta leden toe zelf in te zamelen`,
"label.winxin.cancelprompt":`Weet u zeker dat u wilt afsluiten? Uw huidige operatie is niet opgeslagen.`,
"label.appexchange.installedpage.message2":`Apps en componenten worden geïnstalleerd in pakketten. Alle aangepaste apps, tabbladen en aangepaste objecten worden in eerste instantie gemarkeerd als "In ontwikkeling" en worden niet uitgerold naar uw gebruikers. Dit stelt u in staat om te testen en aan te passen voordat u ze uitrolt. U kunt de componenten individueel uitrollen met behulp van de andere functies in setup of als een groep door op Deploy te klikken.`,
"vue_label_import_importtype":`Type invoer`,
"label.data.importef.des":`Bestanden die niet konden worden geïmporteerd, worden gedurende 48 uur op de server bewaard en worden na 48 uur automatisch verwijderd.`,
"chatter.email.reply":`Reacties op mijn berichten`,
"label.stdashbord.xsld.business.sdl":`Verloren percentage`,
"labal.emailtemplate.namemessage":`De unieke naam van de e-mail template bestaat, gelieve opnieuw in te voeren.`,
"vue_label_email_Please_select_file":`Selecteer een bestand`,
"label.event.modify":`Gebeurtenis bewerken`,
"label.projectManagement.isnmber":`Voer een getal in met maximaal één decimaal.`,
"lable.outlook.detail.emailst":`E-mail instellingen`,
"label.partnerCloud.priceOfManual.isUsed":`Deze instelling bepaalt of partners dit prijzenboek al dan niet kunnen gebruiken voor bestellingen.`,
"setup_mainpage_label_welcome26":`Gegevensbeheer - Batchverwerking`,
"label.file.version":`Versie`,
"pagecreator_systemstyle_label_bordercolor":`Kleur rand`,
"label.approval.isallowed.reject.prompt":`Wilt u een afwijzing toestaan bij het goedkeuren van afzonderlijke gegevens? (Massa goedkeuring kan altijd worden afgewezen).`,
"label.myinfo":`Persoonlijke informatie`,
"front-template-V1-fontSize":`Lettergrootte`,
"lable.outlook.edit.alpreo":`Altijd Voorkeur Uitwisseling`,
"front-email-payment-card-number":`Kaartnummer`,
"label.cpq.quote.pricebook.no.change":`Zodra het prijsboek voor een offerte is vastgesteld, kan het niet meer worden gewijzigd. Gelieve 1 nieuw offerte record aan te maken voor het gebruik van een nieuw prijsboek.`,
"vue_label_file_size_limit_tip":`Bestandsgrootte overschrijdt limiet`,
"lable.PowerProcess.worktime":`Arbeidstijd van het proces van toekenning van rechten`,
"label.monthly.month.report":`Maandelijks YoY en MoM rapport`,
"front-kefu-moudle-v1-sydq-buyuser":`Uw spoor is te volgen. Koop de Easemob om gebruik te blijven maken`,
"label_tabpage_Rolesz":`Rollen en ondergeschikten`,
"chatter.f.n":`Volg deze plaat`,
"UG.Forcast.02":`Prognoses zijn ramingen van de verwachte verkoop voor een bepaalde periode, en prognosemodellen kunnen u helpen de vraag naar producten en de verkoopopbrengsten in een bepaalde periode te bepalen. Managers kunnen prognoses gebruiken om doelen te stellen en de voortgang van het team te meten. De algemene prognose van de organisatie kan een weerspiegeling zijn van de samenvatting van alle verkopen per verkoopvertegenwoordiger (ongeacht het stadium van voltooiing van de verkoop, van het stadium van de pijplijn tot het stadium van afgesloten verkoop).`,
"label.productsales.contract.phb":`Contract Lijst`,
"label.umeng.insert.approval.submit":`#aanvrager dient #obj in voor uw goedkeuring`,
"message.duplication.label.matchfirstletters":`Eerste N Tekens`,
"label.partnerCloud.partnerAccount.toPay":`Ga naar Betalen`,
"label.model.un":`Modelnr.: UN6786`,
"label.save.c1":`De naam van "Web To CloudCC" moet uniek zijn.`,
"week":`Week`,
"Pagelayout.Setup.003":`Het veld Naam moet worden geselecteerd`,
"label.query.detail.openpartnermessage":`Als de klant eenmaal is ingeschakeld als partner, verschijnt hij in de gefilterde rapporten en lijstweergaven op het veld ispartner. bovendien kunnen partnergebruikers aanmaken vanuit contacten die aan deze klant zijn gekoppeld. weet u het zeker?`,
"label.validate.function.funcFormat.DATEVALUE":`DATEVALUE(datum)`,
"label.apply.send.false":`Verzenden mislukt`,
"label.recordtype.edit.selectvalue":`Keuzelijst Waarden`,
"label.chosesubject":`Kies hieronder een onderwerp`,
"label.validate.function.funcExplain.YEAR":`Het jaar van de inleverdatum is een getal tussen 1900 en 9999`,
"component.chatter.button.more":`Zie meer details`,
"label.top.class.smallest":`Het minimumniveau van de hiërarchie is 1.`,
"label.startingvalue":`Startnummer`,
"label.multi.layout.remark":`Lay-out die van toepassing is op front Master-Detail Input en Mass Add`,
"label.role.availableuser":`Beschikbare gebruikers`,
"label.weixin.iebrowser":`De browserversie die u momenteel gebruikt is IE6, die in 2001 door Microsoft werd uitgebracht. Aangezien de browserversie te laag is voor CloudCC om met nieuwe technologie te worden ontwikkeld, is het niet gegarandeerd dat alle functies naar behoren worden gebruikt. Gelieve uw browser tijdig te laden en te updaten.`,
"Homepage_News_004":`Geen recent nieuws.`,
"vue_label_normal_task_sf":`Taak`,
"label.version.nonsupport.trigger":`Triggers worden voorlopig niet ondersteund.`,
"pagecreator_page_label_pagelayout":`Pagina-indeling`,
"label_tabpage_step3":`Stap 3 selecteer de weer te geven velden`,
"label.canOnlyUploadCSVFormatFile":`Upload alleen bestanden in CSV-formaat`,
"label.b.c.least":`Elke "B"-plaat moet ten minste één verwante "C"-plaat hebben.`,
"label.list.userinterface.sales.enable":`Verkooppagina leaderboards gegevens bekijken machtigingen inschakelen`,
"label.umeng.approval.approvalreject":`Goedkeuringsaanvraag voor de #obj is afgewezen. #objnaam`,
"vue_labenl_normal_notice_share_fail":`Delen mislukt`,
"label_emailtocloudcc_tip":`Prompt`,
"label.h5.touchselect":`Klik om te selecteren`,
"label.tabularreport":`Verslag in tabelvorm`,
"label.app.defaulttab":`Standaard tabbladen`,
"label.validate.function.category.Datetime":`Datum en tijd`,
"vue_label_pricebook_editdetail":`Prijslijstvermeldingen bewerken`,
"vue_label_commonobjects_view_no_selected_record":`Geen record geselecteerd`,
"chatter.changed":`Gewijzigd`,
"label.asset.bom.based":`Genereer asset BOM volgens de productstructuur van de order`,
"label.appointmentdetail.wizard.title8":`Begin in elke`,
"label.area.query.user.error":`De gebruikersgegevens die overeenkomen met het opgevraagde gebied zijn mislukt, en de gebied-ID was leeg.`,
"page.field.masterinput":`Master-Detail Ingangsinstellingen`,
"chatter.selads":`Selecteer ontvangers`,
"label.data.exp.please.savebutton":`Vink "Opslaan als sjabloon" aan.`,
"label.members.activity":`Campagne leden`,
"label.weixin.click.searchs":`Klik om record te zoeken`,
"label.input.least.two":`Voer ten minste twee tekens in`,
"label.marketing.seting":`Marketing cloudinstellingen`,
"label.approveprocess.tip":`Goedkeuringen zijn complexe bedrijfsprocessen waarvoor informatie moet worden verzameld en gepland voordat ze kunnen worden geïmplementeerd. Het wordt aanbevolen dat u de onderstaande instructies volgt voordat u aan de slag gaat.`,
"front-email-payment-Invoice-login-account":`Inloggen Account`,
"label.selectmulti.mes":`Te veel ontvangers geselecteerd.`,
"label.workflow.gotolist":`Terug naar lijst: Workflow`,
"label.profile.fieldsafety":`Beveiliging op veldniveau`,
"front-project-module-v1-no-selectemplat":`Geen beschikbaar sjabloon`,
"label.sendemail.queue.assigntitle":`De e-mail van wachtrij toewijzen object notificatie`,
"label.approval.mobile.comments.placeholder":`Geef hier een reactie van maximaal 1000 woorden`,
"vue_label_report_given":`specifiek`,
"vue_label_dashboard_groups":`Gelieve een groep te kiezen`,
"label.service.gantt.popoverTip":`Reisafstand/reistijd`,
"label.mr.title.characters":`Volgens de lengte van de tekens`,
"label.passwordPolicy.setup.day":`dagen`,
"label_tabpage_personvisible":`Zichtbaar voor het betrokken personeel`,
"ct":`Multi-valuta`,
"label.chatter.newEvent":`Nieuw evenement`,
"vue_label_systemSettings_id":`Inloggen Identiteit`,
"label.page.preview.web.tab":`Voorbeeld webtab`,
"label_emailsync_button_sure":`Bevestig`,
"front-template-V1-Modification-time":`Wijzigingstijd`,
"vue_label_homepage_edit_fixed_components":`Bewerk vaste componenten`,
"label.apply":`Solliciteer`,
"Main.Menu.Mobiledownload":`GA OP`,
"vue_label_salesfunnel_notice6":`Het totale aantal kansen met een waarschijnlijkheid van 100%`,
"label.chosesubject.sendemail":`Stuur e-mail`,
"label.changemydisplay.chagetab.des":`Kies de tabbladen die in elk van uw apps zullen worden weergegeven.`,
"label.attendance.setting.checkUser":`al bestaat in andere aanwezigheden.`,
"label.list.projectSetting.setup":`Project Management Instellingen`,
"label.app.introduce2":`U kunt bestaande apps aanpassen aan de manier waarop u werkt, of nieuwe apps maken door standaard- en aangepaste tabbladen te groeperen.`,
"label_emailsync_form_emialpassword":`Wachtwoord`,
"label.Lightning.Setting":`Bliksem Setup`,
"label.print.preview":`Afdrukbaar Bekijken`,
"label_vue_create_edit_obj_create_event_dialog_desc_alert":`Wilt u het evenement nog steeds in dit tijdsbestek organiseren?`,
"label.mobile.phone.report.type":`Soort verslag`,
"lable.account.CalenderWeek":`Kalender week`,
"label_emailtocloudcc_step3total3":`Stap 3 van 3`,
"label_tabpage_emailaddressz":`E-mailadres van de afzender`,
"label.data.is_woking":`Werking`,
"label.knowledge.cancelattach.case":`Annuleren Bevestigen aan zaak`,
"label.sendemail.chat.chatcontent":`De inhoud van de hoofdpost:`,
"label.timezone.set":`Territorium Instellingen`,
"label_tabpage_uploadingz":`Uploaden`,
"front-epwechat-module-v1-home-url":`Homepage URL:`,
"label.reportsSubscription.select.subscription.frequency":`Kies uw abonnementsfrequentie!`,
"label.validate.function":`functie`,
"label.partnerCloud.orderingPlatform.quantity":`Hoeveelheid`,
"label.compact.layout.chatter":`CCChat`,
"label.sso.saml.sp.description2":`Configureer single sign-on om gebruikers in CloudCC te authenticeren vanuit externe omgevingen.`,
"label.ccchat.message.new.error1":`We kunnen geen enkele chat gebruiker vinden met {0} in zijn naam.`,
"label.file.share.email.content3":`Voor meer informatie kunt u inloggen in het CloudCC CRM-systeem.`,
"label.file.cancel.sharing":`Annuleren`,
"label.changemydisplay.showalltabs.add":`Tabbladen toevoegen aan uw standaardweergave`,
"label_chatter_incident":`Evenement`,
"label.file.folder.delete3":`Weet u zeker dat u {foldername}？ wilt verwijderen`,
"label_tabpage_delsuccessz":`Succes wissen`,
"label.view_contact":`Contact weergeven`,
"label.deactivate":`Deactiveer`,
"label.Horizontal.Date":`Filter service afspraak volgens leve datum.`,
"label.forecast.tree.title":`Voorspellingen Hiërarchie`,
"vue_label_dashboard_dategruop":`Selecteer datum groepering basis`,
"label.version.nonsupport.custompage":`Aangepaste pagina's worden tijdelijk niet ondersteund.`,
"label.tabpage.personvisible":`Zichtbaar voor het betrokken personeel`,
"message.error.unknown":`Onbekende fout`,
"label.down":`Down`,
"label.multilang.customforcast.financialyear":`{0} fiscaal jaar：`,
"label.dataimport.type.error":`Typefout, gelieve het record te controleren en te wijzigen.`,
"label.batchadd.newbatchpage.save.num":`Onjuiste numerieke opmaak`,
"front-Dev-V12.2.8-calendar-endField":`Einde veld`,
"label.tabpage.rtemptyz":`Type record kan niet leeg zijn`,
"vue_label_dashboard_maximum":`Geef het maximum`,
"label.expiredate":`Vervaldatum`,
"label_emailtocloudcc_button_view":`Bekijk`,
"label.event.future":`Toekomstige evenementen`,
"label.mobile.app.layout":`Lay-out mobiele app`,
"label.emailobject.contacts":`  contact(en)`,
"label.approvalstep2.tip":`Geef aan of een record aan bepaalde criteria moet voldoen voordat het deze goedkeuringsstap ingaat.`,
"label.usefollowtoset":`Specificeer met behulp van de onderstaande opties de gebruiker aan wie het goedkeuringsverzoek moet worden toegewezen.`,
"label.dashboard.summary.editPageHeader":`Koptekst bewerken`,
"label_partner_workspace_tab_memo":`Selecteer tabbladen voor deze partnerwolk. Zowel standaardtabbladen als aangepaste tabbladen kunnen worden geselecteerd.`,
"front-lightning-module-v1-details-page-chart-title-supports":` De Titel ondersteunt het invoegen van een recordnaam met een opmaak van {recordnaam}, zoals "Opportunitybedrag van {recordnaam}". Als de huidige recordnaam CloudCC is, dan wordt deze weergegeven als "Opportunitybedrag van CloudCC".`,
"label.enable.generate.location.service":`Maakt het mogelijk om op basis van het adres van de klant gegevens over de lengte- en breedtegraad van de klant te genereren`,
"label.loginsystem":`Inloggen`,
"label.email.template.edit.template":`Sjabloon bewerken`,
"vue_label_commonobjects_detail_share":`Inkomstenaandeel`,
"label.icon.142":`Huis`,
"label.maintype":`Meester`,
"label.step2.total4":`Stap 2 van 4`,
"label.select.intended.tablayout":`Kies de pagina-indeling van het webtabblad dat u wilt maken.`,
"label.custom.unit":`Eenheid`,
"label.mr.title.phone":`Telefoon`,
"label.compact.layout.frame.showtype":`Weergave methode:`,
"label.associations":`Bijbehorend voorwerp`,
"label.potentialcustomers.name":`Leiding Naam`,
"label.edit.profile":`Profiel bewerken`,
"label.tabpage.allvisible":`Alle gebruikers zijn zichtbaar`,
"label.login.verification.confirmation.enabled":`Bevestig om in te schakelen`,
"vue_label_norm_recordselected":`{selectNum} geselecteerde record(s)`,
"label.partner.workspace.member.selectedprofile":`Geselecteerd profiel`,
"label.divide":`/Delen`,
"label.version.case.control":`Casemanagement`,
"label.attendance.nocheckin":`Niet inchecken`,
"vue_label_helpcenter_report2.1":`2.Verwijder rij groepering: <br> A. Na het vinden van het "rij groepering" veld dat u wilt verwijderen in de "groepering rij" lijst aan de linkerkant, klikt u op de "×" op het veld vak. <br> B. Of zoek het "rij groepering" veld dat u wilt verwijderen in de kop van het voorbeeld rapport aan de rechterkant, klik op de "drop down knop", en klik op "verwijder groep rij".<br> Kolom groepering verwijderen: <br> A. Nadat u het veld "Kolomgroepering" dat u wilt verwijderen hebt gevonden in de lijst "Kolommen groeperen" aan de linkerkant, klikt u op "×" in het veldvak. <br> 1. B. Of zoek het Rij Groepering veld dat u wilt verwijderen in de tabel kop van het voorbeeld rapport aan de rechterkant, klik op de drop-down knop, en klik op Groepering Rij Verwijderen. <br> Om een kolomgroepering te verwijderen:<br> A. Zoek het Kolomgroeperingsveld dat u wilt verwijderen in de lijst Groepen kolommen aan de linkerkant, en klik op de "x" in het veldvak. <br> B. Of zoek het kolomgroeperingsveld dat u wilt verwijderen in de tabelkop van het voorbeeldrapport aan de rechterkant, klik op de drop-down knop, en klik op Verwijder Groep Kolom. <br>? Datum granulariteit aanpassen voor het groeperen van records<br> Stap 1: Na het groeperen op datumvelden, kunt u ook de datum granulariteit aanpassen. Selecteer eerst het datumveld waarop u het rapport wilt groeperen. Klik dan op de Dropdown knop naast dit veld in de koptekst van het voorbeeld rapport en klik op Datum Groeperings Basis. <br> Stap 2: Selecteer hoe u wilt groeperen: Dag, Maand, Jaar, Boekhoudkundig Kwartaal, Boekhoudkundig Jaar, Aangepast Kwartaal, Aangepast Jaar. <br>? Stap 1: Nadat u de kolom hebt gevonden die u wilt samenvatten in de koptekst van het voorbeeldrapport, klikt u op de "drop-down knop" en klikt u op "Samenvatting". <br>`,
"label.payment.renew":`Vernieuwen`,
"vue_label_file_wrong_type":`'Er is een fout in het bestandstype upload, het bestandsformaat dat u nu aan het uploaden bent is {type}!`,
"UG_opportunity_005":`Meervoudig verkoopproces`,
"label.knowledge.language.korean":`Koreaans`,
"label.customobjects.inputrecordtagandformat":`Recordnaam invoeren Etiket en opmaak`,
"label.h5.chatter.commentednum":`Een antwoord ontvangen`,
"label.quickbooks.button.unlink":`Unlink`,
"label.step5.total5":`Stap 5 van 5`,
"label.projectManagement.Selweek":`Kies week`,
"label.optional.searchfield":`Beschikbare doorzoekbare velden`,
"label.mobile.quickcreate.default.signin":`Inchecken.`,
"label.visualpage.unable.parse":`Niet in staat om marker op te lossen.`,
"mesage.error.role.delete":`U kunt de rol waaraan de kindrol is toegewezen niet verwijderen.`,
"label.role.user":`Gebruikers in de rol`,
"button_partner_workspace_saveas":`Opslaan als`,
"label.file.no.public.link.created":`Geen publieke link gemaakt`,
"label.login.access.shenyu":`Overblijvend`,
"label.ccchat.group.section":`Groep`,
"label.weixin.object.notnull":`Thema kan niet leeg zijn`,
"label.accmarketsea.add.title":`Nieuwe Rekening Pool`,
"label.sales.funnel.layout":`Verkoop trechter lay-out`,
"pagecreator.page.button.edit":`Bewerken`,
"label_tabpage_entercontent":`Gelieve inhoud in te voeren`,
"component_event_label_begindate":`*Start tijd`,
"label.file.versionhref":`Schakel over naar de nieuwe versie van de pagina`,
"label_chatter_send":`Stuur`,
"setup_layout_label_buttonlist":`Knoppen kiezen`,
"label.custom.Current.and.NexttCQ":`Huidige en volgende 3 CQ`,
"pagecreator_page_label_pagedesc":`Beschrijving van de pagina`,
"label.appupload.upload.uploader":`Geüpload door`,
"label.console.step5.tab.primary":`Als een primair tabblad`,
"vue_label_globalsearch_expandlist":`Lijst uitbreiden`,
"label.forecast.edit.userqu":`Doel`,
"label.step1.total5":`Stap 1 van 5`,
"label.multilang.dupicatecheck.onegroupredata":`Voortgang van de controle van duplicaat en de combinatie： een totaal van {0} groepen：`,
"vue_label_systemSettings_repeat":`Duplicaten beheren`,
"label.mobile.side.tab.error1":`Selecteer de functies en toepassingstabbladen die moeten worden weergegeven.`,
"label.knowledgebase.reduction":`Herstel`,
"label.standard.buttonandlink.override.usedefault":`Geen opheffing (gebruik standaard)`,
"dateandtime":`Datum/Tijd`,
"label.group.activate.info":`Groep activeren`,
"label.triggertotask":`Taak Triggers`,
"label.emailobject.save.template":`Concept opslaan als sjabloon`,
"label.audit.objInfo":`Detail goedkeuringsproces`,
"label.callcenter.successfully.logged.account":`Succesvol ingelogd!`,
"label_new_customer_target":`Nieuw account doel`,
"label.campaign.channel.step5":`Stap 5: Bekijk een voorbeeld van de registratiepagina van het marketingkanaal en de broncode.`,
"label.log.type":`Soorten bewerkingen`,
"front-template-V1-noTemplate":`Er werden geen beschikbare sjablonen gevonden onder het geschakelde object.`,
"label_report_line_daixuan":`Kolom in afwachting van verslag`,
"label.tianyancha.businessverify.relation.tip":`Schrijf de velden geretourneerd door tianyancha naar velden van klant`,
"label.default.value":`Gebruik deze waarde als de standaardwaarde voor de hoofdkeuzelijst`,
"label.weixin.campaign.attendance":`Campagne aanwezigheid`,
"message.duplication.label.check":`Kijk op`,
"label.salescloud.salescloud.yes2forbidden":`Ja, ik wil Team Selling uitschakelen.`,
"lable.currencyAdv.exchagecurrency.rate":`Wisselkoersen voor:`,
"lable.Hide.title":`Verberg titels`,
"label.finishedreport":`Gegenereerde rapporten`,
"vue_label_account_business":`Overdracht gesloten zakelijke kansen van klanten eigenaren`,
"vue_label_pool_assigned":`Toegewezen`,
"label.report.export.error":`Er is een uitzondering opgetreden bij de exportbewerking. Probeer het opnieuw.`,
"label.layout.availablefield":`Beschikbare velden`,
"label.licence.remainder":`Resterende licenties`,
"label.approval.idea.required":`Goedkeuring advies is vereist.`,
"front-kefu-moudle-needhand-createcase":`Handmatige bevestiging is vereist alvorens een zaak te creëren`,
"label.dashboard.snapshot.Data.change":`Gegevensbron gewijzigd, herconfigureer`,
"label.partner.workspace.login.footertext":`Tekst voettekst`,
"vue_label_chatter_upload_link_type":`Geselecteerde upload link-type post`,
"front-dialog-module-v1-error-detail":`Fout Details`,
"label.emailobject.sendgroupemail":`Groep e-mail verzenden`,
"lable.newtabpage.allviews":`Alle standpunten`,
"label.khdd":`Accountlocatie`,
"vue_label_dashboard_sortfield":`Sorteerveld`,
"label.form.sample":`Voorbeeldformulier`,
"component_setup_button_cancel":`Annuleren`,
"vue_label_salesfunnel_notice5":`Aantal zakelijke kansen met een waarschijnlijkheid van 1% - 99% * waarschijnlijkheid`,
"pagecreator_systemstyle_label_modifystyle":`Stijl redacteur`,
"UG_homepage_001":`Win meer deals in minder tijd`,
"label.campaign.pc":`PC`,
"label.visualpage.lightning":`Lightning versie`,
"label.knowledge.category.hint.two":`Gebruik deze pagina om de groep voor Bliksem te selecteren nadat u een categoriegroep hebt gemaakt.`,
"label.south.africa.standard.time":`Zuid Afrika Standaard Tijd`,
"label.service.gantt.reservation.number":`Bestelnummer`,
"label.weixin.report.period":`Periode`,
"label.leadtomap.exp":`Gebruik de tabbladen om elk van de aangepaste leadvelden van uw organisatie toe te wijzen aan een van uw aangepaste velden voor accounts, contactpersonen of kansen. Deze toewijzingen worden gebruikt wanneer u leads converteert naar accounts, contactpersonen of kansen.`,
"label.currency.d":`U kunt uw bedrijfsvaluta wijzigen in een andere valuta die door uw organisatie wordt ondersteund. Alle valutaomrekeningskoersen die al in CloudCC.com zijn gedefinieerd, zullen dienovereenkomstig worden aangepast om de verandering weer te geven.`,
"label.forecast.detailforecast.oppyclb":`Kansprognose categorieën`,
"label.reportsSubscriptionPage.email.selected":`Geselecteerde leden`,
"vue_label_homepage_componentname":`Voer de naam van het onderdeel in`,
"lable.account.Previous.FYt":`Vorige 2 FY`,
"label.appupload.success":`Upload voltooid`,
"label.customer.newtab":`Nieuw tabblad aangepaste pagina`,
"label.value.notnull":`U moet een waarde invoeren.`,
"label.case.miniprogram.layout":`De pagina layout van de applet rapport pagina is de pagina layout die gebruikt wordt voor het service verzoek dat ingediend is vanaf het applet einde, en deze pagina layout kan alleen bewerkt worden en kan niet verwijderd worden.`,
"label.partnerCloud.partnerAccount.twoDecimal":`Gelieve in het juiste formaat in te voeren.  Twee decimalen kunnen worden behouden.`,
"UG.Lead.004":`Webformulier`,
"label.umeng.activity.event.eventwillbeginnew":`Evenement melding: #evenement begint om #begintijd`,
"label.projectManagement.subtasks":`Sub-taks`,
"vue_label_checkduplicate_repeat_conditions":`Bepaal herhaalde voorwaarden`,
"label.subject":`Onderwerp`,
"label_search_otherusers_forecast":`Zoek naar voorspellingen van andere gebruikers`,
"label_tabpage_namemandatory":`De naam van het uitzicht is vereist`,
"label.timezone.importtimezone":`De tijdzone instelling voor data import`,
"label.mobile.buttom.team.init":`Team Gebruiker Initialisatie`,
"label.checkfield.choosefield":`Selecteer de velden om de doublures te vinden`,
"label.b_c_least":`Elke "B"-plaat moet ten minste één verwante "C"-plaat hebben.`,
"label.knowledge.setting.hint.five":`Selecteer een kennisauteur`,
"label.h5.similar.opportunity.step2":`Stap 2 Geef de criteria aan`,
"label.page.style.imbedded.cloudcc":`De paginavullende stijl geeft u maximale schermruimte voor de inhoud die u in het CloudCC.com-venster insluit.`,
"label.sendemail.marketactivity.invitecode":`De uitnodigingscode van de campagne #campagnebenaming`,
"label.block.pricing":`Prijzen per blok`,
"message.error.field.number.zero":`Lengte formaat ingevoerd fout, kan niet 0 zijn.`,
"pagecreator.systemstyle.message.save.success":`Stijl succesvol opgeslagen`,
"pagecreator_systemstyle_label_styledesc":`Stijlbeschrijving`,
"APPIntegration_Dropbox_setting_01":`Activeer`,
"label_emailtocloudcc_redmessage2":`Voer het wachtwoord van uw e-mailaccount in`,
"label.user.special.operations":`Alleen gebruikt in bedrijf, kan niet tijdelijk worden gebruikt, neem dan contact op met de beheerder!`,
"pagecreator_page_label_layoutpreview":`Lay-out voorbeeld`,
"APPIntegration_Dropbox_setting_03":`Dropbox inschakelen om bestanden uit Dropbox te kunnen selecteren en als bijlage toe te voegen.`,
"label.sure_leave":`Weet je zeker dat je weggaat?`,
"label.applt.copylink":`Kopieer Miniprogramma Link`,
"label_tabpage_allpotentialcustomers":`Alle aanwijzingen`,
"label.rulestrikedate":`Regel Trigger Tijd`,
"label_tabpage_justsz":`Just`,
"label.customize.memory.function.sorting.title":`Mijn geheugenfunctie van het sorteren aanpassen`,
"message.duplication.label.mergebutton":`Samenvoegen`,
"chatter.group.cancelRequest":`Verzoek annuleren`,
"label.campaign.channel.step6.remark":`Als u de registratiepagina hebt bevestigd, klik dan op de knop Genereer om de registratiepagina te genereren.`,
"label.appupload.upload.install.abort":`Annuleren`,
"label.emailobject.proposetimes":`Stel tijden voor`,
"label.probability.cannot.empty":`U moet een nummer invoeren in uw opportuniteitsmogelijkheid.`,
"vue_label_homepage_editkanban":`Kanban bewerken`,
"lable.Related.template":`Relevante sjablonen`,
"label.cloudccclass.list.cls.time":`Geplande Klassen`,
"component.task.label.enddate":`Verloopdatum`,
"label.sendmail.step3":`Stap 3 Herzien en bevestigen`,
"label.projectManagement.Gridview":`Roosterweergave`,
"label.emailobject.time":`Tijd`,
"label.applt.address":`Klantenserviceportaal van het miniprogramma`,
"label.searchfield":`Zoek Velden`,
"vue_label_calendar_please_enter_the_name":`Voer de naam in`,
"label.list.userinterface.default.page.setup":`Systeem standaard pagina`,
"label.detail.2018":`Details`,
"label.webtocloudcc.success":`Uw informatie is succesvol ingediend. Hartelijk dank voor uw deelname, wij zullen u van harte van dienst zijn.`,
"component_telerecord_label_title":`Telefoon opnemen`,
"label.setting.sureDelete.rules":`Weet je zeker dat je deze regel wilt verwijderen?`,
"vue_label_email_current_theme":`Door dit sjabloon in te voegen wordt het huidige onderwerp van de e-mail afgedekt.`,
"lable.Order.product":`Product bestellen`,
"UG_product_02":`Producten verwijzen naar producten of diensten die worden verkocht of gekocht.`,
"label.appexchange.task":`Werkstroom Taken`,
"label.selectprocesscondition":`Specificeer voorwaarden voor stap`,
"label.mobile.quickcreate.default.scan":`Scan`,
"label.tabpage.prepagez":`Weergave op elke pagina`,
"label.query.error":`Zoekfout.`,
"label.tabularreport.2018.step1":`Stap 1 Kies de kolommen van het rapport`,
"pagecreator.systemstyle.label.modifystyle":`Stijl redacteur`,
"label.app.step3":`Stap 3 Kies de afbeeldingsbron voor het aangepaste app-logo`,
"label_tabpage_rowsz":`Rijen verwijderen`,
"label.validate.function.funcExplain.SUBSTITUTE":`Vervangt nieuwe_tekst door oude_tekst in een tekenreeks. Gebruik SUBSTITUTE wanneer u specifieke tekst in een tekstreeks wilt vervangen.`,
"vue_label_checkduplicate_select_data_to_merge":`Selecteer gegevens om samen te voegen`,
"vue_label_commonobjects_view_chart_displaymode":`Weergavemodus`,
"label.industrialandcommercialverification.servicesetiings":`Dienst Instellingen`,
"label.refresh":`Vernieuwen`,
"label.taskfield":`Taakvelden`,
"label.notification.approval4":`【提交人】 vraagt goedkeuring voor 【对象】`,
"label.group.isusing":`Actief`,
"label.language.settings":`Taalinstelling`,
"front-kefu-moudle-please-login":`Gelieve eerst in te loggen`,
"label.page.double.line.cloudcc":`2 kolommen met CloudCC.com zijbalk`,
"folder.error.delete":`1. De huidige map bevat rapporten en kan niet worden verwijderd! 2. De huidige map bevat verborgen rapporten en kan niet worden verwijderd! Verborgen rapport is een rapport dat gemaakt is op basis van een logisch verwijderd object (instellingen-aanmaak-verloren objecten onder het object), omdat het object niet echt verwijderd is, dus het rapport is verborgen`,
"eight":`Acht`,
"label.marketseamemset.user":`Lid`,
"label.recordnum":`Record Nummer`,
"page.404.button.back":`Terug naar vorige stap`,
"label.mobile.phone.month.plan":`Plannen voor volgende maand`,
"label.marketseamemset.account.title2":`Stel een bovengrens in voor het aantal klanten dat alle leden raakt. De limiet is niet gerelateerd aan de lead pool`,
"vue_label_chatter_current_avatar":`Huidige avatar`,
"label.mobile.side.tab.remark3":`Houd de shift-toets ingedrukt en klik of sleep om een reeks aangrenzende items te selecteren. Houd de ctrl-toets ingedrukt en klik om meerdere niet-aangrenzende items te selecteren.`,
"component.sendmail.label.touser":`Ontvanger`,
"label.homeitems.noobject":`Geen onderwerpen`,
"template.report.overall.sales":`Totale verkoopperiode (per Leadbron)`,
"label.partner.donotdel":`kan niet verwijderen`,
"label.service.miniProgram.bindCopyDesc":`Nadat u uw organisatie hebt gebonden aan het officiële aacount of miniprogramma van uw bedrijf, kunt u dit adres gebruiken als uw eigen klantenserviceportaal door het met één tik te kopiëren en naar dit adres te springen.`,
"UG_Contract_01":`Contract beheren`,
"UG_quota_06":`Een offerte maken`,
"vue_label_report_deletereport":`Rapport verwijderen`,
"front-epwechat-module-v1-input-appname":`Gelieve de naam van de toepassing in te voeren`,
"label_tabpage_deleteviewsuccess":`Bekijk verwijderen succes`,
"component_chatter_label_mygroup":`Mijn groep`,
"label.campagin.roi.leixing":`Type campagne`,
"label.dashboard.myHomepageDashboard":`Mijn Homapage Dashboards`,
"UG_solution_04":`Import oplossing`,
"label.knowledge.setting.hint.four":`Activeer Kennis`,
"label.campaign.channel.add.field":`Klik op de knop om velden toe te voegen`,
"label.eastem.european.time":`Oost Europese Tijd`,
"label.partner.workspace.member.partner":`CloudCC partnerprofiel`,
"label.campaignmember.main.backtocampaign":`Terug naar Campagnes`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.absolute":`Absoluut`,
"label.task.unsolve":`Alle openstaande taken`,
"label.multilang.chatterservice.vote":`{0} ticket(s)`,
"label.console":`Console`,
"label.emailsync.message1":`Als u de verbinding annuleert, zult u niet in staat zijn om de inhoud van de mailbox te synchroniseren met de leads en contacten, weet u zeker dat u wilt annuleren?`,
"pagecreator.systemstyle.label.stylename":`Stijl naam`,
"setup_mainpage_label_welcome16":`Instructies: Klik op het menu aan de linkerkant van de pagina → Applicatie-instellingen → Aanmaken → Workflow, Goedkeuringsproces, Taken, E-mailnotificatie, Veldupdate, en meer.`,
"message.duplication.label.editfilterule":`Duplicaat filterregels zoeken`,
"Account.News.Setting.004":`Enable Nieuws`,
"label_tabpage_saveviewsuccess":`Weergave succesvol opgeslagen`,
"label.forecast.forehistory.replacecommit":`Vastleggen opheffen`,
"pagecreator_button_cancel":`Annuleren`,
"label.knowledge.article.nomatch":`Dit artikel kan niet worden gearchiveerd omdat het ontwerp bestaat. Verwijder het ontwerp en probeer het opnieuw.`,
"vue_label_combined_field":`Geen velden om op te tellen.`,
"label.batchadd.save.prompt":`record(s)`,
"label.tabpage.summaryway":`Samenvatting Door`,
"label.check.input.condition.two":`SQL wordt niet ondersteund`,
"mail.apiCode.notOnly":`De enige naam bestaat al`,
"UG.quota.01":`Beheer rekeningoffertes`,
"label.approved.receiveApprovalEmail.option3":`Alleen als ik een gedelegeerd goedkeurder ben`,
"label.stdashbord.xsld.business.img5":`Totale hoeveelheid waarschijnlijkheid 0%`,
"vue_label_chat_movedfromto":`{naam} verplaatst {label} van {oud veld} naar {nieuw veld}`,
"label.customfields.new.step2.opration":`Algemene opties`,
"label.dashboardSetup.isurl":`Links toevoegen`,
"label.forecast.settings.mrfwqj":`Voorspellingscyclus`,
"label.campaign.channel.field":`Velden`,
"label.weixin.optionthree":`Keuze 3`,
"label.safetystatement":`Veiligheidsverklaring`,
"label.useskipwizard":`Jump Start Wizard gebruiken`,
"label.projectManagement.completion":`Status van voltooiing`,
"label.customfields.fielddependency.new.step2":`<b>Stap 2:</b> Bewerk op de volgende pagina de filterregels die de waarden bepalen die in het afhankelijke veld verschijnen voor elke waarde in het controlerende veld.`,
"setup.mainpage.label.welcome8":`Interface aanpassen via slepen en neerzetten`,
"label.emailobject.list.outbox":`Outbox`,
"label.app.default.login.tab":`Standaard login tab`,
"label.follow_emails":`Followup email is een geweldige manier om snel en gemakkelijk contact op te nemen met uw bezoekers nadat ze formulieren hebben ingediend.`,
"vue_label_homepage_application_page":`Startpagina van de toepassing`,
"label.confirm.template":`Bevestig`,
"lable.product.not":`Kon niet volledig worden gewist`,
"label.multilang.feedtrack.dispalyinfo":`U kunt maximaal {0} velden kiezen:`,
"label.weixin.plz.inputsrhkey":`Voer een zoekwoord in`,
"label.projectManagement.service.appointment":`Service Afspraak`,
"label.list.userinterface.watermark.enable":`Watermerken inschakelen op startpagina's, weergaven, detailpagina's, rapporten en dashboards op pc en mobiele app.`,
"label.confirmDelete":`Weet u zeker dat u deze gegevens wilt wissen?`,
"label.sso.description":`Gebruikers kunnen toegang krijgen tot het CloudCC.com systeem zonder in te loggen op basis van gebruikersnaam en autorisatiecode.<br>Klik op de URL hieronder om toegang te krijgen tot het CloudCC.com systeem: http://localhost:8080/ssologin.action?userName=admin@dev.com&authCode=dcc5c192facd7c08e124fbe93d8950b9 .<br>Gebruik de links hierboven,'http://localhost:8080' vervang a.u.b. de toegang van uw organisatie voor de link.'admin@dev.com' vervang a.u.b. uw gebruikersnaam van de organisatie.<br>'dcc5c192facd7c08e124fbe93d8950b9' vervang a.u.b. uw autorisatiecode van de organisatie.`,
"errormessage_email_atleastonereceiver_z":`U moet een ontvangstadres selecteren of bewerken.`,
"C":`Samenvatting oprollen`,
"label.service.major.event.edit":`Mijlpaal bewerken`,
"label.icon.9":`Dienst`,
"label.visualpage.notvalidate.check":`Ongeldige aangepaste pagina's, raadpleeg de Help-tekst om de pagina te controleren.`,
"label.audit.todo.from":`van`,
"label.directboss":`Deze functie rapporteert aan`,
"label.manageAll.selpage":`Pagina`,
"label.console.step6.all":`Volledig scherm, niet vastgezet en de lijsten zijn alleen zichtbaar als het navigatietabblad is geselecteerd.`,
"vue_label_pool_expiredate":`Verloopdatum`,
"lable.no.matching.record":`Geen overeenstemmend record`,
"label.standard.redirecterror":`Springen naar aangepaste pagina via standaard knoppen mislukt.`,
"label.Platform.Setting":`Platform Instellingen`,
"lable.outlook.edit.havenewc":`Contacten met recent gecreëerde activiteiten`,
"label.partnerCloud.partnerAccount.choosePayment":`Selecteer een betalingsmethode`,
"label.weixin.optionsix":`Keuze 6`,
"lable.SalesCommitmentKanBan.allCommitments":`Pijpleiding`,
"page_404_button_toknowmore":`Meer informatie`,
"label.customfields.number.tip":`Hiermee kunnen gebruikers een willekeurig getal invoeren. Voorloopnullen worden verwijderd.`,
"label.import.index.processimport":`Importeren`,
"label.quote.phone":`Telefoon`,
"label.insert.approval":`Goedkeuring invoegen`,
"label.tabpage.printview":`Weergave Afdrukken`,
"lable.product.price":`Prijs`,
"front-kefu-moudle-call-detail":`Bel details`,
"label.umeng.approval.apply":`toepassen`,
"label.background.the.form":`Vorm achtergrond`,
"chatter.f":`Volgers`,
"label.quickbooks.searchresault.company":`Bedrijf`,
"vue_label_systemSettings_platformutils":`Platform Hulpmiddel`,
"front-quotation-v1-nofilles-tocreate":`Klik op Offerte genereren en verstuur na het genereren.`,
"label.category.6":`Medische behandeling`,
"label.attendance.choose.positon":`Landmarks kiezen`,
"label.batchadd.newbatchpage.save.pho":`Ongeldig telefoonformaat`,
"UG.Account.01":`Wie is je account?`,
"label.marketseamemset.addspecialuser":`Speciale leden toevoegen`,
"label.query.detail.forbidpartneruser":`Verbied partner gebruiker`,
"label.stdashbord.xsld.business.ydzhl":`Won Koers`,
"vue_label_SMS_mymessagebox":`Mijn Berichtenbox`,
"label.knowledgebase.data.publishing.failed":`Publiceren {a} gegevens mislukt. Kies aub een artikel met status gelijk aan Concept om te publiceren.`,
"label.wholestate":`Algemene status`,
"label.selectedline":`Geselecteerde kolommen`,
"label.validate.function.funcExplain.LEFT":`Geeft als resultaat het opgegeven aantal tekens vanaf het begin van een tekenreeks`,
"label.emailmerge.edittemplate.detail":`Mail Merge Sjabloon Details`,
"vue_label_checkduplicate_checkduplicate":`Controleer Duplicaat`,
"label.knowledgebase.assign.articles":`Assing artikelen`,
"label.tabpage.recordsz":`Record`,
"label.field.img.validate.error":`De variabele naam na $User is verkeerd gespeld of een illegale $User referentie, gelieve de spelling te controleren.`,
"workorderlineitem.worktype.isnot.father.worktype":`Het werktype dat bij het bovenliggende record van dit werkorderitem hoort moet geselecteerd worden.`,
"label.ccchat.group.name.noexist":`De ingevoerde groepsnaam bestaat niet, voer hem opnieuw in.`,
"label.weixin.sign.type":`Teken in (uit) typefout.`,
"label.nowvaluereplace":`Vervangen door Bestaande`,
"report_label_report":`Verslagen`,
"label.knowledge.setting.plus":`Plus Instellingen van Kennis`,
"label.event.moveup.2day":`2 dagen vooruit`,
"label.translation.start":`Om te beginnen in de Translation Workbench:`,
"lable.PowerProcess.created.time":`Gebaseerd op de aanmaaktijd van {detailInterestType}`,
"label.ems.step2":`Stap 2`,
"label.tabpage.groupingemptyz":`Groeperingsitems kunnen niet leeg zijn`,
"pagecreator.layout.button.new":`Nieuwe lay-out`,
"label.tabpage.listshow":`De lijst toont`,
"label.partnerCloud.productSet.optionName":`Optie Naam`,
"label.service.without.cycle":`Geen cyclus`,
"label.chatter.sendEmailToGroupMember.subject.V":`{0} gepubliceerde stemmen voor allen in {1}`,
"label_target_model_dimension":`Afmeting van het doelmodel`,
"component.task.label.subject":`Thema`,
"label.custom.field.login.query.information":`Ga het systeem binnen en bekijk de details.`,
"label.validate.function.funcExplain.NOT":`Verander FALSE in TRUE of verander TRUE in FALSE`,
"pagecreator_layout_button_horizontal":`Zijdelingse demontage`,
"lable.Returned.to.successful":`Succesvol terugkeren`,
"label.campaign.channel.ticket.title":`Toegangsbewijs`,
"label.ruleName.supportMaximum.50Characters":`Een maximum van 50 tekens wordt ondersteund voor de naam van regels.`,
"label.email.track.attachment.size.control1":`Totale bijlagegrootte overschrijdt 20m, kan niet worden geüpload`,
"template.report.folder.opportunities":`Analyse van de kansen`,
"label.knowledge.setting.data.eight":`U gaat de {flzmc} categoriegroep en zijn categorieën verwijderen. Deze categorie zal niet beschikbaar zijn voor toewijzing aan records. U heeft 15 dagen om de verwijdering van de categoriegroep te annuleren. Na 15 dagen wordt de categorie permanent verwijderd en kan deze niet meer worden hersteld. Weet u zeker dat u deze categoriegroep en haar categorieën wilt verwijderen?`,
"mail.id.notNull":`De ID kan niet leeg zijn bij het verwijderen van de sjabloon`,
"vue_label_normal_product_sf":`Product`,
"vue_label_report_superiortothisrelationship":`De relatie tussen het superieure object en dit object`,
"label.leadscore.operation":`Operator`,
"label.customfields.formula.percentexample":`Korting = (Bedrag - Korting_Amount__c) / Bedrag`,
"component.setup.iframe.label.inputurlmemo":`Voer de url in van de pagina die moet worden geïmporteerd`,
"label.icon.177":`Logo`,
"label.tabpage.myz":`Mijn`,
"label.leadmarketsea.add.title":`Leadpool creëren`,
"label.partnerCloud.partnerAccount.thePage":`Pagina {skippageNum}`,
"label.visualpage.some.size":`Codecapaciteit: maximale ondersteuning voor 300KB karakters, ongeveer 300.000 bytes.`,
"label.setwxpay.null":`Vereiste informatie voor het configureren van WeChat betaling zijn leeg.`,
"label.icon.74":`Gereedschapswerktuigen`,
"font-evaluate-module-v1-evbad":`Het soort evaluatie is Negatief`,
"System.TimeField.Format.Warning":`Ongeldige tijd`,
"label.captcha":`Willekeurige verificatiecode`,
"label.payment.assessment":`Bekijk andere edities`,
"message.error.not.taskevent":`Niet-taak gebeurtenis object`,
"font-evaluate-module-v1-evaluation":`Waardering`,
"vue_label_commonobject_view_updatedago":`Bijgewerkt {timeInterval} geleden`,
"label.sendemail.birthday.newevent":`Beste eigenaar, over drie dagen is iemand jarig. Houdt u er rekening mee...`,
"label.laststep":`Vorige stap`,
"message.duplication.label.matchoption":`Bijpassende optie`,
"label.setupmultplerecordtype":`Meervoudige recordtypes`,
"vue_label_account_unprocessed_oppprtunities":`Onverwerkte kansen`,
"KeyInformationLayout.DefaultLayout.Name":`Systeem Standaard`,
"label.partner.all":`Alle parter wolk`,
"label.datamanage.export.error":`Export mislukt`,
"label.standard.buttonandlink":`Standaardknop of -link`,
"label.reportsSubscriptionPage.email":`E-mail rapport`,
"message.nogrammarfaultinformula":`Geen syntaxis fouten.`,
"front-kefu-moudle-nofind-instance":`Geen instantie gevonden`,
"label.is.delete.data":`De records die u wilt verwijderen bevatten een verzoek om goedkeuring, weet u zeker dat u wilt verwijderen?`,
"label.partner.error":`Fout: fout in domeinformaat`,
"label.notification.time2":`{0} minuten geleden`,
"label.ccchat.person.invite.needfirstname":`Vul uw naam in`,
"label.mr.title.URL":`URL`,
"chatter.norecord":`Geen gegevens.`,
"label.readwrite":`Lezen/Schrijven`,
"label.partnerCloud.orderingPlatform.orderPayment":`Betaling`,
"label.accesslimittype":`Toegangsniveau`,
"label.preciew_tab":`Voorbeeld link in nieuw tabblad`,
"label.attachment":`Bijlage`,
"label_tabpage_helpNavigationz":`Hulp en navigatie`,
"label.dataimport.select":`Controleer deze informatie, voer de import gegevens uit`,
"chatter.en.info":`Voer informatie in zodat mensen meer over u te weten kunnen komen.`,
"label.ccservice.validate.date":`Het formaat van de overeenkomstige waarde {2} van het veld {1} onder de object-API {0} is onjuist. Voer a.u.b. het juiste datum- of tijdformaat in!`,
"label.social.posts.send":`Mislukt te posten`,
"label.emailobject.time.to":`Naar:`,
"label.defineReportStep1":`Stap 1`,
"savefail":`Opslaan mislukt`,
"label.mr.descreption.title":`Dubbele gegevens samenvoegen`,
"label.share.info.by":`Door`,
"label.list":`Lijst`,
"label.event.select":`Geselecteerd`,
"message.accountmap.cannotfind":`Het adres van de rekening kon niet worden gevonden, gelieve het rekeningadres bij te werken.`,
"label.choosefield":`Goedkeuringspagina velden`,
"label.forecast.settings.title":`Voorspellingen Instellingen`,
"label.setup.log.datetime":`Download gedragslogboek binnen een zoektijdbereik (Excel.xls)`,
"button_partner_new":`Nieuwe partner cloud`,
"label.umeng.approval.dlsp.reject":`#goedkeuringsnaam heeft het goedkeuringsverzoek van #objAPIName #recordnaam voor u afgewezen.`,
"label.tabpage.totalTeamz":`Een totaal van groepen`,
"label.lead.score.prompt3":`Dit kan enkele minuten duren. U ontvangt een bevestigingsmail zodra het voltooid is.`,
"label.schedulejob.setup.schedule.name":`Functie Naam`,
"vue_label_report_advanced":`Als het geavanceerd filter is ingeschakeld, schrijft u handmatig de filtervoorwaarde in het vak voor geavanceerd filter hieronder, het formaat wordt getoond in de figuur.`,
"label.emailsync.form.connecttime":`Verwante tijd`,
"front-gantt-module-v1-project-status":`Projectstatus`,
"label.field.for.example":`Bijvoorbeeld`,
"label.marketsea.manager.notnull":`Administrator kan niet leeg zijn.`,
"label.click.here":`&lt&lt Klik hier om terug te gaan`,
"UG.solution.04":`Import oplossing`,
"label.validate.function.funcExplain.IF":`Of de voorwaarde waar is of niet, en als de voorwaarde WAAR is, wordt één waarde teruggegeven en als de voorwaarde ONWAAR is, wordt een andere waarde teruggegeven.`,
"label.profile.settab":`Tab Instellingen`,
"front-email-payment-weichat-tips":`Scan QRcode om te betalen`,
"label.task.next.week":`Volgende week`,
"label.operatedata.selectobjectfields.tip":`Selecteer de velden die u wilt exporteren, en u moet ten minste één veld selecteren om te exporteren. <font color="red">Opgelet: Tekstveld (Rich) kan niet worden geëxporteerd.</font>`,
"label.recalculate.alert":`Selecteer de deelregel die u wilt herberekenen.`,
"label.marketsea.noopportunitydays":`Dagen zonder het creëren van zakelijke kansen (moet groter zijn dan het aantal dagen zonder follow-up na het verkrijgen)`,
"label.chat.likeperson":` Persoon (personen)`,
"label.selectedFields":`Beschikbare velden`,
"label.App":`Toepassingen`,
"label.file.type":`Bestandstype`,
"permissionService.error1":`Onvoldoende aanvraag licentie.`,
"front-detail-module-v1-chart-display":`Grafiekweergave`,
"label.audit.status":`Goedkeuringsstatus`,
"UG.activity.05":`Telefoon opnemen`,
"label.connectOtherObject":`( Klik om een ander object te relateren )`,
"lable.currencyManage.unEnabledadvcurrency":`Geavanceerd valutabeheer uitschakelen`,
"label.ccpeak.getthree.function":`Er zijn drie functies, en`,
"label.weixin.new.weitoupiao":`Maak een nieuwe micro stemming, kunnen gebruikers deelnemen aan de stemming en de toegang tot de stemming resultaten in micro evenementen op de WeChat.`,
"label.tag.manage.prompt":`Tag staat al uit！`,
"label.goon":`Ga door`,
"label.addworkflowoperate":`Workflow actie toevoegen`,
"label.weixin.click.search":`Klik om record te zoeken`,
"vue_label_report_deletecolumn":`Kolom verwijderen`,
"label.ordercondition":`Sorteer op`,
"message.error.group.notallow":`Groep staat archivering niet toe`,
"label.unread":`Ongelezen Emails`,
"vue_label_report_notice_namerequired":`Kolomnaam is verplicht`,
"label.tabpage.entercontent":`Gelieve inhoud in te voeren`,
"label.schedulejob.setup.schedule.startdate":`Begindatum`,
"component_assistant_button_newtask":`Nieuwe taak`,
"vue_label_report_notice_filter1":`U moet de geavanceerde filter(s) hieronder handmatig invullen zoals in de afbeelding wordt getoond wanneer u de geavanceerde filter inschakelt`,
"value":`Waarden`,
"label.icon.70":`Dienst`,
"label.knowledgebase.delete.draft.t":`Delete Draft`,
"label.setup.mini.bind":`Mini programma's binden`,
"component_timeline_button_more":`Meer stappen`,
"label_emailtocloudcc_redmessage4":`Gelieve havengegevens in te voeren`,
"label.field.input.number":`Voer de geldige nummers in`,
"front-invoice-online-payment-setup-title":`Online betaling starten`,
"front-kefu-moudle-called-user":`Gebelde persoon`,
"label.currency.disable":`Inactieve valuta's`,
"label.user.alias":`Alias`,
"UG_quota_04":`Offerte afdrukken`,
"label.chatter.delete":`Delete`,
"label.addtocurrentcustomer":`Gehecht aan bestaande rekeningen`,
"message.error.recordid.null":`recordid kan niet leeg zijn!`,
"label.merge.records":`Records samenvoegen`,
"report_label_norole":`U heeft geen toestemming om dit te doen, neem contact op met uw beheerder.`,
"label.pqrs":`.`,
"label.email.attach.button":`Klik op de "attach" knop`,
"label.tabpage.selrecordtypez":`Selecteer type record`,
"label.ServiceCloud.purchase.date":`Aankoopdatum`,
"label.customreporttype.delete.prompt":`Gelieve het volgende rapport te verwijderen alvorens de verwijderingsoperatie uit te voeren`,
"label.brief.total.page":`Een totaal van {totaal} pagina('s)`,
"label.reportsSubscription.unsubscribe":`Uitschrijven`,
"label.ccpeak.take.notice.exp.order":`Opmerkingen: moet "__c" toevoegen na de API-naam van de velden in de exp- en bestelvoorwaarden.`,
"report_type_label_quote":`Citaten`,
"label.file.norecord":`Geen items om weer te geven`,
"vue_label_checkduplicate_all_processed":`Alle gegevens zijn verwerkt`,
"label.next":`Volgende`,
"label.icon.10":`Map`,
"label.lanxin.title.setting":`Geïntegreerde informatie`,
"label.h5.chatter.business":`Bijbehorende mogelijkheden`,
"lable.are.you.sure.to.delete.this.view":`Wilt u dit uitzicht verwijderen?`,
"vue_group_no_operation_permission":`Geen toestemming om te opereren!`,
"label.knowledge.archive.article":`Archiefartikel`,
"vue_label_lead_":`Geen actieve scoringsregels beschikbaar, neem contact op met de systeembeheerder`,
"label.fiscal.error.between":`De begindatum van het boekjaar of de einddatum van het boekjaar ligt tussen de boekjaren van het verleden, gelieve dit te controleren en opnieuw in te stellen`,
"label.stdashbord.xsld.business.qdzje":`Totaal Bedrag (Gesloten-Won Opportunities)`,
"label.calendar.day.view":`Dag uitzicht`,
"label.emailtocloudcc.tip":`Prompt`,
"label.schedulejob.setup.schedule.st1":`De 1e`,
"label_tabpage_addtoworkbench":`Toevoegen aan startpagina werkbank`,
"label.umeng.approval.waitapproval":`wacht op goedkeuring`,
"label.justcheckingwebsite":`Alleen website verifiëren`,
"homepage.components":`Home Page Componenten`,
"label.audit.remark":`Goedkeuring Nota's`,
"label.searchs.labelname":`Zoeken {fieldlabelName}`,
"label.remarkofreport":`Verslag`,
"label.weixin.isno":`of`,
"label.currencyCode":`Valuta Code`,
"label.service.resources":`Middelen`,
"label.clone_form":`Kloon Vorm`,
"label.weixin.view.information":`Bekijk Details`,
"UG_activity_05":`Telefoon opnemen`,
"chatter.feed.menutype.user.recentuser":`Mensen die onlangs`,
"label.marketsea.notfollowdays2":`Dagen geen follow-ups`,
"label.tabpage.namemandatory":`De naam van het uitzicht is vereist`,
"message.demo.nosupport":`Deze functie zal in de volgende release worden geïntroduceerd.`,
"label.mail.merge.template":`Samenvoegen van de e-mail sjablonen......`,
"label.sendemail.marketactivity.sign":`Kennisgeving van campagneborden`,
"setup_layout_group_relatedlist":`Verwante Lijsten`,
"label.pc.ui.2018.all.tabs":`Alle menu`,
"label.field.lost.right.bracket":`Dichte beugel is verloren`,
"label.datamanage.contact.novalue":`Opmerking: Als het veld contactnaam leeg is, zullen de contactpersonen niet worden geïmporteerd.`,
"label.version.unlimited.edition":`Onbeperkte Editie`,
"vue_label_dashboard_selectsortfield":`Selecteer een sorteerveld`,
"label.partnerCloud.productSet.instructions":``,
"front-kefu-moudle-v1-canuse-obj":`Zichtbaar voor`,
"thursday":`Donderdag`,
"label.nextapprover":`Volgende goedkeurder`,
"setup_mainpage_label_manageuser":`Gebruikers beheren`,
"label.saveandcontinue":`Save`,
"label.top.userCenter":`Persoonlijk centrum`,
"component.chatter.file.button.save":`Publiceren`,
"label_emailsync_setting":`Persoonlijke e-mail instellingen`,
"label.usableshareuser":`Beschikbaar Gedeeld aan`,
"label.customfields.optionlist.fieldvaluelist.letterrank":`Geef de waarden alfabetisch weer, niet in de ingevoerde volgorde`,
"label.list.button":`Profiel Opdracht`,
"chatter.up.m":`Fout: Geuploade bestanden zijn te groot. Maximale bestandsgrootte is 20 MB.`,
"label.knowledgebase.filters":`{a}filters`,
"label.sso.saml.sp.idtype.username":`Assertion bevat de CloudCC-gebruikersnaam van de gebruiker`,
"vue_label_file_size_limit":`De bestandsgrootte is niet groter dan {size}Mb`,
"label.appupload.install.error.choice4":`Tegenstrijdige componenten overslaan, geen tegenstrijdige componenten installeren`,
"label.currencyDecimalDigits":`Decimale plaatsen`,
"label.weixin.customer.details":`Account Details`,
"component.timeline.label.7daysahead":`7 dagen voor`,
"label.sendsms.batch.step1":`Stap 1 Specificeer de ontvangers die moeten worden opgenomen`,
"label.brief.opportunity1":`Kansen`,
"label.datamanage.click.importbutton":`Klik op <b>Import</b> en de gegevens worden geïmporteerd in het CloudCC-systeem.`,
"label_filter_benchmark_objects":`Filter referentie object`,
"label.area.record.notexist":`Het dossier bestaat niet.`,
"label.event.overdue.unfinished":`Achterstallige gebeurtenissen`,
"label.file.publicview.errortype":`Het bestandstype ondersteunt geen voorbeeldweergave`,
"label.setup.mobile.bottombutton.profile.setting":`Onderste menu van profiel aanpassen`,
"label.campaignmember.main.addleaddesc":`Voeg alle bestaande leads toe aan deze campagne`,
"vue_label_approve_actual_operator":`Feitelijke exploitant`,
"label.version.essential":`Essentiële uitgave`,
"lable.SalesCommitmentKanBan.commitments":`Pijpleiding`,
"label.chatter.pastEvents":`Vroegere activiteiten`,
"vue_label_calendar_choose_calendar_type":`Kies kalendertype`,
"label.service.dispatchingUnits.batch.send":`Batch toewijzen`,
"chatter.poll.option8":`Keuze 8`,
"label_tabpage_summaryway":`Samenvatting methode`,
"front-kefu-moudle-trindex-copy-num":`Kopieer a.u.b. het ondernemingsnummer op de homepage van het Tianrun systeem`,
"lable.quote.syncing.syncfinish":`Sync Voltooid`,
"label.home.task.finish":`Volbrachte taak`,
"label.toleadfield":`Kaart Lead Fields`,
"label.everyone":`Iedereen`,
"label.multilang.databatchadd.success":`{0} gegevens zijn succesvol toegevoegd：`,
"label.quote.createdate":`Datum aanmaken`,
"email.template.nopermission":`Alleen beheerders kunnen sjablonen in deze map bewerken`,
"label.report.action.addtodashboard2":`Dashboard toevoegen`,
"label.campaign.name":`Campagne Naam`,
"label.check.input.condition":`Syntaxisfout, controleer de ingevoerde filtercriteria`,
"front-epwechat-module-v1-upload-file":`Upload krediet document:`,
"label.batchadd.newbatchpage.button.add":`Een rij toevoegen`,
"label.partnerCloud.footer":`Voettekst`,
"lable.Enter.template.name":`Voer de naam van de tamplate in.`,
"label_tabpage_last":`Laatste stap`,
"label.setup.mobile.bottombutton.setting":`Instellingen van de mobiele app op het eerste niveau`,
"label_emailtocloudcc_filed_emailto":`E-mail naar`,
"label.data.downpage.e_title.num3":`3. Gebruikers kunnen exportsjablonen maken volgens hun behoeften en het item "Exporteren volgens sjabloon" selecteren, wat het exporteren gemakkelijker maakt.`,
"startwith":`Begint met`,
"vue_label_normal_cancel":`Annuleren`,
"label.reportTypcrtD":`Bijbehorend object (d) gelieve te klikken om verwant object te selecteren`,
"label.globalselect.disabledvalue":`Ongeldige waarde`,
"vue_label_commonobjects_view_notice_deletecertification":`Weet u zeker dat u de geselecteerde { selectNum } record(s) wilt verwijderen?`,
"front-epwechat-module-v1-bound-role":`Gebonden rollen`,
"label.partnerCloud.financeSetting.gaofilter":`Advances Filter Voorwaarden (b.v. 1 En 2 Of 3 )`,
"label.quote.sprname":`Factuur naam`,
"lable.asset.successfully":`Breng het product met succes naar de activa.`,
"label.projectManagement.service.appointment.work.noedit":`Kan arbeidsuren van service appontment niet bewerken`,
"lable.tianyancha.h5.inputandsearch":`Voer trefwoorden in om relevante bedrijven te zoeken`,
"label.customcomponent.check.tag.firstrow":`De eerste regel moet zijn`,
"label.knowledgebase.published.translations":`Gepubliceerde vertalingen worden ook gearchiveerd en de vertaling in de status Concept wordt verwijderd.`,
"vue_label_wang_yi":`Tom`,
"label.step3.total3":`Stap 3 van 3`,
"label.stdashbord.xsld.business.img6":`Totale hoeveelheid kansrijke fasen met een kans van 100%/(Totale hoeveelheid kansrijke fasen met een kans van 100% Totale hoeveelheid kansrijke fasen met een kans van 0%)`,
"component_button_cancel":`Annuleren`,
"label.delete.false.not.exists":`Verwijderen mislukt, omdat de gegevens niet bestaan.`,
"label.appupload.install.error.choice1":`Installeer alstublieft niet`,
"label.Days.After.Horizontal.Date":`niveau datum na`,
"setup_layout_button_additem":`Voeg de geselecteerde items toe`,
"UG.contact.05":`Een contactpersoon maken`,
"label.form.title":`Formulier Titel`,
"label.horizontalbar-group":`Horizontale lijnen-rij groepering`,
"component_sendmail_label_title":`Stuur e-mail`,
"label.passwordPolicy.setup.neverexpires":`Verloopt nooit`,
"label.sso.saml.idp.config.desc1":`Schakel CloudCC.com in als een identiteitsprovider zodat u single sign-on kunt gebruiken met andere websites`,
"label.chat.topic.desc.null":`Wilt u meer informatie over dit onderwerp? Selecteer in het vervolgkeuzemenu rechtsboven de optie Details bewerken.`,
"label.movablecustomerfield":`Aangepaste velden`,
"label.trigger.folder":`Niet gearchiveerde triggermappen`,
"label.selectuploadfile":`Selecteer een bestand om te uploaden.`,
"front-email-payment-card-tips":`Voer het kaartnummer in`,
"label.tabpage.addcondition":`Voeg de voorwaarde toe`,
"label.number.MinAndMaxCheck":`Het minimum van {0} is {1}, maximum is {2}. Wijzig de hoeveelheid en sla de wijzigingen op.`,
"vue_label_dashboard_dashboard":`Succesvol hernoemen van het dashboard`,
"label.objectDeleteList":`Lijst van objecten verwijderen`,
"lable.service.gantt.and":`EN`,
"label.emailtocloudcc.step2":`Stap 2`,
"label.chatter.postup":`Post omhoog`,
"label.personalsetting":`Persoonlijke instellingen`,
"message.please.choose.permission":`Selecteer toegang`,
"label.mobile.move":`Mobiele app`,
"label.Choose":`Keuzes`,
"label_chatter_vote":`Poll`,
"label.weixin.user.select.one":`Selecteer een gebruiker`,
"pagecreator.page.label.modifypage":`Pagina-editor`,
"label.select.partOrField":`Kies secties of velden die moeten worden gecontroleerd`,
"vue_label_helpcenter_chat":`1. Instant messaging<br> Team kan bedrijfs-WeChat, etc. vervangen, zodat u tekstberichten, bestanden, etc. naar uw collega's van het bedrijf kunt sturen terwijl u in het CRM systeem werkt. Wanneer elke afdeling van de organisatie een discussiegroep moet opzetten, kan de afdelingsleider een groepschat starten in het Team en afdelingsleden toevoegen aan de groepschat.<br> 2. Maak groepschats voor klanten en zakelijke kansen<br> Open de detailpagina van een klant of zakelijke kans en klik op de "Team" knop in de rechterbovenhoek om een groepschat over dit record in het Team te maken. Als de groepschat niet door de record-eigenaar is aangemaakt, zal de record-eigenaar ook automatisch in de groepschat worden getrokken. Anderen kunnen de groepschat binnengaan door te klikken op de "Team" knop in de rechterbovenhoek van de record-detailpagina of nadat ze zijn toegevoegd door de groepseigenaar.<br> 3. Volg records in de groepschat<br> Maak een groepschat voor klanten en zakelijke kansen records volgens de methode in 4.2, en je kunt de dynamiek van de records in de groepschat volgen door kaarten te sturen. Als de gebruiker toegang heeft om de records op de kaart te bekijken, kan hij, als hij op de kaart klikt, direct naar de gedetailleerde informatie pagina van het corresponderende object springen.<br>? Record veld veranderingen bijhouden in groepschat<br> Als de record is geconfigureerd met de "Veld Volgen" gerelateerde lijst en de velden die bijgehouden moeten worden zijn geconfigureerd, wanneer het bijgehouden veld verandert, zal de groepsstrategie assistent in de groepschat een kaart sturen met de informatie over de veldverandering naar de groep.<br> Alle veranderingen in groepschats bijhouden<br> Als de eigenaar van het record verandert, zal de groepsstrategie assistent in de groepschat een kaart met de veranderingsinformatie van de eigenaar naar de groep sturen.<br> Activiteiten bijhouden in groepschats<br> Nadat de record groepschat is aangemaakt, zal de groepsstrategie assistent in de groepschat, als er een nieuwe taak of gebeurtenis over dit record wordt aangemaakt, een kaart met basisinformatie over de taak of gebeurtenis naar de groep sturen.<br> Het nieuwe record van de gerelateerde lijst bijhouden en opnemen in de groepschat<br> Nadat de record groepschat is aangemaakt, zal de Team assistent in de groepschat, wanneer een record van de gerelateerde lijst wordt toegevoegd, een kaart met de basisinformatie van het nieuw toegevoegde record naar de groep sturen. Bijvoorbeeld: wanneer een nieuwe contactpersoon wordt toegevoegd aan de contactlijst van klantrecords, zal een "Nieuw Contact" kaart worden ontvangen in de klantgroep chat, en de basisinformatie van de nieuwe record kan worden gezien op de kaart.`,
"label.tianyancha.business":`Informatie over bedrijfsregistratie`,
"chatter.group.groupMembersToFind":`Groepslid opzoeken`,
"label.pc.ui.2018.pin.top":`Speld naar boven`,
"label.forecast.forehistory.submitor":`Ingediend door`,
"vue_label_email_send_emails_separately":`Met succes e-mails versturen`,
"vue_label_homepage_select_display_field":`Selecteer veld`,
"label.partnerCloud.partnerAccount.accountBalance":`Balans`,
"label.sendemail.template":`Selecteer e-mail sjabloon`,
"label.service.violated":`Overtreden`,
"label.manageAll.title":`Goedkeuringscentrum`,
"label.forecast.settings.qy":`Voorspellingsdeling inschakelen`,
"label.detailofshare":`Details regel delen`,
"label.multilang.passwordpolicy.chechlength":`Fout: Het wachtwoord mag niet minder dan {0} tekens lang zijn:`,
"label.visualpage.filesave.error":`Bestand opgeslagen mislukt, probeer het opnieuw.`,
"vue_label_campaign_please_select_member_status":`Selecteer uw lidmaatschapsstatus`,
"homepage.components.sort":`Bestel de onderdelen`,
"label.brief.thismonth":`Deze maand`,
"label_emailsync_connectaccount_description":`Voeg hier uw persoonlijke mailbox toe, en CloudCC zal automatisch leads en contactpersonen in het systeem matchen op basis van hun e-mailadressen, en de inhoud van de e-mail synchroniseren met de records om tracking en communicatie te vergemakkelijken.`,
"label.sms.csid":`Handtekening Nummer`,
"label.ccdocument.remark":`Beschrijving van het document`,
"label.forecast.customforecast.disdw":`Weergaveeenheid`,
"label_tabpage_field":`Veld`,
"label.logintime.all":`De hele dag`,
"UG_Account_06":`Maak een account aan`,
"label.login":`Inloggen`,
"label.dupicate.data.error":`Zoek dubbele records en foute samenvoegingen, kijk het na.`,
"label.monitorsys.recent.logs":`De laatste 200 logs worden standaard weergegeven.`,
"message.chooseatleastonefield":`Kies tenminste één veld`,
"lable.PowerProcess.name1":`Naam van het rechtsproces`,
"label.processdetail":`Details procesdefinitie`,
"label.upload.file.size.limit":`De geladen bestanden mogen niet groter zijn dan 2MB!`,
"label.forecast.userenablepage.desc":`Gebruikers die zijn ingeschakeld voor prognoses verschijnen in de lijst Ingeschakelde gebruikers. Om beschikbare gebruikers in te schakelen, voegt u ze toe aan de lijst Ingeschakelde gebruikers. Om gebruikers uit te schakelen, verwijdert u ze.`,
"label.visualpage.type.detailembed":`Gebruiksinstructie van aangepaste pagina (paginastijl is "detailEmbed")`,
"label.textmessage.vonage.configurations":`Configuraties`,
"label.report.select.chart.and.item":`Selecteer de grafiek en het highlight item`,
"label.data.downpage.i.title.num1":`1、Het systeem ondersteunt alleen het gangbare CSV formaat.`,
"label.mobileapp.scansetting":`Instellingen mobiele app scanfuctie`,
"chatter.emailFollow":`Volgt`,
"label.weixin.businformation":`Voertuig Details`,
"label.import.index.recentrecord":`Recente invoergegevens`,
"label.case.update":`Update`,
"label.isEnableVisualpage.new.desc":`Selecteer een beschikbare aangepaste pagina uit Beschikbare aangepaste pagina's en voeg deze toe aan de Geselecteerde aangepaste pagina's, klik op Opslaan. De gebruikers met dit profiel hebben dan toegang tot de actieve aangepaste pagina's.`,
"label.emailobject.wizard.title":`Uw e-mail verbinden`,
"vue_label_ccchat_notice_deletepostsuccess":`Succesvol verwijderd bericht`,
"label.deleteQuoteLine":`Quote regel verwijderen`,
"label.integrations.export.failed.Mailchimp":`De export is mislukt, controleer uw netwerkverbinding en probeer het later nog eens`,
"label.increase":` Plus`,
"label.setup.mobile.homepageshortcuts.setunable":`De module wordt niet getoond op de homepage`,
"label.ccchat.person.invite.toolong":`U kunt geen tekst invoeren die langer is dan 255 tekens`,
"label.knowledge.setting.help":`Zelfbediening voor klanten`,
"label.is_pigeonhole":`Archief`,
"message.atleastonecommitter":`Tenminste één ingediend door wie`,
"label.emailobject.wizard.desc4":`Voeg een voorstel tijd in om het makkelijker te maken voor meerdere mensen afspraak`,
"APPIntegration_Dropbox_setting_02":`Uitgeschakeld`,
"template.report.open.opportunities":`Onbenutte kansen`,
"label.goonwork":`Doorgaan met werken`,
"label.isiands.time":`Isiands tijd`,
"label.enable.rules.enableOnlyOneqrcodeOrbarcode":`Ingeschakelde regels (elk object ondersteunt slechts één QR Code of Bar Code)`,
"label.summaryreport.2018.step2":`Stap 2. Vat de informatie samen door:`,
"pagecreator.systemstyle.message.delete.success":`Stijl succesvol verwijderd`,
"label.standarduser":`Standaard Gebruikers`,
"label.reportsSubscription.succeeded":`Meld u succesvol aan!`,
"lable.Select.a.template":`Selecteer een bestaand sjabloon als basis voor het nieuwe sjabloon.`,
"label.file.library.addfile2libsuccess":`{0} bestand(en) geupload!`,
"label.searchfield.instruction":`Zoekveld is een veld dat wordt gebruikt om globaal te zoeken of te zoeken in een enkel object.Indien standaard niet geselecteerd, wordt gezocht op geselecteerde zoekresultaten veld is geselecteerde zoekresultaten velden.`,
"U":`URL`,
"label.Time.slot.overlap":`Een of meerdere tijdslots hebben overlappende tijdbereiken. Gelieve te updaten naar een tijdslot dat niet overlapt.`,
"vue_label_chat_opportunity_details":`Details van de opportuniteit`,
"label.knowledge.category.hint.seven":`Geselecteerde Categorie Groep`,
"label.chatter.list":`Lijst`,
"front-email-payment-Invoice-preview":`Factuur Voorbeeld`,
"label_emailsync_message1":`Als u de verbinding annuleert, zult u niet in staat zijn om de inhoud van de mailbox te synchroniseren met de leads en contacten, weet u zeker dat u wilt annuleren?`,
"label.summaryreport.step5":`Stap5 De volgorde van kolommen in het rapport bepalen`,
"component_newrecords_label_name":`Naam`,
"label.appointment.wizard.subtitle4-4-5":`2 maanden`,
"component_salesperformance_label_title":`Verkoop`,
"label.ccchat.person.invite.says":`Zeg:`,
"label.fax":`Fax`,
"label.knowledge.modify.article":`Artikel wijzigen`,
"label.componenteditor.Limit.number.components":`Op één pagina kunnen tot 15 componenten worden toegevoegd.`,
"label.multilang.forecast.shrepage.desc":`Deze pagina toont de gebruikers, rollen en regio's die gedeelde toegang hebben tot {0}.`,
"label.chat.micropost.write.comment":`Schrijf commentaar`,
"Lead.Scoring.Setting.Rule.Setup.Active":`Actief`,
"label.ccpeakfolder.time":`Geplande Klas Mappen`,
"label.partnerCloud.financeSetting.filter":`Filter voorwaarden:`,
"label.knowledge.delete.topicassignment":`Fout bij het verwijderen van het onderwerp`,
"label.file.orderbyname":`Sorteren op titel`,
"vue_label_chat_activelater":`Later actief`,
"chatter.reply":`opmerking`,
"label.setup.profile.accordtext":`Volgens de tekst`,
"label.encd.plaintext":`Toon duidelijke tekst`,
"label.h5.approval.cannotreassignmark":`Gedelegeerde goedkeuringsprojecten kunnen niet opnieuw worden toegewezen, gelieve goedkeuringsprojecten opnieuw te selecteren`,
"label.version.area.lookup":`{0} tekstgebied of lookup relatie (multi-select) velden`,
"approval.request.email.body":`Voor de volgende punten is goedkeuring nodig：klik op de link hieronder om goed te keuren：`,
"label.user.mass.emails.select":`Massa e-mail: Selecteer het sjabloon`,
"lable.quote.syncing.title":`Synchroniseer Citaten en Kansen`,
"vue_label_dashboard_dashboardaccess":`Dashboard toegang`,
"label_emailtocloudcc_filed_owner":`Eigenaar`,
"label.brief.page":`Pagina`,
"label.isEnableVisualpage_new.desc":`Selecteer een beschikbare aangepaste pagina uit Beschikbare aangepaste pagina's en voeg deze toe aan de Geselecteerde aangepaste pagina's, klik op Opslaan. De gebruikers met dit profiel hebben dan toegang tot de actieve aangepaste pagina's.`,
"label.service.shift.view":`Werk Verschuivingen Bekijken`,
"label.emailsync.addnewaccount":`Nieuwe rekening toevoegen`,
"label.forecast.settings.prompt":`Uitschakelen van prognose delen zal alle handmatig gedeelde toegang verwijderen.`,
"front-electronic-signature-explain-second":`Bij het binden van de elektronische handtekening, gelieve de foto van de Ondernemingsvergunning en de eengemaakte sociale kredietcode voor te bereiden.`,
"label.emailtocloudcc.redmessage3":`Voer server adres in`,
"message.confirmgiveupedit":`Als u deze pagina verlaat, verliest u alle niet-opgeslagen wijzigingen. Wilt u doorgaan?`,
"label.gantt.plan.success":`Succesvol gepland`,
"label.monitorsys.type.error":`Selecteer het type zoekopdracht.`,
"label.industrialandcommercialverification.button.setup":`Opzetten`,
"today":`Vandaag`,
"label.attendance.setting.position":`Landmarks instellen`,
"chatter.mynews":`Mijn berichten`,
"label.recycle.dis.tip1":`Het systeem bewaart de gegevens gedurende 15 dagen in de prullenbak, en de records worden 15 dagen nadat ze in de prullenbak terecht zijn gekomen definitief verwijderd.`,
"label.icon.81":`Koeling`,
"label.customer.tab.page.prompt":`Configureer op zijn minst een pagina!`,
"label.globalselect.use":`Globale optielijst waarde instellen gebruiken`,
"template.report.customer.sales.order":`Verkoopvolgorde van rekeningen met verschillende niveaus`,
"vue_label_dashboard_lastruntime":`Laatste Looptijd`,
"label.edit.ccpeakfolder":`Klassen：Map Bewerken`,
"vue_label_lead_be_converted":`Is omgezet en kan niet worden omgezet`,
"label.tabpage.filenamez":`Bestandsnaam`,
"label.please.click.add.products.":`Klik op "Product toevoegen" om een product aan het prijsboek toe te voegen.`,
"label.followup_emails":`Zodra een bezoeker een formulier heeft ingediend, is een email een gemakkelijke manier om snel contact met hem op te nemen`,
"label.indochina.time":`Indochina Time`,
"message.error.task.email":`Mail taak anomalie`,
"label.dynamic.copy":`Synchroon opmaakregels kopiëren`,
"label.log.d":`Download audit log binnen zoektijd bereik (Excel.csv bestand) >>`,
"pagecreator_layout_label_layoutname":`Naam van de lay-out`,
"template.chart.htsktj":`Statistieken over de inning van contracten`,
"label.appointment.wizard.subtitle4-2-5":`1 dag`,
"label.view_form":`Formulier bekijken`,
"label.tablet":`Tablet`,
"label.campaignmember.main.addcontact":`Leden toevoegen - Bestaande contacten`,
"message.get.userinfo.error":`Mislukt om gebruikersinformatie te krijgen`,
"label.department.username":`Naam gebruiker`,
"label.ems.verifysuccess":`E-mail account succesvol geverifieerd!`,
"label.batchedit.copyValue":`Van toepassing op deze kolom`,
"label.trigger.triggerVersion":`Versie`,
"label.mr.descreption.oneGroupReData5":`niet verwerkte groepen gegevens.`,
"label.appointmentconfirmpage.wizard.subtitle5":`Beschrijving`,
"label.weixin.inbetween":`Multi-Select`,
"label.salescloud.contactrole.relatelist.customnize":`U kunt deze lijst niet aanpassen`,
"label.data.exp.please.nameanddes":`Voer de naam en beschrijving van de sjabloon in.`,
"label_partner_workspace_login":`Inlogpagina`,
"label.notification.approval7":`【被委派人名称】rejected het goedkeuringsverzoek van 【提交人】 van 【对象】【对象名称】for u.`,
"message.send.posts.image.error":`Post foto uploaden mislukt!`,
"message.fieldtrack.operateupdate":`Gewijzigd`,
"label.sharerule.grantuselevelconstructureaccess":`Toegang verlenen met hiërarchieën`,
"label.translation.setup":`Meertalige installatie`,
"PageLayout.Search.MultiSearch.003":`Kies tenminste één veld.`,
"label.ccchat.person.emaildomain":`E-mail bedrijfsdomein`,
"pagecreator.systemstyle.label.bordercolor":`Kleur rand`,
"label.submit":`Indienen`,
"UG.Lead.001":`Hoe introduceer je aanwijzingen?`,
"label.icon.172":`Kaart`,
"label_chatter_owner":`Eigenaar`,
"vue_label_systemSettings_Currency":`Valuta Beheer`,
"page.layout.binfo":`Essentiële informatie`,
"label.version.date":`{0} datumvelden`,
"label.data.is.woking":`Werking`,
"label.customfields.searchrelation.dependobjectDefault.tip":`U kunt een record in het verwante item selecteren als de standaardwaarde voor dit veld`,
"label.partnerCloud.orderingPlatform.configuration":`Confuguur Producten`,
"lable.currencyManage.Enabledadvcurrency":`Geavanceerd valutabeheer inschakelen`,
"label.event.moveup.3hour":`3 uur vooruit`,
"label.reportexport.object":`Objecten exporteren`,
"front-dialog-module-v1-requestid":`Verzoek ID`,
"label.pw.symol":`Symbolen`,
"label_group_field":`Specificeer groeperingsveld`,
"label.recallapprove":`Verzoek om goedkeuring van een terugroeping`,
"vue_label_pool_deal_done":`Gesloten deal`,
"label.shangqing.description":`Dit is een beschrijving van de bedrijfssituatie`,
"label.view.allcansee":`Zichtbaar voor <b>alle gebruikers</b>`,
"chatter.poll.addOption":`Meer toevoegen`,
"label.icon.112":`Voedsel`,
"label.ignorecase":`Behandel "ABC" en "abc" als dubbele waarden (hoofdlettergevoelig)`,
"label.email.track.edit":`Email bewerken`,
"label_tabpage_erraddressz":`Onjuist formaat van e-mail adres, gelieve e-mail adres correct in te vullen`,
"label_tabpage_viewz":`Huidige weergave afdrukken`,
"component.timeline.label.future":`Volgende stap`,
"label.b_c_without":`"B-records kunnen al dan niet verwante C-records hebben.`,
"label.version.autonumberfield":`Auto Nummer Veld`,
"label.appointmentdetail.wizard.title5":`Uitnodiging URL`,
"label.weixin.addoption":`Optie toevoegen`,
"label.b.c":`B naar C relatie`,
"chatter.group.complete":`Compleet`,
"label.must.numeric.value":`De kosten moeten numeriek zijn.`,
"lable.edit.queue.memberdes":`Om leden aan deze wachtrij toe te voegen, selecteer een type lid, kies dan de rol of gebruiker uit de "Beschikbare leden" en verplaats ze naar de "Geselecteerde leden". Indien het deelmodel voor alle objecten in de wachtrij openbaar lezen/schrijven/overdragen is, hoeft u geen gebruikers aan de wachtrij toe te wijzen, aangezien alle gebruikers reeds toegang hebben tot de records voor die objecten.`,
"label.staticresource.chose.limit":`Bestanden in dit formaat worden tijdelijk niet ondersteund. Wij hopen deze functie te kunnen verbeteren.`,
"vue_label_commonobjects_view_kanban_unset":`Selecteer de groeperingsbasis in de Kanban weergave instellingen`,
"label.appexchange.download.merge.mes":`De volgende conflicterende componenten worden geïnstalleerd via een samenvoeging:`,
"label.sharerule.baseofowner":`Gebaseerd op record eigenaar`,
"label.email.template.manage.SMS":`Beheer SMS Sjabloon`,
"label.imgfield.example.tip":`Het groene pictogram betekent goedgekeurd en het rode pictogram betekent afgewezen.`,
"template.report.potential.customer.industry":`Leidt Industrie`,
"component_hots_label_title":`Laatste aanbiedingen`,
"label_file_use_document":`Gebruik opslagruimte`,
"label.input.path":`Voer het pad van het bestand in`,
"label.partnerCloud.financialSetup":`Partner financiële opzet`,
"label_tabpage_myz":`Mijn`,
"vue_label_pool_discard1":`{1}{2}`,
"label_emailtocloudcc_tip2":`Na het verwijderen, zult u niet in staat zijn om E-mail naar CloudCC te gebruiken, bent u zeker dat u wilt verwijderen?`,
"label.customfields.fielddependency.sure":`Het controlerende veld bevat niet de waarde van het afhankelijke veld. Wilt u doorgaan?`,
"label.project.task.date":`De datum van de taak moet vallen binnen het datumbereik van de mijlpaal waartoe hij behoort.`,
"Report.CantDelete.Info":`{0} rapport is de gegevensbron voor het {1} dashboard en kan niet worden verwijderd!`,
"label.assignment.setup.title":`Regels voor de toewijzing`,
"image.pt.most.maxsize":`De maximale bestandsgrootte is 2 MB.`,
"label.appupload.introduce":`Een package bevat componenten zoals apps, objecten, tabbladen, triggers of pagina's. Deze packages kunnen in de CloudCC App Store worden geplaatst om publiekelijk te delen. De lijst hieronder toont alle packages die door uw organisatie zijn aangemaakt. Om een nieuw package aan te maken, klikt u op New.`,
"label.import.page2.confirm":`Bevestig`,
"label.console.step2.introduce":`Vul de onderstaande velden in om de console te definiëren.`,
"label.extendsfather":`Onder zeggenschap van de ouder`,
"front-homepageobject-module-v1-year":`Dit jaar`,
"front-grasp-sales-opportunities":`CRM helpt u om verkoopkansen nauwkeurig te beheersen, meer leads te werven, snel offertes uit te brengen en meer deals te sluiten, terwijl u omnichannel marketing realiseert en de bedrijfsROI voortdurend verbetert.`,
"label.tab.oldpage":`Oude versie pagina`,
"label.service.miniProgram.intro":`Inleiding`,
"label.data.import.setup.operate.insert":`Werk de bestaande records niet bij, maar voeg alleen nieuwe records toe.`,
"label.ccpeak.direction.for.use":`Beschrijving van het gebruik van CloudCC Platform [Versie 2.0]`,
"label.sendemail.chat.addComentsmyFeedsubject":`CloudCC CCChat micropost antwoord`,
"label.campaignmember.main.importmember.contacts":`Importeren Leden-Contacten`,
"setup.mainpage.label.welcome20":`Mail, SMS sjabloon`,
"label.newbatcheditor.remark":`Voor verschillende records zijn er verschillende recordtypes. Standaard wordt de rij-indeling van het recordtype van het eerste record gebruikt als de pafe-indeling voor massabewerking.`,
"label.step4.total7":`Stap 4 van 7`,
"label.campagin.roi.tzhbl":`Rendement op Investering`,
"label.emailmerge.mergepage.step3":`Een activiteit loggen`,
"label.marketsea.isrecyclecreatebyself":`Wilt u zelfgebouwde rekening recyclen`,
"message.mobilechooseatmost.five":`Op mobiele apparaten kunnen maximaal 5 velden in het menu worden geselecteerd.`,
"label.icon.171":`Pension`,
"label.saveandnext":`Opslaan en verder`,
"label.import.page1.selectcodingtype":`Kies het type codering`,
"label.searchlayout.displaybutton":`Weergegeven knoppen`,
"label.approvalstep5":`Stap 5 selecteer de bewerkingseigenschappen van de velden die op de lay-out van de goedkeuringspagina moeten worden weergegeven`,
"label.passwordPolicy.setup.enforcePswHis":`Wachtwoord geschiedenis afdwingen`,
"vue_label_commonobjects_detail_contact_hierarchy":`Contact hiërarchie`,
"front-kefu-moudle-v1-trythjzx-intelligent":`TRRT(tinet) Intelligent Service Call Center`,
"label.select.statistical.indicators":`Kies een statistische index`,
"label.callcenter.Tianrun.RONGTONG":`TRRT(tinet)`,
"label.file.library":`Bibliotheken`,
"lable.completion.rate.color.setting":`Kleurinstelling van voltooiingspercentage`,
"label.name.firstname":`Voornaam`,
"setup_layout_label_readonly":`Alleen-lezen`,
"label.chatter.recordcall":`een oproep gelogd`,
"label.service.appointmentList.service.empty":`De dienstafspraak is leeg.`,
"component_milestones_label_choicestate":`Bevestig deze status`,
"label.approved.receiveApprovalEmail.option2":`Alleen als ik een goedkeurder ben`,
"label.marketseamemset.account.title":`Leadpool leden instellingen`,
"label.changemydisplay.list.custom":`Mijn tabbladen aanpassen`,
"label.emailtemplate.selecttype":`Kies het type e-mailsjabloon dat u wilt maken.`,
"component_timeline_label_title":`Tijdlijn`,
"chatter.group.addRemoveMembers":`Leden toevoegen/verwijderen`,
"label.console.step6.width":`Breedte`,
"pagecreator.systemstyle.message.delete.fail":`Stijl wissen mislukt`,
"label.partnerCloud.orderingPlatform.productPrice":`{productQuantity}producten，{totalCount} stuks, oorspronkelijke {currency} {originalPrice}，discount：{currency} {Reduction}`,
"label.h5.share":`Deel`,
"label.schedulejob.setup.list.tip":`Stel geplande taken in die automatisch wekelijks of maandelijks worden uitgevoerd.`,
"message.intheapproving":`Het dossier vraagt om goedkeuring en kan niet opnieuw worden ingediend.`,
"vue_label_commonobjects_detail_real_time":`Nadat je lid bent geworden, wordt het team weergegeven in je teamlijst en wordt de dynamiek van het team in real time aan je doorgegeven.`,
"label.autoRegister.changepwd.setpwd.too.weak":`Te kort.`,
"label.salescloud.forbiddenteamsales":`Verboden verkoopteam`,
"component.chatter.link.label.title":`Link`,
"label.layout.editsearchdistribute.page":`Selecteer de aangepaste pagina's die moeten worden opgenomen in het tabblad startpagina`,
"label.dashboard.show.value.percent":`Toon waarden of toon %, kies er minstens één`,
"label.everymonth":`Per maand`,
"label.campaign.channel.download.size1":`Groot formaat 1000*1000 pixels`,
"permissionService.error2":`Het is niet gelukt om licentiepermissies toe te voegen.`,
"button.partner.workspace.manage.memo":`Beheer uw partner cloud en configureer partner cloud eigenschappen.`,
"label.forecast.forehistory.commit.remark":`Nota's van indiening`,
"six":`Six`,
"label.datamanage.donot.export.object":`Objecten die geen gegevens mogen exporteren.`,
"label.schedulejob.setup.schedule.execute":`Uitvoeren`,
"lable.account.CurrentandPreviousCY":`Huidige en vorige CY`,
"label.temp.SMS":`SMS sjablonen`,
"label_partner_all_state":`Status`,
"label.editdocument":`Bewerk Eigenschappen`,
"front-epwechat-module-v1-ios-single":`iOS eenmalige aanmelding`,
"lable.redo":`Redo`,
"vue_label_SMS_alltemplates":`Alle sjablonen`,
"label.allfolderreport":`Alle Rapportmappen`,
"label.layout.alltab":`Alle Tabbladen`,
"lable.account.Yesterday":`Gisteren`,
"label.formula.to.evaluate":`Formule-evaluatie`,
"component_setup_label_setupsaveok":`Componentinstellingen succesvol opgeslagen`,
"pagecreator_page_message_canntdelete":`De huidige pagina mag niet verwijderd worden`,
"label.tab.message.failtotp":`Mislukt om de Tab`,
"label.h5.chatter.location":`Voeg de locatie in`,
"vue_label_commonobjects_view_chart_gotodashboard":`Ga naar Dashboard`,
"label.data.exp.conf":`Weet u zeker dat u gegevens wilt exporteren?`,
"label.currency.e":`Valuta type bewerken`,
"message.matrixReportSetupStage.column":`Kies 【Specify Column Headers】 subtotaalbasis, en u moet ten minste één subtotaalbasis kiezen in twee subtotaalbasissen.`,
"font-evaluate-module-v1-have-comment":`Een evaluatie achtergelaten`,
"chatter.feed.dao":`Naar`,
"label.import.index.notice":`Let op:`,
"label.weixin.information":`Details`,
"label.multilingual.tip5":`De meertalige status is niet correct. Vernieuw en probeer het opnieuw!`,
"label.appointment.wizard.subtitle3-7":`Zondag`,
"label.emailobject.groupemail.fail.content":`Beste {0},Dit is het e-mailadres dat niet verzonden kon worden.`,
"vue_label_notice_uploadavatar_fail":`Kan geen avatar uploaden`,
"chatter.group.myGroup":`Mijn Groepen`,
"label.ccpeak.object.fieldapi.name":`is de veld-API-naam van het object`,
"lable.activeCurrency":`Actieve valuta's`,
"label.file.save.to.send":`Opslaan en verzenden`,
"label.emailmerge.list.editfolder":`Map Bewerken`,
"label.Path.Setting":`Pad instellen`,
"label.validate.function.funcFormat.DATE":`DATUM(jaar,maand,dag)`,
"message.objapiexists":`Dit object API bestaat al.`,
"label.sendmail.batch.confirm":`Massa e-mail: Bevestig`,
"message.approval.cannotsubmit.detail":`Dit dossier voldoet niet aan de voorwaarden of de oorspronkelijke indiening voor een geldig goedkeuringsproces. Neem contact op met uw beheerder voor assistentie.`,
"setup.layout.button.deleteitem":`Verwijder de geselecteerde items`,
"label.end.loginipIP":`IP-adres einde`,
"component_event_label_subject":`Thema`,
"message.500":`Interne fout bij de server`,
"label.wei.polltype":`Soorten`,
"vue_label_norm_duplicate":`Duplicaat`,
"label.addcycletrigger":`Periodieke trigger toevoegen`,
"DetailedInfo.Activity.EmailMessage.01":`{0} stuur een e-mail naar {1}.`,
"No.Activity":`Geen activiteit`,
"label.chat.topic.add.topic":`Klik om een onderwerp toe te voegen`,
"label.schedulejob.setup.schedule.morning":`AM`,
"chatter.save.al":`Uw wijzigingen zijn opgeslagen.`,
"label.setsharerule.step3":`Stap 3 Selecteer de gebruikers met wie u wilt delen`,
"label.tabpage.Sdfez":`Dagen geleden`,
"label_submit_forecast":`Voorspelling indienen`,
"label.version.sum.formulafield":`formulevelden`,
"lable.weixin.you.invitation":`Uw uitnodiging`,
"label.stacked.horizontalbar":`Gestapelde horizontale lijnen`,
"label.file.anyone.can.link":`Iedereen met de link kan het bestand bekijken en downloaden.`,
"label.campaignmember.main.importmember.lead.desc":`Importeer leads uit bestanden.`,
"UG_activity_01":`Hoe houdt u uw gegevens bij om te communiceren met uw rekeningen/teams?`,
"label.reason":`Reden`,
"label.version.free.createmax":`Er kunnen 2000 records worden aangemaakt, de bovengrens is bereikt.`,
"label.brief.thisweek":`Deze week`,
"label.deleteobjinapprove":`Voer het commentaar in voordat u dit object uit het goedkeuringsproces kunt verwijderen.`,
"calendar.tips.event":`dag(en) zonder evenementen`,
"label.customerinfo.mailinfo":`Organisatiebreed e-mailadres`,
"lable.electronic.signature":`Ehandtekening`,
"label_emailsync_addnewaccount":`Nieuwe rekening toevoegen`,
"label.layout.exampleoftesgobj":`Testobject Voorbeeld`,
"label.happen_submit":`Wat moet er gebeuren nadat een bezoeker dit formulier heeft ingediend`,
"label.forecast.customforecast.button.submit":`Indienen`,
"label_right_click_notice":``,
"font-trade-module-v1-invoice-no-price":`Terug te betalen`,
"lable.opppdt.selPdt.morecondtions":`Meer filters`,
"label_invalid_token":`Ongeldig token`,
"label_chatter_postup":`Post omhoog`,
"label.escalation.setup.newaction.step1":`Stap 1 Specificeer de tijdscriteria voor deze regel`,
"label.sendmail.step3.dealoption2":`Bewaar een activiteit voor elk bericht`,
"front-kefu-moudle-v1-yesornoBatch-delete-templete":`Weet u zeker dat u sjablonen in batch wilt verwijderen?`,
"vue_label_appstore_enter_website":`Ga naar de officiële website`,
"label.when":`Tijd van publicatie`,
"label.linellae":`Lijnen`,
"label_chatter_detailinfo":`Gedetailleerde informatie`,
"lable.SalesCommitmentKanBan.receivingTaskRate":`Ontvangsten Taak Voltooiingspercentage`,
"vue_label_homepage_dashboard_deleted":`Het dashboard is verwijderd`,
"pagecreator.layout.button.vertical":`Longitudinale demontage`,
"label.redistribution1":`Selecteer tot 5 items`,
"pagecreator_page_label_modifypage":`Pagina-editor`,
"label.Service.Cloud.Setting":`Service Cloud-instelling`,
"setup_layout_label_pagename":`Naam pagina-indeling`,
"label.ems.send":`Stuur`,
"vue_label_commonobjects_view_kanban_notice1":`Kanban-weergave toont alleen de eerste 200 records`,
"lable.outlook.detail.maping":`Veldtoewijzingen`,
"vue_label_pool_abandonorrestore":`{1}{2}`,
"label.mobile.side.tab":`Mobile side slider instelling`,
"label.trigger.operation.email.template.param":`Doorgeven van parameters: taal, e-mail sjabloon ID, en record ID`,
"front-objectTemplate-V1-Select-a-template":`Selecteer een bestaand sjabloon als basis voor het nieuwe sjabloon.`,
"label.email.template.delete.template":`Weet u zeker dat u dit sjabloon wilt verwijderen?`,
"label.reportsSubscription.cancel":`Annuleren`,
"lable.quote.syncingfrom.firstsync.description":`De producten van de opportuniteit zullen de posten van de offerte vervangen`,
"label.weixin.no.pending.xsld.qin":`Sorry, geen verkooptrechter gegevens om te laten zien.`,
"template.dashboard.sales.indicators":`Verkoopindicatoren`,
"label.field.new":`De gebruikers evaluatie- en scoringsoperaties ter beschikking stellen.`,
"label.generatepage.title.desc1":`Genereer mobiele of PC-versie van de HTML-code op basis van de geselecteerde velden, gebruikers kunnen de code naar behoefte aanpassen.`,
"template.report.source.potential.customers":`Leads Bron`,
"label.mr.title.queryData":`Duplicaten zoeken`,
"button_partner_workspace_enable":`Schakel partner cloud in`,
"V":`Auto Nummer`,
"label.icon.19":`Map`,
"vue_label_report_summaryformula":`Samenvattende formule`,
"label.appointment.wizard.subtitle2":`Beschikbaar datumbereik`,
"label.stdashbord.xsld.business.bjdzhl":`Stadium Omzettingspercentage`,
"label.forecast.forehistory.deopportunity":`Kansen`,
"chatter.email.referredToMeLeaveMessage":`Noemt mij in een reactie`,
"label.dategrouprelyon":`Datum Groeperingscriteria`,
"label.sendmail.batch.finish":`Massa e-mail: Ingevuld`,
"label.weixin.allexpired":`Allemaal te Laat`,
"label.dashboardSetup.showdw.d4":`10 duizend`,
"message.duplication.label.masterRecord":`Master Record`,
"vue_label_calendar_availability":`Beschikbaarheid`,
"vue_label_chat_approval_message":`Goedkeuringsbericht`,
"vue_label_zhang_er":`Jenny`,
"label.select.options":`Selecteer de opties`,
"label.israel.daylight.time":`Israël Standaard Tijd`,
"front-sales-search-QB":`0 gegevens in totaal, of een nieuwe rekening aanmaken in de QuickBooks`,
"vue_label_account_change_customer":`Klant eigenaar wijzigen`,
"label.integrations.mailchimp2":`Meer informatie over CloudCC en Mailchimp`,
"lable.product.pricebooks.onisu":`Inactieve Prijs Boeken`,
"front-electronic-signature-backfill-field":`Opvulveld`,
"label.document.myself.folder":`Mijn persoonlijke mappen`,
"label.event.moveup.10hour":`10 uur vooruit`,
"report.label.report":`Verslagen`,
"label.validate.function.funcFormat.CONTAINS":`CONTAINS(tekst, vergelijk_tekst)`,
"label.usermanage.query.false":`Query mislukt, de gebruiker bestaat niet.`,
"front-epwechat-module-v1-input-EncodingAESKey":`Voer EncodingAESKey in`,
"label.event.multi.view":`Weergave voor meerdere gebruikers`,
"label.h5.similar.opportunity.setup":`Gelijkaardige mogelijkheden Instellingen`,
"label.setting.intergrationlist.button.install":`Installeer`,
"label.event.monthview":`Maandweergave`,
"label.version.weixin":`WeChat-versie`,
"label_emailtocloudcc_redmessage6":`IMAP/SMTP-verificatie mislukt, controleer of het e-mailadres en het wachtwoord juist zijn.`,
"UG.homepage.003":`360 graden zicht`,
"vue_label_calendar_shared_calendar":`Kalender delen`,
"label.select.hope.merge.num1.record":`Selecteer de records die u wilt samenvoegen tot één record. Kies maximaal 3 records per keer.`,
"label.createnewprocess":`Creëer nieuw goedkeuringsproces`,
"font-trade-module-v1-invoice-status":`Status van betaling`,
"label.customerinfo.introduce":`Informatie over het bedrijf`,
"label.objectname":`Object Naam`,
"label.chosen.field":`Geselecteerde Velden`,
"label_target_name":`Naam van het doelmodel:`,
"label.appointment.wizard.subtitle4-4-4":`1 maand`,
"label.emailobject.groupemail.msg1":`Geen e-mailadres`,
"label_component_hotdeal_nopermission":`Neem contact op met uw CloudCC-administratie om uw aan zakelijke kansen gerelateerde gegevens te bekijken.`,
"label.appointmentdetail.wizard.title13":`Beschrijving`,
"front-web-module-v1-detail-comment-title":`Geef commentaar op deze dienst`,
"label.visualpage.component.n1":`1. Bel methode.  `,
"lable.outlook.mcto.erecord":`de vroegst gecreëerde records`,
"label.weixin.del.log":`Verwijdering Log`,
"setup_mainpage_label_welcome23":`Beveiligingsinstellingen`,
"label.selectreportline":`Selecteer de kolommen van het verslag`,
"label.chatter.following":`Naar aanleiding van`,
"seven":`Zeven`,
"message.error":`FOUT1a`,
"label.mobile.phone.reporter":`Ingediend door`,
"label.valadate.telphone.false":`Telefoonnummer ingevoerd fout, gelieve opnieuw in te voeren`,
"label.linkedin.setting":`LinkedIn H5 MiniApp integreren`,
"label.mobile.side.tab.success":`Sla de instelling van de schuifbalk aan de mobiele kant met succes op.`,
"label.notification.approval3":`Goedkeuringsaanvraag voor de 【对象】 wordt opnieuw toegewezen aan 【重新审批人】`,
"label.channel.invites.employees":`Het personeel van dit kanaal uitnodigen`,
"label.assignment.setup.detail.assigner":`Toewijzen aan`,
"label.campaignmember.main.updatecontactdesc":`Update de status van alle contacten in één keer`,
"label.permission.detail.app.fenpei":`Toepassingen toewijzen`,
"label.copydown":`Copy Down`,
"label_emailsync_status_action":`Actie`,
"lable.Please.switch":`Schakel naar horizontaal of verticaal menu om deze functie te gebruiken.`,
"label_adjust_remark":`Opmerkingen over de aanpassing`,
"label.weixin.newspaper.coverage.list":`Risico bladen`,
"label.datamanage.contact.field":`Contact Velden`,
"label.partner.workspace.login.headerfooter":`Koptekst en voettekst`,
"lable.account.quarter.ovdate":`Einddatum fiscaal kwartaal`,
"pagecreator.systemstyle.label.textcolor":`Tekst kleur`,
"label.industrialandcommercialverification.fieldmappingsettings":`Veldtoewijzing instellingen`,
"component_chatter_button_message":`Commentaar`,
"label.partnerCloud.enterAddress":`Voer het adres in`,
"label.email.template.recently.used":`Onlangs gebruikt`,
"component.event.label.calendar":`Bekijk Kalender`,
"label.setup.mobile.offlinecache.setting":`Offline cache-instellingen aan mobiele zijde`,
"label.custom.PreviousCQ":`Vorige CQ`,
"lable.total.of.payments":`0 betaling in totaal`,
"label.ccpeak.use.class.time.trigger":`Als de trigger de klasse aanroept, kun je de methoden in de CCService direct gebruiken.`,
"label_tabpage_addresswrongz":`Het formaat van het postbusadres is onjuist, voer het postbusadres correct in!`,
"vue_label_homepage_select_components":`Componenten kiezen`,
"front-kefu-moudle-v1-secretID-reinput":`Voer secretID in`,
"label.ccdocument.select.template.red":`Kies een sjabloonset.`,
"vue_label_email_public_template":`Openbaar sjabloon`,
"label.eowechat.openid":`WeCom ID`,
"label.user.ip.notlogin.range":`Dit IP is niet in het IP bereik.`,
"chatter.email.reply.collection":`Commentaar op een item dat ik bookmarked`,
"label.integrations":`Integraties`,
"label.permission.modifyAppPermission.selectedapp":`Geselecteerde toepassingen`,
"label.privacystatement":`Privacyverklaring`,
"label.specificvalue":`Een specifieke waarde`,
"label.appointmentconfirmpage.wizard.subtitle2":`Datum en tijd`,
"label.message.ispartner.delete":`Omdat de contactpersoon al aan de partnergebruiker is gekoppeld, kan de klant niet worden verwijderd`,
"report_button_go":`Ga naar`,
"label.h5.similar.opportunity":`Gelijkaardige Mogelijkheden`,
"UG_Lead_005":`Brievenbus`,
"label.num.length.not.overstep":`de lengte van de waarde mag niet meer dan 18 bits bedragen`,
"label.profile.mobile.setup.CEOandDirector":`CEO en verkoopdirecteur`,
"label.addfield":`Veld toevoegen`,
"template.dashboard.institutional.overview":`Agentschap Overzicht`,
"label_tabpage_datefield":`Wanneer het datumveld gelijk is, kan het "gisteren", "vandaag", "morgen", "vorige maand", "deze maand", "volgende maand", "vorige week", "deze week", "volgende week" of "JJJJ-MM-DD、MM/DD/JJJJ" formaat gebruiken.`,
"label.category.7":`Toerisme`,
"UG_contact_02":`Contacten benaderen via meerdere kanalen, telefoon, e-mail, sociale media`,
"chatter.feed.menutype.feed.mecom":`Nieuw bericht voor mij`,
"vue_label_systemSettings_calltemplate":`Brief sjabloon`,
"approval_process_errore":`Er is een fout opgetreden tijdens het opslaan, neem contact op met de beheerder.`,
"label.tabpage.choosefilez":`Selecteer bestand`,
"label.changemydisplay.chagetab.cusapp":`Aangepaste apps`,
"clearadvancedoption":`Filterlogica wissen`,
"front-epwechat-module-v1-binding-user":`Gebonden Gebruikers`,
"label.customfields.fielddependency.null":`Geen afhankelijkheden gedefinieerd.`,
"label.enterprise":`Enterprise Editie`,
"font-evaluate-module-v1-five-points":`Neutrale score: 5 punten`,
"lable.Synchronize.from.QuickBook":`Synchroniseren vanuit QuickBook`,
"front-gantt-module-v1-task-number":`Taak Bedrag`,
"label.currency.edit.newexchagecurrency":`Gedateerde wisselkoersen`,
"label.partnerCloud.partnerSite":`Partner`,
"label_tabpage_unequalz":`Ongelijk aan`,
"label.version.solutions":`Oplossingen`,
"label.setting.intergrationlist.button.installed":`Geïnstalleerd`,
"label.h5.chatter.share":`Bestanden delen`,
"front-epwechat-module-v1-unbound-item4":` binding van externe rekeningen`,
"label.textmessage.vonage.accessibility.setting":`Toegankelijkheid Instelling`,
"font-evaluate-module-v1-evaluation-set":`Evaluatieinstellingen`,
"message.servicecrew.time.violation2":`Buiten werktijd`,
"label.processinfo":`Informatie over het goedkeuringsproces`,
"label.knowledgebase.last.modified":`Laatst gewijzigd`,
"label.to.phone":`Naar`,
"label.baseoffirsttimereply":`Goedkeuren of Afwijzen op basis van<strong>eerste </strong>antwoord`,
"label.projectManagement.startingEndingTime":`Tijd`,
"label.licence.enable":`Actief`,
"label.partnerCloud.basicSetting.cshua":`Partner Cloud initialiseren`,
"APPIntegration.Dropbox.setting.03":`Dropbox inschakelen om bestanden uit Dropbox te kunnen selecteren en als bijlage toe te voegen.`,
"label.account.contact":`Contact AI`,
"label.many.dayline.tab":`Mark`,
"label.weixin.input.username":`Vul uw naam in.`,
"label.logintime.pagecue.invalido":`De eindtijd moet de hele dag zijn.`,
"label.icon.30":`Boek`,
"label_tabpage_advancedscreening":`Geavanceerd filter`,
"lable.currencyManage.unEnabledadvcurrency.agree":`Ja, ik wil Advanced Currency Management uitschakelen.`,
"label.tab.web.new":`Nieuw webtabblad`,
"label.bmap.tiananmen":`Tiananmen`,
"label.disabled":`Uitgeschakeld`,
"error.currencyAdv.deleteprecodedate":`Kan de datumwisselkoers van een valuta niet wissen.`,
"message.error.view.checkbox.validerr":`Fout: gelieve waar of onwaar te gebruiken`,
"UG_ST_006":`Direct invoeren`,
"label.dongshifang.title":`DongShiFang SMS`,
"label.data.dataexpalltype.all.desc3":`3、Export Succesvolle gegevens zal een gecomprimeerd bestand dat gebruikers kunnen downloaden van de export succes lijst pagina op basis van de informatie in de e-mail te genereren.`,
"vue_label_pool_returnreason":`Reden van terugkeer`,
"label.list.userinterface.des":`Wijzig de gebruikersinterface met de volgende instellingen:`,
"label.notification.approval2":`Goedkeuringsaanvraag voor de 【对象】 is afgewezen door 【审批人】`,
"label.service.dispatchingUnits.the.level":`Niveau`,
"front-email-payment-Invoice-preview-tips":`Alle factuursjablonen zijn momenteel uitgeschakeld. Neem contact op met de beheerder om het sjabloon in te schakelen voordat u facturen genereert.`,
"label.dashboard.isAvailableFieldOfComponentGroupInTheReport":`Fout:een of meer van de velden die zijn geselecteerd in het component zijn niet langer beschikbaar in het rapport. <br>gebruik de dashboard component editor om een van de beschikbare velden te selecteren.`,
"label.import.step2.chooseidorother":`2、U kunt kiezen om ID of naam te gebruiken om de record te matchen en het lookup veld in te vullen. Als u de bijbehorende record ID en andere informatie wilt verkrijgen, kunt u een rapport maken en de record naam en record ID als groepskolommen instellen, en vervolgens het rapport exporteren.`,
"label.customobjects.introduce":`Custom objects zijn databasetabellen die u in staat stellen om gegevens op te slaan die specifiek zijn voor uw organisatie in CloudCC. U kunt aangepaste objecten gebruiken om CloudCC-functionaliteit uit te breiden of om nieuwe applicatiefunctionaliteit te bouwen.`,
"label.visualpage.oldsystem":`Oude versie`,
"label.icon.94":`Boek`,
"label.setup.log.desctiption":`U kunt het gedragspoor van uw organisatie downloaden (Excel.xls)`,
"label.dynamicpage.layout":`Lay-out regels`,
"lable.list.queue.objct":`Ondersteunde objecten`,
"label.customfields.placeholder.tip":`Voorbeeldtekst wordt weergegeven in het invoervak en verdwijnt nadat het de focus heeft gekregen`,
"label.ems.activationtime":`Activeringstijd`,
"label.detailinfo":`Details`,
"label.icon.17":`Verslag`,
"label_emailtocloudcc_button_complete":`Afwerking`,
"label.visualpage.component.n2":`2. Merk op dat de "component tags" niet kunnen worden genest binnen <cc>tags".`,
"label.object.name.one":`Objectnaam 1`,
"label.summaryreport.step2":`Stap 2 Kies de samengevatte gegevens`,
"thisisanew":`Nieuw!`,
"label.query.detail.editpartneruser":`Bewerk partner gebruiker`,
"label.tabpage.newview":`Maak een nieuw beeld`,
"label.partnerCloud.productSet.addNew":`Nieuwe optie`,
"label.appupload.upload.new.remark":`Dit is een nieuw onderdeel`,
"label.case.ptext":`Wij hebben uw bedrijf gekoppeld aan de websiteversie van het portaal. Kopieer het adres van de webversie van het klantenserviceportaal voor uw bedrijf en voeg het portaal toe op uw officiële website.`,
"lable.PowerProcess.name":`Rechtsproces`,
"label_tabpage_choosefilez":`Selecteer bestand`,
"homepage.components.place":`Component Positie:`,
"lable.Synchronization.failure":`Mislukt te synchroniseren`,
"label.dashboard.snapshot.get.data":`Haal uw gegevens`,
"label.input.invalid.format":`Voer het geldige formaat in`,
"label.quickbooks.view.openinvoices":`Openstaande facturen`,
"label.weixin.seating":`Seating`,
"label.searchlayout.remark":`Met zoeklay-outs kunt u de standaard- en aangepaste velden selecteren die in de volgende zoekfuncties worden weergegeven:`,
"label.escalation.setup.entrydetail.escalation.assiner":`Toewijzen aan`,
"vue_label_calendar_availability_view":`Kalender-beschikbaarheidsweergave`,
"label.country":`Land`,
"label.campagin.roi.zl":`Overzicht`,
"lable.currencyManage.advcurrencyEnabled":`Geavanceerd valutabeheer is ingeschakeld`,
"label.projectManagement.project.task":`Project Taak`,
"label.appointmentpage.wizard.subtitle3-2":`E-mail`,
"label.input.invalid.date":`Voer de geldige data in`,
"vue_label_chatter_my_followers":`Mijn volgelingen`,
"label.setupdevelop":`Ontwikkelen`,
"label.sendemail.send.checksend":`Controleer of de e-mail met succes is verzonden`,
"label.eventfield":`Gebeurtenis Velden`,
"label.ccpeak.ccobject.put":`gebruik put om toe te wijzen aan CCobject, bijvoorbeeld:`,
"label.campaignmember.main.addMemberDesc":`U kunt de bestaande leads en contacten doorzoeken, aan deze campagne toevoegen of de bestaande campagneleden beheren.`,
"label.knowledge.setting.hint.eleven":`Gegevens categorie invoeren`,
"label.knowledge.category.button.four":`Broer of zus categorie toevoegen`,
"label.icon.27":`Leer`,
"vue_label_chatter_certification":`Weet je zeker dat je {isStatus} "{titleName}"?`,
"label.data.downpage.i.title.btn":`Ga naar de import pagina en begin met importeren`,
"label.campaign.channel.step6.pc":`PC-pagina genereren`,
"label.mr.caption.rule":`Regels: u moet een of meer regels selecteren voor het vinden van duplicaten`,
"label.service.gantt.resourcestype":`Type bron`,
"label.searchfitconditions":`Zoek die aan de volgende criteria voldoen:`,
"label.partner.template.name":`Naam sjabloon`,
"setup.mainpage.label.welcome15":`CloudCC Cloud Platform workflowregels automatiseren het ondersteuningsproces voor uw verkoop, marketing en meer. Afhankelijk van een voorgedefinieerde set regels kunnen records automatisch aan gebruikers worden toegewezen of van de ene gebruiker naar de andere worden geconverteerd. Het belangrijkste voordeel van workflowbeheer is het verbeteren van de werkefficiëntie door het elimineren van veel onnodige handelingen bij het bijwerken van records, en het verbeteren van de bedrijfsverwerkingsniveaus en het optimaliseren van controleprocessen door het standaardiseren van werkmethoden en het verlagen van operationele kosten. Het ondersteunt onbeperkte oneindige goedkeuring voor elk object, en kan herinneringse-mail, SMS-herinnering, taak, veldupdate en andere functies triggeren.`,
"vue_label_commonobjects_view_chart":`Grafiek`,
"label.salescloud.teamrole.choose":`Selecteer de rol van het team`,
"lable.outlook.mcto.emailrel":`E-mail Associaties`,
"front-invoice-online-payment-setup-describe":`Snelle toegang, toegang met één klik. Eenvoudige, veilige en snelle online betaalservice.`,
"label.korean.standard.time":`Korea Standaard Tijd`,
"label.lord.howe.standard.time":`Lord Howe Daglicht Tijd`,
"setup_layout_group_button":`Knoppen`,
"label.editdefaultshare":`Standaardinstellingen organisatiebreed delen Bewerken`,
"label_fiscal_year":`Fiscaal jaar`,
"label.appointmentdetail.wizard.title2":`Eigenaar`,
"label.email":`E-mail`,
"label.city":`Stad`,
"label.knowledgebase.data.recovery.failed":`Herstellen {a} gegevens mislukt`,
"setup_mainpage_label_welcome6":`Gebruikers kunnen verschillende veldtypes aanmaken in alle objecten van het CloudCC systeem zonder enige programmeerkennis of code-ontwikkeling. De veldtypes zijn onder andere: zoekrelatie, enkel-selectieveld, dubbel-item selectie, formule, automatische nummering. URL, telefoon, fax, e-mail, checkbox, datum, tijd, getal, tekst, tekstgebied, optielijst (enkelvoudige/meervoudige selectie), valuta, enz.`,
"label_emailtocloudcc_button_enable":`Actief`,
"label.account.custom":`Aangepast fiscaal kwartaal`,
"label.custompublish_time":`Tijd van klantenpublicatie`,
"label.dashboardSetup.selwz":`Weergegeven positie`,
"component_todaytask_label_all":`Bekijk Alle`,
"label.service.resource.group.tip":`Dienstmiddelen die betrekking hebben op bemanningssoorten moeten het bemanningssoort gebruiken.`,
"label.tianyancha.legalpersonname":`Naam rechtspersoon`,
"component.setup.label.titlefield":`Titel veld`,
"label.email.template.public.mail":`Openbare email sjabloon map`,
"front-template-V1-DeleteTempalte":`Weet u zeker dat u "{currentTelmplateName}" wilt verwijderen?`,
"pagecreator.layout.label.layoutdesc":`Lay-out beschrijving`,
"vue_label_file_singel_upload":`Er kan slechts één bestand worden geüpload. Als u het bestand moet vervangen, verwijder dan eerst het geüploade bestand`,
"label.view.hierarchy":`Hiërarchieën weergeven`,
"label.file.owner.settings":`Instellingen eigenaar`,
"label.sales.dashboard.name":`Naam`,
"label.offfer.filer.name":`Quote Bestandsnaam`,
"label.quickbooks.view.recentlypaid":`Onlangs Betaald`,
"label.step1.select.merge.records":`Stap 1 selecteer de samen te voegen records`,
"message.recordtype.assignprofile.tip":`Schakel het selectievakje Inschakelen voor profiel in om het nieuwe recordtype beschikbaar te maken voor een profiel. Gebruikers die aan dit profiel zijn toegewezen zullen in staat zijn om records van dit recordtype aan te maken, of dit recordtype aan bestaande records toe te wijzen. Om het nieuwe recordtype de standaard voor een profiel te maken, selecteer het Maak standaard selectievakje.`,
"label.appointmentdetail.wizard.title9":`Reistijd`,
"label.group":`Groepen`,
"label.deltorecycle":`Verwijderen naar prullenbak`,
"label.import.index.numlimit":`1. Alleen csv-bestanden worden ondersteund en er kunnen maximaal 30.000 records per keer worden geïmporteerd (<span style="color: red">up to 2.000 records kunnen worden geïmporteerd als u een trigger moet uitvoeren</span>). Records die de limiet overschrijden zullen automatisch genegeerd worden door het systeem. Als u meer gegevens wilt importeren, splitst u deze eerst op in meerdere bestanden en importeert u ze op verschillende tijdstippen. .`,
"label.file.delete.desc":`Het verwijderen van een bestand zal het ook verwijderen uit alle andere bestanden of berichten.`,
"UG_activity_04":`Outlook/Gmail postvak, e-mail opnemen`,
"label.event.all.undealt":`Alle onverwerkte gebeurtenissen`,
"label.appupload.upload.install.error":`Deze toepassing kan niet worden geïnstalleerd. beëindig de installatie of wijzig de systeem-api en installeer hem opnieuw!`,
"template.chart.yqydcpsl":`Aantal geactiveerde producten`,
"label.import.index.advancepreparation":`Voorbereidingen`,
"label.eowechat.epdeptnamee":`WeCom Naam afdeling`,
"front-kefu-moudle-please-input-servernum":`Voer het nummer van de serviceaanvraag in.`,
"label.lookup.autocmp.nodata":`Geen overeenkomstige gegevens`,
"vue_label_pool_assign":`Toewijzen`,
"label.knowledge.timing.publish":`Timed publish is mislukt`,
"label.selected.groups":`Geselecteerde Quote-lijngroepen`,
"front-epwechat-module-v1-removesele-desc":`Na het verwijderen, zullen alle instellingen van deze toepassing worden verwijderd. Bent u zeker om te verwijderen?`,
"label.batchtransfer.type2":`Overdracht Gesloten Oppertunities`,
"label.richtext":`Tekstgebied (Rijk)`,
"label.icon.174":`Vliegtuig`,
"vue.please.select.grouping.basis":`Selecteer de Groep per optie.`,
"label.matrixreport":`Matrixrapport`,
"label.jiandangfenpei.leftlist":`Niet-toegewezen Profielen`,
"label_chatter_card":`Kaart`,
"label.file.enter.title":`Voer de titel in`,
"label.the.record.is.locked.and.cannot.be.selected.":`Dit record is vergrendeld, niet selecteerbaar.`,
"label.partner.success":`Succes! domein is beschikbaar`,
"label.selectreporttype":`Selecteer rapport gegevensbron`,
"report.type.label.productPricebooks":`Producten en Prijsboeken`,
"label.texttemplate.mergefields.tip":`Voeg invulvelden toe tijdens het bewerken van de SMS inhoud. Wanneer de SMS wordt verzonden, kunnen de velden worden vervangen door de overeenkomstige tekst. Bijvoorbeeld, {!Contact.naam} kan worden vervangen door de naam van de contactpersoon bij het versturen van de SMS.`,
"label.publicgroup.detail.showallusers":`Bekijk alle gebruikers`,
"label.brief.follow":`Follow Up`,
"label.forecast.settings.qijian.p":`Prognose per kwartaal`,
"label.sms.url":`URL`,
"setup_layout_group_custompage":`Pagina aanpassen`,
"label.validate.function.funcFormat.BEGINS":`BEGINS(tekst, vergelijk_tekst)`,
"label.umeng.chatter.sendmessage":`stuurde je een bericht`,
"label.pc.layout":`PC-indeling`,
"label.currency.v":`Voer decimalen in (aantal cijfers rechts van het decimaalteken) die zijn toegestaan bij het weergeven van gegevens in deze nieuwe valuta. Het moet een geheel getal zijn met een waarde tussen 0 en 6.`,
"label.projectManagement.kanbantask":`Kanban Taak`,
"component_recdetail_label_title":`Gedetailleerde informatie`,
"label.isremider":`Herinnering`,
"front-epwechat-module-v1-input-home-url":`Voer homepage URL in`,
"label.usefullife":`Aflooptermijn`,
"label.visualpage.ptype":`Common`,
"label.quote.name":`Citaat naam`,
"vue_label_report_addtocomponent":`Weet je zeker dat je {naam } wilt toevoegen aan de componenten bibliotheek?`,
"label.dashboardSetup.showdw.d1":`100 Miljoen`,
"label.validate.function.funcFormat.OR":`OR(logisch1,logisch2,...)`,
"label.component.helper.potentialcustom":`Leads die vandaag aan u zijn toegewezen`,
"label.autoRegister.changepwd.setpwd.tip.number":`Tenminste één nummer`,
"label.data.setok.e.desc3":`， uw geëxporteerde gegevens downloaden.`,
"label.data.downpage.e.title.num4":`4、 De export bestanden hebben twee formaten: CSV-formaat en het compressieformaat. De compressie-indeling is verdeeld in twee soorten: een is om automatisch te genereren het gecomprimeerd bestand wachtwoord, de andere is om handmatig in te voeren het gecomprimeerd bestand wachtwoord.`,
"lable.quote.editqtpdt.description":`Selecteer een prijsboek voor deze offerte. U kunt slechts een product uit één prijsboek toevoegen, en als u het geselecteerde prijsboek wijzigt, worden alle bestaande producten uit de offerte verwijderd.`,
"front-kefu-moudle-edit-userinfo":`Gebruikersinformatie bewerken`,
"label.please.ChooseMinAndMax":`Kies tenminste {0} product opties, en tot {1} kan worden gekozen.`,
"label.knowledgebase.archive.an.article":`Een artikel archiveren?`,
"label.multilang.customforcast.submit":`Dient u een prognose in van {0}fiscaal jaar{1} tot {2}fiscaal jaar{3}?`,
"label.import.index.filename":`Bestandsnaam`,
"front-console-no-reco-contact":`Contact kan niet worden geïdentificeerd`,
"label.quantity.greater.than0":`De hoeveelheid moet groter zijn dan 0.`,
"label.codeNorm":`Code Standaard`,
"label.average":`Mean`,
"label.multilang.page1":`Pagina`,
"label.data.exp.save.ok":`Sjabloon succesvol opslaan`,
"message.error.delete.record":`Het te wissen record werd niet gevonden!`,
"label.newvaluereplaceoldvalue":`Globaal een bestaande waarde in een keuzelijst vervangen door een nieuwe waarde. Zorg ervoor dat u eerst de nieuwe waarde in het veld van de keuzelijst hebt aangemaakt.`,
"label.tabpage.saveviewsuccess":`Weergave succesvol opgeslagen`,
"label.partnerCloud.productSet.parentOptions":`Ouderoptie`,
"label.emailtemplate.availablemergefields":`Beschikbare samenvoegvelden`,
"label.data.import.setup":`Instellingen gegevensimport`,
"label.escalation.setup.entrydetail.escalation.action":`Escalatiemaatregelen`,
"System.TimeField.Description":`Hiermee kunnen gebruikers een lokale tijd invoeren. Bijvoorbeeld, "14:40 PM", "14:40" en "14:40:00" zijn allemaal geldige tijden voor dit veld.`,
"front-additional-products":`Andere producten kopen`,
"label.appointment.wizard.subtitle4-4-1":`1 week`,
"label.chatter.colleagues.list":`Lijst van collega's`,
"label.log.invalid.data":`Ongeldige datum`,
"label.file.preview.unconvert":`Er wordt geen preview informatie gegenereerd, klik op preview details`,
"label.customer.detailed":`Kies de pagina voor dit nieuwe tabblad. Voer andere details in.`,
"label.sendsms.content":`De inhoud is als volgt:`,
"label.exported_to":`Het geëxporteerde bestand wordt gemaild naar`,
"label.attendance.checkin":`Inchecken`,
"Dashboard.NoAccessRightToSee.Warning":`U heeft geen toestemming om de dashboads {0} te bekijken die zijn ingesteld als defaitt open, gelieve te resetten.`,
"message.choosedelete":`Selecteer de gegevens die u wilt verwijderen`,
"label_tabpage_choosecontent":`Selecteer de waarde-inhoud`,
"label.no_responses":`Geen reacties`,
"report_type_label_customService":`Klantenondersteuning`,
"label.report.select.condition":`Voorwaarden`,
"label.umeng.activity.distributeevent":`je een evenement toegewezen.`,
"label.knowledge.language.portuguese":`Portugees`,
"label.knowledgebase.published":`Gepubliceerd`,
"UG_opportunity_001":`Hoe volgt u uw verkoop?`,
"label.mr.caption.scope":`Bereik: alle gegevens opvragen indien niet geselecteerd`,
"message.login.mfaverification.to.pclogin":`Uw organisatie heeft de secundaire aanmeldingsverificatie ingeschakeld, de eerste aanmelding vereist binding met het mobiele apparaat, gebruik de pc-kant voor aanmeldingsbinding`,
"vue_label_dashboard_pleaseenterthecolorrange":`Voer het kleurengamma in`,
"label.emailsync.status.time":`Tijd`,
"chatter.putup":`Een bestand delen`,
"vue_label_report_drillcondition":`Boor conditie`,
"label.emailobject.list.myemail":`Mijn e-mail`,
"label_tabpage_andz":`En`,
"label.share_link":`Deel Link`,
"label.emailtocloudcc.exists2":`Deze mailbox is ingesteld op E-mail naar Zaak. Instellingen niet herhalen.`,
"label.icon.89":`Advies`,
"front-kefu-moudle-v1-qdygbzx-chat":`Ben je zeker dat je online chatten uitschakelt?`,
"label.approval.selectone":`Kies ten minste één actie.`,
"chatter.group.groupName":`Naam van de groep`,
"label_chatter_relateitem":`Gerelateerd aan`,
"label.file.folder.delete1":`Map verwijderen?`,
"Pagelayout_Setup_003":`Het veld Naam moet worden geselecteerd`,
"setup_mainpage_label_welcome2":`Aangepaste databank (object)`,
"pagecreator.systemstyle.label.linkcolor":`Link kleur`,
"label.task.this.week":`Deze week`,
"message.custom.field.donotdelete.report":`Naar dit veld wordt verwezen in het rapport`,
"pagecreator.layout.button.delete":`Lay-out verwijderen`,
"label.reportsSubscriptionPage.condition.operator":`Operator`,
"label.location.display.type.degrees":`Graden, minuten, seconden`,
"label.appupload.upload.url":`Installatie URL`,
"label.logical.relation":`Logische relatie`,
"label.knowledge.publish.article":`Artikel publiceren`,
"vue_label_commonobjects_detail_activity_commingtask":`Beschikbare komende taak`,
"vue_label_pool_reason":`{0} reden`,
"front-gantt-module-subtasks-cannot-subtasks":`Subtaken kunnen niet onder subtaken staan!`,
"label_tabpage_filesizez":`Bestandsgrootte`,
"label.customfields.formula.returntype.monry.tip":`Bereken een dollar of ander valuta bedrag en formatteer het veld automatisch als een valuta bedrag.`,
"label.tabpage.allapplications":`Alle toepassingen`,
"message.duplication.label.matchcontainletters":`Bevat`,
"maintenanceplan.workorder.type.asset.workorderlineitem":`Kies "Eén werkorderregel voor elk bedrijfsmiddel" als het soort werkorder.`,
"label.preview_post":`Voorbeeld Post`,
"chatter.p.data":`Post Datum`,
"label.isnot.right.number":`Ongeldig nummer`,
"label.contentsource":`Inhoud Bron`,
"message.groupandsummaryconditionsame":`De voorwaarden voor groepering kunnen niet dezelfde zijn als de samenvattende voorwaarden.`,
"label.weixin.wdyj.nodata.qin":`Sorry, {0} heeft geen gegevens.`,
"chatter.vote":`Stem(men)`,
"label_partner_workspace_tab_option":`Beschikbare tabbladen`,
"chatter.changeVote":`Verander stem`,
"label.data.file.i_title.num2":`2. Het verdient aanbeveling de gegevens te exporteren wanneer de gegevens worden geïmporteerd, zodat het uitvoerdocument wordt gebruikt als sjabloon om de te importeren gegevens te ordenen, en vervolgens te importeren. (Indien de geïmporteerde gegevens een komma bevatten, vervang deze dan door het @-symbool).`,
"label.relation.list.error":`Fout`,
"label.validate.function.funcExplain.MILLISECOND":`Geef milliseconde van dag terug (Van datum/tijd-velden)`,
"label.emailobject.emaildetail.button.relateto":`Gerelateerd aan`,
"label.dashboard.dataSource":`Toon gegevensbron`,
"label.marketseamemset.lead.title":`Leadpool leden instellingen`,
"label.appupload.addobj":`Toevoegen aan pakket`,
"lable.outlook.mcto.domain":`Voeg mijn domein (gmail.com) toe aan de lijst van uitgesloten domeinen.`,
"label.input.right.url":`Voer een geldige URL in`,
"label.newprocessstep5.tip":`De goedkeuringspagina is waar een goedkeurder daadwerkelijk een verzoek zal goedkeuren of afwijzen. Gebruik de opties hieronder om de velden te kiezen die op deze pagina moeten worden weergegeven.`,
"label.schedulejob.setup.schedule.st4":`De 4e`,
"label.emailsync.status.user":`Gebruikers`,
"front-kefu-moudle-v1-jymm-reinput":`Voer een wachtwoord van 12 cijfers in, bestaande uit twee of meer hoofdletters, kleine letters, cijfers en tekens`,
"Lead_Scoring_Setting_Rule_Setup_RuleName":`Score regel naam`,
"label.mr.title.fieldName":`Veldnaam`,
"label.data.deriall":`Alles exporteren`,
"label.tianyancha.businessverify.step2":`Inschakelen verificatie bedrijfsgegevens stap 2`,
"label.submissions":`Inzendingen`,
"vue_label_calendar_removed_successfully":`Kalender succesvol verwijderd`,
"label.eventrecordtype":`Typen gebeurtenisgegevens`,
"lable.outlook.detail.syndire":`Sync Richting`,
"label.mobile.bind.fail":`Mislukt te binden, probeer later opnieuw`,
"label.notification.task2":`【被分配人】 de taak bekeken die u hebt toegewezen`,
"label.partnerCloud.orderingPlatform.paymentMethod":`Betaal door:`,
"label.escalation.setup.newaction.step3":`Stap 3 Selecteer de gebruiker die op de hoogte moet worden gebracht`,
"label.summaryreport.selectsum":`Kies de samengevatte gegevens en het samenvattend type`,
"label.components.setup":`Component Instellingen`,
"label.taskevent.introduce":`Uw activiteitenlijst`,
"label.assignment.setup.detail.conditon":`Criteria`,
"front-lightning-module-v1-details-page-chart-select-statements":`Selecteer rapport`,
"lable.Song.typeface":`SimSun`,
"label.formulassesstrue":`formule evalueert naar waar`,
"label_partner_common_setup":`Algemene instelling`,
"label_chatter_dateRange":`Datumbereik`,
"label.partner.workspace.tab.mobile.using":`Weergave op de mobiele app`,
"message.servicecrew.time.violation1":`Overtreding van de opdrachttijd: er is een teamlid.`,
"report_label_projectcount":`items, sorteren op rapportnaam`,
"label.file.uploadfile":`Bestanden uploaden`,
"vue_label_commonobjects_detail_correct_email_address":`Voer het juiste email adres in`,
"lable.account.CurrentandNextCQr":`Huidige en volgende 3 CQ`,
"setup.layout.label.order":`Sorteer op`,
"label.service.major.event.independent":`Onafhankelijk`,
"label.icon.38":`Positionering`,
"label.knowledge.draft.record":`Het record dat u probeert te verwijderen is niet gevonden.`,
"label_quota_percentage":`Toon voltooiing Percentage van quotum`,
"label.escalation.setup.entrydetail.escalation.minute":`Notulen`,
"label.knowledgebase.edit.article.category":`Wijzig Artikel Categorie`,
"Homepage_News_003":`Kan geen nieuws tonen zonder accountgegevens, maak een nieuwe account aan en het gerelateerde nieuws zal getoond worden.`,
"label.mr.descreption.oneGroupNote3":`records.`,
"label.customsetting.touse.getListCustomSetting":`Zoek de gegevens van het type aangepaste instellingen, geef alle gegevens terug die overeenkomen met de API-naam. Map map = cs.getListCustomSetting(String apiName);`,
"message.error.view.cannotbenull":`Fout: u moet een waarde invoeren`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.friday":`Vrijdag`,
"message.error.view.badprevilege.qin":`Sorry, u hebt geen toegang tot {1}, dus er worden geen gegevens getoond</br>`,
"label.dashboard.distribution":`Distributie`,
"label.field.value.save":`Er moet altijd een waarde in dit veld staan om de record op te slaan.`,
"label_custom_year":`Aangepast jaar`,
"label.code.error":`De code bevat commando's of functies die niet zijn toegestaan, zoals de volgende:`,
"label.appexchange.uninstallpage.message2":`Verwijder permanent al uw aangepaste instellingen voor deze onderdelen`,
"label.global.search.obj":`Globaal zoekobject`,
"label.emailobject.from":`Van`,
"lable.opppdt.selPdt.byconditions":`Op het veld`,
"chatter.p.note":`Notities van deze post`,
"label.hiddenformulaedit":`Verborgen formule-editor`,
"label.editQuotation":`Offerte bewerken`,
"label.notification.arketsea.collection":`{5} verzameld{2}{0}{0}:{1}`,
"label.timzone.tip.info1":`Als het gaat om het opslaan van java. util.Date type gegevens （insert en update） in een database, bijvoorbeeld, Als het gaat om database opslaan (insert en update) van het type java.util.Date, bijvoorbeeld, TpSysTask task=new TpSysTask () ；task.setBeginTime (new Date () ）；......dbman.insert (taak) of dbman.update (taak); u moet nieuwe datum () wijzigen om TimeUtil.getNowDate (userInfo) op te roepen, dus het relevante statement in het bovenstaande voorbeeld moet worden gewijzigd in task.setBeginTime (TimeUtil.getNowDate (userInfo);)`,
"label_tabpage_transformationsz":`Converteren`,
"front-kefu-moudle-IP-phone":`IPtelefoon`,
"label.emailobject.list.draft":`Kladjes`,
"label.tianyancha.businessverify.readandconfirm":`Ik heb de overeenkomst gelezen en ik ga ermee akkoord`,
"label.win.customers":`Gesloten-winrekeningen`,
"vue_label_commonobjects_view_switch_display":`Uw records zijn gegroepeerd per record type, u kunt op de corresponderende record type naam klikken om van display te wisselen.`,
"pagecreator_systemstyle_label_textcolor":`Tekst kleur`,
"label.autosearch.keywords":`Automatisch zoeken op trefwoorden`,
"label.knowledge.setting.data.six":`U gaat categorie {lbmc} verwijderen, weet u zeker dat u door wilt gaan?`,
"front-console-sort-field":`Zaak nr.`,
"label.bangladesh.time":`Bangladesh Tijd`,
"label.dashboardSetup.number":`Numerieke Waarden`,
"lable.account.LastbDays":`Laatste 30 dagen`,
"label.layout.searchdialog":`Opzoekingsdialoog`,
"label.newprocessstep4.tip":`Selecteer de e-mailsjabloon die zal worden gebruikt om goedkeurders te informeren dat een goedkeuringsverzoek aan hen is toegewezen. Merk op dat dit sjabloon zal worden gebruikt voor alle stappen van dit proces.`,
"label.nousing":`Inactief`,
"vue_label_report_detailline":`Detail lijn`,
"label.emailobject.template.message3":`Het maximum aantal mailsjablonen is bereikt!`,
"label.c.d":`C tot D Relatie`,
"message.report.error.fail":`Laden mislukt, probeer opnieuw`,
"label.edit.ccdocument.content":`de attechment gewijzigd.`,
"label.textmessage.exceeded":`Het aantal van uw tekstsjablonen heeft de limiet overschreden!`,
"label.saveas":`Opslaan als`,
"label.visualpage.an.inline.style":`Embed aangepast paginatype op detailpagina en tabblad startpagina`,
"label.pagelayout.remark2":`gegevens. Nadat u paginalay-outs hebt gemaakt, klikt u op de knop Paginalay-out toewijzing om te bepalen welke paginalay-out gebruikers standaard te zien krijgen.`,
"label.notification.approval1":`Het goedkeuringsverzoek voor de【对象】 is goedgekeurd door【审批人】`,
"label.h5.chatter.image":`Upload het beeldformaat is niet correct`,
"vue_label_dashboard_displayunit":`Selecteer een display-eenheid`,
"label.knowledge.default.language":`Standaardtaal van kennis`,
"label.chatter.publish":`Publiceren`,
"label.companyprofile.serveraddress":`Deze synchronisatie synchroniseert alleen de huidige server.`,
"label.chatter.groups":`Groep`,
"label_set_successfully":`Succesvol ingesteld!`,
"label.quote.zongjia":`Totale prijs`,
"label.project.notice.endingdatelater":`De einddatum moet later vallen dan of gelijk zijn aan de begindatum.`,
"label.customfields.fielddependency.info":`Op deze pagina kunt u afhankelijkheden tussen velden definiëren (bv. afhankelijke keuzelijsten).`,
"vue_label_lead_successful_conversion":`Succesvolle conversie`,
"label.icon.93":`Boek`,
"shift.serviceresource.illegal":`Het dienstmiddel behoort niet tot een lid van het servicegebied of de verschuivingsdatum valt niet binnen het bereik van het lidmaatschap.`,
"label.integrations.action.addnewlead":`Nieuwe Leads Toevoegen`,
"label_display_all_zeros":`Toon alle rijen met nulwaarden`,
"canlendaryear":`Kalenderjaar`,
"label_tabpage_selrecordtypez":`Selecteer type record`,
"vue_label_commonobjects_view_chart_funnel":`Trechter diagram`,
"label.layout3":`Lay-out 3`,
"label.logintime.cue":`Geen logintijd opgegeven.`,
"label.service.miniProgram.lastDate":`Laatst Gewijzigde Datum`,
"label.emailobject.view.fromcrm":`Emails van Contacten/Leads`,
"pagecreator.button.mobilepage":`Mobiele kant`,
"lable.oppt.jieduan.signcur":`Gemarkeerd als de huidige fase`,
"label.fullaccess":`Volledige toegang`,
"homepage.layout.pagename":`Naam pagina-indeling`,
"label.appointment.wizard.subtitle4-2-3":`3 h`,
"label.knowledgebase.please.check.record":`Selecteer ten minste één record.`,
"label.view.sortview.closepage":`Venster sluiten`,
"label_forecast_type":`Type voorspelling`,
"all.day":`De hele dag`,
"label.view.sortview.printpage":`Deze pagina afdrukken`,
"message.integration.configure":`De geïntegreerde configuratie is leeg!`,
"label.forecast.customforecast.foretype.close":`Gesloten-Won`,
"label_chatter_like":`Zoals`,
"template.report.folder.customer.potential":`Leads Analyse`,
"label.umeng.approval.dlsp.approve":`#goedkeuringsnaam heeft het goedkeuringsverzoek van #objAPIName #recordnaam voor u goedgekeurd.`,
"vue_label_normal_movedown":`Naar beneden.`,
"chatter.group.groupAccessPermissions":`Groep toegang`,
"label.visualpage.tip":`U kunt hier uw eigen pagina maken`,
"message.validation.isnotdate":`Ongeldige datum`,
"label.icon.173":`Zeilboot`,
"label.icon.124":`Injectie`,
"label.import.page2.csvfiled":`CSV-veld`,
"setup_layout_component_area":`Gebied`,
"label.visualpage.workability.standard":`Beschikbare standaardklassen op de pagina`,
"label_emailtocloudcc_redmessage9":`Databasefout, neem contact op met de beheerder.`,
"label_tabpage_contactsz":`Contacten`,
"label.multilang.workflow.everydayinmonth":`{1} dagen om de {0} maanden`,
"APPIntegration.Social.linkedinerror":`U moet een geldige URL invoeren voor linkedin.com`,
"button_partner_workspace_manage_memo":`Beheer uw partner cloud en configureer partner cloud eigenschappen.`,
"template.chart.bnsrmb":`Inkomstendoelstelling voor het jaar`,
"chatter.follow.now":`Naar aanleiding van`,
"label.entitlement.process.condition.repeat":`Stel mijlpaalherhaling`,
"label.relationobject.isdl":`Afgevaardigde`,
"label.lasttimemodifieralias":`Laatste Modifier Alias`,
"vue_label_commonobjects_detail_task_name":`Bewerk taaknaam`,
"vue_label_homepage_quarterlyperformance":`Kwartaalresultaten`,
"pagecreator.layout.message.delete":`Verwijdert u de huidige geselecteerde lay-out?`,
"component_sendmail_label_cc":`Cc`,
"vue_label_email_enable_signature":`Handtekening inschakelen`,
"label.partnerCloud.financeSetting.create":`Maak automatisch een fonds aan voor in aanmerking komende gebruikers wanneer nieuwe parters worden geactiveerd.`,
"label.data.file.i.title.num1":`1. Het geïmporteerde bestand moet een bestand in CSV-formaat zijn. Het bestand moet een titel bevatten en kan niet zonder titel worden geïmporteerd.`,
"label_efine_assessment":`Evaluatiecyclus`,
"message.duplication.label.sectionTitle":`Selecteer de waarde die u wilt behouden`,
"front-electronic-export-buttonExport":`Doorgaan met exporteren`,
"message.submitpage.email":`Gefeliciteerd, e-mail succesvol verzonden.`,
"after":`Na`,
"label.version.nonsupport":`Unsupport`,
"label.icon.105":`Schema`,
"label.quickcreate.titledesc":`Door Quick Create in te schakelen kunnen gebruikers records aanmaken vanuit het opzoekingsvenster.`,
"label.quote.number":`Voer de hoeveelheid in`,
"label.view.sortview.setdefault.prompt":`Pin deze weergave lijst`,
"label.refertime":`Datum ingediend`,
"frame.personinfo.label.minipic":`Miniatuurafbeelding`,
"label.mobile.home.page.newopp":`Recentelijk gecreëerde leads`,
"label.address":`Adres`,
"front-pay":`Betalen`,
"label.chat.serviceAppointment":`Dienstmededeling`,
"label.umeng.activity.eventviewed":`De gebeurtenis die u hebt toegewezen aan #naam wordt bekeken`,
"label.validate.function.funcExplain.DATE":`Datum aanmaken met jaar, maand en dag`,
"label.commiterselectapprover":`Laat de indiener de goedkeurder handmatig kiezen.`,
"label.appointmentconfirmpage.wizard.subtitle3":`Locatie`,
"vue_label_display_text_field":`Tekstvelden tonen`,
"label.salescloud.teamrole":`Team rol`,
"maintenanceplan.workorder.generate.limit":`De werkopdracht moet binnen de reikwijdte van het onderhoudsschema vallen.`,
"label.campaignmember.selectmember.description":`een view selcet, dan de leden aan de Campagne toevoegt, en de Campagne Menmeber Status is`,
"label.ismodify":`Bewerken toestaan`,
"label.height":`High`,
"label.tabpage.thevalurofz":`De waarde van`,
"label.create_successful":`Succesvol formulier aanmaken`,
"front-invoice-online-payment-setup-configure-dialog":`Betaalinterface configureren`,
"label.customerinfo.smsEid":`SMS Gateway EID`,
"label.visualpage.list.no":`Geen rechten voor toegang tot de aangepaste pagina's`,
"look.trigger.in":`Instructies bekijken`,
"label.setting.disable":`Deactiveer`,
"chatter.group.name":`Groepen`,
"label.solutionadministrator":`Oplossingen Manager`,
"label.vlidaterule.top":`Begin van pagina`,
"pagecreator.layout.message.save.fail":`Opslaan lay-out mislukt`,
"label.partnerCloud.orderingPlatform.noZero":`De hoeveelheid kan niet 0 zijn.`,
"label.customfields.suretodeleteprompt":`Bevestig de prompts voor het verwijderen van aangepaste velden`,
"button_partner_viewdetail":`Bekijk`,
"label.icon.122":`Huis`,
"label.customer.tab.step2.introduce":`Kies de gebruikersprofielen waarvoor het nieuwe aangepaste tabblad beschikbaar zal zijn. U kunt ook de zichtbaarheid van de tabbladen onderzoeken of wijzigen vanaf de detail- en bewerkingspagina's van elk profiel.`,
"label.task.delegated":`Gedelegeerd`,
"vue_label_salesadvance_averageamount":`Per klanttransactie`,
"vue_label_chat_invitedtojoin":`{invite} nodigde je uit om deel te nemen aan de groepschat`,
"label.data.downpage.e_title.num1":`1. Selecteer de objecten die u wilt exporteren, of kies om alles te exporteren.`,
"label_display_options":`Weergave-opties`,
"vue_label_chatter_more_comments":`Meer opmerkingen`,
"label.ggReleaseRange.publish":`Lijst publiceren`,
"label.valuetype.notmate":`Fout in regelvoorwaarde, het waardetype komt niet overeen.`,
"label.chatter.chatter":`CCChat`,
"label.exchange.sync.state.contact.m1":`Laatste gesynchroniseerde activiteit:`,
"label.dataimport.duplication.filter":`Zoek dubbele filterprompts`,
"label.appdownload.uninstall":`Verwijder`,
"message.error.task.add":`Nieuwe taak anomalie`,
"UG.Account.07":`Account importeren`,
"label_tabpage_lastone":`Kies ten minste één bewerking`,
"front-console-holdTime":`Vertragingstijd`,
"label.emailobject.schedule":`Zie mijn schema en boek een tijd hier.`,
"label.lookup.locked.data":`Dit record is vergrendeld, niet kiesbaar`,
"label.assignment.setup.newentries.ifcondtions":`Voer deze regel uit als de`,
"label.magadan.time":`Pietro Pavlov Tijd`,
"message.error.serviceterritorymember":`Definieer het geselecteerde service middel als een lid van het service gebied binnen het tijdsbestek van het service afspraak plan.`,
"label_chatter_delete":`Delete`,
"label.partner.workspace.member.permission":`Beschikbare permissies ingesteld`,
"label.notification.task5":`Uw taak is al te laat`,
"mary":`Mei`,
"label.homepagemodule":`Home Page Componenten`,
"label.compact.layout.frame.error1":`Het rechterscherm kan geen inhoud hebben`,
"chatter.error.refresherror":`Vernieuwen mislukt, probeer opnieuw.`,
"label.login.rememberPsd":`Herinner Mij`,
"Lead.Scoring.Setting.Rule.Setup.01":`Lead Scoring Regel Lijst`,
"label.reportsSubscriptionPage.schedulereport.weekly.sunday":`Zondag`,
"label.visible":`Zichtbaar`,
"label.console.new":`Nieuwe Console`,
"label.mr.descreption.reDataList4":`milliseconden. per pagina.`,
"vue_label_notice_uploadavatar_notice2":`De geüploade avatarafbeelding mag alleen in JPG/PNG/GIF-formaat zijn`,
"label.operation.error":`Operatie mislukt, probeer het opnieuw.`,
"label.sendsms.context":`SMS-inhoud`,
"label.least.show.line":`(minstens 4 regels weergeven)`,
"label.tabpage.newWizardz":`Nieuw toegevoegde functie wizard`,
"label.tippage.li2":`Verwijder alle rapporten gebaseerd op een aangepaste rapport gegevensbron`,
"label.customfields.new.step2.opration.unique":`Uniek`,
"label.listofshare.remark":`De volgende gebruikers kunnen de records bekijken`,
"label.address_information":`Adresgegevens`,
"label.projectManagement.overdue.tasks":`Achterstallige taak`,
"lable.account.PreviousCQ":`Vorige CQ`,
"label.service.miniProgram.advertising":`De advertentienaam wordt alleen gebruikt om meerdere advertenties te identificeren en wordt niet in de advertentie weergegeven.`,
"label.integrations.mailchimp.exportlead":`Exporteer geselecteerde leads naar Mailchimp`,
"label.payments.paytip3":`Selecteer een factuuradres`,
"label.mobile.phone.screen":`Filter`,
"label.h5.tome":`Over mij`,
"label.mobile.side.tab.remark1":`Voeg het CloudCC tabblad en object toe aan het navigatiemenu van de schuifbalk aan de mobiele kant.`,
"vue_label_calendar_choose_a_custom_color":`Kies aangepaste kleur van deze kalender`,
"label.lastname":`Achternaam`,
"vue_label_dashboard_selectreport":`Selecteer rapport`,
"label.lanxin.setting.appid":`AppID`,
"vue_label_report_information":`Exporteer het rapport zoals het wordt weergegeven in Cloud CC, inclusief de rapportkop, groep en filterinformatie.`,
"label_chatter_default":`Standaard`,
"label.globalSearch.info":`Zoeken naar alle geselecteerde objecten`,
"label.integrations.mailchimp.massage2":`De geselecteerde leads exporteren naar Mailchimp en u kunt de leads later bekijken in de Mailchimp-lijst`,
"label.tabpage.addresswrongz":`Het formaat van het postbusadres is onjuist, voer het postbusadres correct in!`,
"label.mobile.phone.customer.call":`Bezoek klant`,
"vue_label_email_linkrecordfail":`Record niet gekoppeld`,
"lable.account.LastfDays":`Laatste 90 dagen`,
"label.cpq.order.status.delete":`Deze bestelling is actief en kan niet worden verwijderd`,
"label.ccchat.notmember.active.group":`U bent geen lid`,
"label.savepayset.failure":`Het is niet gelukt de online betaalrekening op te slaan`,
"label.version.createlimitbyobject":`Uw huidige CloudCC editie is {0}, en u kunt {1} {2} voor elk object. Nu, het aantal van {2} is het maximum van uw abonnement overschreden, gelieve uw CloudCC editie te updaten.`,
"approval.process.errore":`Er is een fout opgetreden tijdens het opslaan, neem contact op met de beheerder.`,
"label.stdashbord.xsld.business.reportanalysis":`Grafiek Analyse`,
"label.login.verification.please.enter":`Voer de beveiligingscode in die u van het MFA-programma hebt gekregen`,
"label.tabpage.cue":`Informatie herinnering`,
"vue_label_salesadvance_converserate":`Converteer verhouding`,
"label.marketsea.recyclereminddays1":`Vóór automatische recycling`,
"label.import.page1.update":`Update`,
"label.document.folder":`Documentenmappen`,
"label.h5.similar.opportunity.feature":`Met deze functie kan een gebruiker zoeken naar opportuniteiten die gemeenschappelijke velden delen met de opportuniteit. Eenmaal ingeschakeld, verschijnt er een lijst met gelijkaardige opportuniteiten op het opportuniteitsrecord.`,
"label.myanmar.time":`Myanmar Time`,
"monday":`Maandag`,
"vue_label_account_shareholder":`Aandeelhouder`,
"button.partner.search":`Vraag`,
"label.partnerCloud.partnerAccount.topUpAmount":`Aanvulling Bedrag`,
"label.tabpage.refreshz":`Vernieuwen`,
"lable.PowerProcess.complete":`Mijlpaal Voltooiing Mins`,
"front-kefu-moudle- normal-phone":`Telefoon algemeen`,
"label.user.unauthorized.organization":`Ongeoorloofde organisatie, neem contact op met de beheerder.`,
"label.area.canot.save.nulldata":`Kan de null gegevens niet opslaan`,
"label.version.role.management":`Beheer van rollen`,
"label.recordtype.batchaddattachments.batch.remark":`Stap 1 Kies een bestand, Stap 2 Klik op de "start upload" knop, bestanden uploaden, Stap 3 Klik op de knop om te eindigen.`,
"label_tabpage_contentz":`Gelieve inhoud in te voeren`,
"label.partner.workspace.member.all":`Alle`,
"label.validate.function.funcFormat.LEFT":`LINKS(tekst, num_chars)`,
"vue_label_SMS_notice_selectatleastone":`Selecteer ten minste één lead of contact`,
"label.appupload.install.error.choice5":`Stop de installatie onmiddellijk en voer conflicterende componenten uit`,
"label.version.lookupmdfield":`Master-Detail relatieveld`,
"setup.layout.label.desc":`Aflopend`,
"vue_label_report_addsummaryformula":`Samenvattingsformule toevoegen`,
"label.done":`Gedaan`,
"label.input.samevalue":`Voer dezelfde waarde in`,
"label.SMS.next":`Selecteer de objecten voor de SMS notificaties en klik op "Volgende". SMS meldingen kunnen alleen geassocieerd worden met hetzelfde type workflow regels en goedkeuringsprocessen.`,
"label.role.allunselectuser":`Alle niet-toegewezen gebruikers`,
"label.loginhistory":`Inlog geschiedenis`,
"vue_label_report_addpublicreportstofolder":`Voeg publieke rapporten toe aan deze map`,
"label.email.track.no.attachment":`Geen bevestiging`,
"label_network_connection_failure":`Netwerkverbinding is mislukt.`,
"vue_label_file_delete_lib_member":`Verwijder bestand bibliotheek lid`,
"label_partner_step1":`Stap 1 kies sjabloon`,
"label.password":`Wachtwoord`,
"label.select.the.fields.around.code":`Kies de velden die rond de QR code/Bar code moeten worden weergegeven.`,
"label.file.share.limit":`Boven de aandelenlimiet kan geen nieuw aandeel worden toegevoegd!`,
"label.desktop":`Desktop`,
"label.sendmail":`Stuur e-mail`,
"label.quote.detail":`Offerte Artikelen`,
"label.approvalstep2":`Stap 2 Criteria voor stappen specificeren`,
"label_component_hotdeal_nodata":`Geen gegevens over zakelijke kansen.`,
"lable.reset":`Reset`,
"label.eventpagelayout":`Lay-outs evenementpagina`,
"label.icon.100":`Schrijfwaren`,
"UG.quota.03":`Offerte template`,
"label.calendar.week.view":`Weekoverzicht`,
"component_chatter_file_button_save":`Publiceren`,
"label.as":`Zoals`,
"template.chart.yqxypjz":`Gemiddelde verwachte reactie`,
"UG.Contract.03":`Contract maken`,
"label.projectManagement.gantt":`Gantt Grafiek`,
"label.forecast.edit.error0":`Fout: U moet ten minste één bedrijfsvaluta selecteren.`,
"label.ccpeak.delete.sharetab":`Verwijder het deelformulier`,
"label.account.contact.goback":`Terug naar Rekeningen`,
"vue_label_email_insert_field":`Selecteer invoegveld`,
"setup_object_field_dependency_label_fieldvalueoptions":`Beschikbare veldwaarden`,
"label.salescloud.opportunity.contactrole.optionlist.main":`Hieronder volgt de hoofdlijst van optiewaarden voor het veld contactrollen bij kansen`,
"label.huanxinconfig.tenantid.lost":`tenantid kan niet leeg zijn`,
"label.mask.show.last_4":`Masker laatste vier tekens`,
"label.targer.name":`Indicator Naam`,
"vue_label_commonobjects_detail_unlocksuccess":`Succesvol ontgrendeld`,
"front-kefu-moudle-length-min":`Lengte (minuten)`,
"label.chat.topic.my.favorite":`Mijn Favoriete Onderwerpen`,
"chatter.upload":`Upload`,
"message.cannotapproveit":`Het goedkeuringsverzoek kan niet worden verwerkt.`,
"label.weixin..xsld.order.by.jine":`Sorteren op contractbedrag`,
"label.projectManagement.wait.test":`Wachten op testen.`,
"template.report.customer.contact.list":`Contactlijst van Rekeningen`,
"label.empty.recycle.bin":`Prullenbak leegmaken`,
"label.detail.approveprocess":`Goedkeuringsprocedures bekijken`,
"label.appexchange.uninstallpage.message4":`Verwijder permanent alle rapporten, overzichten en aangepaste tabbladen van de aangepaste objecten in dit pakket`,
"label.weixin.linkreport":`Gerelateerd aan`,
"label.tianyancha.orgnumber":`Code organisatie`,
"Q":`Keuzelijst (Multi-Select)`,
"pagecreator_systemstyle_message_save_fail":`Stijl opslaan mislukt`,
"label.partner.new":`Partner cloud: nieuw`,
"label.ems.accounttype":`Type rekening (a)`,
"label.weixin.next":`Volgende`,
"label.weixin.coach.interpret":`Aid-Max behoudt zich het recht van herziening en definitieve interpretatie voor in het kader van de WeChat service wet.`,
"label.some":`record(s)`,
"label.currency.rate":`Valuta bewerken: omrekeningskoersen`,
"label.emailobject.template.name":`Sjabloon Naam`,
"UG.Campaign.001":`Planning campagnes`,
"label.mr.descreption.reDataList3":`groepen van gegevens, query tijd`,
"label.project.hit.nine":`Dagelijkse uitgave Herinnering`,
"lable.PowerProcess.golist":`<<Terugkeerlijst:Bevoegdheidsproces`,
"label.viewbuttonedit.remark":`Selecteer de standaard en aangepaste knoppen die op de voorgrond worden weergegeven.`,
"label.component.helper":`Assistent`,
"lable.SalesCommitmentKanBan.contractAndReceipts":`Ondertekende betaling`,
"chatter.group.userName":`Gebruikersnaam`,
"label.mobile.phone.business":`Kansen`,
"label.quickbooks.payments":`BETALEN`,
"label.step6.total7":`Stap 6 van 7`,
"label.forecast.detailforecast.revenue":`Inkomstenprognose`,
"vue_label_commonobjects_view_chart_displayas":`Weergeven als`,
"label.recordeditoption":`Record bewerkbaarheidseigenschappen`,
"label.sendemail.send.sendfailstandby":`Het verzenden van de e-mail is mislukt, neem contact op met uw beheerder(reserve uitbox).(foutcode:`,
"label.knowledgebase.reset.filter":`Filter resetten`,
"label.icon.111":`Voedsel`,
"label.standard.buttonandlink.firstsetting":`Eigenschappen opheffen`,
"front-filter-module-v1-filter-description":`Flitsfilter kan niet worden opgeslagen. Het is alleen van toepassing op de huidige bewerking zonder enige invloed op weergaven of andere gebruikers.`,
"label.showmore":`Zie Meer`,
"UG_Lead_001":`Hoe introduceer je aanwijzingen?`,
"label.exchange.sync.state.setting.m1":`Miscrosoft Exchange service account voorzien:`,
"label.please.enter.channel.name":`Voer de naam van het kanaal in.`,
"label.emailtocloudcc.edit":`Bewerken`,
"label.layout.tabdialog":`tabbladen`,
"label.Emoji":`Emoji`,
"template.report.completed.tasks":`Voltooide Taken`,
"label.tabpage.enterviewname":`Stap 1: voer de naam van het uitzicht in`,
"label.mobile.phone.not.to.choose":`Geen Geselecteerd`,
"label.datamanage.contact.namenull":`Opmerking: Als het contactnaamveld leeg is, wordt het record niet geïmporteerd.`,
"LT":`Geolocatie`,
"label.exchange.sync.state.task.m3":`Records gesynchroniseerd in de laatste 24 uur:`,
"lable.SalesCommitmentKanBan.contractOwner":`Contract Eigenaar`,
"vue_label_chatter_write_review":`Schrijf een commentaar`,
"label.h5.approval.enter.content":`Gelieve goedkeuringsnota's in te voeren`,
"label.location.display.type":`Weergave van lengte- en breedtegraad`,
"label.numberscannotnull":`Aantal kan niet leeg zijn`,
"label.icon.3":`Valuta`,
"setup_object_field_dependency_label_linkedfieldvalue":`Afhankelijk veld`,
"label.task.future":`Toekomstige taken`,
"label.look.more.record":`Toon Meer`,
"vue_label_account_cases":`Alle zaken van klanteneigenaars overdragen`,
"label.emailobject.emaildetail.title.ccaddress":`CC:`,
"label.setHistoryTrack":`Geschiedenis bijhouden instellen`,
"ObjectDetailed.ViewKeyInformation.Layout":`Belangrijke informatie bewerken`,
"label.layout.editsearchdistribute.tip":`Selecteer de velden die u in deze zoeklayout wilt opnemen. Merk op dat uw keuzes enkel de weergave van de zoekresultaten bepalen en geen invloed hebben op de velden die werkelijk doorzocht worden.`,
"label.emailtoall":`Stuur emails naar alle gebruikers.`,
"label_partner_new":`Partner cloud: nieuw`,
"label.direct.dashboard.me.not.approval":`Mijn goed te keuren punten`,
"label.platform.customize.customizeui":`Aangepaste UI`,
"label.userinfo.pwderror.againinput":`Het tweemaal ingevoerde wachtwoord is niet hetzelfde. Voer het opnieuw in.`,
"label.customsetting.introduce":`Gebruik aangepaste instellingen om aangepaste gegevens te maken en te beheren op organisatie-, profiel- en gebruikersniveau. Gegevens over aangepaste instellingen worden opgeslagen in de cache van de toepassing. Dit betekent dat u ze efficiënt kunt openen, zonder de kosten van herhaalde query's.`,
"label.file.owner":`Eigenaar`,
"label.icon.7":`Mensen`,
"label.document.query.button":`Klik op bladeren om het bestand te vinden`,
"label.tabpage.turnoffsz":`Gesloten  Bekeerd`,
"message.error.appid.appsecret.failed":`Het is niet gelukt om de geheime sleutels te krijgen!`,
"vue_label_commonobjects_view_to_display_fields":`Selecteer tot 10 weergavevelden`,
"label.martrixreport.setlinetitle":`Rij koppen specificeren`,
"vue_label_chatter_applycertification":`Stemt u in met "{naam}" om deel te nemen aan de groepschat?`,
"front-electronic-export-success":`Succesvol exporteren, controleer het in de Mailchimp lijst`,
"label.emailsync.status.enable":`Actief verbinden`,
"label.c_d":`C tot D Relatie:`,
"PageLayout_Search_MultiSearch_003":`Kies tenminste één veld.`,
"label.tabpage.newInterfacez":`De nieuwe interface`,
"label.cutomsummaryfieldedit":`Aangepast overzichtsveld bewerken`,
"label.usermanage.view.field.notexist":`Het veld dat overeenkomt met de weergave bestaat niet.`,
"label.list.userinterface.dashboard.setup":`Dashboard Setup`,
"label.knowledgebase.delete.article":`Verwijder artikel`,
"label.dataimport.type.update":`Update`,
"label.marketsea.new":`Nieuw Zwembad`,
"label_tabpage_newlybuildz":`Nieuw`,
"vue_label_helpcenter_report1":`1.Bouw een rapport<br> Het Lightning rapport in het Cloud CC verkoop management systeem is een krachtig hulpmiddel voor gegevensanalyse. Veel verkoopproblemen kunnen worden opgelost door records te groeperen, te filteren en samen te vatten. Bijvoorbeeld: "Hoeveel inkomsten hebben de nieuwe zakelijke kansen van het bedrijf in het laatste kwartaal gecreëerd?" Rapportgrafieken kunnen worden toegevoegd op basis van het voltooien van het gegevensoverzicht. Nadat het rapport is voltooid, klikt u op Uitvoeren om de volledige resultaten van de gegevens te bekijken. <br> Stap 1: Ga naar de Rapport tab en klik op "Nieuw rapport";<br> Stap 2: Selecteer de rapport gegevens bron, en klik dan op "Volgende";<br> De gekozen rapport gegevens bron kan bepalen welke records of velden kunnen worden gebruikt in het rapport. Selecteer of zoek naar een object als hoofdobject. U kunt maximaal 4 objecten selecteren die correlatie hebben met het hoofdobject, en u kunt de relatie tussen de objecten selecteren. <br> Stap 3: Ga naar de rapportbewerkingspagina en toon de voorbeeldgegevens<br> In de bewerkingsmodus kunt u het rapport aanpassen, velden als kolommen aan het rapport toevoegen, rijen en kolommen groeperen, en filters gebruiken om de rapportgegevens te filteren tot de gegevens die u nodig hebt nauwkeurig worden weergegeven<br> Kolommen toevoegen of verwijderen en de volgorde aanpassen<br> Kolom toevoegen: Klik in de rapportbewerkingsmodus op het invoervak "Kolom" in de "Samenvatting" aan de linkerkant van de pagina, en voeg rapportkolommen toe nadat u het veld hebt gezocht of door de vervolgkeuzelijst met velden hebt gebladerd en het doelveld hebt geselecteerd. <br> Kolom verwijderen: <br> A. Nadat u de "kolom" hebt gevonden die u wilt verwijderen in de "Kolom" lijst aan de linkerkant, klikt u op de "×" op het veldvak. <br> B. Of zoek de "kolom" die u wilt verwijderen in de kop van het rapport-voorbeeld aan de rechterkant, klik op de "drop-down knop", en klik op "verwijder kolom".<br> Het verwijderen van de kolom uit het rapport verwijdert het veld niet. Als u de kolom wilt herstellen nadat u hem hebt verwijderd, voeg hem dan gewoon weer toe. <br> Pas de volgorde van de kolommen aan: Sleep het "Kolom" veld in de "Kolom" lijst aan de linkerkant omhoog en omlaag om de "Kolom" rangschikking aan te passen. <br> Rijen groeperen en kolommen groeperen toevoegen en verwijderen<br> Rijen groeperen toevoegen: Klik op het "Groepen van rijen" invoerveld in de "Samenvatting" aan de linkerkant van de pagina, en voeg rapport rij groeperingsvelden toe om gegevens te filteren na het zoeken van het veld of het scrollen van de drop-down veldlijst en dan het doelveld te selecteren. <br> Zonder kolomgroepering toe te voegen, kunt u maximaal drie rijgroeperingen toevoegen. <br> Kolomgroepering toevoegen: als er een rijgroepering bestaat, kunt u een kolomgroepering toevoegen. Klik op het "Groep Kolom" invoerveld in de "Samenvatting" aan de linkerkant van de pagina, selecteer het veld na het zoeken of scroll door de drop-down lijst van velden en selecteer het gewenste veld Manieren om rapport kolom groepering velden toe te voegen om data te filteren. <br> U kunt maximaal twee kolomgroepen toevoegen. Bij het toevoegen van kolomgroepen, kunt u maximaal twee rijgroepen toevoegen. Velden die zijn toegevoegd als rij groepen kunnen niet worden toegevoegd als kolom groepen. <br>`,
"label.notification.event1":`【分配人】 u een evenement toegewezen`,
"chatter.field":`Gebied(en)`,
"chatter.feed.menutype.feed.newscom":`Alles wat ik volg`,
"label.attendance.range":`Aanwezigheidsbereik`,
"vue_label_calendar_deleteconfirm":`Weet u zeker dat u kalender {naam}`,
"label.ems.createTask":`Nieuw {taskName}`,
"label.visualpage.wgd":`Niet gearchiveerde aangepaste pagina's`,
"label.multilang.product.deleterederect1":`Uw poging om <font style="font-weight:bold;">{0}</font> te verwijderen kon niet worden voltooid omdat het nog steeds geassocieerd is met het volgende record. In dit geval raden wij u aan het uit te schakelen.`,
"label_emailtocloudcc_filed_servertype":`E-mailserver`,
"label.umeng.insert.approval.dlsp.approvenew":`#actorname legt #objAPIName#recordnaam ter goedkeuring voor`,
"label.tabpage.queue":`Wachtrij`,
"label.approval.step":`Goedkeuring stappen`,
"label.approvaldatamove.approvalprocessname":`Procesnaam`,
"label.actualapprovedpeople":`Feitelijke goedkeurder`,
"label.systemlog.f":`FAILURE`,
"front-template-V1-addText":`Tekst toevoegen`,
"label.chat.like":`Zoals`,
"label.userinfo.oldpwd.notnull":`Het oude wachtwoord kan niet leeg zijn.`,
"label.service.all.done.major.event":`Je hebt alle mijlpalen voltooid.`,
"label_chatter_to":`Naar`,
"message.toomuchlinecannotoutput":`Er zijn te veel rapportkolommen geselecteerd en het rapport kan niet worden uitgevoerd.`,
"maintenanceasset.assetid.maintenanceplanid.unique":`Het onderhoudsplan is toegewezen aan het bedrijfsmiddel. Gelieve niet herhaaldelijk toe te wijzen.`,
"lable.quote.syncing.firstsync.description":`Quote-artikelen zullen gelegenheidsproducten vervangen`,
"lable.outlook.mcto.saveemail":`Zorg ervoor dat u de e-mailbijlagen opslaat`,
"label.passwordPolicy.setup.pwdremember2":`2 wachtwoorden onthouden`,
"label.project.hit.five":`Taak Bijwerking Mededeling`,
"label.linkedin.setting.appid":`Geheime Sleutel`,
"label.dataimport.error.name.notnull":`Fout: naam kan niet null zijn`,
"label.knowledge.case.field.selected":`Geselecteerde zaakvelden`,
"label.version.datetime":`{0} datum/tijd velden`,
"Dashboard_NoAccessRightToSee_Warning":`U heeft geen toestemming om de dashboads {0} te bekijken die zijn ingesteld als defaitt open, gelieve te resetten.`,
"label.login.access.permission":`Verleen toegang tot`,
"label.operatedata.import.tip":`1. Het geïmporteerde bestand moet een bestand in CSV-formaat zijn. Het bestand moet een titel bevatten en kan niet zonder titel worden geïmporteerd. 2. Het is aanbevolen dat u exporteert alvorens te importeren, de gegevens die u wilt importeren voor de gegevenssjabloon met het exportdocument collationeert, en vervolgens importeert.`,
"workflow.action.tasks.assignortype.rolename":`Rol Naam`,
"vue_label_account_quotations":`Overdracht van alle offertes van de klant eigenaar`,
"lable.account.CurrentCQ":`Huidige CQ`,
"label.user.database.error":`Databasefout!`,
"label_emailtocloudcc_titel":`E-mail naar CloudCC`,
"label_file_content":`Inhoud van de tekst`,
"label.button.behavior":`Gedrag`,
"message.recordtype.new.tip":`Vul de gegevens in`,
"label.ccchat.message.new.error3":`Fout: u kunt niet meer dan 9 ontvangers selecteren`,
"vue_label_commonobject_notice_lessthanwords":`De bestandsnaam moet minder dan {FILE_NAME_COUNT} woorden bevatten!`,
"label.stacked.verticalline":`Gestapelde-verticale kolommen`,
"vue_label_SMS_messagebox":`Berichtenbox`,
"label.appexchange.installedpage.message3":`</b>Afhankelijk van de links naast een geïnstalleerd pakket, kunt u vanaf deze pagina verschillende acties ondernemen. Om een pakket te verwijderen, klikt u op <b>Verwijder</b>. Klik op <b>Licenties beheren</b> om de pakketlicenties te beheren.`,
"label.unusedapproveprocess":`Inactieve goedkeuringsprocedures`,
"label.onlywithspecificconditions":`Alleen records die aan bepaalde criteria voldoen, mogen in de berekening worden opgenomen`,
"lable.outlook.mcto.formaterror":`Formatteringsfout`,
"label.area.parent":`Gebied van de ouders`,
"vue_label_chat_activesuccess":`Met succes geactiveerd`,
"label.setting.intergrationlist.button.upgrade":`Upgrade`,
"label.page_hidden":`Verbergen velden voor registratiepagina`,
"label.customsetting.manage.belong":`Setup Eigenaar`,
"label.appointment.wizard.subtitle4-2-8":`7 dagen`,
"template.chart.ydywjhxsje":`Maandelijks bedrag voor verkoop van zakelijke kansen`,
"label.multilang.currencylist.after":`Na {0}`,
"vue_label_commonobjects_view_chart_countby":`Tel door`,
"label.week":`Week`,
"label.emailtemplate.name":`Sjabloon Naam`,
"label.umeng.sign":`getekend in`,
"label.appupload.upload.details":`Details`,
"label.file.loading":`Laden`,
"label.newdetail.orgTitle":`Contact Rollen`,
"label.salescloud.field.addoptionlist":`Picklist waarden toevoegen`,
"pagecreator.page.funcpath":`/ bouwer / pagina lijst`,
"Account.News.Setting.001":`Account Instellingen`,
"label.marketsea.getnoconversiondays":`Niet omgezette dagen (moet meer zijn dan het aantal dagen zonder follow-up na verkrijging)`,
"message.error.event.add":`Nieuwe gebeurtenis anomalie`,
"front-electronic-export-choseChimp":`Selecteer de geëxporteerde Mailchimp lijst`,
"vue_label_report_personothers":`Anderen`,
"label.hierarchy.diagram":`Hiërarchische Structuur`,
"label.stdashbord.xsld.business.yqsr":`Verwachte inkomsten`,
"label.chat.topic.max.count":`U hebt het maximum aantal onderwerpen bereikt.`,
"label.sendemail.send.sendfail":`E-mail verzenden mislukt, neem contact op met uw beheerder.`,
"registration.page.body.title":`Registratie Pagina`,
"label.userphoto.back":`Terug`,
"label.service.without.timeslot":`Er lijken geen tijdslots te zijn, laten we ze toevoegen!`,
"label.processsetting.remaining.quantity":`Er kunnen maximaal 255 tekens worden ingevoerd, resterend:`,
"label.sure.delete":`Bevestig om te verwijderen`,
"front-epwechat-module-v1-callback":`Terugbelconfiguratie`,
"front-email-payment-failed":`Sorry, betaling mislukt!`,
"label.icon.67":`Machine`,
"UG_Forcast_01":`Voorspelling`,
"label.escalation.setup.newentries.step3":`Stap 3 Geef aan hoe escalatietijden worden ingesteld`,
"lable.account.NextCY":`Volgende CY`,
"report.type.label.quote":`Citaten`,
"label.area.name":`Territorium Naam`,
"component.setup.label.object":`Objecten`,
"label.customsetting.type":`Instelling Type`,
"label.showdetail":`Toon Details`,
"label.department.prev":`Vorige Pagina`,
"label.select.data.source.report":`Selecteer gegevensbron Rapport`,
"UG_homepage_002":`Beheer uw aanwijzingen, leads, verkooptrechters en accountinformatie met geïntegreerde bedrijfshulpmiddelen`,
"vue_label_report_notice_exprot1":`Alleen de detailrijen worden geëxporteerd. Gebruik deze gegevens voor meer berekeningen of upload ze naar andere systemen. Export per pagina, tot 5000 items op één pagina`,
"message.error.task.phonecreate":`Telefoon taak creatie anomalie`,
"label_chatter_day":`Dag`,
"label.setinitialcommiter":`Stap 6: Initiële indieners specificeren`,
"message.huanxinconfig.notfound":`Easemob configuratie is niet gevonden`,
"label.customfields.file.count.tip":`Voer het aantal bestanden in dat in dit veld kan worden ingevoerd, de standaardwaarde is 1`,
"label.weixin.appmanage":`App Beheer`,
"label.approverautoconfirm":`Geautomatiseerde Goedkeurder Bepaald door`,
"vue_label_CCChat_followers":`Volgers`,
"label.usermanage.notselect":`Er zijn geen gebruikers geselecteerd.`,
"label.item":`Item(s)`,
"label.sendemail.chat.linkurl":`De URL van de link:`,
"label.sendmail.step3.deliveroptions":`Leveringsopties`,
"homepage.components.creationtime":`Gemaakt op`,
"label.pc.ui.2018.ccchat.setting":`CCChat-instelling`,
"label.knowledge.search.result.highlight":`Markeer relevante artikelen in de zoekresultaten`,
"label.data.downpage.e.title.num2":`2、Indien u ervoor kiest om gegevens van een enkel object te exporteren, moet u kiezen hoe de gegevens worden geëxporteerd: aangepast exporteren, exporteren volgens sjabloon en exporteersjabloon.`,
"label.field.duplicate.error.msg1":`Hier zijn dubbele gegevens, controleer eerst de dubbele, en stel dan uniek eigendom in.`,
"label.campaign.channel.input.number.error":`Fout in getalformaat`,
"label.goto.dashboard":`Ga naar Dashboards`,
"com.cloudcc.login.error.message.invalid.ip":`Uw IP is niet in het IP bereik.`,
"label.selectnewfieldvalue":`Geef nieuwe veldwaarde op`,
"label.appointmentdetail.wizard.title11":`Einddatum`,
"Opportunity_Detailed_Phase_Label_Popup_001":`Begindatum van de huidige fase`,
"front-dynamiclayout-module-v1-readonly":`Het veld van {vereist} is ingesteld als Alleenlezen.`,
"vue_label_calendar_start_field":`Veld voor Start`,
"label.weixin.recalculate.shared.failed":`Herberekening van de regel voor het delen van objecten mislukt.`,
"label.sendmail.step3.dealoptions":`Verwerkingsopties`,
"setup_layout_label_modifypage":`Pagina-indeling bewerken`,
"homepage.components.select.wide":`Selecteer brede componenten om te tonen`,
"label.import.page1.laststep":`Vorige`,
"label.weixin.donot.permission":`U hebt geen toestemming om deze bewerking uit te voeren.`,
"message.error.name.null":`naam kan niet leeg zijn!`,
"label.salescloud.teamrole.optionlist":`Team Rol Picklist Waarden`,
"component_setup_label_titlefield":`Titel veld`,
"vue_label_commonobjects_detail_have_been":`Je bent geweest`,
"label.textmessage.vonage.setup":`Vonage Setup`,
"label.recordtype.profile.enableit":`Inschakelen voor profiel`,
"UG.product.04":`Creëer product`,
"label.knowledge.No.related.articles":`Geen gerelateerd artikel...`,
"label.chat.muted":`Niet storen`,
"registration.page.field.selection":`Selecteer veld van registratiepagina`,
"label.project.hit.eleven":`Uitvaardiging van een toewijzingsbericht`,
"lable.newtabpage.advsearch":`Geavanceerd zoeken`,
"label.report.share.roleandsub":`Rollen en interne ondergeschikten`,
"component.salesperformance.label.nodata":`Voeg uw zakelijke opportuniteit toe en keer hier terug om de prestatiegrafiek te bekijken.`,
"label.submitted_on":`Ingediend op`,
"label.file.create.link":`Maak link`,
"label.contact":`Contacten`,
"label.tab.message.failtoopenleft":`De samenvoegbewerking is mislukt bij het openen van de linkerkolom`,
"label.replaces":`Vervangen`,
"label.customcomponent.check.tag.startwith":`Component moet beginnen met het label &lt;cc:component&gt;.`,
"label.tab.web":`Web Tabbladen`,
"message.success.task.add":`Succesvol opslaan van de nieuwe taakinformatie`,
"label.chatter.addresser":`Afzender`,
"label.mobile.homepage":`Homepage`,
"label.data.imp.su.ok":`Importeren`,
"label.knowledge.category.hint.one":`Categoriegroep is de hiërarchie van gegevenscategorieën. Bijvoorbeeld, een categoriegroep met de naam "Locatie" kan de geografische hiërarchie van continent, land, regio en staat bevatten. Gebruik deze pagina om categoriegroepen en subcategorieën te beheren.`,
"label.schedulejob.setup.schedule.weekly":`Wekelijks`,
"label.tag.manage.description":`Alle tags van {0} zijn als volgt. U kunt de beschikbare tags hernoemen of verwijderen.`,
"label.tabcontrol":`Tabs`,
"label.field.duplicate3":`Behandel "ABC" en "abc" als dubbele waarden __(hoofdlettergevoelig)`,
"label.customsetting.type.list":`Lijst`,
"lable.account.ovdate":`Einddatum fiscaal kwartaal`,
"label_chatter_pastSevenday":`De afgelopen 7 dagen`,
"front-kefu-moudle-v1-lxndxsdb-free":`Neem contact op met uw vertegenwoordiger en schakel free agent servicer in`,
"label.termsforusage":`Gebruiksvoorwaarden`,
"label.forecast.settings.qijian.m":`Maand Prognose`,
"label_tabpage_viewname":`Naam bekijken`,
"label.report.action.addtodashboard1":`Toevoegen aan Dashboard`,
"label_vue_create_edit_obj_create_event_dialog_desc":`De gebruiker die u hebt toegewezen is al bezig met roosters:`,
"vue_label_report_standardfilter":`Standaard Filter`,
"label.umeng.approval.submit":`#aanvrager heeft een record #obj ter goedkeuring ingediend.`,
"label.tab.mobile.sign":`Mobiele-kant pictogram`,
"vue_label_commonobjects_detail_check_the_content":`Er is een verificatiefout, gelieve de inhoud te controleren`,
"UG_Campaign_001":`Planning campagnes`,
"chatter.group.baseInformation":`Basisinformatie`,
"label.sendemail.send.noreceiver":`Geen ontvanger of het adres van de ontvanger is leeg.`,
"template.chart.yskje":`Vorderbaar bedrag`,
"label.textarea":`Tekstgebied`,
"vue_label_statistics_value":`Statistische waarde`,
"font-evaluate-module-v1-select-img":`Selecteer afbeelding`,
"label.totalof":`Je bent een totaal van`,
"label.hangye":`Industrieën`,
"label.partner.common.setup":`Gemeenschappelijke instellingen`,
"label.icon.78":`Landbouw`,
"lable.outlook.detail.addemail":`Email toevoegen`,
"label.ServiceCloud.fuwuquyu":`Dienstengebied`,
"label.gb2312encoding":`Chinees (GB2312)`,
"label.appointment.wizard.subtitle4-3-1":`10 min.`,
"label_emailtocloudcc_reauthorization":`Hergoedkeuring`,
"label.approval.message":`Goedkeuringsadviezen kunnen tot 1000 tekens worden ingevoerd.`,
"label_component_helper":`Assistent`,
"label.editRate":`wisselkoersen bewerken`,
"label.setuptemplate":`Automatisering Sjablonen`,
"label_emailsync_button_cancel":`Annuleren`,
"label.marketseamemset.account.maxuser":`Maximum aantal klanten`,
"label.someerror":`Om veiligheidsredenen loopt uw CloudCC-sessie bijna ten einde.<br><br>Wat gaat u nu doen?`,
"label_person_in_charge":`Toezichthouder`,
"label.visualpage.reference.standard.style":`Roep de standaard stijl van Platform op, pas aan-custom stijl`,
"errormessage_email_relatedorreceivermusthaveone_z":`U moet ten minste één ontvanger of een verwant onderwerp kiezen.`,
"label.insert.field.empty.continue":`Er bestaan records met de nietige waarde 【{resDataField}】, dus de code kan niet gegenereerd worden. Wilt u doorgaan met genereren?`,
"component.newrecords.label.title":`Recente records`,
"template.detail_info_link":`Details Link`,
"component_setup_tabs_label_default":`Standaard pagina`,
"label.emailobject.template.name.null":`Mail sjabloon naam kan niet leeg zijn！`,
"label.knowledge.field.changed":`{1} is veranderd`,
"homepage.components.select.narrow":`Selecteer te tonen componenten`,
"label.mobile.phone.week":`Week`,
"component_chatter_button_like":`Zoals`,
"label.brief.won":`Won`,
"label.setup.profile.replaceme":`Vervang de dingen over mij`,
"label.knowledge.setting.enable.lightning":`Activeer Kennis van de Bliksem`,
"label.middle":`Midden`,
"label.icon.109":`Mensen`,
"vue_label_normal_activity_sf":`Activiteit`,
"chatter.poll.option6":`Keuze 6`,
"label.lanxin.setting":`Integreer Lanxin H5 MiniApp`,
"label.stdashbord.xsld.business.totals":`Totaal Kansen`,
"label.emailobject.emaildetail.promptbutton1":`Bevestig`,
"Opportunity.Detailed.Phase.Label.001":`Stadium`,
"label.customcomponent.params.info":`Hoe gebruik je parameters.`,
"label.emailtocloudcc.button.next":`Volgende`,
"front-email-payment-billing-date":`Factuur Datum`,
"label.ems.with3day":`Binnen 3 dagen`,
"label.project.subtask.date":`De datum van de subtaak moet vallen binnen het datumbereik van de taak waartoe hij behoort.`,
"label.role.allunselectanduseduser":`Alle niet-toegewezen en actieve gebruikers`,
"front-kefu-moudle-yes-wantbuy":`Ja, ik wil kopen`,
"label.looking_for":`Heb je gekregen wat je zocht?`,
"page.404.label.noresource":`Sorry, de bron die u wilt bereiken bestaat niet.`,
"vue_label_ccchat_notice_deletecommentcertification":`Weet je zeker dat je deze opmerking wilt verwijderen?`,
"label.data.setok.e.desc1":`Export succes, ontvangt u een systeem bericht waarschuwingen,afgeleide gegevens worden tijdelijk opgeslagen in de server, het systeem alleen voor u om 48 uur op te slaan, neem dan zo snel mogelijk naar`,
"label.weixin.confirm.delete":`Weet u zeker dat u deze gegevens wilt verwijderen?`,
"A":`Tekstgebied (rijke tekst)`,
"template.report.sales.cycle":`Duur van de verkoopcyclus`,
"label.service.shift":`Werktijden`,
"label.visualpage.display.side.bar":`zijbalk weergeven,false-zijbalk niet weergeven`,
"label.list.userinterface.chatter.showall":`CCChat Homepage toont standaard alle berichten`,
"vue_label_systemSettings_set_course":`Zet het pad uit door tips toe te voegen voor elke fase om gebruikers stap voor stap te begeleiden.`,
"label.icon.156":`Mensen`,
"label.marketsea.button.move":`Verplaats`,
"front-email-payment-select-email":`Voer de postcode in`,
"front-electronic-signature-service-provider":`Dienstverlener`,
"label.h5.add.checkin":`Inchecken.`,
"vue_label_amount_total":`Totaal Bedrag`,
"label.campaign.channel.new":`Campagnes: een nieuw marketing kanaal`,
"label.knowledgebase.restore.creates.draft":`Herstel zal een ontwerp genereren van de huidige versie. U moet het ontwerp publiceren zodat iedereen het kan zien.`,
"UG_Case_01":`Zaak`,
"label.validate.function.funcExplain.CONTAINS":`Controleer of de tekst een specifiek karakter bevat, en indien ja, stuur dan TRUE terug, zoniet stuur FALSE terug`,
"label.data.exp.savetemp":`Opslaan als sjabloon`,
"front-project-module-v1-template-newcreate":`Maak Project van Project Sjabloon`,
"label.field.default.count":`Standaard aantal rijen`,
"page.note.acc":`Opmerkingen`,
"label.close":`Sluiten`,
"label.app.detailbeforeedit":`Aangepaste app details hieronder. Klik op "Bewerken" om aangepaste apps te wijzigen.`,
"label.profile.standardfieldsafety":`Standaard beveiliging op veldniveau`,
"vue_label_report_notice_deletefilter":`Verwijder eerst het geavanceerde filter`,
"label.multilang.datamoveaction.movesuccess":`In totaal zijn {0} records succesvol overgedragen!：`,
"label.emailmerge.edittemplate.descirption":`Voer informatie in over uw samenvoegsjabloon. Merk op dat de beschrijving alleen in CloudCC.com wordt weergegeven, niet in Word.`,
"label.visualpage.at.the.end":`Gebruik de tag aan het eind`,
"label.exchange.sync.state":`Exchange Sync State`,
"label.newdashboardpage.new":`Een rij toevoegen`,
"label.querydetailservice.profile.notsetup":`Het profiel voor uw account is niet ingesteld.`,
"label.escalation.setup.detail.description":`Voeg regels toe die de criteria specificeren die worden gebruikt om gevallen te escaleren. U kunt de volgorde van regelitems op deze pagina wijzigen nadat u ze hebt aangemaakt.`,
"lable.setup.mobilesetup.isenbaleh5newandedit":`Als je h5 inschakelt in je mobile-side en`,
"vue_label_file_upload_tip_msg":`Wij raden aan dat het geüploade bestand kleiner is dan 30MB, anders kan het ertoe leiden dat de pagina traag laadt`,
"label.eowechat.epdeptid":`WeCom Afdeling ID`,
"label.adminorapprover":`Beheerders <strong>Of</strong> de huidige toegewezen goedkeurder kan records bewerken tijdens het goedkeuringsproces.`,
"label_emailtocloudcc_email":`E-mail`,
"setup_main2018_label_norole":`U hebt niet de administratieve rechten`,
"label.onlyone":`Uniek`,
"label.sso.saml.idp.config.nameidtype":`Onderwerp Type`,
"vue_label_normal_campaign_sf":`Campagnes`,
"label.icon.61":`Kraan`,
"label.datatype":`Gegevenstype`,
"label.mobile.home.page.today.work":`Mijn Banen`,
"label.sendemail.chat.praiseFeedcommentsubject":`CloudCC CCChat vond uw opmerking leuk`,
"chatter.sel.p":`0 geselecteerd.`,
"label.b_c":`B naar C relatie:`,
"label.tabcontrolnameandtaglib":`Tabbladnamen en labels`,
"label.globaloperation.tip":`Creëer, bewerk en bekijk globale bewerking, die gebruikt kan worden voor detailpagina's.`,
"R":`Record Soorten`,
"label.initcommiteoperate":`Eerste indieningsacties`,
"front-kefu-moudle-v1-Operation-without0-permission":`Geen toestemming om dit record te gebruiken, neem contact op met de beheerder`,
"button_partner_create":`Nieuw`,
"label.document.name.length.cannot.than":`De lengte van de documentnaam mag niet meer dan 255 karakters bedragen.`,
"label.area.donot.delete":`Kan dit gebied niet verwijderen, omdat het huidige gebied een sub-gebied heeft.`,
"label.currency.activation":`Activeer`,
"label.connect":`&Concatenate`,
"button.partner.viewdetail":`Bekijk`,
"setup_object_field_dependency_label_mustsetup":`Stel eerst de afhankelijkheid van het veld in en sla op.`,
"label.SalesCommitmentKanBan.task":`Vorderingen Taak Bedrag`,
"lable.quote.syncing.finishbutton":`Gedaan`,
"label.weixin.group.type":`Type toegang`,
"vue_label_commonobjects_detail_relationship":`Graad van verwantschap`,
"vue_label_email_cc":`Bcc`,
"setup.object.field.dependency.label.fieldvalueoptions":`Beschikbare veldwaarden`,
"label.sso.lookAtTheKey":`Sleutel weergeven`,
"UG.opportunity.008":`Opportunity-team`,
"label.customfields.new.step1":`Stap 1 Kies het veldtype`,
"lable.qrcodeOrbarcode.rule":`Genereer QR Code/Bar Code Regels`,
"vue_label_notice_nopermission_delete":`Sorry, u hebt geen toegang om dit record te verwijderen, gelieve de beheerder te contacteren.`,
"label.customerobj.tab":`Tabbladen voor aangepaste objecten`,
"com.cloudcc.login.error.message.nolicens":`De licentie bestaat niet`,
"label.sendsms.batch.confirm":`Mass SMS: Bevestig`,
"label.forecast.settings.sos":`Inkomsten en hoeveelheid`,
"label.calendar.addevent.notice.opencalendarfirst":`Open mijn kalender of andere kalenders voordat u evenementen toevoegt`,
"message.success.task.phonerecord":`Sla telefoon records succesvol op`,
"label.knowledgebase.create.new.subtab":`Nieuwe Sub-tab`,
"label.knowledge.article.recordid":`De ID van kennisartikel kan niet null zijn`,
"Opportunity.Detailed.Phase.Label.Popup.003":`Dagen in huidige fase`,
"homepage.layout.nowpage":`Bestaande pagina-indeling`,
"template.chart.khslph":`Aantal Rekeningen Rangschikking`,
"front-epwechat-module-v1-android-single":`Android Single Sign On:`,
"serviceresource.assignedresource.islacksr.lack":`U kunt de service resource niet verwijderen want er is een service appointtmen aan toegewezen. U kunt deze service resource uitschakelen.`,
"label.email.only.display.info":`Alleen contactpersonen of collega's met opgeslagen e-mailadressen worden in het onderstaande vak weergegeven`,
"label.weixin..xsld.yjhtje":`Verwacht contractbedrag`,
"label.permission.delete.permsets.error.prompt":`De rechtenverzameling kan niet worden verwijderd omdat er gebruikers aan zijn toegewezen.`,
"label.ccchat.enter.two.choices":`Geef ten minste twee keuzes aan`,
"label.edit.field.select.style2":`Eén optie per regel`,
"vue_label_email_please_enter_email_subject":`Voer e-mail onderwerp in`,
"batch.sendemail.f":`, mail mislukt.`,
"label.sms.senderr":`SMS verzenden mislukt`,
"label.batchadd.newbatchpage.save.em":`Ongeldig e-mail formaat`,
"label.icon.96":`Kompas`,
"message.recordtype.deleterecord.tip":`Gebruik deze pagina om alle bestaande pecord types te vervangen door nieuwe record types. Selecteer het record type hieronder om alle records die de verwijderde record types bevatten te repalcen. Indien u alleen het recordtype van een bestaand recordtype wilt verwijderen zonder het te vervangen door een nieuw recordtype, selecteer dan "Geen".`,
"label.field.edit.max":`Maximumscore`,
"label.partnerCloud.orderingPlatform.preferential":`Korting`,
"label.callcenter.login.later":`Log later in`,
"batch.change.owner":`Selecteer de eigenaar`,
"label.version.allow.upload.size":`editie, maximum toegestane upload bestand`,
"setup.mainpage.label.welcome17":`Toestemmingsinstellingen`,
"label.tag.sectionname":`Tag Informatie`,
"label_partner_workspace_setup":`Instellingen`,
"label.managecontrol":`Administratieve machtigingen`,
"label.timetrigger.condition":`Evaluatie voorwaarde is ingesteld op elke keer dat de record wordt aangemaakt of bewerkt.`,
"label.reportsSubscriptionPage.schedulereport.monthly.week":`Week`,
"front-verkoop-bywerking-error":`Update mislukt`,
"label.allowcommittercallback":`Indieners de mogelijkheid bieden goedkeuringsaanvragen in te trekken`,
"vue_label_commonobjects_detail_lead_finishistatus":`Markeer status als voltooid`,
"message.error.object.lookupmd":`het relatieveld Mater-Detail wordt in dit object gecreëerd`,
"label.stdashbord.xsld.business.img7":`Aantal fasen met een waarschijnlijkheid van 0% / (Aantal fasen met een waarschijnlijkheid van 100%   Aantal fasen met een waarschijnlijkheid van 0%)`,
"label.checkruleofevent":`Gebeurtenis-validatieregels`,
"front-epwechat-module-v1-single":`Eenmalige aanmelding`,
"label.tabpage.save":`Save`,
"label_emailtocloudcc_search":`Zoeken op`,
"label.tianyancha.h5.registeredPlace":`Geregistreerde plaats (inkorting)`,
"label.field.addoptionlist":`Picklist waarde toevoegen: Keuzelijst`,
"label.schedule_anotherpost":`Plan andere posten`,
"label.customfields.searchrelation.tip":`Creëert een relatie die dit object met een ander object verbindt. Het relatieveld laat gebruikers toe op een lookup icoon te klikken om een waarde te selecteren uit een popup lijst. Het andere object is de bron van de waarden in de lijst.`,
"label.partnerCloud.partnerAccount.prepaidPhone":`Rekening opwaarderen`,
"label.projectManagement.view.details":`Details bekijken`,
"label.sendemail.chat.praiseFeed":`Beste #naam:hallo! #naamgebruiker vond je micropost leuk.`,
"label.validate.function.category.Text":`Tekst`,
"component.task.label.newevent":`Nieuwe taak`,
"label.data.import.setup.operate":`Wat wil je doen als je een bestaand record vindt?`,
"label.salescloud.salesdashboard.clear.option":`Duidelijke opties`,
"lable.account.PreviousCY":`Vorige 2 CY`,
"label.appointment.wizard.subtitle8":`Bedrijfsnaam zichtbaar voor de genodigde`,
"label_emailsync_status_viewlog":`Logboek bekijken`,
"message.duplication.label.filtertitle":`Duplicaat filters zoeken`,
"label.custom.quarter.description":`Op deze pagina kunt u aangepaste kwartalen definiëren en bewerken. De datum van het aangepaste kwartaal wordt gegenereerd op basis van de keuzes die u hieronder maakt.`,
"label_tabpage_filenamez":`Bestandsnaam`,
"lable.currencyAdv.andbefordate":`en voordat`,
"label.version.nonsupport.sharerule":`Sharing Rules worden tijdelijk niet ondersteund.`,
"front-epwechat-module-v1-unbound":`Ontbinden`,
"label.division":`Divisie`,
"label.data.import.setup.repeat":`Wilt u voorkomen dat er dubbele records worden aangemaakt?`,
"label.callcenter.makesure.Amazon.connect":`Opmerking: Zorg ervoor dat u een instantie van Amazon Connect hebt aangemaakt`,
"label.version.lead.control":`Leiding Management`,
"label.copying.reward.groups":`Kloon Quote Lijngroep`,
"#label.severalorone":`Zip of individueel bestand#`,
"label.mailinginfo":`Postadres`,
"component.telerecord.label.title":`Een oproep loggen`,
"label.godocumentlist":`Terug naar de lijst: Documenten`,
"APPIntegration.Dropbox.setting.01":`Activeer`,
"label.tianyancha.website":`Website`,
"label_tabpage_greaterequalz":`Groter dan of gelijk aan`,
"vue_label_campaign_influencedopportunity":`Beïnvloedde zakelijke mogelijkheid`,
"message.save.param.null":`Parameter is leeg, opslaan mislukt`,
"front-epwechat-module-v1-domain":`Vertrouwde domeinnaam  JSSDK：`,
"label.allowreport":`Rapporten toestaan`,
"label.service.major.event":`Mijlpaal`,
"label.import.index.selectobjectandfiles":`Selecteer object en bestand`,
"label.chatter.task":`Taak`,
"label.knowledge.setting.hint.twelve":`Gegevens categorie invoeren`,
"lable.account.CurrentandPreviousFY":`Huidig en vorig BJ`,
"label.martrixreport.step3":`Stap 3 Selecteer de samengevatte gegevens`,
"front-console-select-cases":`Het aantal geselecteerde zaken mag niet meer zijn dan 10`,
"label.partnerCloud.partnerAccount.backHome":`Terug naar startpagina`,
"label.me.assign":`Door mij toegewezen`,
"label.appointment.wizard.subtitle3":`Ontmoetingstijd`,
"label.edit_columns":`Kolommen bewerken`,
"label.partnerCloud.orderingPlatform.useRebates:":`Gebruik korting:`,
"label.projectManagement.enter.up.to.10.digits":`Er kunnen maximaal 10 cijfers worden ingevoerd.`,
"label.integrations.description.mailchimp":`Door CloudCC met MailChimp te integreren, kunt u geselecteerde leads en contactpersonen uit uw CloudCC-account naar MailChimp importeren en de e-mail naar de beoogde ontvangers sturen. Uw gebruikers kunnen de resultaten ook in MailChimp volgen.`,
"label.ccchat.person.error.requiredomain":`Fout: minstens één domein vereist`,
"label.projectManagement.Pleaseselectitem":`Selecteer een project`,
"label.netaccess":`Netwerk toegang`,
"vue_label_SMS_searchobject":`Object zoeken`,
"label.role.viewintree":`Tonen in boomstructuur`,
"lable.SalesCommitmentKanBan.accountName":`Naam van de rekening`,
"label.please.contact.your.administrator":`Neem contact op met de beheerder om de regels te activeren voor het genereren van QR code/Bar code`,
"label.sso.saml.sp.idenitysource":`SAML Identiteitsplaats`,
"label.queue.delete":`Delete`,
"label.service.miniProgram.jumpLink":`Sprong link`,
"label_set_ forecast_scope":`Stel prognosebereik in`,
"label.weixin.success.sign":`Heeft zich succesvol aangemeld, alstublieft.`,
"front-dialog-module-v1-error-code":`Foutcode`,
"label.projectManagement.nodata.problem":`Geweldig! Er hoeven geen lastige problemen opgelost te worden.`,
"label.myhomepage":`Mijn startpagina`,
"label.exchange.sync.state.task.m1":`Laatste gesynchroniseerde activiteit:`,
"label.pw.config":`Bevestig uw wachtwoord`,
"front-console-new-contact":`Nieuw contact`,
"label.customfields.fielddependency.editexplain":`<li>Dubbelklik op een cel om de zichtbaarheid ervan te wijzigen voor de waarde van het Controlling Field die in de kolomkop wordt weergegeven.</li><li>Om meerdere cellen tegelijk te wijzigen, selecteert u meerdere cellen en klikt u vervolgens op de knop Include Values of Exclude Values om de zichtbaarheid van alle geselecteerde cellen tegelijk te wijzigen.</li><li>Gebruik SHIFT   klik om een bereik van aangrenzende cellen te selecteren. Gebruik CTRL   klik om meerdere cellen te selecteren die niet aangrenzend zijn.</li><li>Gebruik de knop Voorbeeld om de resultaten te testen.</li>`,
"setup_mainpage_label_welcome7":`Instructies: Klik op het menu aan de linkerkant van de pagina → Applicatie-instellingen → Aanmaken → Object → Objectnaam → Aangepast veld.`,
"message.validation.sum":`Er worden te veel velden getoond op de goedkeuringspagina, u kunt tot 190 velden selecteren.`,
"label.knowledge.attach.case":`Bevestig aan de koffer`,
"front-electronic-signature-custom-field-type":`Aangepaste veldtypes`,
"vue_label_pricebook_activated":`Prijslijst is geactiveerd`,
"vue.schedule.pre":`Dit is mijn schema, alstublieft`,
"Lead_Tools_BatchScoring":`Lead Batch Scoring`,
"front-lightning-module-v1-details-page-chart-screening-based-on":`Filter op`,
"label.report.no.recently":`Geen recent record.`,
"label.service.gantt.dangerous.sum":`Aantal dienstafspraken in gevaar.`,
"label.main.field":`Primair veld`,
"label.weixin.optionfive":`Keuze 5`,
"homepage.wide":`Brede (rechter) kolom`,
"vue_label_notice_confirmdelatehomepage":`Weet u zeker dat u de startpagina wilt verwijderen?`,
"vue_label_report_exportpages":`Uitvoerpagina's: Nee.`,
"label.select_compaign":`Kies een campagne`,
"attachment.button.massdownload":`Massa Downloaden`,
"label.chatter.incident":`Evenement`,
"label_partner_new_step1":`Stap 1 Kies het sjabloon dat u bevalt`,
"button.partner.workspace.saveas.memo":`Sla de huidige partnerwolk op als een "sjabloon".`,
"vue_label_pricebook_edit":`Prijslijst bewerken`,
"label.weixin.privacy.rights":`Privacy Toestemmingen1aB geschatte locatie (web-based), exacte locatie (GPS).`,
"label.please.codeType":`Kies type code.`,
"label.approveorrefuserequest":`Goedkeuren / Afwijzen`,
"message.error.sharemember":`Het doorgegeven sharemember kan niet leeg zijn, controleer de doorgegeven parameters!`,
"label.file.folder.edit":`Map bewerken`,
"label.data.import.setup.repeat.yes":`Ja-Voorkom dat er dubbele records worden aangemaakt. Opmerking1aAls u een bestaande record wilt bijwerken, moet u deze optie selecteren.`,
"label.approveBeforeTheOperation":`Werk alvorens goed te keuren`,
"vue_label_file_already_checked_file":`{CheckedWork} bestanden zijn geselecteerd, er kunnen maximaal 10 bestanden tegelijk worden toegevoegd`,
"vue_label_hidden_record_count":`Recordaantal verbergen`,
"UG_product_01":`Lijst van producten/diensten`,
"label.tabpage.clearoptionsz":`Wis geavanceerde opties`,
"label.partnercloud.num.overstep":`Maximum aantal partnerwolken overschreden.`,
"label.tianyancha.businessverify.msg8":`Op dit moment ondersteunt deze functie alleen het bevragen van ondernemingen die geregistreerd zijn voor zaken op het vasteland van China, en het heeft een zekere vertraging.`,
"Lead_Scoring_DetailedPage_Popup_Title":`Leidend Inzicht`,
"label.emailtocloudcc.email":`E-mail`,
"vue_label_pool_highcost":`Hoge productkosten`,
"label.callcenter.enterprise.configuration":`Kopieer het sleutelpaar in OndernemingsconfiguratieSysteeminterconnectie in het systeem van Tianrun`,
"label.view.edit.search.prompt":`Voer de trefwoorden in`,
"label.ems.sms":`Stuur een sms`,
"label.emailobject.list.new":`Samenstellen`,
"label.salescloud.forenableteamsales":`Verkoopteam inschakelen`,
"pagecreator.systemstyle.funcpath":`/ bouwer / merkgebonden stijlbibliotheek`,
"label.partnerCloud.basicSetting.domain":`Toplevel domein kan niet leeg zijn`,
"label.projectManagement.Posttask":`Post-taak`,
"label.tianyancha.businessverify":`Verificatie van bedrijfsgegevens mogelijk maken`,
"label.tianyancha.h5.info":`Basisgegevens`,
"september":`September`,
"chatter.poll.option9":`Keuze 9`,
"label.department.firstpage":`Het is de eerste pagina`,
"label.reportsSubscriptionPage.condition.button":`Voorwaarde toevoegen`,
"label.exchange.sync.state.task":`Taken`,
"pagecreator.layout.button.splitall":`Alles splitsen`,
"vue_label_calendar_please_select_the_start":`Selecteer het veld voor de start`,
"label.tab.message.failtogettop":`Het lukt niet om de bovenste tab te krijgen`,
"label.sharerule.organizationscopesetshare":`Organisatiebrede standaardinstellingen`,
"label.delete.rules":`Regels verwijderen`,
"label.recordtype.tabname.detail":`Klik op "Bewerken" om de eigenschappen van dit recordtype te wijzigen. Selecteer de beschikbare keuzelijst waarden voor dit record type door te klikken op bewerken link in de keuzelijst waarden gerelateerde lijst.`,
"label.knowledge.setting.hint.ten":`Niet zeker van de wijze van orgnisatie? Geen probleem. U kunt het later uitvoeren.`,
"vue_label_norm_undone":`Deze bewerking kan niet worden teruggetrokken`,
"label.trigger.line":`lijn:`,
"lable.info.queue.reason":`Reden om lid te worden`,
"label.validate.function.funcExplain.HOUR":`Reutrn Geeft als resultaat het uur van de dag (van datum/tijd velden), variërend van 0 -11`,
"label.update.document.content":`de inhoud van het document gemotiveerd`,
"lable.Existing.template":`Beschikbare sjablonen`,
"label.summaryreport.step3":`Stap 3 Selecteer de groeperingsmethode voor samengevatte gegevens`,
"label.emailmerge.list.filetype":`Soort document`,
"label.customfields.helptext.tip":`De tekst wordt weergegeven op de detailpagina en de bewerkpagina wanneer de gebruiker met de muis over het informatie-icoon naast dit veld gaat.`,
"label.setting.intergrationlist.description":`Met CloudCC-integraties kunt u gegevens bekijken en delen tussen bedrijfsapplicaties zonder uw CRM te verlaten. Sommige integraties, zoals QuickBooks en Zapier, vereisen rechten om ze beschikbaar te maken voor uw gebruikers. Andere integraties, zoals Gmail en Outlook, kunnen door elke individuele gebruiker op zijn eigen account worden geconfigureerd.`,
"component_milestones_label_title":`Mijlpaal`,
"label.custom.AntiRevocation":`Annuleren Ongedaan maken`,
"label.mobile.app.new.task":`Maak nieuwe taken en gebeurtenissen aan op de mobiele app`,
"vue_label_opportunity_related_chooseproduct":`Kies ten minste één product`,
"label.standardguest":`Standaard Gast`,
"label.icon.125":`Instrument`,
"label.skipsomeset":`Omdat dit de Jump Start Wizard is, kiest CloudCC automatisch enkele instellingen voor u.`,
"label.forecast.shrepage.fmanager":`Forecast Manager`,
"label.mobile.quickcreate.default.work":`Kantoor`,
"label.projectManagement.nodata.team.members":`Kan mijn projectlid niet vinden`,
"label_social_media_account_settings":`Instelling account sociale media`,
"UG.quota.05":`Bisync met kansen`,
"label.partner.workspace.tab.selectedoption":`Geselecteerde tabbladen`,
"front-kefu-moudle-v1-clientID-reinput":`Gelieve clientID in te voeren`,
"label.mobile.home.page.contract.value":`Verwacht contractbedrag`,
"december":`December`,
"label.campagin.roi.dcrs":`Aanwezigheid`,
"label.currency.edits":`Valuta bewerken`,
"label.currency.company":`Vennootschap Valuta`,
"label.customfields.newformula.nogrammererror":`Geen syntaxfouten in samenvoegvelden of functies.`,
"label.version.nonsupport.api":`Interfate API wordt tijdelijk niet ondersteund.`,
"label.data.file.i.title.num2":`2. Het verdient aanbeveling de gegevens te exporteren wanneer de gegevens worden geïmporteerd, zodat het uitvoerdocument wordt gebruikt als sjabloon om de te importeren gegevens te ordenen, en vervolgens te importeren. (Indien de geïmporteerde gegevens een komma bevatten, vervang deze dan door het @-symbool).`,
"front-console-conversation-title":`Evaluatie van de dienst`,
"front-kefu-moudle-call":`Bel`,
"vue_label_systemSettings_pagefooter":`Instellingen voettekst`,
"label.newRule.successfully.added":`Nieuwe regels succesvol toegevoegd.`,
"label.trigger.direction.for.use":`Instructies voor platform triggers [Versie 2.0]`,
"label.instrumentPanel.maxLabelname":`Deze waarde moet groter zijn dan de minimumwaarde, de breekpunt 1-waarde en de breekpunt 2-waarde.`,
"label.same.month.report":`Jaaropjaar en MoMverslag`,
"label.knowledge.language.american":`Amerikaan`,
"label.paging.totalof":`Een totaal van {0}`,
"label.tianyancha.businessverify.enable.error":`Als het niet lukt om te achterhalen of de verificatie van de bedrijfsgegevens is ingeschakeld, neem dan contact op met de systeembeheerder!`,
"vue_label_commonobjects_detail_email_template":`Gebruik e-mail sjabloon`,
"message.error.save.failed":`Mislukt?`,
"advancedoptions":`Filter logica toevoegen...`,
"setup_object_layout_message_selectedlayoutandrecordtype":`Selecteer de lay-out en het recordtype`,
"label.sendemail.recycle.operatesuccess":`je hebt met succes je prullenbak geleegd, en #size data verwijderd.`,
"J":`Tekstgebied (lang)`,
"message.validation.isnotmail":`Voer een ongeldig e-mailadres in.`,
"label.timetrigger.before.lasttime":`1 uur eerder dan de laatst gewijzigde datum`,
"label.tabpage.arecordtypez":`Beschikbaar recordtype`,
"label.reportoption":`Rapport Opties`,
"pagecreator.button.next":`Volgende stap`,
"assetbom.transferowner.notpermission":`U hebt niet de bevoegdheid om asset BOM over te dragen. Neem contact op met de beheerder.`,
"label.toptitle.lightning":`Lightning`,
"label.copy.target":`Kloon Indicator Waarde`,
"label.productsales.oppor.approach":`Dreigende kansen`,
"label.email.template.select":`Kies een e-mail sjabloon.`,
"label.edit.lower.bound.of.discount.per.tier.is.required.":`De ondergrens voor het bewerken van elk niveau van korting is vereist.`,
"label.tabularreport.step3":`Stap3 De volgorde van de kolommen in het rapport bepalen`,
"label.multilang.cchttpservice.signin":`Beste {0}, uw uitgenodigde gast {1} van {2} is succesvol geregistreerd.`,
"label.appexchange.uninstallpage.message3":`Verwijder permanent alle gegevens van de aangepaste objecten in dit pakket`,
"label_tabpage_ownedz":`Helemaal`,
"label.tabularreport.2018.step2":`Stap 2 Kies rapportcriteria`,
"label.object":`Object`,
"template.report.contracted.customers":`Industriële analyse van gecontracteerde rekeningen`,
"label.field.remark3":`Merk op dat het verwijderen van een aangepast veld alle filters zal verwijderen die het aangepaste veld gebruiken. Het kan ook het resultaat wijzigen van Toewijzings- of Escalatieregels die gebaseerd zijn op de gegevens van het aangepaste veld.`,
"label.eventview.issms":`SMS-bericht`,
"label.knowledge.language.brazilian":`Portugees (Brazilië)`,
"vue_label_norm_viewfilter":`Een filter toepassen`,
"label.forecast.settings.qijian":`Prognoseperiode`,
"label.startuploadfile.step.intruduce":`Klik op "Select File" om het bestand te zoeken en de geselecteerde bestanden in het onderste gebied weer te geven.`,
"label.smstemplate":`SMS sjabloon`,
"vue_label_chatter_no_permission":`U heeft geen toegang om dit bestand te bekijken`,
"label.callcenter.Incorrect.data.filling":`Er is een fout bij het invullen van de gegevens`,
"label.tag.search.button":`Zoeken op tags`,
"label.multiplyselectoptions":`Keuzevak opties`,
"lable.outlook.detail.mutual":`Bidirectionele Sync`,
"label.workflow.estimatecondition1":`gemaakt, en elke keer als het wordt bewerkt om vervolgens te voldoen aan criteria`,
"label.validate.globalvariable.user.profileId":`Profiel ID`,
"UG.Campaign.003":`Creëer een campagne`,
"label.validate.function.funcExplain.ISNULL":`De uitdrukking is null en geeft TRUE terug, anders bevat ze een waarde en geeft ze FALSE terug.`,
"label.setting.intergrationlist.status0":`INTEGRATIESTATUS`,
"label.copy_error":`Mislukt te kopiëren`,
"label.connectOtherNone":`Het geselecteerde object heeft geen andere relateerbare objecten.`,
"label.bmap.beijing":`Beijing`,
"front-kefu-moudle-v1-hxzxybsc-again":`Easemob is verwijderd. Gelieve opnieuw aan te sluiten!`,
"label.wei.pollsubject":`Stem Onderwerp`,
"APPIntegration_Social_twittererror":`U moet een geldige URL invoeren voor twitter.com`,
"label.appupload.install.apicannotuse":`De naam van de api is nog steeds niet beschikbaar`,
"label.returntolist":`Terug naar lijst`,
"label.translation.start2":`Selecteer een instellingsonderdeel.`,
"lable.edit.queue.alter":`Selecteer de objecten die u aan deze wachtrij wilt toewijzen.`,
"label.campaign.channel.step3":`Stap3 Selecteer de velden die moeten worden weergegeven op de registratiepagina van het marketingkanaal`,
"label.data.newtemplate.e.seltype":`Selecteer de methode voor het exporteren van gegevens`,
"front-kefu-moudle-hangup":`Hang op.`,
"label.forecast.forecastroleuserpage.shre.managerandother":`Beheerders en de prognosebeheerders kunnen deze prognose delen`,
"label.knowledgebase.mark.as.new.version":`Markeer als nieuwe uitgave`,
"label.conditiontag.lookup":`Lookup`,
"label.import.page3.importsucceed":`Succesvol importeren`,
"label.stdashbord.xsld.condtion":`Conditie-instellingen`,
"label_emailtocloudcc_redmessage10":`De informatie is verlopen, gelieve opnieuw in te loggen.`,
"label.event.moveup.1hour":`1 uur vooruit`,
"label.chat.topic.page.add.favorite":`Opslaan als bladwijzer op CCChat-pagina`,
"label.icon.88":`Advies`,
"page_404_label_noresource":`Sorry, de bron die u wilt bereiken bestaat niet.`,
"label.quickbooks.refresh":`Vernieuwen`,
"front-kefu-moudle-which-getphone-case":`Regels voor het creëren van gevallen na het beantwoorden van een gesprek`,
"label.objecttab.edit":`Object Tabblad Bewerken`,
"label.data.file.the.trigger":`Trigger uitvoeren`,
"frame.personinfo.label.personimage":`Profiel foto`,
"label_tabpage_turnoffsz":`Zet uit - geconverteerd`,
"label.sendmail.batch.chose":`Massa e-mail: Selecteer ontvangers`,
"label.data.downpage.i_title":`Stappen voor het importeren van gegevens:`,
"label.recycle.clearconfirm":`Ben je zeker?`,
"chatter.using":`Deze gebruiker`,
"label.batchadd.newbatchpage.list":`Gegevenslijst massaal toevoegen`,
"pagecreator.systemstyle.button.new":`Nieuwe stijl`,
"label.notification.serviceappointment.changestate":`Status van {1}{0} veranderd in{2}{3}`,
"label.weixin.weipollname":`Micro Stem Naam`,
"label.tabpage.skip":`Ga naar`,
"label.edit.field":`Velden bewerken`,
"label.edit.new.rule":`Generatieregels bewerken`,
"label.approved.receiveApprovalEmail":`Emails met verzoeken om goedkeuring ontvangen`,
"label.dashboard.refreshNow":`Vernieuw nu`,
"label.lookup.introduce":`Voer ten minste 1 teken in om het zoeken te vervagen.`,
"homepage.components.newdes":`Zorg ervoor dat de hieronder ingevoerde HTML-code geldig en goed geformuleerd is. Als u ongeldige HTML-code in een component schrijft, kan het tabblad van de hele startpagina onjuist worden weergegeven.`,
"label.role.giveuserrole":`Rollen toewijzen aan gebruikers`,
"lable.opppdt.selPbk.subtitle":`Prijs Boek`,
"setup_mainpage_label_welcome19":`Instructies:  Klik op het menu aan de linkerkant van deze pagina → Beheer Instellingen → Beheer Gebruikers → Gebruikers, Rollen, Profielen`,
"setup.mainpage.label.welcome22":`Instructies: Klik op het menu aan de linkerkant van deze pagina → Instellingen beheren → Nieuwsbrief sjabloon → E-mail sjabloon.`,
"label.tianyancha.h5.zipcode":`Postcode`,
"label_tabpage_allapplications":`Alle toepassingen`,
"label.chatter.like":`Zoals`,
"label.licence.noremainder":`Onvoldoende licenties`,
"lable.outlook.edit.dataset":`Gegevens Instellingen`,
"D":`Datum`,
"label.detail":`Lees`,
"label.globaloperation.operationtype.custom_page":`Aangepaste pagina`,
"label.addattachment.down":`Download het bestand`,
"label.data.exportall.all_btn":`Alle gegevens exporteren`,
"label.recordtypeselect.current":`Huidig recordtype`,
"label.tabpage.entercusnamez":`Voer de naam van de klant in`,
"label.location.valunit.km":`Km`,
"label.mobile.phone.week.plan":`Volgende week`,
"vue_label_report_everyday":`Alledaags`,
"label.weixin.broadcasting":`Ik stuur...`,
"label.input.search.string":`Voer de zoekterm in`,
"label.picandreporttype":`Grafiektype`,
"label.setmulti":`Meervoudige overdracht`,
"label.visualpage.component.t":`Hoe gebruik je componenten?`,
"label.knowledge.designate":`Alleen kennisartikelen met de status Concept kunnen worden toegewezen.`,
"label.enable.barcode.only":`Alleen barcode activeren`,
"vue_label_commonobjects_detail_a_group_strategy":`Deze gegevens hebben geen eigenaar en kunnen geen Team creëren`,
"setup.layout.group.button":`Knoppen`,
"label.mini.layout.remark":`is de opmaak die gebruikt wordt in het zwevende venster op de pagina.`,
"setup.mainpage.label.welcome3":`Het maken van formulieren in het CloudCC cloud-platform is gebaseerd op aangepaste databases (objecten). Gebruikersgedefinieerde objecten zijn databasetabellen waarin gegevens worden opgeslagen die specifiek zijn voor uw organisatie. Tabel-naar-tabel relaties kunnen eenvoudig worden gelegd zonder enige programma-ontwikkeling.`,
"label.knowledge.draft.status":`De poststatus van kennisartikelen is Ontwerp!`,
"label.manageAll.sel.one1":`Goed te keuren punten`,
"label.campagin.roi.bhydkhywjh":`Aantal gesloten kansen`,
"label_partner_template_thumbnail":`Thumbnail`,
"label.loginip.setup":`IP-bereik inloggen`,
"label.data.downpage.e.title.e.btn":`Ga naar de export pagina en start het exporteren`,
"vue_label_appstore_project_management":`Projectbeheer`,
"assetbom.delete.notpermission":`U hebt niet de bevoegdheid om asset BOM te verwijderen. Neem contact op met de beheerder.`,
"vue.dashboard.setdrill.inThe":`behoudens`,
"label.mobile.more.savephoto":`Bewaar foto`,
"label.customerinfo.PageTriggerFag":`Sync`,
"label.commonobjects.Nopermission":`Sorry, u hebt geen toestemming om deze gegevens te bewerken, neem contact op met de systeembeheerder.`,
"label.searchlayout.opperationtab.xsldfield":`De velden die worden weergegeven wanneer u op de link Sales Funnel klikt op de startpagina van het tabblad opportunities.`,
"label.emailsync.form.disconnect":`Annuleer Conncet`,
"label.document.nofile.upload":`Geen bestand uploaden.`,
"label.appointmentpage.wizard.subtitle3-3":`Telefoon`,
"message.custom.field.donotdelete":`Veld wordt gebruikt en kan niet worden verwijderd.`,
"chatter.using0":`{0}ms is gebruikt op dit punt`,
"label.tabpage.multiple":`Meerkeuze`,
"label.attendance.setting.sy.alert":`U moet de geschikte gebruikers voor de aanwezigheid selecteren.`,
"label.refuse":`Weiger`,
"label.log.button":`zoeken op gebruikersnaam`,
"component_chatter_link_label_title":`Link`,
"template.report.contract.collection":`Contract Betaling`,
"label.campaignmember.selectmember.step1":`Stap 1 Selecteer campagne en status van campagneleden`,
"label.datamanage.warn.owner":`Waarschuwing: als u doorgaat met deze import, zullen alle records geïmporteerd worden met u als de record eigenaar.`,
"label.a.b":`A naar B relatie`,
"label.app.step3.homeisfrist":`Homepage moet de eerste zijn.`,
"UG_Lead_003":`Sociaal`,
"label.partner.workspace.member.choice":`Profiel kiezen`,
"lable.outlook.detail.emaping":`Map Gebeurtenis Velden`,
"label.service.appointmentList.gantt.chart.shows":`Toon Datum van Gantt`,
"label.mr.caption.account.result":`Duplicaten zoeken en samenvoegen: Resultaten voor het zoeken naar duplicaten van Rekeningen`,
"vue_label_chatter_approve_members_join":`Leden goedkeuren om lid te worden van de groep`,
"label.reportsSubscriptionPage.schedulereport.monthly.day":`Dag`,
"pagecreator.systemstyle.label.modifycolor":`Kleur bewerken`,
"label.tabpage.yesz":`Ja`,
"label.fieldtoolongmessage":`Veld overschrijdt limiet`,
"lable.account.year.name":`Fiscaal jaar Naam`,
"label.mini.layout":`Hover Lay-out`,
"label.icon.97":`Lesgeven`,
"vue_label_chat_smart_assistant":`Slimme assistent`,
"label.marketingmanagementuser":`Marketing Gebruiker`,
"label_emailtocloudcc_description2":`Verbind uw e-mail`,
"label.campaign.channel.input.name":`1. Voer de naam van het marketingkanaal in`,
"UG.homepage.007":`Van het versturen van follow-up e-mails tot het automatiseren van verkoopcampagnes, van het creëren van workflows met behulp van onze Blueprint-technologie tot het triggeren van aangepaste macro's: automatiseer dagelijkse taken en richt u meer op het opbouwen van relaties.`,
"label.share":`Delen`,
"label.step2.total6":`Stap 2 van 6`,
"label.sendemail.chat.addComentspraise":`Beste #naam:hallo! #naamgebruiker heeft gereageerd op de micropost die je leuk vond`,
"label.icon.20":`Bestand`,
"label.service.gantt.absenteeism":`Absenteïsme`,
"message.error.color.nagatice":`Het aantal huidige pagina's kan niet negatief zijn.`,
"chatter.group.applyToJoin":`Toetreden`,
"pagecreator_layout_message_delete":`Verwijdert u de huidige geselecteerde lay-out?`,
"label.multilang.viewlist.count":`Een totaal van {0} records：`,
"message.notdesable.type":`Dit recordtype kan niet worden verwijderd omdat het volgende profiel dit recordtype als standaardwaarde gebruikt.`,
"label.standard.time":`Standaard Tijd`,
"label_chatter_newpost":`Laatste bericht`,
"front-epwechat-module-v1-binding":`Bind WeCom`,
"label.recent":`Recent`,
"label.globaloperation.createfeeditem":`Maak een samenvattingsproject`,
"label_partner_common_roleNum":`Aantal rollen`,
"front-template-V1-quikSearch":`Voer veldnaam in en zoek`,
"label_tabpage_haschangedz":`Deze aanwijzing is omgezet`,
"label.service.work.order.line":`Werk Order Items`,
"label.lead.score.ok":`OK`,
"Account_News_Setting_003":`Algemene Instellingen`,
"label.event.moveup.15minutes":`15 minuten vooruit`,
"vue_label_all_selected_objects":`Alle`,
"label.visualpage.an.inline.style.relatedlist":`Embed aangepast paginatype aan gerelateerde lijsten`,
"label.umeng.approval.approvaling":`#aanvrager vraagt goedkeuring voor #obj #objnaam #eigenaar`,
"lable.SalesCommitmentKanBan.digital":`Cijfer`,
"label.appupload.img.max.size":`De afbeelding die u heeft geupload is te groot, de maximale grootte van de afbeelding mag niet groter zijn dan 20K, gelieve opnieuw te uploaden.`,
"vue_label_normal_top":`Top`,
"label.knowledge.language.traditional":`Traditioneel Chinees`,
"homepage.layout.edit":`Bewerk Home Layout`,
"label.campagin.qrcode":`Campagin QR Code`,
"label.emailmerge.merge.emailmerge":`E-mail samenvoegen`,
"label.icon.18":`Klok`,
"vue_label_homepage_taskview":`Taak Weergave`,
"label.search.related.record":`Er zijn geen gegevens gevonden.`,
"label.report.reports":`Verslagen`,
"label.appointment.wizard.subtitle4-3-2":`15 min.`,
"label.forecast.condition":`Prognoses Criteria`,
"label.westem.indonesia.time":`West-Indonesië Tijd`,
"front-epwechat-module-v1-callback-desc":`Kopieer de volgende informatie naar de backend van WeCom.`,
"label.version.group":`Team Editie`,
"label.allReportType":`Alle aangepaste rapportgegevensbronnen`,
"label.trigger.lastmodifydate":`Laatst Gewijzigde Datum`,
"message.layout.unique.sectionfield":`De uniciteitsbeperking van het veld in de paginalay-out is overtreden. Controleer het en sla het opnieuw op.`,
"vue_label_systemSettings_mobelbottonsetting":`Instelling bodemmenu voor mobiele app`,
"label.recordtype.selectonefield":`Selecteer ten minste één veld dat u wilt toevoegen`,
"label.notification.group1":`【申请人】 verzoekt om toetreding tot uw openbare groep`,
"component_todaytask_label_title":`Vandaag`,
"label.assignment.setup.list.description":`Wijs automatisch leads toe aan gebruikers op basis van criteria die u definieert. U kunt meerdere regels met verschillende voorwaarden maken.`,
"label.project.resource.data":`Deze service resource is toegewezen aan een service afspraak, gelieve deze niet opnieuw toe te voegen.`,
"label.emailmerge.newtemplate.file":`bestand`,
"label.notification.task1":`【分配人】 u een taak toegewezen`,
"label.ServiceCloud.Overlapping":`Overlappende zendingen weergeven`,
"label.globalselect.used":`De positie van het gebruik van het veld`,
"setup_layout_button_layoutprop":`Eigendommen`,
"label.quickbooks.retrivingdata":`Gegevens ophalen...`,
"component.button.ok":`Bevestig`,
"message.pleaseinputformula":`Gelieve formule in te geven`,
"label.h5.whatifollow":`Wat ik volg`,
"label.new.crew.target":`Nieuw Personeelsdoel`,
"label_chatter_task":`Taak`,
"label.knowledge.setting.data.four":`Er kunnen maximaal {count} categori groepen worden geselecteerd.`,
"label.rule.not.enabled":``,
"label_in_scope":`Binnen het bereik`,
"label.partnerCloud.orderingPlatform.bundle":`Pakket`,
"label.emailtocloudcc.redmessage10":`De informatie is verlopen, gelieve opnieuw in te loggen.`,
"label.knowledgebase.data.assignment.succeeded":`{a}gegevens succesvol toegewezen`,
"vue_label_commonobjects_view_nokanban":`Er is nog geen kanban-aanzicht aangemaakt`,
"label.knowledgebase.article.cancelled.attaching.case":`Het artikel {naam} is geannuleerd om aan zaak te hechten！`,
"label.brief":`Samenvatting`,
"label.version.sum.app":`toepassingen`,
"label.commoninfo":`Algemene informatie`,
"vue_label_SMS_nodata":`Geen gegevens`,
"label.icon.153":`Informatie`,
"label.conditiontag.lookup.false":`FALSE`,
"label.emailobject.view.unread":`Ongelezen E-mails`,
"label.staticresource.useful":`Waar wordt dit gebruikt?`,
"label.ems.connect.test":`Test`,
"vue_label_chat_group_assistant_notification":`Kennisgeving groepsassistent`,
"label.multipleactivity.total":`Een totaal van`,
"vue_label_report_addtocomponentlibrary":`Toevoegen aan componentenbibliotheek`,
"font-evaluate-module-v1-following-personnel":`Stel volgende gebruikers op de hoogte wanneer ze minder dan 3 evaluaties ontvangen:`,
"label.setup.mobile.bottombutton.change.fail":`Niet veranderd`,
"front-epwechat-module-v1-unbound-item5":`en de gegevens kunnen niet worden opgehaald, weet u zeker dat u de binding moet verbreken?`,
"label.customerinfo.smsUid":`SMS Gateway UID`,
"label.list.isOpenApprovalQueue":`Goedkeuringswachtrij activeren (niet beschikbaar onder Handmatige selectie van goedkeurder)`,
"label.leadscore.setup.scorenumber":`Tijd(en)`,
"label.workflow.selectobj.introduce":`Selecteer het object waarop deze workflow regel van toepassing is.`,
"label.visualpage.label.for.example":`Paginalabels zoals:`,
"label.appointmentdetail.wizard.title17":`Donderdag Plan`,
"label.projectManagement.timeFrame":`De begin- en eindtijd van de taak moeten binnen het tijdsbestek van de mijlpaal liggen.`,
"lable.product.pricebooks.list":`Prijs Boek is een product lijst met een speciale prijs en gedefinieerde valuta. Prijsboek kan worden ingesteld voor meerdere valuta. Bij het invoeren van een product in een prijsboek, kunnen de kansen of offertes alleen producten in een enkel prijsboek bevatten. Om het product in het prijsboek te bewerken, klikt u op de naam van het prijsboek.`,
"font-trade-module-v1-delete-invoice":`Factuur verifiëren`,
"vue_label_salesadvance_winamount":`Bruto bedrag van Won`,
"component.salesperformance.label.nopermission":`Neem contact op met uw systeembeheerder om gegevens over zakelijke kansen te bekijken.`,
"vue_label_report_formatreport_desc":`Exporteer het rapport met rapportkoppen, groepen en filterinstellingen.`,
"label.enable.qrcode.only":`Activeer alleen QR code`,
"label.smstemplate.edit":`SMS-sjabloon bewerken`,
"label.qrcodeSetting.detailed.information":`QR code kan meer gegevens opslaan dan bar code en lineair scannen is niet nodig. Dus QR code wordt op grote schaal toegepast, waaronder product tracking, item identificatie, documentatie beheer, en marketing, enz.`,
"label.event.moveup.1week":`1 week vooruit`,
"label.customize.memory.function.sorting.disable":`Geheugen van koptekstsortering uitschakelen`,
"label.icon.195":`Badkuip`,
"label.compact.layout.assign":`Belangrijke informatie lay-out opdracht`,
"label.icon.183":`Huis`,
"front-kefu-moudle-v1-jchxzxzi-chat":`Integreer seat online chatten van Easemob om een uitgebreidere SaaSdienst aan te bieden.`,
"label.mycontact":`Mijn Contacten`,
"label.tabularreport.2018.step3":`Stap 3 Kies rapportcriteria`,
"chatter.group.uploadGroupPicture":`Upload groepsfoto`,
"label.total.forecast.setup":`forecast at first and set to be`,
"label.weixin.group.description":`Noot`,
"label.edit_emailfooter":`Email voettekst bewerken`,
"label.ems.create":`Nieuw`,
"label.weixin.optionseven":`Keuze 7`,
"font-evaluate-module-v1-continue-work":`Uw evaluatie heeft ons aangemoedigd! Wij zullen ons blijven inspannen om het beter te doen!`,
"label.close.multilingual":`Multitaal uitschakelen`,
"component.chatter.post.button.user":`Mensen toevoegen`,
"label.use_QRcode":`Gebruik QRcode`,
"label.operatedata.exportsuc":`De export is geslaagd. Bekijk de e-mail om de download link te krijgen. Download uw geëxporteerde bestanden binnen 48 uur. Het wordt aanbevolen dat u de e-mail verwijdert die de download link bevat van uw geëxporteerde bestanden.`,
"label.page.step2.define.content":`Stap 2 Inhoud en display-eigenschappen bepalen`,
"label_tabpage_groupingitem":`Groeperingsitem`,
"label.customfields.placeholder":`Vul het monster in`,
"vue_label_commonobjects_detail_enter_subject":`Voer thema in`,
"label.multilang.workflow.everyotherdayinmonth":`{1} dagen om de {0} maanden`,
"label.knowledgebase.data.archiving.failed":`{a} dataarchief mislukt`,
"vue_label_notice_nopermission_view":`Sorry, u hebt geen toegang om dit dossier te bekijken, gelieve de beheerder te contacteren.`,
"vue_label_calendar_calendar_view":`Kalenderweergave`,
"lable.outlook.edit.des":`Als een Exchange-contact overeenkomt met meerdere CloudCC.com-contacten, synchroniseert u het met een CloudCC.com-contact dat aan de volgende criteria voldoet.`,
"label.custom.NextCQ":`Volgende CQ`,
"label.emailsync.form.stutas":`Status`,
"label.nameandintro":`Naam en beschrijving`,
"label.dashboardSetup.showdw":`Weergaveeenheid`,
"label.tianyancha.actualcapital":`Ontvangen kapitaal`,
"front-kefu-moudle-info-delete-calluser":`De informatie is gewijzigd, neem contact op met de beheerder`,
"label.emailobject.list.all":`Alle`,
"label.campaign.channel.step7.send":`Selecteer de gebruikers die e-mail willen ontvangen`,
"label.formulafield.type":`Formule Type terugkeer`,
"label.reportsSubscriptionPage.schedulereport.weekly.thursday":`Donderdag`,
"label.chosesubject.eat":`Schema Diner`,
"label.back":`Terug`,
"label.h5.allcompany":`Alle wolken berichten`,
"label.location.display.type.digital":`Digitaal`,
"label.datamanage.error.csv":`Ongeldig bestandsformaat, het systeem ondersteunt alleen het gewone CSV-formaat, probeer het opnieuw.`,
"label.emailobject.mark":`Mark`,
"setup_mainpage_label_welcome9":`Gebruikers kunnen de classificatieweergave en de aanpassing van de lay-out van alle pagina-elementen en de instelling van alleen-lezen en verplichte velden van de velden op de pagina realiseren door met de muis te slepen zonder code-ontwikkeling.`,
"label.icon.56":`Meetinstrument`,
"label.forecast.edit.fwcd":`Bereik Lengte`,
"vue_label_email_Please_select_related_items_first":`Selecteer eerst gerelateerde items`,
"label.icon.87":`Boek`,
"label.knowledgebase.recovery.was.successful":`Het herstel was succesvol`,
"label.emailobject.emaildetail.promptcontent":`Weet u zeker dat u deze e-mail wilt verwijderen?`,
"label.delete.role":`Rollen verwijderen`,
"label.multiselect":`Keuzelijst (Multi-Select)`,
"label.customerinfo.mailisnull":`Geen bedrijfs e-mail adres ingesteld.`,
"label.waitforamoment":`Pagina wordt geladen, even geduld...`,
"lable.edit.queue.tip":`Voer de naam van de wachtrij in en het e-mailadres dat moet worden gebruikt voor het verzenden van kennisgevingen (bijvoorbeeld wanneer een zaak in de wachtrij is geplaatst). Het e-mailadres kan voor een individu of een distributielijst zijn. Wanneer een zaak aan een wachtrij wordt toegewezen, zullen alleen de leden van de wachtrij hiervan op de hoogte worden gebracht.`,
"lable.custom.y.d":`Op deze pagina kunt u een aangepast jaarrecord definiëren. De datums voor het aangepaste jaar worden gegenereerd op basis van de keuzes die u hieronder maakt.`,
"chatter.feed.content.user.searchbutton":`Zoeken op`,
"label.data.downpage.i.list.desc3":`Gebruikers kunnen de reden van de mislukte import zien in de laatste kolom van het bestand na het downloaden.`,
"label.tag.manage.createdby":`Gemaakt door`,
"label.h5.similar.opportunity.last.months3":`Laatste 3 maanden`,
"chatter.group.members":`Leden`,
"label.knowledgebase.data.translation.failed":`Vertaal {a}gegevens mislukt`,
"label.log.look":`Controle-instellingen aanwijzingen`,
"label.service.gantt.week.timescale":`Tijdschaal op weekweergave:`,
"label.userLicence":`Gebruikerslicentie`,
"label.file.library.managemembers.permission":`Toegang`,
"label_emailtocloudcc_name":`Naam`,
"label.mr.mrSuccess":`Fusie voltooid`,
"vue_label_commonobject_view_notice_selectadd":`Selecteer de gegevens die u wilt toevoegen`,
"vue_label_commonobjects_detail_level":`Niveau`,
"CloudCCCRM_ST_Info_TypeIn_001":`Gelieve in te voeren`,
"label_chatter_list":`Lijst`,
"label_tabpage_optionsz":`Opties`,
"UG_homepage_008":`Inzicht in de huidige bedrijfsstatus (verkoopbriefings, leaderboards, verkooptrechters, enz.), zicht op zakelijke kansen die problematisch kunnen zijn, voorspelling van toekomstige prestaties, tijdige acceptatie en toewijzing van belangrijke kwesties, en weloverwogen beslissingen.`,
"label.myselfdashboard":`Mijn persoonlijke dashboards`,
"label.globaloperation.operationtype.record_phone":`Telefoon opnemen`,
"label.field.standard":`Standaard velden`,
"label.changemydisplay.appedit.check":`Persoonlijke aangepaste instellingen van aangepaste apps overschrijven`,
"label.tianyancha.h5.legalpersonnames":`Wettelijk vertegenwoordiger`,
"label.tabpage.sorttypez":`Soort sorteren`,
"label.newdashboard.folder":`Nieuwe Dashboard Map`,
"label.campaign.channel.step6":`Stap 6: Genereer de registratiepagina van het marketingkanaal`,
"label.ems.composeemail":`Stuur e-mail`,
"label.app.step4.tabcanuse":`Beschikbare tabbladen`,
"label.sendmail.batch":`Massa e-mail`,
"label.process.execute.title":`In afwachting van`,
"lable.outlook.detail.lastup":`Laatst bijgewerkt`,
"label_emailtocloudcc_delete":`Delete`,
"lable.opppdt.selPdt.leastone":`Selecteer ten minste één rij`,
"label.customfields.new.step2.opration.exid":`Externe ID`,
"label.assignment.setup.newrule.description":`Voer de regelnaam in en schakel vervolgens het selectievakje Ingeschakeld in om deze regel voor automatische toewijzing te gebruiken. Het inschakelen van deze regel zal de huidige toewijzingsregel uitschakelen.`,
"label.campaign.channel.input.to.isactivity":`7. Actief het afzetkanaal`,
"label.document.return":`Terug naar Documenten`,
"label.data.downpage.i_title.num5":`5. Controleer de juistheid van de gegevens.`,
"label.taskinto":`Taken zijn de sjablonen die workflow regels gebruiken bij het automatisch toewijzen van taken aan gebruikers.`,
"label.customfields.formula.textexample":`Volledige naam = Achternaam`,
"label.appointmentpage.wizard.subtitle1-1":`Volgende week`,
"label.weixin.radio":`Single-Select`,
"vue_label_file_replace_reason_check":`Reden voor vervanging (facultatief)`,
"label.sendemail.recycle.operateexception":`Leeg uw prullenbak is mislukt, probeer het opnieuw.`,
"label.vlidaterule.formulaerror":`Geef een fout weer als de korting meer dan 30% bedraagt`,
"vue_label_campaign_existing_member_status":`Status van bestaand lid behouden`,
"label.service.miniProgram.fillSlideshowName":`Gelieve de naam van de carrousel in te vullen.`,
"label_partner_workspace_login_headerfooter":`Koptekst en voettekst`,
"label.quickbooks.viewlist.total2":`Er zijn {0} schattingen voor een totale waarde van {1}`,
"chatter.viewingResults":`Zie Resultaten`,
"label_tabpage_allvisible":`Alle gebruikers zijn zichtbaar`,
"label.quote":`Citaten`,
"label.changemydisplay.list.des":`Pas de tabbladen aan uw behoeften aan`,
"label.leadscore.notimes":`Geen tijd meer om leads te scoren`,
"label.icon.51":`Stroomopwekking`,
"component.assistant.label.title":`Assistent`,
"label.emailobject.emailsent":`Verzonden e-mail！`,
"label.group.nofile":`Er zijn geen dossiers naar deze groep gestuurd.`,
"label.foldervisitlimit2":`Alle gebruikers hebben geen toegang tot deze map`,
"label.dataoperate":`Gegevensverwerking`,
"label.addattachment.size":`Maat`,
"label.not.double":`Dubbele waarden zijn niet toegestaan.`,
"label.customfields.formula.number.tip":`Bereken een numerieke waarde.`,
"lable.opppdt.addpdt.table.description":`Lijn Beschrijving`,
"label.sms.isactivity":`Actief`,
"label.campaign.channel.input.owner":`4. Wie wordt de eigenaar van de leiding van dit kanaal?`,
"label.visualpage.notfound.error":`Er is een onbekende fout opgetreden, neem contact op met de beheerder.`,
"label.mr.title.button.group3":`records`,
"label_tabpage_beginz":`Begin`,
"label_tabpage_queue":`Wachtrij`,
"label.tabpage.advancedscreening":`Geavanceerd filter`,
"nogreate":`minder of gelijk`,
"chatter.fields":`Velden in`,
"button_partner_workspace_manage":`Beheer`,
"label.partnerCloud.orderingPlatform.search":`Producten zoeken`,
"message.password.isnull":`Voer uw wachtwoord in.`,
"label.fenbeitong.title":`FenBeiTong Instelling`,
"label.salescloud.contactrole.message.chooseatleastone":`Kies tenminste een contactpersoon.`,
"label.knowledge.delete.election":`Fout bij het verwijderen van gegevenscategorie selectie`,
"front-console-status-hoided":`Lay Up`,
"label.lastmodifydate":`Laatst Gewijzigde Datum`,
"vue_label_chat_deleting_chat":`Na het verwijderen, wordt de chatgeschiedenis gewist en verwijderd uit de Teamlijst. Bij ontvangst van een nieuw bericht, zal het weer verschijnen in de Team lijst.`,
"label.timeframe":`Tijdsbestek`,
"UG.opportunity.002":`Definieer uw verkoopcyclus, configureer fase`,
"label.templates.merge":`Selecteer de sjablonen die moeten worden samengevoegd. Er kunnen er maximaal 20 worden geselecteerd.`,
"label.generatepage.c2":`Maximale lengte is 30.`,
"label.appointment.wizard.subtitle4-1-6":`2 h`,
"label.passwordPolicy.setup.pwdremember3":`3 wachtwoorden onthouden`,
"button.partner.workspace.enable":`Schakel partner cloud in`,
"vue_label_pool_nopool_notice":`U bent nog niet aangesloten bij een pool, neem contact op met de beheerder om een pool aan te maken of u bij een pool aan te sluiten.`,
"label.layout.required.field.select":`Geselecteerde verplichte velden`,
"label.loginhis.date":`Typ de begin- en einddatum.`,
"vue_label_commonobjects_detail_and_overdue":`Komend en te laat`,
"label_tabpage_advancedsearch":`Geavanceerd zoeken`,
"label.custom.field.login.home.query":`Ga naar de homepage en bekijk de details van de taak.`,
"page":`Pagina`,
"label_tabpage_onlymevisible":`Het is alleen zichtbaar voor mij`,
"label.weixin.optionfour":`Keuze 4`,
"label.confirm.to.remove":`Bevestig te verwijderen`,
"label.event.moveup.30minutes":`30 minuten vooruit`,
"label.mail.merge.template.finish":`Samenvoegen e-mail sjablonen voltooid`,
"label.multilang.currencylist.before":`Voor {0}`,
"label.goback":`om naar de vorige te gaan`,
"label.unknown.prefix":`Ongeldige prefix, gelieve opnieuw in te voeren.`,
"lable.account.CurrentandPreviousCYt":`Huidige en vorige 2 CY`,
"label.product.dent":`Klik op Meer filters om meer dan één filter te gebruiken. De zoekresultaten omvatten alle records die zowel met uw trefwoord als met uw filter overeenstemmen.`,
"label.ems.bcc":`Bcc`,
"label.import.index.operation":`Operatie`,
"label.knowledge.setting.hint.eight":`Hou alles perfect in orde!`,
"label.sso.saml.sp.idtype.fid":`Assertie bevat de Federatie ID van Gebruiker object`,
"vue_label_chat_voice":`Stem`,
"label.config.pw":`Bevestig nieuw wachtwoord`,
"lable.newtabpage.closesearchresult":`Samenvouwen Zoekresultaten`,
"lable.account.NextWeek":`Volgende week`,
"label.ems.username":`Gebruikersnaam (u)`,
"vue_label_email_emails_from_potential":`E-mails van leads en contactpersonen in uw CRM, en e-mails met hen in ontvangers, worden hier gecategoriseerd`,
"lable.approval.shared":`Goedkeuringsaandeel`,
"label.tabpage.allz":`Alle`,
"label.file.uploadfiles":`Bestanden uploaden`,
"label.emailobject.text":`Tekst:`,
"label.version.allow.create":`Sta het maken van nieuwe`,
"label.empty.field":`Het veld kan niet leeg zijn.`,
"label.emailsync.status.department":`Afdeling`,
"label.pw.str":`5 tekens`,
"label.attendance":`Deelnames`,
"label_mobile_buttom_team":`Team`,
"label.campaignmember.main.addcontactdesc":`Voeg alle bestaande contacten toe aan deze campagne`,
"label.search.result":`Zoekresultaten`,
"label.weixin.activity.account":`Activiteit gasten`,
"label_tabpage_clearoptionsz":`Wis geavanceerde opties`,
"UG.activity.01":`Hoe houdt u uw gegevens bij om te communiceren met uw rekeningen/teams?`,
"serviceappointment.new.status.limit":`Het is niet gelukt om een nieuwe serviceafspraak te maken met de status gepland of verzonden.`,
"label.notice.higher":`Stuur e-mail naar manager`,
"label.passwordPolicy.setup.gletters":`personage(s)`,
"label.data.exportsf.des":`Succesvol geëxporteerde bestanden worden automatisch gewist nadat ze 48 uur op de derver zijn opgeslagen.`,
"label.view.onlymecansee":`Alleen zichtbaar voor<b>mij</b>`,
"UG.Lead.005":`Brievenbus`,
"label.umeng.approval.approvalfail":`ingediend faild.`,
"label.huanxinconfig.clientid.lost":`clientid kan niet leeg zijn`,
"label.campaignmember.main.updatecontactstatus":`Status bijwerken - bestaande contacten`,
"component_chatter_button_delete":`Delete`,
"label.weixin.no.pending.projects.qin":`Geen punten om goed te keuren.`,
"front-electronic-signature-auto-fill-field":`Automatisch aanvullen veld`,
"message.resetpw":`Weet u zeker dat u uw wachtwoord opnieuw wilt instellen?`,
"label.service.ganttBaiduMap.service.resourname":`Naam van de dienst Middelen`,
"vue_label_pricebook_deleted":`Prijslijst geschrapt`,
"label.icon.193":`Badkuip`,
"label.validate.function.funcFormat.NOT":`NIET(logisch)`,
"label.address.city":`Stad`,
"label.pc.ui.2018.searchs":`ZOEK...`,
"label.yard":`Uitnodigingscode`,
"label.data.downpage.i_title.btn":`Ga naar de import pagina en begin met importeren`,
"label.useablereceivers":`Beschikbare ontvangers`,
"label.cloudccsite.name.length":`Hiermee kunnen gebruikers tot 255 tekens invoeren`,
"label.secrecy":`Vertrouwelijk`,
"label.campagin.roi.ydkhywjhzz":`Totaal aantal gesloten kansen`,
"vue_label_report_conditiondesc_one":`Behalve de inschrijving, kunt u voorwaarden stellen voor dit rapport. U krijgt een melding als aan alle voorwaarden is voldaan. Dit is optioneel`,
"label.datamanage.select.contactfield":`(Selecteer het veld dat overeenkomt met het importcontact)`,
"label.emailtocloudcc.filed.action":`Actie`,
"label.smstemplate.new":`Nieuw SMS sjabloon`,
"label.mobile.side.tab.app":`Apps`,
"label.icon.118":`Klok`,
"label.customfields.selectcontainfieldlayout.tip":`Het veld zal worden toegevoegd als het laatste veld in de eerste 2-koloms sectie van deze pagina-indelingen. Het veld verschijnt op geen enkele pagina als u geen opmaak selecteert. Om de plaats van dit veld op de pagina te wijzigen, moet u de opmaak van de pagina aanpassen.`,
"Lead_Homepage_Tools_BatchScoring":`Partij score`,
"lable.quote.syncing.quote":`Citaten`,
"pagecreator.button.preview":`Voorbeeld`,
"label.ccchat.am":`AM`,
"chatter.feed.menutype.user.nullrecent":`Geen recente gegevens`,
"lable.info.queue.showallmember":`Wachtrij leden bekijken`,
"label.multilang.campaign.selelctmember.desc":`Selecteer een view en selecteer het lid dat u aan de campagne wilt toevoegen. De status van het lid is {0}`,
"label.notification.ccchat3":`【评论用户名】 heeft op je bericht gereageerd.`,
"UG.product.03":`Multi-valuta ondersteunde prijs handleiding`,
"label.sso.saml.idp.config.pksize":`Sleutelgrootte`,
"label.defineCustomReportType":`Definieer de gegevensbron van het aangepaste rapport`,
"component.timeline.button.filter":`Filter`,
"label.mr.nextGroup":`Sla de groep over en ga naar de volgende groep`,
"label.quote.sprdz":`Factuuradres`,
"label.total.refuse.forecast.have.priority":`Weigeren Alle Voorspellingen Prioriteit`,
"lable.product.peep":`Voer een geldige prijs in.`,
"label.file.who.can.access":`Wie kan toegang krijgen`,
"label.page.last":`Laatste Pagina`,
"label.icon.180":`Mensen`,
"font-evaluate-module-v1-enabled-successfully":`Met succes ingeschakeld evaluatie optie "Neural"`,
"label.appointment.wizard.subtitle4-2-2":`2 h`,
"label.passwordPolicy.setup.oneyear":`Een jaar`,
"label.login.bound.mfadevice.title":`Virtuele MFA-apparaten inschakelen`,
"vue_label_dashboard_statisticalvalue":`Selecteer een statistische waarde`,
"label.ishistory":`Geschiedenis`,
"component.timeline.label.title":`Tijdlijn`,
"label.page.step3.of.step5":`Stap 3 van 5`,
"label.assignment.setup.detail.section":`Regel Detail`,
"label.salescloud.opportunity.nothave.main.contactrole":`Geen belangrijke contacten`,
"label.import.page1.limitedcsv":`ALLEEN CSV-formaat voor het uploaden van bestanden`,
"label.icon.187":`Hamer`,
"label.emailobject.wizard.desc5":`Pas uw handtekening aan om uw post er beter uit te laten zien.`,
"vue_label_report_notice_copy_success":`Kopieer het rapport met succes!`,
"label.dupicatecheck.repeatcondition.chooserulemsg":`U hebt niet gekozen voor de regel van dubbele controle.`,
"label.componentEditor.upper.limit":`Tot 100`,
"label.validate.function.funcExplain.ISNEW":`Controleert of het record nieuw is, en geeft WAAR terug als het nieuw is, anders geeft het ONWAAR terug`,
"label.postalCode":`Postcode`,
"label.dashboard.snapshot.enable.flag":`Dashboard snapshots inschakelen`,
"vue_label_file_upload_type_size":`Alleen {fileType} bestanden kunnen worden geupload, en niet meer dan {size}Mb`,
"label.appointment.wizard.subtitle3-6":`Zaterdag`,
"homepage.narrow":`Smalle (Linker) Kolom`,
"chatter.addmute.confirm":`Weet je zeker dat je deze post "niet storen" wilt houden?`,
"label.lookup.account":`Zoek Accounts`,
"message.lostthemanager":`Deze indiening vereist de goedkeuring van de manager van de gebruiker, en de waarde van de manager van de gebruiker is nihil. Neem contact op met uw beheerder voor meer informatie.`,
"label.exchange.sync.state.contact.m3":`Records gesynchroniseerd in de laatste 24 uur:`,
"label.version.phone.app":`Mobiele app`,
"label_tabpage_search":`Zoeken op`,
"vue_label_helpcenter_campaign":`Klik in de gedetailleerde informatie op de knop met het boomdiagram naast de campagne om het hiërarchische structuurdiagram van de campagne te bekijken en de Ouder-Kind hiërarchie van de campagne te begrijpen.<br>Beheer de contacten of leads die betrokken zijn bij de campagne via de gerelateerde lijst van campagneleden.`,
"front-lightning-module-v1-dashborad-last-year":`Vorig jaar`,
"label.campaign.channel.value":`Waarden`,
"vue_label_opportunity_contactrole_primarycontact_notice":`Om uw primaire contactpersoon te selecteren, slaat u deze stap op en kiest u uit Beheer`,
"label.biaoqingfaxian.title":`Biedings- en offerteaanvraag`,
"label.approved":`Goedgekeurd`,
"label.hong.kong.time":`Hong Kong Time`,
"label.customfields.file.cannotopen":`Kan het bestand niet openen`,
"lable.New.tips":`Klik op "Nieuw" om een nieuw service rapport sjabloon aan te maken op basis van een standaard sjabloon of een gekozen sjabloon. Activeer het sjabloon en begin het te gebruiken.`,
"component.setup.tabs.label.add":`Toegevoegd:`,
"label.forecast.forehistory.replacebest":`Best Case Overridden`,
"front-kefu-moudle-v1-jctrrt-call-serve":`Call Center geïntegreerd met TRRT om meer omvattende SaaSdiensten aan te bieden`,
"label.workflow.configrule":`Stap 2 Configureer Workflow Regel`,
"label.dashboard.snapshot.refresh.frequently":`Dashboard snapshots worden te vaak ververst, probeer het later nog eens`,
"label.ems.editsetting":`E-mail instelling bewerken`,
"message.confirmdeleteAPP":`Weet u zeker dat u deze app wilt verwijderen?`,
"label_chatter_activity":`Activiteiten`,
"label.editsharerules":`Regels delen Bewerken`,
"label.loginservice.license.notuse.must":`De licentie is momenteel niet beschikbaar, u moet`,
"label.import.step2.beforeexport":`1、Voordat u gaat importeren, zorg er dan voor dat u alle gerelateerde records importeert. Bijvoorbeeld, als u contact records importeert en u wilt het account veld invullen, wat een lookup veld is, dan moet u eerst het account record aanmaken dat u wilt invullen, dan het contact record importeren en het account veld invullen met naam of ID van de corresponderende account.`,
"label.chat.mute":`Niet storen`,
"label.icon.128":`Huis`,
"label.give":`En En`,
"label.hide":`Niet tonen`,
"label.relationobject.wpr":`Gedelegeerd goedkeurder`,
"label.summation":`Som`,
"label.layout.availabletab.details":`Details`,
"label.circle":`Donut Grafiek`,
"vue_label_opportunity_contactrole_add":`Contactrollen toevoegen`,
"label.file.library.file2libsuccess":`Succesvol toegevoegd!`,
"label.weixin.report.reportgenerated":`Gegenereerd verslag`,
"label.icon.91":`Mensen`,
"report.label.pleaseinput":`Voer in waarnaar u wilt zoeken`,
"label.escalation.setup.newaction.otheremail.tip":`U kunt maximaal vijf (5) e-mailadressen opgeven om op de hoogte te worden gebracht. Elk e-mailadres wordt gescheiden door ",".`,
"label.area.donot.have.data":`Geen gegevens`,
"label.customcomponent.btn.reference":`Component Referentie`,
"label.appointmentdetail.wizard.title7":`Herinneringstijd`,
"label.ccchat.with":`Heb`,
"label.file.size":`Maat`,
"label.product.sort.beyond":`Er kunnen maximaal 10 niveaus worden ingesteld !`,
"label.ccchat.2018":`CCChat`,
"label.report.select.column":`Selecteer de kolommen`,
"label.appointmentpage.wizard.subtitle1_1":`Kies datum en tijd`,
"label.passwordPolicy.setup.uppercasealpandnumsymbol":`Moet cijfers, hoofdletters, kleine letters en speciale tekens combineren`,
"label_chatter_addressee":`Ontvanger`,
"label.profile.remark2":`Als uw organisatie gebruik maakt van recordtypes, gebruik dan de Edit links in de Record Type Settings sectie hieronder om één of meer recordtypes beschikbaar te maken voor gebruikers met dit profiel.`,
"UG_Account_01":`Wie is je account?`,
"label.dataimport.error.contact.notnull":`Fout: contactnaam kan niet null zijn.`,
"lable.account.CalenderQuarter":`Kalender kwartaal`,
"vue_label_commonobjects_detail_empty":`Verkoopprijs kan niet leeg zijn`,
"label.approveassigntemplate":`Goedgekeurd om Email sjablonen toe te wijzen.`,
"label.objectRelationshipDescription1":`Deze rapportgegevensbron zal rapporten genereren over`,
"vue_label_email_insertmergefield":`Samenvoegveld invoegen`,
"label.mobile.home.page.check.team":`Team`,
"lable.edit.queue.edit":`Wachtrij bewerken`,
"label.campagin.roi.query":`Campagne ROI bekijken`,
"label.dataimport.field.allow.access.to":`De gegevensvelden zijn niet toegankelijk, gelieve het overeenkomstige record manueel te verwijderen en opnieuw te proberen.`,
"pagecreator.systemstyle.message.canntdelete":`De huidige stijl is niet toegestaan om te verwijderen`,
"label.searchkey":`Voer trefwoorden in`,
"chatter.showall":`Toon alle`,
"show":`Toon`,
"label.quote.choseproduct":`Kies product`,
"label.report.selected.field":`Geselecteerde Velden`,
"label.globaloperation.operationtype.create_data":`Record aanmaken`,
"label.knowledge.setting.data.seven":`Verwijder Categorie Groep: {flzmc}`,
"chatter.email.mentionOrMessage":`Vermeldingen of berichten`,
"label_tabpage_exclusivez":`Exclusief`,
"chatter.en.userinfo":`Voer de informatie over u in.`,
"label.log.orgid":`Organisatie`,
"label.dataimport.insertdata.error.fieldrepeat.update":`Het veld $schemefield_name$ in de record kan niet in de database worden gevonden en kan niet worden bijgewerkt. De record heeft import genegeerd.`,
"vue_label_chatter_add_link_success":`Link succesvol toegevoegd`,
"label.sender_details":`Om nieuwe afzendergegevens toe te voegen, maakt u een gebruiker aan in uw`,
"label.ccpeak.addwhere.condition":`Een "waar" criterium kan worden toegevoegd`,
"label.datamove.total":`Totaal`,
"label.tianyancha.businessverify.warning":`Houd er rekening mee dat deze verificatie alleen de zakelijke gegevens geregistreerd in China vasteland ondersteunen.`,
"label.emailmainbody":`E-mail Lichaam`,
"label.justadmin":`Alleen beheerders`,
"label.data.downpage.e.list.desc1":`Deze pagina toont succesvol geëxporteerde bestanden. Download de geëxporteerde bestanden op tijd volgens de download link in uw e-mail.`,
"label.reportsSubscriptionPage.email.value":`Bestaande Waarden`,
"message.error.serviceappointment":`Vul de geplande starttijd en de geplande eindtijd in op de service afspraak.`,
"label.textMessageObject.selectone":`Selecteer ten minste één record als de ontvanger van het tekstbericht`,
"label.schedulejob.setup.schedule.plan":`Schema`,
"label.assignment.layout.field.isassigned":`Toewijzen volgens de actieve toewijzingsregels.`,
"label.captcha.error":`Verificatiefout!`,
"mobel_web_not_more_data":`Geen gegevens meer.`,
"label.emailsync.form.emailaddress":`Email Adres`,
"label.loginservice.error":`Inlogfout, neem contact op met de beheerder.`,
"label.integrations.description":`Verbind uw CloudCC account met andere apps`,
"vue_label_homepage_notice_selectone":`Selecteer ten minste één lead of contact`,
"label.chatter.default":`Standaard`,
"label.tabpage.datefield":`Wanneer het datumveld gelijk is, kan het "gisteren", "vandaag", "morgen", "vorige maand", "deze maand", "volgende maand", "vorige week", "deze week", "volgende week" of "JJJJ-MM-DD、MM/DD/JJJJ" formaat gebruiken.`,
"front-kefu-moudle-myzdhsc-file":`Opname bestand niet gevonden of niet gegenereerd`,
"label.createname":`Schepper`,
"label.mobile.phone.enter.plan":`Voer uw plan in`,
"report.label.highlevelreport":`Met geavanceerde rapporten kunt u relaties leggen tussen maximaal 4 objecten.`,
"label.edit.select.label":`Modus bewerken`,
"label.partnerCloud.financeSetting.deduction":`Na activering zullen de funs worden toegevoegd aan kortingsrekening, kortingsinkomen en kortingsuitgavenobject. Partnergebruikers kunnen de kortingrekening gebruiken om het te betalen bedrag af te trekken.`,
"message.duplication.label.updateoption":`Actie inzake bijwerking`,
"label.custom.CurrentCQ":`Huidige CQ`,
"front-kefu-moudle-wait":`Waiting`,
"sunday":`Zondag`,
"label.service.timezone":`Tijdzone`,
"setup.layout.label.selectfield":`Selecteer velden`,
"label_emailtocloudcc_filed_action":`Actie`,
"label.forecast.customforecast.mycommit":`Mijn toezegging`,
"label.uploadsuc":`Upload Succesvol`,
"vue_label_commonobjects_view_notice_atleast1field":`Selecteer ten minste 1 weergaveveld`,
"label.dataimport.khmc.length":`Fout: de lengte van de rekening is te lang.`,
"label.isemailnotification":`Verzend notificatie e-mail`,
"label.addAPPexchange":`Apps toevoegen vanuit CloudCC App Store`,
"label.partnerCloud.orderingPlatform.currency":`Valuta:`,
"UG_quota_02":`Veranderingskans-fase`,
"label.customer.tab.step2.same.option3":`Tab Verborgen`,
"H":`Telefoon`,
"label_tabpage_searchz":`Zoeken op`,
"vue_label_homepage_deleted":`Verwijderd`,
"label.weixin.recent.view":`Onlangs bekeken standpunten`,
"template.report.opportunity.sales":`Verkoopvolume van Opportunities`,
"label.customfields.new.step2.opration.unique.info.v1":`Behandel "ABC" en "abc" als dubbele waarden (hoofdlettergevoelig)`,
"savesuccess":`Succesvol opgeslagen`,
"label.partner.workspace.member.memo":`Alle gebruikers met een geselecteerd profiel en toestemming hebben toegang tot deze partner cloud.`,
"label.icon.23":`Drug`,
"lable.batchadd.service.cfq.before":`Triggers (vóór het invoegen)`,
"label.instrumentPanel.breakpointTwoLabelname":`Deze waarde moet groter zijn dan de minimumwaarde en de breekpunt 1-waarde.`,
"message.selectgsummaryinformation":`Selecteer de gegevens die u wilt samenvatten`,
"label.tianyancha.businessverify.msg6":`Deze functie maakt gebruik van diensten van derden en kan onstabiele prestaties of onmogelijke service hebben als gevolg van hoog gelijktijdig gebruik. CloudCC is niet verantwoordelijk voor enige aansprakelijkheid.`,
"vue_label_helpcenter_report3":`3.A. Klik op het veld zoekvak, selecteer het veld dat u wilt door ernaar te zoeken of door in de lijst met velden naar beneden te scrollen, selecteer de operator van het veld, voer een waarde in of selecteer een waarde, klik op Toepassen en het veldfilter treedt in werking. <br> B. Klik op het " " teken boven het veld zoekvak en voer een geavanceerde filterconditie in, bestaande uit cijfers en letters in het "Filterconditie invoerveld". Bijvoorbeeld, (1 en 2) of3.<br>? Filters bewerken<br> Om de filters te bewerken, neemt u de standaard filters op, en klikt u op de filters. <br>? Filters verwijderen<br> Klik op het "x" icoon op een filter om deze te verwijderen. <br>? Het rapport uitvoeren<br> Klik op de Uitvoeren knop in de rechterbovenhoek van de bewerkingspagina om de volledige rapportresultaten te zien. <br>? Sla het rapport op<br> Klik op de knop "Opslaan" in de rechterbovenhoek van de bewerkingspagina, vul de naam van het rapport in, selecteer de rapportmap en sla het op. <br>2. Maken van een rapportmap<br> Voordat u een rapportmap maakt, genereert het systeem standaard Mijn aangepaste rapportmap en Ongearchiveerde openbare rapportmap. <br> Stap 1: Klik in de Rapporten tab op Nieuwe rapportmap<br> Stap 2: In de Nieuwe rapportmap pop-up, kunt u kiezen om rapporten uit de Ongearchiveerde openbare rapportmap over te brengen naar deze map. U kunt selecteren welke gebruikers toegang hebben tot deze map en welke toegangsrechten ze hebben. <br>3. Rapporten bekijken<br> Stap 1: Ga vanuit de Rapporten tab naar de Rapporten lijst pagina en zoek het rapport dat u wilt bekijken door te klikken op "Onlangs bekeken", "Ik heb gemaakt", "Alle rapporten", of de Rapporten map. of Rapporten map om het rapport te vinden dat u wilt bekijken. <br> Stap 2: Klik op de rapportnaam om het rapport te bekijken. Of klik op de drop-down knop uiterst rechts van het rapport en selecteer Uitvoeren om het rapport te bekijken. <br>Als u een beheerderprofiel hebt, ga dan vanuit de Rapporten tab naar de Rapportenlijst pagina en klik op het tandwiel icoon naast de Nieuwe Map knop om de velden te selecteren die getoond moeten worden in de tabelkop van de rapportenlijst in elke map. <br>4. Rapporten exporteren<br> Stap 1: Ga vanuit de Rapporten tab naar de Rapportenlijst pagina, zoek het rapport dat u wilt exporteren, en klik op de drop-down knop uiterst rechts van het rapport. <br> Stap 2: Selecteer het type<br> Rapport opmaken: bevat rapportkoppen, groepering, filtering details. <br> Alleen detail rapport: Niet opgemaakte detail rijen. <br> Stap 3: Klik op Exporteren. De detailrapportage moet worden geëxporteerd in pagina's, met een maximum van 2000 gegevens per pagina.  `,
"label.batchdelete.success":`Massale verwijdering succesvol`,
"label.newprocess5.seq":`Bestel`,
"label.knowledgebase.data.translated.successfully":`Vertaal {a}data succesvol`,
"label_enable_range":`Activeer bereik`,
"label.ccchat.and":`En`,
"label.assignment.setup.list.norule":`Geen regels gespecificeerd.`,
"vue_label_report_summaryformulacolumn":`Overzicht formule kolom`,
"label.field.edit.change1":`De maximumscore mag niet hoger zijn dan 100`,
"syntaxerror":`Syntaxfout, controleer de criteria die u invoerde.`,
"label.icon.116":`Huis`,
"lable.asset.BOM.according.to.product":`Genereer asset BOM volgens productstructuur`,
"chatter.like.post":`mensen vonden dit bericht leuk`,
"label.trigger.page":`Trigger pagina's`,
"vue_label_email_contact_adminstrator":`Het systeem is abnormaal, neem contact op met de beheerder.`,
"label.workreport":`Werk aantekeningen`,
"vue_label_homepage_edit_card_view":`Kaartweergave bewerken`,
"label_emailsync_status_disabel":`Inactief`,
"label.icon.54":`Graafmachine`,
"message.error.view.validerr.common":`Verificatie mislukt.`,
"label.exchange.sync.account.username":`Gebruikersnaam dienstaccount (Domeinnaam of UPN):`,
"label.dataimport.error.date":`Fout: Datum`,
"label.orgname":`Organisatie`,
"label.weixin.group.owner":`Eigenaar`,
"vue_label_dashboard_colorrange":`Kleurbereik`,
"label.forecast.shrepage.tableth":`Voorspelling Toegang`,
"label.related.disabled":`Verwante lijsten zijn niet ingeschakeld, neem contact op met de systeembeheerder om verwante lijsten in de pagina-indelingen in te schakelen.`,
"label.version.product.management":`Beheer van producten`,
"label.knowledge.new.article.published":`Het artikel wordt gepubliceerd als een nieuw artikel.`,
"label.sendsms.batch.step4":`Stap 4 Uw SMS is ingediend.`,
"vue_label_commonobjects_detail_and_tasks":`Gefeliciteerd, alle gebeurtenissen en taken zijn verwerkt`,
"label.salescloud.ci":`tijd(en)`,
"label.ccpeak.getapi.name.time":`Als u de methoden in de CCService klasse wilt gebruiken, moet u deze instantiëren.`,
"label.escalation.setup.detail.conditon":`Criteria`,
"label.lbs.isUseLbs":`Locatiediensten inschakelen`,
"front-lightning-module-v1-dashborad-color-depth":`Kleurdiepte`,
"date":`Datum`,
"label.select.personnel":`Selecteer Personeel`,
"label.appointmentpage.wizard.notif3":`Email is verplicht!`,
"label.import.page1.pleaseselectwayofdealdata":`Selecteer de verwerkingsmodus`,
"label.partner.all.memo":`Lijst toont alle partner clouds in uw organisatie. Klik op url om in te loggen.`,
"label.appointment.wizard.subtitle4-3-3":`30 min.`,
"component_telerecord_label_subject":`Onderwerp`,
"label.sendsms.batch.finish":`Mass SMS: Voltooid`,
"label.login.access.myusername":`Mijn gebruikersnaam`,
"label.weixin.wechatnumber":`WeChat ID`,
"label.eowechat.status":`Gebruikersstatus`,
"Lead_Scoring_Setting_Rule_Setup_Value":`Score`,
"label.appexchange.oldreport.noupload":`Oude rapporten - niet uploaden`,
"label.approverfieldediting":`Approver Veld en Records Bewerkbaarheid`,
"label_tabpage_customernamez":`Naam klant`,
"vue_label_dashboard_linkagesettings":`Koppeling Instelling`,
"vue_label_ccchart_notice_deletecomment":`Weet je zeker dat je deze opmerking wilt verwijderen?`,
"label.allprofile":`Alle Profielen`,
"label.campaignmember.main.addMember":`Leden toevoegen - Zoeken`,
"label.projectManagement.subtask.list":`Sub-taak Lijst`,
"label.code.some.size":`Codecapaciteit: maximaal 200KB tekens, ongeveer 20.0000 bytes.`,
"front-custom-service":`Service Cloud biedt klanten efficiënte en flexibele diensten op maat, verkort de oplostijd voor diensten en verhoogt de oplostarieven met het intelligente werkordersysteem, verbetert de klantloyaliteit en verhoogt de heraankoopcijfers.`,
"label.SMS.det":`SMS Notificatie Details`,
"setup_layout_label_nobutton":`Geen beschikbare knoppen`,
"vue_label_email_Could_not_save_template":`Kon sjabloon niet opslaan`,
"label.imgfield.height":`Hoogte`,
"label.leadscore":`Lead scoring`,
"setup_object_field_dependency_label_removefromlist":`Verwijder geselecteerde waarden`,
"message.error.code.null":`Autorisatie code kan niet null zijn!`,
"label.tianyancha.businessscope":`Bedrijfsomvang`,
"vue_label_chat_empty_message":`Leeg bericht`,
"label.total":`Totaal`,
"label.delerror.list":`Lijst van niet verwijderde bestanden`,
"label.selectedreceivers":`Geselecteerde ontvangers`,
"label.layout.availablepages":`Beschikbare pagina's`,
"label.pc.ui.2018.personalinfo":`Persoonlijke informatie`,
"label.chat.topic.edit.detial":`Details bewerken`,
"label.mr.descreption.reDataList1":`In de query om te voldoen aan de voorwaarden van een totaal van`,
"label.document.value.too.long":`Dit bestand is meer dan 5M groot!`,
"lable.opppdt.addpdt.table.listprice":`Lijst Prijs`,
"label.selectoperate":`Selecteer de actie`,
"label.icon.5":`Valuta`,
"label.icon.126":`Ziekenhuisbed`,
"label.hiddensearch":`Verborgen zoeken`,
"label.view.sortview.exportble":`Exporteerbaar`,
"vue_label_homepage_noassignee":`Geen cessionaris`,
"label.knowledgebase.close.and.resolve":`Gesloten en opgelost`,
"label.licence.used":`Gebruikte licenties`,
"label.newprocessstep5":`Stap 5 Selecteer de velden die op de goedkeuringspagina moeten worden weergegeven`,
"vue_label_appstore_all_applications":`Alle toepassingen`,
"label.no.edit.permission":`Kan niet selecteren. Geen toestemming om de geselecteerde records te bewerken.`,
"vue_label_calendar_calendar_added_successfully":`Kalender succesvol toegevoegd`,
"report_line":`Gegevensveld`,
"component.chatter.link.label.name":`Link naam`,
"label.data.expnode.e_desc1":`1. Aangepaste export: gebruikers kunnen velden selecteren om te exporteren en filtervoorwaarden instellen naargelang hun behoeften.`,
"label.tabularreport.step4":`Stap 4 Kies rapportcriteria`,
"Opportunity.Detailed.Phase.Change.Text.001":`Change Opportunity Stadium`,
"label.quickbooks.searchresault.action":`Actie`,
"component_timeline_label_today":`Vandaag`,
"label.callboard.remark":`Voer hieronder uw bedrijfsmededeling in.`,
"label.campagin.field.choose":`Selecteer de velden die u wilt opnemen in de registratiepagina voor campagneleden`,
"front-gantt-module-rolling-temporary-tasks":`Rollen naar tijdelijke taak`,
"label.file.des":`Beschrijving`,
"Dashboard_View_RecentlyView":`Onlangs bekeken`,
"UG_Account_04":`Passieve query account filtering`,
"chatter.refresh":`Vernieuwen`,
"label.tianyancha.companyorgtype":`Type bedrijf`,
"label.chatter.dateRange":`Datumbereik`,
"label.campagin.step3":`Stap 3: Pagina's genereren`,
"label.appointmentdetail.wizard.title14":`Maandag Plan`,
"setup.object.field.dependency.button.setdependency":`Veld Afhankelijkheid Instellingen`,
"serviceterritorymember.serviceterritory.isactive.notactive":`Dit servicegebied is niet ingeschakeld. U kunt alleen leden toevoegen onder een ingeschakeld servicegebied.`,
"template.chart.ygydyj":`Werknemer Win Order Prestaties`,
"label.tag.edittags":`Tags bewerken`,
"label.clone":`Kloon`,
"front-electronic-signature-setting-intro1":`Voordat u uw account bindt, is het aanbevolen dat u zich eerst registreert en verifieert op het DocuSignplatform.`,
"label_reach":`Prestaties`,
"label.tabpage.havez":`Bijgevoegd`,
"label.email.clearCase":`Alleen lege e-mailberichten die niet aan zaken zijn gekoppeld`,
"label.customer.tab.all":`Alle Tabbladen`,
"label.direct.dashboard.day.report":`Nieuwe dagelijkse werkbrief`,
"label_tabpage_exportview":`Weergave exporteren`,
"label.passwordPolicy.setup.maxFailTimes":`Maximum aantal ongeldige aanmeldingspogingen`,
"label.processsetting.complete.enable":`Voltooien en activeren`,
"label.marketsea.memberfield":`Velden kunnen door leden worden gekocht`,
"label.report.export.format.title":`Formaat Rapporten`,
"label.recycle.execute.title":`De prullenbak leegmaken.`,
"label.file.use.most.user":`Gebruikers met de meeste gebruikte opslagruimte`,
"report_type_label_systemReport":`Systeemrapporten`,
"label.customobjects.majorobject":`Primair object`,
"label.file.delete.public.link":`Verwijder publieke link`,
"front-epwechat-module-v1-id":`WeCom ID`,
"label.partner.common.roleNum":`Aantal rollen`,
"label.sendtonextapprover":`Verzonden naar volgende goedkeurder`,
"label.notification.tip3":`Laad 10 Meer meldingen`,
"label.tabpage.placeenterz":`Wil je alsjeblieft binnenkomen?`,
"label.mobile.phone.cc.people":`Cc`,
"component_setup_iframe_label_inputurlmemo":`Voer de url in van de pagina die moet worden geïmporteerd`,
"label.umeng.activity.statuschange":`De taakstatus die u aan #naam hebt toegewezen is gewijzigd in #newstatus`,
"label.step3.restricted.visibility":`Stap 3 Beperk de zichtbaarheid`,
"label.multilang.datadelete.approvedata":`Records worden goedgekeurd ({0}):`,
"label.reportsSubscription.save":`Save`,
"label.emailobject.template.visibility":`Zichtbaarheid`,
"label_partner_step3":`Stap 3 Basisinformatie`,
"label.product.across":`Accross Price Books`,
"label.same.analyze.opportunity.name":`Naam van de gelegenheid`,
"label.chatter.memotel":`Memo-telefoon`,
"label.recentview.seloption2":`Onlangs Gemaakt`,
"label.ccchat.message.search.desc1":`We konden geen nieuws vinden met`,
"label.reportexport":`Exporteren`,
"label.service.gantt.drop.tip":`Toestemming geweigerd: U hebt niet genoeg rechten om te werken. Neem contact op met de beheerder.`,
"label.australian.westem.standard.time":`Australische westelijke standaardtijd （Australia）`,
"label.emailobject.email":`E-mail`,
"Homepage_Contract_FieldMissed_DoesntSupport":`Er zijn geen "qdrq" en "htje" velden op het contractobject, dus de gegevens kunnen niet worden getoond.`,
"label.email.cancel.upload.info":`Hiermee wordt het lopende uploadproces geannuleerd`,
"label.page.copy.merged.field.value":`Samenvoegveld waarde kopiëren`,
"UG.ST.006":`Direct invoeren`,
"label.trigger.service.connot.access":`Ontoegankelijke verklaring`,
"label.projectManagement.new.tasks":`Nieuwe taak`,
"lable.SalesCommitmentKanBan.receiptsRate":`Ontvangsten Voltooiingspercentage`,
"label.productsales.oppor.overdue":`Achterstallige kansen`,
"vue_label_pool_convertedbyme":`Omgebouwd door mij`,
"label.loginip.pagecue.invalidt":`Het begin-internetadres is verder dan het eind-internetadres of het internetadres is ongeldig.`,
"label.campagin.roi.xyzj":`Totale respons`,
"label.visualpage.list.title":`Actieve toegang tot aangepaste pagina's`,
"chatter.feed.searchinitvalue":`Voer de naam in...`,
"label.export_submission":`Exporteer ingediende gegevens`,
"this.season":`Dit kwartaal`,
"label.forecast.settings.gx":`Uitwisseling van prognosegegevens`,
"label.tag.addtags.tagcolour":`Tag Kleur`,
"label.api":`API-naam`,
"label.bulk.delete":`Massa verwijderen (permanent)`,
"label.reportsSubscriptionPage.condition.emailoption":`E-mail opties`,
"vue_label_dashboard_newdashboardsuccessfully":`Creëer nieuw dashboard met succes`,
"three":`Drie`,
"label.prompt":`Prompt`,
"label.same.analyze.contact.phone":`Mobiel`,
"label.icon.62":`Pijpleiding`,
"label.forecast.shrepage.tableth.isnable":`Toestaan om in te zenden`,
"label.multilang.polloption.vote":`{0} ticket(s)`,
"label.customfields.totalsummary.selecttotaltype":`Selecteer Type oprolmechanisme`,
"lable.SalesCommitmentKanBan.receivingCommitmentRate":`Ontvangsten Vastleggingspercentage`,
"label.areaAndSub":`Grondgebied en deelgebied`,
"vue_label_pool_recycle":`Recycleer`,
"lable.outlook.detail.synset":`Synchronisatie-instellingen`,
"label.quote.detail.introduce":`Voer de trefwoorden in, klik op "Zoeken" om te zoeken, wanneer het zoeken klaar is, klik op "Selecteren" om naar de volgende stap te gaan.`,
"label.profile.customappset":`Aangepaste app-instellingen`,
"label.changemylanguage":`Verander Taal`,
"message.approval.plzcapppor":`Kies de goedkeurder`,
"vue_label_pool_operatecertification2":`{0}{1}{2}{3}？`,
"label.publiccalendarandresource":`Openbare kalenders en hulpmiddelen`,
"label.wtd.changefields.title.desc1":`Selecteer de velden die u in uw Web-to-CloudCC-formulier wilt opnemen, voer de opgegeven retour-URL in en klik vervolgens op "Genereer".`,
"label.weixin.voting.not.empty":`Stemopties kunnen niet leeg zijn`,
"label.campaign.channel.equal":`Gelijk aan`,
"label.emailobject.emaildetail.button.back":`Terug`,
"label.ccchat.person.invite.allowemails":`Voor de veiligheid, vul alleen het e-mailadres eindigend met de onderstaande`,
"label.notEdit.message":`Sorry, u hebt geen toegang om deze gegevens te bewerken, neem contact op met de systeembeheerder.`,
"label.layout.selectedfields.relatedlist":`Geselecteerde velden / Verwante lijsten`,
"label.weixin.voting.deadline":`Deadline`,
"label.document.upload":`Te uploaden bestand`,
"label.import.page2.notmatchfiled":`{csvfiledlength} velden in het bestand in totaal. {difflength} velden zijn niet in kaart gebracht.`,
"label.data.exp.selzippwd":`Als u niets invult, is er standaard geen gecomprimeerd wachtwoord.`,
"label.user.step2.select.email.template":`Stap 2 Kies het e-mail sjabloon`,
"label.currency.effective":`Actieve valuta's`,
"label.version.control.type":`Organisatie Editie`,
"label.projectManagement.Taskorproblem":`Taak/probleem`,
"label.everyweek":`Wekelijks`,
"label.passwordPolicy.setup.pwdremember4":`4 wachtwoorden onthouden`,
"label.emailobject.groupemail":`Groep e-mail`,
"label.approvepagelayout1":`Iedereen heeft dezelfde indeling`,
"label.integrations.mailchimp.massage5":`Importeer de geselecteerde leads en contactpersonen uit uw CloudCC-account naar MailChimp en verstuur de e-mail naar de beoogde ontvangers`,
"label.icon.22":`Toevoegen aan`,
"Dashboard_View_All":`Alle dashboards`,
"label.import.page2.example":`Voorbeeld`,
"label.send.letter":`Uitnodigingsbrief sturen`,
"label.mobilesectionpart":`Mobiel deel`,
"component_setup_tabs_label_title":`Tabblad bladeren`,
"label.knowledgebase.results":`{a}resultaten`,
"label.field.remark":`Op deze pagina kunt u de velden specificeren die kunnen verschijnen op de`,
"vue_label_systemSettings_url":`Domeinnaam instellen`,
"vue_label_SMS_failed_find_view_list":`Kan de viewlist niet vinden`,
"setup_layout_label_order":`Sorteer op`,
"label.customsetting.touse":`Aangepaste instellingen gebruiken`,
"label.product.enter":`Voer trefwoorden in om de bijpassende producten te vinden.`,
"label.email.template.private.SMS":`Exclusieve SMS Template Map`,
"vue_label_homepage_chart_deleted":`De grafiek of het dashboard is verwijderd`,
"label.conversion_pages":`Conversie pagina`,
"label.compact.layout.select":`Selecteer de belangrijkste velden voor de lay-out van de informatie`,
"report_label_folderandreport":`Rapporten en mappen`,
"label.product.entry":`Prijs Boek Lijst`,
"label.campaignmember.main.manageMember":`Leden beheren`,
"front-QBtoCC-changing":`Bijwerken...`,
"vue_label_pool_abandonreason":`Teruggooi Reden`,
"template.report.customer.contract.statistics":`Contractuele analyse van de rekeningen`,
"label.invoice.message.sendsuccessully":`Factuur succesvol verzonden`,
"label.addcurrentoperate":`Exsiting actie toevoegen`,
"label.customerinfo.mailpwd":`Mail Box wachtwoord`,
"batch.nochange.owner":`Geen toestemming om de eigenaar van het dossier te veranderen!`,
"label_tabpage_uploadfailez":`Upload mislukt, gelieve opnieuw te uploaden.`,
"vue_label_systemSettings_mobelqrsetting":`Mobiele app scannen instellen`,
"label.regular_field":`Vorm Domein`,
"label.tabpage.delsuccessz":`Succes wissen`,
"label.Days.Before.Horizontal.Date":`niveau datum vóór`,
"label.evaluation.general":`Oké`,
"chatter.notlike.p":`Stop met deze post leuk te vinden`,
"label.chatter.send":`Stuur`,
"label.emailsync.button.cancel":`Annuleren`,
"label.notification.task4":`Uw taak loopt vandaag af`,
"vue_label_helpcenter_detail1.2":`Snel de status van een taak wijzigen: vink het vakje voor de taak aan in de module "Te laat en komend", en klik op de knop Verversen om de status van de taak snel te wijzigen in "Klaar".<br> Voordat u gaat verversen, annuleert u het vinkje en de status van de taak zal niet veranderen.<br> Taken met een hoge prioriteit worden gemarkeerd met een "rode vlag" icoon in de activiteitentijdlijn.<br>De weergavevolgorde van de activiteitentijdlijn<br>Rangschik in omgekeerde volgorde volgens de vervaldatum van de taak, de vervaldatum van het opgenomen gesprek, de startdatum van de gebeurtenis, de datum van het verzenden en ontvangen van e-mails, en de datum van het verzenden en ontvangen van SMS. Als de bovenstaande data gelijk zijn, worden ze gesorteerd in de omgekeerde volgorde van de aanmaaktijd van de record.<br>?Tijdlijnfilter<br>Gebruik de filters in de tijdlijn van de gebeurtenis om het bereik van zichtbare items te beperken, te focussen op belangrijke items en doel-items te vinden. De tijdlijnfilter bevat drie soorten filters: datumbereik, weer te geven activiteit en activiteitstype.<br> Weer te geven activiteiten: alle activiteiten, mijn activiteiten<br> In de gebeurtenis tijdlijnfilter, kan deze optie het weergavebereik van de gebeurtenis verkleinen.<br> Mijn activiteiten: Toon de activiteiten waaraan u hebt deelgenomen, als eigenaar of als deelnemer. Bijvoorbeeld, u bent de eigenaar die e-mails verstuurt of evenementen organiseert. Als u bijvoorbeeld de ontvanger bent van het e-mail Cc of Bcc veld, betekent dit dat u deelneemt aan de gebeurtenis.<br>`,
"component_chatter_post_label_title":`Publiceren`,
"label.data.dataexptemplate.desc":`Het sjabloon voor de gegevensexport, dat door gebruikers wordt aangemaakt, wordt gebruikt voor de gegevensexport en kan de gegevensexport vergemakkelijken.`,
"label.helptext":`Help Tekst`,
"vue_label_norm_removecomponent_certify":`Bevestig verwijderen component`,
"front-template-V1-Click-new-template":`Klik op "Nieuw" om een nieuwe sjabloon aan te maken. Activeer en begin dit sjabloon te gebruiken`,
"label.optional_fields":`Optionele velden`,
"label.delete_about":`Je gaat verwijderen`,
"chatter.feed.initvalue":`Waar ben je mee bezig?`,
"label.mail.configure":`Configureer uw persoonlijke e-mailadres om berichten te kunnen verzenden en ontvangen op de CloudCC e-mail startpagina, en synchroniseer uw e-mailgeschiedenis met leads en contactpersonen.`,
"label.project.hit.seven":`Taak Verval Herinnering`,
"label.button.upgrade":`EDITIE UPGRADEN of WIJZIGEN`,
"lable.PowerProcess.event.name":`Mijlpaal Naam`,
"label.weixin.confirm":`Bevestig`,
"label.customfields.new.inputformula":`Formule invoeren`,
"label.standard.buttonandlink.edit":`Standaardknop of -link opheffen`,
"workflow.action.tasks.assignortype.createdtype":`Schepper Type`,
"front-email-payment-paypal-describe":`Klik op "Doorgaan", u kunt inloggen op de PayPal website of een PayPal account aanmaken om de betaling van de factuur te voltooien.`,
"label.selectexistingoperate":`Selecteer bestaande acties`,
"label.workflow":`Workflow`,
"label.assignment.setup.detail.ruleentries":`Regel Ingangen`,
"label.data.file.i.title.num3":`3. Het systeem leest het gegevensbestand vooraf naar de server en start dan de back-end massa-importeur, waarvan de resultaten per e-mail aan de gebruikers zullen worden meegedeeld, zodat u niet op deze pagina hoeft te wachten.`,
"label.use.view":`Bestaande uitzichten gebruiken`,
"label.forecast.settings.moren":`Standaard productfamilie`,
"vue_label_calendar_add_share":`Aandeel toevoegen`,
"label_tabpage_newview":`Maak een nieuw beeld`,
"label.recycle":`Prullenbak`,
"UG_solution_03":`Creëer een oplossing`,
"label.customfields.formula.text.tip":`Maak een tekststring, bijvoorbeeld door andere tekstvelden aan elkaar te koppelen.`,
"vue_label_file_single_file_size":`Maximale ondersteuning voor één bestand`,
"label.a.b.least":`Elke "A"-plaat moet ten minste één verwante "B"-plaat hebben.`,
"label.validate.function.addtoformula":`Geselecteerde functie invoegen`,
"label_tabpage_pleaseSelectz":`Gelieve te kiezen`,
"label.account.NextFQ":`Volgende FQ`,
"label.project.project.name":`De projectnaam kan niet worden herhaald.`,
"label.emailtocloudcc.filed.owner":`Eigenaar`,
"label.textmessage.template.message2":`Het veld dat in de huidige e-mail is ingevoegd komt niet overeen met de bijbehorende record, wat kan leiden tot null-waarden.`,
"label.icon.92":`Boek`,
"label.trailerpage":`Staart pagina`,
"component_event_label_noevent":`Het lijkt erop dat je je werk vandaag hebt afgemaakt.`,
"label.trigger.tip":`Over Triggers`,
"label.knowledge.case.field.usable":`Beschikbare zaakvelden`,
"label.group.isusing.success":`Activeer met succes`,
"label.marketsea.nextnotfollowdays":`Sinds de laatste follow-up`,
"component.todaytask.label.choicestate":`Kies status`,
"label.recordtype.main":`--Master--`,
"label.sendletter.step1":`Stap1: Ontvangers van uitnodiging opgeven`,
"label_tabpage_saveviewfailed":`Beeld opslaan mislukt`,
"vue_label_report_notiec_selectone":`Elke bovenliggende objectregistratie moet ten minste één verwante objectregistratie hebben`,
"UG_opportunity_003":`Volg uw verkoopkanalen, creëer dashboards`,
"#label.importsourcestep4":`Stap 4 Importeer uw bestanden#`,
"front-kefu-moudle-v1-trrt-tip":`U moet gebruikers (klantendienstagenten) aan de extensies van TRRT koppelen om de functie van "Klik om te kiezen" te verkrijgen.`,
"UG.Forcast.09":`Volgende stap`,
"label.ggReleaseRange.subordinates":`Zoek rol en ondergeschikte`,
"label.log.desctiption":`U kunt audittrace downloaden die meer informatie bevat.(Excel.csv bestand).`,
"label.submitted":`Ingediend`,
"label.validate.function.funcExplain.BEGINS":`Controleert of de tekst met een bepaald teken begint, en zo ja, geeft dan TRUE terug, en anders FALSE.`,
"label.campaign.channel.code":`Marketingkanaal QR-code`,
"chatter.group.theLastActivityDate":`Datum laatste activiteit`,
"vue_label_dashboard_pleaseenterabreakpoint2value":`Voer een breekpunt 2 waarde in`,
"label.labeltranslation":`Label vertalen`,
"label.multilang.product.deleterederect":`Uw verwijdering van {0} kon niet worden voltooid omdat het nog steeds geassocieerd is met records in andere prijsboeken. Het geassocieerde record is als volgt.`,
"lable.currencyManage.manageRate.dis":`Om de wisselkoersen voor andere objecten te beheren, nieuwe munteenheden toe te voegen, munteenheden te activeren of deactiveren, of om de bedrijfsvaluta te wijzigen, klikt u op Beheer munteenheden.`,
"setup.layout.label.modifypage":`Pagina-indeling bewerken`,
"label.import.page2.editforname":`Bewerk de mapping voor het veld {Noodnaam} .`,
"label.searchlayout":`Zoek Lay-outs`,
"label.chatter.loadmore":`Meer laden`,
"label.trigger.folder.all":`Alle triggermappen`,
"label.export_submissions":`Formulierinzendingen exporteren`,
"lable.SalesCommitmentKanBan.allsignedTaskRate":`Totaal ondertekende taak voltooiingspercentage`,
"KeyInformationLayout_DefaultLayout_Name":`Systeem Standaard`,
"label.h5.chatter.great":`zoals(en)`,
"label.call.center.configuration.enable":`Gebruik de volgende instellingen om uw organisatie Center Call functie in te schakelen`,
"label.overdate":`Einddatum`,
"chatter.poll":`Poll`,
"label.login.input.verification.code":`Voer de beveiligingscode in:`,
"label.file.sharetype.cooperation":`Collaborateur`,
"label.app.step5":`Stap 5 Toewijzen aan profielen`,
"front-gantt-module-save-order":`Bewaar de bestelling`,
"label.globalselect.toallrecord":`Voeg nieuwe optielijstwaarden toe aan alle recordtypes die deze globale waardeset gebruiken`,
"setup.mainpage.label.welcome24":`Het CloudCC-cloudplatform biedt beveiligingstoegangsinstellingen voor alle objectgegevens in het systeem. Het delen van gegevens en de toegangsrechten kunnen worden gecontroleerd door verschillende regels en voorwaarden in te stellen.`,
"homepage.layout.desctiption":`Op deze pagina kunt u verschillende tabbladindelingen voor het begin-tabblad maken.`,
"vue_label_SMS_notice_send_sussess":`Verzonden SMS`,
"label.projectManagement.overdue":`Achterstallige`,
"label.assignment.setup.list.lead.description":`Wijs automatisch leads toe aan gebruikers op basis van door u gedefinieerde regels voor leadtoewijzing. U kunt meerdere regels met verschillende voorwaarden maken.`,
"label.list.projectSetting.des":`Wilt u emails versturen onder de onderstaande instellingen:`,
"setup.mainpage.label.welcome18":`Met de machtigingsinstellingen op ondernemingsniveau van CloudCC kunt u de gebruiksrechten van individuele gebruikers controleren terwijl ze met gegevens en modules werken. De op rollen gebaseerde machtigingsinstellingen omvatten ook gebruikersposities, groepen, rollen, regels voor het delen van gegevens en beveiligingscontroles op veldniveau om het delen van gegevens tussen verschillende mensen en afdelingen van de onderneming mogelijk te maken.`,
"label.ratio":`JoJ en MoM`,
"label.Xaxis":`X-as`,
"label.google.map":`Google Kaart`,
"Dashboard.SelectBoardToDisplay":`Selecteer de dashboards die u wilt tonen op het dashborad tabblad`,
"label.data.newtemplate.e_conditions":`Exportvoorwaarden`,
"label.emailtocloudcc.description3":`Sluit uw zakelijke e-mailaccount aan, zoals sales@company.com, info@company.com, support@company.com. Log automatisch ontvangen e-mails als leads en cases in CloudCC om tijdige opvolging van klantenbrieven te verzekeren.`,
"label.page.select.profile":`Kies de gebruikersprofielen waarvoor het nieuwe aangepaste tabblad beschikbaar zal zijn. U kunt ook de zichtbaarheid van de tabbladen onderzoeken of wijzigen vanaf de detail- en bewerkingspagina's van elk profiel.`,
"label.chosen.button":`Geselecteerde knoppen`,
"front-epwechat-module-v1-info":`Backend informatie van WeCom`,
"label.translation.select":`Filter Criteria`,
"ten":`Tien`,
"label.barcode":`streepjescode`,
"lable.product.nextdel":`Doorgaan en het getoonde record verwijderen， of klik op`,
"label.default":`Standaard`,
"label.chatter.theme":`Onderwerpen`,
"vue_label_commonobjects_view_split_screen_view":`Gedeelde Scherm Weergave`,
"label.ems.myemails":`Mijn e-mails`,
"label.email.clearPersonalEmail":`Wilt u alle gesynchroniseerde E-mails uit uw persoonlijke E-mailbox verwijderen?`,
"label.login.access.admin":`De administrateur van uw bedrijf`,
"label.emailobject.wizard.desc":`Nadat u uw emailaccount in CloudCC hebt gekoppeld, kunt u direct vanuit CloudCC email verzenden en deze automatisch koppelen aan gerelateerde leads, contactpersonen en kansen. De communicatiegeschiedenis is overzichtelijk gerangschikt op tijdlijn.`,
"label.passwordPolicy.setup.minpwdlength":`Minimale lengte wachtwoord`,
"choserow":`Kies kolommen om weer te geven`,
"front-epwechat-module-v1-role-binding":`Rollen Binding`,
"lable.outlook.edit.newdata":`Heeft de oudste creatie datum`,
"label.schedulejob.setup.schedule.enddate":`Einddatum`,
"label.quickbooks.view":`Bekijk`,
"font-evaluate-module-v1-not-inform":`Geen kennisgeving`,
"chatter.poll.option3":`Keuze 3`,
"setup_layout_label_selectfield":`Selecteer velden`,
"label.partner.common.roleSetup":`Partnerrol- en gebruikersinstellingen`,
"label_partner_new_step3":`Stap 3 voer naam en url in`,
"label.transfer":`Overdracht`,
"label.bmap.myaddress":`Mijn locatie`,
"label_tabpage_individual":`Individuele keuze`,
"label.autoRegister.changepwd.setpwd.repassword":`Voer het wachtwoord opnieuw in`,
"vue_label_commonobjects_detail_and_before":`Eerder`,
"front-kefu-moudle-v1-single-Login-area":`Single Signon Domeinnaam`,
"label.replacedocument":`Document vervangen`,
"label.validate.function.category.Logical":`Logica`,
"label.companyprofile.syncsuccess":`Sync Succesvol`,
"template.chart.rwzthyxj":`Taak Onderwerp en Prioriteit`,
"label.product.clearcondition":`Duidelijke voorwaarden`,
"component_task_label_person":`* Aangewezen persoon`,
"label.tabpage.as":`Zoals`,
"message.error.calendar.add":`De kalender is al toegevoegd`,
"label.marketsea.isrecycleleadcreatebyself":`Wilt u zelfgebouwde leads recyclen`,
"label.icon.57":`Barometer`,
"UG.Lead.010":`Of`,
"setup_object_field_dependency_label_configured":`Paginalay-outs toegewezen aan het profiel`,
"label.tianyancha.regnumber":`Geregistreerde code`,
"front-kefu-moudle-v1-Opened-chats":`Chat inschakelen`,
"label_tabpage_converstatez":`Geconverteerde staat`,
"label.bmap.beijing.haidianqu":`Shangdi 10 Straat, Haidian District, Beijing`,
"label.startimport":`Starten met importeren`,
"label.knowledgebase.application.default.settings":`Lightning App Standaardinstelling`,
"lable.account.year.custom":`Aangepaste fiscale jaren`,
"label.event.nextmonth":`Volgende maand`,
"label.email.body":`Lichaam`,
"setup.object.field.dependency.label.mustsetup":`Stel eerst de afhankelijkheid van het veld in en sla op.`,
"label_tabpage_multiple":`Meerkeuze`,
"label.task.this.month":`Deze maand`,
"label.customfields.formula.moneyexample":`Brutomarge = Bedrag - Kosten__c`,
"label.tonewemailnotice":`Selecteer het object voor deze taak en klik op Volgende. Taken kunnen alleen worden gekoppeld aan werkstroomregels en goedkeuringsprocessen van hetzelfde type.`,
"setup.mainpage.label.welcome11":`Aangepast rapport`,
"label.layout.availabletab":`Beschikbare tabbladen`,
"label.data.importef":`Importeren mislukte bestanden`,
"label.appupload.upload.alert":`Geef details over dit pakket alvorens het te uploaden. Deze instellingen bepalen aan welke vereisten moet worden voldaan om dit pakket te installeren.`,
"label.sales.accountteam.shared":`Account Team Delen`,
"lable.currency.addexchageRate":`Wisselkoersen toevoegen`,
"label.page.simplified.chinese":`Chinees (Vereenvoudigd)`,
"label.service.dispatchingUnits.search.service.area":`Zoek servicegebied`,
"lable.list.queue.name":`Naam wachtrij`,
"pagecreator.button.save":`Save`,
"label.ccpeak.support.function":`Ondersteuning van alle soorten functies in één formulier`,
"label.tianyancha.legalpersonid":`Rechtspersoon id`,
"label.sendemail.chat.addPostmainPage":`Beste #naam:hallo! #gebruikersnaam staat op uw CCChat startpagina.`,
"batch.no.change":`Geen toestemming om de gegevens over te dragen.`,
"label.the.referenced":`opgeroepen in`,
"label.input.webtab.information":`Vul informatie in over het webtabblad.`,
"vue_label_systemSettings_subscription":`Abonnement Type`,
"label.login.access.title":`Toegang verlenen tot account login`,
"label.schedulejob.setup.schedule.lastday":`de laatste dag`,
"label.synchronize.department":`Synchroniseer gebruikers`,
"label_tabpage_lessequalz":`Minder dan of gelijk aan`,
"label.file.library.successmanagemember":`Succesvol opgeslagen`,
"label.service.major.event.oreder":`Volgorde`,
"label.desktopintegration":`Desktop Integratie`,
"label.a_b":`A naar B relatie`,
"every":`Elke`,
"label.tabpage.bar":`Bar`,
"label.filecontentsnotnull":`De inhoud van het bestand kan niet leeg zijn.`,
"label.layout.detailoftestobj":`Details testobject`,
"label.summaryreport.2018.step3":`Stap 3 Kies kolomkoppen`,
"UG.Lead.002":`Er zijn vele manieren om "leads" voor uw product of dienst te identificeren.`,
"label_partner_workspace_member_selectedprofile":`Geselecteerd profiel`,
"label.newdescription":`Nieuwe noot`,
"vue_label_normal_moveup":`Schuif op.`,
"label.mobile.quickcreate.default.logacall":`Gesprekshistorie`,
"userterritory.serviceterritory.user.unique":`Dit servicegebied is al aan deze gebruiker toegewezen. Gelieve niet opnieuw toe te wijzen.`,
"label.weixin.record":`Record`,
"front-kefu-moudle-connecting":`Aansluiten`,
"label.monitorsys.recent.operation.log":`Recent operatielogboek`,
"lable.outlook.detail.lmaping":`Kaart Lead Fields`,
"lable.account.year.ovdate":`Einddatum boekjaar`,
"vue.homepage.auditcard.record":`{recordTotaal} records`,
"label.processsetting.delete.process.succeeded":`Verwijder proces succesvol!`,
"label.customerinfo.smsPwd":`SMS Gateway Wachtwoord`,
"label.tolead.object":`Objecten importeren`,
"label.data.downpage.i.list.desc2":`Nadat de gegevens zijn geïmporteerd, ontvangt u een e-mail om u eraan te herinneren dat de import is gelukt.`,
"label.sharerule.ruletype":`Type regel`,
"label.reportsSubscriptionPage.email.toothers":`Stuur naar mij en bepaalde groepen gebruikers`,
"label.emailobject.templates":`Sjablonen`,
"vue_label_checkduplicate_":`Botsingsanalyse`,
"label.campaign.channel.lookup.example":`Bekijk voorbeeld`,
"label.login.verification.please.note":`Let op:`,
"label.version.charge":`Laad`,
"label.ccdocument.show.trace":`Toon Trace`,
"label.sendemail.approval.submit":`Hallo, #naam:#actorname de #objLabel-#recordnaam ingediend door #actordate wacht op uw goedkeuring. klik op de volgende link of log in op het crm-systeem om naar het goedkeuringscentrum te gaan voor goedkeuring:#path#appPath/query.action?id=#recordid&m=query\n#orgName`,
"setup.mainpage.label.welcome12":`De gebruiker kan de rapportdefinitie voltooien door met de muis te klikken, zonder te programmeren, en de stappen van het systeem te volgen. Het systeem kan kiezen uit een lijstrapport, een samenvattingsrapport en een matrixrapport. Weergave-opties voor alle velden zijn ook beschikbaar. Verwijder onnodige veldinformatie. Tegelijkertijd biedt het een verscheidenheid aan grafische weergaven, waaronder stroken, vouwlijnen, ringen, trechters en taarten, zodat gebruikers in één oogopslag kunnen zien.`,
"UG_contact_06":`Contacten importeren`,
"message.success.event.add":`Succesvol opslaan van nieuwe evenement informatie`,
"report.line":`Gegevensveld`,
"label.approvepagelayout2":`Iedereen heeft een andere indeling`,
"vue_label_normal_contract_sf":`Contract`,
"label.tabpage.tpcustomersz":`Converteer leads`,
"label.ccchat.message.new.error5":`Fout, uw bericht kan niet langer zijn dan 10000 tekens.`,
"label.severalorone":`Iindividueel dossier`,
"pagecreator_systemstyle_label_buttonfontcolor":`Knop tekst`,
"label.customer.tab.step3.introduce":`Kies de aangepaste apps waarvoor het nieuwe aangepaste tabblad beschikbaar zal zijn. U kunt ook de zichtbaarheid van de tabbladen onderzoeken of wijzigen vanaf de detail- en bewerkingspagina's van elke aangepaste app.`,
"chatter.group.groupEdit":`Groep bewerken`,
"label.partnerCloud.partnerAccount.spending":`Uitgaven voor korting`,
"label.slip":`item)`,
"label.field.master.class":`Het relatieniveau van opdrachtgever-detail is hoger dan niveau 3`,
"label.sendemail.chat.addComentsmyFeed":`Beste #naam:hallo! #naamgebruiker heeft gereageerd op je micropost.`,
"label.service.ganttBaiduMap.selectingDispatchTime":`Selecteer Verzend Interval`,
"label.knowledgebase.remove.article":`Weet je zeker dat je het artikel uit de archieven wilt verwijderen?`,
"label.appupload.notmanaged":`Ongecontroleerd`,
"label.report.goto.step":`Ga naar Stap`,
"label.publicgroup.save.mustbeselect":`U moet de leden selecteren`,
"label.data.expnode.e.desc2":`2、Exporteren per sjabloon: gebruikers kunnen een sjabloon kiezen om gegevens te exporteren.`,
"UG.product.02":`Producten verwijzen naar producten of diensten die worden verkocht of gekocht.`,
"label.sendemailtouser":`Weet u zeker dat u e-mail wilt sturen naar de geselecteerde gebruikers?`,
"label.knowledge.setting.hint.nine":`Als u het niet weet, wat heeft u dan aan die kennis? Sorteer gelijksoortige artikelen als de enige een gegevens categorie en accumuleren tot een bredere categorie. Nu, laten we een gegevens categorie toevoegen. U kunt later meer categorieën toevoegen.`,
"front-asset-module-v1-view-asset-bom":`Bekijk de inventarislijst`,
"label_partner_all_enable":`Activeer`,
"label.processsetting.disable.process.successfully":`Proces succesvol uitschakelen`,
"label.call.center.enable":`Call Center inschakelen`,
"message.recordtype.applyitseparatly":`Pas voor elk profiel een andere pagina-indeling toe.`,
"label.weixin.report.customize":`Aanpassen`,
"label.file.mongdb.file.is.not.exist":`Bestand bestaat niet`,
"label.chat.edit.topics":`Wijzig onderwerp`,
"label.knowledge.delete.searchterm":`Fout bij het verwijderen van gepromoveerde zoekterm`,
"label_emailtocloudcc_redmessage3":`Voer server adres in`,
"use":`Gebruik`,
"label.batchtransfer.transferfrom":`Overdracht van`,
"label.recycle.my":`Mijn prullenbak`,
"label_json_string_null":`Leeg`,
"label.version.lookupfield":`Lookup relatieveld`,
"lable.tianyancha.h5.searchf":`Niet gevonden`,
"label.validate.globalvariable.description":`$User.[Field API] eg: $User.id <br>De waarden die u kunt gebruiken zijn,naam,rolId,rolNaam,profielId,profielNaam,afdeling,titel,e-mail`,
"UG.opportunity.006":`Opportuniteitsgenie`,
"label.applt.copy":`Kloon met één tik`,
"chatter.emailMessageOrReply":`Berichten of commentaar op mijn bericht`,
"label.newreport.self":`Geselecteerde velden`,
"label.visualpage.checkpinxie":`Controleer de spelling van de pagina.`,
"label.knowledgebase.article.attaching.case":`Het artikel {naam} is aan de zaak gekoppeld!`,
"label.dialogbox":`Dialoogvenster`,
"label.summaryreport.step3.new":`Stap 3 Kies de samen te vatten gegevens`,
"label.confirm":`Bevestig`,
"label.mobile.buttom.team":`Team`,
"label.quickbooks.action.link":`Link`,
"vue_label_commonobjects_view_support_to_datas":`De bediening ondersteunt tot 10 gegevens`,
"vue_label_helpcenter_homepage":`Elke gebruiker heeft vanaf het begin twee homepages, een standaard homepage en een persoonlijke homepage. De beheerder kan een overeenkomstige profiel-homepage aan de gebruiker toewijzen, afhankelijk van het profiel van de gebruiker. Merk op dat de homepage van de Lightning versie en de homepage van de oude versie niet interoperabel zijn.<br> 1. Standaard homepage<br> De inhoud van de standaard homepage is uniform en niet aanpasbaar. Inclusief kwartaal prestatie component, recent bekeken component, goedkeuringscentrum component, vandaag gebeurtenis component, taak component, achterstallige zakelijke kansen component, buiten de 30 dagen zakelijke kansen component, en aankomende zakelijke kansen component<br> Kwartaal prestatie component: iedereen kan zijn eigen kwartaal doelen instellen<br> Recent bekeken component: Toon de 10 meest recent bekeken objectrecords<br> 30-dagen niet-contact zakelijke opportuniteitscomponent: Toon 5 business opportunities waarvan de contactloze dagen groter zijn dan 30 dagen en de waarschijnlijkheid niet 0 of 100 is<br> 2. Persoonlijke startpagina<br> Iedereen heeft een persoonlijke startpagina, en de inhoud op de persoonlijke startpagina kan worden aangepast door componenten toe te voegen of te verwijderen, of door te slepen en neer te zetten om de positie en grootte van de componenten aan te passen<br> Er zal standaard een briefingcomponent, een goedkeuringscentrumcomponent, een achterstallige zakelijke opportuniteitscomponent en een komende zakelijke opportuniteitscomponent zijn bij het openen van een account op de persoonlijke startpagina<br> Persoonlijke startpagina staat tot 15 componenten toe<br> 3. Profiel homepagina<br> Beheerders kunnen profiel homepages maken/wijzigen/verwijderen door de homepage aan te passen, en kunnen verschillende homepages aan verschillende profielen toewijzen, zodat gebruikers met verschillende profielen verschillende homepages kunnen zien<br> Tot 15 componenten per profiel homepage<br> 4. Componenten toevoegen<br> Persoonlijke homepage en profielhomepage kunnen worden aangepast om componenten toe te voegen, u kunt dashboardcomponenten, dashboardgrafiekcomponenten en kaartweergavecomponenten toevoegen<br> Dashboardcomponent: voeg het volledige dashboard in het systeem toe aan de homepage. Het aantal sub-componenten in het dashboard geeft aan hoeveel componenten het dashboard component in beslag neemt (de homepage ondersteunt tot 15 componenten), en de gegevens van het dashboard component na het toevoegen zullen niet worden geassocieerd met het oorspronkelijke dashboard (dat wil zeggen, als het oorspronkelijke dashboard wordt verwijderd, kan het dashboard component nog steeds functioneren) <br> Grafiek component in het dashboard: U kunt een bepaalde grafiekcomponent in het dashboard in het systeem toevoegen aan de startpagina, en de koppelingsfunctie van de component zal op dat moment ongeldig zijn<br> Kaartweergavecomponent: U kunt ervoor kiezen om een bepaalde weergave van een object als gegevensbron aan de startpagina toe te voegen, en velden en bewerkingsitems kunnen worden aangepast. Maar let op dat als de gegevensbron van de kaartweergave wordt verwijderd, de kaartweergave geen gegevens zal hebben`,
"label.usersandlimit":`Gebruikers en Toestemming`,
"label.sendmail.step3.introduce2":`ontvanger(s) geselecteerd om deze e-mail te ontvangen.`,
"label.setupcustomfield":`Aangepaste velden`,
"label.layout.last.notdel":`De laatste mag de lay-out niet verwijderen.`,
"label.emailtocloudcc.redmessage7":`Configuratiefout, neem contact op met de beheerder.`,
"label.includedIn":`Bevat in {ouderproductnaam}`,
"label.permission.detail.app.pagesetting":`Aangepaste pagina-instellingen`,
"label.addfile.tips":`{selectedNum} bestanden zijn geselecteerd. Er kunnen maximaal {originNum} bestanden in één keer worden toegevoegd.`,
"label.fieldinformation":`Veld Details`,
"label.campagin.roi.sjcb":`Werkelijke kosten`,
"label.email.all.works.company":`Alle collega's van het bedrijf`,
"label.currencyDesc":`Gebruik deze pagina om alle valuta's te definiëren die door uw organisatie worden gebruikt. Bedrijfsvaluta moet worden ingesteld op de valuta waarin uw hoofdkantoor inkomsten rapporteert. Als u een andere valuta als bedrijfsvaluta aanwijst, zullen alle omrekeningskoersen aan deze wijziging worden aangepast.`,
"label.file.details":`Details`,
"label.foldervisitlimit3":`Alleen de volgende gebruikers hebben toegang tot deze map:`,
"label.account.next.M":`Volgende maand`,
"label.oweralias":`Eigenaar Alias`,
"label.projectManagement.entryname":`Naam project`,
"label.customcomponent.page.add.title1":`Component Informatie`,
"label.projectManagement.PleaseenterCreator":`Voer een maker in`,
"label.multipleactivity.memberselected":`Geselecteerde leden`,
"label_chatter_memotel":`Memo-telefoon`,
"lable.Confirm.customers":`Bevestig om {num} afleidingen te herstellen.`,
"front-email-payment-Invoice-number":`Factuur nr.`,
"label.not.appoint.validation":`Er zijn geen objecten gespecificeerd voor de validatieregel, gelieve te specificeren.`,
"label.peru.time":`Peru Tijd`,
"label.setting.intergrationlist.status3":`QuickBooks login vereist`,
"vue_label_display_number_field":`Toon Nummer Velden`,
"label_productline_count":`Productreeks Bedrag`,
"label.data.downpage.i_title.num2":`2. Voordat u begint met importeren, controleert u of de veldnaam in het bestand dat u wilt importeren overeenkomt met de objectveldnaam in het CloudCC.`,
"label.field.duplicate4":`Behandel "ABC" en "abc" als verschillende waarden __(hoofdlettergevoelig)`,
"message.approval.step.validation.invalid.levels":`Minstens 1 niveau`,
"label.tianyancha.businessverify.step1":`Inschakelen verificatie bedrijfsgegevens stap 1`,
"label.hidedetail":`Verberg details`,
"UG_Lead_009":`APP belgeschiedenis`,
"label.partnerCloud.newProductSeries":`Nieuwe productfamilie`,
"label.brief.opportunities":`Totaal`,
"label.user.mfa.unbind.remind":`U staat op het punt de MFA voor de geselecteerde gebruikers te deblokkeren en moet het MFA-apparaat opnieuw koppelen na de volgende aanmelding, weet u dat zeker?`,
"vue_label_report_grouprow":`Groepsrij`,
"setup.layout.label.newarea":`Nieuw gebied`,
"label.nostart":`Niet begonnen`,
"UG_Lead_010":`Of`,
"label.emailmerge.mergepage.record.requeired":`Selecteer de records die u wilt samenvoegen.`,
"label.appointmentpage.wizard.notif1btn1":`Bevestig`,
"UG.Account.02":`Sommige bedrijven verlenen diensten aan andere bedrijven, andere werken rechtstreeks samen met eindgebruikers, en weer andere staan ten dienste van NGO's.`,
"label.address.country":`Land`,
"label.userinfo.updatepwd":`Wijzig Wachtwoord`,
"label.salescloud.teamrole.optionlist.opportunity":`Voeg kans teamlid toe aan`,
"lable.account.Current.FY":`Huidig FY`,
"chatter.coll.p":`Bladwijzer van dit bericht`,
"label.setupsms":`SMS`,
"label.atlantic.daylight.time":`Atlantische zomertijd`,
"label.recordslock":`Record Slot`,
"button_partner_search":`Vraag`,
"vue_label_salesfunnel_notice4":`Aantal zakelijke kansen met een waarschijnlijkheid van 1% - 99%`,
"vue_label_report_statistics":`Statistieken`,
"label.ccchat.notmember.active.group0":`U bent geen lid van een activiteiten groep met {0} in hun naam`,
"label.tag.manage.newtag":`Nieuw label`,
"label.customfileds.formula.dateandtime.tip":`Bereken een datum/tijd, bijvoorbeeld door een aantal uren of dagen bij een andere datum/tijd op te tellen.`,
"label.weixin.mobile.fly.ios":`Delen vanaf een mobiel apparaat (IOS)`,
"vue_label_file_over_file_size":`De bestandsgrootte van file.name  'overschrijdt de systeemvoorinstelling!`,
"label.schedulejob.setup.schedule.last":`laatste`,
"label.ccchat.whose.name.contains":`van elke actieve groep waarvan de naam`,
"label.project.milestone.name":`U kunt niet twee mijlpalen met dezelfde naam in één project hebben.`,
"message.passwordPolicy.validate.reuse":`Fout: U kunt dit oude wachtwoord niet opnieuw gebruiken.`,
"label.stdashbord.xsld.business.img3":`De hoeveelheid waarschijnlijkheid van 1%-99% * Waarschijnlijkheid`,
"label.event.view.list":`Lijst bekijken`,
"label.workflow.ruletriggertime":`Regel Trigger Tijd`,
"label.campaign.channel":`Marketingkanalen`,
"label.appexchange.emailnotice":`Werkstroom e-mail waarschuwing`,
"label.icon.77":`Landbouw`,
"label.visualpage.display.value":`Voer de weer te geven waarden in, en let op dat er geen spaties voor of achter staan.`,
"label.forecast.customforecast.type.user":`Door gebruiker`,
"label_tabpage_lessz":`Minder dan`,
"label.same.analyze.contact.email":`E-mail`,
"vue_label_report_range":`bereik`,
"lable.product.pricebooks.nr":`U kunt de inhoud van bestaande prijsboeken klonen door een keuze te maken uit de onderstaande lijst.`,
"label_mobile_buttom_team_setUp":`Team Instellingen`,
"label.email.bcc.recipients":`Bcc ontvangers`,
"vue_label_ccchat_notice_deletepostfail":`Bericht verwijderen mislukt`,
"label_file_type":`Bestandstype`,
"label.multilang.feedtrack.operateupdate":`Een {0} record is gewijzigd：`,
"label.contractmanager":`Contract Manager`,
"front-gantt-module-drag-one-task-sorting":`Taken kunnen alleen gesorteerd worden binnen dezelfde mijlpaal!`,
"label.partner.step2":`Stap 2 bevestig sjabloon`,
"front-epwechat-module-v1-again-binding":`Herbinden`,
"label.service.miniProgram.imageSize":`Er kan niet meer dan 2MB aan foto's worden geüpload!`,
"setup_main2018_label_managesetup":`Administratieve instellingen`,
"component_salesperformance_label_nopermission":`Neem contact op met uw systeembeheerder om gegevens over zakelijke kansen te bekijken.`,
"lable.account.stadate":`Begindatum fiscaal kwartaal`,
"label.service.gantt.and.resourcestype":`en het type bron is`,
"label.ems.attachfiles":`Bijlage toevoegen`,
"label.data.expnode.e.desc1":`1、 Aangepaste Export: gebruikers kunnen velden selecteren om te exporteren en filter voorwaarden in te stellen volgens hun behoeften.`,
"vue_label_systemSettings_analyse":`Analyseren`,
"label.project.all.date":`De einddatum moet later zijn dan of gelijk aan de begindatum!`,
"vue_label_commonobjects_view_summary_basis":`Aggregatiegrondslag`,
"template.chart.yywjhdschd":`Campagnes met kansen`,
"vue_label_pool_notmeet":`Voldoet niet aan de eisen van de klant`,
"label.attendance.manager":`Aanwezigheid beheren`,
"vue_labenl_normal_current":`Huidige`,
"label.projectManagement.completed.quantity":`Voltooiing Hoeveelheid`,
"label.layout.testfield":`Test velden`,
"label.customfields.selectcontainrelatelistlayout":`Selecteer de paginalay-outs die deze verwante lijst moeten bevatten`,
"label.fiji.time":`Fiji Time`,
"message.error.domain.already.exists":`Domeinnaam bestaat al.`,
"label.accountandcontact":`Rekeningen/Contacten`,
"label.dashboardSetup.right":`Rechts`,
"label.view.appliedMobile.xgry":`Als u dit item aanvinkt, kunnen de relevante gebruikers de weergave op de startpagina werkbank zien`,
"label.file.share.all":`Elke gebruiker in uw bedrijf`,
"vue_label_pool_summary":`Totaal {0} records, ververst op {1}`,
"label.emailtemplate.new":`Nieuw Email sjabloon`,
"label.tag.manage.button1":`Maak nieuwe tag`,
"label.data.exp.tempexppage":`Sjabloonpagina voor gegevensexport`,
"font-trade-module-v1-invoice-total":`Totaal factuurbedrag`,
"label.folder.sort":`Map sorteren`,
"label.multilang.campaign.countnum":`{0} tijd(en)`,
"label.homepagelayout":`Lay-outs startpagina`,
"setup_layout_button_cancel":`Annuleren`,
"lable.Search.in.QuickBook":`Zoeken in QuickBook`,
"setup_fielddependency_label_pleaseclick":`Klik op Controlling Field waarde om te bewerken`,
"setup.fielddependency.label.pleaseclick":`Klik op Controlling Field waarde om te bewerken`,
"label.version.sum.field":`aangepast(e) veld(en)`,
"label.form.is.submitted.successful":`Bericht van succesvolle formulierindiening`,
"label.campaignmember.main.batchaddmember":`Campagne leden massaal toevoegen`,
"label.sendemail.activity.newevent":`Beste #belongtoidccname, hallo:Je collega #createbyidccname heeft je een nieuw evenement toegewezen in #createdate, dat als volgt luidt:Onderwerp: #onderwerp #begintijd: #begintijd #eindtijd: #eindtijd: gerelateerde items: #gerelateerde items: #remark Voor meer details, bezoek deze link: #pad #orgNameCRM-systeem`,
"label.knowledgebase.select.target":`Kies een doel`,
"setup.layout.label.buttonlist":`Knoppen kiezen`,
"pagecreator.page.label.pagedesc":`Beschrijving van de pagina`,
"label.version.professional":`Professionele Editie`,
"UG.Forcast.10":`Compleet`,
"template.chart.schdyqsr":`Verwachte inkomsten uit campagnes`,
"front-filter-module-v1-quick-filter":`Flitsfilter`,
"label.notification.group2":`Je bent succesvol lid geworden van het publieke team`,
"label.ServiceCloud.statistics.by.serviceArea":`Statistieken per verzorgingsgebied`,
"label.validate.function.funcExplain.TIMENOW":`Geeft als resultaat een tijd die het huidige moment vertegenwoordigt`,
"label.brief.lastmonth":`Vorige maand`,
"label.weixin.member.states":`Lidmaatschapsstatus`,
"template.chart.ljxsje":`Cumulatief Verkoopbedrag`,
"label.eidt.queue.label.hasused2":`Deze wachtrijnaam bestaat al of is al eerder gebruikt.`,
"label.textmessage.nophonenumber":`Dit contact heeft geen GSM nummer in zijn bestand!`,
"label.task.new":`Nieuwe taak`,
"label.tabpage.grid":`De rasterweergave`,
"label.workbanch.setup.viewname":`Bekijk naam`,
"front-gantt-module-temporary-tasks":`Tijdelijke taak`,
"label.reportTypeDescripe":`Met een aangepaste rapportgegevensbron kunt u gebruikers in staat stellen rapporten te maken op basis van de voorgedefinieerde objecten, objectrelaties en velden die u opgeeft.`,
"setup_layout_label_fieldlist":`Beschikbare velden`,
"label.ggReleaseRange.searchforRole":`Rol van zoekpartner`,
"label.datamanage.account.field":`Account velden`,
"label_tabpage_groupingemptyz":`Groeperingsitems kunnen niet leeg zijn`,
"label.permission.edit.insertinfo":`Toestemmingenset informatie invoeren`,
"label.back_forms":`Terug naar formulierenlijst`,
"vue_label_calendar_step_2":`Stap 2: Maak een kalender van een standaard of aangepast object.`,
"lable.outlook.mcto.out":`Uitgesloten domeinen`,
"label.workflow.accessnext":`Gebruik deze goedkeuringsprocedure als`,
"label.data.exp.temppage":`Gegevens exporteren en pagina met sjablonen maken`,
"label_tabpage_printview":`Weergave Afdrukken`,
"vue_label_report_preview":`Om de laatste bewerkingen te zien, refresh voor preview.`,
"frame_personinfo_label_personimage":`Profiel foto`,
"component.chatter.button.like":`Zoals`,
"label.ems.drafts":`Kladjes`,
"front-lightning-module-v1-details-page-chart-report-name":`Naam rapport`,
"label.partner.workspace.login":`Inlogpagina`,
"include":`inclusief`,
"label_length_20":`Beperk de lengte tot 20 tekens.`,
"component_event_button_save":`Save`,
"label.weixin.recalculate.shared.success":`Object delen regel herberekening succes.`,
"message.duplication.errorinscript.lessthan2":`U moet ten minste twee records selecteren om samen te voegen.`,
"label_my_forecast":`Mijn voorspelling`,
"label.ems.to":`Ontvanger`,
"label_mobile_buttom_team_init":`Team Gebruiker Initialisatie`,
"label.sendemail.send.codeerror":`Code conversie mislukt, voer de juiste codering in.`,
"lable.quote.syncing.and":`en`,
"label.campaignmember.selectmember.step1oftotal":`Stap 1 van 2`,
"label.ems.step3":`Stap 3`,
"lable.PowerProcess.detail.message":`Informatie over het Mijlpaalproces`,
"chatter.poll.option2":`Keuze 2`,
"front-view-module-v12-verify-number":`Fout in numeriek formaat. Controleer de invoergegevens.`,
"label.setup.mobile.homepageshortcuts.savesuccess":`De instellingen van de gierzwaluwfunctie worden opgeslagen.`,
"lable.outlook.edit.zdyoutfi":`Naam aangepast uitwisselingsveld`,
"label.assignment.setup.newentries.inputentries":`Voer de regel in`,
"label.customfields.money.tip":`Hiermee kunnen gebruikers een dollar of een ander valutabedrag invoeren en het veld automatisch opmaken als een valutabedrag. Dit kan handig zijn als u gegevens exporteert naar Excel of een andere spreadsheet.`,
"label.service.appointmentList.cancelThePlan":`Plan annuleren`,
"label.chat.topic.suggest.add.topic":`Geen suggestie, voeg je eigen onderwerp toe.`,
"vue_label_commonobjects_detail_tips":`Tips`,
"message.error.view.nameexists":`Fout: De unieke naam van de view bestaat al.`,
"label_emailtocloudcc_step2_name":`Configuratie van e-mail eigendom`,
"label.field.validation.apiname":`Het moet beginnen met een letter. Het mag alleen hoofdletters, kleine letters, cijfers en underscore bevatten. En de maximale lengte is 50 tekens, minimale lengte is 2 tekens. Let op dat het geen database sleutelwoord kan zijn.`,
"page.field.masterinput.remark2":`Bijvoorbeeld, wanneer u een nieuwe order aanmaakt, moet u deze functie inschakelen om de orderregelgegevens op dezelfde pagina in te voeren. (deze functie is zeer geschikt voor objecten in de master-detail relatie).`,
"label.rule.enabled.successfully":`Activeer de regels met succes`,
"label.role.createrolelist.tip":`Hieronder vindt u een lijst van de rollen voor uw organisatie. U kunt meer informatie bekijken door op de link van de rol te klikken.`,
"label.multilang.datamanage.dataimport.redundantmsg":`De lengte van de titel is &nbsp;{0}&nbsp; maar de lengte van de gegevens is &nbsp;{1}&nbsp; het systeem kan niet bepalen welke &nbsp;{2}&nbsp; velden overbodig zijn.`,
"label.visualpage.staticresource":`Introduceer Statische Bron`,
"chatter.group.members01":`Leden`,
"label.planned.workname":`Functie Naam`,
"label.service.dispatchingUnits.gantt.data":`Overeenkomende Gantt Datum`,
"label.data.newtemplate.t.conditions":`Sjabloon Voorwaarden`,
"label.accmarketsea.edit.title":`Account-pool bewerken`,
"label_chatter_priority":`Prioriteit`,
"label_mobile_buttom_team_open":`Team inschakelen op PC & App`,
"front-gantt-module-no-tasks-available":`Geen beschikbare taken`,
"component.newrecords.label.type":`Type opslag`,
"label.version.ccdocument.and.remark":`Notities & Bijlagen`,
"label.martrixreport.step2":`Selecteer de groeperingsmodus die wordt gebruikt om de gegevens te berekenen die u wilt oprollen`,
"label.projectManagement.Scheduleinformation":`Informatie over dienstregelingen`,
"label.emailmerge.mergeFolder.description":`Op deze pagina kunt u een Microsoft Word document maken met uw contact gegevens. Selecteer mail merge sjablonen, maximaal 20.`,
"label.autoRegister.changepwd.setpwd.tip":`Het wachtwoord moet aan de volgende voorwaarden voldoen`,
"label.partnerCloud.orderingPlatform.shoppingEmpty":`De winkelwagen is leeg, klik op "Producten toevoegen" om toe te voegen.`,
"label.marketcloud_seminar":`Marketing Cloud Seminar`,
"label.knowledgebase.no.results.knowledge.search":`Geen resultaten over "{a}" in Kennis`,
"label.createdate":`Gemaakt op`,
"vue_label_systemSettings_bazaar":`Markt`,
"report_type_label_contractPayment":`Contracten en vorderingen`,
"label.myemailset":`Mijn e-mail instellingen`,
"label.emailtype":`Type e-mail`,
"label.appexchange.uninstallpage.message5":`Verwijder permanent alle relaties en gerelateerde lijsten die geassocieerd zijn met de aangepaste objecten in dit pakket`,
"label.customerinfo.applicationlicencenum":`Eigenschap Licenties Aantal`,
"label.product":`Producten`,
"lable.opppdt.selPdt.subtitle":`Product Selectie Voor`,
"label_emailtocloudcc_step1_lead1":`E-mail aan leiding`,
"label.multilang.recentview.query":`Bekijk je laatste...`,
"label.cumstom":`Custom`,
"lable.product.pep":`Geef de prijs op.`,
"label.suggestion":`Ideeën`,
"vue_label_email_sentto":`verzonden`,
"label.email.cancel":`Nadat de koppeling is geannuleerd, kan de mailbox niet meer worden gebruikt om emails te verzenden of te ontvangen. Weet u zeker dat u de associatie wilt annuleren?`,
"component_timeline_label_1monthahead":`1 maand voor`,
"setup_mainpage_label_welcome31":`Instructies: Klik op het menu aan de linkerkant van deze pagina → Beheer Instellingen → Aanmaken → Toepassing`,
"label.weixin.settlement.rate":`Afwikkelingspercentage`,
"front-lightning-module-v1-details-page-chart-add-report":` Er kunnen maximaal 4 grafieken aan het rapport worden toegevoegd.`,
"label_related_list_types":`Verwante lijst type Lightning versie`,
"label.tabpage.converstatez":`Geconverteerde staat`,
"label.chatter.ok":`Bevestig`,
"lable.SalesCommitmentKanBan.contractRate":`Ondertekend tarief`,
"component.setup.label.setupsavefail":`Het opslaan van de componentinstellingen is mislukt`,
"label.email.form.text2":`[overschakelen naar html]`,
"UG.Lead.009":`APP belgeschiedenis`,
"label.escalation.setup.newrule.title":`Escalatie regel`,
"label.field.available.value":`Beschikbare veldwaarden`,
"label.cannotuseaddtimetrigger":`<b>`,
"vue_label_chat_activefail":`Geactiveerd falen`,
"label.dashboard.show.total.percent":`Toon totaal of toon %, kies er minstens één`,
"label.schedulejob.setup.schedule.jobprg":`Banenprogramma's`,
"label.select.email.type":`Selecteer type email!`,
"chatter.group.allTheMembers":`Alle leden`,
"label.webtab.validation.apiname":`Het moet beginnen met een letter. Het mag alleen hoofdletters en kleine letters, cijfers en underscore bevatten. En de maximale lengte is 20 tekens, minimale lengte is 2 tekens.`,
"label_partner_new_step3_name":`Naam`,
"vue_label_chatter_remove_member":`Lid verwijderen`,
"label.customobjects.majorobject.tip":`Indien u een niet-principe-gedetailleerd relatieobject selecteert, nemen de samenvattende gegevens geen machtiging`,
"label.forecast.edit.kjjd":`FQ`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.three":`Drie`,
"label.weixin.senderror":`Verzenden mislukt`,
"label.visiturl":`Bezoek URL`,
"label.apply.img.error":`De tekeninvoer in de gragh is onjuist`,
"label.been.detained":`Reset Korting`,
"vue_label_helpcenter_dashboard2":`<br> In het nieuw gecreëerde dashboard, moet u eerst componenten toevoegen, en de rapport gegevensbron of lijstweergave gegevensbron selecteren. Bepaal vervolgens het type grafiek dat wordt gebruikt en selecteer de bijbehorende groepering en statistische gegevens om de grafiek te maken<br> Na het toevoegen van de componenten, kunt u op de "Opnieuw sorteren" knop op het dashboard klikken om de positie en grootte van de componenten aan te passen. <br> Als u tijd filter condities wilt instellen voor sommige componenten, kunt u klikken op "Filter Conditie Instellingen" om de component te selecteren en het tijdveld in te stellen waarop de component moet filteren. Na het instellen, kunt u filteren op tijd op het dashboard en het bijbehorende tijdbereik selecteren om de geselecteerde gegevens te actualiseren. <br>Note: Een dashboard ondersteunt maximaal 10 componenten. <br> 2. Instelling en koppeling van componenten<br> In hetzelfde dashboard, kan component A component B en C van dezelfde gegevensbron instellen als zijn koppelingsobjecten. Nadat de instelling is voltooid, klik op een data gebied van component A, component B en component C zullen gelijktijdig de data hertellen op basis van de data gebied condities van component A. <br> Merk op dat klikken op het data gebied van component B of component C niet zal leiden tot hertelling van component A. Als u dit effect wilt bereiken, moet u component A instellen als koppelingsobject op component B/C. <br> Voor elke grafiek component in het dashboard, komen de gegevens uit de view of het rapport. Daarom is voorzien in een penetratie functie, dat wil zeggen, klikken op het gegevensgebied van de component kan naar het corresponderende rapport en lijstweergave springen. Merk op dat als de oorspronkelijke gegevensbron faalt, de component geen gegevens zal hebben en de penetratie-functie ook zal falen. <br> Omdat zowel penetratie als koppeling het gegevensgebied van de component zijn om op te klikken, kunnen ze niet beide tegelijk in werking treden. Als de component zowel de penetratie- als de koppelingsfunctie heeft ingesteld, dan kan de component slechts één functie tegelijk laten werken, en kunt u de functie kiezen door de koppelings- en penetratiestatus om te wisselen.`,
"vue_label_commonobject_view_notice_delete_false":`Gegevens {0} konden niet worden verwijderd, reden is {1};`,
"label.weixin.newspaper.coverage.information":`Details risicoblad`,
"label.you.do.not.have.permission.to.operate.":`Je hebt geen toegang om te opereren.`,
"label.checkfield.match":`Wedstrijd`,
"message.custom.field.donotdelete.ref":`Naar dit veld wordt verwezen door andere velden`,
"label.version.maxsum":`heeft de bovengrens bereikt.`,
"System.ChangeUser.Info.001":`Eigenaar gewijzigd en klik om terug te keren naar de vorige pagina.`,
"label.target":`Doel`,
"template.dashboard.behavior.analysis":`Analyse van acties`,
"label.login.verification.enter.prompt":`Voer een 6-cijferige digitale beveiligingscode in`,
"label.am":`AM`,
"chatter.emailSetUp.remark":`Sta gebruikers toe om CCChat e-mails te ontvangen wanneer iemand je volgt, commentaar geeft op je post, en meer.`,
"label.accmarketsea.grouplist.title":`Account Pool Groep Instelling`,
"label.stdashbord.xsld.business.danwei":`Eenheid: 10 duizend`,
"label.app.step1.error.namenull":`U moet de naam van de openbare groep invoeren.`,
"label.login.button.verification":`Indienen om te verifiëren`,
"label_tabpage_newWizardz":`Nieuw toegevoegde functie wizard`,
"label.addattachment.step1.intruduce":`Voer het bestandspad in of klik op de knop om het bestand te vinden.`,
"pagecreator.layout.funcpath":`/ bouwer / lay-out bibliotheek`,
"fourth":`De Vierde`,
"label.timetrigger.after.lasttime":`Een dag later dan de laatste wijzigingsdatum.`,
"vue_label_report_showme":`Laat me zien.`,
"label.h5.similar.opportunity.end.date.in":`De einddatum valt binnen de volgende periode`,
"label.turntonextstep":`Ga naar de volgende stap`,
"label.icon.106":`Schema`,
"label.user.receivenewsbulletin":`Nieuwsuitzending ontvangen`,
"label.mask.card.number":`Kredietkaartnummer`,
"setup.object.layout.label.profileoptions":`Beschikbare profielen`,
"vue_label_systemSettings_obj":`Objecten en Velden`,
"label.call.center.history.open":`Automatisch openen van de oproep geschiedenis pagina`,
"label.attendance.cityname":`Voer de plaatsnaam in`,
"label.newemailnotice.tip":`Creëer een e-mail alert om te koppelen aan één of meer workflow regels of goedkeuringsprocessen. Bij het wijzigen van een e-mail alert, zullen alle wijzigingen van toepassing zijn op alle regels of goedkeuringen die eraan gekoppeld zijn.`,
"label.app.step1.error.labelnull":`Fout1aLabel kan niet leeg zijn.`,
"front-kefu-moudle-connect-free-account":`CloudCCgebruikers aan TRRT's Proefrekeningen koppelen`,
"label.biaoqingfaxian.description":`Als bid&tender discovery is ingeschakeld, kan een menu van bid&tender discovery worden toegevoegd aan de front-end, waar gebruikers bid-informatie van relevante industrieën kunnen bekijken en bid-gegevens kunnen omzetten in leads in het systeem.`,
"label.filter":`Filter`,
"label.data.downpage.e.title.num1":`1、Selecteer de objecten die u wilt exporteren, of kies om alles te exporteren.`,
"label.h5.similar.opportunity.last.months12":`Recente 9-12 Maanden`,
"label.chatter.name":`Naam`,
"vue_label_helpcenter_email":`1. Mail versturen<br> Het systeem verlaten om naar uw mailbox te gaan om met contactpersonen te communiceren is niet meer van deze tijd. Op Cloud CC kunt u uw persoonlijke e-mailadres koppelen om direct vanuit Cloud CC e-mails te versturen. Wanneer u het e-mailadres of de naam van de ontvanger invoert, kan deze uw contact- of leadrecord voor u matchen. U kunt ook e-mail records koppelen aan gerelateerde records die zijn geconfigureerd, en de e-mails die u verstuurt zullen worden gesynchroniseerd op de record detailpagina.<br> 2. 4 veelgebruikte functies bij het versturen van e-mails<br> Bij het versturen van een e-mail, kunt u de 4 functies onder de tekst van de e-mail gebruiken om u te helpen bij uw werk.<br>Mailtracking<br> Als u emailtracking inschakelt, helpen we u bij het bijhouden van het aantal keren dat deze e-mail is geopend en wanneer deze voor het laatst is geopend. U kunt uw muis boven het "oog" icoon in de outbox lijst houden om het te bekijken.<br>Upload Bijlage<br> Klik op Upload Bijlage, u kunt het bestand selecteren dat is geupload naar het systeem, of u kunt ervoor kiezen om het bestand te uploaden. U kunt meerdere bijlagen selecteren, zolang de grootte van de bijlage maar kleiner is dan 20M.<br>Voeg samengevoegde velden toe<br> Als de email is gekoppeld aan een object record, kunt u klikken om het samengevoegde veld in te voegen, selecteer het gekoppelde object, selecteer het veld dat u wilt invoegen, en voer de vervangende tekst in na de komma in het samengevoegde veld, zoals {!Contact.Voornaam,Meneer of Mevrouw }. Wanneer u de sjabloon opslaat, worden de samengevoegde velden weergegeven in de e-mailtekst van de sjabloon. Gebruik samengevoegde velden om e-mailinhoud te personaliseren. U kunt aan elk samengevoegd veld vervangende tekst toevoegen. De vervangende tekst wordt alleen getoond wanneer de samengevoegde record de gegevens van het veld niet bevat.<br>Bewerk en activeer handtekening<br> Wanneer u werk e-mails verstuurt, zal een handtekening die uw identiteit weergeeft, helpen uw werk professioneler te maken. Klik op de knop "Handtekening bewerken", u kunt de basisinformatie bewerken, en u kunt afbeeldingen invoegen. Als u "Handtekening inschakelen" aanvinkt, wordt uw handtekening telkens wanneer u een e-mail opstelt aan de hoofdtekst van het bericht toegevoegd. U kunt de handtekening op elk moment uitzetten.<br> 3. Filter de inbox<br> U kunt alle ongelezen mails in uw inbox filteren om uw werk te vergemakkelijken. Wanneer u bestanden via e-mail wilt downloaden, kunt u alle e-mails met bijlagen in uw inbox filteren, zodat u snel de e-mail kunt vinden die u nodig hebt. Bovendien kunt u snel de gegevens zien van klanten in het systeem die u volgt via e-mails door e-mails te screenen die openstaande zakelijke kansen bevatten of e-mails te screenen die zijn verzonden door leads of contactpersonen.<br> 4. Massamailing<br> Er is een knop voor groepmailing in de rechterbovenhoek van de lijst met leads en contacten. U kunt bulkmails sturen naar potentiële klanten of contactpersonen met e-mailadressen. Wanneer u een record van marketing activiteiten heeft, kunt u emails sturen naar leden van de marketing activiteiten in batches, wat ook handig is voor het versturen van uitnodigingen voor evenementen.`,
"front-kefu-moudle-auto-callphone":`Automatisch nieuwe cases aanmaken voor verbonden gesprekken`,
"label.fiscal.FQ":`Fiscaal Kwartaal`,
"label_tabpage_groupsVisiblez":`Sommige gebruikersgroepen zijn zichtbaar`,
"UG.product.01":`Lijst van producten/diensten`,
"vue_label_commonobjects_view_members":`Facultatieve leden`,
"label.organization.id":`Organisatie-ID`,
"label.tyle_preview":`Stijl Voorbeeld`,
"label.campaign.channel.input.to.owner":`6. Stel in of de eigenaars op de hoogte moeten worden gebracht wanneer leden van de campagne zich aanmelden`,
"label.appointmentconfirmpage.wizard.notif1":`De afspraak is geannuleerd!`,
"lable.tianyancha.maping":`Veld in kaart brengen`,
"front-kefu-moudle-v1-noadd-online-chats":`Online agent is niet toegevoegd`,
"vue_label_commonobjects_detail_group_strategy":`Ben je zeker dat je het klantenteam moet invoeren?`,
"vue_label_report_deletegrouprow":`Groep rij verwijderen`,
"lable.account.y.d":`Op deze pagina kunt u een aangepast fiscaal jaarrecord definiëren. De data voor het fiscale jaar worden gegenereerd op basis van de keuzes die u hieronder maakt.`,
"label.visualpage.lllegal.definitions":`Ongeldige definitie`,
"label.tabpage.enterrecordnamez":`Voer de eigenaar van het record in`,
"vue_label_report_howmuchlines":`{lengte} lijnen`,
"homepage.components.custom":`Aangepaste componenten`,
"label.campaign.channel.upload.img":`Afbeelding uploaden`,
"UG_Case_03":`Automatisch opwaarderen van de behuizing`,
"label.approved.receiveApprovalEmail.option4":`Nooit`,
"System.Data.Import.Warning.MaxCount":`Uw organisatie kan slechts {0} gegevens per keer importeren, dat is nu buiten de limiet, gelieve aan te passen en opnieuw te importeren.`,
"label.sent.sms":`stuurde een SMS`,
"vue_label_dashboard_statistictype":`Statistisch type`,
"label_report_last_year_same":`Zelfde periode vorig jaar`,
"lable.Examle":`Voorbeelden`,
"label.customerinfo.PageTriggerFagTitle":`Het duurt twee uur om te synchroniseren.`,
"label.mobile.phone.read":`Herzien`,
"label.product.gopage":`Ga naar pagina`,
"label.a_b_without":`"A-records kunnen al dan niet verwante B-records hebben.`,
"front-kefu-moudle-callin-missphone":`Oproepen in gemiste oproepen`,
"label.sso.saml.sp.idsource.attrname":`Attribuutnaam`,
"label.h5.chatter.colleagues2":`Collega's`,
"label.approveprocess":`Goedkeuringsprocedures`,
"label.dataimport.error.name.null":`Fout: naam is null`,
"label.paging.countitems":`{0}`,
"vue_label_report_notice_filter":`Wanneer geavanceerd filteren niet is ingeschakeld, zijn de verschillende filtervoorwaarden "en", d.w.z. dat records die voldoen aan de gemeenschappelijke kenmerken van 1 en 2 in het rapport worden weergegeven. Bijvoorbeeld: 1 is een zakelijke opportuniteit met een bedrag groter dan 1 miljoen, en 2 is een geschatte contractdatum gelijk aan deze maand, dus het rapportresultaat is meer dan 1 miljoen zakelijke opportuniteiten deze maand.`,
"front-lightning-module-v1-dashborad-export-picture":`Beeld exporteren`,
"label.activity.disabled":`Geen activiteit ingeschakeld, neem contact op met uw systeembeheerder om de activiteitsgeschiedenis en onverwerkte activiteiten op de paginalay-out in te schakelen.`,
"message_chooseatleastonefield":`Selecteer ten minste één veld om weer te geven.`,
"label.case.text":`Via de website ingediende formulieren voor serviceverzoeken kunnen zaakrecords in het systeem genereren. Selecteer de gebruiker als de maker van het dossier, en de geselecteerde gebruiker moet de toelating hebben om het dossier aan te maken. De webpagina is beschikbaar voor computers en mobiele telefoons.`,
"label.sendmail.step3.dealoption1":`BCC me op één bericht`,
"label.forecast.settings.title.remark":`De beste raming van de geraamde inkomsten voor de gebruiker, die een volledig zakelijk beeld voor gebruikers oplevert`,
"label.apply.youxiaotime.finish.opperation":`U heeft 5 minuten om de handelingen te voltooien. Negeer dit bericht als de handeling niet persoonlijk is.`,
"label.user":`Gebruiker`,
"pagecreator.page.button.copy":`Kopiëren`,
"label.userinfo.pwdupdate.or.reset":`Uw wachtwoord is voor het laatst gewijzigd of gereset op`,
"label.fieldupdata":`Veld updates`,
"label.sendemail.chat.followsubject":`CloudCC CCChat heeft iemand volgen`,
"component_task_label_enddate":`Verloopdatum`,
"label.campaign.channel.step6.remark5":`U kunt het opnieuw toewijzen via Lead Toewijzingsregels. Meer weten over Regels voor Leadtoewijzing?`,
"label.mr.title.mobilePhone":`Mobiel`,
"label.notice":`Herinnering`,
"message.serviceappo.time.violation":`Beschikbare tijd overschrijding van service afspraak: De afgesproken aanvangstijd van de serviceafspraak is later dan de vroegst beschikbare aanvangstijd.`,
"label.account":`Rekeningen`,
"front-kefu-moudle-callcenter-user":`Call Center gebruikers`,
"label.usermanage.query.notexist":`De opgevraagde gebruiker bestaat niet.`,
"label.forecast.userinfo.isnable":`Sta prognoses toe`,
"label_partner_workspace_member":`Lid`,
"vue_label_dashboard_penetrationsetting":`Penetratie Instelling`,
"chatter.fieldtrack.operatecreate":`creëerde een`,
"label_tabpage_tpcustomersz":`Converteer leads`,
"label.emailtocloudcc.redmessage6":`IMAP/SMTP-verificatie mislukt, controleer of het e-mailadres en het wachtwoord juist zijn.`,
"label.customfields.file.upload":`Upload`,
"label.forecast.isforecast":`Geen prognose ingeschakeld`,
"label_benchmark":`Referentie`,
"label.exchange.sync.state.system":`Systeem Sync Status`,
"UG.opportunity.003":`Volg uw verkoopkanalen, creëer dashboards`,
"label.campaign.matchway.select.error":`Om de gegevens bij te werken, selecteert u de overeenstemmingsmethode`,
"vue_label_dashboard_located":`Dashboard Map`,
"front-electronic-signature-enter-object":`Voer het object in`,
"vue_label_systemSettings_mobelquick":`Snelle installatie van mobiele toepassingen`,
"lable.outlook.list":`Exchange Sync Configuraties`,
"label.sendemail.approval.dlsp":`Hallo, #dlspr:#actorname#objapiname-#recordname ingediend door #actordate is ingesteld als uw proxy-goedkeurder door de oorspronkelijke goedkeurder #spr en wacht op uw goedkeuring. Klik op de link hieronder of log in op het crm-systeem om naar het goedkeuringscentrum te gaan voor goedkeuring:\n#url bedankt! \Achternaam`,
"label.service.deleteCustomView.wanttoremove.filter":`Weet je zeker dat je de "{naam}" filter wilt verwijderen?`,
"component_task_label_newevent":`Nieuwe taak`,
"vue_label_commonobjects_view_chart_groupby":`Groep door`,
"front-kefu-moudle-v1-edit-chats":`Agent bewerken`,
"pagecreator_page_message_delete_fail":`Verwijderen van pagina mislukt`,
"label.file.search":`Bestanden zoeken...`,
"label.projectManagement.Addpredecessors":`Pre-taak toevoegen`,
"label_tabpage_norecordtypez":`Onbruikbaar recordtype`,
"label.come.recycle.bin":`Ga naar de prullenbak`,
"label.reportsSubscriptionPage.schedulereport.monthly.time.relative":`Relatief`,
"label.customfields.address.tip":`Hiermee kan de gebruiker provincie, stad, provincie velden selecteren en specifieke adresgegevens invoeren die kunnen worden gebruikt om de lengte- en breedtegraad te berekenen.`,
"label.weixin.optioneight":`Keuze 8`,
"label.recordtypeselect.modify":`Wijzig Record Type`,
"label.forecast.settings.future3":`Toekomstige 3 cycli`,
"label.rename":`Hernoemen`,
"label.emailtocloudcc.button.complete":`Afwerking`,
"chatter.new.at":`Meest recente activiteit`,
"component.setup.label.milestonesfield":`Mijlpaal veld`,
"vue_label_commonobjects_detail_email_newaddress":`Stuur naar`,
"lable.PowerProcess.big.event":`Mijlpaal:`,
"label.appexchange.uninstallpage.confirm":`Ja, ik wil de installatie van dit pakket ongedaan maken en alle bijbehorende onderdelen definitief verwijderen.`,
"label_mobile_buttom_homepage":`Homepage`,
"label.sso.saml.idp.config.logouturl":`Enkelvoudige uitlog URL`,
"lable.quote.pdf.button.savetoquote":`Opslaan om te citeren`,
"label.page.select.application":`Selecteer de aangepaste apps waarin u de nieuwe aangepaste tabbladen wilt gebruiken. U kunt ook bekijken of wijzigen of een tabblad wordt weergegeven op de detailpagina en bewerkingspagina van elke aangepaste app.`,
"chatter.down":`Download`,
"label.tabpage.searchz":`Zoeken op`,
"label.emailsync.form.action":`Actie`,
"label.campaignmember.setup.campaignmember.field":`Velden van campagne leden`,
"label.version.remark":`Opmerking: Met de gratis versie kunnen slechts 5 gebruikers en 2000 records worden aangemaakt en kunt u geen gegevens importeren of exporteren.`,
"label.selectoperateobject":`Selecteer het object.`,
"label.appointmentdetail.wizard.title12":`Boek Tijd`,
"label.submitforapproval":`Ter goedkeuring voorleggen`,
"label.the.lower.bound.of.each.layer.of.editing.discount.must.be.equal.to.the.upper.bound.of.the.upper.level.":`De ondergrens voor het bewerken van elk niveau van korting is gelijk aan de bovengrens van het laatste niveau.`,
"label.appupload.install.component.view":`Uitzicht Componenten`,
"label.profile.customobjcontrol":`Aangepaste objectmachtigingen`,
"label.customfields.configprofilefieldsafety.tip":`Selecteer de profielen waaraan u via veldniveaubeveiliging bewerkingstoegang tot dit veld wilt verlenen. Het veld wordt verborgen voor alle profielen als u het niet toevoegt aan de beveiliging op veldniveau.`,
"label.service.gantt.service.resources":`Dienstmiddelen`,
"label.input.right.emailaddress":`Voer een ongeldig e-mailadres in.`,
"label.ccdocument.folder.notedit":`De map is niet bewerkbaar.`,
"label.data.choses.i.desc":`Importeer gegevens van een enkel object, afhankelijk van uw behoeften.`,
"label.icon.75":`Auto`,
"label.summaryreport.step4":`Stap 4 Kies de kolommen van het rapport`,
"label.appupload.upload.install":`Installeer`,
"label.reportlist.newfolder":`Nieuwe rapport map`,
"label.projectManagement.myproject":`Mijn Project`,
"label.true":`TRUE`,
"label.tabpage.reallproplez":`Record eigenaar`,
"label.change.lead.share.error":`Geen recht om klant te bewerken`,
"F":`Datum/Tijd`,
"lable.account.CurrentandNextCQ":`Huidige en volgende CQ`,
"UG.activity.06":`Wil je accounts opvolgen`,
"UG.contact.03":`Contacten volgen op één plaats, verkoopsignalen`,
"label.field.duplicate.error.msg2":`Instelling unieke eigenschap mislukt`,
"label.sales.dashboard.reality":`Werkelijke betalingen`,
"lable.PowerProcess.type":`Soorten processen voor het verkrijgen van rechten`,
"batch.selected.data":`Geselecteerde gegevens:`,
"#label.importsourcefilestep2":`Stap 2 Comprimeer uw bestand (Optioneel)#`,
"label.emailtemplate.select":`Kies het Email sjabloon dat u wilt gebruiken.`,
"chatter.most.w":`U kunt maximaal 500 tekens invoeren`,
"vue_label_calendar_new_object_calendar":`Nieuw object Kalender`,
"label.aggregated_formsdata":`Geaggregeerde formuliergegevens`,
"label.knowledge.language.french":`Frans`,
"label.customfields.enc.tip":`Hiermee kunnen gebruikers elke combinatie van letters en cijfers invoeren en gecodeerd opslaan. En ze kunnen niet worden doorzocht.`,
"label.icon.158":`Wolk`,
"font-evaluate-module-v1-bad-review ":`Wanneer het type evaluatie negatief is`,
"UG_quota_03":`Offerte template`,
"label.eidt.queue.label.hasused":`Het etiket is al in gebruik`,
"label.lookupfilter":`Zoek Filters`,
"label.callcenter.Instance.name":`Instantie Naam`,
"label.commitertype":`Type indiener`,
"vue_label_checkduplicate_any_one":`Ontmoet iemand`,
"label.campaign.channel.input.img":`Selecteer de afbeelding van uw lokale computer als dankpagina`,
"vue_label_dashboard_pleaseenterafoldername":`Voer een mapnaam in`,
"label.tianyancha.look":`Bekijk`,
"label.tabpage.lastone":`Kies ten minste één bewerking`,
"label.sendemail.approval.submit.title":`{!objLabel} - {!recordName} wacht op uw goedkeuring`,
"label.chat.topic.delete.prompt1":`Het verwijderen van een onderwerp kost tijd, het onderwerp zal bewaard blijven in berichten en records totdat het proces is voltooid.`,
"component_setup_label_displaybutton":`Weergaveknop`,
"label.partnerCloud.backgroundImage":`Achtergrondbeeld`,
"label.mobile.phone.time.range":`Tijd Bereik`,
"label.page.url.address.remark":`Voer het adres van de webpagina in het "Link URL" veld in. U kunt een eenvoudige URL invoeren zoals deze in de adresbalk van de browser verschijnt, of u kunt een of meer samenvoegvelden gebruiken om organisatiespecifieke gegevens van CloudCC.com in URL-parameters in te voegen. Sommige sites werken niet in een Web tab vanwege de beveiligingsinstellingen van de browser, of omdat de site zichzelf heeft verhinderd om in een frame te worden weergegeven.`,
"label.h5.copyemail":`E-mail is gekopieerd`,
"label.view.step3":`Stap 3 Selecteer de weer te geven velden`,
"label.quickbooks.view.moneyreceived":``,
"label.emailobject.attachment.preview":`Voorbeeld`,
"label.selectapprover":`Selecteer Goedkeurder`,
"vue_label_normal_opportunity_sf":`Opportunity`,
"label_emailtocloudcc_filed_port":`Haven`,
"mesage.errorinsaving":`Er is een fout opgetreden tijdens het opslaan. Neem contact op met uw beheerder.`,
"label.partnerCloud.partnerCloudName":`Voer de naam van de partnerwolk in`,
"lable.edit.queue.checkemail":`Fout: Ongeldig e-mailadres.`,
"label_builder":`Pagina bouwer`,
"component_setup_label_setupsavefail":`Het opslaan van de componentinstellingen is mislukt`,
"label.icon.76":`Auto`,
"label.reportsSubscriptionPage.schedulereport.monthly":`Maandelijks`,
"message.nopermession":`Geen Toestemming`,
"label.view.groupscansee":`Zichtbaar voor <b>bepaalde groepen gebruikers</b>`,
"label.leadscore.rule.new":`Lead Scoring Regel`,
"label.new.ccpeakfolder.time":`Geplande Klassen: Nieuwe map`,
"label.record":`Records`,
"message.error.flabel":`De veldlabels die u opgeeft kunnen geen Engelse enkele of dubbele aanhalingstekens bevatten.`,
"label.emailobject.emaildetail.promptbutton2":`Annuleren`,
"label.h5.phone":`Bel`,
"label.visualpage.error.deal.with":`Er is een fout opgetreden, neem contact op met uw beheerder`,
"label.button.step1.select.field":`Stap 1 Selecteer de velden`,
"label.setsharerule.step1":`Stap 1 Selecteer uw regeltype`,
"component.chatter.file.label.title":`Bestand uploaden`,
"front-epwechat-module-v1-appname":`App Naam`,
"chatter.error.notsel":`Fout: Selecteer een afbeelding om te uploaden.`,
"label.updatevalue":`Exacte waarde Veranderen van`,
"label.chatter.sendEmailToGroupMember.subject.D":`{0} documenten geplaatst voor iedereen in {1}`,
"label_tabpage_grid":`De rasterweergave`,
"homepage.components.standard":`Standaard onderdelen`,
"label.movable":`Activiteiten`,
"label.report.selected.field.cannot":`De geselecteerde velden mogen niet groter zijn dan 50.`,
"label.projectManagement.distribution.by.excess":`Toewijzen op overuren`,
"addrow":`Rij toevoegen`,
"label.approvaldatamove.p":`Gebruik de volgende opties om meerdere goedkeuringsverzoeken te beheren. Klik op "Zoeken" om goedkeuringsverzoeken te filteren. Wanneer de resultaten worden weergegeven in een lijstweergave, geef dan de actie op.`,
"label.passwordPolicy.setup.title":`Wachtwoordbeleid`,
"label.appointmentpage.wizard.title1":`{0} ({1}) nodigt u uit om`,
"label.tippage.li1":`Aangepaste rapportgegevensbron permanent verwijderen`,
"label.campagin.roi.dcl":`Aanwezigheidspercentage`,
"label.h5.new.errorbody":`Deze verplichte velden met * moeten worden ingevuld.`,
"label.cy.enable":`Valuta inschakelen`,
"label.currency.rate.e":`Bewerk de omrekeningskoersen voor de munteenheden van uw organisatie.`,
"or":`Of`,
"lable.custom.Previous.CYt":`Vorige 2 CY`,
"front-epwechat-module-v1-unbound-desc":`De binding opheffen zal de gebonden rekening opheffen. Weet u zeker dat u de binding wilt opheffen?`,
"pagecreator_button_publish":`Publiceren`,
"font-evaluate-module-v1-case-owners":`Informeer de eigenaar van de zaak:`,
"label.pw.new":`Voer een nieuw wachtwoord in`,
"message.tabsearch.nokeywords":`Voer een trefwoord in van ten minste één teken lang`,
"label.sendemail.send.erroruser":`Onjuiste gebruiker`,
"label.personalinfo":`Mijn persoonlijke informatie`,
"label.case":`Gevallen`,
"lable.product.pricebooks.now":`Bestaande prijsboeken`,
"label.ccpeak.take.notice":`Opmerking: ID, Autonummer, Aangemaakt door, Aangemaakt datum en andere systeemvelden hoeven geen waarden in te voeren.`,
"label.page.first":`De eerste pagina`,
"label.icon.168":`Vizieren`,
"label.choices":`Selecteer`,
"label.is.delete.document":`Weet u zeker dat u dit bestand wilt verwijderen?`,
"homepage.layout.custom":`Aangepaste indelingen`,
"label.emailobject.template.insert.field":`Velden`,
"label.ccpeak.folder.all":`Alle Klassenmappen`,
"front-console-conversation-btn3":`Email doorsturen`,
"label.ems.port":`Haven`,
"label.app.introduce":`Een app is een groep tabbladen die als een eenheid werken om functionaliteit te bieden. Gebruikers kunnen tussen apps schakelen met het uitklapmenu voor apps in de rechterbovenhoek van elke pagina.`,
"label.file.library.managemembers.admin":`Bibliotheekbeheerder`,
"vue_label_salesadvance_win":`Won`,
"label.email.click.complete.info":`Klik op de knop "voltooien" om terug te keren naar de vorige pagina.`,
"label.umeng.activity.event.willbegin":`Uw evenement #event begint in #tijd.`,
"label.mobile.phone.week.summary":`Wekelijkse samenvatting`,
"label.quickbooks.fieldlabel.terms":`Voorwaarden`,
"lable.currencyManage.advcurrencyEnabled.dis":`Hiermee kunt u gedateerde wisselkoersen beheren die een valutaomrekeningskoers toewijzen aan een specifiek datumbereik. Gedateerde wisselkoersen worden toegepast op valutavelden op opportunities, opportunity producten, en de rapporten die aan deze twee objecten zijn gekoppeld.`,
"label.weixin.data.save.failed":`Het niet opslaan van gegevens.`,
"label.service.gantt.filter.logic":`Filter logica:`,
"vue_label_pool_adopt":`verzamelen`,
"label.emailobject.markasunread":`Markeer als ongelezen`,
"label_please_select_a_member":`Selecteer alstublieft leden.`,
"label.salescloud.unit.ci":`Eenheid (Tijd)`,
"vue_label_pool_obsolete":`weggegooid`,
"label.cancelall":`Alles deselecteren`,
"label.exchange.sync.state.setting.m2":`Gebruikers in actieve CloudCC Exchange-configuraties:`,
"vue_label_pool_claimtime":`Claim tijd`,
"label.forecast.forehistory.history":`Voorspelling Geschiedenis`,
"label.knowledge.article.record":`Het kennisartikel is ongekwalificeerd.`,
"label.setting.intergrationlist.button.uninstall":`Integratie verwijderen`,
"label_tabpage_gotit":`Ik heb het.`,
"label.data.exp.csvform":`Alleen geldig voor geëxporteerde gegevens.`,
"UG.Forcast.06":`Selecteer de gebruikers die een voorspelling mogen doen`,
"vue_label_report_savereport":`Verslag opslaan`,
"setup.object.field.dependency.label.mustone":`U moet ten minste 1 waarde van het afhankelijke veld selecteren.`,
"label.batchadd.newbatchpage.des1":`Naam veld van de record is verplicht, en zo niet, dan wordt de record niet opgeslagen.`,
"lable.custom.CurrentandPreviousCYt":`Huidige en vorige 2 CY`,
"label.versiontype.Professional":`Professionele Editie`,
"label.customfields.configprofilefieldsafety":`Beveiliging op veldniveau instellen`,
"label.ccpeak.wgd.time":`Ongeplande Geplande Klassen`,
"component.telerecord.label.subject":`Thema`,
"label_year":`Jaar`,
"pagecreator_layout_label_modifylayout":`Lay-out editor`,
"label.compact.layout.frame.splitline":`Scheidingslijn van rechter scherm en linker scherm`,
"lable.PowerProcess.enter.the.process":`{describeName} Entry Process`,
"label.emailobject.cc":`Cc:`,
"front-electronic-export-choseCount":`Selecteer de geïmporteerde gegevens`,
"label.setup.mobile.bottombutton.recovery.default.success":`Met succes hersteld standaard? staat`,
"label.datamanage.import.accountfield":`Selecteer de velden in het importbestand die naar elke rekening moeten worden geïmporteerd uit de onderstaande lijst. Klik dan op "Volgende stap":`,
"vue_label_opportunity_related_list":`Toevoegen aan verwante lijst`,
"label.group.recent":`Onlangs bekeken groepen`,
"vue_label_pool_finalclaimtime":`Definitief claimtijdstip`,
"vue_label_homepage_30daysnocontact":`Zakenkansen zonder contact gedurende 30 dagen`,
"label.tianyancha.field.error":`Tianyancha data is niet gevonden, neem contact op met de systeembeheerder om de initialisatie uit te voeren`,
"label.product.go":`Ga naar Rapporten`,
"label.customsetting.manage.introduce":`Als de aangepaste instelling een lijst is, klikt u op Nieuw om een nieuwe set gegevens toe te voegen. Als uw toepassing bijvoorbeeld een instelling had voor Landcodes, zou elke set de Landnaam en de kiescode kunnen bevatten.`,
"label.task.dateadd":`Plus`,
"label.email.recipients.select":`Selecteer de ontvangers`,
"chatter.emailListMyChat":`Houdt van een post of een opmerking die ik maakte`,
"label.batchadd.newbatchpage.save.name":`Als de naam null is, zal het systeem dit record standaard niet toevoegen, controleer of de naam niet null is, en sla dan op.`,
"UG_Lead_011":`Maak een aanwijzing`,
"vue_label_salesfunnel_notice2":`Totaal Lopende Mogelijkheden`,
"APPIntegration_Social_linkedinerror":`U moet een geldige URL invoeren voor linkedin.com`,
"label.industrialandcommercialverification.enablestatus2":`Real-time Query Rekeningnaam`,
"label.stdashbord.xsld.business.ajssx":`Door Rol`,
"lable.info.queue.showalluser":`Bekijk alle gebruikers`,
"label.generatepage.c1":`Het moet beginnen met een letter. Het mag alleen hoofdletters, kleine letters, cijfers en underscore bevatten.`,
"label.thenset":`En dan volgens`,
"label.salescloud.salescloud.defaultteam":`Standaard groep van gebruikers`,
"label_partner_workspace_tab_selectedoption":`Geselecteerde tabbladen`,
"label.tippage.li":`Aangepaste rapportgegevensbron verwijderen：`,
"lable.quote.syncingfrom.syncingto":`Opportunity-producten zijn gesynchroniseerd met offerteregels`,
"label.emailobject.delete":`Delete`,
"label.data.selectimportobject":`Selecteer de te importeren objecten`,
"label.knowledge.language.dutch":`Nederlands`,
"message.campaign.page.overtime":`De pagina is verlopen.`,
"label.ccchat.message.search.desc4":`Controleer de spelling van de zoekwoorden.`,
"label.login.forgetPsd":`Wachtwoord vergeten`,
"vue_label_title_order":`Bestel`,
"template.report.contract.follow.status":`Followup stand van zaken contract`,
"label.forecast.edit.kjnd":`Fiscaal Jaar`,
"front-electronic-export-listTitle":`Mailchimp Lijst`,
"label.dataimport.error.khmc.notnull":`Fout: u moet de naam van de rekening invoeren`,
"label.testobject":`Testobject`,
"label_chatter_nextStep":`Volgende stap`,
"label.file.public.link.share":`Openbare links delen`,
"label.weixin.organization.name":`Organisatie Naam`,
"label.quote.email":`E-mail`,
"label.reg_field":`Gewoon veld`,
"font-evaluate-module-v1-response":`Antwoord na evaluatie:`,
"label.chatter.sendmail":`Stuur e-mail`,
"label.weixin.start.incorrect":`Ongeldig formaat van begindatum`,
"component_chatter_link_label_url":`Link url`,
"vue_label_pool_operatecertification1":`{0}{1}{2}`,
"lable.currencyManage.Enabledadvcurrency.agree":`Ja, ik wil Geavanceerd Valutabeheer inschakelen.`,
"label.east.africa.time":`Oost Afrikaanse Tijd`,
"label.product.proof.Three":`In {0}, kies een minimum van {1} product opties, maar maximaal {2}.`,
"label_emailtocloudcc_filed_password":`Wachtwoord`,
"component.task.label.person":`* Aangewezen persoon`,
"pagecreator_systemstyle_label_buttonareacolor":`Kleur werkgebied`,
"label.clearrule":`Duidelijke regels`,
"lable.customer.access":`Toestemming voor toegang tot account`,
"label.finish.wait":`Uw aanvraag is verwerkt, controleer a.u.b. de kennisgeving van voltooiing in uw mailbox.`,
"label.weixin.appr.auditor":`Goedkeurder`,
"label.tabpage.systemz":`Systeem(en)`,
"label.file.nocan.process.desc":`Kan verzoek niet verwerken. We kunnen levering van inhoud niet afhandelen`,
"label.relationobject.name":`Verwant object Naam`,
"setup.layout.group.relatedlist":`Verwante Lijsten`,
"label.generatepage.title":`Web naar CloudCC-pagina`,
"label.page.step3.input.url.information":`Stap 3 Vul de URL gegevens in`,
"label.change.to":`Verander de status van campagnemember in`,
"label.validate.function.funcFormat.TIMEVALUE":`TIJDVALUE(datum)`,
"label.partnerCloud.seriesSettings":`Product familie Setup`,
"component.timeline.label.1monthahead":`1 maand voor`,
"label.batchadd.senumberpage.selnum":`Selecteer het aantal records dat moet worden toegevoegd`,
"label.downloadapp":`BESCHIKBAAR OP`,
"label.dashboardSetup.showmainpage":`Weergegeven op Homepage`,
"label.h5.nophoneprompt":`De collega heeft het contactnummer niet ingevoerd`,
"label.service.deleteCustomView.wanttoremove.theFilter":`Wilt u het filter "{naam}" verwijderen?`,
"label.appupload.state1":`Geüpload`,
"component_timeline_button_filter":`Filter`,
"label.passwordPolicy.setup.subtitle":`Stel de wachtwoordbeperkingen en het beleid voor het blokkeren van aanmeldingen in voor alle gebruikers.`,
"vue_label_normal_quote_sf":`Quote`,
"label.productsales.today.noevttskaddall":`Er zijn geen openstaande gebeurtenissen en aflopende taken, u kunt op " " klikken in de rechterbovenhoek om een nieuwe gebeurtenis en taak toe te voegen.`,
"label.projectManagement.no.end.date":`Geen einddatum`,
"label.sendmail.batch.chosetemplate":`Massa e-mail: Kies een sjabloon`,
"serviceterritorymember.serviceresource.isactive.notactive":`Deze service resource is niet ingeschakeld. U kunt de service territories toewijzen aan een ingeschakelde service resource.`,
"label.notification.event.overlapEvent.continue":`Ga door`,
"label.appupload.component.type.obj":`Aangepast object`,
"label.partnerCloud.financeSetting.basicConfiguration":`Toegangspad: Openbaar Platform  Ontwikkeling  Basisconfiguratie`,
"lable.outlook.detail.info":`Exchange Sync Configuratie Details`,
"vue_label_commonobjects_detail_activity_commingevents":`Beschikbaar aankomend evenement`,
"coderules.nullvalue2":`Het genereren is mislukt. Voer de waarde in voor 【{0}】,【{1}】 die gebruikt wordt in de generatie regels.`,
"label.version.sum.workflowrule":`workflow regel(s)`,
"label.sso.saml.idp.config.enable":`Activeer Identity Provider`,
"label.temp.exp.conf":`Weet u zeker dat u het sjabloon wilt exporteren?`,
"label.department":`Afdeling`,
"label.trigger.operation.email.template":`Verkrijg Email sjabloon informatie`,
"label.page.content.frame.height":`Hoogte inhoudskader (pixels)`,
"label.ServiceCloud.jinengyaoqiu":`Vereiste vaardigheden`,
"PageLayout.Search.MultiSearch.001":`Selecteer maximaal 3 velden.`,
"label.error500":`Oeps! Fout...<br />Gelieve de beheerder te contracteren...`,
"label.appexchange.download.stop":`Stop de installatie met conflict`,
"label.service.dispatchingUnits.left.right.totalAll":`Momenteel {left}-{right} records, {totalCount} records in totaal.`,
"label.tabpage.haschangedz":`Deze aanwijzing is omgezet`,
"label.industrialandcommercialverification.button.cancel":`Annuleren`,
"label.edit.role":`Rol Bewerken`,
"label.mr.descreption.condition2":`Regels - op basis van de eerste tekens: voer een nummer in, zoek de duplicaten op basis van de eerste tekens van het ingevoerde nummer.`,
"label.testgrammer":`Syntaxis controleren`,
"label.age":`Leeftijd`,
"lable.real.time.chat":`Technische ondersteuning voor chatten in realtime wordt door Easemob geboden. Gelieve geavanceerde instellingen in Easmob te configureren.`,
"vue_label_opportunity_selected":`{\a6} geselecteerd`,
"label.weixin.optionone":`Keuze 1`,
"label.file.delete.public.link.desc":`Het verwijderen van de publieke link betekent dat niemand toegang kan krijgen tot het bestand met die url. Als je een nieuwe maakt, zal het een andere URL zijn.`,
"label_tabpage_cancel":`Annuleren`,
"template.report.opportunity.analysis":`Analyse van de opportuniteitsfase`,
"label.escalation.setup.newrule.inputrule":`Voer de regelnaam in`,
"label.ccpeak.getapi.name":`Haal de API-naam van het veld op bij het ophalen van de recordwaarde:`,
"second":`De Tweede`,
"label_tabpage_uploadsz":`Upload`,
"label.description":`Opmerkingen`,
"label.ccchat.person.invite.notsamepwd":`Inconsistent wachtwoord`,
"label.mobile.app.isEnableAblumWatermark":`Voeg watermerk toe aan foto's geselecteerd uit mobiele fotoalbums bij het inchecken`,
"vue_label_allsearch_searchable_items":`Doorzoekbare Items`,
"lable.outlook.detail.react":`Recente activiteiten`,
"label.sales.team":`Opportunity-team`,
"label.guif.standard.time":`Golf Standaard Tijd`,
"label.emailobject.emaildetail.button.forward":`Vooruit`,
"label.refused":`Afgewezen`,
"homepage.components.one":`Stap 1 Voer de naam van de aangepaste component in`,
"day":`Dag`,
"label.dataimport.error.number":`Fout: Nummer`,
"label.customer.tab.step2.same.option2":`Standaard Uit`,
"component_button_ok":`Bevestig`,
"label.allrecordmeetprocess":`Alle records moeten deze stap ingaan`,
"label.version.onefile.size":`Grootte van elke geüploade bijlage`,
"label.partnerCloud.orderingPlatform.allProducts":`Alle Producten`,
"pagecreator.page.message.publish.success":`Pagina succesvol gepubliceerd`,
"lable.currencyAdv.exchagecurrency.rate.pro":`Vorige reeks`,
"label.attendance.persons":`Geschikte gebruikers`,
"label.send.an.email":`Stuur een e-mail`,
"registration.page.browser.title":`Campagin Marketing Kanaal Registratie`,
"label.importfilestep3":`Stap 2 Selecteer en upload uw bestand(en)`,
"lable.currencyAdv.exchagecurrency.rate.next":`Volgende reeks`,
"label.ems.no.sync.msg":`U heeft nog geen mail synchronisatie informatie geconfigureerd.`,
"label.total_views":`Formulier Indienen Voorbeeld`,
"label.knowledge.article.notnull":`Kies tenminste één artikel.`,
"message.error.view.lastview.delete":`De laatste openbare lijstweergave kan niet worden verwijderd</br>U kunt de laatste openbare lijstweergave die zichtbaar is voor alle gebruikers niet verwijderen.<br><br>`,
"label.integrations.second.half":`stuk(ken) van gegevens, selecteer de geïmporteerde gegevens`,
"vue_label_systemSettings_mobelparams":`Mobiele app parameters instellen`,
"message.choose.maximum":`U kunt tot 150 records kiezen om te delen, nu`,
"vue_label_homepage_won&unprocessed":`Open Onbewerkt`,
"UG.contact.01":`Hoe haalt u het beste uit uw contacten?`,
"label.data.import.setup.remark":`De beheerder kan de regels instellen die bij het importeren van gegevens moeten worden uitgevoerd, waaronder het al dan niet uitvoeren van validatieregels, triggers en duplicatie- en matchingsregels.`,
"pagecreator_layout_message_delete_success":`Lay-out succesvol verwijderd`,
"lable.account.name":`Fiscaal Kwartaal Naam`,
"label.userinfo.must.updatepwd":`Voor de veiligheid moet u uw wachtwoord veranderen.`,
"label.mobile.phone.subordinate.setup":`Kan niet instellen om ondergeschikten te bevatten, selecteer ze allemaal en stel ze in om voorspellingen toe te staan.`,
"label.monitorsys.delete.date":`Verwijder Datum`,
"label_emailsync_form_emailaddress":`Email Adres`,
"label.projectManagement.cancelled":`Geannuleerd`,
"label.partnerCloud.partnerAccount.rechargeAmount":`Het herlaadbedrag moet tussen 0,1 en 100000000 liggen.`,
"label.select.relatedlist.approval.layout":`Selecteer gerelateerde lijsten om weer te geven op de goedkeuringspagina-indeling`,
"label.userphoto.thumbnail":`Thumbnail`,
"label.assignment.setup.list.rulename":`Regel Naam`,
"label.emailtemplate.usemergefields":`Velden samenvoegen in e-mail sjabloon`,
"label.tabpage.enabletomobile":`Of de mobiele-kant ingeschakeld moet worden`,
"setup_layout_label_desc":`Aflopend`,
"vue_label_pool_abandonreasondiscription":`Beschrijving van de reden van teruggooi`,
"label.ems.outputmails":`Verstuur e-mail server (smtp)`,
"font-evaluate-module-v1-evall":`Alle evaluaties`,
"front-epwechat-module-v1-unbound-tips":`De volgende gegevens zullen worden gewist na het opheffen van de binding:`,
"label.weixin.number.data":`Gegevens`,
"front-objectTemplate-V1-UseObject":`Toepasselijk object`,
"label.call.center.configuration":`Call Center Instellingen`,
"vue_label_systemSettings_website":`Webportaal van de klantendienst`,
"lable.currencyAdv.foreverdate":`Vaste Datum`,
"label.globalselect.view":`Keuzelijst waardeset bekijken`,
"component_newrecords_label_title":`Recente records`,
"component_assistant_label_title":`Assistent`,
"label.equals.deletebut.bulk.delete":`Inclusief verwijderknop, massaal verwijderen (naar prullenbak)`,
"label.field.duplicate.error.msg4":`Fout: Ongeldige gegevens.`,
"label.input.right.date":`Voer het geldige datumformaat in`,
"file.error.notsel":`Fout: selecteer het te uploaden bestand`,
"label.customcomponent.page.add.title":`Nieuw aangepast onderdeel`,
"message.chooseatleastthreefield":`Kies ten minste 3 velden`,
"label.dataimport.system.unnecessary":`kan het systeem niet verschillende`,
"message.login.wrong":`Onjuiste gebruikersnaam of wachtwoord.`,
"label.appupload.install.recheck":`Kijk nog eens.`,
"label.ems.option":`Optie`,
"label.wei.subject.img":`Onderwerp lcon`,
"chatter.emailReceiveOrNotAccept":`Selecteer deze optie om CCChat herinnering toe te staan, het deselecteren van deze optie voorkomt dat u ccchat herinnering ontvangt.`,
"label.icon.46":`Oven`,
"label.newpw":`Nieuw wachtwoord`,
"font-evaluate-module-v1-praise":`Het soort evaluatie is Positief`,
"label.help.user":`Gebruikershandleiding`,
"label.callcenter.no.searchs":`Geen relevante vraag naar de informatie`,
"UG_homepage_007":`Van het versturen van follow-up e-mails tot het automatiseren van verkoopcampagnes, van het creëren van workflows met behulp van onze Blueprint-technologie tot het triggeren van aangepaste macro's: automatiseer dagelijkse taken en richt u meer op het opbouwen van relaties.`,
"label.saveandnew":`Save`,
"component_salesperformance_label_70finish":`Afgewerkt - onverwerkt (>70%)`,
"lable.account.dp":`Op deze pagina kunt u aangepaste fiscale jaren definiëren.`,
"label.notification.serviceappointment.injeopardy":`{1}{0} is in kritieke toestand. Verwerk het zo snel mogelijk.`,
"label.workflow.edit.esimaterule":`Fout: u kunt de evaluatiecriteria niet wijzigen in "elke keer wanneer u een record aanmaakt of wijzigt" zolang u tijdstriggers aan deze regel hebt gekoppeld.`,
"label.partnerCloud.basicSetting.feature":`Functionele instellingen`,
"label.sms.companyname.gm.infor":`C.M.W.L.SMS Info (Deze dienst ondersteunt alleen het vasteland van China)`,
"vue_label_homepage_components":`Selecteer componenten`,
"label_chatter_allactivity":`Alle activiteiten`,
"label.quickcreate.title":`Snel lay-outs maken`,
"label.tabpage.exclusivez":`Exclusief`,
"front-service-cloud-transfer-desc":`Wanneer de BOMeigenaar van het activum wordt overgedragen, worden het huidige activum en de eigen activa onder het activum van eigenaar veranderd`,
"label.data.downpage.i.list.desc1":`Tijdens de import, gegevens die niet succesvol zijn geïmporteerd omdat de gegevens onjuist zijn geformatteerd, of omdat de trigger of validatieregel faalt, genereert het CSV-bestand dat op de huidige pagina moet worden weergegeven. De gegevens die met succes zijn geïmporteerd, worden niet op de huidige pagina weergegeven.`,
"template.report.individual.case.status":`Status gevallen`,
"label.report.export.file.format":`Formaat: Excel formaat .csv`,
"vue_label_filternotice1":`Dat wil zeggen, aan elke filtervoorwaarde wordt tegelijkertijd voldaan, bijvoorbeeld: 1 zakelijke opportuniteit met een bedrag groter dan 1 miljoen zakelijke opportuniteiten, 2 is een zakelijke opportuniteit met een geschatte contractdatum gelijk aan deze maand, en het screeningresultaat toont zakelijke opportuniteiten groter dan 1 miljoen deze maand; wanneer <span style="color: red">de geavanceerde filter is ingeschakeld</span> Wanneer u de voorwaarden handmatig moet filteren in het geavanceerde filtervak`,
"label.lead.score.confirm1":`Dit kan enkele minuten duren. U ontvangt een bevestigingsmail zodra het voltooid is.`,
"label.scores":`Scores`,
"label.dashboard.message.mainnoset":`Home dashboard is niet geconfigureerd`,
"label.customfields.optionlist.fieldvaluelist":`Voer waarden in, met elke waarde gescheiden door een nieuwe regel`,
"label.autosearch.title":`Automatisch titelonderzoek`,
"label.knowledge.setting.hint.seventeen":`Maak enkele artikelen`,
"label_tabpage_closez":`Sluiten`,
"label.partnerCloud.orderingPlatform.shoppingCart":`Winkelwagen`,
"label.recalculate":`Herberekenen`,
"label.umeng.approval.approvalmes4obj":`#numsucc records were approved in #obj, #numfailed reocrds were failed to approve.`,
"label.appointment.wizard.subtitle2-2":`Naar`,
"label.validate.function.funcExplain.AND":`Controleer of alle parameters waar zijn. Geef WAAR terug als alle parameters waar zijn.`,
"label.recordtype.batchaddattachments.remark":`Stap 1 Kies bestand, Stap 2 Archief, Stap 3 Klik op de "start upload" knop, bestanden uploaden, Stap 4 Klik op de knop om te eindigen.`,
"label.reportlist.findreport":`Zoek Rapporten`,
"label.partnerCloud.financeSetting.enterAppsecret":`Voer App Secret in`,
"label.campagin.roi.query2":`Bekijk Marketingkanalen ROI`,
"label.sendmail.notice.immediately":`E-mailmeldingen verzenden`,
"label.file.library.managemembers1":`Leden beheren`,
"label.forecast.customforecast.foredis.yclb":`Verwachting Categorie`,
"label.no.target.model.available.":`Geen beschikbaar indicator model. Maak eerst een indicatormodel aan, of neem contact op met de systeembeheerder.`,
"label.quote.contactname":`Naam contactpersoon`,
"label.customer.tab.step2.same":`Eén tabblad zichtbaarheid toepassen op alle profielen`,
"UG_product_03":`Multi-valuta ondersteunde prijs handleiding`,
"label.pc.system.prompt":`Systeem Prompt`,
"homepage.components.description":`Component Beschrijving`,
"front-email-payment-safety-code":`Veiligheidscode`,
"label.the.extra.reward.group.describes":`Aanhalingsteken toevoegen`,
"label.isEnableVisualpage.new.rightlist":`Actieve aangepaste pagina's`,
"label.icon.84":`Transformator`,
"label.chat.message.to":`Ontvanger`,
"lable.product.pricebooks.edit":`Prijs Boek Bewerken`,
"label.partner.workspace.member.belong":`Behoort tot`,
"pagecreator_systemstyle_message_delete_success":`Stijl succesvol verwijderd`,
"label.salescloud.teamrole.message.chooseatleastone":`Kies tenminste een gebruiker.`,
"label.knowledgebase.self.window":`Identiek venster`,
"label.product.cost":`Kostprijs`,
"label.imgfield.remove":`Duidelijke beelden`,
"label.event.lastweek":`Vorige week`,
"template.report.today.statistics":`Verkoop van vandaag`,
"label.emailobject.recipients":`Ontvangers({0})`,
"vue_label_commonobjects_view_successfully":`Stel de standaardweergave met succes in`,
"label.uploadfail.typeerror":`Uploaden mislukt, het bestandstype is ongeldig.`,
"vue_label_lead_required_fields":`Gelieve de verplichte velden in te vullen`,
"front-console-reopen":`Heropen`,
"message.layout.unique.relatedlist":`Ga terug naar de unieke beperkingen van de verwante lijst in de paginalayout, bevestig en sla opnieuw op.`,
"label.emailobject.emaildetail.nextactivity":`Volgende activiteiten`,
"label.publicgroup.save.error":`Fout: een van de volgende groepen is al de moedergroep van deze groep`,
"label.editdefaultshare.tip":`Bewerk hieronder de standaardwaarden voor delen voor de hele organisatie. Als u deze standaardwaarden wijzigt, moeten alle regels voor delen opnieuw worden berekend. Dit kan aanzienlijke systeembronnen en tijd vergen, afhankelijk van de hoeveelheid gegevens in uw organisatie.`,
"label.icon.53":`Auto`,
"label.exchange.sync.state.setting.m3":`Gebruikers met gekoppelde e-mailadressen van Microsoft Exchange en CloudCC:`,
"label.currency.enable":`Valuta's: Valuta inschakelen`,
"component.timeline.label.past":`Vroegere activiteiten`,
"workflow.action.tasks.assignortype.user":`Gebruiker`,
"setup_layout_label_relatedlistsetup":`Verwante lijst Instellingen`,
"label.systemadmin":`Systeembeheerder`,
"label_tabpage_allz":`Alle`,
"label.ems.subject":`Onderwerp`,
"message.recordtype.selectlayout.tip":`Selecteer de pagina-indeling die gebruikers met dit profiel te zien krijgen voor records met dit recordtype. Kies na het opslaan de keuzelijstwaarden die bij dit recordtype beschikbaar zijn.`,
"label.current.version":`Huidige programmaversie`,
"label.sourceoffile":`Untranslated - Produceert een reeks bestanden, per taal, met tekst die nog niet vertaald is`,
"label.file.versionerror":`Gebruik het tabblad bestandsfunctie in de nieuwe versie van de interface`,
"label.validate.function.funcExplain.MINUTE":`Geef minuut van dag terug (Van datum/tijd-velden)`,
"abel.setup.mobile.bottombutton.profile.setting":`Onderste menu van profiel aanpassen`,
"label.recycle.dis.tip3":`Selecteer Mijn prullenbak in de vervolgkeuzelijst om de items te bekijken die u hebt verwijderd. De beheerder kan All Recycle Bin selecteren om alle organisatiegegevens te bekijken die zijn verwijderd.`,
"message.selectnothing":`Geen Geselecteerd`,
"label.develop":`Ontwikkelen`,
"label.tab.lightningpage":`bliksem versie pagina`,
"label.chat.micropost.share.info":`Deel`,
"label.block.pricing.editor":`Editor blokprijzen`,
"label.ccchat.file.unavailable":`Dit bestand is niet beschikbaar`,
"label_component_helper_businesschange_0UntreatActivity":`Kansen zonder onverwerkte activiteit`,
"label.search.setup.obj":`Kan maximaal 100 objecten instellen.`,
"component.setup.button.cancel":`Annuleren`,
"message.longtextareamaxlength":`Lengte niet meer dan 32.000 tekens`,
"vue_label_chat_removedby":`U bent verwijderd uit de groepschat door de "Beheerder"`,
"label.autoRegister.changepwd.setpwd.tip.morechar":`Kan niet minder zijn dan 8 tekens`,
"label.informassigner":`Informeer de toegewezen persoon`,
"font-evaluate-module-v1-not-received":`Nooit een tevredenheidsbeoordeling van contacten ontvangen`,
"label.trigger.triggertime":`Triggertijd`,
"label.attendance.cannot.make":`Niet in staat om te markeren`,
"label.shouldallrecords":`Alle records moeten in de berekening worden opgenomen`,
"label.eidt.queue.alter1":`Selecteer de leden van de rij`,
"L":`Keuzelijst`,
"label_emailtocloudcc_filed_email":`E-mail`,
"label.productsales.contract.badversion":`Uw huidige editie ondersteunt het bekijken van contractobjecten niet, dus u kunt geen contractbedragen bekijken.`,
"label.tabpage.operation":`Operatie`,
"label.file.copy.public.link":`De publieke link is gekopieerd`,
"label.all.SMS":`ALLE SMS-Alerts`,
"UG_opportunity_008":`Opportunity-team`,
"UG.Campaign.002":`Plannen, uitvoeren en controleren van de doeltreffendheid van de marktactiviteiten.`,
"label.jiandangfenpei.title":`Profiel Opdracht`,
"pagecreator.systemstyle.message.delete":`Verwijdert u de huidige geselecteerde stijl?`,
"lable.outlook.mcto.repeat":`Als er dubbele records worden gevonden, wordt de e-mail geassocieerd met de`,
"label.user.field":`Gebruikersvelden`,
"vue_label_commonobjects_detail_market_hierarchy":`Markthiërarchie`,
"label.ems.emails":`E-mails`,
"label.tabpage.deleteviewfailed":`Weergave verwijderen mislukt`,
"label.data.exp.new.expobjtemp":`Maak het object geëxporteerd sjabloon`,
"label.useformulassetval":`Formules gebruiken om nieuwe waarden in te stellen`,
"label.service.newBuildDialog.six.fields":`Er kunnen maximaal 6 velden worden geselecteerd.`,
"error":`Fout`,
"template.chart.sdyyfx":`Verloren reden analyse`,
"label.icon.191":`Snor`,
"label.app.step3.tabused":`Geselecteerde tabbladen`,
"label.user.level":`Gebruikersniveau`,
"label.custombutton.querydata.notexist":`De gegevens bestaan niet.`,
"label.executestate.calculating":`Berekenen...`,
"label.visualpage.folder.notdel2":`1.Deze map bevat bestanden en kan niet worden verwijderd.2.Deze map bevat verborgen bestanden en kan niet worden verwijderd. Een verborgen bestand wordt bevrijd van een logisch verwijderobject (verwijderen uit Setup-Create-Obkects), dat iis verborgen omdat het object niet daadwerkelijk wordt verwijderd.`,
"vue_label_report_conditiondesc_three":`U krijgt bericht als aan alle voorwaarden is voldaan`,
"approval.request.email.subect":`Verzoek om goedkeuring`,
"label.log.user.value":`Voer je gebruikersnaam in om te zoeken!`,
"label.isCompanyCurrency":`Bedrijf`,
"label.related.2018":`Verwante Lijsten`,
"label.tonga.time":`Tonga Tijd`,
"message.actionfailed":`Actie mislukt`,
"label.’s":`'s`,
"label.custombutton.queryobj.notnull":`Het object ID van de query kan niet null zijn.`,
"label.list.userinterface.setup":`Gebruikersinterface`,
"front-kefu-moudle-v1-yxgsbzq-reinput":`Het email formaat is onjuist. Gelieve opnieuw in te voeren`,
"label.chatter.content":`Inhoud`,
"label.projectManagement.Addnotes":`Opmerkingen toevoegen`,
"label.service.newBuildDialog.reservation":`Bestelde tonen`,
"label.ccchat.pm":`PM`,
"vue_label_chat_cannot_invite_users":`Niet-groepshouders kunnen geen gebruikers uitnodigen om deel te nemen aan groepschats`,
"label_partner_workspace_member_belong":`Behoort tot`,
"label.task.modify":`Taak bewerken`,
"label.tabpage.transformationsz":`Converteren`,
"label.new.password.no.indexof":`Het nieuwe wachtwoord mag geen Chinese tekens en spaties bevatten.`,
"label.ji.quarter":`Nee. {a}Kwartier`,
"label.sso.isActiveNo":`Geen`,
"label.mobile.phone.week.report":`Wekelijkse werkaantekeningen`,
"label.email.template.please.select.folder":`Kies een map`,
"label.pc.ui.2018.tab.groups":`Menugroep`,
"label.h5.approval.status":`Goedkeuringsstatus`,
"setup.mainpage.label.welcome27":`Het CloudCC-cloudplatform biedt functies zoals importeren, exporteren, batchgewijs wissen en batchgewijze overdracht van alle objectgegevens in het systeem.`,
"vue_label_systemSettings_setHomePage":`Setup Home`,
"label.select.button":`Beschikbare knoppen`,
"label_emailsync_status_enable":`Actief verbinden`,
"label.trigger.triggerVersion.detail":`Dit veld kan niet worden bewerkt. Er zijn momenteel twee versies van triggers, 1.0 en 2.0, en alle nieuwe triggers zijn 2.0, versie 1.0 is verbannen voor het maken van.`,
"pagecreator_layout_message_save_fail":`Opslaan lay-out mislukt`,
"label.salescloud.salesdashboard.10big":`Top 10 Kansen in de komende 3 maanden`,
"label.file.share.size":`De maximale share en publiclink van elk bestand is`,
"label.page.simple":`Eenvoudig`,
"pagecreator.page.message.delete":`Verwijdert u de huidige geselecteerde pagina?`,
"label.weixin.newspaper.coverage.detailinfo":`Detailinformatie risicoblad`,
"label.list.userinterface.chattersetup":`CCChat-instellingen`,
"lable.opppdt.addpdt.table.quantity":`Hoeveelheid`,
"label.product.description":`Product Beschrijving`,
"button_partner_back":`Terug`,
"label.user.current.loginuser.sessionid":`De SessionID van de huidige ingelogde gebruiker is:`,
"label.otherreport":`Andere verslagen`,
"pagecreator_button_mobilepage":`Mobiele kant`,
"label.mobile.phone.state":`Status`,
"lable.currencyManage.unenableCurrencyAdv":`Schakel geavanceerd valutabeheer uit.`,
"lable.product.addp":`Prijs toevoegen`,
"label.field.validate.notpass":`Geen syntaxis fouten.`,
"label.app.global.search.obj":`U kunt maximaal 10 objecten instellen voor gebruik bij globaal zoeken.`,
"label.group.archived":`Archief`,
"vue_label_approve_to_submit":`Om in te dienen`,
"showfrom":`Toon van`,
"chatter.emailNotification":`E-mail berichten`,
"label.callcenter.pleaseenter.enterprise.number":`Voer het ondernemingsnummer in.`,
"label.forecast.customforecast.forecastnumber":`Prognose Getallen`,
"label.vlidaterule.messagelocation":`Foutlocatie`,
"label.h5.similar.opportunity.step3.conment":`De kolom Relevantie, die het aantal overeenkomende velden weergeeft, wordt altijd weergegeven.`,
"label.ccchat.group.gd.setting.info":`CCChat-groepsinstellingen wijzigen`,
"label.knowledgebase.delete.article.succeeded":`Succesvol artikel verwijderen`,
"message.layout.edit":`Het beheer van de paginaopmaak is een afzonderlijke functie met toegevoegde waarde. Als uw organisatie bevestigt dat het de functiemodule heeft aangeschaft, vraag dan de systeembeheerder om het wachtwoord. Neem contact op met CloudCC.com voor meer informatie.`,
"label.case.create":`Geval ({0}) wordt gecreëerd`,
"label.icon.170":`Winkelen`,
"message.error.contact.null":`Contact kan niet leeg zijn`,
"label.appupload.install.error.hasinstalled":`Dit softwarepakket is reeds geïnstalleerd in uw organisatie. alvorens de nieuwe versie te installeren, dient u eerst de geïnstalleerde versie te verwijderen.`,
"label.service.miniProgram.imageType":`PNG, JPG en JPEG formaat worden ondersteund. Afbeeldingen van 750*349 pixels worden aanbevolen. Beweeg de muis over de foto om opnieuw te uploaden of te verwijderen.`,
"label.leadscore.rule.edit":`Leads Scoren Regel: Regel bewerken`,
"vue_label_commonobject_anytime":`Anytime`,
"label.clearing.conditions":`Duidelijke voorwaarden`,
"label.campagin.roi.ydkhjhze":`Totaal aantal gewonnen klantenkansen`,
"Lead_Auto_Scoring_Setting_001":`Automatisch scoren bij bewerken of opslaan (behalve de leads die batchgewijs zijn geïmporteerd of aangemaakt door de interface)`,
"pagecreator.systemstyle.label.buttonareacolor":`Kleur werkgebied`,
"label.batchregist.huanxinuser.finish":`De massale aanmelding van gebruikers is voltooid`,
"UG_opportunity_006":`Opportuniteitsgenie`,
"message.serviceappo.violation":`Overtreding van de toewijzingsperiode: het is in strijd met een andere dienstafspraak.`,
"label.recordtypeselect.selectnew":`Selecteer nieuw recordtype`,
"Lead.Tools.BatchScoring":`Lead Batch Scoring`,
"label.partnerCloud.financeSetting.enterWechat":`Voer alstublieft WeChat merchant account in.`,
"label.philippine.time":`Filipijnen Tijd`,
"five":`Vijf`,
"label_average_value":`AVERAGE`,
"message.realdelete":`Ben je zeker?`,
"label.currency.note":`Voer informatie in voor de nieuwe valuta. Merk op dat u een valuta niet kunt verwijderen zodra u deze hebt geactiveerd.`,
"label.projectManagement.delete.prompt":`Delete Prompt`,
"label.approval.present":`(Actueel)`,
"label.escalation.setup.newrule.name":`Regel Naam`,
"label.edit.list":`Bewerkbare gegevenslijst`,
"label.partnerCloud.financeSetting.informationOne":`1. Bezoek Alipay merchant center (b.alipay.com) en log in met Alipay abonnee.`,
"label.customfields.numberText":`2.De som van de lengte van het ingevoerde getal en het aantal decimalen mag niet meer dan 18 bedragen.`,
"label.biaoqing.businessverify.relation.tip":`Schrijft de geretourneerde waarde van bid&tender op het leadveld`,
"label.icon.149":`Robot`,
"System.btn.SaveAndCommit":`Opslaan en verzenden`,
"label.calendar.many":`Multi Gebruiker`,
"label.ccchat.create.email":`De email is aangemaakt`,
"template.report.income.marketing.activities":`Verslag van de campagneinkomsten`,
"label.ccchat.person.invite.needemail":`Voer een e-mail adres in.`,
"template.report.open.amount":`Niet afgesloten bedrag`,
"label.currentoperate":`Geselecteerde acties`,
"label.finalapprove":`Definitief Goedkeuren`,
"label.emailmerge.mergepage.step2":`2. Selecteer het sjabloon voor de samenvoeging, maximaal 20:`,
"label_tabpage_sorttypez":`Soort sorteren`,
"label.workbanch":`Mijn Werkbank`,
"font-evaluate-module-v1-disable":`Weet je zeker dat je dit moet deactiveren?`,
"label.ServiceCloud.distributionMap":`Distributiekaart`,
"lable.Confirm.potential.customers":`Bevestig om {num} leads te verzamelen.`,
"label.mobile.quickcreate.default.nearby":`Dichtbij`,
"label.isremider.noremider":`Geen Herinnering`,
"label.approval.select.step":`Kies welke goedkeuringsstap terug moet`,
"chatter.error.pm":`Fout: Bestandsgrootte is te groot.`,
"UG_activity_08":`Reserveer een rooster`,
"label.marketsea.notwinopportunitydays":`Aantal dagen zonder een deal (moet groter zijn dan het aantal dagen zonder een zakelijke kans te creëren)`,
"label.selectpage":`Selecteer een bestaande pagina`,
"label.dashboard.dispalyOnTheHomePage":`Onthulde Homepage`,
"front-lightning-module-v1-details-page-chart-set-report":`Rapport opstellen`,
"vue_label_pool_mydeal":`Mijn deal`,
"vue_label_report_lastone":`De laatste.`,
"label.tabpage.potentialcustomersz":`Leads`,
"font-evaluate-module-v1-more-satisfied":`We zijn niet goed genoeg! We zullen u de volgende keer meer tevreden stellen!`,
"label.trigger.instructions":`<p>Instructies voor gebruik：</p><p><li>Parameters kunnen direct worden aangehaald:(DataContext)context,(UserInfo)userInfo,(Map)record_old,(Map)record_new</li><li>Wanneer u de waarde van een record wilt ophalen, gebruik dan direct "get", de API-naam van het veld</li><li>Als u een nieuwe record wilt aanmaken, gebruik dan "String id = IDGenerator.generateID("ID Prefix")"</li><li>Als u een foutmelding wilt ontvangen, gebruik dan "trigger.addErrorMessage("")";trigger zal terugkeren naar de huidige regel, niet langer naar beneden uitvoeren！</li></p><font color="red">Note:Maximum ondersteuning 200KB karakters, ongeveer 200.000 bytes.</font><font size=3 color="red">【Key：Moet notities toevoegen!】</font>`,
"lable.SalesCommitmentKanBan.commitmentToCompletionRate":`Uitvoeringspercentage van de verbintenis`,
"label.umeng.approval.dlsp.approvenew":`Gedelegeerde goedkeuring: #actorname vraagt goedkeuring #objapiname#recordname`,
"label.edit.visualpagefolder":`Aangepaste pagina : Map bewerken`,
"label.pc.flash.teach":`Video-onderwijs`,
"label.showsearch":`Toon Zoeken`,
"label.reportsSubscriptionPage.condition.title1":`U krijgt bericht als aan alle voorwaarden is voldaan (EN)`,
"label.h5.search.result":`Graaf`,
"vue_label_commonobjects_view_chart_pie":`Cirkeldiagram`,
"label_please_enter_currency":`Voer de valuta in`,
"chatter.share.to.profile":`Uw profiel`,
"label.mykeeptouchset":`Mijn Keep In Touch-instellingen`,
"label.profile.mustcopyaprofile":`U moet een bestaand profiel selecteren om van te klonen.`,
"label.managereport":`Rapporten beheren`,
"label.total.choice":`bestanden, geselecteerde`,
"label_emailtocloudcc_help":`Voer het juiste e-mailwachtwoord of de juiste autorisatiecode in. Als uw e-mail server de IMAP/SMTP service moet inschakelen om in te loggen met een account van derden, moet u eerst inloggen in de instellingen van uw e-mail account om de service in te schakelen, en de juiste autorisatiecode kopiëren naar dit wachtwoord invoerveld.`,
"label.trigger.sel":`Triggers in deze map`,
"label.dashboardLookUp":`Dashboards bekijken`,
"label.batchadd.newbatchpage.save.emptytext":`Gelieve te controleren of er verplichte informatie niet is ingevuld.`,
"setup.mainpage.label.welcome16":`Instructies: Klik op het menu aan de linkerkant van de pagina → Applicatie-instellingen → Aanmaken → Workflow, Goedkeuringsproces, Taken, E-mailnotificatie, Veldupdate, en meer.`,
"vue_label_email_mark as":`Markeer als`,
"label.customobjdel.cannot.delete.try":`Het object kan niet worden verwijderd omdat het verbonden is met de volgende relatie van andere objecten.`,
"label.customsetting.visible.public":`Publiek`,
"label.log.bit":`Bits`,
"label.data.exportall.all.desc":`Exporteert alle gegevens voor alle objecten die de huidige gebruiker mag bekijken.`,
"message.login.mfadevice.already.bound":`De gebruiker heeft het MFA-apparaat al gebonden.`,
"label.campaign.channel.please.img":`Upload de afbeelding`,
"assetbom.manage.notpermission":`Neem contact op met uw beheerder om toegang te krijgen tot het beheer van de BOM.`,
"schedstarttime.schedendtime.time.illegal":`De geplande begintijd van de serviceafspraak moet kleiner zijn dan of gelijk aan de werkelijke eindtijd.`,
"label.referperson":`Eigenaar`,
"front-email-payment-area":`District`,
"label.c.d.least":`Elke "C"-plaat moet minstens één verwante "D"-plaat hebben.`,
"label.weixin.longitude.isnull":`Lengtegraad en breedtegraad zijn leeg of ongeldig`,
"setup.layout.button.ok":`Bevestig`,
"vue_label_fiter_component_date_customdate":`Aangepaste datum`,
"label.enable.case.createarticle":`Sta gebruikers toe om artikelen te maken van cases.`,
"label.event.moveup.8hour":`8 uur vooruit`,
"label.input.most.string":`Voer alstublieft maximaal {0} tekens in`,
"lable.SalesCommitmentKanBan.contractEndDate":`Einddatum contract`,
"label.visualpage.function.name":`Noem de functie:`,
"label_emailtocloudcc_redmessage1":`Ongeldig e-mailadres`,
"message.aliasnameinput":`Fout: De naam moet uniek zijn, en beginnen met een letter. Hij mag alleen letters en cijfers bevatten.`,
"label.data.exp.selectedtemp":`Selecteer het sjabloon dat wordt gebruikt voor de gegevensexport`,
"label.import.page1.suitedwayoflinkman":`Contact passende stijl`,
"label.customsetting":`Aangepaste instellingen`,
"label.versiontype.Free":`Gratis plan`,
"setup.layout.label.norelatedlist":`Geen gerelateerde lijsten`,
"label.forecast.edittotal.de.leiji":`Rollup van`,
"label.customfields.file.max":`Het geuploade bestand is te groot, gelieve niet groter te zijn dan 5m`,
"label_partner_all_workspace":`Werkruimte`,
"label.searchrelation":`Opzoeking Relatie`,
"label.icon.185":`Advies`,
"label.service.gantt.effective":`Geldig`,
"label.newreportstp1":`Stap 1 Selecteer tabelformaat`,
"label.category.9":`Productie`,
"label.zuowei":`Zoals`,
"front-quotation-v1-select-quota":`Selecteer Citaat`,
"label.dashboard.refresh":`Vernieuwen`,
"label.weixin.saveandnew.log":`Save`,
"label.report.list":`Verslag Lijsten`,
"FL":`Bestand`,
"label.h5.followingcolleagues":`Collega's vallen`,
"template.report.conversions.number":`Aantal Leads Conversies (Per eigenaar)`,
"label.validate.function.funcFormat.MONTH":`MAAND(datum)`,
"front-kefu-moudle-v1-tenant-ID":`ID huurder`,
"label.reportsSubscriptionPage.schedulereport.monthly.time":`Tijd`,
"label.multilang.workflow.everyotherday":`Elke {0} dagen`,
"label.chat.message.send.message":`Stuur informatie`,
"label.knowledgebase.fast.operation.error":`Snelwerkende Fout`,
"label.multilang.dupicatecheck.dumplicatedata":`In de {0} records zijn in totaal {1} groepen van gedupliceerde gegevens gevonden die aan de voorwaarde voldoen, en de query duurde {2} milliseconden. Elke pagina toont {3} groepen van gegevens.`,
"vue_label_report_addFile_detail_Information":`Exporteer alleen 2000 rijen met details. Gebruik deze gegevens voor extra berekeningen, of upload ze naar andere systemen.`,
"label.ccchat.message.search.desc3":`Zoektips`,
"message.deletereport.prompt":`Kan dit rapport niet verwijderen`,
"pagecreator.page.message.save.success":`Pagina succesvol opgeslagen`,
"vue_label_rise":`Ascend`,
"label.appupload.install.error.choicehead":`Wat te doen als de bestaande componenten in het systeem conflicteren met de te installeren componenten?`,
"message.dispatch.violation":`Overtreding van de opdrachtperiode: de opdrachtperiode valt niet binnen de werktijd van de middelen.`,
"label.tool":`Gereedschap`,
"label.sso.saml.idp.downloadcert":`Download Certificaat`,
"label.chatter.detailinfo":`Gedetailleerde informatie`,
"label.area.tree":`Territories Hierachy Tree View`,
"label.partnerCloud.priceOfManual.notEnabled":`Niet activeren`,
"label.chosesubject.call":`Bel`,
"label.leadscore.rule.detail":`Leads Scoren: Regel Detail`,
"front-welcome-to-try":`Verwelkom het proces`,
"label.umeng.activity.event.willbegin1":`Event #event start in #time.`,
"component.event.label.noevent":`Het lijkt erop dat je je werk vandaag hebt afgemaakt.`,
"label.document.templatesetof.folder":`Sjabloon set van map`,
"label.quickbooks.none":`Geen resultaten gevonden, voer een naam in om te zoeken of maak een nieuwe klant aan`,
"label.assignment.setup.newrule.inputrule":`Voer de naam van de toewijzingsregel in`,
"label.appointmentdetail.wizard.title4":`Bedrijfsnaam`,
"label.malaysia.time":`Maleisië Tijd`,
"label.partnerCloud.partnerAccount.way":`Aanvullingsmethode`,
"label.roleoflinkman":` Contact Rol`,
"mesage.error.role.delate.user":`De rol kan niet worden verwijderd omdat hij de gebruikers heeft toegewezen.`,
"chatter.warning":`Waarschuwing: Indien u een ander object selecteert, zullen uw wijzigingen niet bewaard worden. Weet u zeker dat u dit wilt doen?`,
"label.service.gantt.violations.sum":`Dienstafspraken met overtredingen`,
"label.permission.objectpermission.recordfenpei1":`Toegewezen recordtypes`,
"label.mobile.phone.required.plan":`Plan is vereist`,
"label.after_leaving":`Huidige gegevens worden niet opgeslagen na het verlaten van`,
"label.cpq.opportunity.mainquote.trasnfer.order":`Er is een primaire prijsopgave gedaan onder de kans en overgedragen aan de orde.`,
"component.setup.iframe.label.title":`Pagina aanpassen`,
"visit.dispatchplatform.nopermission":`Toestemming geweigerd: U hebt geen toegang tot de dispatch console. Neem contact op met de beheerder.`,
"label.validate.function.funcExplain.RIGHT":`Geeft als resultaat het opgegeven aantal tekens vanaf het einde van een tekst`,
"component.chatter.link.button.save":`Publiceren`,
"label.knowledge.selection":`Elke Knowledge heeft maximaal 8 gegevensgroepen die kunnen worden geselecteerd.`,
"chatter.email.homePage":`Stuur me een bericht op mijn CCChat homepage`,
"vue_label_commonobjects_view_copy_view":`Kopieer uitzicht`,
"label.documentmessage":`Document Details`,
"label.emailtocloudcc.step1":`Stap 1`,
"label.user.mfa.unbind":`Ontkoppel de MFA voor de geselecteerde gebruikers`,
"label.stdashbord.xsld.business.sdzje":`Totaal Bedrag (Gesloten-Verloren Opportuniteiten)`,
"vue.please.select.the.total.method":`Selecteer sommatie manier.`,
"label.stdashbord.xsld.business.img1":`Aantal fasen met een waarschijnlijkheid van 1%  99%`,
"label.reportsSubscriptionPage.condition.title":`Naast het abonneren kunt u voorwaarden instellen voor dit rapport. U krijgt dan een melding wanneer aan de voorwaarden is voldaan. Dit is optioneel.`,
"chatter.sel.field":`Fout: Er zijn meer dan 20 velden geselecteerd.`,
"label.login.access.year":`Jaar`,
"label.dashboard.all":`Alle dashboards`,
"label.approver":`Goedkeurder`,
"Lead.Homepage.Tools.BatchScoring":`Partij score`,
"lable.opppdt.selPdt.lesscondtions":`Minder filters`,
"label.integrations.action.export":`Exporteren`,
"label.datamanage.lookupandsure":`(Bekijk en bevestig)`,
"label.email.attach.to.mail":`Bijvoegen bij e-mail`,
"message.nodataordeleted":`Gegevens bestaan niet of zijn gewist`,
"component_newrecords_label_all":`Bekijk alle`,
"lable.currencyAdv.startdate.rate":`Toon alle tarieven gedefinieerd voor de startdatum in het volgende bereik`,
"label.callbackoperate":`Terugroepacties`,
"label.knowledge.setting.hint.eighteen":`Begin een artikel te maken voor de kennis`,
"label.user.step4.submit.email":`Stap 4 Uw e-mailverzoek is ingediend`,
"label.appointment.wizard.subtitle4-1":`Reistijd tussen evenementen`,
"component.assistant.button.newtask":`Nieuwe taak`,
"label.icon.129":`Kaart`,
"label.relatedlist":`verwante lijsten`,
"label.report.recently":`Onlangs bekeken`,
"label.batchadd":`Massa toevoegen`,
"front-template-V1-Delete-succeeded":`"{currentTelmplateName}" is met succes verwijderd`,
"label.appupload.upload.otherdetail":`Extra details`,
"label.emailobject.link":`Link:`,
"label.quickbooks.createcustomer":`Klant aanmaken in QuickBooks`,
"report.label.projectcount":`items, sorteren op rapportnaam`,
"vue_label_normal_contact_sf":`Neem contact op met`,
"chatter.group.groupActivities":`Alle groepen`,
"label_tabpage_addoptionsz":`Opties toevoegen`,
"label.knowledgebase.submit.for.translation":`Indienen voor vertaling`,
"vue_label_pool_notallowed":`De aard van het bedrijf is niet toegestaan`,
"label.icon.80":`Papierscheppen`,
"label.readonlys":`Alleen lezen`,
"label.recordsediting":`Record Bewerkbaarheid`,
"label.mr.title.email":`E-mail`,
"label.partner.all.enable":`Activeer`,
"label.customsetting.manage.errmessage":`Onderhoud aangepaste velden voordat u de gegevens beheert.`,
"label.cloudccclass.list.cls":`Klasse`,
"label.weixin.click.loadall":`Klik om alles te laden`,
"label.weixin.appr.initialtime":`Ingediende tijd`,
"UG_ST_002":`Bepaal`,
"setup_mainpage_label_welcome17":`Toestemmingsinstellingen`,
"label.appupload.state0":`Niet geüpload`,
"label.icon.115":`Huis`,
"setup_mainpage_label_welcome5":`Aangepast veld`,
"lable.custom.year.ovdate":`Aangepaste einddatum van het jaar`,
"label_tabpage_findz":`Zoeken op`,
"label.appupload.uploading":`Uploaden...`,
"setup.mainpage.label.welcome1":`Heb overeenkomstige toestemming nodig`,
"label.file.folder.delete2":`Bibliotheek verwijderen?`,
"2018UI_Homepage_DataNoAccess_Info":`U heeft geen toestemming om dit dossier te bekijken, klik a.u.b. om terug te keren naar de vorige stap.`,
"label.ems.google":`Google`,
"label.hawaii.aleutian.standard.time":`Hawaii-Aleutian Standard Time`,
"template.report.unfinished.tasks":`Onvoltooide Taken`,
"vue_label_calendar_add_calendar":`Kalender toevoegen`,
"label.button.sel.useremail":`Stuur e-mail naar geselecteerde gebruikers`,
"user.email.template":`Beste{gebruikersnaam}：<br>De uitnodigingscode van [{Campaign.name}] ziet er als volgt uit<br>{Campaign.ColleagueInvitationLetter}<br>en de URL is：<br>{Campaign.ColleagueInvitationLetterLink}<br>QR Code registratie en URL link registratie worden ondersteund voor de huidige campagne! Bedankt voor uw steun! <br>Marketing Executive:{Campagne.Eigenaar}`,
"label.forecast.settings.shouru":`Inkomsten`,
"label.casesensitive":`Behandel "ABC" en "abc" als verschillende waarden (hoofdlettergevoelig)`,
"message.pleaseinputrightdistanceweek":`Gelieve de juiste intervalweek in te vullen.`,
"label.linellae-group":`kolomgroepering`,
"label.showdefault_times":`Toon standaard publicatietijd`,
"label.smstemplate.finishmessagedetailinfo":`Vul de gegevens van het SMS-sjabloon in`,
"label.service.miniProgram.backgroundImage":`Achtergrondbeeld`,
"label.recentview.news":`Laatste Records`,
"label.reportType.chose.and.form":`Selecteer de rapportgegevensbron en een rapportopmaak`,
"setup.layout.button.additem":`Voeg de geselecteerde items toe`,
"front-epwechat-module-v1-auto-mate":`Automatch`,
"vue_label_helpcenter_contract&plan":`? Een contract is een schriftelijke overeenkomst tussen de partijen. Veel bedrijven gebruiken contracten om de voorwaarden voor het zakendoen met andere bedrijven vast te leggen. Gebruik Cloud CC om uw bestaande contracten met uw klanten en zakelijke kansen vast te leggen en te documenteren. Traceer het contract door het goedkeuringsproces.<br>?`,
"label_mobile_version_nonsupport_feature":`Deze functie wordt niet ondersteund in de huidige versie. Gelieve bij te werken naar de laatste versie.`,
"label.icon.44":`Brand`,
"label.data.downpage.i.title.num3":`3、Voordat u gaat importeren, moet u eerst alle gerelateerde records importeren. Bijvoorbeeld: als er een lookup-relatie is tussen de objecten die u nu importeert en de contactpersonen, moet u eerst de contactpersonen importeren en dan pas uw gegevens importeren.`,
"label.mr.object.customer":`Rekeningen`,
"label.social.user.null":`Gebruikersinformatie van Social kan niet leeg zijn`,
"front-epwechat-module-v1-unbound-item2":` alle gegevens van toepassingsinstellingen`,
"label.partnerCloud.partnerAccount.noempty":`Het herlaadbedrag kan niet leeg zijn.`,
"label.weixin.myapproval":`Mijn goedkeuringen`,
"label.data.setok.e_desc1":`Export succes, ontvangt u een systeem bericht waarschuwingen,afgeleide gegevens worden tijdelijk opgeslagen in de server, het systeem alleen voor u om 48 uur op te slaan, neem dan zo snel mogelijk naar`,
"lable.batchadd.service.cfq.after":`Triggers (na invoegen)`,
"label.umeng.activity.youhaveanevent":`Je hebt een nieuwe gebeurtenis.`,
"label_emailsync_status_connectaccounts":`Aangesloten e-mailaccount`,
"label.multilang.shenpi.count":`Een totaal van {0} records：`,
"pagecreator.page.message.delete.fail":`Verwijderen van pagina mislukt`,
"label.version.sum.lookupmdfield":`Master-Detail relatievelden`,
"vue_label_pool_clueduplication":`Dubbele aanwijzing`,
"label.system.setup.log":`Logboek systeemgedrag`,
"label.globaloperation.operationtype.send.e-mail":`Stuur e-mail`,
"vue_label_pricebook_entry":`Nieuwe prijslijst`,
"label.forecast.forehistory.submit.date":`Ingediende datum/tijd`,
"chatter.handle":`Waar ben je mee bezig?`,
"lable.SalesCommitmentKanBan.complete":`Voltooid Bedrag`,
"label.weixin.upload.pictures":`Afbeelding uploaden`,
"label.create.document":`Nieuw document`,
"vue_label_commonobjects_detail_unlockconfirm":`Bevestigen om te ontgrendelen?`,
"label.customer.page":`Aangepaste pagina-tabbladen`,
"button.partner.workspace.saveas":`Opslaan als`,
"setup.layout.label.asc":`Oplopend`,
"label.ccpeak.folder.time":`Niet gearchiveerde geplande klassenmappen`,
"label_tabpage_includez":`Neem  op.`,
"label.custom.button":`Aangepaste knoppen`,
"label.weixin.binding":`Bind`,
"P":`Percentage`,
"chatter.stop.n":`Stop met deze plaat te volgen`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.wednesday":`Woensdag`,
"template.report.revenue.marketing.activities":`Campagneinkomsten`,
"lable.SalesCommitmentKanBan.theActualReceipts":`Werkelijke ontvangsten`,
"vue_label_popularresults":`Populaire Resultaten`,
"label.log.belongs":`Ondergeschikt deel`,
"label.profile.remark":`Gebruikers met dit profiel hebben de hieronder vermelde rechten en pagina-indelingen. Beheerders kunnen hun profiel wijzigen door persoonlijke informatie van gebruikers te bewerken.`,
"label.appupload.component.type.button":`Knop`,
"label.partner.all.operate":`Operatie`,
"vue_label_notice_modify_fail":`Niet bewerken`,
"label.icon.137":`Aarde`,
"front-dialog-module-v1-nosupport-copy":`Clone wordt niet ondersteund`,
"label.integrations.mailchimp.massage3":`Integratie succesvol verwijderd`,
"UG.opportunity.010":`Een transactie aanmaken`,
"front-lightning-module-v1-details-page-chart-selecting-reports":` U kunt alleen publieke rapporten kiezen, d.w.z. rapporten met toegang voor alle gebruikers, en niet gearchiveerde publieke rapporten.`,
"System_btn_SaveAndCommit":`Opslaan en verzenden`,
"vue_label_dashboard_statisticaltype":`Selecteer een statistisch type`,
"label.mr.object.opportunity":`Kansen`,
"label.area.detail.remark":`Bekijk gebruikers in dit gebied`,
"label.view.sortview.index":`Bestel`,
"label.mobile.quickcreate.default.events":`Evenementen`,
"label.product.price":`Verkoopprijs`,
"label.leadmarketsea.edit.title":`Lead Pool Edit`,
"pagecreator.layout.button.edit":`Lay-out bewerken`,
"label.addressee":`Ontvangers`,
"label.movablesearchlayout":`Activiteit Zoek Lay-outs`,
"label.ems.confirm":`Bevestig`,
"vue_label_file_save_to_file":`Opslaan in bestand`,
"component_chatter_button_more":`Zie meer details`,
"label.ccdocument.hidden.trace":`Verborgen spoor`,
"label.partnerCloud.maximumTwo":`Een bestand van maximaal 2M wordt ondersteund.`,
"label.event.moveup.4hour":`4 uur vooruit`,
"label.batchadd.save":`Fout bij delen toevoegen`,
"label.passwordPolicy.setup.expireDate":`Wachtwoord gebruiker vervalt in`,
"label.workflowrule":`Werkstroom Regels`,
"vue_label_notice_pleaseselecview":`Kies een uitzicht`,
"label.h5.chatter.colleagues":`Over de collega's`,
"lable.opppdt.addpdt.subtitle":`Product toevoegen aan`,
"label.data.import.setup.repeat.no":`Nee - alle records in mijn importbestand invoeren.`,
"label.changeCorporate":`Veranderen van bedrijfsvaluta`,
"label.customfields.dateandtime.tip":`Hiermee kunnen gebruikers een datum en tijd invoeren, of een datum kiezen uit een popup kalender. Wanneer gebruikers op een datum in de popup klikken, worden die datum en de huidige tijd ingevoerd in het veld Datum/Tijd.`,
"label.integrations.mailchimp.massage1":`Selecteer ten minste 1 record om uit te voeren`,
"lable.PowerProcess.custom":`Gebaseerd op aangepaste voorwaarde`,
"label.service.editDialog.displays.service.appointmentsFordays":`Toon service afspraken van {} dagen voor niveau datum en {} dagen na niveau datum.`,
"label.Receivables.ActualMoneyTime":`Werkelijke Ontvangst Datum`,
"label.matrixreport.intro":`Matrixrapporten tonen samenvattende gegevens berekend in horizontale en verticale termen in rastervorm.`,
"message.validation.isnotnumber":`Voer het ongeldige nummer in.`,
"label.partner.workspace.member.search":`Zoeken op`,
"label.customfields.deletewill":`Het verwijderen van een aangepast veld zal:`,
"label.content":`Inhoud`,
"component.setup.button.weburl":`Externe URL`,
"setup.mainpage.label.welcome28":`Instructies: Klik op het menu aan de linkerkant van deze pagina → Beheer Instellingen → Gegevensbeheer → Gegevens Importeren en Exporteren, Batch Overdracht, Batch Verwijderen.`,
"label.related.setup":`Taken en gebeurtenissen instellen`,
"label.weixin.sign":`Lieverd, je hebt je al aangemeld, je hoeft het niet opnieuw te doen.`,
"label.norecord":`Geen gegevens`,
"label.emailmerge.detail.emailtempldatemerge":`Mail Merge sjablonen`,
"label_emailsync_status_role":`Rol`,
"label.mobileapp.modelsetting2":`Selecteer modules die voldoen aan uw zakelijke behoeften<br>Activeren： de geselecteerde modules worden getoond in Meer  Standaard Functie<br>Deactiveren: de geselecteerde modules zullen niet getoond kunnen worden in Meer  Standaard Functie.`,
"component.sendmail.label.title":`Stuur e-mail`,
"component_assistant_button_newevent":`Nieuw evenement`,
"label.chatter.input":`Gelieve inhoud in te voeren`,
"message.error.view.operate.rtnlink":`Klik<a href='javascript:history.back();'>hier</a> om terug te gaan.`,
"lable.new.profile":`Nieuw Profiel`,
"label.custom.field.null":`Er is geen beschikbare`,
"label.reportsSubscriptionPage.schedulereport.weekly.saturday":`Zaterdag`,
"label.stdashbord.xsld.business.img4":`Totaal aantal fasen met waarschijnlijkheid 100%`,
"pagecreator_layout_button_splitall":`Alles splitsen`,
"label.mobile.phone.total.amount":`Totaal bedrag (tienduizend)`,
"label.ratifyhistory":`Goedkeuringsgeschiedenis`,
"label.projectManagement.Antecedents":`Pre-taak`,
"label.projectManagement.Newserviceappointment":`Nieuwe Service Afspraak`,
"label.delete.record.is.approval":`De records die u wilt verwijderen worden ter goedkeuring gevraagd, weet u zeker dat u ze wilt verwijderen?`,
"front-gantt-module-no-tasks-describe":`U kunt in een Ganttdiagram zien hoe werkitems in de loop van de tijd zijn georganiseerd, hoe ze elkaar overlappen en hoe ze met elkaar in verband staan.`,
"vue_label_visualize_data":`De gegevens van TianYanCha zijn ingevuld. Sla de wijzigingen op.`,
"UG.activity.02":`Taken toewijzen`,
"label.field.duplicate2":`Geen dubbele waarden toegestaan`,
"label.cloudccclass.list.tip":`Hiermee kunnen ontwikkelaars klassen ontwikkelen op het CloudCC.com-platform die kunnen worden gebruikt om pagina's en triggers aan te passen.`,
"before":`Vóór`,
"UG.ST.001":`Prompt`,
"label_tabpage_userGuidez":`Gebruikershandleiding`,
"vue_label_account_looking_for":`Voer in wat u zoekt`,
"vue_label_calendar_notice_timecantmove":`De tijd van de kalender kan niet worden veranderd door te slepen`,
"label.mobile.phone.enter.summary":`Voer uw samenvatting in`,
"label.object.api.existed":`De API-naam van dit object bestaat al, verander a.u.b. een andere API-naam.`,
"label.weixin..xsld.order.by.time":`Volgorde op sluitingsdatum`,
"label.h5.chatter.whether":`Wel of niet`,
"label.file.delete.success":`Bestand succesvol verwijderd`,
"label.imgfield.type.url.tip1":`De gebruiker kan de link invoeren die naar de afbeelding verwijst, en de grootte van de afbeelding instellen door toe te voegen`,
"label.tomanyrecords":`Meer dan 5.000 items in de vorm.`,
"label.save.partnercloud":`Fout bij het opslaan van Partner Cloud`,
"vue_label_homepage_fliteritems":`Filter configuratie-items`,
"pagecreator_page_button_new":`Nieuwe pagina`,
"label.sharerule.baseofcondition":`Gebaseerd op criteria`,
"label.dashboard.snapshot":`Dashboard momentopnamen`,
"label.appointmentpage.wizard.subtitle1.1":`Kies datum en tijd`,
"label.reportsSubscriptionPage.condition.emailsummary":`Alleen samenvatting`,
"chatter.group.showAll":`Toon alle`,
"label.tabpage.helpNavigationz":`Hulp en navigatie`,
"label.emailtocloudcc.button.back":`Annuleren`,
"approval_request_email_subect":`Verzoek om goedkeuring`,
"label.lookup.error":`Er is een fout opgetreden tijdens het zoeken`,
"label.publicgroup.save.groupisnull":`De groepsgegevens zijn null tijdens het opslaan. Gelieve opnieuw op te slaan. Als er nog steeds een fout optreedt, neem dan contact op met uw beheerder.`,
"label.pie":`Cirkeldiagram`,
"chatter.feed.is":`is een bedrijfsnetwerk waarmee uw gebruikers kunnen samenwerken, met elkaar kunnen praten en informatie kunnen delen, allemaal in real time.`,
"label.customfields.file.max5m":`De maximale bestandsgrootte is 5m`,
"com.cloudcc.login.error.message.vaildauthfail":`Ongeldige aanmeldingsauthenticatie`,
"label.profile.appsetuppermission":`Beheer appinstellingen`,
"label.customfields.file.totalmax":`Het geuploade bestand is te groot, gelieve niet groter te zijn dan 500m`,
"label.sms.list":`SMS-interface-lijst`,
"message.error.referencedcolumnIdnotexist":`De referentievelden van het rapport zijn verwijderd en kunnen niet correct worden weergegeven. Neem contact op met uw beheerder voor hulp.`,
"front-lightning-module-v1-details-page-chart-setting-chart":`Opzet rapportgrafiek`,
"label.recordtype.profile.enables":`Momenteel beschikbare recordtypes`,
"chatter.this.n":`deze plaat`,
"label.only.upload.file":`Alleen jpg/png bestanden zijn toegestaan om te uploaden en niet meer dan 500kb.`,
"vue_label_lead_conversion_failed":`Conversie mislukt`,
"label.file.share.file.success":`Bestanden succesvol delen`,
"label.processsetting.delete.process":`Weet je zeker dat je het proces wilt verwijderen?`,
"message.uniquenamevalidate":`Het moet beginnen met een letter. Het moet beginnen met een letter. Het mag alleen letters, cijfers en underscore bevatten.`,
"label.group.archived.desc.info":`Deze groep is gearchiveerd, dus u kunt geen nieuwe berichten maken of bestanden delen met deze groep. groep inschakelen maakt alle functies mogelijk.`,
"label.customer.maincontact":`Hoofdcontact`,
"label.appointment.wizard.subtitle1-9":`4 h`,
"label_productline_income":`Opbrengst productserie`,
"label.dashboardSetup.tz.ybb":`Ga naar Dashboards`,
"label.recordowner":`Record eigenaar`,
"message.approval.othersdoing":`Iemand anders werkt aan dit proces, ververs het alsjeblieft om de laatste gegevens te krijgen.`,
"Opportunity_Detailed_Phase_Label_002":`{0} dag(en) in huidige stadium`,
"label.field.validating.rule.isnot.passed":`Het compileren van de validatieregel is mislukt, controleer de syntaxis.`,
"label.textmessage.fieldskong":`Sommige van de ingevoegde velden in het bericht zijn ongeldig, gelieve aan te passen en opnieuw te verzenden!`,
"com.cloudcc.login.error.message.islocked":`Uw id is vergrendeld`,
"label.forecast.customforecast.foredis.debfb":`% Quotum`,
"lable.opppdt.selPbk.changepbk.worning":`Wijzig het prijzenboek voor deze opportuniteit, en het aan deze opportuniteit gekoppelde opportuniteitsproduct zal worden verwijderd. Weet u het zeker?`,
"label.mr.backLookReData":`terug, de lijst van dubbele gegevens bekijken`,
"label.quickbooks.searchqb":`Zoeken in QuickBooks`,
"label.service.gantt.searchSkills":`Vaardigheden zoeken`,
"label.account.Current.and.NexttFQ":`Huidige en volgende 3 FQ`,
"customer.notopen.chat":`De organisatie heeft de chatfunctie niet geactiveerd, neem contact op met de beheerder`,
"vue_label_commonobjects_view_sum":`Totaal {totaal} record(s)`,
"label.partnerCloud.orderingPlatform.adjust":`Aanpassen bestelling product`,
"label.emailmerge.mergeFolder.tips":`Op deze pagina kan een Microsoft Wordbestand met de contactgegevens worden gegenereerd. Kies email templates die moeten worden samengevoegd, en er kunnen maximaal 20 templates worden geselecteerd.`,
"vue_label_ccchat_notice_deletecommentfail":`Commentaar verwijderen mislukt`,
"label.emailsync.status":`E-mailstatus van de gebruiker`,
"label.forecast.forecastroleuserpage.desc":`Wijs een forecast manager toe aan deze rol. De forecasts van zijn of haar ondergeschikten zullen worden samengevoegd in de forecasts van zijn of haar manager.`,
"label.step1.total4":`Stap 1 van 4`,
"front-kefu-moudle-confirm-fjcase":`Ben je zeker om deze zaak te splitsen`,
"label.icon.60":`Kraan`,
"label.appointmentpage.wizard.subtitle3":`Voer uw gegevens in`,
"label.loginservice.license.exceed.time":`De vergunning is verlopen.`,
"label.customcomponent.check.tag.lastrow":`De laatste regel moet zijn`,
"label.product.code":`Product Code`,
"label.salescloud.salesdashboard.phone":`Telefoon`,
"label_please_input_price_list_price":`Voer de catalogusprijs in.`,
"label.multilang.page3":`pagina('s)`,
"label.file.lastmodifydate":`Gewijzigde tijd`,
"label.icon.121":`Computer`,
"message.error.system.service.unknow":`Onbekende diensten, neem contact op met uw beheerder.`,
"label.thesecond":`De 2e Kolom`,
"vue_label_report_conditiondesc_two":`Voeg voorwaarden toe aan dit rapport`,
"label.exchange.serverUrl":`Server Adres`,
"RL":`referentie`,
"label.emailobject.emailsend.sendindividuallyprompt":`Elke ontvangst zal een bericht ontvangen dat alleen naar hem gestuurd is. Weet je het zeker?`,
"label.appointmentconfirmpage.wizard.subtitle4":`Deelnemers`,
"message.save.opportunity.team.save.failed":`Business opportunity groep mislukt`,
"vue_labenl_normal_notice_share_success":`Succesvol gedeeld`,
"label.triggerfolder":`Trigger Mappen`,
"label.more":`Meer`,
"label.file.num":`Hoeveelheid`,
"label.dashboard.list.sortBy":`item(s), sorteren op toegangstijd`,
"c":`Valuta's`,
"label.weixin.detail.edit":`Bewerken`,
"label.escalation.setup.newentries.step2":`Stap 2 Selecteer de criteria voor deze regelinvoer`,
"label.report.error.prompt":`Configuratie mislukt. Alleen serierapport met een set rijen wordt ondersteund. Zorg ervoor dat het een publiek rapport is en niet verwijderd!`,
"label.notification.new":`Nieuw`,
"label_tabpage_releaseTourz":`Gids publiceren`,
"label.icon.41":`Positionering`,
"label.sendsms.hello.new":`Hallo, je hebt een nieuwe`,
"label.custom.combination":`Combineer`,
"label.project.hit.fifteen":`Kennisgeving van mijlpaaltoewijzing`,
"label.campaign.channel.step6.mobile":`Mobiele pagina genereren`,
"label.goback.N.step":`Terug naar vorige stap N`,
"label_partner_all_name":`Partner cloud naam`,
"label.usermanage.loginusername.exist":`De gebruikersnaam bestaat al.`,
"template.chart.cpxse":`Verkoop van producten`,
"chatter.feed.deletecomments":`Weet je zeker dat je deze opmerking wilt verwijderen?`,
"label.list.userinterface.show.newrcords.enable":`Uitschakelen laatste record`,
"label.sso.saml.idp.config.enablelogout":`Enkelvoudig uitloggen inschakelen`,
"label.file.library.create":`Nieuwe bibliotheek`,
"label.event.moveup.half.day":`0,5 dag vooruit`,
"label.stdashbord.xsld.business.jhzje":`Totaal aantal kansen`,
"label.partnerCloud.orderingPlatform.unitPrice":`Kosten per eenheid`,
"label.recordtype.edit.attribute":`Algemene eigenschappen`,
"front-template-V1-TemplatePreview":`Sjabloon Voorbeeld`,
"label.tabpage.personalCenterz":`Persoonlijk centrum`,
"label.setuplookuplayout":`Zoek Lay-outs`,
"label.no.merge.records":`Er kunnen geen records worden samengevoegd`,
"label.attachementNew.set2":`Stap 2 Archief`,
"label.publicgroup.detail.showmembers":`Bekijk Groepsleden`,
"UG.Forcast.03":`Begin met het plannen en uitvoeren van bedrijfsstrategieën. <br>Ik wens u een voorspoedige toekomst!`,
"label.h5.manageprompt":`Selecteer een tabblad om homepage toe te voegen, of klik op het tabblad om het te openen.`,
"label.icon.145":`Gerelateerd`,
"label.select":`Selecteer`,
"label.publicgroup":`Openbare groepen`,
"label.customcomponent.usewhere.title":`Waar wordt dit onderdeel gebruikt:`,
"label.custom.page.button.name":`Knop Naam`,
"pagecreator_layout_button_vertical":`Longitudinale demontage`,
"label.marketsea.autorecyclerule":`Automatische recyclingregels`,
"label.reportsSubscription.entrance.attachment":`Excel formaat .xlsx`,
"component_chatter_button_collect":`Bladwijzer`,
"label.page.step2.of.step5":`Stap 2 van 5`,
"label.reportsSubscription.addfile.helptext":`U kunt instellen of een rapport als bijlage moet worden toegevoegd aan de e-mails met abonnementen, en het formaat van bijgevoegde rapporten.`,
"label.oldpw":`Oud wachtwoord`,
"lable.SalesCommitmentKanBan.contractAmount":`Ondertekend bedrag`,
"lable.Bundle":`Superieur Pakket`,
"label.weixin.unit.million":`Eenheid (tienduizend yuan)`,
"label.app.choseprofile":`Profiel toewijzen`,
"label_tabpage_editz":`Bewerken`,
"label.email.attachement.size.info":`Bestand kan niet groter zijn dan`,
"label.chatter.pastSevenday":`De afgelopen 7 dagen`,
"label.weixin.end.later.start":`De einddatum moet later zijn dan de begindatum.`,
"label.passwordPolicy.setup.lockoutPeriod":`Effectieve periode van uitsluiting`,
"pagecreator_page_funcpath":`/ bouwer / pagina lijst`,
"label.emailobject.apperror":`Geen postservice beschikbaar, neem contact op met de beheerder.`,
"label.custom.page.button.broadband":`Knopgrootte (pixel)`,
"label.weixin.contract.rate":`Uitvoeringspercentage van het contract`,
"label.brief.payments":`Betalingen`,
"lable.approvaldatamove.transfermsg":`Massale overdracht van alle hangende goedkeuringsverzoeken aan een nieuwe gebruiker`,
"label.datamanage.account.namenull":`Opmerking: Als het veld Rekeningnaam leeg is, wordt het record niet geïmporteerd.`,
"lable.SalesCommitmentKanBan.allTotalPaymentAmount":`Totaal Rollup Ontvangsten Bedrag`,
"Opportunity_Detailed_Phase_Label_001":`Stadium`,
"vue_label_helpcenter_calendar2":`<br> Objectkalenders: Kalenders die u maakt met objecten geven de recordgegevens weer als kalenderitems in het datumveld op de kalenderweergave. U kunt objectkalenders bewerken of verwijderen, en de kleur voor elke objectkalender aanpassen. <br> Nieuwe gebeurtenis<br> U kunt op twee manieren een nieuwe gebeurtenis in de kalenderweergave maken. <br> (1) Klik op de knop Nieuwe gebeurtenis in de rechterbovenhoek van de kalenderweergave om een nieuwe gebeurtenis te maken. In een nieuwe gebeurtenis kunt u de gebeurtenis koppelen aan andere objecten, zoals zakelijke kansen, door andere objecten te selecteren in de velden Verwante items en Naam. Gebeurtenis records die zijn gekoppeld aan andere objecten worden gesynchroniseerd in de Activiteitenmodule van de detailpagina van de andere objecten. <br> (2) Of u kunt een nieuwe gebeurtenis aanmaken door op het kalenderrooster te klikken. <br> Nieuw Object Kalender<br> Stap 1: Klik op de Kalender tab in het navigatie menu om naar de Kalender weergave pagina te gaan. <br> Stap 2: Zoek Mijn Kalenders aan de rechterkant van het scherm, klik op het icoontje naast Mijn Kalenders, en ga verder in het Nieuwe Object Kalender pop-up venster. <br> Stap 3: Begin met het geven van een naam aan de aangemaakte object kalender. Selecteer het object dat de basis vormt van de kalender, en selecteer de velden die de inhoud van de kalenderweergave bepalen, "Start veld", "Weergave filter", "Weergave veld". Het Start veld bepaalt het tijdbereik waarover gegevens worden getoond, je kunt de gegevens filteren met weergave filters, en het Weergave veld bepaalt wat er wordt getoond op de kalender invoer. <br> Andere kalenders<br> Andere kalenders bevatten de kalenders van andere gebruikers die zijn toegevoegd. U kunt kalenders toevoegen van mensen die aan u ondergeschikt zijn en die een gedeelde kalender met u hebben. <br> Deel Mijn Gebeurtenissen Kalender<br> Stap 1: Klik op de Kalender tab van het navigatiemenu om naar de Kalender weergave pagina te gaan. <br> Stap 2: Zoek Mijn Gebeurtenissen aan de rechterkant van de kalender weergave onder Mijn Agenda's, klik op de drop-down knop rechts van Mijn Gebeurtenissen, en selecteer Deel Kalender. <br> Stap 3: In de Gedeelde Agenda pop-up, selecteert u de gebruikers en toegangsrechten waarmee u de agenda wilt delen. Daarnaast kunt u ook de gedeelde agenda bekijken door te klikken op "Wie heeft er toegang" en de gedeelde agenda's verwijderen door te klikken op het "x" icoontje rechts van de gedeelde agenda's. <br> Zodra de kalender is gedeeld, kunnen uw ondergeschikte collega's uw evenementenkalender toevoegen aan andere kalenders en vervolgens uw evenementenkalender bekijken. <br> Een kalender toevoegen<br> Stap 1: Klik op de Kalender tab in het navigatiemenu om naar de Kalender weergave pagina te gaan. <br> Stap 2: Klik op de drop-down knop voor andere kalenders aan de rechterkant van de kalender weergave en selecteer Kalender toevoegen. <br> Stap 3: Selecteer in de pop-up Gedeelde Kalenders de evenementenkalenders van de mensen die u wilt toevoegen. U kunt de agenda's van uw ondergeschikten selecteren, maar ook de agenda's die met u worden gedeeld. Klik op Toevoegen om succesvol toe te voegen. <br> Verwijder de toegevoegde agenda<br> Klik op de vervolgkeuzetoets rechts van de agenda die u wilt verwijderen onder de andere agenda's en selecteer Verwijderen.`,
"label.callcenter.Seat.number":`Zitplaatsnummer`,
"vue_label_commonobjects_view_change_all_selected_records":`Alle geselecteerde records wijzigen`,
"label.user.notinuse":`De gebruiker is inactief, neem contact op met uw beheerder.`,
"label.usermanage.hasbeen.reached":`Het maximum aantal gelicentieerde gebruikers is bereikt, neem contact op met de serviceprovider voor meer licenties.`,
"vue_label_help_list":`Lijst bekijken`,
"label.infomation.edit":`Essentiële informatie Bewerken`,
"label.ccchat.person.setting.info":``,
"label.sso.isDelete":`Is Delete`,
"label.unique.identification.number":`Unieke identificatiecode`,
"label.weixin.no.pending.projects":`Geen punten om goed te keuren`,
"label.projectManagement.Pleaseenteramember":`Gelieve een lid in te voeren`,
"label.salescloud.salesdashboard.visit":`Bezoek`,
"label.weixin.user.registered":`Registratie van gebruikers`,
"message.loginhistory.downloadcsv":`Download de laatste zes maanden login geschiedenis. ( CSV )`,
"label.icon.37":`Positionering`,
"template.chart.schdyqyx":`Verwachte reactie van de campagnes`,
"label.tel.ten":`U kunt tot 10 telefoonnummers invoeren voor SMS-berichten, en elk telefoonnummer wordt gescheiden door een ";".`,
"label.data.exp.objdata":`U zult de gegevens voor dit object exporteren volgens de volgende voorwaarden`,
"label.loginservice.after.use":`Daarna kunt u de.`,
"pagecreator_systemstyle_message_delete":`Verwijdert u de huidige geselecteerde stijl?`,
"label.globalselect.deleteerror":`Aangezien deze optielijst waardeset gebruikt wordt door de volgende velden, kan hij niet tijdelijk verwijderd worden.`,
"label.department.add":`Nieuwe afdeling toevoegen`,
"label.attendance.dingwei":`Locatie`,
"label.workflow.editrule":`Regel bewerken`,
"lable.product.pecm":`Voer het juiste bedrag in.`,
"label.icon.182":`Aktentas`,
"label.help.release.notes":`Releaseopmerkingen van CloudCC R7.1`,
"UG.product.05":`Invoerproduct`,
"label.email2":`E-mail`,
"label.weekrepeat":`Week Herhaling`,
"label.mr.descreption.oneGroupReData2":`set(s)`,
"chatter.at.d":`Bijdrage`,
"label.mr.descreption.oneGroupReData1":`Duplicaten zoeken en samenvoegen: een totaal van`,
"label.weixin.mobile.fly.android":`Delen op mobiele Android-app`,
"label.brackets.right":`)Sluiten Parenthese`,
"message.recordtype.applytoAllProfiles":`Een pagina-indeling toepassen op alle profielen`,
"label.customcomponent.page.index.tip":`Vergelijkbaar met de manier waarop de functie werkt in een programmeertaal, kunt u met aangepaste componenten gemeenschappelijke ontwerppatronen inkapselen en ze vervolgens hergebruiken in een of meer aangepaste pagina's.`,
"lable.List.properties":`Lijst Attributen`,
"label.fieldinfo":`Veld Details`,
"label.ems.error.fail":`Laden mislukt, probeer het opnieuw of neem contact op met de systeembeheerder.`,
"label_emailsync_form_email":`E-mail`,
"lable.currencyManage.button.manageRate":`Valuta's beheren`,
"component_salesperformance_label_100finish":`Beëindigd`,
"label.knowledgebase.data.assignment.failed":`{a}gegevenstoewijzing mislukt`,
"label.custom.buttonandlink.remark":`Selecteer het gedrag: Weergeven in bestaand venster/Display in nieuw venster (Bestaand venster:dispaly in huidig venster. Nieuw venster: weergave in nieuw venster)`,
"label.list.userinterface.watermark.setup":`Watermerk Instelling`,
"component_timeline_label_7daysahead":`7 dagen voor`,
"label.sendemail.chat.replyinchat":`Commentaar van de post:`,
"component.salesperformance.label.title":`Verkoop`,
"label.data.downpage.e.list.desc2":`Na voltooiing ontvangt u een e-mail om u eraan te herinneren dat de gegevens met succes zijn geëxporteerd.`,
"vue_label_campaign_fromclosedopprotunities":`Van {sjcb} gesloten zaken kansen`,
"label.umeng.activity.taskviewed":`De taak die je hebt toegewezen aan #naam wordt bekeken`,
"vue_label_salesadvance_retentions":`Bewaarnummer`,
"label.fieldtag":`Veld label`,
"label.quickbooks.button.searchinquickbooks":`Zoeken in QuickBooks`,
"label.quickbooks.viewlist.action":`ACTIE`,
"label.weixin.sysapp":`Systeem Apps`,
"label.approval.examine.level":`Goedkeuren en afwijzen per gebruikersniveau, het maximale gebruikersniveau is`,
"label.appupload.upload.error":`Deze app kan niet worden geïnstalleerd. Annuleer de installatie of wijzig de API in uw systeem, en installeer opnieuw.`,
"label.emailtemplate":`Email sjabloon`,
"front-email-payment-Invoice-amount":`Factuurbedrag`,
"label.viewselectedproducts":`Geselecteerde producten bekijken`,
"label.tianyancha.businessverify.openfirst":`Schakel verificatie van bedrijfsgegevens in`,
"lable.SalesCommitmentKanBan.returnAList":`Terug naar de lijst: Collega's`,
"label.knowledgebase.nopublished.draft.translations":`Geen gepubliceerde of ontwerpversie van vertaling`,
"vue_label_calendar_day_view":`Kalender-dag weergave`,
"label.globalselect.remark":`Met de waardenverzameling van de globale optielijst kunt u waarden delen tussen objecten.`,
"label.orderby":`Sorteer op`,
"lable.weixin.LastaDaysFinished":`Voltooid in de afgelopen 7 dagen`,
"lable.currencyManage.Enabledadvcurrency.discripation":`Hiermee kunt u gedateerde wisselkoersen beheren die een valutaomrekeningskoers toewijzen aan een specifiek datumbereik. Gedateerde wisselkoersen worden toegepast op valutavelden op opportunities, opportunity producten, en de rapporten die aan deze twee objecten zijn gekoppeld. Ze worden niet toegepast op velden op andere objecten of andere rapporttypes. Bijvoorbeeld, de wisselkoers op 1 januari was 1 USD voor 6,68 CNY, maar op 6 februari veranderde deze in 1 USD voor 6,70 CNY. Uw opportuniteiten die afgesloten werden tussen 1 januari en 6 februari gebruiken de eerste wisselkoers (1 = 1,68), terwijl opportuniteiten die afgesloten werden na 6 februari de tweede wisselkoers gebruiken (1 = 6,70).`,
"label.reportsSubscriptionPage.schedulereport.monthly.week.one":`One`,
"label.leadtoobjectfield":`Aangepaste Lead-velden in kaart brengen`,
"label.dashboardSetup.shujuyuan":`Gegevensbronnen`,
"label.tabpage.userz":`Gebruikers`,
"label.sms.companyname.dsf":`SMS-1 Instelling`,
"label.step2.total3":`Stap 2 van 3`,
"front-gantt-module-Drag-dropt- reorder-tasks":`Sleep om taken te herschikken!`,
"label.dashboard.snapshot.no.enabled":`Dashboard snapshot functie niet ingeschakeld`,
"label.dashboard.unit3":`Eenheid: gehele eenheid`,
"label.forecast.shrepage.desc2":`Gebruikers, rollen en territoria met gedeelde toegang.`,
"label.commonobjects.new":`Nieuw {gebeurtenisnaam}`,
"label.view.nameonlyone":`Bekijk Unieke Naam`,
"label.assignment.setup.newentries.user":`Gebruikers`,
"label.otheremails":`Extra e-mails`,
"component_sendmail_button_send":`Stuur`,
"vue_label_accountpool":`Rekening pool`,
"label.h5.approval.actortime":`Datum ingediend`,
"message.approval.cannotsubmit":`Kan niet ter goedkeuring worden ingediend`,
"vue_label_pool_createdbyme":`Gemaakt door mij`,
"label.change.event":`Gebeurtenis bekijken`,
"vue_label_homepage_personalpage":`Persoonlijke Homepage`,
"label.new.collect.target":`Nieuwe geaggregeerde indicator`,
"label.ServiceCloud.zichanxuhao":`Activa nr.`,
"label.product.userl":`Kolommen voor alle gebruikers`,
"label.syslog":`Systeemlogboek`,
"label.reportcreatestatus":`Status rapportgeneratie`,
"label.datamanage.account.novalue":`Opmerking: Als het veld Rekeningnaam leeg is, zullen de rekeningrecords niet worden geïmporteerd.`,
"label.letter.body":`Uitnodiging Tekst`,
"label.select.please":`Gelieve te kiezen`,
"label.escalation.setup.entrydetail.description":`1.Klik op Bewerken om de regelinvoer te wijzigen. <br/>2.Klik op Nieuw om een update operatie toe te voegen.`,
"label.component.salesDashboard.nodata":`Voeg de zakelijke mogelijkheid toe die u gebruikt, en kom dan hier terug om de prestaties te zien.`,
"vue_label_helpcenter_account":`<br>?In de gedetailleerde informatie, klik op de knop met het boomdiagram naast de klant om het hiërarchisch diagram van de klant te bekijken, de kind-ouder relatie van gerelateerde klanten te begrijpen, en sommige veldinformatie van elke klant te bekijken.<br>?Wanneer u de eigenaar van een klant wijzigt, kunt u ervoor kiezen om tegelijkertijd de eigenaar van de klant-gerelateerde zakelijke kansen, cases en andere informatie te wijzigen.`,
"front-kefu-moudle-v1-awshjzx-intelligent":`AWS Intelligent Service Call Center`,
"label.productby":`Gegenereerd door`,
"label.operation.date":`Bediening Datum`,
"label.name.donot.delete":`Naam kan niet worden verwijderd`,
"label.validate.function.funcFormat.DATETIMEVALUE":`DATETIMEVALUE(datum)`,
"label.escalation.setup.entrydetail.howescalationtime":`Hoe escalatietijden worden vastgesteld`,
"label.view.step2":`Stap 2 Filtercriteria specificeren`,
"lable.outlook.edit.notnull":`U moet de veldnaam invoeren.`,
"label.knowledgebase.createnewbrowser":`Nieuw Browser Tabblad`,
"label.partner.all.name":`Partner cloud naam`,
"chatter.group.groupSetUp":`Groep Instellingen`,
"label.reportlist.findfolder":`Zoek een map...`,
"component.setup.tabs.label.title":`Tabblad bladeren`,
"label.passwordPolicy.setup.pswComplexReq":`Vereiste complexiteit wachtwoord`,
"label.emaildocument":`Stuur een document in de vorm van een emai`,
"message.selectgsummaryconditon":`selecteer de samenvattende criteria`,
"component_todaytask_label_notask":`Er is geen vervaldatum vandaag, neem een koffie.`,
"label.user.organization.notexists":`De organisatie is niet gevonden.`,
"label.isEnableVisualpage.new.leftlist":`Beschikbare aangepaste pagina's`,
"label.mobile.phone.write.week.report":`Nieuwe wekelijkse werkaantekeningen`,
"label.emailmerge.edittemplate.edit":`Mail Merge Sjabloon Bewerken`,
"template.dashboard.folder.sales.manage":`Verkoopmanagement`,
"label.confirm.order.productsToassets":`Weet u zeker dat u orderproduct wilt omzetten in activa?`,
"label.service.dispatchingUnits.leftRight.total":`Momenteel {{ left }}-{ right }} records, {{ totalCount }} records in totaal.`,
"label.import.step1.chooseidorother":`2、U kunt kiezen om ID of naam te gebruiken om de record te matchen en het lookup veld in te vullen. Als u de bijbehorende record ID en andere informatie nodig heeft, kunt u een rapport maken en de record naam en record ID als groepskolommen instellen, en vervolgens het rapport exporteren.`,
"label_tabpage_completez":`Markeer de geselecteerde status om te voltooien`,
"chatter.c.adr":`Adres`,
"label.account.d":`Op deze pagina kunt u een aangepast fiscaal kwartaal definiëren en bewerken. De datum van het aangepaste fiscale kwartaal wordt gegenereerd op basis van de keuzes die u hieronder maakt.`,
"label.tag.more50":`Maak tot 50 tags`,
"setup.layout.label.areashow":`Sectiekop weergeven Aan`,
"label.partnerCloud.basicSetting.rebate":`Activeer korting`,
"label.tabpage.greaterequalz":`Groter dan of gelijk aan`,
"vue.please.select.the.aggregate.basis":`Selecteer SUM BY opties.`,
"label.form":`Formulieren`,
"label.chatter.colleagues.list.beizhu":`Activeer`,
"label.priority":`Prioriteit`,
"vue_label_checkduplicate_set_repeat_rules":`Herhaalregels instellen`,
"label.share_form":`Deel uw formulier`,
"label_relation_shareholder":`Aandeelhouders en dochterondernemingen kunnen niet dezelfde zijn.`,
"label.project.hit.sixteen":`Uitgifte Verval Herinnering`,
"label.service.miniProgram.imageFormat":`Alleen PNG, JPG en JPEG afbeeldingen worden ondersteund om te uploaden.`,
"label.summary.mode":`Samenvatting methode`,
"vue_label_beforeverification":``,
"label.data.newtemplate.desc":`Sla de velden en criteria geselecteerd door gebruikers als sjabloon en gebruikers kunnen direct gegevens exporteren door export data template.`,
"lable.evaluation.badreview":`Bad`,
"label.total.tabs":`{0} Totaal {1}`,
"label.emailmerge.mergeFolder.foldertemplate":`Sjablonen in deze map`,
"vue_label_normal_notice_repeated":`Voeg alsjeblieft niet herhaaldelijk`,
"label.icon.140":`Gegevens`,
"label.fromonetoanother":`van de ene gebruiker naar de andere`,
"label.user.list":`Alle Gebruikers`,
"label.file.prevent.share.operate":`Voorkomen dat anderen delen en niet delen`,
"label.app.detail":`App Details`,
"label.h5.similar.opportunity.correlation":`Relativiteit`,
"label_emailtocloudcc_filed_username":`Email Adres`,
"vue_labe_account_shareholdingratio":`Verhouding aandelenbezit`,
"label.data.dataexpalltype.all_desc3":`3. Geslaagde exportgegevens zullen een gecomprimeerd bestand genereren dat gebruikers kunnen downloaden van de exportlijstpagina volgens de informatie in de e-mail.`,
"label.callcenter.please.select .seatID":`Kies het stoelnummer`,
"label.remark.length.cannot.than":`De beschrijving kan niet meer dan 255 karakters bevatten.`,
"label.batchtransfer.dateandtimetype.tip":`Voor datum/tijd velden, voer de waarde in in het volgende formaat:`,
"label.component.helper.businesschange.0UntreatActivity":`Kansen zonder onverwerkte activiteit`,
"front-project-module-v1-plase-input-start-time":`Vul de begindatum in`,
"label.event.moveup.6hour":`6 uur vooruit`,
"label.data.exp.tempexp":`Exporteren per sjabloon`,
"label.schedulejob.setup.schedule.afternoon":`PM`,
"label.ems.format":`Formaat`,
"label.objectHasBeenDeleted":`Verwijderde objecten`,
"label.ServiceCloud.chaxunchenggong":`Succesvol gezocht`,
"label.campaign.channel.input.notice.owner":`Informeer Eigenaar`,
"label.bajisitan.time":`Pakistaanse tijd`,
"label.warnMes":`Object waarnaar verwezen wordt, verwijderen mislukt.`,
"lable.Up.to.ten.fields":`Kies een object en voeg tot 10 velden toe aan de grafiek. Klik op de pijlen omhoog en omlaag om de volgorde van de velden te sorteren.`,
"label.approverule":`Regels voor de goedkeuring`,
"message.error.specific":`Specifieke foutmelding terugzenden`,
"front-template-V1-saveUse":`Opslaan en weergeven`,
"label.uploadfile.success":`met succes geüpload`,
"label.tabname.donot.database.key":`Tabbladnaam kan geen databasesleutelwoord zijn`,
"message.recordtype.selectlayout.select":`--Selecteer pagina-indeling--`,
"front-detail-module-v1-list-cardview":`Lijst/kaartaanduiding`,
"label.product.maintenance":`Onderhoud`,
"vue_label_helpcenter_approve":`1. Goed te keuren items<br> Maak een lijst van alle items die uw goedkeuring nodig hebben. U kunt naar goed te keuren records zoeken op begindatum, einddatum, indiener, recordtype, en gerelateerde items van het goedkeuringsrecord.<br> Verwerk een enkel record: Klik op de linkerknop van elk record.<br> A. Goedkeuring<br> Stap 1: Klik op "Goedkeuren" om de goedkeuringsaanvraag pagina te openen<br> Stap 2: Klik op "Goedkeuren" of "Afwijzen" om de goedkeuringsoperatie te voltooien.<br> Als voor de volgende goedkeuringsstap in de configuratie van het goedkeuringsproces handmatig een goedkeurder moet worden geselecteerd, wordt stap 3 uitgevoerd na "Goedkeuren".<br> Stap 3: Selecteer de volgende goedkeurder om de goedkeuringsoperatie te voltooien.<br> Als u de terugstap moet selecteren nadat de goedkeuring is afgewezen in de configuratie van het goedkeuringsproces, gaat u naar stap 4 na "Afwijzen".<br> Stap 4: Selecteer de goedkeuringsstap die moet worden teruggestuurd om de goedkeuringsoperatie te voltooien.<br> B. Opnieuw toewijzen<br> Stap 1: Klik op "Opnieuw toewijzen"<br> Stap 2: Zoek de nieuwe goedkeurder<br> Stap 3: Klik op "Goedkeuringsverzoek opnieuw toewijzen" om de nieuwe toewijzing van goedkeurders te voltooien.<br>Note: Als u de plaatsvervangende goedkeurder bent van een record, kunt u de nieuwe toewijzing niet uitvoeren.<br> Batch-verwerking van meerdere records: Na het selecteren van meerdere goed te keuren items, klikt u op de bewerkingsknop boven de lijst.<br> C. Goedkeuring<br> Stap 1: Selecteer meerdere records die moeten worden goedgekeurd<br> Stap 2: Klik op "Goedkeuren"<br> Stap 3: Klik op "Goedkeuren" of "Afwijzen" om de goedkeuringsoperatie te voltooien.<br> Als u de terugstap moet selecteren nadat de goedkeuring is afgewezen in de configuratie van het goedkeuringsproces, ga dan naar stap 4 na "Afwijzen".<br> Stap 4: Selecteer de goedkeuringsstap die moet worden teruggestuurd om de goedkeuringsoperatie te voltooien.<br> D. Herverdelen<br> Stap 1: Selecteer meerdere goed te keuren records<br> Stap 2: Klik op "Herverdelen"<br> Stap 3: Zoek de herverwijzers<br> Stap 4: Klik op "Verzoek om goedkeuring opnieuw toe te wijzen" om het herverdelen van de goedkeurders te voltooien.<br> 2. Ingediende projecten<br> Toont alle goedgekeurde items die u hebt ingediend. U kunt snel zoeken naar het record dat u wilt bekijken aan de hand van de startdatum, einddatum, indiener, recordtype, gerelateerde items, en goedkeuringsstatus van het goedkeuringsrecord.<br> 3. Mijn goedgekeurde projecten<br> Toont alle goedgekeurde items die u hebt goedgekeurd. U kunt snel zoeken naar het record dat u wilt bekijken aan de hand van de startdatum, einddatum, indiener, recordtype, gerelateerde items, en goedkeuringsstatus van het goedkeuringsrecord.<br> 4. Afgewezen items <br> Toont alle goedgekeurde items die u hebt afgekeurd. U kunt snel zoeken naar het record dat u wilt bekijken aan de hand van de begindatum, einddatum, indiener, recordtype, gerelateerde items, en goedkeuringsstatus van het goedkeuringsrecord.`,
"label.knowledgebase.knowledge.article":`Kennis Artikel`,
"march":`Maart`,
"label.accraditation":`Goedkeuring van`,
"vue_label_pool_cantreach":`Kan klant niet bereiken`,
"label.service.appointmentList.startOf.maturityPeriod":`Begin van de vervalperiode`,
"message.huanxin.closed":`Inactieve Chatfunctie`,
"label.implementation.time.operation":`Geplande taken uitvoeren`,
"label.setting.intergrationlist.permissions":`INTEGRATIEBEVOEGDHEDEN`,
"label.translation.norecord":`Geen gegevens`,
"label.lack.expression":`Uitdrukking is verloren`,
"setup.layout.message.relatedlistfield":`Selecteer velden die u in de verwante lijst wilt weergeven.`,
"label.group.file":`Groep bestanden`,
"message.error.id.null":`Geen dergelijke id-informatie`,
"label.a_b_least":`Elke "A"-plaat moet ten minste één verwante "B"-plaat hebben.`,
"label.addattachment.step3":`Stap 4 Klik op "Voltooien" om terug te keren naar de vorige pagina.`,
"label.data.exportsf":`Geëxporteerde bestanden`,
"label.callcenter.call.out":`Roep maar.`,
"front-electronic-export-exportIntro":`De geselecteerde gegevens worden geëxporteerd naar de Mailchimp lijst die u hebt geselecteerd`,
"label.custombutton.deletedata.notnull":`Gewiste gegevens kunnen niet leeg zijn.`,
"UG.homepage.002":`Beheer uw aanwijzingen, leads, verkooptrechters en accountinformatie met geïntegreerde bedrijfshulpmiddelen`,
"label.globaloperation":`Wereldwijde werking`,
"label.icon.58":`Werknemer`,
"vue_label_salesadvance_lostrate":`Omloopsnelheid`,
"chatter.from":`van`,
"front-epwechat-module-v1-account-binding":`Bind op rekening`,
"label.list.userinterface.old.page.setup":`Oude pagina`,
"label.forecast.settings.periods":`&nbsp;cyclus(en)`,
"label.file.share.email.content":`#sharedBy heeft een bestand met je gedeeld op #orgname`,
"label.knowledge.category.hint.five":`Instelling gegevenscategorie`,
"setup.layout.label.selectedfield":`Selecteer velden`,
"label_business_income":`Business Opportunity Inkomsten`,
"vue_label_display_options_field":`Toon keuzelijst velden`,
"label.emailtocloudcc.set":`Mailbox-informatie instellen`,
"label.knowledge.setting.data.five":`Verwijder Categorie: {lbmc}`,
"front-epwechat-module-v1-bound-enterprise":`Gebonden Onderneming`,
"label.ccpeak.delete.recycle":`Het record zal worden verwijderd in de prullenbak`,
"label.leadconvers.tip":`Leads kunnen niet worden geconverteerd naar accounts, contacten, kansen en opvolgtaken. U moet een lead pas converteren als u hem als gekwalificeerd hebt geïdentificeerd.`,
"label.rsa.key.invalid":`De publieke sleutel is ongeldig, gelieve opnieuw in te loggen.`,
"label.mobile.bind.success":`Bind succesvol`,
"label.emailtocloudcc.filed.servertype":`E-mailserver`,
"label.user.new":`Nieuwe gebruiker`,
"label.setup.mobile.homepageshortcuts.remark":`Organisaties kunnen de swift-functies op organisatieniveau, die worden getoond op het bovenste gedeelte van de homepage, instellen volgens het bedrijfsscenario.`,
"label_emailtocloudcc_select2":`Selecteer Weergavetype`,
"page.send.email":`Stuur e-mail`,
"label.service.newBuildDialog.field.display":`Weer te geven velden`,
"vue_label_homepage_card_impending":`Dreigende kansen`,
"label.message.contactispartner.delete":`Een partner gebruiker is geassocieerd met dit contact, kan niet worden verwijderd`,
"label.attendance.checkout":`Kijk uit.`,
"label.emailmerge.newtemplate.description":`Voer informatie in over uw samenvoegsjabloon. Merk op dat de beschrijving alleen in CloudCC.com wordt weergegeven, niet in Word.`,
"laebe.data.exp.success":`Na een succesvolle export ontvangt u een herinnering per e-mail. De geëxporteerde gegevens worden gedurende 48 uur op de server bewaard. Gelieve zo snel mogelijk te downloaden van de lijst met geëxporteerde gegevens.`,
"lable.Maximum.number":`Er zijn maximaal 50 tekens toegestaan voor de sjabloonnaam.`,
"label.projectManagement.drag.and.drop.existing.tasks":`Sleep een bestaande taak naar de huidige categorie`,
"label.forecast.tree.desc":`De prognose hiërarchie bepaalt hoe prognoses binnen de organisatie worden gerold en wie ze kan bekijken en aanpassen. De hiërarchie wordt automatisch gegenereerd op basis van uw rolhiërarchie, maar het kan nodig zijn managers, verkopers of andere gebruikers toe te voegen of te bewerken.`,
"vue_label_chatter_upload_file_type":`Geselecteerde upload bestandstype post`,
"front-lightning-module-v1-dashborad-analysis-dimension":`Analyse Dimensie`,
"vue_label_homepage_custom_homepage":`Aangepaste homepage`,
"label.icon.39":`Positionering`,
"label.appointmentpage.wizard.notif1":`Kies eerst een tijd!`,
"vue_label_report_filterby":`Filter op {screenCondition}`,
"label.argentina.time":`Argentijnse tijd`,
"label.role.assign.notremove":`Kan de gebruikers niet verwijderen van <b>Geselecteerde gebruikers</b> naar "Alle niet-toegewezen en actieve gebruikers" of "Alle niet-toegewezen gebruikers".`,
"label.sharerule.detailsetshare":`Details regel delen`,
"label.file.publicview.error1":`Het bestand is verwijderd of de openbare link is niet ingeschakeld`,
"label.data.downpage.e_title.num4":`4. De export bestanden hebben twee formaten: CSV-formaat en het compressieformaat. Het compressieformaat is verdeeld in twee types: het ene is om het paswoord voor het gecomprimeerde bestand automatisch te genereren, het andere om het paswoord voor het gecomprimeerde bestand manueel in te geven.`,
"label.knowledge.case.article":`Zaak Artikel`,
"label.data.newtemplate.e.conditions":`Exportvoorwaarden`,
"front-object-change-owner":`De eigenaar van de gerelateerde lijsten die overeenkomen met deze rekeninghouder zal ook worden gewijzigd in de nieuwe eigenaar`,
"label.newdashboardpage.edittitle":`Titel bewerken`,
"label.datamove.end.query.no.record":`Einde van de query, geen gekwalificeerde records.`,
"lable.SalesCommitmentKanBan.receiptsTarget":`Ontvangsten Doel`,
"label.orderagain":`Nabestellen`,
"vue_report_dashboard_transfer":`Map verplaatsen`,
"label.view.sortview.default":`Standaard Weergave`,
"label.brasilia.time":`Brasilia zomertijd`,
"label.industrialandcommercialverification.instructions":`Activeer Verificatie van industriële en commerciële gegevens om de gebruiker te helpen de juiste industriële en commerciële registratiegegevens in te voeren. Let op: deze functie ondersteunt alleen het opvragen van industriële en commerciële registratiegegevens op het vasteland van China.`,
"label.chatter":`Wolkenpost`,
"label.sso.goBackToList":`Terug naar Beheer Lijst`,
"label.mobile.side.tab.state":`Aangepaste schuifregelaar starten`,
"label.weixin.addbus":`Voertuigen toevoegen`,
"label.dropbox.description":`Koppel uw DropBox-account om het in CloudCC te gebruiken.`,
"label.service.newBuildDialog.available.tousers":`Stel dit filter beschikbaar voor alle gebruikers.`,
"label.knowledge.language.thai":`Thai`,
"label.passwordPolicy.setup.foreverlock":`Voor altijd (moet gereset worden door admin)`,
"label.bmap.unreported.location":`Je hebt je locatiegegevens niet gedeeld. Gelieve in te stellen in WeChat Official Account .`,
"label.tag.field":`Tags`,
"label.addyourlanguage":`Klik op Toevoegen om de talen toe te voegen die uw organisatie ondersteunt.`,
"label.chat.topic.my.use":`Onderwerpen die ik gebruik`,
"UG.contact.06":`Contacten importeren`,
"label.embed_code":`Embed Code`,
"label.campaign.channel.input.chenben":`3. Werkelijke kosten:`,
"label.quickbooks.estimates":`Ramingen`,
"label.report.items.i.created":`Rapporten die ik heb gemaakt`,
"label.forecast.edit.fwqd":`Bereik Start`,
"label.validate.function.funcExplain.DATEVALUE":`Maak een datum van zijn datetime`,
"vue_label_helpcenter_calendar1.1":`Gebeurtenissen zijn een krachtig hulpmiddel om ervoor te zorgen dat u altijd inzicht hebt in klantrelaties en deals kunt sluiten. U kunt gebeurtenissen koppelen aan kansen, leads, klanten en contactpersonen. De kalenderweergave toont voornamelijk gebeurtenisrecords.<br> 1. Kalenderweergave en lijstweergave<br>Kalenderweergave<br> Klik op de kalendertab van het navigatiemenu om de kalenderpagina te openen. <br>Kalenderweergave<br> Indeling van kalenderweergaven: Kalenderweergaven zijn onderverdeeld in maandweergave, weekweergave, dagweergave en beschikbaarheidsweergave. De opgenomen gegevens van verschillende tijdbereiken kunnen afzonderlijk worden weergegeven via verschillende rasterstijlen. De beschikbaarheidsweergave geeft de dagelijkse recordgegevens weer met elke kalender als dimensie, inclusief mijn kalender en andere kalenders. Klik op het "kalenderknop" icoontje rechtsboven in de kalenderpagina om van weergave te wisselen. <br> Wat kan worden bekeken in de kalenderweergave: Kalender omvat mijn kalender en andere kalenders. U kunt mijn agenda bekijken in de agenda-weergave, inclusief alle geregistreerde gegevens van mijn evenementenkalender en objectenkalender. We noemen deze gegevens "agenda-items". <br> Je kunt alle gebeurtenissen die je hebt in de kalenderweergave bekijken. De kalender die u maakt met het object zal de gegevens weergeven als kalender-items in de kalenderweergave in het datumveld. U kunt ook andere kalenders bekijken in de kalenderweergave, dat wil zeggen, u kunt alle agenda-items bekijken die gedeeld zijn door uw collega's en die u hebt toegevoegd aan de weergave. <br>`,
"label.tabpage.rowsz":`Rijen verwijderen`,
"label.file.library.managemembers.memberlist":`Huidige leden`,
"label.report.action.addtodashboard4":`Toevoegen aan Bestaand prikbord`,
"label.chat.send.voice":`Een spraakbericht sturen`,
"label.home.dashboard.add":`Toevoegen aan Homepage Dashboards`,
"front-dialog-module-v1-copied-requestid":`Verzoek ID is gekloond`,
"label.customfields.exportdata":`Gegevensexport`,
"label.emailobject.signature":`Handtekening`,
"label.hide.source":`Broncode verbergen`,
"label.icon.71":`Dienst`,
"vue_label_help_whatslightning":`Wat is bliksem?`,
"report.type.label.systemReport":`Systeemrapporten`,
"front-kefu-moudle-v1-input-email":`Voer email adres in`,
"label.event.moveup.5minutes":`5 minuten vooruit.`,
"message.error.postsid.null":`Post ID kan niet leeg zijn!`,
"UG.Account.05":`Contactstructuurdiagram`,
"label_emailtocloudcc_description3":`Sluit uw zakelijke e-mailaccount aan, zoals sales@company.com, info@company.com, support@company.com. Log automatisch ontvangen e-mails als leads en cases in CloudCC om tijdige opvolging van klantenbrieven te verzekeren.`,
"report.label.searchresult":`Zoekresultaten`,
"vue_label_report_detailsonly_desc":`Exporteer alleen detailrijen. Gebruik deze gegevens voor extra berekeningen of om naar andere systemen te uploaden.`,
"label.partnerCloud.partnerAccount.payment":`Bedrag van de betaling:`,
"vue_label_commonobjects_view_select_member":`Selecteer lid`,
"label.emailtocloudcc.step1.lead1":`E-mail aan leiding`,
"label.forecast.settings.current":`Lopende periode`,
"label.canceluploadfile":`Annuleren`,
"label.manual.shared":`Handmatig delen`,
"label.document.uniquename.length.cannot.than":`De lengte van de unieke naam van het document mag niet meer dan 255 karakters bedragen.`,
"vue_label_lead_notcreateopportunity":`Creëer geen gelegenheid`,
"APPIntegration.Social.twittererror":`U moet een geldige URL invoeren voor twitter.com`,
"message.duplication.label.errormessage":`Foutmelding`,
"label.file.img":`Afbeelding`,
"label.tabpage.sum":`Totaal aantal?`,
"label.permission.systempermission.fenpei":`Toestemming Opdracht`,
"template.dashboard.folder.data":`Gegevensanalyse`,
"label.sms.account":`Gebruikersaccount`,
"label.product.filter":`Product Filter`,
"label.file.content":`Inhoud van de tekst`,
"label.percent":`Percentage`,
"label.single.attachment":`Single`,
"label.processsetting.failed.enable.process":`Kan proces niet activeren`,
"label.view.modify":`Bewerken`,
"label.knowledgebase.enter.keywords.filter":`Gelieve trefwoorden in te voeren om te filteren`,
"label.tabpage.uploadfailez":`Upload mislukt, gelieve opnieuw te uploaden.`,
"label.please.enter.the.target.model.name":`Voer de naam van het doelmodel in.`,
"label.layout.availabletab.related":`gerelateerde`,
"label.label":`Etiket`,
"label.reportsSubscriptionPage.schedulereport.monthly.day.saturday":`Zaterdag`,
"label.addattachment.unit":`byte`,
"vue_label_commonobjects_view_selected":`{gecontroleerdeLengte} geselecteerde record(s)`,
"label.view.sortview.printble":`Printbaar`,
"label.umeng.insert.approval.approvaling":`#aanvrager dient #obj#objnaam#eigenaar in voor uw goedkeuring`,
"label.forecast.customforecast.tztotal":`Aangepast totaalbedrag`,
"label.ccchat.failtoset":`ccchat instellingsfout`,
"label.ccchat.message.new.error2":`CCChat Gebruiker`,
"label.validate.function.category.Advanced":`Geavanceerd`,
"label.projectManagement.team.members":`Teamleden`,
"vue_label_report_clickcrosstofliter":`Klik op kruispunten in de tabel hierboven om details te filteren.`,
"lable.opppdt.selPdt.leasttwenty":`U kunt tot 25 lijnen kiezen`,
"label.campaign.channel.download":`Download HD QR-code`,
"component_event_label_person":`Aangewezen persoon`,
"vue_label_homepage_new_homepage":`Nieuwe startpagina`,
"label.version.sum.vlidaterule":`Validatieregels`,
"vue_label_chat_click_for_details":`Klik voor details`,
"label.fold":`Vouwen`,
"label.readonly":`Alleen lezen`,
"label.h5.similar.opportunity.result":`Gelijkaardige Mogelijkheden`,
"label.yourimportsuc":`Uw import verzoek is verwerkt, gelieve uw email te bekijken.`,
"label.report.line.yixuan":`Geselecteerde rapportkolom`,
"setup_layout_label_areaname":`Sectie Naam`,
"label.forecast.edit.title":`Doel`,
"label.chatter.allweather":`All-weather`,
"label.service.ganttBaiduMap.scheduled.endtime":`Geplande einddatum`,
"lable.create.new.list":`Nieuwe lijst`,
"label.emailobject.groupemail.msg3":`{0}mail`,
"lable.opppdt.selPdt.description":`Klik op Meer filters om meer dan één filter te gebruiken. De zoekresultaten omvatten alle records die zowel met uw trefwoord als met uw filter overeenstemmen.`,
"label.file.versionerror1":`U kunt op de link hieronder klikken om direct naar de nieuwe interface bestandstabblad over te schakelen, of u kunt de bestandstabbladfunctie gebruiken nadat u handmatig naar de nieuwe interface bent overgeschakeld`,
"label.under.approve.record":`In afwachting van`,
"front-epwechat-module-v1-open":`Activeer`,
"label.projectManagement.delete.task":`Alle gerelateerde informatie van deze taak zal ook worden verwijderd als u deze taak verwijdert, en de gegevens kunnen niet worden hersteld. Weet u zeker dat u de verwijdering wilt bevestigen?`,
"label.reportforms":`Verslagen`,
"label.tabpage.onlymevisible":`Het is alleen zichtbaar voor mij`,
"label.customer.tab.please.name":`Voer de naam van de tab in`,
"label_emailsync_form_stutas":`Status`,
"message.recordtype.nolist":`Geen recordtypes gedefinieerd.`,
"label.version.forecasting.sales":`Voorspellingen`,
"chatter.sel.mostfield":`U kunt maximaal`,
"label.data.derived":`Gegevensexport`,
"label.component.helper.businesschange.expiredtask":`Zakelijke kansen met vervallen taken`,
"label.cycle":`Fiets`,
"lable.product.standp":`Standaard Prijs`,
"label.sendemail.batchapproval":`Batchgoedkeuring`,
"message.organization.not.open.mffverification":`De organisatie maakt de secundaire certificering niet mogelijk.`,
"label.icon.131":`Paraplu`,
"UG.activity.08":`Reserveer een rooster`,
"label_partner_workspace_member_choicepermission":`Kies toestemmingenset`,
"label.reportTypeCategory":`Verslag Gegevensbron`,
"label.exporttwotype":`U kunt twee soorten tekst exporteren`,
"message.oppdt.selectpricebook":`Selecteer prijs boek`,
"vue_label_dashboard_generatefromlistview":`Genereren vanuit lijstweergave`,
"label.quote.title":`Titel`,
"label.tianyancha.businessverify.cancel.sure":`Na het uitschakelen van de verificatie van bedrijfsgegevens, is het onmogelijk om de registratiegegevens van een bedrijf opnieuw in te vullen bij het aanmaken/bewerken van een klant. is dit bevestigd?`,
"label.save":`Save`,
"label.mobile.quickcreate.default.appstore":`Apps`,
"label.partnerCloud.orderingPlatform.configure":`{a} producten zijn niet geconfigureerd, gelieve op te slaan na configuratie.`,
"front-epwechat-module-v1-unbound-role":`Ongebonden rollen`,
"label.partnerCloud.financeSetting.enterAlipay":`Voer bedrijfscertificaat van Alipay in.`,
"label.validate.function.funcExplain.TODAY":`Terug naar huidige datum`,
"label.visualpage.parameter.values":`Parameterwaarden direct op de pagina weergeven:`,
"label.version.task.and.activity":`Taken en activiteiten bundelen`,
"label.audit.history":`Goedkeuringsgeschiedenis`,
"setup.object.field.dependency.label.addtolist":`Voeg de geselecteerde waarden toe`,
"vue_label_report_exportquantity":`Export hoeveelheid:`,
"label_tabpage_havez":`Bijgevoegd`,
"label.partnerCloud.partnerAccount.amountOfRebate":`Beschikbaar kortingsbedrag`,
"label.createralias":`Gemaakt door Alias`,
"label.created_followup":`Followup email maken`,
"label_chatter_mygroups":`Mijn groepen`,
"label.chat.topic.no.display":`Geen toonbare onderwerpen`,
"vue_label_calendar_month_view":`Kalender-maand weergave`,
"label.service.gantt.resources.assigned.work":`Hulpbron met toegewezen werk`,
"UG_activity_07":`Maak een taak`,
"label.quote.xsjg":`Verkoopprijs`,
"message.toomanyrows":`Te veel records om op te vragen.`,
"label.importsourcestep1":`Stap 1 Bereid het vertaalde Tab Separated File voor`,
"vue_label_normal_appointment_sf":`Afspraak`,
"lable.list.queue.message":`De wachtrij kan niet worden verwijderd, omdat er objectrecords bij de wachtrij horen.`,
"label.service.major.event.desc":`Mijlpaal vertegenwoordigt tijdsafhankelijke stappen in het ondersteuningsproces. Het kan worden toegevoegd aan het begin van het proces voor het recht. U kunt het proces dan toepassen op de rechten van rekeningen en er een zaak of werkorder van maken.`,
"label.ems.hostorport.null":`Zowel de server als de poort kunnen niet leeg zijn.`,
"chatter.group.private":`Privé`,
"label.icon.192":`Zeepje`,
"vue_label_systemSettings_list":`Verwante Lijst Display Setup`,
"label.activity.saveobj.notnull":`Het opgeslagen object kan niet leeg zijn.`,
"vue_label_chatter_current_no_people_approval":`Momenteel geen mensen die goedkeuring nodig hebben`,
"label.tianyancha.reglocation":`Geregistreerd adres`,
"UG_ST_005":`Ik heb het, laat me deze pagina niet meer zien en log de volgende keer direct in.`,
"label.vlidaterule.example.truetodisplay":`Deze boodschap verschijnt wanneer de formule Foutconditie waar is`,
"label.icon.99":`Opmerkingen`,
"label.whenselectmoreapprover":`Wanneer u meer dan één goedkeurder selecteert`,
"label.forecast.customforecast.directorbest":`Beste geval van rechtstreekse ondergeschikte`,
"label.customsetting.view.introduce":`Geef waarden op voor de velden die u hebt aangemaakt. Deze gegevens worden in de cache van de toepassing opgeslagen.`,
"label.there.are.no.unenabled.rules":`Alle regels zijn ingeschakeld.`,
"front-project-module-v1-plase-selectemplat":`Selecteer project sjabloon`,
"label.campaignmember.selectmember.from":`Van`,
"setup_layout_button_quicksave":`Snel Opslaan`,
"label.setup.service.report":`Service Rapport Sjabloon Instelling`,
"label.visualpage.direction.for.use":`Instructie van klantpagina's [versie 2.0]`,
"message.modify":`Weet je zeker dat je wilt wijzigen?`,
"label.sms.inside":`Interieur`,
"label.category.3":`Onderwijs`,
"label.login.mfadevice.verification.title":`Verificatie van MFA-apparaten`,
"UG_Forcast_08":`Vorige stap`,
"label.projectManagement.unable.to.complete":`Onmogelijk te voltooien`,
"front-kefu-moudle-all-missphone":`Alle gemiste oproepen`,
"font-evaluate-module-v1-emergency":`Waarschuwing`,
"label.sso.saml.sp.idsource.attr":`Identiteit is in een Attribuut element`,
"chatter.not.meg":`Kan geen leeg bericht verzenden.`,
"label.chatter.startDate":`Start gegevens`,
"label.emailobject.track.times":`Totaal geopend: {0}`,
"label.customsetting.fieldhasbeendeleted":`Verwijderde velden`,
"label.knowledge.setting.hint.thirteen":`Andere gegevens categorie toevoegen`,
"message.duplication.label.newfiltertitle":`Nieuwe Duplicaat Regel`,
"setup_object_field_dependency_label_selectedfieldvalue":`Beschikbare veldwaarden`,
"vue_label_calendar_who_currently_has_access":`Wie heeft momenteel toegang`,
"message.passwordPolicy.validate.minlengthe":`personage(s)`,
"label.emailsync.status.disconnect":`Annuleer Conncet`,
"label.applt.down.one":`Downloaden met één tik`,
"label.manageAll.sel.one2":`Items die ik heb ingediend`,
"message.error.SQLTimeout":`Door een onjuiste configuratie van het systeem of niet-geoptimaliseerde aangepaste SQL-query's, heeft het systeem de toegestane querycapaciteit overschreden, waardoor de query mislukt is. Neem contact op met de systeembeheerder voor het afstellen van het systeem.`,
"label.global.search.obj.setup":`Globale doorzoekbare objectinstellingen`,
"vue_label_commonobjects_view_chat":`Team`,
"vue_label_systemSettings_startSet":`Start Setup`,
"label.quickbooks.viewlist.balance":`BALANS`,
"message.error.fieldid.null":`fieldid kan niet leeg zijn! Bestand inhoud id`,
"label.replaceallnullvalue":`Vervang alle lege waarden`,
"label.georgia.time":`Georgia Time`,
"label.hastransfer":`Bevat geconverteerde`,
"label.partner.all.description":`Beschrijving`,
"font-evaluate-module-v1-following-peopple":`Wanneer u de negatieve recensie heeft ontvangen, breng dan de volgende gebruikers op de hoogte`,
"label_business_count":`Bedrag zakelijke kansen`,
"vue_label_ccchat_closedetail":`Sluiten`,
"label.partner.all.disable":`Uitschakelen`,
"label.view.relationship":`Object Relaties`,
"label.noless":`>=Grooter Dan of Gelijk`,
"label.sendsms.batch.step2":`Stap 2 Kies een sjabloon of pas de inhoud van uw SMS aan`,
"label.stdashbord.xsld.business.jieduan":`Stadiumnaam`,
"label.appupload.component.type.trigger":`Trekker`,
"label.knowledge.setting.data.two":`De naam van de categorie is verplicht.`,
"label.color.display.of.completion.rate":`Kleurendisplay van afhandelingspercentage`,
"label.loginhis.default":`Toont standaard de laatste 200 geschiedenis`,
"vue_label_pricebook_book":`Huidige prijslijst`,
"label.knowledgebase.data.deletion.failed":`{a} gegevens wissen mislukt`,
"label_partner_workspace_member_permission":`Beschikbare permissies ingesteld`,
"label.list.userinterface.approval.setup":`Goedkeuring Setup`,
"label.weixin.binding.effect":`Binding ongeldig, gelieve opnieuw in te loggen.`,
"label.appupload.install.newapicannotnull":`Nieuwe api-naam kan niet leeg zijn`,
"chatter.feed.menutype.feed.company":`Alle bedrijven`,
"label.assignment.setup.detail.email":`E-mail`,
"label_tabpage_selectcontentz":`Selecteer inhoud`,
"template.report.converted.leads.campaign":`Geconverteerde leads uit campagnes`,
"label.forecast.season":`Dit kwartaal`,
"label.post":`Post`,
"label.knowledge.setting.hint.fifteen":`De basis is gelegd. Nu kunnen u en uw team uw kennisartikelen schrijven en organiseren.`,
"front-kefu-moudle-v1-Seats-name":`Bijnaam agent`,
"label.weixin.leadname":`Leiding Naam`,
"label.account.quarter":`Kwart`,
"label.detail.field":`Bekijk Velden`,
"label.icon.189":`Cosmetisch`,
"label.appointment.disable.reappointment":`Deactiveren Herschikken`,
"label.appointmentconfirmpage.wizard.subtitle1":`Naam evenement`,
"label.campaign.channel.step6.remark3":`Het systeem genereert een unieke QR-code voor de werving, die door de werknemers kan worden gebruikt en de verrichte wervingen kunnen worden meegeteld voor hun persoonlijke prestaties.`,
"System.AddressFieldType.Post":`Postcode`,
"label_partner_new_step2":`Stap 2 Bevestig sjabloon`,
"vue_label_helpcenter_file":`Bekijk en beheer uw bestanden<br> Gebruik de nieuwe versie van het bestandsobject om bestanden te bekijken en te beheren die uw eigendom zijn of die door anderen zijn gedeeld. U kunt bestanden in sommige formaten online bekijken. <br>Bestandenbibliotheek<br>Gebruik de bestandenbibliotheek functie om een team kennisbank op te zetten, stel verschillende beheerders en leden in voor gemakkelijk beheer; gebruik de mappenfunctie om bestanden te classificeren.`,
"label.locateddowncurrentvalue":`De waarde onder de huidige`,
"label.tianyancha.businessverify.msg5":`2. betrouwbaarheid van de dienst`,
"label.setup.mobile.bottombutton.change.success":`Succesvol veranderd`,
"label.appointmentconfirmail.wizard.subtitle2":`Tijd`,
"label.email.address.lookup":`Zoek e-mail adres`,
"setup.mainpage.label.welcome":`Welkom bij CloudCC PaaS platform, de belangrijkste functies van het platform zijn als volgt:`,
"label.icon.55":`Bulldozer`,
"label_tabpage_enterrecordnamez":`Voer de eigenaar van het record in`,
"label.tabpage.andz":`En`,
"label.selectfiletoimport":`Selecteer bestand om te importeren`,
"label.version.sum.trigger":`trekker(s)`,
"label.multi.layout":`Compacte indelingen`,
"pagecreator.button.back":`Laatste stap`,
"label.imgfield.truetype":`Upload het juiste type foto`,
"front-kefu-moudle-v1-publicKey":`Gedeelde sleutel`,
"label.data.exp.newtemp":`Sjabloon maken`,
"label.martrixreport.2018.step4.new":`Stap 4 Kies kolomkoppen`,
"label.sendemail.chat.addComentsatsubject":`Ik werd genoemd in CloudCC CCChat bericht`,
"vue_label_applauncher_description_leadpool":`Gebruik de Lead Pool om de opvolgingsstatus binnen de organisatie op een handige manier te beheren en personeel te motiveren om transacties af te ronden.`,
"label.knowledgebase.archive.published.articles.without.drafts":`U kunt alleen gepubliceerde artikelen archiveren die geen klad hebben.`,
"label.projectManagement.bar.chart":`Staafdiagram`,
"label.ccpeak.condition.return.sort":`Terugkeren en sorteren op voorwaarden`,
"label.salescloud.opportunity.contactrole":`Opportunity Contact Rol`,
"label.language":`Taal`,
"message.error.view.badprevilege":`Sorry, u mag deze dienst niet ontvangen, neem contact op met uw beheerder.`,
"label.textmessage.managetemplates":`Sjablonen beheren`,
"message.error.type.null":`Het type kan niet null zijn!`,
"setup.mainpage.label.welcome9":`Gebruikers kunnen de classificatieweergave en de aanpassing van de lay-out van alle pagina-elementen en de instelling van alleen-lezen en verplichte velden van de velden op de pagina realiseren door met de muis te slepen zonder code-ontwikkeling.`,
"label.appupload.component.type.page":`Aangepaste pagina's`,
"label.textmessage.bookschedule":`Klik op de link hieronder om mijn schema te zien en te boeken:`,
"component_chatter_post_button_save":`Publiceren`,
"lable.oppt.jieduan.signcomplete":`Markeer de etappe als voltooid`,
"label.help.notes":`HELP EN GIDS`,
"label_tabpage_reallproplez":`Noteer alle mensen`,
"label.obtain.authorization.failure":`Kan geen autorisatiecode krijgen. Gelieve opnieuw te autoriseren.`,
"label.account.FiscalQuarter":`Fiscaal Kwartaal`,
"label.customsetting.savecustomvalue":`De gegevens voor deze locatie bestaan al, pas ze aan en sla ze opnieuw op.`,
"label.maximum":`Maximum`,
"component_chatter_file_label_maxsize":`Maximale bestandsgrootte is 20m`,
"c218":`Uw bericht is opgeslagen als een concept`,
"c875":`Nieuw bericht voor conversatie`,
"c183":`Tag Filter`,
"c366":`Configureer de pool`,
"c91":`Email Interactie Score`,
"c184":`Stadium Vooruitgang`,
"c750":`Initiatiefnemer:`,
"c619":`Twitterberichten moeten 280 tekens of minder bevatten. Probeer samentrekkingen te gebruiken om dingen in te korten.`,
"c69":`Te betalen`,
"c675":`Links uitgelijnd`,
"c533":`Aantal opgewaardeerde gevallen`,
"c167":`De lengte van de order is vereist`,
"c682":`Vierkant`,
"c960":`Super Editie`,
"c850":`Dit toont het huidige aantal volgers voor elk van uw sociale accounts, behalve voor Facebook, dat het huidige aantal 'vind ik leuk'pagina's toont.`,
"c343":`Projectleden toevoegen`,
"c8":`Kies vorm`,
"c157":`Open bestelmodus`,
"c397":`Service Bemanning`,
"c556":`afbeeldingen worden niet geplaatst`,
"c563":`Actieve tijd`,
"c179":`Partner Logo`,
"c147":`Regels voor het opnemen van orders`,
"c303":`Wettelijke verplichting`,
"c885":`Zijbalk verbergen`,
"c808":`Afbeelding invoegen`,
"c718":`Doorgaan met opzetten`,
"c414":`Dank u voor uw tijd om het af te maken.`,
"c9":`Solliciteren door werknemers`,
"c15":`Het is gefactureerd. Gelieve opnieuw te selecteren`,
"c59":`Verbind u eerst als Easemob administrator seat en ga dan naar de geavanceerde setup.`,
"c504":`Plan projecten, wijs werk toe, beheer resources en werk samen met uw team om projectdoelen te bereiken, de voortgang van het project te controleren en het project volgens planning en binnen budget op te leveren.`,
"c836":`Bind Fadada Account`,
"c187":`Dank U Pagina`,
"c208":`Pakket downloaden`,
"c952":`Brazilië`,
"c104":`Antwoord eens`,
"c346":`Berekening van taakmiddelen`,
"c913":`Zijbalk uitbreiden`,
"c571":`{selectnummer} formulier(en) is/zijn geselecteerd`,
"c44":`Kies een netwerk om verbinding mee te maken`,
"label.social.posts.content.null":`De inhoud van het bericht is leeg`,
"c852":`Bedrijfsnaam (Oningevuld)`,
"c561":`Filter toepassen`,
"obtain.contract.envelopeid.fail":`Kan geen informatie over enveloppe of nietgebonden bericht krijgen`,
"c465":`Alleen orders in dezelfde valuta kunnen een factuur genereren`,
"c982":``,
"c350":`Taak sorteren`,
"c352":`Personeelskalender`,
"c670":`Grafische Pictogrammen`,
"front-electronic-signature-given":`Levering`,
"c542":`Evaluatie van de tevredenheid`,
"c314":`Factuurbestand genereren`,
"c148":`Email notificatie Setup`,
"c47":`Domein verbinden`,
"c754":`Vul in`,
"c326":`Activa BOM`,
"c289":`Voorkeur`,
"c196":``,
"c63":`Open {objName}`,
"c769":`Het geïnitieerde ondertekende taakdocument zal na de herroeping worden gewist. Doorgaan met ongedaan maken?`,
"c216":`Uw bericht is gepland`,
"c842":`Verzend kennisgeving van indiening per email`,
"c389":`Gebied van de moederdienst`,
"c7":`Eigenaar van de promotie`,
"c981":``,
"c143":`Selecteer de gebruiker die meldingen moet ontvangen. Deze instelling kan worden gewijzigd in alle landingspagina's waarop het formulier wordt gebruikt.`,
"c930":`Werknemer Positionering Schakelaar`,
"c515":`Werksamenvatting toevoegen`,
"c393":`Dienst Gebied Lid`,
"c357":`Tarief`,
"c597":`Doel Maat`,
"front-electronic-signature-cancelIntro1":`De Esignature van DocuSign zal niet beschikbaar zijn na het ontbinden. Weet u zeker dat u de verbinding wilt verbreken?`,
"c271":`U heeft een timeout van het accepteren van de bestelling, nummer: {0}. Handel het onmiddellijk af en wees u bewust van werkvertraging. Klik om meer te zien >`,
"label.gaode.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`Amap werkt niet goed. Controleer of de geheime sleutel correct is!`,
"c424":`Beheer van servicegebieden`,
"c711":`Verbind uw sociale accounts en bereik een hele nieuwe wereld van fans.`,
"c197":`U hebt het maximum aantal inzendingen bereikt. Bedankt voor uw deelname!`,
"front-electronic-signature-save-success":`Opslaan mapping succesvol`,
"c765":`Geblokkeerd`,
"c286":`Nietnaleving`,
"c145":`De ingediende werkuren voor één/meerdere taken per persoon per dag mogen niet meer dan 24 uur bedragen.`,
"c264":`Persoonlijke velden beheren`,
"label.china":`China`,
"label.no.bind.mobile":`Geen mobiel. Ga naar persoonlijke informatie en bind`,
"c95":`Geselecteerde producten verwijderen`,
"front-electronic-signature-open-signInfo1":`De Esignature&stempel van DocuSign is ingeschakeld. Schakel deze uit en activeer vervolgens de Esignature&stempel van Fadada.`,
"c391":`Bekijk commentaar`,
"c106":`Interacties`,
"c519":`Alle gerelateerde informatie van deze urenstaat zal ook worden verwijderd als u deze urenstaat verwijdert, en de gegevens kunnen niet worden hersteld. Weet u zeker dat u de verwijdering wilt bevestigen?`,
"c528":`Logboek Timesheet`,
"c78":`Bestelnr.`,
"c41":`Ontbind succesvol`,
"c517":`Voer een geldig belastingtarief in`,
"c774":`Teken vooruitgang`,
"c296":`Gelieve de veldnaam in te vullen`,
"c757":`Om te aanvaarden`,
"front-electronic-signature-confirmintro":`Bind succesvol. U kunt nu beginnen met ondertekenen vanuit het Contracts object.`,
"c446":`Taak Status`,
"c238":`{! ServiceResource.name} heeft de bestelling geaccepteerd. Account: "{!ServiceAppointment.accountid.name}", Onderwerp: "{!ServiceAppointment.subject}", Nummer: "{!ServiceAppointment.name}"`,
"c980":``,
"c802":`Elke gebruiker kan alleen worden toegevoegd als een dienstbron`,
"c387":`Service Hulpbron Vaardigheden`,
"c965":`EaseMob Service is niet ingeschakeld`,
"c480":`Naar welke lijst zullen we sturen?`,
"c937":`Telefoonnummer wijzigen`,
"c632":`Bekijk op Facebook`,
"c131":`Het rekeningveld van de factuur is leeg, gelieve de informatie toe te voegen.`,
"c680":`Wit`,
"c806":`Wanneer`,
"c649":`Je hebt alles in je inbox gelezen.`,
"c797":`Recente contacten`,
"c616":`Open link in nieuw venster`,
"c169":`Sorry, je hebt geen toestemming om deze grafiek te bekijken`,
"c21":`Het productnummer kan niet lager zijn dan het gefactureerde bedrag`,
"c231":`Kan niet minder zijn dan het aantal producten dat is verpakt`,
"c555":`De afbeelding van uw bericht is niet gepubliceerd.`,
"c583":`Kaart van China`,
"front-electronic-signature-open-signInfo2":`De Esignature&stempel van Fadada is ingeschakeld. Schakel deze uit en schakel vervolgens de elektronische handtekening en stempel van DocuSign in.`,
"c822":`Nieuwe externe contacten`,
"c600":`Numeriek diagram`,
"c442":`Allround projectbeheersysteem`,
"c762":`Om te tekenen`,
"label.user.not.permission":`De huidige gebruiker heeft geen toestemming om`,
"c35":`Abonnement Naam`,
"c921":`rol(len)`,
"c305":`Publiek belang`,
"c730":`U kunt het oude wachtwoord niet hergebruiken`,
"c525":`Portaal gebruiker uitschakelen`,
"c942":`Amerika`,
"c780":`Handtekening proces`,
"c447":`Eindkanaal Bron`,
"c369":`Stuur Offerte Bestand`,
"c702":`Maak ontwerp`,
"c22":`Het betaalde bedrag op de factuur zal groter zijn dan de totale waarde als u dit betalingsdetail blijft aanmaken. Gelieve het bedrag aan te passen en opnieuw op te slaan.`,
"c79":`Bestel Datum`,
"c785":`Echte naam (facultatief)`,
"label.insert.approval.reassign.error":`Goedkeuring in de invoegende goedkeuringsstatus kan niet opnieuw worden toegewezen`,
"c273":`Acceptatie order timeout. Annuleer de verzending.`,
"c3":`Grafiek succesvol verwijderen`,
"c448":`Chat Sessie`,
"c495":`Alles wat je nodig hebt om sneller en slimmer te verkopen`,
"c429":`Expeditie KPI`,
"c16":`Er zijn meer dan één gefactureerde orders. Gelieve opnieuw te selecteren`,
"c128":`Tot 5 rijen kunnen worden toegevoegd`,
"c955":`De minimum breedte van {label} is {minWidth}px`,
"c716":`U bent klaar om te beginnen posten, direct vanuit CloudCC`,
"c638":`Publicatiemogelijkheden`,
"c746":`Verzoek tot vernietiging intrekken`,
"c534":`Aantal gesloten zaken`,
"c948":`Italië`,
"c317":`Bestand met inkooporders verzenden`,
"c426":`Beheer van dienstmiddelen`,
"c457":`Totaal contractbedrag Rangschikking`,
"c263":`Persoonlijke velden`,
"c372":`Orde genereren`,
"c907":`Alleen verkrijgbaar in lightning versie`,
"c771":`Vullen vooruitgang`,
"c408":`Aanpasbare buitendienstapplicatie`,
"c12":`Groeipercentage`,
"c379":`Betalingsgegevens`,
"c410":`Type werk`,
"c510":`Partner bestellen`,
"c701":`Campagne toewijzen`,
"c617":`Tekst is nodig om een bericht te publiceren`,
"c213":`EPSformaat`,
"c473":`Het systeem zal een unieke uitnodigingscode genereren voor werknemers, die de uitnodigingscode kunnen gebruiken om uitnodigingen te maken en te tellen als persoonlijke prestaties. Let op: de eigenaar van de lead is de huidige campagneeigenaar of de uitnodiger van het marketingkanaal.`,
"c975":``,
"c168":`Kies een kaart!`,
"c121":`Uncategorized`,
"label.send.invoice":`Factuur verzenden`,
"c792":`Bevestigen Initiëren`,
"c686":`Maat`,
"c652":`Dit toont het aantal berichten dat binnen de geselecteerde periode over uw accounts is gepubliceerd. Dit omvat ook berichten die zijn gepubliceerd op uw verbonden accounts buiten CloudCC.`,
"c136":`Geef hier een korte introductie`,
"c662":`Aangepast pictogram`,
"label.invoice.customer.is.error":`Het genereren van facturen wordt alleen ondersteund voor orders die door dezelfde klant zijn geplaatst.`,
"c580":`Bellengrafiek`,
"c894":`Wijs campagne toe aan berichten en u kunt alle gerelateerde berichten in dezelfde campagne bekijken. Dit wordt gebruikt voor een verbazingwekkende marketing inspanning.`,
"c570":`Ontwerp`,
"c133":`overschrijden`,
"c564":`Beste gebruiker: \Welkom bij CloudCC systeem. U heeft verzocht om uw wachtwoord te resetten op {!operatetime}, log alstublieft in met de verificatiecode hieronder binnen 15 minuten: \Willekeurige verificatiecode: {Belangrijk: Als u deze handeling niet heeft aangevraagd, of u denkt dat dit bericht u niet zou mogen bereiken, neem dan onmiddellijk contact op met uw beheerder!`,
"c854":`Het lijkt erop dat er niets is gepubliceerd.`,
"c775":`Stopgezet`,
"c105":`Meer dan eens herhalen`,
"c729":`Controleer of u het sociale platform hebt geconfigureerd of niet. Ga naar backend instellingen  Integraties  Inschakelen (Twitter/Facebook/LinkedIn)`,
"c491":`Gedeactiveerd`,
"c609":`Handelsmerk`,
"c611":`Link naar`,
"c843":`Indiening bekijken`,
"c933":`Conversie pagina`,
"c383":`Opportunityproducten`,
"c186":`De unieke ID bestaat al. Gelieve niet herhaaldelijk toe te voegen`,
"c608":`Vervangen`,
"c149":`Zet notificatie van Outlook aan (ondersteunt alleen een deel van email diensten)`,
"c486":`Antwoord op email adres:`,
"c598":`Donut Grafiek`,
"c726":`Verzoek vernietiging succesvol`,
"c645":`Ontwerp goedkeuren`,
"label.verificationCode.is.invalid":`De verificatiecode was ongeldig. Gelieve hem opnieuw te verkrijgen`,
"c904":`Tussen`,
"c594":`2D Lijngrafiek`,
"c103":`Meer dan één keer klikken`,
"c188":`commentaar(en)`,
"c891":`Het record mag geen contact, kans, lead of account zijn`,
"c902":`Afstand tussen aanmeldadres en bezoeker`,
"c484":`Emails:`,
"c421":`Werkordergeneratie methode`,
"c406":`Geautomatiseerd verkoopbeheer`,
"c739":`Campagne: Sollicitatie van werknemers`,
"c329":`Vervanging activa`,
"c351":`Herhalingsfrequentie`,
"c622":`Netwerk statistieken voor het laatst ververst op`,
"2":`Filteropties succesvol configureren`,
"c463":`Mijn Mogelijkheden`,
"c268":`Informatie succesvol samenvoegen`,
"label.mobile.no.letter.blankcharacter":`Het telefoonnummer mag geen letters en spaties bevatten`,
"c438":`Overdracht`,
"c581":`MoM&YoY tabel`,
"c953":`ZuidKorea`,
"c90":`Onderwerp`,
"c2":`Verwijder dashboard succesvol!`,
"c897":``,
"c444":`Eerste kanaal Bron`,
"c242":`{!ServiceResource.name} heeft de bestelling afgewezen. Account: "{!ServiceAppointment.accountid.name}", Nummer: "{!ServiceAppointment.name}"`,
"c135":`Blanco Sjabloon`,
"c659":`Volg mij.`,
"c773":`Afronding`,
"c11":`Promotie van vormmarketing`,
"c799":`Externe contacten`,
"c880":`sociale berichten bewerken`,
"c890":`Uitnodigings email succesvol verzonden`,
"c846":`Selecteer een in aanmerking komende dienstafspraak`,
"front-electronic-signature-sucessSign":`Start ondertekening met succes`,
"c472":`Kies een vorm om de poster op aan te brengen`,
"c963":`Naam veld is verplicht`,
"c390":`Child Service Territory`,
"c248":`Aanvaarding van de orderoverdracht is hangende`,
"c646":`Inbox Stream`,
"c308":`Kies ten minste één gegeven`,
"c858":`Weet je zeker dat je {een} bericht als klad wilt opslaan? Deze berichten zullen niet gepubliceerd worden tenzij je ze opnieuw plant.`,
"c152":`Aantal voltooide serviceafspraken in het huidig geselecteerde tijdvak / Aantal alle serviceafspraken in het huidig geselecteerde tijdvak`,
"c316":`Bekijk voortgang zaak`,
"c435":`Bekijk Versie`,
"c362":`Bijgevoegde productbeperkingen`,
"c800":`Voer naam of bedrijfsnaam in`,
"c415":`Geplande start`,
"c735":`De naam kan niet worden herhaald`,
"c903":`Selecteer het pictogram van de toepassing`,
"label.insert.approval.massreassign.error":`Batchgoedkeuringen bestaande Invoegen goedkeuring kan niet opnieuw worden toegewezen. Het systeem zal automatisch voor u filteren`,
"c354":`Timesheet bewerken`,
"c409":`Onestop platform voor klantenservice`,
"c651":`Dit toont het aantal huidige volgers voor elk van uw sociale accounts, behalve voor Facebook, dat het aantal huidige pagina Likes toont.`,
"c582":`Wereldkaart`,
"c826":`Weet u zeker dat u uw wijzigingen wilt negeren?`,
"c781":`Onderneming: Vul de bedrijfsnaam in die op de bedrijfsvergunning staat. De controle zal worden uitgevoerd bij de ondertekening.`,
"c873":`Meer details`,
"c837":`Na het opheffen van de binding, kan de Fadada Esignature functie niet meer gebruikt worden, en de autofill en backfill veldfunctie die zijn ingesteld zullen worden verwijderd. Weet u zeker dat u de account wilt deblokkeren?`,
"label.diedirect.sale":`Rechtstreekse prijsverlagingen`,
"c798":`Interne contacten`,
"c368":`Genereer offerte bestand`,
"c770":`Geïnitieerd`,
"c882":`Voorwaarden van de Dienst`,
"front-setting-dialog-title-two":`Instellen vanaf de persoonlijke informatie pagina als deze keer niet ingevoerd. Bind in terwijl u het nummer invoert`,
"c535":`Onopgelost`,
"front-electronic-signature-look-account":`Bekijk rekening`,
"c19":`Weergavemodus opnamedetails`,
"c52":`Belasting Naam`,
"c388":`Associëren en gebruiksrecht`,
"c18":`Er zijn meer dan één inactieve orders, gelieve opnieuw te selecteren`,
"c820":`Voer het telefoonnummer/mailbox in`,
"c285":`Overzicht`,
"c478":`Mailchimp verifiëren`,
"c164":`Voer een gehele waarde in van 060`,
"label.tip.excess.quota":`Het gebruik van deze hulpbron is overschreden`,
"c318":`Inkooporderbestand genereren`,
"c698":`Sociaal Netwerk`,
"c312":`Meerdere bestellingen zijn nog niet effectief, gelieve opnieuw te selecteren`,
"c110":`Groeperen per project`,
"c549":`Het datumbereik mag niet langer zijn dan 31 dagen!`,
"c845":`Selecteer ten minste één serviceafspraak`,
"c282":`Persoonlijke gegevens van klanten beheren in CRM`,
"c270":`Timeout van bestelling accepteren`,
"c288":`Wijziging basis gegevensverwerking`,
"c878":`Huidig adres`,
"c324":`Wachtrijen toevoegen aan gevallen`,
"c129":`Deze actie zal het bestand permanent verwijderen. Wilt u doorgaan?`,
"c339":`GDPRgegevens vernietigen`,
"c405":`Bemanning maat`,
"c848":`Linkedinaccounts`,
"c345":`Project Sjabloon`,
"c591":`Kaart van Australië`,
"c180":`Taal op inlogpagina`,
"c126":`Geleverd`,
"c311":`Niet effectief, gelieve opnieuw te selecteren`,
"c587":`Kaart van Mexico`,
"c37":`Dit is de tekst die uw klant op de voorkeurspagina van de communicatie moet zien`,
"c840":`Yay! Geen mislukte berichten.`,
"c241":`{!ServiceResource.name} heeft de bestelling afgewezen. Account: "{!ServiceAppointment.accountid.name}", Onderwerp: "{!ServiceAppointment.subject}", Nummer: "{!ServiceAppointment.name}"`,
"c141":`Het dankbericht is vereist`,
"obtain.contract.fail":`Het is niet gelukt om contractinformatie te verkrijgen`,
"c945":`Rusland`,
"c454":`Contractbedrag Maandelijks`,
"c34":`U heeft 100 producten in uw winkelwagen. Gelieve minstens één item te verwijderen alvorens een nieuw product toe te voegen.`,
"c243":`{!ServiceResource.name} heeft de bestelling afgewezen. Onderwerp: "{!ServiceAppointment.subject}", Nummer: "{!ServiceAppointment.name}"`,
"c548":`Taak/Punt, subtaak en project kunnen niet worden bewerkt vanuit een urenstaat`,
"c807":`Nu plaatsen`,
"c590":`Kaart van Duitsland`,
"c831":`Certificeren van`,
"c198":`Uw formulier is veilig gepubliceerd en kan worden gebruikt op de volgende URL om uw formulier te delen als een openbare link.`,
"c977":``,
"c66":`Logistieke informatie van product is bijgewerkt naar Geleverd`,
"label.twitter.title.setting":`Twitter Geïntegreerde informatie`,
"c922":`Neem contact op met de beheerder om Team`,
"front-email-payment-Invoice-Tips":`Neem contact op met de beheerder om PayPal of VISA in te schakelen en vervolgens de online betaling te starten`,
"c605":`	
Standaard factuuradres`,
"c403":`Projecten`,
"c156":`Regels voor het opnemen van orders voor mobiele telefoons`,
"c635":`Plan een andere post`,
"c753":`Deelnemer`,
"c647":`Alle activiteiten`,
"c295":`Na het uitschakelen worden alle markeringen van persoonlijke velden, de grondslag voor gegevensverwerking en andere informatie om te voldoen aan DGPR verwijderd, behalve de bewerkingsgeschiedenis voor records. Bent u zeker om uit te schakelen?`,
"c915":`Open zwembad`,
"front-electronic-signature-signStatus":`U bent begonnen met online ondertekenen. De contractstatus is {signStauts}`,
"c568":`Layout aanpassen`,
"c744":`Voer een geldig getal tussen 0 en 100 in`,
"c464":`post(en) zijn verwijderd`,
"c385":`Werk Samenvatting`,
"c392":`Kies de oplossing die u nodig hebt`,
"c418":`Toegewezen dienstmiddelen`,
"c256":`Als u van account verandert, wordt de bestelling met geselecteerde artikelen gewist. Weet u zeker dat u wilt veranderen?`,
"c690":`Beeld laden`,
"c261":`Vernietig gegevens`,
"c62":`Solliciteren door werknemers`,
"c892":`Het huidige record werd niet gevonden`,
"c909":`Prijsdefinities voor deze valuta zijn toegevoegd. Gelieve niet opnieuw toe te voegen!`,
"c883":`&`,
"c134":`Bovengrens van het aantal leden van de pool`,
"c896":`Record is vergrendeld en ondersteunt het toevoegen van bestanden niet. Neem contact op met de beheerder om te ontgrendelen`,
"c974":``,
"c209":`Middelgroot`,
"c185":`Statistieken op deze pagina`,
"c796":`Neem contact op met de beheerder om een contractsjabloon op het Fadadaplatform in te stellen voordat u begint met ondertekenen.`,
"c60":`Project Telling`,
"c866":`Toepassing instellen`,
"c666":`Weergave`,
"c219":`Uw bericht is verwijderd.`,
"c732":`Poster`,
"c155":`{NAME} Naam`,
"c511":`Econtract`,
"c240":`Afgewezen`,
"c468":`Sorteertype is leeg`,
"c961":`Q{kwartaal} {jaar}`,
"c404":`Een instrument voor marketing en het genereren van leads`,
"c586":`Kaart van Singapore`,
"c694":`Breedte/hoogte`,
"c297":`Gelieve het type persoonsgegevens in te voeren`,
"c860":`Adres veranderen`,
"c58":`Project Homepage`,
"c920":`Als autorecycle regels zijn geconfigureerd, zal het systeem de records automatisch terugplaatsen in de pool als de lead na de tijdslimiet niet is geconverteerd. Dat verbetert de efficiëntie van leadopvolging.`,
"c27":`Voer het variabele bedrag in om het brutobedrag aan te passen, bijvoorbeeld  10 of 10.`,
"c94":`3 keer omhoog.`,
"c1":`Alleen mobiel`,
"c557":`Ontvangen gevallen`,
"c294":`Instellingen voor GDPRnaleving uitschakelen`,
"c970":``,
"c565":`Wijs deze taak toe aan`,
"c668":`Uitlijning`,
"c972":``,
"c660":`Copyright`,
"c433":`Leadpool veld tracering`,
"c443":`Archief Alle`,
"c275":`{0} heeft een timeout voor het accepteren van de order, en de verzending is geannuleerd. Nummer: {1}. Klik om meer te zien >`,
"c691":`Link (Facultatief)`,
"c956":`U heeft uw Mailchimp account nog niet geactiveerd. Ga naar instellingen>Integratie>Integratie lijst om uw Mailchimp account te activeren of neem contact op met de beheerder.`,
"c910":`Nieuwe werkopdracht`,
"c692":`Standaardbrowser`,
"c355":`Timesheets in batch toevoegen`,
"c122":`Product afbeelding`,
"c395":`Gebiedstype`,
"c689":`Max Hoogte`,
"c344":`Bekijk Project met Gantt Grafiek`,
"c656":`Vernieuwingstijd`,
"c943":`Japan`,
"front-electronic-signature-outerSinger":`Externe ondertekenaar`,
"front-generate-v1-invoiceDetail":`Factuurdetails`,
"front-electronic-signature-open-vertify":`Voer de verificatiecode in`,
"c291":`Persoonsgegevens Type`,
"front-setting-phone-message":`Voer het telefoonnummer in`,
"c559":`Geëscaleerde gevallen`,
"label.google.map.cannot.work.normally.please.check.whether.the.secret.key.is.correct":`Google map werkt niet goed. Controleer of de geheime sleutel correct is!`,
"c259":`Grondbeginselen van gegevensverwerking`,
"c488":`Uitgenodigde tijd`,
"c6":`Naam van de promotie`,
"front-electronic-signature-signerInfo":`Info ondertekenaar instellen`,
"c512":`Projectleden`,
"c507":`Lead Cultivation`,
"c760":`Afgewezen`,
"c756":`Geen zenden`,
"c321":`Vereist of niet`,
"c817":`Rechteninstellingen van aangepast paginamenu bekijken`,
"c949":`Spanje`,
"label.biaoqing.field.relation.tip":`Bid&tender discovery field`,
"c382":`Relatie Net Scoring`,
"c265":`Dit bevel kan niet worden gewijzigd want het is nog niet van kracht`,
"c417":`Informatie over het werk van de dienst`,
"c847":`Facebookaccounts`,
"c494":`Realiseer verenigd beheer van alle kanalen in CloudCC Marketing Cloud. Bouw een band en een langdurig vertrouwen op met uw klanten, stimuleer ROI met analyses en zet bereik om in inkomsten.`,
"c86":`Campagne: Werknemer Referal bewerken`,
"c776":`Succesvol ongedaan maken`,
"c709":`Kies een netwerk om verbinding mee te maken`,
"label.mobile.orVerificationCode.is.error":`Het telefoonnummer of de verificatie code fout`,
"c579":`Radar Kaart`,
"c413":`Status dienstafspraak`,
"c950":`Nederland`,
"c573":`2D staafdiagram`,
"label.choose.is.tax":`Kies type belasting`,
"c768":`De opdracht voor het ondertekenen van het contract is nog niet voltooid. Gelieve het document te downloaden nadat het contract is ondertekend.`,
"c604":`Factuuradres bestaat al, sla het huidige op als nieuw factuuradres`,
"c160":`Achterstallige behandeling`,
"c239":`Geaccepteerd`,
"c834":`Voorlopig Geslaagd`,
"c113":`Stuur {naam}`,
"c146":`Relevante producten zullen worden gewist na het veranderen van de valuta. Wilt u doorgaan met veranderen?`,
"c313":`Factuurbestand verzenden`,
"c140":`Kies object en sjabloon`,
"c298":`Nietconform`,
"c681":`Cirkel`,
"c870":`Weet je zeker dat je een batch wilt wissen?`,
"c551":`<span style="fontsize: 16px; fontweight: bold; color: #fe8a14"> {days}</span> resterende dagen in de proef`,
"c88":`Resterende dagen in proces`,
"c175":`Het lukt niet om detailinformatie te krijgen`,
"c64":`Of {objName} al dan niet geopend moet worden`,
"c319":`Formulier Stijl Setup`,
"label.pay.online":`Initieer online betaling`,
"c941":`China  Taiwan`,
"c550":`Kies de startdatum of einddatum`,
"c365":`Synchroniseer Quote regel met Opportunity product`,
"c908":`Pictogram kiezen`,
"c260":`Verzoek tot vernietiging`,
"c50":`Belastingtarief`,
"c869":`Ben je zeker dat je alle data archiveert`,
"c93":`Herhaaldelijk openen`,
"c280":`Verwijder email`,
"c23":`Het betaalde bedrag op de factuur zal hoger zijn dan het orderbedrag als u dit betaalgegeven blijft aanmaken. Gelieve het bedrag aan te passen en opnieuw op te slaan.`,
"front-console-v1-see-contacts":`Meerdere contacten geïdentificeerd. Gelieve te selecteren`,
"c607":`Afleveradres bestaat al, sla het huidige op als nieuw factuuradres`,
"c229":`Mijlpaal verwijderen`,
"front-filter-v1-filter-by-name":`Filter op '{naam}'`,
"c125":`In transit`,
"c513":`Timesheets`,
"c80":`Factuuradres`,
"c648":`Gesprekken`,
"c521":`Aantal bestelde`,
"c560":`Gesloten zaken`,
"c973":``,
"c509":`Paklijst`,
"c685":`Nieuw adres toevoegen`,
"c178":`Het formaat van de geüploade afbeelding wordt niet ondersteund. Gelieve afbeeldingen te uploaden in het formaat png, jpg en jpeg.`,
"c436":`Bezoekers Details`,
"front-electronic-signature-prepareTemplate":`Neem contact op met de beheerder om de contractvorm in het systeem in te stellen voordat u begint met ondertekenen.`,
"c749":`Ondertekeningsproces`,
"c114":`Klik op de Genereer {naam} knop om {naam} te genereren alvorens te verzenden.`,
"c898":``,
"c279":`Verkoop`,
"c232":`Kan het aantal te verpakken producten niet overschrijden`,
"c911":`Verzending geannuleerd`,
"c901":`Uw aantal inzendingen heeft de limiet bereikt.`,
"c663":`Alternatieve tekst`,
"c541":`Statistieken van de huidige zaak`,
"c536":`Ontvangen`,
"front-project-v1-batch-deletion-confirmation-information":`Batchverwijdering van de geselecteerde records zal ook alle informatie verwijderen die aan de geselecteerde records is gekoppeld, en de gegevens kunnen niet worden hersteld,. Weet u zeker dat u wilt verwijderen?`,
"c893":`De huidige gebruiker heeft geen toegang tot het bewerken van het adresveld van het accountdetail`,
"c623":`Monitor`,
"c493":`Vorm digitale marketing, grijp alle kansen`,
"c327":`Activa Hiërarchie`,
"c747":`Uw totaal aantal producten is vol. Gelieve eerst enkele producten te verwijderen en dan verder te gaan met producten toevoegen.`,
"c728":`Gegevensbescherming`,
"front-reportlist-v1-optimizedReport":`rapporten worden geoptimaliseerd na query. Gelieve niet willekeurig te wijzigen.`,
"c741":`Vul de inhoud van de email in!`,
"c643":`Post Details`,
"c537":`Gem. responstijd`,
"front-electronic-signature-add-field":`Voeg opvulveld toe`,
"c626":`Alle Gebruikers`,
"c199":`Formulier link`,
"c917":`Gebruik de pool om het potentieel van het team te stimuleren en de efficiëntie van de accountopvolging te verbeteren. De beheerder van de pool maakt een uniform beheer voor accounts en batchtoewijzingen. Verkoopmedewerkers kunnen ook leads screenen en followups ontvangen.`,
"c159":`De orderlengte mag niet meer zijn dan`,
"c640":`Schema Post`,
"c192":`Huidige pagina layout:`,
"c978":``,
"c969":``,
"c871":`Dit is hoe uw bericht zal worden weergegeven op {a}. Er kunnen kleine verschillen optreden als {a} de layout aanpast.`,
"c814":`1{0} geselecteerd`,
"c235":`{! ServiceResource.name} heeft de bestelling geaccepteerd. Onderwerp: "{!ServiceAppointment.subject}", Nummer: "{!ServiceAppointment.name}"`,
"c215":`Uw bericht is gepubliceerd`,
"c425":`Beheer van serviceafspraken`,
"c182":`De werkopdracht en het dossier kunnen niet tegelijk worden verbonden`,
"c194":`Beperking van het aantal inzendingen`,
"c657":`Geen toestemming om te werken, neem contact op met de beheerder.`,
"c855":`Het lijkt erop dat er niets gepland is.`,
"c333":`Begroting Kosten`,
"c338":`Leverancier  Vernietigen`,
"c431":`Campagne Hiërarchie`,
"c374":`Prijs Boek Product`,
"c506":`Geautomatiseerd schema`,
"font-trade-module-invoice-totalMoney":`Totaal factuurvorderingen`,
"c203":`Deel uw formulieren via Mailchimp`,
"c962":`{maand} {jaar}`,
"c786":`Telefoonnummer/Mailbox`,
"c469":`De pagina is in bewerkingstoestand. De huidige gegevens kunnen niet worden opgeslagen als u de pagina verlaat`,
"c137":`Kies een sjabloon voor het formulier`,
"c483":`Campagne Info`,
"c947":`Frankrijk`,
"c190":`De munteenheid van betalingsitems moet overeenkomen met de munteenheid van bestelling, factuur en betaling. Verfijn de munteenheid en sla opnieuw op.`,
"c386":`Vervuld`,
"c803":`Rekeningen: Alle Rekeningen`,
"c759":`Om te vullen`,
"c823":`Orde Instellen`,
"c422":`Methode voor het maken van serviceafspraken`,
"c782":`Hoe deel te nemen`,
"c416":`Service Rapport Push Record`,
"c758":`Geaccepteerd`,
"c407":`Service bemanningslid`,
"c51":`Nieuwe belasting`,
"c844":`Bind DocuSignaccount`,
"c361":`Menu Bewerken`,
"c602":`Matrixgrafiek`,
"c191":`Bewerkingstoestemming van huidige weergave is vereist`,
"c299":`Selecteer ten minste één object`,
"c432":`Campagne Geschiedenis`,
"c650":`Publiceer een nieuw bericht om een nieuw gesprek te beginnen`,
"c531":`Aantal ontvangen gevallen`,
"c13":`Huidige gebruiker heeft geen rechten om te bewerken`,
"c162":`Gelijktijdig de cedent en de cessionaris op de hoogte brengen`,
"c171":`Aandelenbezit`,
"c230":`Taak verwijderen`,
"c470":`Automatisch vullen van velden`,
"c367":`Genereer contract`,
"c26":`Instelling Korting`,
"c705":`Gepubliceerde berichten`,
"c613":`Externe pagina`,
"front-electronic-signature-openSign":`Begin met tekenen`,
"c349":`Slepen en neerzetten`,
"c683":`Meer laden`,
"c679":`Grijs`,
"c914":`Zijbalk samenvouwen`,
"c224":`Ga naar Mijlpaal`,
"c220":`Uw bericht is zonder succes gepubliceerd`,
"c498":`CloudCC Inventory ondersteunt efficiënt online en offline omnichannel business en realiseert de stroom en het beheer van goederen en fondsen. Meerdere modules worden effectief gecombineerd, en gebruikers kunnen verfijnd orderbeheer realiseren om winwinsituaties met partners te creëren.`,
"c566":`Automatisch opvragen van het adres van de rekening na het opslaan`,
"front-electronic-signature-ContractTemplate":`Kies Contract Sjabloon`,
"c540":`Het oplossen van tijd door kanalen`,
"c793":`Document sjablonen`,
"c293":`Objecten instellen om GDPRnaleving mogelijk te maken`,
"front-invoice-online-pay-again":`U heeft al een online betaling geïnitieerd. Probeer het niet opnieuw.`,
"front-electronic-signature-open-password":`Voer het wachtwoord in`,
"front-v1-partner-background-tooltip":`Een bestand van maximaal 2M wordt ondersteund. Het wordt aanbevolen om duidelijke afbeeldingen te uploaden.`,
"c449":`Chat Geschiedenis`,
"c30":`Klassiek`,
"c245":`{!oldServiceResource.name} heeft de werkorder met nummer {!ServiceAppointment.name} overgedragen aan {!newServiceResource.name}`,
"c923":`Hier is je team`,
"c24":`Kaart tonen`,
"c872":`Naam (Oningevuld)`,
"c886":`Open zijbalk`,
"c485":`Vorm Naam:`,
"c101":`pc('s)`,
"c816":`Bekijk bericht`,
"c445":`Projectrol`,
"c853":`Dit toont het aantal vindikleuks en reacties op uw gepubliceerde berichten.`,
"c398":`Begin nu`,
"c522":`Aantal gefactureerde`,
"c287":`Naleving`,
"c578":`MoM&YoY Numerieke Grafiek`,
"c40":`Voer het wachtwoord in`,
"c631":`Bekijk op Twitter`,
"c489":`Uitgeschakelde tijd`,
"c819":`Telefoonnummer/Mailbox`,
"c935":`Vorm Type`,
"c625":`Alle campagnes`,
"c471":`Campagne: Werknemer Verwijzing`,
"front-electronic-signature-writen":`Gevuld`,
"c889":`Deactiveer gebruikersaccount succesvol`,
"c201":`Deel dit formulier via uw sociale media`,
"c467":`Het sorteerveld is leeg`,
"label.mobile.no.null":`Telefoonnummer kan niet leeg zijn`,
"c307":`Recht`,
"front-kefu-moudle-wait-calling":`Gesprek aan de gang, probeer later nog eens`,
"c784":`Vul de bedrijfsnaam in op de bedrijfsvergunning`,
"c490":`Laatste keer inloggen`,
"c790":`Handgeschreven handtekening`,
"c336":`Leads  Vernietig`,
"c453":`Homepage Kanban`,
"c530":`Stel eerst de bedrijfspostbus in`,
"c610":`Het icoontje linkt naar het hoofddomein als je de URL niet hebt opgegeven`,
"c359":`Grafiek`,
"c193":`Beperkingen`,
"label.mobile.verificationCode.exceeded.times":`Aantal herhalingen overschreden. Gelieve opnieuw aan te vragen`,
"c138":`Bedrijfssjabloon`,
"c821":`Nieuwe interne contacten`,
"c381":`Online betalen aanvragen`,
"c761":`Ondertekening`,
"c964":`Masterdetail relatie veld is verplicht`,
"c585":`Kaart van het Verenigd Koninkrijk`,
"c500":`Bied onestopklantenserviceoplossingen met gestandaardiseerde processen en efficiënt beheer, coördineer servicemiddelen om uw klanten de beste ondersteuning te bieden.`,
"c214":`Voeg bitmaps in drie formaten en vectorafbeeldingen in alle formaten toe`,
"c714":`Plan berichten om op het juiste moment te publiceren.`,
"c552":`Afgewezen`,
"c684":`{sumTotalCount} meer`,
"c54":`Vul de belastingsoort in`,
"c320":`Selecteer formuliervelden`,
"c236":`{! ServiceResource.name} heeft de bestelling geaccepteerd. Account: "{!ServiceAppointment.accountid.name}", Nummer: "{!ServiceAppointment.name}"`,
"c123":`Logistieke informatie`,
"c654":`Terug naar Dashboardlijst`,
"c335":`Winstmarge`,
"c267":`Het is niet gelukt wijzigingen vast te leggen omdat niet aan het criterium is voldaan`,
"c226":`Ga naar Subtaak`,
"c102":`Klik eenmaal`,
"c637":`Opslaan als klad`,
"c633":`Nieuwe sociale berichten maken`,
"c777":`Deelnemersinformatie instellen`,
"c223":`Toevoegen aan project`,
"c592":`Watervalgrafiek`,
"c315":`Alleen geldige orders kunnen facturen genereren`,
"c89":`Email Evenementnaam`,
"c108":`Automatch succesvol`,
"c402":`Veld`,
"c748":`Selecteer een prijzenboek voor {title}. U kunt alleen producten uit één prijsboek toevoegen. Het wijzigen van het geselecteerde prijsboek zal resulteren in het verwijderen van alle bestaande producten.`,
"c501":`Bied uw klanten een velddienst van hoge kwaliteit`,
"c269":`Niet gelukt om informatie samen te voegen`,
"front-electronic-signature-open-confirm":`Bind rekening`,
"c584":`Kaart van de Verenigde Staten`,
"c437":`Onsuccesvol`,
"c738":`Datum verzonden`,
"c274":`U hebt een timeout van het aanvaarden van de bestelling, en de verzending is geannuleerd. Nummer: {0}. Klik om meer te zien >`,
"c83":`Zoek gegevens`,
"c206":`PNGformaat`,
"c309":`Bestelling verzenden`,
"c539":`Hoogste aandeel bronnen`,
"c304":`Grote belangen`,
"c151":`Beschrijf kort de hoofdinhoud van het formulier`,
"c639":`Nu plaatsen`,
"c720":`Nee, bedankt.`,
"c801":`Nieuwe contacten`,
"c900":`Er is geen adresinformatie beschikbaar voor de bezoeker, zodat de incheckafstand niet kan worden berekend.`,
"c695":`Originele grootte`,
"c864":`Kies een vorm`,
"c881":`Ik heb gelezen en ben akkoord gegaan`,
"c794":`Ondertekeningsjabloon`,
"c543":`Ontvangen evaluaties`,
"c466":`Alleen orders met hetzelfde prijsboek kunnen een factuur genereren`,
"c867":`{gebruikersnaam} zal een uitnodigingsemail ontvangen waarin u wordt gevraagd een wachtwoord aan te maken voor toegang tot uw Helpcentrum.
Doorgaan?`,
"c529":`Geen beschikbare manieren om op te waarderen, neem contact op met de beheerder`,
"c742":`Maximaal 4 afbeeldingen kunnen worden geselecteerd en elk van hen mag niet groter zijn dan 200K. Klik op de afbeelding om te selecteren.`,
"c430":`Zoeken op prestatieterm`,
"c553":`Laatste uitgenodigde tijd`,
"c575":`Kolomgrafiek`,
"c124":`Levering in afwachting`,
"c629":`Onsuccesvol`,
"c554":`Eerste Uitgenodigde Tijd`,
"c547":`Laatste 7 dagen`,
"c599":`Tabel`,
"c588":`Kaart van Canada`,
"c703":`Via`,
"c713":`Creëer sociale berichten vanuit CloudCC.`,
"c142":`Dit is de actie die zal worden ondernomen nadat een bezoeker het formulier op uw site heeft ingediend`,
"c153":`Nadat u de producten van het huidige record hebt gewist, kunt u de valuta wijzigen.`,
"c253":`GDPRnaleving`,
"c612":`Interne pagina`,
"c400":`Locatie van dienstmiddelen`,
"c671":`Icoon en Woord`,
"c20":`Mag niet groter zijn dan de te factureren hoeveelheid van de verwante order.`,
"c514":`De grafieken van het verslag`,
"c946":`Verenigd Koninkrijk`,
"c717":`Nieuw bericht`,
"c174":`Allemaal succesvol bewerkt`,
"c940":`China  Hong Kong`,
"c743":`Voer geldige nummers in`,
"c441":`Slim zakelijk en financieel beheer`,
"c423":`Verzendplatform`,
"c723":`Bevestig om vernietiging aan te vragen`,
"c664":`Geen sociaal netwerk`,
"c859":`Voer alstublieft {0} in.`,
"c356":`Geplande kosten`,
"c221":`Ga naar Project`,
"front-email-payment-Invoice-Tips1":`Neem contact op met de beheerder om WeChat, Alipay, PayPal of VISA in te schakelen en start dan de online betaling`,
"c99":`Product QTY`,
"c278":`Wilt u de volgende emails verwijderen?`,
"c364":`Citaat Lijn`,
"c572":`De Geselecteerde Velden kunnen niet leeg zijn, gelieve veld(en) toe te voegen`,
"c310":`Bestelbestand genereren`,
"c247":`Overgedragen`,
"c158":`Tijd drempel toewijzen`,
"c325":`Sjabloon voor kennisgeving van zaakstoewijzing`,
"c877":`Nietordelijk vullen`,
"front-filter-v1-press":`Druk op`,
"c505":`Bezoekers volgen`,
"c523":`Toevoegen als portaalgebruiker`,
"c727":`Vernietig gegevens met succes`,
"front-electronic-signature-sended":`Verzonden`,
"c150":`Gelieve de vereiste informatie in te vullen`,
"c700":`LAATST BIJGEWERKTE TIJD`,
"c824":`Teken in volgorde`,
"c710":`Eén huis om al uw sociale media te beheren`,
"c358":`Begroting`,
"c544":`Kanalen`,
"c212":`SVGformaat`,
"c165":`Voer een gehele waarde in van 024`,
"c932":`Spam`,
"c888":`Activeer gebruikersaccount met succes`,
"c838":`Operator`,
"c98":`Product Categorie`,
"c830":`GECREËERD DOOR`,
"c661":`Netwerk`,
"c818":`Instellingen menu aangepaste pagina`,
"c861":`Kies uit Kaart`,
"c736":`Geplaatst door`,
"c204":`Standaard`,
"c839":`Het lijkt erop dat er niets gepland is.`,
"c456":`Betaald bedrag`,
"c341":`Eindafrekening`,
"c724":`Bevestig de vernietiging van gegevens`,
"c865":`Ik heb gelezen en ga akkoord met {0} en {1}`,
"c332":`Het bedrag kan niet hoger zijn dan de te factureren bestelling`,
"c520":`Betaling mislukt. De beschikbare korting is onvoldoende`,
"c906":`Minus`,
"c482":`Noem je Compagin:`,
"c49":`Update veiligheidsinstellingen van domein`,
"c725":`Verzoek tot vernietiging met succes herroepen`,
"c76":`BETALEN`,
"c558":`Zaken in wacht`,
"c876":`Teken Nietordelijk`,
"front-invoices-v1-nofilles-tocreate":`Klik op de knop Factuur genereren om een factuur te genereren en deze te verzenden.`,
"c779":`Uiterste datum ondertekening`,
"c603":`MoM&YoY Biaxial Grafiek`,
"c455":`Contract Doel`,
"c428":`Verzending in Kaart Modus`,
"c55":`Gelieve de belastingswaarde in te vullen`,
"c899":`Checkin afstand`,
"label.facebook.title":`FacebookH5 MiniApp`,
"c487":`Naam ontvanger:`,
"label.social.posts.info":`Er is geen inhoud van de post gevonden`,
"c704":`Publiek`,
"c673":`Webbeeld`,
"front-electronic-signature-singed":`Ondertekening begonnen`,
"c722":`1 account aangesloten`,
"c595":`Gebiedstabel`,
"c120":`soort(en)`,
"c68":`Betaalbare bestelling`,
"c479":`CloudCC Formulieren Mailchimp`,
"front-electronic-signature-explain-mainTitle":`Ehandtekening en stempel`,
"c5":`Belasting`,
"c976":``,
"c812":`COMMENTAAR`,
"c532":`Aantal rustende gevallen`,
"c330":`Contract Post`,
"c249":`de post gaat er nu uit`,
"c630":`Bekijk op LinkedIn`,
"c958":`Post Like ID kan niet leeg zijn`,
"c170":`Mislukt om gegevens te creëren met het record id {0}, mislukte reden: {1};`,
"c810":`REPLIES`,
"c783":`Vereisten voor ondertekening`,
"c968":``,
"c752":`Start ondertekeningstaak`,
"c439":`Bezoeker`,
"c67":`Bestelling succesvol verzonden!`,
"front-generate-v1-invoice":`Factuur genereren`,
"c477":`U moet zich authentificeren met uw MailChimp account. Klik op de knop "MailChimp verifiëren" en u wordt doorgestuurd naar MailChimp om campagnes te verzenden.`,
"c966":`Neem contact op met de beheerder`,
"c764":`Afgewezen`,
"c301":`Er kunnen maximaal 200 tekens worden ingevoerd`,
"c61":`Open eerst de Kennis en gebruik het dan`,
"c815":`Archiveer alle`,
"c827":`U hebt nog niet opgeslagen wijzigingen op deze pagina die verloren zullen gaan als u doorgaat.`,
"c688":`Max Breedte`,
"c33":`Abonnementstype bewerken`,
"c217":`post gaat uit {datum}`,
"c721":`Verbreek de verbinding`,
"c284":`Verwerk gegevensaanvragen van klanten in CRM`,
"c939":`China  Macau`,
"c503":`Houd de voortgang van uw project bij`,
"c492":`Uitgenodigd`,
"c73":`Huidig saldo`,
"label.the.peoples.republic.of.china":`Volksrepubliek China`,
"c828":`POST`,
"c36":`Voorbeeld`,
"c954":`Nieuw telefoonnummer`,
"front-electronic-signature-innerSinger":`Interne ondertekenaar`,
"c508":`ROIanalyse`,
"c833":`Certificering geslaagd`,
"c207":`Vector Formaat`,
"c31":`Half scherm`,
"c71":`Kies een betalingsoptie`,
"c373":`Standaard prijzenboek`,
"c545":`Oplostijd (h)`,
"c77":`Module instellen`,
"label.lastcompiledate":`Laatste compilatietijd`,
"c119":`Ontvangst bevestigen`,
"c281":`Gegevensverwerking`,
"c715":`Monitor merkvermeldingen en reageer snel.`,
"c127":`Kolommen beheren`,
"c283":`Verzoek om gegevens`,
"c919":`Gebruik de pool om het potentieel van het team te stimuleren en de leadconversie te verbeteren. De poolbeheerder maakt een uniform beheer voor leads en batchopdrachten. Verkooppersoneel kan ook leads screenen en followups ontvangen.`,
"c82":`Alleen voor bliksem`,
"front-file-delete-intro":`Het bestand werd verwijderd`,
"c606":`Standaard afleveradres`,
"c905":`Toevoegen`,
"c644":`GEPUBLICEERDE TIJD`,
"c75":`Korting Saldo`,
"c884":`Privacybeleid`,
"c538":`Gemiddelde oplostijd`,
"c322":`Nieuwe Factuur`,
"c461":`Trend betaling`,
"c825":`Ondernemingen`,
"c56":`Het totaal van de factuurvorderingen en het te ontvangen bedrag zijn niet consistent. Gelieve opnieuw in te vullen.`,
"c931":`U hebt de schakelaar voor de positiebepaling van de werknemer niet ingeschakeld en kunt de interval voor het delen van locaties niet gebruiken. Doorgaan?`,
"c276":`GDPRnaleving mogelijk maken`,
"c334":`Begrotingsbedrag`,
"c733":`Campagne: Nieuwe Poster`,
"c384":`Nieuwe paklijst`,
"c139":`Vergadering sjabloon`,
"c957":`Post Comment ID kan niet leeg zijn`,
"front-electronic-signature-nosign":`Er is geen dienstverlener van Ehandtekening gekozen door uw org. Neem contact op met de beheerder om deze dienst in te schakelen.`,
"c419":`Onderhoudsplan`,
"c934":`Omzetting Titel`,
"c677":`Rechts uitgelijnd`,
"c593":`Lijngrafiek`,
"c272":`{0} heeft een timeout voor het accepteren van de order. Rekening: {1}, Onderwerp: {2}, Nummer: {3}. Klik om meer te zien >`,
"c811":`RETWEETS`,
"c451":`Split Case`,
"c277":`Zodra u de email verwijdert, zullen de volgende emails ook worden verwijderd en niet meer naar toekomstige contacten worden verzonden. Dit is onomkeerbaar.`,
"c244":`{!ServiceResource.name} heeft de order afgewezen. Nummer: "{!ServiceAppointment.name}"`,
"c627":`Gepubliceerd`,
"c601":`Doelwitgrafiek`,
"c251":`post(en) publiceren is mislukt`,
"c202":`Delen in Mailchimp`,
"font-social-prohibit-create":`Je kunt geen nieuw bericht maken terwijl je aan het bewerken bent`,
"c394":`CloudCC helpt u uw bedrijf online te beheren en de efficiëntie te verbeteren. Kies de applicatie die u wilt gebruiken en volg de introductie en begeleiding.`,
"c323":`PDFformaat`,
"front-setting-dialog-title-one":`Om verlies van uw account te voorkomen, snel in te loggen en gemakkelijk terug te vinden, bindt u het telefoonnummer`,
"front-electronic-signature-cancelIntro2":`Als dit de eerste keer is dat u een account aanmaakt, klik dan op Doorgaan om naar de volgende stap te gaan. Als u opnieuw bindt na het opheffen van de binding, is het raadzaam om op Annuleren te klikken en opnieuw te binden nadat u de browsergegevens hebt gewist.`,
"c353":`Weergave van Timesheets`,
"c621":`Rijke tekst inhoud`,
"front-v1-partner-image-tooltip":`Een bestand van maximaal 2M wordt ondersteund. De afbeelding zal worden verkleind tot {size}. Het wordt aanbevolen om duidelijke afbeeldingen met vergelijkbare verhoudingen te uploaden.`,
"c772":`Afgewerkt`,
"c734":`Naam Poster Kanaal`,
"c380":`Nieuwe betaling`,
"c979":``,
"c233":`U kunt de paklijst van verzonden status niet wissen`,
"c458":`Kaart van rekeningenverdeling`,
"c697":`Kies accountadres{naam}`,
"c476":`Kies de werknemer aan wie u de uitnodigingscode wilt sturen`,
"c634":`Maak een boeiende post en maak contact met de wereld`,
"c144":`De eindtijd kan niet meer zijn dan 2038. Gelieve een nieuwe eindtijd te kiezen.`,
"c474":`U kunt opnieuw toewijzen door gebruik te maken van de toewijzingsregels voor afleidingen. Voor de toewijzingsregels, zie`,
"c371":`Synchroniseer met Opportunity`,
"c420":`Onderhoud Activa`,
"c620":`Dit wordt gebruikt om meerdere stukken inhoud te groeperen voor de analyse van een enkele marketinginspanning.`,
"c708":`De schaal verenigen of niet`,
"c100":`Korting`,
"c576":`2D Kolomgrafiek`,
"c751":`Deadline voor ondertekening:`,
"c252":`Conformiteit Instellingen`,
"c699":`Alleen nieuw`,
"c74":`Betalen met korting`,
"c805":`Kies een sociaal netwerk om te beginnen:`,
"c452":`Geschiedenis`,
"c740":`Selecteer een werknemer om de uitnodiging te versturen`,
"c596":`Biaxiale grafiek`,
"c832":`Toetsing van`,
"c971":``,
"c262":`Geschiedenis`,
"c363":`Gevoelig`,
"label.singleSignOn.is.invalid":`Loginfree was ongeldig`,
"c72":`Betaling door derden`,
"c292":`Marketing`,
"c499":`Efficiënte klantenservice om indruk te maken op klanten`,
"c574":`Gestapeld staafdiagram`,
"c618":`Wijzig de inhoud of de publicatietijd voor dit bericht.  Twitter staat niet toe dat meer dan één bericht met dezelfde inhoud binnen 24 uur wordt gepubliceerd.`,
"front-setting-phone-format":`Gelieve uw telefoonnummer in het juiste formaat in te voeren`,
"c460":`Rekeninggrootte Rangschikking`,
"c189":`De valuta van de factuur moet overeenkomen met de valuta van de bestelling. Verfijn de valuta en sla opnieuw op.`,
"label.exe.supported.request.rejected":`exe. bestand wordt niet ondersteund om te worden verzonden. Het verzoek wordt geweigerd!`,
"c835":`Er bestaat al een factuur voor deze offerte. Doorgaan of niet?`,
"c655":`Bericht van`,
"c45":`Verbind Door`,
"c43":`Account aansluiten`,
"c481":`Log in als een andere gebruiker`,
"c674":`Extern adres`,
"c266":`Deze bestelling kan niet worden gewijzigd want ze is voltooid`,
"c967":``,
"c154":`Zoek in prijsboeken na het selecteren van producten`,
"c841":`Heb je ideeën? Schrijf maar op.   `,
"c615":`Er is geen rekening geselecteerd`,
"c84":`Kies medewerker om uitnodigingscode te versturen`,
"c401":`Dienst`,
"c290":`Ingeschakelde objecten`,
"c205":`Downloaden QRcode`,
"c928":`Er kunnen maximaal 10 velden worden geselecteerd.`,
"c195":`Indieningslimiet`,
"1":`Geen beschikbare acties`,
"c46":`Autoriseer met succes`,
"c459":`Ondertekend contract Bedrag`,
"c250":`berichten worden opgeslagen als klad`,
"c399":`Inventaris`,
"c518":`De #recordName van #label heeft de goedkeuring niet gekregen voor #failReason`,
"c396":`Kies verschillende oplossingen`,
"c300":`Vernietig aangevraagd door`,
"c789":`Methode voor onbeperkte handtekeningen`,
"c874":`Je hebt alles in je inbox gelezen.`,
"c38":`Nummer van het huizenblok`,
"c228":`Subtaak toevoegen`,
"c342":`Winst`,
"c879":`Sociale berichten klonen`,
"c173":`Succesvol opnieuw inbinden`,
"c778":`Initiatiefnemer`,
"c211":`Klein formaat`,
"c496":`CloudCC Verkoop  een slim CRM voor alle scenario's om u te helpen uw verkoopdoelstellingen te bereiken`,
"c427":`Verzending in Gantt Grafiek Modus`,
"c851":`Dit toont het aantal berichten dat binnen de geselecteerde periode over uw accounts is gepubliceerd.`,
"c32":`Nieuw type abonnement`,
"c28":`Jaaropjaar groei`,
"c163":`Gelijktijdig informeren en annuleren van verzending`,
"c225":`Ga naar taak`,
"c569":`Kies eerst een account`,
"c92":`Open eenmaal`,
"c412":`Maak automatisch een service afspraak`,
"c81":`In winkelwagen`,
"c653":`Dit toont het aantal likes, reacties en commentaren voor uw gepubliceerde berichten. Dit omvat ook berichten die zijn gepubliceerd op uw verbonden accounts buiten CloudCC Als u op zoek bent naar Twitter retweets, vindt u ze in Shares.`,
"c516":`Aanwezigheid`,
"c918":`Als autorecycle regels zijn geconfigureerd, zal het systeem de records automatisch naar de pool recyclen als de account de deal niet heeft gesloten na de tijdslimiet. Dat verbetert de efficiëntie van de accountopvolging.`,
"c809":`LIKES`,
"c181":`Gelieve een werkorder of dossier in te vullen`,
"c745":`Voer tot 2 decimalen in`,
"c669":`Kleur`,
"c929":`Controleer de netwerkverbinding`,
"c117":`Opslaan en betalen`,
"c938":`China vasteland`,
"c112":`Alle {naam} sjablonen zijn momenteel uitgeschakeld. Neem contact op met de beheerder om het sjabloon in te schakelen voordat u {naam} genereert.`,
"c347":`Wijziging werkuren van projecttaak`,
"c795":`Kies contract sjabloon`,
"c17":`Inactief. Gelieve opnieuw te selecteren`,
"c787":`Ondertekend door de exploitant`,
"c829":`CAMPAGNE`,
"c161":`Informeer ook`,
"c65":`Wilt u de logistieke status van het product wijzigen in Geleverd`,
"c665":`Voeg er nog één toe.`,
"c767":`Voortgang ondertekening controleren`,
"c87":`QRcode van het campagneformulier`,
"c589":`Kaart van Frankrijk`,
"front-electronic-signature-newTime":`Laatst bijgewerkt op`,
"c813":`SHARE`,
"c85":`{member} inviter geselecteerd`,
"c951":`Polen`,
"c29":`Groei van maand tot maand`,
"c210":`Groot formaat`,
"c39":`Gearchiveerd`,
"c672":`Word`,
"c97":`Deze keuzelijst moet ten minste één "Geconverteerd"optie bevatten`,
"c687":`Max. grootte`,
"c916":`Zwembad sluiten`,
"c475":`Gelieve de eigenaar van de campagne in te vullen`,
"c628":`Gepland`,
"c788":`Het prijzenboek voor deze gelegenheid is momenteel uitgeschakeld. Schakel het prijzenboek in voordat u een nieuwe bestelling aanmaakt.`,
"c177":`Voorgestelde grootte: 390*210`,
"c856":`Yay! Geen mislukte berichten.`,
"c70":`Bestelinformatie`,
"c546":`Laatste 24 uur`,
"c331":`Activa omzetten`,
"label.order.paidamount.greater.than.total":`Nadat de nieuwe betalingsgegevens zijn aangemaakt, zal het terugbetaalde bedrag van de bestelling hoger zijn dan het bedrag van de bestelling. Gelieve de betaling opnieuw aan te passen en dan op te slaan.`,
"c524":`Reinvite`,
"c246":`{!oldServiceResource.name} heeft de werkorder met nummer {!ServiceAppointment.name} aan u overgedragen.`,
"label.parameter.is.incorrect":`Verkeerde parameters`,
"c667":`Icoonspatie`,
"c737":`Sociaal Platform`,
"c48":`Loskoppelen`,
"c111":`Genereer {naam}`,
"c755":`In volgorde`,
"c526":`Portaalgebruiker inschakelen`,
"c450":`Gevallen samenvoegen`,
"front-electronic-export-reChoseChimp":`De huidige weergave heeft geen gegevensrecords en kan niet worden geëxporteerd. Selecteer een nieuwe weergave`,
"label.invoice.paidamount.greater.than.total":`Nadat de nieuwe betalingsgegevens zijn aangemaakt, zal het terugbetaalde bedrag van de factuur hoger zijn dan de totale waarde. Gelieve de betaling opnieuw aan te passen en dan op te slaan.`,
"c222":`Project bewerken`,
"c849":`Twitter accounts`,
"c678":`Zwart en Wit`,
"c502":`Bieden uitgebreide oplossingen voor het afhandelen van alle processen in de buitendienst om de activiteiten te stroomlijnen, de productiviteit te verbeteren en de klantenloyaliteit en tevredenheid te vergroten.`,
"c497":`Slimmere inventaris, sterker zakelijk en financieel beheer`,
"c200":`Deel op sociale media`,
"c658":`Rijke tekst`,
"c434":`Nieuw gerelateerd contact`,
"c641":`U kunt niet meer dan 4 afbeeldingen kiezen, klik op de geselecteerde afbeelding om deze te deselecteren. De grootte van de afbeelding die u uploadt moet onder de 200kb blijven`,
"c944":`Duitsland`,
"c411":`Vervaldatum Compensatie`,
"c624":` Alle Rekeningen`,
"label.twitter.title":`TwitterH5 MiniApp`,
"c791":`Standaard Handtekening`,
"c306":`Mee eens`,
"c14":`Huidige gebruiker heeft geen toestemming om te verwijderen`,
"c176":`Alleen png, jpg en jpeg afbeeldingen worden ondersteund om te uploaden. De geüploade afbeelding mag niet groter zijn dan 2M.`,
"c166":`Voer de maximale orderlengte in volgens de regels`,
"c731":`Het wijzigen van het geselecteerde prijsboek zal ook alle bestaande producten verwijderen. Weet u zeker dat u naar het nieuwe prijsboek wilt overschakelen?`,
"c237":`{!ServiceResource.name} accordeerde de order. Nummer: "{!ServiceAppointment.name}"`,
"c887":`Gebruiker opnieuw uitnodigen met succes`,
"c227":`Bewerk Subtaak`,
"c257":`Beschikbaar Contact`,
"c712":`Rapportage en vergelijking van prestaties over netwerken, berichten en campagnes.`,
"c107":`Zoek gebruikers op naam, account en mobiel nummer`,
"c370":`Contract`,
"c895":`Afstandberekening mislukt, voer het volledige adres in`,
"c693":`Autoregulatie`,
"c763":`Ondertekend`,
"c302":`Gewettigde belangen`,
"c577":`Gestapelde kolommengrafiek`,
"c258":`Een klacht indienen`,
"c676":`Center`,
"c868":`Na het deactiveren van deze account, zal het systeem zijn toegang of bewerkingen in uw portaal beperken. Doorgaan?`,
"c53":`Verhouding (%)`,
"c527":`#userName heeft goedkeuringstaak aan u toegewezen`,
"label.facebook.title.setting":`Geïntegreerde informatie op Facebook`,
"c340":`Wijzig de eigenaar van het projectplan`,
"c706":`Over de grafieken`,
"label.mobile.used":`Het mobiele nummer is gebruikt`,
"c328":`Activum QRcode`,
"c337":`Contacten  Vernietigen`,
"c642":`Recente beelden`
}